import { TDateISO } from '../@types/TDateISO';
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseApi } from './api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: TDateISO; output: TDateISO; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: number; output: number; }
  JSON: { input: unknown; output: unknown; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: unknown; output: unknown; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: number; output: number; }
  /** The ObjectId scalar type represents a 12 byte ObjectId, represented as UTF-8 character sequences. */
  ObjectId: { input: string; output: string; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: unknown; output: unknown; }
  UUID: { input: string; output: string; }
};

/** Filter operations on a boolean field whose absent stored key means false. The Mongo provider treats false-or-missing as one state: eq: false matches rows lacking the stored key, and eq: true / eq: false partition the collection. */
export type AbsentAsFalseBooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcceptUserInviteInput = {
  code: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum AccountClassification {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Revenue = 'REVENUE'
}

export type AccountClassificationOperationFilterInput = {
  eq?: InputMaybe<AccountClassification>;
  in?: InputMaybe<Array<AccountClassification>>;
  neq?: InputMaybe<AccountClassification>;
  nin?: InputMaybe<Array<AccountClassification>>;
};

/**
 * MongoDB read-model document for a tenant's accounting integration policy. There is exactly one
 * document per tenant; Id equals TenantId today, but use GetDocumentId for all
 * reads/writes so that invariant can evolve without breaking call sites. Holds policy only —
 * Merge.dev connection secrets continue to live on MergeTenantIntegration /
 * TenantIntegrationDocument.
 */
export type AccountingIntegrationConfigDocument = {
  __typename?: 'AccountingIntegrationConfigDocument';
  defaultIncomeAccount?: Maybe<DefaultIncomeAccount>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevAccountId?: Maybe<Scalars['String']['output']>;
  oneTimePullCompleted: Scalars['Boolean']['output'];
  oneTimePullCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDetail: OutboundDetailLevel;
  provider: AccountingProvider;
  tenantId: Scalars['String']['output'];
};

export type AccountingIntegrationConfigPayload = {
  __typename?: 'AccountingIntegrationConfigPayload';
  accountingIntegrationConfig?: Maybe<AccountingIntegrationConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type AccountingIntegrationConfigStateData = {
  __typename?: 'AccountingIntegrationConfigStateData';
  defaultIncomeAccount?: Maybe<DefaultIncomeAccount>;
  mergeDevAccountId?: Maybe<Scalars['String']['output']>;
  oneTimePullCompleted: Scalars['Boolean']['output'];
  oneTimePullCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDetail: OutboundDetailLevel;
  provider: AccountingProvider;
  tenantId: Scalars['String']['output'];
};

export enum AccountingProvider {
  NetSuite = 'NET_SUITE',
  None = 'NONE',
  QuickBooks = 'QUICK_BOOKS',
  Xero = 'XERO'
}

export type ActivateCategoryInput = {
  code: Scalars['String']['input'];
};

export type ActivateConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
};

export type ActivateContainerConfigInput = {
  containerConfigId: Scalars['String']['input'];
};

export type ActivateCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ActivateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
};

export type ActivateCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type ActivateDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type ActivateFeatureFlagInput = {
  name: FeatureFlagName;
};

export type ActivateItemInput = {
  itemId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type ActivateLocationInput = {
  locationId: Scalars['String']['input'];
};

export type ActivateMaterialItemInput = {
  id: Scalars['String']['input'];
};

export type ActivatePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type ActivateProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type ActivateProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type ActivateProductionLotInput = {
  productionLotId: Scalars['String']['input'];
};

export type ActivateProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type ActivateProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type ActivateProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type ActivateProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type ActivateProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type ActivateProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type ActivateProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type ActivateProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type ActivateProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type ActivateProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type ActivateProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type ActivateSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type ActivateSizeUomInput = {
  code: Scalars['String']['input'];
};

export type ActivateTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type ActivateTaxAuthorityInput = {
  id: Scalars['String']['input'];
};

export type ActivateTenantInput = {
  entityId: Scalars['String']['input'];
};

export type ActivateVendorInput = {
  id: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ActiveImportJobsConnection = {
  __typename?: 'ActiveImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActiveImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActiveImportJobsEdge = {
  __typename?: 'ActiveImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

export type ActivePortalUserMapping = {
  __typename?: 'ActivePortalUserMapping';
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type AddBillingAddressInput = {
  address: CreateAddressInput;
  customerId: Scalars['String']['input'];
};

export type AddBlockingRuleLinkedItemsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
};

export type AddBlockingRuleLinkedLocationsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedLocationIds: Array<Scalars['String']['input']>;
};

/**
 * GraphQL input for addBpfLotChange. Primitive/non-Option fields only (HotChocolate input
 * type). Tenant and user are taken from the authenticated principal, never this input.
 *
 * MissionEntryId is optional: the Nav [BP Cycle Count Assign].[Entry ID] of the BPF
 * mission task this count is recorded against, paired with LotCountId to identify the task
 * ({TenantId}-{MissionEntryId}-{LotCountId}). When supplied, this change is validated as still
 * open for counting and, on success, stamps the task's IsComplete / OldQuantity /
 * NewQuantity / LotChangeId / CompletedAt / CompletedByEmail. Every
 * existing ad-hoc caller leaves it null and is unaffected.
 */
export type AddBpfLotChangeInput = {
  changeReasonCode: Scalars['String']['input'];
  changeType: BpfLotChangeType;
  fromSiteLocationId: Scalars['String']['input'];
  fromSubLocationId: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  jobReference: Scalars['String']['input'];
  lotCountId: Scalars['String']['input'];
  lotReference: Scalars['String']['input'];
  missionEntryId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  stage: BpfLotStage;
  toSiteLocationId: Scalars['String']['input'];
  toSubLocationId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  variantReference: Scalars['String']['input'];
};

export type AddCategoryInput = {
  category: CategoryDataInput;
};

export type AddConfigCategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configCategoryId: Scalars['String']['input'];
  defaultSizeUomCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sizeUomCodes: Array<Scalars['String']['input']>;
};

export type AddContactInput = {
  contact: ContactDataInput;
  customerId: Scalars['String']['input'];
};

export type AddContainerConfigForConfigCategoryDataInput = {
  categoryCode: Scalars['String']['input'];
  configCategoryId: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type AddContainerConfigInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type AddContainerConfigToConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
};

export type AddCountInput = {
  comment: Scalars['String']['input'];
  countRowId: Scalars['String']['input'];
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AddCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerItemInput = {
  customerId: Scalars['String']['input'];
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  isDefault: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  retailShelfPrice?: InputMaybe<Scalars['Decimal']['input']>;
  retailShelfPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  sizeUomCode?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerTypeInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type AddInventoryNoteInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AddItemAvailabilityInput = {
  comment: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
};

export type AddItemInput = {
  categories: Array<CategoryDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AddItemToCartInput = {
  cartId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type AddItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgrade: ItemUpgradeDataInput;
};

export type AddLineItemDataInput = {
  addedBy: Scalars['String']['input'];
  containerCode?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  dateAdded: Scalars['DateTime']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentSource?: FulfillmentSource;
  handlingUom?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  kitGroupId?: InputMaybe<Scalars['String']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  price: Scalars['Decimal']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  royaltyExempt?: Scalars['Boolean']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddLineItemsInput = {
  items: Array<AddLineItemDataInput>;
  orderId: Scalars['String']['input'];
};

export type AddLineItemsWithPricingInput = {
  batchSize?: Scalars['Int']['input'];
  items: Array<AddLineItemDataInput>;
  locationId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type AddLocationInput = {
  customerId: Scalars['String']['input'];
  location: CreateCustomerLocationInput;
};

export type AddMasterLineItemDataInput = {
  addedBy: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  dateAdded: Scalars['DateTime']['input'];
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  orderedQuantity?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Decimal']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddMasterLineItemsInput = {
  items: Array<AddMasterLineItemDataInput>;
  masterOrderId: Scalars['String']['input'];
};

export type AddNoteInput = {
  noteContent: Scalars['String']['input'];
  taskAssignmentId: Scalars['String']['input'];
};

export type AddOrderLineUpgradeInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<OrderLineUpgradeCostDataInput>;
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  pricing: OrderLineUpgradePricingDataInput;
  sourceItemUpgradeId?: InputMaybe<Scalars['String']['input']>;
};

export type AddPortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

export type AddPriceGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddProductionLotAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowValuesInput>;
};

export type AddProductionMaterialEventDetailsDataInput = {
  description: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  multiple: Scalars['Decimal']['input'];
  productionMaterialEventDetailId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionMaterialEventDetailsInput = {
  details: Array<AddProductionMaterialEventDetailsDataInput>;
  productionMaterialEventId: Scalars['String']['input'];
};

export type AddProductionMaterialEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type AddProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variation: ProductionRecipeVariationDataInput;
};

export type AddProductionSpaceEventDetailsDataInput = {
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionSpaceEventDetailsInput = {
  details: Array<AddProductionSpaceEventDetailsDataInput>;
  productionSpaceEventId: Scalars['String']['input'];
};

export type AddProductionSpaceEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventDetailsDataInput = {
  description: Scalars['String']['input'];
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  multiple: Scalars['Decimal']['input'];
  productionTaskEventDetailId: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  taskEventTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionTaskEventDetailsInput = {
  details: Array<AddProductionTaskEventDetailsDataInput>;
  productionTaskEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventToItemInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type AddPromotionRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type AddPromotionRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type AddPurchaseOrderLineItemInput = {
  erpJobId?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  materialItemErpId?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
};

export type AddReserveRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type AddReserveRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

/**
 * GraphQL input for the retail product-count mutations. Primitive/non-Option fields only (HotChocolate
 * input type). Tenant and user are taken from the authenticated principal, never this input.
 */
export type AddRetailProductCountInput = {
  bpLotCode: Scalars['String']['input'];
  countType: RetailCountType;
  customerReference: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  locationId: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  note: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  unit: Scalars['String']['input'];
  unitQuantityChange: Scalars['Decimal']['input'];
};

export type AddSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destination: DestinationConfigDataInput;
};

export type AddSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destination: MongoDestinationConfigDataInput;
};

export type AddSftpTenantConfigInput = {
  batchSize: Scalars['Int']['input'];
  configId: Scalars['String']['input'];
  configName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podId: Scalars['String']['input'];
  sourceDirectory: Scalars['String']['input'];
  sourceEndpoint: Scalars['String']['input'];
  sourceFilePattern: Scalars['String']['input'];
  sourcePassword: Scalars['String']['input'];
  sourcePort: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
  sourceUsername: Scalars['String']['input'];
};

export type AddShipFromLocationInput = {
  customerId: Scalars['String']['input'];
  location: ShipFromLocationDataInput;
};

export type AddSignatureImageInput = {
  base64SignatureImage: Scalars['String']['input'];
  dateCaptured: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type AddSiteLocationAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowValuesInput>;
};

export type AddSizeUomInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  eachesPerUnit: Scalars['Int']['input'];
};

export type AddSizeUomToConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type AddTenantEmailDomainInput = {
  domain: Scalars['String']['input'];
};

export type AddTenantEmailSenderInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: EmailSenderVerificationMethod;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddTenantInput = {
  entityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
};

export type AddWsapiImportEntityMappingInput = {
  enabled: Scalars['Boolean']['input'];
  entityType: WsapiImportEntityType;
  fieldMappings: Array<FieldMappingInput>;
  keySourceField: Scalars['String']['input'];
  keyTargetField: Scalars['String']['input'];
  sourceTable: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type AddressData = {
  __typename?: 'AddressData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AddressDataFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AddressDataFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressDataFilterInput>>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type AddressDataInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  stateProvince: Scalars['String']['input'];
  toName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressDataSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type AdjustAllocationInput = {
  allocationId: Scalars['String']['input'];
  newQty: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
};

export type AdjustMaterialItemInput = {
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

export type AdjustPostedProductionDataInput = {
  adjustmentId: Scalars['String']['input'];
  delta: Scalars['Int']['input'];
  grade: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  producedLocationId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  reasonCode: Scalars['Int']['input'];
};

export type AdjustProductionLotAllocationInput = {
  allocationId: Scalars['String']['input'];
  newAllocatedQty: Scalars['Int']['input'];
  orderedQty: Scalars['Int']['input'];
};

/**
 * Normalized MongoDB read model for admin management of background service configs.
 * One document per service. Contains the full PodAssignments array.
 * MultiReplicaCapable is code-owned (set by the seed via Set so it
 * stays authoritative across restarts) and never accepted on a mutation input.
 */
export type AdminBackgroundServiceConfigDocument = {
  __typename?: 'AdminBackgroundServiceConfigDocument';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  multiReplicaCapable: Scalars['Boolean']['output'];
  podAssignments: Array<PodAssignmentData>;
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export type AdminBackgroundServiceConfigPayload = {
  __typename?: 'AdminBackgroundServiceConfigPayload';
  data?: Maybe<BackgroundServiceConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResult = {
  __typename?: 'AdminBackgroundServiceConfigResult';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  podAssignmentCount: Scalars['Int']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  totalTenantCount: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigCount: Scalars['Int']['output'];
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResultFilterInput = {
  and?: InputMaybe<Array<AdminBackgroundServiceConfigResultFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminBackgroundServiceConfigResultFilterInput>>;
  podAssignmentCount?: InputMaybe<IntOperationFilterInput>;
  scope?: InputMaybe<BackgroundServiceScopeOperationFilterInput>;
  serviceName?: InputMaybe<BackgroundServiceNameOperationFilterInput>;
  timerPeriodSeconds?: InputMaybe<IntOperationFilterInput>;
  totalTenantCount?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  workerConfigCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResultSortInput = {
  displayName?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  podAssignmentCount?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  serviceName?: InputMaybe<SortEnumType>;
  timerPeriodSeconds?: InputMaybe<SortEnumType>;
  totalTenantCount?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  workerConfigCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminBackgroundServiceConfigsConnection = {
  __typename?: 'AdminBackgroundServiceConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminBackgroundServiceConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminBackgroundServiceConfigResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminBackgroundServiceConfigsEdge = {
  __typename?: 'AdminBackgroundServiceConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminBackgroundServiceConfigResult;
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResult = {
  __typename?: 'AdminBackgroundServicePodResult';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  tenantCount: Scalars['Int']['output'];
  timerPeriodSeconds: Scalars['Int']['output'];
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResultFilterInput = {
  and?: InputMaybe<Array<AdminBackgroundServicePodResultFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  notTenants?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AdminBackgroundServicePodResultFilterInput>>;
  podName?: InputMaybe<StringOperationFilterInput>;
  scope?: InputMaybe<BackgroundServiceScopeOperationFilterInput>;
  serviceName?: InputMaybe<BackgroundServiceNameOperationFilterInput>;
  tenantCount?: InputMaybe<IntOperationFilterInput>;
  timerPeriodSeconds?: InputMaybe<IntOperationFilterInput>;
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResultSortInput = {
  displayName?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  notTenants?: InputMaybe<SortEnumType>;
  podName?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  serviceName?: InputMaybe<SortEnumType>;
  tenantCount?: InputMaybe<SortEnumType>;
  timerPeriodSeconds?: InputMaybe<SortEnumType>;
};

/**
 * Bulk-create summary: Sent = emails an invite was created for (the worker emails them
 * within one tick), AlreadyInvited = emails that already have a pending unexpired invite
 * in this tenant. Whether the email already belongs to an existing FusionAuth user is detected
 * asynchronously by the worker before sending (the FusionAuth API key lives only in worker
 * config) and surfaced on the invite list.
 */
export type AdminCreateUserInvitesPayload = {
  __typename?: 'AdminCreateUserInvitesPayload';
  alreadyInvited: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  invites: Array<UserInviteDocument>;
  sent: Array<Scalars['String']['output']>;
};

/** Force-recalc every row for a given (tenant, customer) across all items and locations. */
export type AdminDbrCalcForceRecalcByCustomerInput = {
  customerLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a given (tenant, item) across all customers and locations. */
export type AdminDbrCalcForceRecalcByItemInput = {
  itemLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a given (tenant, location) across all customers and items. */
export type AdminDbrCalcForceRecalcByLocationInput = {
  locationLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a tenant. */
export type AdminDbrCalcForceRecalcByTenantInput = {
  tenantId: Scalars['String']['input'];
};

/** Force-recalc a single (tenant, customer, item, location) row. */
export type AdminDbrCalcForceRecalcRowInput = {
  customerLookupCode: Scalars['String']['input'];
  itemLookupCode: Scalars['String']['input'];
  locationLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByCustomerConnection = {
  __typename?: 'AdminDbrCalcResultsByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByCustomerEdge = {
  __typename?: 'AdminDbrCalcResultsByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByItemConnection = {
  __typename?: 'AdminDbrCalcResultsByItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByItemEdge = {
  __typename?: 'AdminDbrCalcResultsByItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByLocationConnection = {
  __typename?: 'AdminDbrCalcResultsByLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByLocationEdge = {
  __typename?: 'AdminDbrCalcResultsByLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByTenantConnection = {
  __typename?: 'AdminDbrCalcResultsByTenantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByTenantEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByTenantEdge = {
  __typename?: 'AdminDbrCalcResultsByTenantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcTenantQueueConnection = {
  __typename?: 'AdminDbrCalcTenantQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcTenantQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcTenantQueueDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcTenantQueueEdge = {
  __typename?: 'AdminDbrCalcTenantQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcTenantQueueDocument;
};

/**
 * Result of a force-recalc admin mutation. ModifiedCount is the number
 * of RestockWorkQueueDocument rows whose LastCalcDate, LockedDate,
 * and LeaseId were unset by the call. A modified count of zero is not an error —
 * it means no rows existed yet for the requested scope; the next upsert pass (S14/S15)
 * will create them with LastCalcDate=null, which the worker filter picks up.
 */
export type AdminDbrCalcWorkPayload = {
  __typename?: 'AdminDbrCalcWorkPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

/** GraphQL payload for admin feature flag mutations, containing either the result data or validation errors. */
export type AdminFeatureFlagPayload = {
  __typename?: 'AdminFeatureFlagPayload';
  data?: Maybe<FeatureFlagStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResult = {
  __typename?: 'AdminFeatureFlagResult';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  id: Scalars['String']['output'];
  status: FeatureFlagStatus;
  tenantOverrideCount: Scalars['Int']['output'];
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResultFilterInput = {
  and?: InputMaybe<Array<AdminFeatureFlagResultFilterInput>>;
  config?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  featureName?: InputMaybe<FeatureFlagNameOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminFeatureFlagResultFilterInput>>;
  status?: InputMaybe<FeatureFlagStatusOperationFilterInput>;
  tenantOverrideCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResultSortInput = {
  config?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  featureName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantOverrideCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminFeatureFlagsConnection = {
  __typename?: 'AdminFeatureFlagsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminFeatureFlagsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminFeatureFlagResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminFeatureFlagsEdge = {
  __typename?: 'AdminFeatureFlagsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminFeatureFlagResult;
};

export type AdminRestockCalcBatchTimingsResult = {
  __typename?: 'AdminRestockCalcBatchTimingsResult';
  averageMs?: Maybe<Scalars['Long']['output']>;
  p95Ms?: Maybe<Scalars['Long']['output']>;
  sampleCount: Scalars['Int']['output'];
};

export type AdminRestockCalcForceRecalcByCustomerInput = {
  customerCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByItemInput = {
  itemCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByLocationInput = {
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByTenantInput = {
  tenantId: Scalars['String']['input'];
};

/**
 * Force-recalc a single 5-tuple. weeksOfSupply is required because the
 *             on-demand work collection is keyed by the full 5-tuple.
 */
export type AdminRestockCalcForceRecalcRowInput = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};

/**
 * AR1 parity twin of WorkQueue.AdminRestockWorkQueuePayload. EnqueuedCount
 * here counts rows inserted-or-already-pending in RestockCalcOnDemandWork (legacy
 * AdminDbrCalcWorkPayload.modifiedCount counted rows whose calc-cache fields were unset
 * in RestockCalcWork). Field name carries the new semantics so the PWA can distinguish.
 */
export type AdminRestockCalcPayload = {
  __typename?: 'AdminRestockCalcPayload';
  enqueuedCount: Scalars['Long']['output'];
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocument = {
  __typename?: 'AdminRestockCalcResultDocument';
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  demandQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  inputsSnapshot: Array<AdminRestockCalcResultInputDocument>;
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  strategyKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocumentFilterInput = {
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<AdminRestockCalcResultDocumentFilterInput>>;
  calcDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  demandQuantity?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inputsSnapshot?: InputMaybe<ListFilterInputTypeOfAdminRestockCalcResultInputDocumentFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcResultDocumentFilterInput>>;
  strategyKey?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocumentSortInput = {
  achievableQuantity?: InputMaybe<SortEnumType>;
  calcDate?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  demandQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  strategyKey?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

export type AdminRestockCalcResultInputDocument = {
  __typename?: 'AdminRestockCalcResultInputDocument';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminRestockCalcResultInputDocumentFilterInput = {
  and?: InputMaybe<Array<AdminRestockCalcResultInputDocumentFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcResultInputDocumentFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByCustomerConnection = {
  __typename?: 'AdminRestockCalcResultsByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByCustomerEdge = {
  __typename?: 'AdminRestockCalcResultsByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByItemConnection = {
  __typename?: 'AdminRestockCalcResultsByItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByItemEdge = {
  __typename?: 'AdminRestockCalcResultsByItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByLocationConnection = {
  __typename?: 'AdminRestockCalcResultsByLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByLocationEdge = {
  __typename?: 'AdminRestockCalcResultsByLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByTenantConnection = {
  __typename?: 'AdminRestockCalcResultsByTenantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByTenantEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByTenantEdge = {
  __typename?: 'AdminRestockCalcResultsByTenantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** AR1 parity twin of WorkQueue.RestockWorkQueueSchedulerStatusResult. */
export type AdminRestockCalcSchedulerStatusResult = {
  __typename?: 'AdminRestockCalcSchedulerStatusResult';
  lastSuccessfulTick?: Maybe<Scalars['DateTime']['output']>;
  lastTick?: Maybe<Scalars['DateTime']['output']>;
  lastTickSucceeded?: Maybe<Scalars['Boolean']['output']>;
  tickIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type AdminRestockCalcTenantQueueConnection = {
  __typename?: 'AdminRestockCalcTenantQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcTenantQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcTenantQueueDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocument = {
  __typename?: 'AdminRestockCalcTenantQueueDocument';
  enabled: Scalars['Boolean']['output'];
  hasPendingWork: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxStalenessHours: Scalars['Int']['output'];
  oldestPendingCalcDate?: Maybe<Scalars['DateTime']['output']>;
  priority: Scalars['Int']['output'];
  refreshHours: Scalars['Int']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocumentFilterInput = {
  and?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentFilterInput>>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  hasPendingWork?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  oldestPendingCalcDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  refreshHours?: InputMaybe<IntOperationFilterInput>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocumentSortInput = {
  enabled?: InputMaybe<SortEnumType>;
  hasPendingWork?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxStalenessHours?: InputMaybe<SortEnumType>;
  oldestPendingCalcDate?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  refreshHours?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type AdminRestockCalcTenantQueueEdge = {
  __typename?: 'AdminRestockCalcTenantQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcTenantQueueDocument;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueSummary exposed by
 * AdminRestockCalcTenantQuery.GetAdminRestockCalcWorkSummary.
 */
export type AdminRestockCalcWorkSummary = {
  __typename?: 'AdminRestockCalcWorkSummary';
  hasPendingWork: Scalars['Boolean']['output'];
  oldestPending?: Maybe<Scalars['DateTime']['output']>;
};

/** AR1 parity twin of WorkQueue.RestockWorkQueueWorkerFleetStatusResult. */
export type AdminRestockCalcWorkerFleetStatusResult = {
  __typename?: 'AdminRestockCalcWorkerFleetStatusResult';
  currentLeases: Scalars['Int']['output'];
  oldestLeaseAgeMs?: Maybe<Scalars['Long']['output']>;
  recentBatchTimings: AdminRestockCalcBatchTimingsResult;
  recentIterationCount: Scalars['Int']['output'];
};

/**
 * Cross-tenant SuperAdmin payload for adminRestockDataValidity. Summary is
 * null only when input validation fails; per-check Mongo failures degrade that check to
 * Unknown inside the service rather than failing the query.
 */
export type AdminRestockDataValidityPayload = {
  __typename?: 'AdminRestockDataValidityPayload';
  errors?: Maybe<Array<ValidationError>>;
  summary?: Maybe<RestockDataValiditySummary>;
};

/**
 * Seeds Restock import data for a tenant. LocationCodes are per-store ErpIds (the values
 * surfaced by adminRestockSeedingCustomerLocations); empty means ALL resolvable
 * restock-configured stores of the selected customers (server-side expansion).
 * DryRun defaults to true: preview counts without writing.
 */
export type AdminRestockSeedImportDataInput = {
  customerCodes: Array<Scalars['String']['input']>;
  days?: Scalars['Int']['input'];
  dryRun?: Scalars['Boolean']['input'];
  itemCodes: Array<Scalars['String']['input']>;
  itemCost?: Scalars['Decimal']['input'];
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['String']['input'];
  unitsOnHand?: Scalars['Int']['input'];
  unitsPerDay?: Scalars['Int']['input'];
};

export type AdminRestockSeedImportDataPayload = {
  __typename?: 'AdminRestockSeedImportDataPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<AdminRestockSeedImportDataResult>;
};

/**
 * Outcome of a seed request: the expanded scope, per-collection upsert counts (zero in dry-run),
 * the seeded date window, the deterministic validation target
 * (ExpectedWeeklyRateOfSale = 7 × unitsPerDay), and non-fatal warnings
 * (unconfigured tuples skipped, items without availability).
 */
export type AdminRestockSeedImportDataResult = {
  __typename?: 'AdminRestockSeedImportDataResult';
  customerCount: Scalars['Int']['output'];
  dayCount: Scalars['Int']['output'];
  documentsPerCollection: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  expectedWeeklyRateOfSale: Scalars['Decimal']['output'];
  inventoryStatesModified: Scalars['Long']['output'];
  inventoryStatesUpserted: Scalars['Long']['output'];
  itemCount: Scalars['Int']['output'];
  locationTupleCount: Scalars['Int']['output'];
  transactionSummariesModified: Scalars['Long']['output'];
  transactionSummariesUpserted: Scalars['Long']['output'];
  warnings: Array<Scalars['String']['output']>;
  windowEndUtc: Scalars['DateTime']['output'];
  windowStartUtc: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type AdminRestockSeedingCustomerLocationsConnection = {
  __typename?: 'AdminRestockSeedingCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockSeedingCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockSeedingCustomerResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockSeedingCustomerLocationsEdge = {
  __typename?: 'AdminRestockSeedingCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockSeedingCustomerResult;
};

/**
 * A restock-configured customer with its per-store locations, for the seeding page dropdowns.
 * Sourced from RestockCustomerLocations joined per store to CustomersSummary; only stores with a
 * resolvable ErpId (the seed/dashboard key) are surfaced, so every selectable store can flow.
 */
export type AdminRestockSeedingCustomerResult = {
  __typename?: 'AdminRestockSeedingCustomerResult';
  customerLookupCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  locations: Array<AdminRestockSeedingLocationResult>;
};

/**
 * An item selectable for seeding. HasAvailability badges items with at least one
 * positive-quantity RestockAvailability row — items without it will seed demand but keep a
 * null achievable (allocation requires greenhouse availability).
 */
export type AdminRestockSeedingItemResult = {
  __typename?: 'AdminRestockSeedingItemResult';
  hasAvailability: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AdminRestockSeedingItemsConnection = {
  __typename?: 'AdminRestockSeedingItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockSeedingItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockSeedingItemResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockSeedingItemsEdge = {
  __typename?: 'AdminRestockSeedingItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockSeedingItemResult;
};

/**
 * Kicks the daily pre-calc pipeline for a tenant so freshly seeded import data flows the same
 * day: clears today's RestockPreCalculation success marker and satisfies the InventoryState
 * dependency. CustomerCodes scopes which seeded customers the admin is acting on (for
 * validation and the audit log); the next pre-calc tick picks up their data.
 */
export type AdminRestockSeedingKickPipelineInput = {
  customerCodes: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AdminRestockSeedingKickPipelinePayload = {
  __typename?: 'AdminRestockSeedingKickPipelinePayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<AdminRestockSeedingKickPipelineResult>;
};

/**
 * Outcome of a pipeline kick: which markers were cleared/written and the refreshed pipeline
 * status block.
 */
export type AdminRestockSeedingKickPipelineResult = {
  __typename?: 'AdminRestockSeedingKickPipelineResult';
  inventoryStateSyntheticWritten: Scalars['Boolean']['output'];
  preCalcMarkersCleared: Scalars['Long']['output'];
  status: AdminRestockSeedingPipelineStatusResult;
};

/**
 * A restock-configured store belonging to a seeding-page customer. LocationLookupCode is
 * the store's CustomersSummary.ErpId — the per-store key the seed write and the dashboard
 * store-row join use, echoed back as AdminRestockSeedImportDataInput.LocationCodes to
 * narrow to a single store. StoreNumber is for display only.
 */
export type AdminRestockSeedingLocationResult = {
  __typename?: 'AdminRestockSeedingLocationResult';
  locationLookupCode: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
};

/**
 * One pipeline entity's state. TodaySatisfied mirrors the wsapi-services daily guard:
 * any successful iteration ending within today UTC.
 */
export type AdminRestockSeedingPipelineEntityStatus = {
  __typename?: 'AdminRestockSeedingPipelineEntityStatus';
  entity: Scalars['String']['output'];
  lastIteration?: Maybe<AdminRestockSeedingPipelineIterationInfo>;
  todaySatisfied: Scalars['Boolean']['output'];
};

/** The most recent iteration of a pipeline entity, successful or not. */
export type AdminRestockSeedingPipelineIterationInfo = {
  __typename?: 'AdminRestockSeedingPipelineIterationInfo';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  itemsProcessed: Scalars['Long']['output'];
  start: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Per-entity pipeline state for a tenant: the last iteration of each daily-chain worker and
 * whether its today-UTC guard is satisfied. Explains why seeded data is not flowing and shows
 * post-kick progress.
 */
export type AdminRestockSeedingPipelineStatusResult = {
  __typename?: 'AdminRestockSeedingPipelineStatusResult';
  entities: Array<AdminRestockSeedingPipelineEntityStatus>;
  todayUtc: Scalars['DateTime']['output'];
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocument = {
  __typename?: 'AdminTenantDocument';
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: Maybe<TenantBillingData>;
  created: Scalars['DateTime']['output'];
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  finalCreditEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxDiscountPercentage: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId: Scalars['String']['output'];
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode: OrganicReceiveMode;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength: Scalars['Int']['output'];
  produceEnabled: Scalars['Boolean']['output'];
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled: Scalars['Boolean']['output'];
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours: Scalars['Int']['output'];
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours: Scalars['Int']['output'];
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey: Scalars['String']['output'];
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: Maybe<RestockProviderSettingsData>;
  status: TenantStatus;
  /**
   * When true, the order tax engine folds each line's royalty into the taxable base
   * ("tax on royalty"). Defaults to false so pre-feature BSON documents deserialize
   * cleanly to OFF — most tenants do NOT tax royalty. Read by the order tax input resolver.
   */
  taxRoyaltyEnabled: Scalars['Boolean']['output'];
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: Maybe<TrialKind>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: Maybe<TrialLimitsData>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: Maybe<TenantUnitConfigData>;
  useErpPricing: Scalars['Boolean']['output'];
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocumentFilterInput = {
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AdminTenantDocumentFilterInput>>;
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: InputMaybe<TenantBillingDataFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  finalCreditEnabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxDiscountPercentage?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminTenantDocumentFilterInput>>;
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode?: InputMaybe<OrganicReceiveModeOperationFilterInput>;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength?: InputMaybe<IntOperationFilterInput>;
  produceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours?: InputMaybe<IntOperationFilterInput>;
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: InputMaybe<RestockProviderSettingsDataFilterInput>;
  status?: InputMaybe<TenantStatusOperationFilterInput>;
  /**
   * When true, the order tax engine folds each line's royalty into the taxable base
   * ("tax on royalty"). Defaults to false so pre-feature BSON documents deserialize
   * cleanly to OFF — most tenants do NOT tax royalty. Read by the order tax input resolver.
   */
  taxRoyaltyEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: InputMaybe<NullableOfTrialKindOperationFilterInput>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: InputMaybe<TrialLimitsDataFilterInput>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: InputMaybe<TenantUnitConfigDataFilterInput>;
  useErpPricing?: InputMaybe<BooleanOperationFilterInput>;
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocumentSortInput = {
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: InputMaybe<TenantBillingDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: InputMaybe<SortEnumType>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: InputMaybe<SortEnumType>;
  finalCreditEnabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxDiscountPercentage?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode?: InputMaybe<SortEnumType>;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength?: InputMaybe<SortEnumType>;
  produceEnabled?: InputMaybe<SortEnumType>;
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled?: InputMaybe<SortEnumType>;
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours?: InputMaybe<SortEnumType>;
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours?: InputMaybe<SortEnumType>;
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: InputMaybe<RestockProviderSettingsDataSortInput>;
  status?: InputMaybe<SortEnumType>;
  /**
   * When true, the order tax engine folds each line's royalty into the taxable base
   * ("tax on royalty"). Defaults to false so pre-feature BSON documents deserialize
   * cleanly to OFF — most tenants do NOT tax royalty. Read by the order tax input resolver.
   */
  taxRoyaltyEnabled?: InputMaybe<SortEnumType>;
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: InputMaybe<SortEnumType>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: InputMaybe<SortEnumType>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: InputMaybe<TrialLimitsDataSortInput>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: InputMaybe<TenantUnitConfigDataSortInput>;
  useErpPricing?: InputMaybe<SortEnumType>;
};

/** GraphQL mutation payload for admin tenant operations. */
export type AdminTenantPayload = {
  __typename?: 'AdminTenantPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenant?: Maybe<TenantStateData>;
};

export type AdminTenantPricingPageDeleteInput = {
  tenantId: Scalars['String']['input'];
};

export type AdminTenantPricingPageUpsertInput = {
  content: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type AdminTenantsConnection = {
  __typename?: 'AdminTenantsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminTenantsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminTenantDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminTenantsEdge = {
  __typename?: 'AdminTenantsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminTenantDocument;
};

/**
 * GraphQL payload for admin trial policy mutations, containing either the resulting policy or
 * validation errors.
 */
export type AdminTrialPolicyPayload = {
  __typename?: 'AdminTrialPolicyPayload';
  data?: Maybe<TrialPolicyStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type AdminUserInvitesConnection = {
  __typename?: 'AdminUserInvitesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminUserInvitesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserInviteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminUserInvitesEdge = {
  __typename?: 'AdminUserInvitesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserInviteDocument;
};

/** A connection to a list of items. */
export type AdminUsersConnection = {
  __typename?: 'AdminUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminUsersEdge = {
  __typename?: 'AdminUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserDocument;
};

/**
 * MongoDB read model for admin management of worker configs.
 * One document per config name. Contains the full TenantValues array.
 */
export type AdminWorkerConfigDocument = {
  __typename?: 'AdminWorkerConfigDocument';
  configName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValues: Array<TenantValueData>;
};

export type AdminWorkerConfigPayload = {
  __typename?: 'AdminWorkerConfigPayload';
  data?: Maybe<WorkerConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResult = {
  __typename?: 'AdminWorkerConfigResult';
  configName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValueCount: Scalars['Int']['output'];
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResultFilterInput = {
  and?: InputMaybe<Array<AdminWorkerConfigResultFilterInput>>;
  configName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminWorkerConfigResultFilterInput>>;
  tenantValueCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResultSortInput = {
  configName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  tenantValueCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminWorkerConfigsConnection = {
  __typename?: 'AdminWorkerConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminWorkerConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminWorkerConfigResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminWorkerConfigsEdge = {
  __typename?: 'AdminWorkerConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminWorkerConfigResult;
};

/**
 * Result of one page-scoped advance call: the refreshed job (carrying id, status and the per-phase
 * progress counts), the phase that ran, how many rows this call processed, whether the scheduler
 * should call again (hasMoreWork), and any error.
 */
export type AdvanceProductionLotAsyncImportJobPayload = {
  __typename?: 'AdvanceProductionLotAsyncImportJobPayload';
  errors?: Maybe<Array<ValidationError>>;
  hasMoreWork: Scalars['Boolean']['output'];
  job?: Maybe<AsyncImportJobDocument>;
  phase: ProductionLotAdvancePhase;
  rowsProcessed: Scalars['Int']['output'];
};

export type AffectedChildJob = {
  __typename?: 'AffectedChildJob';
  affectedVariationIds: Array<Scalars['String']['output']>;
  parentProductionJobId?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
};

/**
 * Result of AgGridRowsQuery: row payloads plus an exact total computed only on the first
 * block. AG Grid's server-side row model in infinite-scroll mode detects the final block by a short
 * return, so the $facet/double-pass count cost is never paid (contrast GridResponse);
 * the first-block count is a separate sort-free $count (or Atlas $searchMeta) aggregation
 * that lets the client size the scrollbar / show a total.
 */
export type AgGridRowsResult = {
  __typename?: 'AgGridRowsResult';
  /**
   * Exact total row count for the current query, populated only when request.startRow == 0 and
   * null on every later block — AG Grid re-requests from row 0 whenever filter/sort/search/group keys
   * change, so the first-block count is always fresh. In grouping mode this counts groups at the
   * requested level.
   */
  rowCount?: Maybe<Scalars['Int']['output']>;
  /** The block's rows — heterogeneous by design (group rows vs leaf rows differ in shape). */
  rowData: Array<Scalars['JSON']['output']>;
  /**
   * Unfiltered grand total (records, ignoring the current filter/search), populated only on the first
   * block and only for grids that supply an unfiltered-count hook (e.g. combinedOrders); null otherwise.
   * Lets the client show "N filtered of M total" without a second round-trip.
   */
  unfilteredRowCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Result of AgGridSetValuesQuery: the distinct set-filter option values for one grid column,
 * normalized to grid-ready JSON primitives (canonical enum names, ISO dates, plain numbers) exactly like the
 * agGridRows output, sorted ascending and capped.
 */
export type AgGridSetValuesResult = {
  __typename?: 'AgGridSetValuesResult';
  /**
   * The distinct, normalized, ascending values a set filter offers for the requested column, reflecting the
   * grid's OTHER active filters (the target column's own filter is excluded). Never includes blanks.
   */
  values: Array<Scalars['JSON']['output']>;
};

export enum AgentType {
  Claude = 'CLAUDE',
  Codex = 'CODEX',
  Gemini = 'GEMINI',
  NotApplicable = 'NOT_APPLICABLE'
}

/** A connection to a list of items. */
export type AllBaseRatesOfSaleConnection = {
  __typename?: 'AllBaseRatesOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllBaseRatesOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BaseRateOfSaleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllBaseRatesOfSaleEdge = {
  __typename?: 'AllBaseRatesOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BaseRateOfSaleDocument;
};

/** A connection to a list of items. */
export type AllContainerConfigsConnection = {
  __typename?: 'AllContainerConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllContainerConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ContainerConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllContainerConfigsEdge = {
  __typename?: 'AllContainerConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContainerConfigDocument;
};

/** A connection to a list of items. */
export type AllDailySalesProportionsConnection = {
  __typename?: 'AllDailySalesProportionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDailySalesProportionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DailySalesProportionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDailySalesProportionsEdge = {
  __typename?: 'AllDailySalesProportionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DailySalesProportionDocument;
};

/** A connection to a list of items. */
export type AllDeliverySchedulesConnection = {
  __typename?: 'AllDeliverySchedulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDeliverySchedulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeliveryScheduleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDeliverySchedulesEdge = {
  __typename?: 'AllDeliverySchedulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeliveryScheduleDocument;
};

/** A connection to a list of items. */
export type AllForecastSettingsConnection = {
  __typename?: 'AllForecastSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllForecastSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ForecastSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllForecastSettingsEdge = {
  __typename?: 'AllForecastSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ForecastSettingsDocument;
};

/** A connection to a list of items. */
export type AllProgramReplenishmentSettingsConnection = {
  __typename?: 'AllProgramReplenishmentSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllProgramReplenishmentSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProgramReplenishmentSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllProgramReplenishmentSettingsEdge = {
  __typename?: 'AllProgramReplenishmentSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProgramReplenishmentSettingsDocument;
};

/** A connection to a list of items. */
export type AllReplenishmentSettingsConnection = {
  __typename?: 'AllReplenishmentSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllReplenishmentSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReplenishmentSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllReplenishmentSettingsEdge = {
  __typename?: 'AllReplenishmentSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReplenishmentSettingsDocument;
};

/** A connection to a list of items. */
export type AllWeeklySlopeFactorsConnection = {
  __typename?: 'AllWeeklySlopeFactorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllWeeklySlopeFactorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WeeklySlopeFactorDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllWeeklySlopeFactorsEdge = {
  __typename?: 'AllWeeklySlopeFactorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WeeklySlopeFactorDocument;
};

export type AllocateCommandInput = {
  allocationType: AllocationType;
  availability?: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  mode?: AllocationMode;
  perStoreMinimum?: Scalars['Int']['input'];
  priorities: Array<AllocationPriorityDimension>;
  reservationQuantity: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
  storeFilters: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AllocateLineItemDataInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  lineItemId: Scalars['UUID']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AllocateLineItemsInput = {
  items: Array<AllocateLineItemDataInput>;
  orderId: Scalars['String']['input'];
};

export type AllocateProductionLotToOrderLineInput = {
  allocatedQty: Scalars['Int']['input'];
  allocationId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  orderedQty: Scalars['Int']['input'];
  productionLotId: Scalars['String']['input'];
};

export type AllocationErrorData = {
  __typename?: 'AllocationErrorData';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AllocationItemData = {
  __typename?: 'AllocationItemData';
  allocatedAt: Scalars['DateTime']['output'];
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AllocationItemDocument = {
  __typename?: 'AllocationItemDocument';
  allocatedAt: Scalars['DateTime']['output'];
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type AllocationItemDocumentFilterInput = {
  allocatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  allocatedBy?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AllocationItemDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AllocationItemDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type AllocationItemDocumentSortInput = {
  allocatedAt?: InputMaybe<SortEnumType>;
  allocatedBy?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  lineItemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type AllocationLineItemData = {
  __typename?: 'AllocationLineItemData';
  allocatedQuantity: Scalars['Decimal']['output'];
  orderLineItemId: Scalars['String']['output'];
  purchaseOrderLineItemId: Scalars['String']['output'];
};

export type AllocationLineItemDataFilterInput = {
  allocatedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AllocationLineItemDataFilterInput>>;
  or?: InputMaybe<Array<AllocationLineItemDataFilterInput>>;
  orderLineItemId?: InputMaybe<StringOperationFilterInput>;
  purchaseOrderLineItemId?: InputMaybe<StringOperationFilterInput>;
};

export enum AllocationMode {
  AllocateAll = 'ALLOCATE_ALL',
  AllocateUpTo = 'ALLOCATE_UP_TO'
}

export type AllocationModeOperationFilterInput = {
  eq?: InputMaybe<AllocationMode>;
  in?: InputMaybe<Array<AllocationMode>>;
  neq?: InputMaybe<AllocationMode>;
  nin?: InputMaybe<Array<AllocationMode>>;
};

export type AllocationPayload = {
  __typename?: 'AllocationPayload';
  errors?: Maybe<Array<AllocationErrorData>>;
  result?: Maybe<AllocationResultData>;
};

export enum AllocationPriorityDimension {
  Available = 'AVAILABLE',
  Carts = 'CARTS',
  DaysSinceLastDelivery = 'DAYS_SINCE_LAST_DELIVERY',
  DaysSinceLastSale = 'DAYS_SINCE_LAST_SALE',
  DemandQuantity = 'DEMAND_QUANTITY',
  SellDownUnits = 'SELL_DOWN_UNITS',
  StoreClass = 'STORE_CLASS',
  TrailingSales = 'TRAILING_SALES',
  UnitsOnHand = 'UNITS_ON_HAND',
  WeeklyRateOfSale = 'WEEKLY_RATE_OF_SALE'
}

export type AllocationPriorityDimensionOperationFilterInput = {
  eq?: InputMaybe<AllocationPriorityDimension>;
  in?: InputMaybe<Array<AllocationPriorityDimension>>;
  neq?: InputMaybe<AllocationPriorityDimension>;
  nin?: InputMaybe<Array<AllocationPriorityDimension>>;
};

export type AllocationResultData = {
  __typename?: 'AllocationResultData';
  allocations: Array<StoreAllocationData>;
  feasibilityStatus: FeasibilityStatus;
  warnings: Array<Scalars['String']['output']>;
};

export type AllocationTemplateData = {
  __typename?: 'AllocationTemplateData';
  allocationType: AllocationType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  equalizeWeeksOfSupply: Scalars['Boolean']['output'];
  favorHigherWeight: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mode: AllocationMode;
  name: Scalars['String']['output'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AllocationTemplateDocument = {
  __typename?: 'AllocationTemplateDocument';
  allocationType: AllocationType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  equalizeWeeksOfSupply: Scalars['Boolean']['output'];
  favorHigherWeight: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  mode: AllocationMode;
  name: Scalars['String']['output'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AllocationTemplateDocumentFilterInput = {
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<AllocationTemplateDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  equalizeWeeksOfSupply?: InputMaybe<BooleanOperationFilterInput>;
  favorHigherWeight?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mode?: InputMaybe<AllocationModeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AllocationTemplateDocumentFilterInput>>;
  priorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  targetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type AllocationTemplateDocumentSortInput = {
  allocationType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  equalizeWeeksOfSupply?: InputMaybe<SortEnumType>;
  favorHigherWeight?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  targetWeeksOfSupply?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type AllocationTemplatePayload = {
  __typename?: 'AllocationTemplatePayload';
  errors?: Maybe<Array<ValidationError>>;
  template?: Maybe<AllocationTemplateData>;
};

/** A connection to a list of items. */
export type AllocationTemplatesConnection = {
  __typename?: 'AllocationTemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllocationTemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AllocationTemplateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllocationTemplatesEdge = {
  __typename?: 'AllocationTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AllocationTemplateDocument;
};

export enum AllocationType {
  StrictPriority = 'STRICT_PRIORITY',
  WeeklyDistribution = 'WEEKLY_DISTRIBUTION',
  WeightedDistribution = 'WEIGHTED_DISTRIBUTION'
}

export type AllocationTypeOperationFilterInput = {
  eq?: InputMaybe<AllocationType>;
  in?: InputMaybe<Array<AllocationType>>;
  neq?: InputMaybe<AllocationType>;
  nin?: InputMaybe<Array<AllocationType>>;
};

/**
 * Per-(tenant, productionCategory) allotted-time learning baseline (CC-WSAPI-B1), projected from
 * CountSessionCompleted events. A forward-only rolling baseline: every completed session
 * with a positive pace contributes its units/min and minutes/unit to a window capped at the most
 * recent WindowSize sessions (by completion time). The averages and median are
 * recomputed from the stored window on every update — never via relative operators — so the
 * document is a pure function of the SET of contributing sessions and is identical on replay
 * (Atlas accaf08f). Keyed by the composite {tenantId}-{productionCategoryId} document id,
 * so all access is by the auto-indexed _id.
 */
export type AllottedTimeBaselineDocument = {
  __typename?: 'AllottedTimeBaselineDocument';
  averageMinutesPerUnit: Scalars['Decimal']['output'];
  averageUnitsPerMinute: Scalars['Decimal']['output'];
  /** Number of sessions in the rolling window (capped at WindowSize). */
  completedSessionsCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  medianMinutesPerUnit: Scalars['Decimal']['output'];
  productionCategoryId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type AmendPurchaseOrderLineItemInput = {
  erpJobId?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  materialItemErpId?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
};

export type AppendTaxAuthorityRateInput = {
  effectiveDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  rate: Scalars['Decimal']['input'];
};

export type ApplyConsolidationGroupDataInput = {
  categoryGroup?: InputMaybe<Scalars['String']['input']>;
  genusCode?: InputMaybe<Scalars['String']['input']>;
  newQuantity: Scalars['Int']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  rollupLevel?: InputMaybe<ConsolidationPreviewRollupLevel>;
  sourceProductionLotIds: Array<Scalars['String']['input']>;
  weekReady: Scalars['DateTime']['input'];
};

export type ApplyConsolidationInput = {
  groups: Array<ApplyConsolidationGroupDataInput>;
};

export type ApplyConsolidationPayload = {
  __typename?: 'ApplyConsolidationPayload';
  consolidationResults: Array<ApplyConsolidationResultData>;
  errors?: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type ApplyConsolidationResultData = {
  __typename?: 'ApplyConsolidationResultData';
  archivedProductionLotIds: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  newProductionLotId?: Maybe<Scalars['String']['output']>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type ApprovePurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type AssignItemGlAccountsInput = {
  cogsGlAccountId?: InputMaybe<Scalars['String']['input']>;
  incomeGlAccountId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
};

export type AssignMaterialItemToVendorInput = {
  id: Scalars['String']['input'];
  vendor: MaterialVendorInput;
};

export type AssignUserCustomerInput = {
  customerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AssignUserCustomersInput = {
  customerIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserRoutesInput = {
  routes: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserSitesInput = {
  siteLocationIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignmentOverrideChangeProjection = {
  __typename?: 'AssignmentOverrideChangeProjection';
  eventId: Scalars['String']['output'];
  hasExistingOverride: Scalars['Boolean']['output'];
  jobDefaultAssignedTo?: Maybe<Scalars['String']['output']>;
  recipeDefaultAssignedTo?: Maybe<Scalars['String']['output']>;
};

/**
 * Read model for the supervisor "Assignments" tab in HardgoodsSidePanel: one document
 * per (tenant, assignment) carrying assignment-level state plus a per-task summary map
 * keyed by TaskId. Projected from CycleCountAssignment.V1.* events (HGI-09) with
 * absolute upserts and absolute per-task-key sets only — no reads, no relative operators
 * (atlas standard accaf08f270b40efa04fbbcdd605fc1c).
 */
export type AssignmentSummaryDocument = {
  __typename?: 'AssignmentSummaryDocument';
  assignmentId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  dueBy: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  /**
   * Flattened, distinct list of every material item touched by this assignment's
   * tasks. Maintained absolutely on CycleCountAssignmentEvents.V1.AssignmentCreated
   * from the per-task MaterialItemId. Backs Mongo-side filtering in
   * GetAssignmentHistoryByItem via $in + index seek (B4-E).
   */
  materialItemIds: Array<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Flattened, distinct list of every site location touched by this assignment's
   * tasks. Maintained absolutely on CycleCountAssignmentEvents.V1.AssignmentCreated
   * from the per-task SiteLocationId. Backs Mongo-side filtering in
   * GetAssignmentsByLocation via $in (B4-E). Empty when no task
   * carries a site (pre-B4-E historical events).
   */
  siteLocationIds: Array<Scalars['String']['output']>;
  status: CycleCountAssignmentStatus;
  tasks: Array<KeyValuePairOfStringAndAssignmentTaskSummary>;
  tenantId: Scalars['String']['output'];
  workerUserId: Scalars['String']['output'];
};

/**
 * Per-task projection of an assignment task for the supervisor summary. Read-model-only type
 * (not the event record). Status reflects the last absolute lifecycle event for the task.
 */
export type AssignmentTaskSummary = {
  __typename?: 'AssignmentTaskSummary';
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  expectedQty: Scalars['Decimal']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Site location of the bin this task targets (B4-E). Captured on the
   * CycleCountAssignmentEvents.V1.AssignmentCreated event from
   * the MaterialItemLocationQuantity row at fan-out time. Null on
   * historical pre-B4-E events.
   */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
};

export type AsyncImportJobDocument = {
  __typename?: 'AsyncImportJobDocument';
  asyncImportJobId: Scalars['String']['output'];
  autoStartImport: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  failedRows: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importedRows: Scalars['Int']['output'];
  jobType: AsyncImportJobType;
  status: AsyncImportJobStatus;
  tenantId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  validatedRows: Scalars['Int']['output'];
};

export type AsyncImportJobDocumentFilterInput = {
  and?: InputMaybe<Array<AsyncImportJobDocumentFilterInput>>;
  asyncImportJobId?: InputMaybe<StringOperationFilterInput>;
  autoStartImport?: InputMaybe<BooleanOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  failedRows?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  importedRows?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<AsyncImportJobTypeOperationFilterInput>;
  or?: InputMaybe<Array<AsyncImportJobDocumentFilterInput>>;
  status?: InputMaybe<AsyncImportJobStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalRows?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  validatedRows?: InputMaybe<IntOperationFilterInput>;
};

export type AsyncImportJobDocumentSortInput = {
  asyncImportJobId?: InputMaybe<SortEnumType>;
  autoStartImport?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  failedRows?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importedRows?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalRows?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  validatedRows?: InputMaybe<SortEnumType>;
};

export type AsyncImportJobPayload = {
  __typename?: 'AsyncImportJobPayload';
  asyncImportJob?: Maybe<AsyncImportJobDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum AsyncImportJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Importing = 'IMPORTING',
  Pending = 'PENDING',
  ReadyForImport = 'READY_FOR_IMPORT',
  Unknown = 'UNKNOWN',
  Uploading = 'UPLOADING',
  Validated = 'VALIDATED',
  Validating = 'VALIDATING',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type AsyncImportJobStatusOperationFilterInput = {
  eq?: InputMaybe<AsyncImportJobStatus>;
  in?: InputMaybe<Array<AsyncImportJobStatus>>;
  neq?: InputMaybe<AsyncImportJobStatus>;
  nin?: InputMaybe<Array<AsyncImportJobStatus>>;
};

export enum AsyncImportJobType {
  ProductionLot = 'PRODUCTION_LOT',
  SiteLocation = 'SITE_LOCATION',
  Unknown = 'UNKNOWN'
}

export type AsyncImportJobTypeOperationFilterInput = {
  eq?: InputMaybe<AsyncImportJobType>;
  in?: InputMaybe<Array<AsyncImportJobType>>;
  neq?: InputMaybe<AsyncImportJobType>;
  nin?: InputMaybe<Array<AsyncImportJobType>>;
};

/** A connection to a list of items. */
export type AsyncImportJobsConnection = {
  __typename?: 'AsyncImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AsyncImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AsyncImportJobsEdge = {
  __typename?: 'AsyncImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

export enum AsyncImportRowStatus {
  Imported = 'IMPORTED',
  ImportFailed = 'IMPORT_FAILED',
  New = 'NEW',
  Unknown = 'UNKNOWN',
  Validated = 'VALIDATED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type AsyncImportRowStatusOperationFilterInput = {
  eq?: InputMaybe<AsyncImportRowStatus>;
  in?: InputMaybe<Array<AsyncImportRowStatus>>;
  neq?: InputMaybe<AsyncImportRowStatus>;
  nin?: InputMaybe<Array<AsyncImportRowStatus>>;
};

/**
 * Input record for the atomicMove mutation. Emits Created + Shipped + Received
 * in a single transaction with shared timestamp.
 */
export type AtomicMoveMovementOrderInput = {
  fromSiteLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lines: Array<MovementOrderLineInput>;
  movementOrderId: Scalars['String']['input'];
  toSiteLocationId: Scalars['String']['input'];
};

export type AttachAvailabilityPhotoInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type AutoAllocateRestockSessionOrderQuantitiesInput = {
  allocations: Array<AutoAllocateRestockSessionOrderQuantityAllocationDataInput>;
  itemId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type AutoAllocateRestockSessionOrderQuantityAllocationDataInput = {
  customerLocationId: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
};

export type AvailabilityAdjustmentData = {
  __typename?: 'AvailabilityAdjustmentData';
  comment: Scalars['String']['output'];
  direction: AvailabilityAdjustmentDirection;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reason: AvailabilityAdjustmentReason;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export enum AvailabilityAdjustmentDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export enum AvailabilityAdjustmentReason {
  Ordered = 'ORDERED',
  OrderCancelled = 'ORDER_CANCELLED'
}

export type AvailabilityCountData = {
  __typename?: 'AvailabilityCountData';
  comment: Scalars['String']['output'];
  countRowId: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type AvailabilityImportItemInput = {
  itemMatcher: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
};

export enum AvailabilityImportItemMatchStatus {
  Matched = 'MATCHED',
  MultipleMatches = 'MULTIPLE_MATCHES',
  NotFound = 'NOT_FOUND'
}

export type AvailabilityImportItemResolutionData = {
  __typename?: 'AvailabilityImportItemResolutionData';
  itemId?: Maybe<Scalars['String']['output']>;
  itemMatcher: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  status: AvailabilityImportItemMatchStatus;
};

export type AvailabilityImportItemResolutionPayload = {
  __typename?: 'AvailabilityImportItemResolutionPayload';
  errors?: Maybe<Array<ValidationError>>;
  items?: Maybe<Array<AvailabilityImportItemResolutionData>>;
};

export type AvailabilitySessionDocument = {
  __typename?: 'AvailabilitySessionDocument';
  id: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
  sessionId: Scalars['String']['output'];
  status: AvailabilitySessionStatus;
  tenantId: Scalars['String']['output'];
  totalNumberOfAdjustments: Scalars['Int']['output'];
  totalNumberOfCounts: Scalars['Int']['output'];
};

export type AvailabilitySessionDocumentFilterInput = {
  and?: InputMaybe<Array<AvailabilitySessionDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AvailabilitySessionDocumentFilterInput>>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AvailabilitySessionStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalNumberOfAdjustments?: InputMaybe<IntOperationFilterInput>;
  totalNumberOfCounts?: InputMaybe<IntOperationFilterInput>;
};

export type AvailabilitySessionDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  recordedAt?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalNumberOfAdjustments?: InputMaybe<SortEnumType>;
  totalNumberOfCounts?: InputMaybe<SortEnumType>;
};

export type AvailabilitySessionLogData = {
  __typename?: 'AvailabilitySessionLogData';
  comment: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
};

export type AvailabilitySessionPayload = {
  __typename?: 'AvailabilitySessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  session?: Maybe<AvailabilitySessionStateData>;
};

export type AvailabilitySessionStateData = {
  __typename?: 'AvailabilitySessionStateData';
  adjustments: Array<AvailabilityAdjustmentData>;
  counts: Array<AvailabilityCountData>;
  logs: Array<AvailabilitySessionLogData>;
  sessionId: Scalars['String']['output'];
  status: AvailabilitySessionStatus;
  tenantId: Scalars['String']['output'];
};

export enum AvailabilitySessionStatus {
  Closed = 'CLOSED',
  Live = 'LIVE',
  Staged = 'STAGED'
}

export type AvailabilitySessionStatusOperationFilterInput = {
  eq?: InputMaybe<AvailabilitySessionStatus>;
  in?: InputMaybe<Array<AvailabilitySessionStatus>>;
  neq?: InputMaybe<AvailabilitySessionStatus>;
  nin?: InputMaybe<Array<AvailabilitySessionStatus>>;
};

/** A connection to a list of items. */
export type AvailabilitySessionsConnection = {
  __typename?: 'AvailabilitySessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AvailabilitySessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AvailabilitySessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AvailabilitySessionsEdge = {
  __typename?: 'AvailabilitySessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AvailabilitySessionDocument;
};

/** A connection to a list of items. */
export type AvailableInventoryConnection = {
  __typename?: 'AvailableInventoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AvailableInventoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AvailableInventoryEdge = {
  __typename?: 'AvailableInventoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/**
 * Result containing an enabled background service configuration for a pod manifest.
 * MultiReplicaCapable is derived from ServiceName;
 * Replicas is the deployment replica count for this (service × pod) row.
 */
export type BackgroundServiceConfigManifestResult = {
  __typename?: 'BackgroundServiceConfigManifestResult';
  displayName: Scalars['String']['output'];
  multiReplicaCapable: Scalars['Boolean']['output'];
  replicas: Scalars['Int']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  tenantIds: Array<Scalars['String']['output']>;
  timerPeriodSeconds: Scalars['Int']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export type BackgroundServiceConfigStateData = {
  __typename?: 'BackgroundServiceConfigStateData';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  /**
   * Code-owned flag derived from ServiceName. Read-only on the API surface —
   * never present on any mutation input.
   */
  multiReplicaCapable: Scalars['Boolean']['output'];
  podAssignments: Array<PodAssignmentStateData>;
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export enum BackgroundServiceName {
  AcknowledgmentEmail = 'ACKNOWLEDGMENT_EMAIL',
  AsyncImport = 'ASYNC_IMPORT',
  BcCustomerSync = 'BC_CUSTOMER_SYNC',
  BcItemSync = 'BC_ITEM_SYNC',
  BpfCycleCountMissionPostback = 'BPF_CYCLE_COUNT_MISSION_POSTBACK',
  BpfCycleCountMissionSync = 'BPF_CYCLE_COUNT_MISSION_SYNC',
  ClickUpTimeAggregation = 'CLICK_UP_TIME_AGGREGATION',
  ConfirmationEmail = 'CONFIRMATION_EMAIL',
  CsvToMongoSync = 'CSV_TO_MONGO_SYNC',
  CsvToSqlSync = 'CSV_TO_SQL_SYNC',
  CustomerClean = 'CUSTOMER_CLEAN',
  CustomerSync = 'CUSTOMER_SYNC',
  DailyTenantSync = 'DAILY_TENANT_SYNC',
  DtsOnHandQueuing = 'DTS_ON_HAND_QUEUING',
  ErpAvailabilitySync = 'ERP_AVAILABILITY_SYNC',
  ErpInTransitSync = 'ERP_IN_TRANSIT_SYNC',
  ErpLoadListRouteSync = 'ERP_LOAD_LIST_ROUTE_SYNC',
  ErpLoadListUserSync = 'ERP_LOAD_LIST_USER_SYNC',
  ErpOrderReceiptPostback = 'ERP_ORDER_RECEIPT_POSTBACK',
  ErpOrderSync = 'ERP_ORDER_SYNC',
  FgAvailabilitySift = 'FG_AVAILABILITY_SIFT',
  FgAvailabilitySnapshot = 'FG_AVAILABILITY_SNAPSHOT',
  FinishLotPostback = 'FINISH_LOT_POSTBACK',
  FinishLotSync = 'FINISH_LOT_SYNC',
  FlagStaleFloatingTimeEntry = 'FLAG_STALE_FLOATING_TIME_ENTRY',
  FlakyTaskCreator = 'FLAKY_TASK_CREATOR',
  FootTrafficIngestion = 'FOOT_TRAFFIC_INGESTION',
  FredIngestion = 'FRED_INGESTION',
  GrowPointCategoryImport = 'GROW_POINT_CATEGORY_IMPORT',
  GrowPointCategoryValidate = 'GROW_POINT_CATEGORY_VALIDATE',
  GrowPointCustomerExtract = 'GROW_POINT_CUSTOMER_EXTRACT',
  GrowPointCustomerExtractor = 'GROW_POINT_CUSTOMER_EXTRACTOR',
  GrowPointCustomerImport = 'GROW_POINT_CUSTOMER_IMPORT',
  GrowPointCustomerValidate = 'GROW_POINT_CUSTOMER_VALIDATE',
  GrowPointHistoricalOrderImport = 'GROW_POINT_HISTORICAL_ORDER_IMPORT',
  GrowPointHistoricalOrderValidate = 'GROW_POINT_HISTORICAL_ORDER_VALIDATE',
  GrowPointImport = 'GROW_POINT_IMPORT',
  GrowPointInventoryImport = 'GROW_POINT_INVENTORY_IMPORT',
  GrowPointInventoryValidate = 'GROW_POINT_INVENTORY_VALIDATE',
  GrowPointItemExtract = 'GROW_POINT_ITEM_EXTRACT',
  GrowPointItemExtractor = 'GROW_POINT_ITEM_EXTRACTOR',
  GrowPointItemImport = 'GROW_POINT_ITEM_IMPORT',
  GrowPointItemValidate = 'GROW_POINT_ITEM_VALIDATE',
  GrowPointPriceImport = 'GROW_POINT_PRICE_IMPORT',
  GrowPointPriceValidate = 'GROW_POINT_PRICE_VALIDATE',
  GrowPointSiteLocationImport = 'GROW_POINT_SITE_LOCATION_IMPORT',
  GrowPointSiteLocationValidate = 'GROW_POINT_SITE_LOCATION_VALIDATE',
  GrowPointTaxAuthorityImport = 'GROW_POINT_TAX_AUTHORITY_IMPORT',
  GrowPointTaxAuthorityValidate = 'GROW_POINT_TAX_AUTHORITY_VALIDATE',
  GrowPointTermsImport = 'GROW_POINT_TERMS_IMPORT',
  GrowPointTermsValidate = 'GROW_POINT_TERMS_VALIDATE',
  InventoryInTransitSync = 'INVENTORY_IN_TRANSIT_SYNC',
  InventoryStateSync = 'INVENTORY_STATE_SYNC',
  ItemClean = 'ITEM_CLEAN',
  ItemPricingSync = 'ITEM_PRICING_SYNC',
  ItemProgramClean = 'ITEM_PROGRAM_CLEAN',
  ItemSync = 'ITEM_SYNC',
  IterationFailureEmail = 'ITERATION_FAILURE_EMAIL',
  JobSync = 'JOB_SYNC',
  LoadListSync = 'LOAD_LIST_SYNC',
  LocationSync = 'LOCATION_SYNC',
  MaterialLotProcessing = 'MATERIAL_LOT_PROCESSING',
  MergeDevCrmExport = 'MERGE_DEV_CRM_EXPORT',
  MergeDevCrmImport = 'MERGE_DEV_CRM_IMPORT',
  MergeDevImport = 'MERGE_DEV_IMPORT',
  NavOnHandQueuing = 'NAV_ON_HAND_QUEUING',
  NewsIngestion = 'NEWS_INGESTION',
  NoaaIngestion = 'NOAA_INGESTION',
  OnHandProcess = 'ON_HAND_PROCESS',
  OrderEaseAvailability = 'ORDER_EASE_AVAILABILITY',
  OrderEaseImport = 'ORDER_EASE_IMPORT',
  OrderSync = 'ORDER_SYNC',
  PipelineFlakeImport = 'PIPELINE_FLAKE_IMPORT',
  PortalLoginRedirectSync = 'PORTAL_LOGIN_REDIRECT_SYNC',
  /** @deprecated Retired with the PortalUserRequest queue (Kennedy 2026-07-17); worker decommission tracked separately. Retained for BSON string round-tripping of existing config docs per discipline bf43effe — never renumber or reuse ordinal 33. */
  PortalUserSync = 'PORTAL_USER_SYNC',
  ReportScheduleExecution = 'REPORT_SCHEDULE_EXECUTION',
  RestockCalcAchievableQuantity = 'RESTOCK_CALC_ACHIEVABLE_QUANTITY',
  RestockCalcAchievableQuantityDrain = 'RESTOCK_CALC_ACHIEVABLE_QUANTITY_DRAIN',
  RestockCalcDemandQuantity = 'RESTOCK_CALC_DEMAND_QUANTITY',
  RestockCalcScheduler = 'RESTOCK_CALC_SCHEDULER',
  RestockCalcStalenessNotifier = 'RESTOCK_CALC_STALENESS_NOTIFIER',
  RestockCalcWorkMembershipUpserter = 'RESTOCK_CALC_WORK_MEMBERSHIP_UPSERTER',
  RestockOrderSync = 'RESTOCK_ORDER_SYNC',
  RestockPreCalculation = 'RESTOCK_PRE_CALCULATION',
  RetailBpLotSync = 'RETAIL_BP_LOT_SYNC',
  RetailCountPostback = 'RETAIL_COUNT_POSTBACK',
  RfidScanSync = 'RFID_SCAN_SYNC',
  SalesPeopleSync = 'SALES_PEOPLE_SYNC',
  SftpSync = 'SFTP_SYNC',
  ShopifyAvailabilitySync = 'SHOPIFY_AVAILABILITY_SYNC',
  ShopifyOrderImport = 'SHOPIFY_ORDER_IMPORT',
  SignupForgeHook = 'SIGNUP_FORGE_HOOK',
  SiteLocationsSync = 'SITE_LOCATIONS_SYNC',
  StationManagerSync = 'STATION_MANAGER_SYNC',
  TestTimingRollup = 'TEST_TIMING_ROLLUP',
  TrialExpiry = 'TRIAL_EXPIRY',
  TrialProvisioning = 'TRIAL_PROVISIONING',
  UnitsOnHandSync = 'UNITS_ON_HAND_SYNC',
  UnitsShippedSync = 'UNITS_SHIPPED_SYNC',
  Unknown = 'UNKNOWN',
  UserInvite = 'USER_INVITE',
  UserLastLoginSync = 'USER_LAST_LOGIN_SYNC'
}

export type BackgroundServiceNameOperationFilterInput = {
  eq?: InputMaybe<BackgroundServiceName>;
  in?: InputMaybe<Array<BackgroundServiceName>>;
  neq?: InputMaybe<BackgroundServiceName>;
  nin?: InputMaybe<Array<BackgroundServiceName>>;
};

export enum BackgroundServiceScope {
  PerTenant = 'PER_TENANT',
  System = 'SYSTEM'
}

export type BackgroundServiceScopeOperationFilterInput = {
  eq?: InputMaybe<BackgroundServiceScope>;
  in?: InputMaybe<Array<BackgroundServiceScope>>;
  neq?: InputMaybe<BackgroundServiceScope>;
  nin?: InputMaybe<Array<BackgroundServiceScope>>;
};

export type BaseRateOfSaleDocument = {
  __typename?: 'BaseRateOfSaleDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  program: Scalars['String']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

export type BaseRateOfSaleDocumentFilterInput = {
  and?: InputMaybe<Array<BaseRateOfSaleDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BaseRateOfSaleDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  weeklyRateOfSale?: InputMaybe<DecimalOperationFilterInput>;
};

export type BaseRateOfSaleDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold?: InputMaybe<SortEnumType>;
  weeklyRateOfSale?: InputMaybe<SortEnumType>;
};

export type BatchActivateCategoriesInput = {
  categories: Array<ActivateCategoryInput>;
};

export type BatchActivateCustomersInput = {
  customers: Array<ActivateCustomerInput>;
};

export type BatchActivateItemsInput = {
  items: Array<ActivateItemInput>;
};

export type BatchActivatePriceGroupsInput = {
  priceGroups: Array<ActivatePriceGroupInput>;
};

export type BatchAddCategoriesInput = {
  categories: Array<AddCategoryInput>;
};

export type BatchDeactivateProductionLotResult = {
  __typename?: 'BatchDeactivateProductionLotResult';
  errors?: Maybe<Array<ValidationError>>;
  productionLot?: Maybe<ProductionLotStateData>;
  productionLotId: Scalars['String']['output'];
};

export type BatchDeactivateProductionLotsInput = {
  items: Array<DeactivateProductionLotInput>;
};

export type BatchDeactivateProductionLotsPayload = {
  __typename?: 'BatchDeactivateProductionLotsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<BatchDeactivateProductionLotResult>;
};

export type BatchDeleteCustomersInput = {
  customers: Array<DeleteCustomerInput>;
};

export type BatchDeleteItemsInput = {
  items: Array<DeleteItemInput>;
};

export type BatchDeletePriceGroupsInput = {
  priceGroups: Array<DeletePriceGroupInput>;
};

export type BatchDeleteSiteLocationsInput = {
  siteLocations: Array<DeleteSiteLocationInput>;
};

export type BatchInactivateCategoriesInput = {
  categories: Array<InactivateCategoryInput>;
};

export type BatchInactivateCustomersInput = {
  customers: Array<InactivateCustomerInput>;
};

export type BatchInactivateItemsInput = {
  items: Array<InactivateItemInput>;
};

export type BatchInactivatePriceGroupsInput = {
  priceGroups: Array<InactivatePriceGroupInput>;
};

export type BatchRemoveCategoriesInput = {
  categories: Array<RemoveCategoryInput>;
};

/** Batch timing aggregates over the recent window. */
export type BatchTimingsResult = {
  __typename?: 'BatchTimingsResult';
  /** Mean of TotalMs across the window. Null when no recent samples. */
  averageMs?: Maybe<Scalars['Long']['output']>;
  /**
   * 95th-percentile TotalMs using the nearest-rank method
   * (ceil(0.95 * n) - 1, clamped to [0, n-1]). Null when no recent samples.
   */
  p95Ms?: Maybe<Scalars['Long']['output']>;
  /** Number of iteration samples contributing to AverageMs / P95Ms. */
  sampleCount: Scalars['Int']['output'];
};

export type BatchUpdateCategoriesInput = {
  categories: Array<UpdateCategoryInput>;
};

/**
 * Batch input for batchUpdateCrmExportStatuses. The wsapi-services worker submits one row
 * per customer it processed this cycle; each row carries exactly one outcome. Mirrors
 * BatchUpdateMergeDevExportStatuses. Rows with zero or multiple outcomes are rejected
 * per-row, not at the batch level.
 */
export type BatchUpdateCrmExportStatusesInput = {
  updates: Array<CrmExportStatusUpdateRowInput>;
};

/**
 * Batch input for batchUpdateMergeDevExportStatuses. The worker submits one row per
 * processed entity; each row carries exactly one outcome discriminator (MergeDevExportStatusUpdateRow.Completed,
 * MergeDevExportStatusUpdateRow.FailedTransient, or MergeDevExportStatusUpdateRow.FailedPermanent).
 * Rows with zero or multiple discriminators are rejected per-row, not at the batch level.
 */
export type BatchUpdateMergeDevExportStatusesInput = {
  updates: Array<MergeDevExportStatusUpdateRowInput>;
};

export enum BillingFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY'
}

export type BillingFrequencyOperationFilterInput = {
  eq?: InputMaybe<BillingFrequency>;
  in?: InputMaybe<Array<BillingFrequency>>;
  neq?: InputMaybe<BillingFrequency>;
  nin?: InputMaybe<Array<BillingFrequency>>;
};

export enum BillingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  None = 'NONE',
  PastDue = 'PAST_DUE',
  Suspended = 'SUSPENDED',
  Trialing = 'TRIALING'
}

export type BillingStatusOperationFilterInput = {
  eq?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  neq?: InputMaybe<BillingStatus>;
  nin?: InputMaybe<Array<BillingStatus>>;
};

export type BlockingRuleItemLocationDocument = {
  __typename?: 'BlockingRuleItemLocationDocument';
  blockingRuleId: Scalars['String']['output'];
  blockingRuleName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BlockingRuleItemLocationDocumentFilterInput = {
  and?: InputMaybe<Array<BlockingRuleItemLocationDocumentFilterInput>>;
  blockingRuleId?: InputMaybe<StringOperationFilterInput>;
  blockingRuleName?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BlockingRuleItemLocationDocumentFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BlockingRuleItemLocationDocumentSortInput = {
  blockingRuleId?: InputMaybe<SortEnumType>;
  blockingRuleName?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BlockingRuleItemLocationsConnection = {
  __typename?: 'BlockingRuleItemLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BlockingRuleItemLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BlockingRuleItemLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BlockingRuleItemLocationsEdge = {
  __typename?: 'BlockingRuleItemLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BlockingRuleItemLocationDocument;
};

export type BlockingRulePayload = {
  __typename?: 'BlockingRulePayload';
  blockingRule?: Maybe<BlockingRuleStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type BlockingRuleStateData = {
  __typename?: 'BlockingRuleStateData';
  blockingRuleId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: BlockingRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum BlockingRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type BpfCycleCountMissionTasksConnection = {
  __typename?: 'BpfCycleCountMissionTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfCycleCountMissionTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfMissionTaskDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfCycleCountMissionTasksEdge = {
  __typename?: 'BpfCycleCountMissionTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfMissionTaskDocument;
};

/** A connection to a list of items. */
export type BpfCycleCountMissionsConnection = {
  __typename?: 'BpfCycleCountMissionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfCycleCountMissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfMissionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfCycleCountMissionsEdge = {
  __typename?: 'BpfCycleCountMissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfMissionDocument;
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The optimistic
 * delta to BpfLotCountDocument and the ERP write-back enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocument = {
  __typename?: 'BpfLotChangeDocument';
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode: Scalars['String']['output'];
  /** The kind of change recorded. */
  changeType: BpfLotChangeType;
  /** When the change was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** The ERP write-back queue record id this change enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId: Scalars['String']['output'];
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId: Scalars['String']['output'];
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic delta or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-counts.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The Nav item / SKU this change concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference: Scalars['String']['output'];
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId: Scalars['String']['output'];
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /** Free-form field-user notes; empty when none. */
  notes: Scalars['String']['output'];
  /** The signed quantity delta the field user recorded. */
  quantityChange: Scalars['Decimal']['output'];
  /** The stage the change applies to (Grow / Ready / Material). */
  stage: BpfLotStage;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId: Scalars['String']['output'];
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId: Scalars['String']['output'];
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user: Scalars['String']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The optimistic
 * delta to BpfLotCountDocument and the ERP write-back enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotChangeDocumentFilterInput>>;
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  /** The kind of change recorded. */
  changeType?: InputMaybe<BpfLotChangeTypeOperationFilterInput>;
  /** When the change was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The ERP write-back queue record id this change enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic delta or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-counts.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this change concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference?: InputMaybe<StringOperationFilterInput>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId?: InputMaybe<StringOperationFilterInput>;
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfLotChangeDocumentFilterInput>>;
  /** The signed quantity delta the field user recorded. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The stage the change applies to (Grow / Ready / Material). */
  stage?: InputMaybe<BpfLotStageOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The optimistic
 * delta to BpfLotCountDocument and the ERP write-back enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocumentSortInput = {
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode?: InputMaybe<SortEnumType>;
  /** The kind of change recorded. */
  changeType?: InputMaybe<SortEnumType>;
  /** When the change was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The ERP write-back queue record id this change enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic delta or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-counts.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this change concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference?: InputMaybe<SortEnumType>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId?: InputMaybe<SortEnumType>;
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<SortEnumType>;
  /** The signed quantity delta the field user recorded. */
  quantityChange?: InputMaybe<SortEnumType>;
  /** The stage the change applies to (Grow / Ready / Material). */
  stage?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

/**
 * Single-record payload for the BPF lot-change mutation. Carries the audit record on success, or the
 * validation error(s) on failure (including the BPF-only tenant rejection).
 */
export type BpfLotChangePayload = {
  __typename?: 'BpfLotChangePayload';
  errors?: Maybe<Array<ValidationError>>;
  lotChange?: Maybe<BpfLotChangeDocument>;
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocument = {
  __typename?: 'BpfLotChangeReasonDocument';
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code: Scalars['String']['output'];
  /** The human-facing reason description shown in the PWA dropdown. */
  description: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotChangeReasonDocumentFilterInput>>;
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code?: InputMaybe<StringOperationFilterInput>;
  /** The human-facing reason description shown in the PWA dropdown. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfLotChangeReasonDocumentFilterInput>>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocumentSortInput = {
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code?: InputMaybe<SortEnumType>;
  /** The human-facing reason description shown in the PWA dropdown. */
  description?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BpfLotChangeReasonsConnection = {
  __typename?: 'BpfLotChangeReasonsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotChangeReasonsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotChangeReasonDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotChangeReasonsEdge = {
  __typename?: 'BpfLotChangeReasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotChangeReasonDocument;
};

export enum BpfLotChangeType {
  AddInventory = 'ADD_INVENTORY',
  BackToGrow = 'BACK_TO_GROW',
  Confirm = 'CONFIRM',
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Move = 'MOVE',
  Output = 'OUTPUT',
  Unknown = 'UNKNOWN'
}

export type BpfLotChangeTypeOperationFilterInput = {
  eq?: InputMaybe<BpfLotChangeType>;
  in?: InputMaybe<Array<BpfLotChangeType>>;
  neq?: InputMaybe<BpfLotChangeType>;
  nin?: InputMaybe<Array<BpfLotChangeType>>;
};

/** A connection to a list of items. */
export type BpfLotChangesConnection = {
  __typename?: 'BpfLotChangesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotChangesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotChangeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotChangesEdge = {
  __typename?: 'BpfLotChangesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotChangeDocument;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput.
 */
export type BpfLotCountDocument = {
  __typename?: 'BpfLotCountDocument';
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The Nav item / SKU this lot concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference: Scalars['String']['output'];
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /** The current on-hand quantity at this stage and location. */
  quantity: Scalars['Decimal']['output'];
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId: Scalars['String']['output'];
  /**
   * The last writer: NavSyncSource when reconciled from Nav, or
   * OptimisticSource when last touched by a mutation's optimistic delta. Nav
   * reconciliation always overwrites optimistic state.
   */
  source: Scalars['String']['output'];
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage: BpfLotStage;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for Quantity (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated: Scalars['DateTime']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput.
 */
export type BpfLotCountDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotCountDocumentFilterInput>>;
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this lot concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfLotCountDocumentFilterInput>>;
  /** The current on-hand quantity at this stage and location. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The last writer: NavSyncSource when reconciled from Nav, or
   * OptimisticSource when last touched by a mutation's optimistic delta. Nav
   * reconciliation always overwrites optimistic state.
   */
  source?: InputMaybe<StringOperationFilterInput>;
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage?: InputMaybe<BpfLotStageOperationFilterInput>;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for Quantity (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput.
 */
export type BpfLotCountDocumentSortInput = {
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this lot concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference?: InputMaybe<SortEnumType>;
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /** The current on-hand quantity at this stage and location. */
  quantity?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId?: InputMaybe<SortEnumType>;
  /**
   * The last writer: NavSyncSource when reconciled from Nav, or
   * OptimisticSource when last touched by a mutation's optimistic delta. Nav
   * reconciliation always overwrites optimistic state.
   */
  source?: InputMaybe<SortEnumType>;
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage?: InputMaybe<SortEnumType>;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for Quantity (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BpfLotCountsByStageConnection = {
  __typename?: 'BpfLotCountsByStageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotCountsByStageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotCountsByStageEdge = {
  __typename?: 'BpfLotCountsByStageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotCountDocument;
};

/** A connection to a list of items. */
export type BpfLotCountsConnection = {
  __typename?: 'BpfLotCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotCountsEdge = {
  __typename?: 'BpfLotCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotCountDocument;
};

export enum BpfLotStage {
  Grow = 'GROW',
  Material = 'MATERIAL',
  Ready = 'READY',
  Unknown = 'UNKNOWN'
}

export type BpfLotStageOperationFilterInput = {
  eq?: InputMaybe<BpfLotStage>;
  in?: InputMaybe<Array<BpfLotStage>>;
  neq?: InputMaybe<BpfLotStage>;
  nin?: InputMaybe<Array<BpfLotStage>>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocument = {
  __typename?: 'BpfMissionDocument';
  /** When this mission document was first created. */
  created: Scalars['DateTime']['output'];
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate: Scalars['DateTime']['output'];
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate: Scalars['DateTime']['output'];
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status: BpfMissionStatus;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** When this mission document was last written. */
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocumentFilterInput = {
  and?: InputMaybe<Array<BpfMissionDocumentFilterInput>>;
  /** When this mission document was first created. */
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfMissionDocumentFilterInput>>;
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status?: InputMaybe<BpfMissionStatusOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When this mission document was last written. */
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocumentSortInput = {
  /** When this mission document was first created. */
  created?: InputMaybe<SortEnumType>;
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate?: InputMaybe<SortEnumType>;
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** When this mission document was last written. */
  updated?: InputMaybe<SortEnumType>;
};

export enum BpfMissionStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Unknown = 'UNKNOWN'
}

export type BpfMissionStatusOperationFilterInput = {
  eq?: InputMaybe<BpfMissionStatus>;
  in?: InputMaybe<Array<BpfMissionStatus>>;
  neq?: InputMaybe<BpfMissionStatus>;
  nin?: InputMaybe<Array<BpfMissionStatus>>;
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocument = {
  __typename?: 'BpfMissionTaskDocument';
  /** Whether the underlying lot count is active (open for counting). */
  active: Scalars['Boolean']['output'];
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription: Scalars['String']['output'];
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription: Scalars['String']['output'];
  /** When the count was recorded; null until counted. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: Maybe<Scalars['String']['output']>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete: Scalars['Boolean']['output'];
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription: Scalars['String']['output'];
  /** The Nav item / SKU this task's lot concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode: Scalars['String']['output'];
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: Maybe<Scalars['String']['output']>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey: Scalars['String']['output'];
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed: Scalars['Boolean']['output'];
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId: Scalars['String']['output'];
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId: Scalars['String']['output'];
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocumentFilterInput = {
  /** Whether the underlying lot count is active (open for counting). */
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<BpfMissionTaskDocumentFilterInput>>;
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription?: InputMaybe<StringOperationFilterInput>;
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription?: InputMaybe<StringOperationFilterInput>;
  /** When the count was recorded; null until counted. */
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this task's lot concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode?: InputMaybe<StringOperationFilterInput>;
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: InputMaybe<StringOperationFilterInput>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey?: InputMaybe<StringOperationFilterInput>;
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BpfMissionTaskDocumentFilterInput>>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed?: InputMaybe<BooleanOperationFilterInput>;
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocumentSortInput = {
  /** Whether the underlying lot count is active (open for counting). */
  active?: InputMaybe<SortEnumType>;
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription?: InputMaybe<SortEnumType>;
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription?: InputMaybe<SortEnumType>;
  /** When the count was recorded; null until counted. */
  completedAt?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete?: InputMaybe<SortEnumType>;
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this task's lot concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode?: InputMaybe<SortEnumType>;
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: InputMaybe<SortEnumType>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey?: InputMaybe<SortEnumType>;
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: InputMaybe<SortEnumType>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: InputMaybe<SortEnumType>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId?: InputMaybe<SortEnumType>;
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

export type BpfStartingNodeDataInput = {
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
  treeType: BpfTreeType;
};

/** One starting-node grant stored within a BpfUserStartingNodeDocument. */
export type BpfStartingNodeDocument = {
  __typename?: 'BpfStartingNodeDocument';
  siteLocationId: Scalars['String']['output'];
  /** The sub-location entry point, or None to enter at the station (site) root. */
  subLocationId?: Maybe<Scalars['String']['output']>;
  treeType: BpfTreeType;
};

/** One starting-node grant stored within a BpfUserStartingNodeDocument. */
export type BpfStartingNodeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfStartingNodeDocumentFilterInput>>;
  or?: InputMaybe<Array<BpfStartingNodeDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The sub-location entry point, or None to enter at the station (site) root. */
  subLocationId?: InputMaybe<OptionOfStringFilterInput>;
  treeType?: InputMaybe<BpfTreeTypeOperationFilterInput>;
};

/** One starting-node grant in the mutation payload output. */
export type BpfStartingNodeStateData = {
  __typename?: 'BpfStartingNodeStateData';
  siteLocationId: Scalars['String']['output'];
  subLocationId?: Maybe<Scalars['String']['output']>;
  treeType: BpfTreeType;
};

export enum BpfTreeType {
  Finish = 'FINISH',
  Material = 'MATERIAL',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type BpfTreeTypeOperationFilterInput = {
  eq?: InputMaybe<BpfTreeType>;
  in?: InputMaybe<Array<BpfTreeType>>;
  neq?: InputMaybe<BpfTreeType>;
  nin?: InputMaybe<Array<BpfTreeType>>;
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocument = {
  __typename?: 'BpfUserStartingNodeDocument';
  id: Scalars['String']['output'];
  startingNodes: Array<BpfStartingNodeDocument>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfUserStartingNodeDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfUserStartingNodeDocumentFilterInput>>;
  startingNodes?: InputMaybe<ListFilterInputTypeOfBpfStartingNodeDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type BpfUserStartingNodePayload = {
  __typename?: 'BpfUserStartingNodePayload';
  bpfUserStartingNode?: Maybe<BpfUserStartingNodeStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * GraphQL output projection of BpfUserStartingNodeState returned by the
 * set mutation's payload.
 */
export type BpfUserStartingNodeStateData = {
  __typename?: 'BpfUserStartingNodeStateData';
  startingNodes: Array<BpfStartingNodeStateData>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type BpfUserStartingNodesConnection = {
  __typename?: 'BpfUserStartingNodesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfUserStartingNodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfUserStartingNodeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfUserStartingNodesEdge = {
  __typename?: 'BpfUserStartingNodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfUserStartingNodeDocument;
};

export enum BsonDataType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  Decimal128 = 'DECIMAL128',
  Double = 'DOUBLE',
  Guid = 'GUID',
  Int32 = 'INT32',
  Int64 = 'INT64',
  NotSet = 'NOT_SET',
  ObjectId = 'OBJECT_ID',
  String = 'STRING'
}

export type BsonDataTypeOperationFilterInput = {
  eq?: InputMaybe<BsonDataType>;
  in?: InputMaybe<Array<BsonDataType>>;
  neq?: InputMaybe<BsonDataType>;
  nin?: InputMaybe<Array<BsonDataType>>;
};

export type BuildItemInput = {
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

/**
 * Input for the bulkAssignTasks mutation.
 * Assigns a single worker to multiple task assignments in one operation.
 */
export type BulkAssignTasksInput = {
  assignedTo: Scalars['String']['input'];
  taskAssignmentIds: Array<Scalars['String']['input']>;
};

/** GraphQL payload wrapper for bulk task assignment mutation results. */
export type BulkAssignTasksPayload = {
  __typename?: 'BulkAssignTasksPayload';
  errors?: Maybe<Array<ValidationError>>;
  taskAssignments?: Maybe<Array<TaskAssignmentStateData>>;
};

export type BulkCreateMaterialItemInput = {
  materialItems: Array<CreateMaterialItemInput>;
};

export enum CalculationStatus {
  Blocked = 'BLOCKED',
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING'
}

/** Input for cancelAssignment. */
export type CancelAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CancelErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type CancelProductionLotAllocationInput = {
  allocationId: Scalars['String']['input'];
};

export type CancelPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type CancelRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type CancelScheduledLaborRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  laborTypeId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type CancelScheduledOverheadRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type CaptureSignatureDataInput = {
  base64SignatureImage: Scalars['String']['input'];
  dateCaptured: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type CartAddressData = {
  __typename?: 'CartAddressData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export enum CatalogDisplayMode {
  Grid = 'GRID',
  List = 'LIST'
}

/** A connection to a list of items. */
export type CategoriesConnection = {
  __typename?: 'CategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CategoriesEdge = {
  __typename?: 'CategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryDocument;
};

export type CategoryBulkActionPayload = {
  __typename?: 'CategoryBulkActionPayload';
  categories?: Maybe<Array<CategoryPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CategoryData = {
  __typename?: 'CategoryData';
  code: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
};

export type CategoryDataFilterInput = {
  and?: InputMaybe<Array<CategoryDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  eaches?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CategoryDataFilterInput>>;
};

export type CategoryDataInput = {
  code: Scalars['String']['input'];
  eaches: Scalars['Int']['input'];
};

export type CategoryDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  eaches?: InputMaybe<SortEnumType>;
};

export type CategoryDocument = {
  __typename?: 'CategoryDocument';
  category: CategoryData;
  id: Scalars['String']['output'];
  status: CategoryStatus;
  tenantId: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CategoryDocumentFilterInput = {
  and?: InputMaybe<Array<CategoryDocumentFilterInput>>;
  category?: InputMaybe<CategoryDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryDocumentFilterInput>>;
  status?: InputMaybe<CategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type CategoryDocumentSortInput = {
  category?: InputMaybe<CategoryDataSortInput>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type CategoryPayload = {
  __typename?: 'CategoryPayload';
  data?: Maybe<CategoryPayloadData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CategoryPayloadData = {
  __typename?: 'CategoryPayloadData';
  category: CategoryData;
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Per-row failure surfaced by validateCategoryDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type CategoryStagedRowError = {
  __typename?: 'CategoryStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export enum CategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type CategoryStatusOperationFilterInput = {
  eq?: InputMaybe<CategoryStatus>;
  in?: InputMaybe<Array<CategoryStatus>>;
  neq?: InputMaybe<CategoryStatus>;
  nin?: InputMaybe<Array<CategoryStatus>>;
};

export type ChangeProductionCatalogStatusInput = {
  productionCatalogId: Scalars['String']['input'];
  status: ProductionCatalogStatus;
};

export type ChangeVendorPurchaseOrderItemsInput = {
  items: Array<ChangedVendorPurchaseOrderItemInput>;
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type ChangeVendorPurchaseOrderStatusInput = {
  purchaseOrderId: Scalars['String']['input'];
  status: VendorPurchaseOrderStatus;
};

export type ChangeWorkOrderQuantityProducedInput = {
  jobId: Scalars['String']['input'];
  quantityProduced: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
};

export type ChangeWorkOrderStatusInput = {
  jobId: Scalars['String']['input'];
  status: WorkOrderStatus;
  workOrderId: Scalars['String']['input'];
};

export type ChangedVendorPurchaseOrderItemInput = {
  id: Scalars['String']['input'];
  quantityReceived: Scalars['Decimal']['input'];
};

export type CheckpointPayload = {
  __typename?: 'CheckpointPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<CheckpointStateData>;
};

export type CheckpointStateData = {
  __typename?: 'CheckpointStateData';
  checkpointType: CheckpointType;
  externalId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export enum CheckpointType {
  BpfNavInventory = 'BPF_NAV_INVENTORY',
  DtsInventory = 'DTS_INVENTORY',
  UnitsOnHand = 'UNITS_ON_HAND'
}

export type ChildParentRelationship = {
  __typename?: 'ChildParentRelationship';
  child: SiteLocationType;
  validParents: Array<SiteLocationType>;
};

/** GraphQL input for claimPendingErpWriteBacks. */
export type ClaimPendingErpWriteBacksInput = {
  batchSize: Scalars['Int']['input'];
  workflow: ErpWriteBackWorkflow;
};

export type CleanCustomersInput = {
  erpIds: Array<Scalars['String']['input']>;
};

export type CleanItemsInput = {
  erpIds: Array<Scalars['String']['input']>;
};

export type ClearActiveCountSessionInput = {
  productionLineId: Scalars['String']['input'];
};

export type ClearCustomerCommissionOverrideInput = {
  customerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ClearCustomerLocationNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type ClearCustomerNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
};

/** Input for the clear-email-suppression mutation. */
export type ClearEmailSuppressionInput = {
  dropReason?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  listType?: InputMaybe<EmailSuppressionListType>;
};

/** Payload returned from the clear-email-suppression mutation. */
export type ClearEmailSuppressionPayload = {
  __typename?: 'ClearEmailSuppressionPayload';
  cleared: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  errors?: Maybe<Array<ValidationError>>;
  listType?: Maybe<EmailSuppressionListType>;
};

export type ClearInventoryNoteInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  noteId: Scalars['UUID']['input'];
};

export type ClearItemContainerConfigOverrideInput = {
  containerCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  shippingConfigCategoryCode: Scalars['String']['input'];
  siteCode: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type ClearItemLaborCostInput = {
  productionItemId: Scalars['String']['input'];
};

export type ClearItemNoteInput = {
  context: NoteContext;
  itemId: Scalars['String']['input'];
};

export type ClearJobGrowWeeksOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearJobLinksOverrideDataInput = {
  linkId?: InputMaybe<Scalars['String']['input']>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearJobPlannedHoursOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type ClearJobPlantsPerPotOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearOnHandAdjustmentQueueInput = {
  batchSize?: Scalars['Int']['input'];
};

/** Clears one doc-type's routing entry back to the built-in default. */
export type ClearOrderEmailRecipientRoutingInput = {
  docType: OrderEmailRecipientDocType;
};

export type ClearOrderNoteInput = {
  context: NoteContext;
  orderId: Scalars['String']['input'];
};

export type ClearSpaceCategorySiteOverrideInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ClearSpaceDimensionOverrideInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ClearTaskEventDirectCostInput = {
  productionTaskEventId: Scalars['String']['input'];
};

/**
 * Result of clearTenantIntegrationData: the tenant whose Merge read models were cleared, the
 * total documents deleted, the per-collection breakdown, and any error. On a clean re-run the counts
 * are zero and errors is empty — the reset is idempotent.
 */
export type ClearTenantIntegrationDataPayload = {
  __typename?: 'ClearTenantIntegrationDataPayload';
  cleared: Array<ClearedCollection>;
  errors?: Maybe<Array<ValidationError>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalDeleted: Scalars['Long']['output'];
};

/** The number of documents deleted from a single read-model collection during a reset. */
export type ClearedCollection = {
  __typename?: 'ClearedCollection';
  collectionName: Scalars['String']['output'];
  deletedCount: Scalars['Long']['output'];
};

export type ClickUpRoadmapTaskData = {
  __typename?: 'ClickUpRoadmapTaskData';
  addToRoadmap: Scalars['Boolean']['output'];
  dateUpdated: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicScore: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ClickUpTaskData = {
  __typename?: 'ClickUpTaskData';
  assigneeEmails: Array<Scalars['String']['output']>;
  dateUpdated: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  logHoursEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CloseSessionInput = {
  comment: Scalars['String']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CombinedOrderDocument = {
  __typename?: 'CombinedOrderDocument';
  /**
   * Total of every payment and deposit applied to the order, taken from the order's amount-paid rollup.
   * Null until the first payment is applied, and always null for master orders; consumers treat null as
   * zero.
   */
  amountPaid?: Maybe<MoneyData>;
  /**
   * Outstanding balance (order total less amount paid), taken from the order's balance rollup. Null until
   * the first payment is applied, and always null for master orders.
   */
  balance?: Maybe<MoneyData>;
  billingAddress: AddressData;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: Maybe<Scalars['String']['output']>;
  erpId?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  finalCredit?: Maybe<Scalars['Boolean']['output']>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: Maybe<MoneyData>;
  /** The freight charge type applied to the order. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  generalNotes?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: Maybe<Scalars['Boolean']['output']>;
  initializedDate?: Maybe<Scalars['DateTime']['output']>;
  locations: OrderLocationDocumentData;
  numberOfLines: Scalars['Int']['output'];
  orderEntityId: Scalars['String']['output'];
  orderEntityNumber: Scalars['String']['output'];
  orderEntityType: OrderEntityType;
  orderTotal: MoneyData;
  orderType: OrderType;
  /**
   * The order's payment standing, taken from the order's own payment-status rollup (derived on the order
   * when a payment is applied, never recomputed here). Master orders have no payment ledger, so they are
   * always Unpaid.
   */
  paymentStatus: PaymentStatus;
  poNumber: Scalars['String']['output'];
  produceAllocate?: Maybe<Scalars['Boolean']['output']>;
  pullNotes?: Maybe<Scalars['String']['output']>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: Maybe<Scalars['String']['output']>;
  salesPerson?: Maybe<Scalars['String']['output']>;
  scheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName: Scalars['String']['output'];
  shipNotes?: Maybe<Scalars['String']['output']>;
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  status: OrderStatus;
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  termsTermLimitDays?: Maybe<Scalars['Int']['output']>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type CombinedOrderDocumentFilterInput = {
  /**
   * Total of every payment and deposit applied to the order, taken from the order's amount-paid rollup.
   * Null until the first payment is applied, and always null for master orders; consumers treat null as
   * zero.
   */
  amountPaid?: InputMaybe<OptionOfMoneyDataFilterInput>;
  and?: InputMaybe<Array<CombinedOrderDocumentFilterInput>>;
  /**
   * Outstanding balance (order total less amount paid), taken from the order's balance rollup. Null until
   * the first payment is applied, and always null for master orders.
   */
  balance?: InputMaybe<OptionOfMoneyDataFilterInput>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  finalCredit?: InputMaybe<BooleanOperationFilterInput>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: InputMaybe<MoneyDataFilterInput>;
  /** The freight charge type applied to the order. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: InputMaybe<BooleanOperationFilterInput>;
  initializedDate?: InputMaybe<DateTimeOperationFilterInput>;
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CombinedOrderDocumentFilterInput>>;
  orderEntityId?: InputMaybe<StringOperationFilterInput>;
  orderEntityNumber?: InputMaybe<StringOperationFilterInput>;
  orderEntityType?: InputMaybe<OrderEntityTypeOperationFilterInput>;
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  /**
   * The order's payment standing, taken from the order's own payment-status rollup (derived on the order
   * when a payment is applied, never recomputed here). Master orders have no payment ledger, so they are
   * always Unpaid.
   */
  paymentStatus?: InputMaybe<PaymentStatusOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  produceAllocate?: InputMaybe<BooleanOperationFilterInput>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  scheduledOrdersCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName?: InputMaybe<StringOperationFilterInput>;
  shippedDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
  termsTermLimitDays?: InputMaybe<IntOperationFilterInput>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: InputMaybe<IntOperationFilterInput>;
};

export type CombinedOrderDocumentSortInput = {
  /**
   * Total of every payment and deposit applied to the order, taken from the order's amount-paid rollup.
   * Null until the first payment is applied, and always null for master orders; consumers treat null as
   * zero.
   */
  amountPaid?: InputMaybe<SortEnumType>;
  /**
   * Outstanding balance (order total less amount paid), taken from the order's balance rollup. Null until
   * the first payment is applied, and always null for master orders.
   */
  balance?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressDataSortInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  finalCredit?: InputMaybe<SortEnumType>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: InputMaybe<MoneyDataSortInput>;
  /** The freight charge type applied to the order. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: InputMaybe<SortEnumType>;
  initializedDate?: InputMaybe<SortEnumType>;
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  numberOfLines?: InputMaybe<SortEnumType>;
  orderEntityId?: InputMaybe<SortEnumType>;
  orderEntityNumber?: InputMaybe<SortEnumType>;
  orderEntityType?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  /**
   * The order's payment standing, taken from the order's own payment-status rollup (derived on the order
   * when a payment is applied, never recomputed here). Master orders have no payment ledger, so they are
   * always Unpaid.
   */
  paymentStatus?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  produceAllocate?: InputMaybe<SortEnumType>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  scheduledOrdersCount?: InputMaybe<SortEnumType>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName?: InputMaybe<SortEnumType>;
  shippedDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  syncDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
  termsTermLimitDays?: InputMaybe<SortEnumType>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CombinedOrdersConnection = {
  __typename?: 'CombinedOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CombinedOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CombinedOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CombinedOrdersEdge = {
  __typename?: 'CombinedOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CombinedOrderDocument;
};

export type CommandBarDocument = {
  __typename?: 'CommandBarDocument';
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  optionName: Scalars['String']['output'];
  optionValue: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type CommandBarDocumentFilterInput = {
  aggregateId?: InputMaybe<StringOperationFilterInput>;
  aggregateType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CommandBarDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  optionName?: InputMaybe<StringOperationFilterInput>;
  optionValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommandBarDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type CommandBarDocumentSortInput = {
  aggregateId?: InputMaybe<SortEnumType>;
  aggregateType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  optionName?: InputMaybe<SortEnumType>;
  optionValue?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CommandBarOptionsConnection = {
  __typename?: 'CommandBarOptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommandBarOptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CommandBarDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommandBarOptionsEdge = {
  __typename?: 'CommandBarOptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommandBarDocument;
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocument = {
  __typename?: 'CommissionConfigDocument';
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerOverrides: Array<CustomerCommissionOverrideData>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocumentFilterInput = {
  and?: InputMaybe<Array<CommissionConfigDocumentFilterInput>>;
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerOverrides?: InputMaybe<ListFilterInputTypeOfCustomerCommissionOverrideDataFilterInput>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CommissionConfigDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocumentSortInput = {
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type CommissionConfigPayload = {
  __typename?: 'CommissionConfigPayload';
  commissionConfig?: Maybe<CommissionConfigDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type CommissionConfigsConnection = {
  __typename?: 'CommissionConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommissionConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CommissionConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommissionConfigsEdge = {
  __typename?: 'CommissionConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommissionConfigDocument;
};

export type CommitSpaceRebalanceInput = {
  moves: Array<CommitSpaceRebalanceMoveInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CommitSpaceRebalanceMoveInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toWeekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
  toWeekStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommitSpaceRebalancePayload = {
  __typename?: 'CommitSpaceRebalancePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

/** Input for completeAssignmentTask; records the worker's counted quantity. */
export type CompleteAssignmentTaskInput = {
  assignmentId: Scalars['String']['input'];
  binLocationId: Scalars['String']['input'];
  completedQty: Scalars['Decimal']['input'];
  idempotentKey: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  varianceReasonCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

/**
 * Input for completeM365MailboxConnect. The state is the signed value returned by
 * m365MailboxAuthorizeUrl and is required — it binds the callback to the user who started the
 * connect. The redirectUri is optional and falls back to the configured default redirect URI when
 * omitted. Never carries tenant or user id (those come from the JWT).
 */
export type CompleteM365MailboxConnectInput = {
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CompleteMergeLinkInput = {
  publicToken: Scalars['String']['input'];
  setup?: InputMaybe<MergeConnectSetupInput>;
};

export type CompleteTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type CompleteTenantEmailSenderVerificationInput = {
  senderId: Scalars['String']['input'];
  verificationLink: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ConfigCategoriesConnection = {
  __typename?: 'ConfigCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConfigCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConfigCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConfigCategoriesEdge = {
  __typename?: 'ConfigCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigCategoryDocument;
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocument = {
  __typename?: 'ConfigCategoryDocument';
  code: Scalars['String']['output'];
  configCategoryId: Scalars['String']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  defaultSizeUomCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sizeUomCodes: Array<Scalars['String']['output']>;
  status: ConfigCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ConfigCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  configCategoryId?: InputMaybe<StringOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  defaultSizeUomCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConfigCategoryDocumentFilterInput>>;
  sizeUomCodes?: InputMaybe<ListStringOperationFilterInput>;
  status?: InputMaybe<ConfigCategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  configCategoryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  defaultSizeUomCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for config category mutations. */
export type ConfigCategoryPayload = {
  __typename?: 'ConfigCategoryPayload';
  configCategory?: Maybe<ConfigCategoryStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ConfigCategoryStateData = {
  __typename?: 'ConfigCategoryStateData';
  code: Scalars['String']['output'];
  configCategoryId: Scalars['String']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  defaultSizeUomCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sizeUomCodes: Array<Scalars['String']['output']>;
  status: ConfigCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ConfigCategoryStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ConfigCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ConfigCategoryStatus>;
  in?: InputMaybe<Array<ConfigCategoryStatus>>;
  neq?: InputMaybe<ConfigCategoryStatus>;
  nin?: InputMaybe<Array<ConfigCategoryStatus>>;
};

export type ConfirmAllocationInput = {
  allocationId: Scalars['String']['input'];
  confirmedQty: Scalars['Decimal']['input'];
};

export type ConfirmReceiptInput = {
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type ConfirmationEmailData = {
  __typename?: 'ConfirmationEmailData';
  sent: Scalars['DateTime']['output'];
  toEmail: Scalars['String']['output'];
};

export type ConfirmationEmailDataFilterInput = {
  and?: InputMaybe<Array<ConfirmationEmailDataFilterInput>>;
  or?: InputMaybe<Array<ConfirmationEmailDataFilterInput>>;
  sent?: InputMaybe<DateTimeOperationFilterInput>;
  toEmail?: InputMaybe<StringOperationFilterInput>;
};

export type ConfirmationEmailDataSortInput = {
  sent?: InputMaybe<SortEnumType>;
  toEmail?: InputMaybe<SortEnumType>;
};

/** Input for connectOrderEaseIntegration — the supplier-scoped credential pair. */
export type ConnectOrderEaseIntegrationInput = {
  clientKey: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export enum ConsolidationCustomerGrouping {
  Combine = 'COMBINE',
  KeepSeparate = 'KEEP_SEPARATE'
}

export enum ConsolidationDirection {
  BackwardOnly = 'BACKWARD_ONLY',
  Both = 'BOTH',
  ForwardOnly = 'FORWARD_ONLY'
}

export enum ConsolidationLocationGrouping {
  Combine = 'COMBINE',
  KeepSeparate = 'KEEP_SEPARATE'
}

/**
 * A single pivot cell — the rolled-up demand for one (row, week) intersection.
 * TotalQty is post-rounding (per the rule set's RoundingUnit). The raw,
 * un-rounded sum is preserved in RawTotalQty for client-side display.
 */
export type ConsolidationPreviewCellData = {
  __typename?: 'ConsolidationPreviewCellData';
  demandEstimated: Scalars['Boolean']['output'];
  efficiencyFlag: ConsolidationPreviewEfficiencyFlag;
  jobCount: Scalars['Int']['output'];
  rawTotalQty: Scalars['Int']['output'];
  sourceJobIds: Array<Scalars['String']['output']>;
  totalQty: Scalars['Int']['output'];
  weekStart: Scalars['DateTime']['output'];
};

/**
 * GraphQL output for the consolidationPreview query. Weeks lists the
 * pivot's column headers in chronological order; Rows contains one row per
 * rollup grouping (granularity controlled by the request's
 * ConsolidationPreviewRollupLevel).
 */
export type ConsolidationPreviewData = {
  __typename?: 'ConsolidationPreviewData';
  rows: Array<ConsolidationPreviewRowData>;
  ruleContext: ConsolidationPreviewRuleSetContextData;
  weeks: Array<Scalars['DateTime']['output']>;
};

/**
 * Indicates how a cell's TotalQty compares to the rule set's
 * MinimumLotQuantity. Empty cells (TotalQty == 0) are treated as
 * BelowMin when the minimum is positive, and AtMin
 * when the minimum is zero.
 */
export enum ConsolidationPreviewEfficiencyFlag {
  AboveMin = 'ABOVE_MIN',
  AtMin = 'AT_MIN',
  BelowMin = 'BELOW_MIN'
}

/**
 * Raw GraphQL input for ValidGetConsolidationPreview. StartWeek
 * and EndWeek are treated as UTC instants; the query aligns each job's
 * DeliveryDate into its ISO-week start (Monday 00:00 UTC) before pivoting.
 */
export type ConsolidationPreviewInput = {
  endWeek: Scalars['DateTime']['input'];
  productionCatalogIds: Array<Scalars['String']['input']>;
  rollupLevel: ConsolidationPreviewRollupLevel;
  startWeek: Scalars['DateTime']['input'];
};

/**
 * Payload-style envelope for consolidationPreview. Read-side queries in
 * this slice surface validation/lookup failures via the same payload contract
 * mutations use (Atlas discipline cd1f708d) rather than throwing, so the client
 * can render an error message inline with the pivot UI.
 */
export type ConsolidationPreviewPayload = {
  __typename?: 'ConsolidationPreviewPayload';
  consolidationPreview?: Maybe<ConsolidationPreviewData>;
  errors?: Maybe<Array<ValidationError>>;
  /**
   * True when the preview was produced without validation/lookup errors. Computed from the
   * payload contents (mirrors the sibling convention, e.g. CycleCountPayload) so clients
   * can branch on success without inspecting the errors array.
   */
  success: Scalars['Boolean']['output'];
};

/**
 * Granularity of the rows in the consolidation preview pivot. Cell emits one
 * row per production catalog, Genus collapses by genus across catalogs, and
 * Category emits one rolled-up row across all requested catalogs.
 */
export enum ConsolidationPreviewRollupLevel {
  Category = 'CATEGORY',
  Cell = 'CELL',
  Genus = 'GENUS'
}

/**
 * A pivot row. ProductionCatalogId is populated only for
 * Cell rows; GenusCode for
 * Genus rows; both are
 * Option`1.None on Category
 * rollups. Cells aligns positionally with Weeks.
 */
export type ConsolidationPreviewRowData = {
  __typename?: 'ConsolidationPreviewRowData';
  categoryGroup?: Maybe<Scalars['String']['output']>;
  cells: Array<ConsolidationPreviewCellData>;
  genusCode?: Maybe<Scalars['String']['output']>;
  level: ConsolidationPreviewRollupLevel;
  productionCatalogId?: Maybe<Scalars['String']['output']>;
};

/**
 * Snapshot of the consolidation rules applied to this preview. Surfaces the values
 * the server actually used so the client can show the same context to operators
 * without re-reading the rule set.
 */
export type ConsolidationPreviewRuleSetContextData = {
  __typename?: 'ConsolidationPreviewRuleSetContextData';
  fromTenantOverride: Scalars['Boolean']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
};

/**
 * MongoDB read-model document for a tenant's consolidation rule set. There is exactly
 * one document per tenant; Id equals TenantId today, but
 * use GetDocumentId for all reads/writes so that invariant can evolve
 * without breaking call sites.
 */
export type ConsolidationRuleSetDocument = {
  __typename?: 'ConsolidationRuleSetDocument';
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['output'];
  lookForwardWeeks: Scalars['Int']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ConsolidationRuleSetPayload = {
  __typename?: 'ConsolidationRuleSetPayload';
  consolidationRuleSet?: Maybe<ConsolidationRuleSetStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ConsolidationRuleSetStateData = {
  __typename?: 'ConsolidationRuleSetStateData';
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['output'];
  lookForwardWeeks: Scalars['Int']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ConsumeProductionJobMaterialDataInput = {
  locationId: Scalars['String']['input'];
  lotCode?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  quantityConsumed: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ConsumeProductionJobMaterialsEntryInput = {
  consumedMaterials: Array<ConsumeProductionJobMaterialDataInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type ConsumeProductionJobMaterialsResult = {
  __typename?: 'ConsumeProductionJobMaterialsResult';
  errors?: Maybe<Array<ValidationError>>;
  productionJobId: Scalars['String']['output'];
  productionLot?: Maybe<ProductionLotStateData>;
};

export type ConsumeProductionJobsMaterialsInput = {
  jobs: Array<ConsumeProductionJobMaterialsEntryInput>;
};

export type ConsumeProductionJobsMaterialsPayload = {
  __typename?: 'ConsumeProductionJobsMaterialsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ConsumeProductionJobMaterialsResult>;
};

export type ConsumedMaterialDataInput = {
  locationId: Scalars['String']['input'];
  lotCode: Scalars['String']['input'];
  materialAllocationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantityConsumed: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ContactData = {
  __typename?: 'ContactData';
  emailAddresses: Array<EmailAddressData>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  importId: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumbers: Array<PhoneNumberData>;
  status: ContactStatus;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type ContactDataInput = {
  emailAddresses: Array<EmailAddressDataInput>;
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  importId?: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumbers: Array<PhoneNumberDataInput>;
  status?: ContactStatus;
  title: Scalars['String']['input'];
  type: ContactType;
};

export enum ContactStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum ContactType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Sales = 'SALES',
  Support = 'SUPPORT',
  Unknown = 'UNKNOWN'
}

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocument = {
  __typename?: 'ContainerConfigDocument';
  categoryCode: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  maxLayersPerContainer: Scalars['Int']['output'];
  maxTraysPerLayer: Scalars['Int']['output'];
  parentContainerConfigId?: Maybe<Scalars['String']['output']>;
  shipFactor: Scalars['Int']['output'];
  shipMinimum: Scalars['Int']['output'];
  siteCodes: Array<Scalars['String']['output']>;
  sizeUomCode: Scalars['String']['output'];
  status: ContainerConfigStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocumentFilterInput = {
  and?: InputMaybe<Array<ContainerConfigDocumentFilterInput>>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  containerConfigId?: InputMaybe<StringOperationFilterInput>;
  containerName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  depth?: InputMaybe<DecimalOperationFilterInput>;
  height?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxLayersPerContainer?: InputMaybe<IntOperationFilterInput>;
  maxTraysPerLayer?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContainerConfigDocumentFilterInput>>;
  parentContainerConfigId?: InputMaybe<OptionOfStringFilterInput>;
  shipFactor?: InputMaybe<IntOperationFilterInput>;
  shipMinimum?: InputMaybe<IntOperationFilterInput>;
  siteCodes?: InputMaybe<ListStringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ContainerConfigStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
};

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocumentSortInput = {
  categoryCode?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  containerConfigId?: InputMaybe<SortEnumType>;
  containerName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  depth?: InputMaybe<SortEnumType>;
  height?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxLayersPerContainer?: InputMaybe<SortEnumType>;
  maxTraysPerLayer?: InputMaybe<SortEnumType>;
  parentContainerConfigId?: InputMaybe<SortEnumType>;
  shipFactor?: InputMaybe<SortEnumType>;
  shipMinimum?: InputMaybe<SortEnumType>;
  sizeUomCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
};

export type ContainerConfigPayload = {
  __typename?: 'ContainerConfigPayload';
  containerConfig?: Maybe<ContainerConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ContainerConfigStateData = {
  __typename?: 'ContainerConfigStateData';
  categoryCode: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  maxLayersPerContainer: Scalars['Int']['output'];
  maxTraysPerLayer: Scalars['Int']['output'];
  parentContainerConfigId?: Maybe<Scalars['String']['output']>;
  shipFactor: Scalars['Int']['output'];
  shipMinimum: Scalars['Int']['output'];
  siteCodes: Array<Scalars['String']['output']>;
  sizeUomCode: Scalars['String']['output'];
  status: ContainerConfigStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

export enum ContainerConfigStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ContainerConfigStatusOperationFilterInput = {
  eq?: InputMaybe<ContainerConfigStatus>;
  in?: InputMaybe<Array<ContainerConfigStatus>>;
  neq?: InputMaybe<ContainerConfigStatus>;
  nin?: InputMaybe<Array<ContainerConfigStatus>>;
};

/**
 * Aggregated view of a Container backing the Maintenance → Containers tab.
 * Distinct rows per ContainerCode, projected from the ContainerConfig
 * documents that share the same code. Per the 2026-04-09 Items Review,
 * container metadata (name, dimensions) lives on ContainerConfig itself
 * rather than a separate Container aggregate; this query is the read-only
 * distinct view that surfaces in the Containers tab.
 */
export type ContainerRow = {
  __typename?: 'ContainerRow';
  containerCode: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  status: ContainerConfigStatus;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Decimal']['output'];
};

export type CorrectOrderInput = {
  creditOrderId?: InputMaybe<Scalars['String']['input']>;
  newCustomerId: Scalars['String']['input'];
  newOrderId?: InputMaybe<Scalars['String']['input']>;
  sourceOrderId: Scalars['String']['input'];
};

/**
 * Payload for the internal wrong-customer correction mutation. Order is the
 * replacement order created for the new customer; CreditOrder is the credit
 * created for the original customer. Both are created atomically — on failure both are null
 * and Errors is populated.
 */
export type CorrectOrderPayload = {
  __typename?: 'CorrectOrderPayload';
  creditOrder?: Maybe<OrderStateData>;
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
};

/**
 * A single step in the cost calculation audit trail, recording what happened at each
 * decision point during cost resolution. Includes a severity-coded message and
 * expandable key-value context for downstream display (e.g., WorkSuite AI explanations).
 */
export type CostCalcStep = {
  __typename?: 'CostCalcStep';
  code: Scalars['String']['output'];
  context: Array<CostCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: CostCalcStepSeverity;
};

/**
 * A key-value pair providing additional context for a CostCalcStep.
 * Rendered as expandable detail in the calculation steps modal (e.g., "UnitCost": "$0.12").
 */
export type CostCalcStepContextEntry = {
  __typename?: 'CostCalcStepContextEntry';
  /** Optional entity ID for navigation. Paired with EntityType to build the route. */
  entityId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional entity type hint for navigation (e.g., "ProductionCategory", "SiteLocation").
   * When set, the frontend can render the value as a clickable link.
   */
  entityType?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Severity level for a cost calculation audit step.
 * Used to derive the overall status of a cost resolution result
 * (Error > Warning > Info).
 */
export enum CostCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum CostCategory {
  Labor = 'LABOR',
  Material = 'MATERIAL',
  Overhead = 'OVERHEAD'
}

/**
 * One row of a job's cost breakdown grouped by subcategory, summarizing quantity, cost, and
 * (for labor) headcount for the cost records that share that subcategory.
 */
export type CostCategoryBreakdown = {
  __typename?: 'CostCategoryBreakdown';
  /** Combined headcount for the subcategory, or null when no record carries one. */
  headcount?: Maybe<Scalars['Int']['output']>;
  /** Number of cost records aggregated into this row. */
  recordCount: Scalars['Int']['output'];
  /** The subcategory these records were grouped under, or null when unspecified. */
  subcategory?: Maybe<Scalars['String']['output']>;
  /** Total cost of the records in this subcategory. */
  totalCost: Scalars['Decimal']['output'];
  /** Total quantity across the records in this subcategory. */
  totalQuantity: Scalars['Decimal']['output'];
  /** Unit of measure for the quantity, taken from the first record that specifies one. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Cost per unit (total cost divided by total quantity), or null when quantity is zero. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * An individual cost line item within a cost category (material, labor, or overhead).
 * Provides a human-readable name for display and a source entity ID for navigation.
 */
export type CostEventResult = {
  __typename?: 'CostEventResult';
  /** Optional additional context describing how the cost was derived. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Human-readable name (e.g., material item name, labor type name, location name). */
  name: Scalars['String']['output'];
  /** Cost per unit for this line item. */
  perUnitCost: Scalars['Decimal']['output'];
  /** The source entity ID, enabling frontend navigation to the originating record. */
  sourceId: Scalars['String']['output'];
  /**
   * The type of entity that SourceId refers to (e.g., "SiteLocation", "MaterialItem",
   * "ProductionCategory", "ProductionTaskEvent"). Enables the frontend to build the correct navigation route
   * without hardcoding source-type inference per cost category.
   */
  sourceType: Scalars['String']['output'];
};

export enum CostSourceType {
  CountC = 'COUNT_C',
  EventsTimeEntry = 'EVENTS_TIME_ENTRY',
  InventoryDrawDown = 'INVENTORY_DRAW_DOWN',
  Manual = 'MANUAL',
  OverheadAllocation = 'OVERHEAD_ALLOCATION',
  PurchaseOrder = 'PURCHASE_ORDER'
}

/**
 * One week of a job's cost timeline, carrying the labor, material, and overhead spend recorded
 * in that UTC week so cost can be charted over the production window.
 */
export type CostTimelineEntry = {
  __typename?: 'CostTimelineEntry';
  /** Labor cost recorded during the week. */
  laborCost: Scalars['Decimal']['output'];
  /** Material cost recorded during the week. */
  materialCost: Scalars['Decimal']['output'];
  /** Overhead cost recorded during the week. */
  overheadCost: Scalars['Decimal']['output'];
  /** Human-readable label for the week, formatted as the week-start date (yyyy-MM-dd). */
  weekLabel: Scalars['String']['output'];
  /** UTC start (Monday) of the week this entry covers. */
  weekStart: Scalars['DateTime']['output'];
};

export type CountDataInput = {
  comment: Scalars['String']['input'];
  grade?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
};

export type CountMaterialItemInput = {
  countType: MaterialItemCountType;
  countedByUserEmail: Scalars['String']['input'];
  countedRecorded: Scalars['DateTime']['input'];
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantityCounted: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type CountProductionLinesConnection = {
  __typename?: 'CountProductionLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountProductionLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLineDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountProductionLinesEdge = {
  __typename?: 'CountProductionLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLineDocument;
};

export type CountReasonData = {
  __typename?: 'CountReasonData';
  code: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocument = {
  __typename?: 'CountRegistrationDocument';
  countSessionId: Scalars['String']['output'];
  countedQtyAfter: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  paceUnitsPerMinute: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  registeredBy: Scalars['String']['output'];
  remainingQty: Scalars['Decimal']['output'];
  sequenceNumber: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocumentFilterInput = {
  and?: InputMaybe<Array<CountRegistrationDocumentFilterInput>>;
  countSessionId?: InputMaybe<StringOperationFilterInput>;
  countedQtyAfter?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CountRegistrationDocumentFilterInput>>;
  paceUnitsPerMinute?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  registeredBy?: InputMaybe<StringOperationFilterInput>;
  remainingQty?: InputMaybe<DecimalOperationFilterInput>;
  sequenceNumber?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocumentSortInput = {
  countSessionId?: InputMaybe<SortEnumType>;
  countedQtyAfter?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  occurredAt?: InputMaybe<SortEnumType>;
  paceUnitsPerMinute?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  registeredBy?: InputMaybe<SortEnumType>;
  remainingQty?: InputMaybe<SortEnumType>;
  sequenceNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CountRegistrationsConnection = {
  __typename?: 'CountRegistrationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountRegistrationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CountRegistrationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountRegistrationsEdge = {
  __typename?: 'CountRegistrationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountRegistrationDocument;
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocument = {
  __typename?: 'CountSessionDocument';
  countedQty: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  crewSize: Scalars['Int']['output'];
  estimatedMinutesRemaining?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  lastTickAt?: Maybe<Scalars['DateTime']['output']>;
  paceUnitsPerMinute: Scalars['Decimal']['output'];
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId: Scalars['String']['output'];
  productionCategoryName?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLineId: Scalars['String']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
  remainingQty: Scalars['Decimal']['output'];
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  status: CountSessionStatus;
  targetQty: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocumentFilterInput = {
  and?: InputMaybe<Array<CountSessionDocumentFilterInput>>;
  countedQty?: InputMaybe<DecimalOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  crewSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  lastTickAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CountSessionDocumentFilterInput>>;
  paceUnitsPerMinute?: InputMaybe<DecimalOperationFilterInput>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryName?: InputMaybe<StringOperationFilterInput>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLineId?: InputMaybe<StringOperationFilterInput>;
  recipeName?: InputMaybe<StringOperationFilterInput>;
  remainingQty?: InputMaybe<DecimalOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startedBy?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CountSessionStatusOperationFilterInput>;
  targetQty?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocumentSortInput = {
  countedQty?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crewSize?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  lastTickAt?: InputMaybe<SortEnumType>;
  paceUnitsPerMinute?: InputMaybe<SortEnumType>;
  plantsPerPot?: InputMaybe<SortEnumType>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionCategoryName?: InputMaybe<SortEnumType>;
  productionJobId?: InputMaybe<SortEnumType>;
  productionLineId?: InputMaybe<SortEnumType>;
  recipeName?: InputMaybe<SortEnumType>;
  remainingQty?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  targetQty?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type CountSessionPayload = {
  __typename?: 'CountSessionPayload';
  countSession?: Maybe<CountSessionStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CountSessionStateData = {
  __typename?: 'CountSessionStateData';
  countSessionId: Scalars['String']['output'];
  countedQty: Scalars['Decimal']['output'];
  crewSize: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  lastSequenceNumber: Scalars['Int']['output'];
  lastTickAt?: Maybe<Scalars['DateTime']['output']>;
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  productionCategoryId: Scalars['String']['output'];
  productionCategoryName?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLineId: Scalars['String']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  status: CountSessionStatus;
  targetQty: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
};

export enum CountSessionStatus {
  Completed = 'COMPLETED',
  Paused = 'PAUSED',
  Running = 'RUNNING'
}

export type CountSessionStatusOperationFilterInput = {
  eq?: InputMaybe<CountSessionStatus>;
  in?: InputMaybe<Array<CountSessionStatus>>;
  neq?: InputMaybe<CountSessionStatus>;
  nin?: InputMaybe<Array<CountSessionStatus>>;
};

/** A connection to a list of items. */
export type CountSessionsConnection = {
  __typename?: 'CountSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CountSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountSessionsEdge = {
  __typename?: 'CountSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountSessionDocument;
};

export type CreateAdHocVendorPurchaseOrderInput = {
  id: Scalars['String']['input'];
  isUrgent?: Scalars['Boolean']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
};

export type CreateAddress = {
  __typename?: 'CreateAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type CreateAddressFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CreateAddressFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CreateAddressFilterInput>>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type CreateAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  stateProvince: Scalars['String']['input'];
  toName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateAddressSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type CreateAllocationLineItemInput = {
  allocatedQuantity: Scalars['Decimal']['input'];
  orderLineItemId: Scalars['String']['input'];
  purchaseOrderLineItemId: Scalars['String']['input'];
};

export type CreateAllocationTemplateInput = {
  allocationType: AllocationType;
  equalizeWeeksOfSupply: Scalars['Boolean']['input'];
  favorHigherWeight: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  mode: AllocationMode;
  name: Scalars['String']['input'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One material item to count, supplied by the supervisor when creating an
 * assignment. The (item, bin) fan-out is computed server-side by joining the
 * MaterialItemLocationQuantity read model — clients only nominate items.
 */
export type CreateAssignmentItemInput = {
  materialItemId: Scalars['String']['input'];
  overrideQty?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCartInput = {
  billToAddressCity: Scalars['String']['input'];
  billToAddressCountry: Scalars['String']['input'];
  billToAddressId: Scalars['String']['input'];
  billToAddressLine1: Scalars['String']['input'];
  billToAddressLine2: Scalars['String']['input'];
  billToAddressStateProvince: Scalars['String']['input'];
  billToAddressToName: Scalars['String']['input'];
  billToAddressZipcode: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expectedDeliveryDate: Scalars['DateTime']['input'];
  shipToAddressCity: Scalars['String']['input'];
  shipToAddressCountry: Scalars['String']['input'];
  shipToAddressId: Scalars['String']['input'];
  shipToAddressLine1: Scalars['String']['input'];
  shipToAddressLine2: Scalars['String']['input'];
  shipToAddressStateProvince: Scalars['String']['input'];
  shipToAddressToName: Scalars['String']['input'];
  shipToAddressZipcode: Scalars['String']['input'];
  shopperEmail: Scalars['String']['input'];
  shopperFirstName: Scalars['String']['input'];
  shopperId: Scalars['String']['input'];
  shopperLastName: Scalars['String']['input'];
  shopperPhone: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CreateCommissionConfigInput = {
  defaultRatePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

/**
 * Input for createCountAssignment. IdempotentKey is a client-supplied
 * retry-correlation token validated as ValidIdStrict (32-char dashless GUID)
 * at the mutation boundary so clients can use Guid.NewGuid().ToString("N").
 * Dedup is the aggregate's job — StartWithNewEntity rejects duplicate creates
 * on AssignmentId.
 */
export type CreateCountAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  dueBy: Scalars['DateTime']['input'];
  idempotentKey: Scalars['String']['input'];
  items: Array<CreateAssignmentItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  workerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerLocationInput = {
  adGroup: Scalars['String']['input'];
  address: CreateAddressInput;
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  globalLocationNumber: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  locationLookupCode?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  name: Scalars['String']['input'];
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPeople: Array<SalesPersonDataInput>;
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CreateCustomerLocationSettingsInput>;
  storeNumber: Scalars['String']['input'];
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerLocationSettingsInput = {
  notes?: InputMaybe<Array<CreateNoteDataInput>>;
  retailerName: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingNotes?: InputMaybe<Scalars['String']['input']>;
  storeClass: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type CreateErpLoadListSessionInput = {
  containerCode: Scalars['String']['input'];
  routes: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
};

export type CreateFavoritesListInput = {
  createdBy: Scalars['String']['input'];
  description: Scalars['String']['input'];
  favoritesListId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateForecastInput = {
  customerId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  forecastId: Scalars['String']['input'];
  level: ForecastLevel;
  name: Scalars['String']['input'];
  programIds: Array<Scalars['String']['input']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['input'];
  weeklyMetric: ForecastWeeklyMetric;
};

export type CreateInventoryItemCommandInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  itemType: ItemType;
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  readyDate?: InputMaybe<Scalars['LocalDate']['input']>;
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

/**
 * Input for createInvoiceEmailDraft. Carries only the order id; the tenant and user come from
 * the caller's JWT (the draft is created in the caller's own mailbox for the caller's own tenant).
 */
export type CreateInvoiceEmailDraftInput = {
  orderId: Scalars['String']['input'];
};

/**
 * Result of createInvoiceEmailDraft: the created draft's Outlook webLink (so the pwa can
 * deep-link into Outlook) and its Graph draft id on success, or the coded validation error(s) that
 * stopped it. WebLink/DraftId are null on failure.
 */
export type CreateInvoiceEmailDraftPayload = {
  __typename?: 'CreateInvoiceEmailDraftPayload';
  draftId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  webLink?: Maybe<Scalars['String']['output']>;
};

export type CreateJobInput = {
  containerQuantity: Scalars['Int']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemErpId?: Scalars['String']['input'];
  itemGenusCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemRecordId: Scalars['String']['input'];
  itemUPC: Scalars['String']['input'];
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

export type CreateKitInput = {
  containerCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  kitId: Scalars['String']['input'];
  lines: Array<KitLineDataInput>;
  name: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type CreateLocationInput = {
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  locationType: LocationType;
  name: Scalars['String']['input'];
  parentLocationId: Scalars['String']['input'];
  siteParentId?: Scalars['String']['input'];
};

export type CreateMakeToOrderPlanInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CreateMaterialItemInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isOrganic?: Scalars['Boolean']['input'];
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sellable?: Scalars['Boolean']['input'];
};

/**
 * Input record for createMovementOrder. IdempotentKey is a client-supplied
 * retry-correlation token validated as ValidIdStrict (32-char dashless GUID) so
 * clients can use Guid.NewGuid().ToString("N"). Dedup is the aggregate's job:
 * StartWithNewEntity rejects duplicate creates on MovementOrderId.
 */
export type CreateMovementOrderInput = {
  fromSiteLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lines: Array<MovementOrderLineInput>;
  movementOrderId: Scalars['String']['input'];
  toSiteLocationId: Scalars['String']['input'];
};

export type CreateNoteDataInput = {
  id: Scalars['String']['input'];
  noteText: Scalars['String']['input'];
};

/**
 * Admin input for provisioning a customer-portal (Buyer) user through the unified path: one
 * WorkSuiteUser (carrying Portal + the customer scope) and a
 * linked portal-scoped UserInvite so the wsapi-services worker creates the FusionAuth login
 * with the wsCustomerId/wsUserType=customer claims and sends the set-password email.
 * Single-use Data type per the read-model/command type-isolation convention.
 */
export type CreatePortalUserDataInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiresInDays: Scalars['Int']['input'];
  fullName: Scalars['String']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
};

export type CreatePortalUserInput = {
  createdBy: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userType: UserType;
};

export type CreateProductionCatalogInput = {
  color: Scalars['String']['input'];
  genus: Scalars['String']['input'];
  productionCatalogId: Scalars['String']['input'];
  series: Scalars['String']['input'];
};

export type CreateProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type CreateProductionLineInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
  productionLineId: Scalars['String']['input'];
};

export type CreateProductionLotAsyncImportJobInput = {
  autoStartImport: Scalars['Boolean']['input'];
};

export type CreateProductionLotInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  isAd: Scalars['Boolean']['input'];
  isTrial: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  weekReadyDate: Scalars['DateTime']['input'];
};

export type CreateProductionMaterialEventInput = {
  name: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type CreateProductionRecipeInput = {
  isCombo: Scalars['Boolean']['input'];
  isStartRecipe: Scalars['Boolean']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionRecipeId: Scalars['String']['input'];
};

export type CreateProductionRecipeWithVariationInput = {
  isCombo: Scalars['Boolean']['input'];
  isStartRecipe: Scalars['Boolean']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionRecipeId: Scalars['String']['input'];
  variation: ProductionRecipeVariationDataInput;
};

export type CreateProductionSpaceEventInput = {
  name: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type CreateProductionTaskEventInput = {
  name: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type CreateProductionTriggerInput = {
  expireBy: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  productionTriggerId: Scalars['String']['input'];
  source: ProductionTriggerSource;
  unit: ProductionTriggerUnit;
};

export type CreatePromotionRuleInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  promotionRuleId: Scalars['String']['input'];
  quantityFloor: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreatePurchaseOrderAllocationInput = {
  id: Scalars['String']['input'];
  items: Array<CreateAllocationLineItemInput>;
  orderId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type CreateReportFolderInput = {
  folderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInput = {
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  filters: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  handlebarsTemplate: Scalars['String']['input'];
  isStarred: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pageSettings: Scalars['String']['input'];
  parameterConfig: Scalars['String']['input'];
  parameterValues: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};

export type CreateReportScheduleInput = {
  cronExpression: Scalars['String']['input'];
  docType?: InputMaybe<OrderEmailDocType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  nextRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  outputFormat: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
  reportTemplateId?: InputMaybe<Scalars['String']['input']>;
  runOnce: Scalars['Boolean']['input'];
  scheduleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZoneId: Scalars['String']['input'];
};

export type CreateReportTemplateInput = {
  category: Scalars['String']['input'];
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  handlebarsTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  tags: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type CreateReserveRuleInput = {
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  reserveRuleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type CreateRestockSessionInput = {
  items: Array<CreateRestockSessionItemDataInput>;
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
  stationCode?: InputMaybe<Scalars['String']['input']>;
  stores: Array<CreateRestockSessionStoreInput>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type CreateRestockSessionItemDataInput = {
  itemId: Scalars['String']['input'];
};

export type CreateRestockSessionStoreInput = {
  customerLocationId: Scalars['String']['input'];
  storeName: Scalars['String']['input'];
};

export type CreateScheduledOrderInput = {
  lineItems: AddLineItemsInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  order: InitializeOrderInput;
};

export type CreateSiteLocationAsyncImportJobInput = {
  autoStartImport: Scalars['Boolean']['input'];
};

export type CreateSiteMapInput = {
  customerId: Scalars['String']['input'];
  customerLocationId: Scalars['String']['input'];
  excludeFromDistribution: Scalars['Boolean']['input'];
  programId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  siteMapId: Scalars['String']['input'];
};

export type CreateTaskAssignmentInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  sourceLevel: TaskAssignmentSourceLevel;
  taskAssignmentId: Scalars['String']['input'];
  taskEventName: Scalars['String']['input'];
};

export type CreateTaskEventTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskEventTypeId: Scalars['String']['input'];
};

/**
 * Simplified input for the createTask mutation.
 * Resolves TaskEventType by ID rather than requiring the name.
 */
export type CreateTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  taskEventTypeId: Scalars['String']['input'];
};

export type CreateTaxAuthorityInput = {
  code: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  glAccount: Scalars['String']['input'];
  glAccountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  roles: Array<UserRole>;
  userId: Scalars['String']['input'];
};

export type CreateUserInviteInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  expiresInDays: Scalars['Int']['input'];
  linkedUserId?: InputMaybe<Scalars['String']['input']>;
  recipientEmail: Scalars['String']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
  userType?: UserType;
};

export type CreateUserInvitesInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  expiresInDays: Scalars['Int']['input'];
  linkedUserId?: InputMaybe<Scalars['String']['input']>;
  recipientEmails: Array<Scalars['String']['input']>;
  registrations: Array<UserInviteRegistrationDataInput>;
  userType?: UserType;
};

export type CreateVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateVendorPurchaseOrderInput = {
  billingAddress: CreateAddressInput;
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isUrgent?: Scalars['Boolean']['input'];
  items: Array<CreateVendorPurchaseOrderItemInput>;
  orderPlacedDate: Scalars['DateTime']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  shippingAddress: CreateAddressInput;
  siteLocationId: Scalars['String']['input'];
  status: VendorPurchaseOrderStatus;
  vendorName: Scalars['String']['input'];
};

export type CreateVendorPurchaseOrderItemInput = {
  erpJobId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  materialItemErpId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
  quantityReceived: Scalars['Decimal']['input'];
};

export type CreateWorkOrderInput = {
  activityCode: Scalars['String']['input'];
  containerQuantityToProduce: Scalars['Int']['input'];
  erpId?: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  plannedQuantity: Scalars['Int']['input'];
  productionPhaseCode: Scalars['String']['input'];
  quantityToProduce: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
  workOrderItems: Array<BuildItemInput>;
  workOrderStatus: WorkOrderStatus;
};

export type CreateWsapiImportInput = {
  enabled: Scalars['Boolean']['input'];
  integrationId: Scalars['String']['input'];
  scheduleDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  scheduleTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  wsapiImportId: Scalars['String']['input'];
};

export type CreditExistingOrderInput = {
  creditOrderId: Scalars['String']['input'];
  lines?: InputMaybe<Array<CreditOrderLineDataInput>>;
  sourceOrderId: Scalars['String']['input'];
};

export type CreditOrderLineDataInput = {
  lineNumber: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * Batch mutation result. One CrmExportPayload per input row, in submission order, so
 * the worker can inspect each row's outcome. Per-row problems land on that row's
 * errors; the whole batch never rejects for a single bad row.
 * Errors here is reserved for whole-batch failures (empty updates today); when it is
 * non-null CrmExports is null.
 */
export type CrmExportBatchPayload = {
  __typename?: 'CrmExportBatchPayload';
  crmExports?: Maybe<Array<CrmExportPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocument = {
  __typename?: 'CrmExportDocument';
  customerId: Scalars['String']['output'];
  exportStatus: CrmExportStatus;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id: Scalars['String']['output'];
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** Last write timestamp (observability only). */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocumentFilterInput = {
  and?: InputMaybe<Array<CrmExportDocumentFilterInput>>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  exportStatus?: InputMaybe<CrmExportStatusOperationFilterInput>;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CrmExportDocumentFilterInput>>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Last write timestamp (observability only). */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocumentSortInput = {
  customerId?: InputMaybe<SortEnumType>;
  exportStatus?: InputMaybe<SortEnumType>;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: InputMaybe<SortEnumType>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<SortEnumType>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Last write timestamp (observability only). */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Discriminator payload for a terminal failure. */
export type CrmExportFailedPermanentUpdateDataInput = {
  lastError: Scalars['String']['input'];
};

/**
 * Discriminator payload for a retryable failure. The worker computed RetryCount (new total
 * after this attempt) and NextRetryAt (earliest next attempt) from its own retry-budget
 * policy — wsapi just records them.
 */
export type CrmExportFailedTransientUpdateDataInput = {
  lastError: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

/**
 * Result of a single worker status report. On success CrmExport is the outbox row as it
 * stands after the write; Errors carries a per-row failure (bad discriminator shape, or the
 * customer has no outbox row) and then CrmExport is null. The two are mutually exclusive.
 */
export type CrmExportPayload = {
  __typename?: 'CrmExportPayload';
  crmExport?: Maybe<CrmExportDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Lifecycle status of a single customer's outbound export to a Merge.dev CRM
 * (Salesforce / HubSpot). One row per customer in the CrmExports outbox; the
 * wsapi-services worker drains rows the transition matrix leaves eligible.
 */
export enum CrmExportStatus {
  /** The worker successfully pushed the customer/contacts to the CRM. */
  Completed = 'COMPLETED',
  /**
   * Terminal failure (non-retryable, or the transient budget was exhausted). Surfaces for human
   * review. A subsequent intent stamp resets the row to PENDING so corrected data
   * re-exports.
   */
  FailedPermanent = 'FAILED_PERMANENT',
  /**
   * Most recent attempt failed transiently (5xx, 429, timeout, etc.). The worker retries at or
   * after nextRetryAt until its budget is exhausted, then writes
   * a terminal FAILED_PERMANENT. A fresh intent stamp resets the row to
   * PENDING (new field values may cure the failure).
   */
  FailedTransient = 'FAILED_TRANSIENT',
  /** Intent stamped (a mapped field changed) and no terminal outcome recorded yet — the worker should attempt the push. */
  Pending = 'PENDING'
}

export type CrmExportStatusOperationFilterInput = {
  eq?: InputMaybe<CrmExportStatus>;
  in?: InputMaybe<Array<CrmExportStatus>>;
  neq?: InputMaybe<CrmExportStatus>;
  nin?: InputMaybe<Array<CrmExportStatus>>;
};

/**
 * One row in the batch. Exactly one outcome must be set: completed = true, OR
 * failedTransient, OR failedPermanent.
 *
 * Completed is a bare flag rather than a nested payload object (as it is on the accounting
 * MergeDevExportStatusUpdateRow, which carries the QB invoice id) because a CRM completion
 * carries no outbox payload — the CRM record URL is persisted on the customer itself via
 * setCustomerCrmLink, and a GraphQL input object must define at least one field, so an
 * empty Completed payload type is not expressible.
 */
export type CrmExportStatusUpdateRowInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['String']['input'];
  failedPermanent?: InputMaybe<CrmExportFailedPermanentUpdateDataInput>;
  failedTransient?: InputMaybe<CrmExportFailedTransientUpdateDataInput>;
};

/** A connection to a list of items. */
export type CrmExportsConnection = {
  __typename?: 'CrmExportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CrmExportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CrmExportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CrmExportsEdge = {
  __typename?: 'CrmExportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CrmExportDocument;
};

/**
 * One entry in a customer's merged activity timeline. A single flat, kind-tagged row spanning all three
 * activity sources — order milestones, order payment-ledger entries, and customer notes — so the feed
 * pages as one strictly reverse-chronological stream. Fields that do not apply to an entry's kind are
 * null: order milestones carry the order identity and status, ledger entries add amount, source and the
 * recording user, and notes carry text and their author. Ordering is newest first, tie-broken by Id so
 * paging stays stable across a page boundary.
 */
export type CustomerActivityEntry = {
  __typename?: 'CustomerActivityEntry';
  /** The user who recorded a payment or wrote a note; null when unknown or not applicable. */
  actedBy?: Maybe<Scalars['String']['output']>;
  /** Amount and currency of a payment or deposit entry; null for every other kind. */
  amount?: Maybe<MoneyData>;
  /** Stable identifier for this entry, unique within the feed and used as the ordering tie-break. */
  id: Scalars['String']['output'];
  /** Which kind of activity this entry records. */
  kind: CustomerActivityKind;
  /** When the activity happened. The feed is sorted by this value, newest first. */
  occurredAt: Scalars['DateTime']['output'];
  /** Identifier of the order this entry belongs to; null for a note. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Human-readable number of the order this entry belongs to; null for a note. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The order's current status; null for a note. */
  orderStatus?: Maybe<OrderStatus>;
  /**
   * Where a payment or deposit came from — imported from the accounting integration, or recorded
   * manually in FULFILL. Null for every other kind.
   */
  source?: Maybe<OrderPaymentSource>;
  /** The note's text; null for every kind other than a note. */
  text?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type CustomerActivityFeedConnection = {
  __typename?: 'CustomerActivityFeedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerActivityFeedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerActivityEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerActivityFeedEdge = {
  __typename?: 'CustomerActivityFeedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerActivityEntry;
};

/**
 * What a single customer activity entry records. Order milestones carry the moment the order reached
 * that state; Payment and Deposit are the order payment ledger's two entry kinds; Note is a customer
 * note. The kind tells a client which of the entry's optional fields are populated.
 */
export enum CustomerActivityKind {
  /** A deposit was received toward an order's deposit requirement. */
  Deposit = 'DEPOSIT',
  /** A note was recorded against the customer. */
  Note = 'NOTE',
  /** The order was created. */
  OrderPlaced = 'ORDER_PLACED',
  /** The order shipped. */
  OrderShipped = 'ORDER_SHIPPED',
  /** The order first entered an active state (submitted, acknowledged, picked or shipped). */
  OrderSubmitted = 'ORDER_SUBMITTED',
  /** The order synchronized to the tenant's ERP or accounting system. */
  OrderSynchronized = 'ORDER_SYNCHRONIZED',
  /** A payment was applied to an order balance. */
  Payment = 'PAYMENT'
}

/**
 * A customer's outstanding balance distributed across days-past-due buckets, where each order's due date is
 * its expected delivery date offset by the order's terms limit. The five buckets sum to arBalance. An order
 * that carries no expected delivery date has no due date at all, so it is treated as most-overdue and its
 * outstanding amount is counted in days90Plus — never in current, which would report an arbitrarily overdue
 * balance as not yet due. Counting it in a bucket rather than dropping it keeps the buckets summing to
 * arBalance.
 */
export type CustomerArAging = {
  __typename?: 'CustomerArAging';
  /** Outstanding amount that is not yet past due. Excludes orders that carry no due date. */
  current: Scalars['Decimal']['output'];
  /** Outstanding amount between 1 and 30 days past due. */
  days1To30: Scalars['Decimal']['output'];
  /** Outstanding amount between 31 and 60 days past due. */
  days31To60: Scalars['Decimal']['output'];
  /** Outstanding amount between 61 and 90 days past due. */
  days61To90: Scalars['Decimal']['output'];
  /**
   * Outstanding amount more than 90 days past due, plus the outstanding amount of any order that carries
   * no expected delivery date and therefore no due date.
   */
  days90Plus: Scalars['Decimal']['output'];
};

export type CustomerBulkActionPayload = {
  __typename?: 'CustomerBulkActionPayload';
  customers?: Maybe<Array<CustomerPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A per-customer commission rate (percent value, 0–100) that takes precedence over the user's default rate. */
export type CustomerCommissionOverrideData = {
  __typename?: 'CustomerCommissionOverrideData';
  /**
   * The customer this override applies to. Null when the customer no longer exists
   * in the caller's tenant, or when the lookup is briefly unavailable — never treat
   * null as "override inactive"; the override's own fields remain authoritative.
   */
  customer?: Maybe<CustomersSummaryDocument>;
  customerId: Scalars['String']['output'];
  ratePercent: Scalars['Decimal']['output'];
};

/** A per-customer commission rate (percent value, 0–100) that takes precedence over the user's default rate. */
export type CustomerCommissionOverrideDataFilterInput = {
  and?: InputMaybe<Array<CustomerCommissionOverrideDataFilterInput>>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerCommissionOverrideDataFilterInput>>;
  ratePercent?: InputMaybe<DecimalOperationFilterInput>;
};

export type CustomerContextNoteData = {
  __typename?: 'CustomerContextNoteData';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CustomerErpIdPayload = {
  __typename?: 'CustomerErpIdPayload';
  customerId: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * The authoritative, backend-resolved answer to "where will this customer's invoices be sent" — the
 * same rules the on-demand invoice email compose dialog uses, exposed read-only so the UI never needs
 * its own copy of the routing logic. recipients is empty exactly when fallbackReason is
 * not None; a non-None reason means an actual send would fall back to the order's own
 * contact instead, which this customer-level view has no order to show.
 */
export type CustomerInvoiceRecipientsData = {
  __typename?: 'CustomerInvoiceRecipientsData';
  /**
   * Why recipients is empty: None when it isn't; NoRoutedContact when the
   * customer simply has no contact of the routed type (normal, not a misconfiguration);
   * RoutedContactHasNoEmail when a routed contact exists but every one of its emails is
   * blank — the misconfiguration this query exists to surface, since an actual send would silently
   * fall back to the purchaser with no warning.
   */
  fallbackReason: CustomerRecipientFallbackReason;
  /**
   * Every non-blank email of every contact currently routed to receive this customer's invoice
   * emails (every AccountsPayable contact by default, or the tenant's configured override),
   * deduped case-insensitively, contact-then-email order preserved. Empty when fallbackReason
   * is not None.
   */
  recipients: Array<Scalars['String']['output']>;
};

export type CustomerItemEffectiveDateOverlap = {
  __typename?: 'CustomerItemEffectiveDateOverlap';
  customerItemId: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerItemPayload = {
  __typename?: 'CustomerItemPayload';
  customerItem?: Maybe<CustomerItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  typedErrors?: Maybe<CustomerItemTypedErrors>;
};

export type CustomerItemStateData = {
  __typename?: 'CustomerItemStateData';
  additionalSkus: Array<Scalars['String']['output']>;
  additionalUpcs: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerItemId: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  isDefault: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPriceCurrency?: Maybe<Scalars['String']['output']>;
  sizeUomCode?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: CustomerItemStatus;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum CustomerItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type CustomerItemStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerItemStatus>;
  in?: InputMaybe<Array<CustomerItemStatus>>;
  neq?: InputMaybe<CustomerItemStatus>;
  nin?: InputMaybe<Array<CustomerItemStatus>>;
};

export type CustomerItemTypedErrors = {
  __typename?: 'CustomerItemTypedErrors';
  effectiveDateOverlap?: Maybe<CustomerItemEffectiveDateOverlap>;
  upcSkuCollision?: Maybe<CustomerItemUpcSkuCollision>;
};

export type CustomerItemUpcSkuCollision = {
  __typename?: 'CustomerItemUpcSkuCollision';
  customerItemId: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type CustomerItemsConnection = {
  __typename?: 'CustomerItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerItemsEdge = {
  __typename?: 'CustomerItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

/**
 * MongoDB document for a single per-location typed note (one per NoteContext).
 * Mirrors the customer-level typed-note read surface.
 */
export type CustomerLocationContextNoteDocument = {
  __typename?: 'CustomerLocationContextNoteDocument';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * MongoDB document for a single per-location typed note (one per NoteContext).
 * Mirrors the customer-level typed-note read surface.
 */
export type CustomerLocationContextNoteDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationContextNoteDocumentFilterInput>>;
  context?: InputMaybe<NoteContextOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationContextNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerLocationDocument = {
  __typename?: 'CustomerLocationDocument';
  adGroup: Scalars['String']['output'];
  address?: Maybe<AddressData>;
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier: Scalars['String']['output'];
  code: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  /** The display name of the customer associated with this location. */
  customerName: Scalars['String']['output'];
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The freight charge value override for this location. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  locationLookupCode: Scalars['String']['output'];
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId: Scalars['String']['output'];
  settings?: Maybe<CustomerLocationSettingsDocument>;
  storeNumber: Scalars['String']['output'];
  /**
   * Ship-to override of the customer's tax-authority list. Empty means
   * "inherit the customer's list" (which itself may inherit the tenant default).
   * Resolution order: ship-to -> customer -> tenant default.
   */
  taxAuthorityIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
};

export type CustomerLocationDocumentFilterInput = {
  adGroup?: InputMaybe<StringOperationFilterInput>;
  address?: InputMaybe<AddressDataFilterInput>;
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerLocationDocumentFilterInput>>;
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  /** The display name of the customer associated with this location. */
  customerName?: InputMaybe<StringOperationFilterInput>;
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The freight charge value override for this location. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  globalLocationNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  locationLookupCode?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationDocumentFilterInput>>;
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<CustomerLocationSettingsDocumentFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Ship-to override of the customer's tax-authority list. Empty means
   * "inherit the customer's list" (which itself may inherit the tenant default).
   * Resolution order: ship-to -> customer -> tenant default.
   */
  taxAuthorityIds?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerLocationDocumentSortInput = {
  adGroup?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressDataSortInput>;
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  /** The display name of the customer associated with this location. */
  customerName?: InputMaybe<SortEnumType>;
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The freight charge value override for this location. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  globalLocationNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationLookupCode?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<SortEnumType>;
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<CustomerLocationSettingsDocumentSortInput>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
};

/**
 * One group header for the Restock Locations sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via restockCustomerLocations), a
 * display Label, and the server-computed Count of locations in the group
 * under the active search.
 */
export type CustomerLocationGroupBucket = {
  __typename?: 'CustomerLocationGroupBucket';
  /** Number of locations in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — the location's Region or Market value. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for customerLocationGroups. Mirrors the Restock Locations sidebar's
 * group-by options so the client renders server-computed group headers instead of grouping the full
 * location list in memory. Both options are flat scalar fields on
 * RestockCustomerLocationDocument that map cleanly to the Restock Locations list
 * where eq-value (e.g. restockCustomerLocations(where: { region: { eq: "<Key>" } })),
 * so a bucket's Key is directly usable to lazy-load its
 * children. RestockCustomerLocationDocument carries no Status/location-type field, so the
 * Region/Market location dimensions are used instead of the speculative Status dimension.
 */
export enum CustomerLocationGroupField {
  /** One bucket per distinct location Market. */
  Market = 'MARKET',
  /** One bucket per distinct location Region. */
  Region = 'REGION'
}

/** MongoDB document for customer location notes. */
export type CustomerLocationNoteDocument = {
  __typename?: 'CustomerLocationNoteDocument';
  id: Scalars['String']['output'];
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

/** MongoDB document for customer location notes. */
export type CustomerLocationNoteDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationNoteDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  noteText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerLocationSettingsData = {
  __typename?: 'CustomerLocationSettingsData';
  deliveryScheduleId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<NoteData>>;
  retailerName: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  ruleIds: Array<Scalars['String']['output']>;
  shippingNotes?: Maybe<Scalars['String']['output']>;
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type CustomerLocationSettingsDataInput = {
  deliveryScheduleId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<NoteDataInput>>;
  retailerName: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  ruleIds: Array<Scalars['String']['input']>;
  shippingNotes?: InputMaybe<Scalars['String']['input']>;
  storeClass: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocument = {
  __typename?: 'CustomerLocationSettingsDocument';
  /**
   * Per-location typed notes — one current value per NoteContext (Ship/Pull/General).
   * The single source of truth for the location's notes; the legacy flat ShippingNotes
   * is a derived read of the Ship entry. Written by
   * CustomerLocationProjectionService on the typed-note events. A separate concern from the
   * legacy append-only Notes activity log.
   */
  contextNotes: Array<CustomerLocationContextNoteDocument>;
  deliveryScheduleId: Scalars['String']['output'];
  deliveryScheduleName: Scalars['String']['output'];
  notes: Array<CustomerLocationNoteDocument>;
  retailerName: Scalars['String']['output'];
  route: Scalars['String']['output'];
  ruleIds: Array<Scalars['String']['output']>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes: Scalars['String']['output'];
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationSettingsDocumentFilterInput>>;
  /**
   * Per-location typed notes — one current value per NoteContext (Ship/Pull/General).
   * The single source of truth for the location's notes; the legacy flat ShippingNotes
   * is a derived read of the Ship entry. Written by
   * CustomerLocationProjectionService on the typed-note events. A separate concern from the
   * legacy append-only Notes activity log.
   */
  contextNotes?: InputMaybe<ListFilterInputTypeOfCustomerLocationContextNoteDocumentFilterInput>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via CustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<ListFilterInputTypeOfCustomerLocationNoteDocumentFilterInput>;
  or?: InputMaybe<Array<CustomerLocationSettingsDocumentFilterInput>>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  ruleIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  zone?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocumentSortInput = {
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via CustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  zone?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomerLocationsConnection = {
  __typename?: 'CustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerLocationsEdge = {
  __typename?: 'CustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/** A connection to a list of items. */
export type CustomerLocationsWithBaseRateOfSaleConnection = {
  __typename?: 'CustomerLocationsWithBaseRateOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerLocationsWithBaseRateOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerLocationsWithBaseRateOfSaleEdge = {
  __typename?: 'CustomerLocationsWithBaseRateOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/**
 * Server-computed order-history and accounts-receivable rollup for one customer, produced by a single
 * MongoDB aggregation over the combined-orders read model. Every figure here covers ONE order set: the
 * customer's orders excluding master orders, cancelled orders and deleted orders — only orders actually
 * placed count, and a withdrawn order never inflates a total. Master orders are recurring templates rather
 * than purchases and carry no payment ledger, so they are excluded outright rather than counted in some
 * figures and not others. A customer with no orders yields a zeroed instance rather than null.
 */
export type CustomerOrderStats = {
  __typename?: 'CustomerOrderStats';
  /** The arBalance split into days-past-due buckets. */
  aging: CustomerArAging;
  /**
   * Sum of amounts paid across every order in scope — the same order set as lifetimeOrderValue, so the
   * two are read side by side. This is a server-side total in its own right, deliberately NOT
   * lifetimeOrderValue less arBalance: those two cover different order sets (drafts are in the lifetime
   * figure and out of the AR figure), so subtracting one from the other reports money as paid that was
   * never paid.
   */
  amountPaid: Scalars['Decimal']['output'];
  /**
   * Total outstanding balance (order total less amount paid) across the orders that carry accounts
   * receivable: submitted, acknowledged, picked, shipped, sync-error, closed and synchronized. Closed and
   * synchronized orders are included because that is where most money actually owed sits.
   *
   * Draft orders (initialized, open) are DELIBERATELY excluded — a quote is not a commitment and must
   * never read as money owed. That makes this set NARROWER than the one behind openOrderCount; the two
   * are not meant to agree and should not be reconciled against each other.
   */
  arBalance: Scalars['Decimal']['output'];
  /** Lifetime order value divided by order count; 0 when the customer has no orders. */
  averageOrderValue: Scalars['Decimal']['output'];
  /** Initialized date of the customer's earliest order; null when there is none. */
  firstOrderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Initialized date of the customer's most recent order; null when there is none. */
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Sum of order totals across every order in scope. */
  lifetimeOrderValue: Scalars['Decimal']['output'];
  /**
   * Number of orders that have neither completed nor been withdrawn: the drafts (initialized, open), the
   * orders in fulfillment (submitted, acknowledged, picked, shipped), and sync-error orders, which are
   * quarantined mid-flight rather than finished.
   *
   * This set is DELIBERATELY WIDER than the one behind arBalance, which excludes drafts. A draft order is
   * open but nothing is owed on it yet, so openOrderCount and arBalance are not meant to agree and should
   * not be reconciled against each other.
   */
  openOrderCount: Scalars['Int']['output'];
  /**
   * Number of the customer's orders in scope. Master orders, cancelled orders and deleted orders are
   * excluded.
   */
  totalOrderCount: Scalars['Int']['output'];
  /** Sum of order totals for orders initialized on or after January 1st of the current year. */
  ytdOrderValue: Scalars['Decimal']['output'];
};

export type CustomerPayload = {
  __typename?: 'CustomerPayload';
  customer?: Maybe<CustomerStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type CustomerPortalFavoritesListsConnection = {
  __typename?: 'CustomerPortalFavoritesListsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalFavoritesListsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FavoritesListDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalFavoritesListsEdge = {
  __typename?: 'CustomerPortalFavoritesListsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FavoritesListDocument;
};

/** A connection to a list of items. */
export type CustomerPortalInventoryAvailabilityConnection = {
  __typename?: 'CustomerPortalInventoryAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalInventoryAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalInventoryAvailabilityEdge = {
  __typename?: 'CustomerPortalInventoryAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/** A connection to a list of items. */
export type CustomerPortalItemsConnection = {
  __typename?: 'CustomerPortalItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalItemsEdge = {
  __typename?: 'CustomerPortalItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type CustomerPortalSellableHardgoodsConnection = {
  __typename?: 'CustomerPortalSellableHardgoodsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalSellableHardgoodsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalSellableHardgoodsEdge = {
  __typename?: 'CustomerPortalSellableHardgoodsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/**
 * Customer-readable, read-only projection of the portal settings. Surfaces the
 * enforcement fields the worksuite-pwa portal needs to gate a real customer session:
 * portalEnabled (route guard), minimumOrderAmount (cart minimum),
 * CatalogDisplayMode (catalog view), and the FULFILL "Availability rule"
 * (availabilityMinGrade + availabilityLocationId) the portal feeds
 * into the existing customerPortalInventoryAvailability grade/location filter so a customer
 * sees exactly the items the operator made available. It is the customer-scope counterpart of the
 * staff-only portal settings and is returned by the
 * customerPortalSettings query (task 729b97fa).
 */
export type CustomerPortalSettingsData = {
  __typename?: 'CustomerPortalSettingsData';
  /**
   * Location filter of the FULFILL "Availability rule"; nullable — null means "all
   * locations".
   */
  availabilityLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Minimum inventory grade (grade-or-better) of the FULFILL "Availability rule". 0 is the
   * "Any" option (no grade floor, so gradeless hard-good inventory is included); a tenant that has
   * never saved settings reads the documented default of 2.
   */
  availabilityMinGrade: Scalars['Int']['output'];
  catalogDisplayMode: CatalogDisplayMode;
  /**
   * "Include sellable hard goods" option of the FULFILL "Availability rule". When true,
   * gradeless sellable hard goods are included in availability; defaults to false on a
   * tenant that has never opted in.
   */
  includeSellableHardGoods: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Decimal']['output'];
  portalEnabled: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type CustomerPortalUsersConnection = {
  __typename?: 'CustomerPortalUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PortalUserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalUsersEdge = {
  __typename?: 'CustomerPortalUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PortalUserDocument;
};

/**
 * Why a customer-only recipient resolution (ResolveForCustomerAsync) returned no recipients.
 * There is no order in this scope, so unlike the order-scoped ResolveAsync there is nothing to
 * fall back to — the caller gets an honest reason instead of a resolved address.
 */
export enum CustomerRecipientFallbackReason {
  /** Recipients were resolved; the recipient list is non-empty. */
  None = 'NONE',
  /**
   * The customer has no contact of the routed contact type at all. A normal, unconfigured state —
   * not a misconfiguration.
   */
  NoRoutedContact = 'NO_ROUTED_CONTACT',
  /**
   * The customer has one or more contacts of the routed contact type, but every one of them has only
   * blank/whitespace email addresses. A misconfiguration: at send time this same customer would
   * silently fall back to the purchaser with no warning.
   */
  RoutedContactHasNoEmail = 'ROUTED_CONTACT_HAS_NO_EMAIL'
}

/**
 * Per-row failure surfaced by validateCustomerDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type CustomerStagedRowError = {
  __typename?: 'CustomerStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type CustomerStateData = {
  __typename?: 'CustomerStateData';
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  billingAddresses: Array<CreateAddress>;
  carrier: Scalars['String']['output'];
  contacts: Array<ContactData>;
  contextNotes: Array<CustomerContextNoteData>;
  crmRecordUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  customerTypeId: Scalars['String']['output'];
  defaultDiscountPercentage?: Maybe<Scalars['Decimal']['output']>;
  depositRequirementType?: Maybe<DepositRequirementType>;
  depositRequirementValue?: Maybe<Scalars['Decimal']['output']>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  erpPriceGroupId: Scalars['String']['output'];
  federalTaxNumber: Scalars['String']['output'];
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  locations: Array<LocationData>;
  name: Scalars['String']['output'];
  notes: Array<NoteData>;
  orderSubmitter?: Maybe<OrderSubmitterData>;
  poRequired: Scalars['Boolean']['output'];
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  route: Scalars['String']['output'];
  salesPeople: Array<SalesPersonData>;
  sendOrderEmails: Scalars['Boolean']['output'];
  shipFromLocations: Array<ShipFromLocationData>;
  status: CustomerStatus;
  synchronizeOrders: Scalars['Boolean']['output'];
  taxAuthorityIds: Array<Scalars['String']['output']>;
  taxExemptNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type CustomerStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerStatus>;
  in?: InputMaybe<Array<CustomerStatus>>;
  neq?: InputMaybe<CustomerStatus>;
  nin?: InputMaybe<Array<CustomerStatus>>;
};

/** A connection to a list of items. */
export type CustomerTimeEntriesConnection = {
  __typename?: 'CustomerTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerTimeEntriesEdge = {
  __typename?: 'CustomerTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeEntryDocument;
};

/**
 * One row of a customer's top-N SKUs by quantity, produced by a single MongoDB aggregation over the
 * customer's non-deleted orders and their line items. Revenue is the sum of each matched line's
 * quantity times its effective unit price (OverridePrice when set, else Price), matching
 * how the order itself values the line.
 */
export type CustomerTopSku = {
  __typename?: 'CustomerTopSku';
  /** Display name of the SKU, taken from the first matched line item. */
  name: Scalars['String']['output'];
  /** Total quantity of this SKU across every matched line, the ranking key. */
  quantity: Scalars['Int']['output'];
  /** Total revenue for this SKU across every matched line. */
  revenue: Scalars['Decimal']['output'];
  /** The item SKU this row summarizes. */
  sku: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocument = {
  __typename?: 'CustomerTypeDocument';
  customerTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Linked Chart-of-Accounts row resolved from RevenueGlAccountId. Null when the customer type is classification-only (no revenue account configured), or when the linked account no longer exists for the tenant. */
  revenueGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId: Scalars['String']['output'];
  status: CustomerTypeStatus;
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerTypeDocumentFilterInput>>;
  customerTypeId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerTypeDocumentFilterInput>>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CustomerTypeStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocumentSortInput = {
  customerTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for the CustomerType aggregate. Either
 * CustomerType contains the post-event state, or Errors describes why the
 * mutation failed.
 */
export type CustomerTypePayload = {
  __typename?: 'CustomerTypePayload';
  customerType?: Maybe<CustomerTypeStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CustomerTypeStateData = {
  __typename?: 'CustomerTypeStateData';
  customerTypeId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revenueGlAccountId: Scalars['String']['output'];
  status: CustomerTypeStatus;
  tenantId: Scalars['String']['output'];
};

export enum CustomerTypeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CustomerTypeStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerTypeStatus>;
  in?: InputMaybe<Array<CustomerTypeStatus>>;
  neq?: InputMaybe<CustomerTypeStatus>;
  nin?: InputMaybe<Array<CustomerTypeStatus>>;
};

/** A connection to a list of items. */
export type CustomerTypesConnection = {
  __typename?: 'CustomerTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerTypesEdge = {
  __typename?: 'CustomerTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerTypeDocument;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomersSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomersSummaryDocument;
};

export type CustomersSummaryDocument = {
  __typename?: 'CustomersSummaryDocument';
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier: Scalars['String']['output'];
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId: Scalars['String']['output'];
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: Maybe<Scalars['Decimal']['output']>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: Maybe<DepositRequirementType>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: Maybe<Scalars['Decimal']['output']>;
  erpId: Scalars['String']['output'];
  erpPriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber: Scalars['String']['output'];
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The customer-level freight charge value. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  numberOfBillingAddresses: Scalars['Int']['output'];
  numberOfContacts: Scalars['Int']['output'];
  numberOfLocations: Scalars['Int']['output'];
  numberOfNotes: Scalars['Int']['output'];
  numberOfShipFromLocations: Scalars['Int']['output'];
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired: Scalars['Boolean']['output'];
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /** The distinct, sorted state/province values across this customer's ship-to locations. Ship-from locations are a separate collection and are never included here. Empty when the customer has no ship-to locations, or none of them have a state recorded. */
  shipToStates: Array<Scalars['String']['output']>;
  status: CustomerStatus;
  synchronizeOrders: Scalars['Boolean']['output'];
  /**
   * Customer-level override of the tenant's default tax-authority list. Empty means
   * "inherit the tenant default". Per-ship-to overrides live on
   * CustomerLocationDocument.TaxAuthorityIds.
   * Resolution order: ship-to -> customer -> tenant default.
   */
  taxAuthorityIds: Array<Scalars['String']['output']>;
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomersSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<CustomersSummaryDocumentFilterInput>>;
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: InputMaybe<NullableOfDepositRequirementTypeOperationFilterInput>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: InputMaybe<DecimalOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  erpPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber?: InputMaybe<StringOperationFilterInput>;
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The customer-level freight charge value. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfBillingAddresses?: InputMaybe<IntOperationFilterInput>;
  numberOfContacts?: InputMaybe<IntOperationFilterInput>;
  numberOfLocations?: InputMaybe<IntOperationFilterInput>;
  numberOfNotes?: InputMaybe<IntOperationFilterInput>;
  numberOfShipFromLocations?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomersSummaryDocumentFilterInput>>;
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<CustomerStatusOperationFilterInput>;
  synchronizeOrders?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Customer-level override of the tenant's default tax-authority list. Empty means
   * "inherit the tenant default". Per-ship-to overrides live on
   * CustomerLocationDocument.TaxAuthorityIds.
   * Resolution order: ship-to -> customer -> tenant default.
   */
  taxAuthorityIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
};

export type CustomersSummaryDocumentSortInput = {
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier?: InputMaybe<SortEnumType>;
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId?: InputMaybe<SortEnumType>;
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: InputMaybe<SortEnumType>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: InputMaybe<SortEnumType>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: InputMaybe<SortEnumType>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  erpPriceGroupId?: InputMaybe<SortEnumType>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber?: InputMaybe<SortEnumType>;
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The customer-level freight charge value. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfBillingAddresses?: InputMaybe<SortEnumType>;
  numberOfContacts?: InputMaybe<SortEnumType>;
  numberOfLocations?: InputMaybe<SortEnumType>;
  numberOfNotes?: InputMaybe<SortEnumType>;
  numberOfShipFromLocations?: InputMaybe<SortEnumType>;
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<SortEnumType>;
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  synchronizeOrders?: InputMaybe<SortEnumType>;
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL payload returned by every CycleCountAssignment mutation. Follows the
 * standard mutation payload convention: nullable state on success,
 * ValidationError array on failure
 * (Atlas: cd1f708de28e44f8ae6d21f9a20f2212 — Payload Error Convention).
 *
 * SkippedItems reports MaterialItemIds that the supervisor
 * nominated on createCountAssignment but which had zero stocked bins in
 * the MaterialItemLocationQuantity read model — they produce no tasks but
 * must remain visible so the supervisor can distinguish "0 bins for item X" from
 * "no items requested at all" (B4-D). The field is additive
 * (Atlas: bde8323d82064d928e44bebcff552a2e) — every mutation populates it
 * with at least an empty array, never null, so the schema surface is the
 * non-null-list-of-non-null-strings shape clients can rely on
 * (Codex C2-F3 cycle 1 finding).
 */
export type CycleCountAssignmentPayload = {
  __typename?: 'CycleCountAssignmentPayload';
  cycleCountAssignment?: Maybe<CycleCountAssignmentStateData>;
  errors?: Maybe<Array<ValidationError>>;
  /**
   * Material item IDs the supervisor nominated on createCountAssignment
   * but which had no stocked bins in the read model. Always populated as an
   * empty array (never null) on every other mutation so the schema surface is
   * the non-null-list-of-non-null-strings shape clients can rely on
   * (Codex C2-F3 cycle 1; Atlas bde8323d82064d928e44bebcff552a2e).
   */
  skippedItems: Array<Scalars['String']['output']>;
};

/**
 * Flattened GraphQL projection of CycleCountAssignmentState. The
 * StateData suffix follows the WSAPI convention reserved for cross-layer
 * shapes (Atlas: ...Data types are unique to their producing layer).
 */
export type CycleCountAssignmentStateData = {
  __typename?: 'CycleCountAssignmentStateData';
  assignmentId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  dueBy: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: CycleCountAssignmentStatus;
  tasks: Array<CycleCountAssignmentTaskStateData>;
  tenantId: Scalars['String']['output'];
  workerUserId?: Maybe<Scalars['String']['output']>;
};

export enum CycleCountAssignmentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Unknown = 'UNKNOWN'
}

/** Per-task GraphQL projection. */
export type CycleCountAssignmentTaskStateData = {
  __typename?: 'CycleCountAssignmentTaskStateData';
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  expectedQty: Scalars['Decimal']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type CycleCountHistoryConnection = {
  __typename?: 'CycleCountHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CycleCountHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CycleCountLogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CycleCountHistoryEdge = {
  __typename?: 'CycleCountHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CycleCountLogDocument;
};

/** Input for a single item within a cycle count submission. */
export type CycleCountItemInput = {
  itemId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocument = {
  __typename?: 'CycleCountLogDocument';
  id: Scalars['String']['output'];
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** Total number of items in this submission. */
  itemCount: Scalars['Int']['output'];
  /** Individual item counts within this submission. */
  items: Array<CycleCountLogItem>;
  /** Store/site location that was counted. */
  locationId: Scalars['String']['output'];
  /** Display name of the location at the time of posting. */
  locationName: Scalars['String']['output'];
  /** UTC time the count was submitted. */
  postedAt: Scalars['DateTime']['output'];
  /** Email of the person who submitted the count. */
  recordedBy: Scalars['String']['output'];
  /** Tenant that owns this count record. */
  tenantId: Scalars['String']['output'];
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocumentFilterInput = {
  and?: InputMaybe<Array<CycleCountLogDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** Total number of items in this submission. */
  itemCount?: InputMaybe<IntOperationFilterInput>;
  /** Individual item counts within this submission. */
  items?: InputMaybe<ListFilterInputTypeOfCycleCountLogItemFilterInput>;
  /** Store/site location that was counted. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the location at the time of posting. */
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCountLogDocumentFilterInput>>;
  /** UTC time the count was submitted. */
  postedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Email of the person who submitted the count. */
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  /** Tenant that owns this count record. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** Total number of items in this submission. */
  itemCount?: InputMaybe<SortEnumType>;
  /** Store/site location that was counted. */
  locationId?: InputMaybe<SortEnumType>;
  /** Display name of the location at the time of posting. */
  locationName?: InputMaybe<SortEnumType>;
  /** UTC time the count was submitted. */
  postedAt?: InputMaybe<SortEnumType>;
  /** Email of the person who submitted the count. */
  recordedBy?: InputMaybe<SortEnumType>;
  /** Tenant that owns this count record. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A single item-level entry within a CycleCountLogDocument. */
export type CycleCountLogItem = {
  __typename?: 'CycleCountLogItem';
  /** Item identifier. */
  itemId: Scalars['String']['output'];
  /** Display name of the item at the time of posting. */
  itemName: Scalars['String']['output'];
  /**
   * Optional free-text note captured at count submit time. Bounded by
   * MaxNoteLength; null when absent.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** The hard-count quantity recorded for this item at this location. */
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional reason recorded with this item count (e.g. "Damaged", "Moved").
   * Validated at the mutation boundary against
   * WorkSuite.Domain.Shared.CountReasons; null when absent
   * or whitespace at submission time. Legacy documents written before this field was
   * introduced read back as null.
   */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** SKU of the item. */
  sku: Scalars['String']['output'];
};

/** A single item-level entry within a CycleCountLogDocument. */
export type CycleCountLogItemFilterInput = {
  and?: InputMaybe<Array<CycleCountLogItemFilterInput>>;
  /** Item identifier. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the item at the time of posting. */
  itemName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional free-text note captured at count submit time. Bounded by
   * MaxNoteLength; null when absent.
   */
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCountLogItemFilterInput>>;
  /** The hard-count quantity recorded for this item at this location. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Optional reason recorded with this item count (e.g. "Damaged", "Moved").
   * Validated at the mutation boundary against
   * WorkSuite.Domain.Shared.CountReasons; null when absent
   * or whitespace at submission time. Legacy documents written before this field was
   * introduced read back as null.
   */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** SKU of the item. */
  sku?: InputMaybe<StringOperationFilterInput>;
};

/**
 * GraphQL payload returned from CycleCountMutation.PostCycleCounts.
 * Returns the persisted log document on success, or validation errors on failure.
 */
export type CycleCountPayload = {
  __typename?: 'CycleCountPayload';
  cycleCount?: Maybe<CycleCountLogDocument>;
  errors?: Maybe<Array<ValidationError>>;
  /** Number of items successfully posted. Zero on failure. */
  itemsPosted: Scalars['Int']['output'];
  /** True when all items were successfully posted. */
  success: Scalars['Boolean']['output'];
};

export enum CycleCountTaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type CycleCountTaskStatusOperationFilterInput = {
  eq?: InputMaybe<CycleCountTaskStatus>;
  in?: InputMaybe<Array<CycleCountTaskStatus>>;
  neq?: InputMaybe<CycleCountTaskStatus>;
  nin?: InputMaybe<Array<CycleCountTaskStatus>>;
};

export type DailySalesProportionDocument = {
  __typename?: 'DailySalesProportionDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  dayOfWeek: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  proportion: Scalars['Decimal']['output'];
  region: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type DailySalesProportionDocumentFilterInput = {
  and?: InputMaybe<Array<DailySalesProportionDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DailySalesProportionDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  proportion?: InputMaybe<DecimalOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type DailySalesProportionDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  dayOfWeek?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  proportion?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocument = {
  __typename?: 'DbrCalcResultDocument';
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  /** Timestamp at which this result was produced. */
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  /**
   * Customer display name resolved from CustomersSummaryDocument via the
   * row's RestockWorkQueueResultDocument.CustomerCode (i.e. the customer's
   * CustomerLookupCode). Null when no summary exists for the code so the client
   * can render a fallback rather than receiving an empty string that masks missing data.
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /**
   * Bounded snapshot of inputs that fed the calculation. Captured for explainability
   * rather than recomputation — keep small, do not store full upstream documents.
   */
  inputsSnapshot: Array<DbrCalcResultInputDocument>;
  itemCode: Scalars['String']['output'];
  /**
   * Item display name resolved from ItemSummaryDocument via the row's
   * RestockWorkQueueResultDocument.ItemCode (i.e. the item's
   * ItemLookupCode). Null when no summary exists for the code.
   */
  itemName?: Maybe<Scalars['String']['output']>;
  locationCode: Scalars['String']['output'];
  /**
   * Customer-location display name resolved from CustomerLocationDocument
   * via the row's (RestockWorkQueueResultDocument.CustomerCode,
   * RestockWorkQueueResultDocument.LocationCode) pair (i.e. the location's
   * CustomerLookupCode + LocationLookupCode). Both codes are needed because
   * LocationLookupCode is only unique within a customer.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * Operator-facing per-row order quantity. Reads RestockWorkQueueResultDocument.AchievableQuantity
   * when allocation has run; falls back to a rounded RestockWorkQueueResultDocument.DemandQuantity
   * for rows where the allocation engine did not produce a value (per T-E spec:
   * "orderQuantity = demand for now"). Does NOT recompute achievable — see Atlas
   * standard e05b714192b34cc298e08d3bbbc241da.
   */
  orderQuantity: Scalars['Int']['output'];
  /**
   * Per-store Restock Index (0–100) for the row's RestockWorkQueueResultDocument.CustomerCode
   * + RestockWorkQueueResultDocument.LocationCode pair. Aggregated across
   * every current calc row for that store (not just the daily-demand grid's
   * asOf/weeksOfSupply slice) so the column shows the same value as the
   * per-store dashboard. Resolved via a batch DataLoader so a page of N daily-demand
   * rows costs one round-trip, not N.
   */
  storeRanking?: Maybe<Scalars['Int']['output']>;
  /** Identifier of the strategy that produced this result. */
  strategyKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply: Scalars['Decimal']['output'];
};

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocumentFilterInput = {
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<DbrCalcResultDocumentFilterInput>>;
  /** Timestamp at which this result was produced. */
  calcDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Bounded snapshot of inputs that fed the calculation. Captured for explainability
   * rather than recomputation — keep small, do not store full upstream documents.
   */
  inputsSnapshot?: InputMaybe<ListFilterInputTypeOfDbrCalcResultInputDocumentFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcResultDocumentFilterInput>>;
  /** Identifier of the strategy that produced this result. */
  strategyKey?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocumentSortInput = {
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: InputMaybe<SortEnumType>;
  /** Timestamp at which this result was produced. */
  calcDate?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  /** Identifier of the strategy that produced this result. */
  strategyKey?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

/**
 * Single named input captured in RestockWorkQueueResultDocument.InputsSnapshot.
 * String value keeps the snapshot type-uniform regardless of input shape.
 */
export type DbrCalcResultInputDocument = {
  __typename?: 'DbrCalcResultInputDocument';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Single named input captured in RestockWorkQueueResultDocument.InputsSnapshot.
 * String value keeps the snapshot type-uniform regardless of input shape.
 */
export type DbrCalcResultInputDocumentFilterInput = {
  and?: InputMaybe<Array<DbrCalcResultInputDocumentFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcResultInputDocumentFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/** Scheduler heartbeat snapshot exposed by RestockWorkQueueFleetQuery.GetAdminRestockWorkQueueSchedulerStatus. */
export type DbrCalcSchedulerStatusResult = {
  __typename?: 'DbrCalcSchedulerStatusResult';
  /**
   * Most recent successful EntityType.DbrCalcScheduler iteration End.
   * Diverges from LastTick when the scheduler is currently failing — operational
   * signal that the heartbeat is degraded. Null when no successful tick has been recorded.
   */
  lastSuccessfulTick?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent EntityType.DbrCalcScheduler iteration End regardless of success. Null when none recorded. */
  lastTick?: Maybe<Scalars['DateTime']['output']>;
  /** Success flag of the most recent tick (the one represented by LastTick). Null when none recorded. */
  lastTickSucceeded?: Maybe<Scalars['Boolean']['output']>;
  /** Configured tick interval in milliseconds (TimerPeriodSeconds * 1000). Null when no config row exists. */
  tickIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocument = {
  __typename?: 'DbrCalcTenantQueueDocument';
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled: Scalars['Boolean']['output'];
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork: Scalars['Boolean']['output'];
  /** Natural id — the tenantId; one row per tenant. */
  id: Scalars['String']['output'];
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours: Scalars['Int']['output'];
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: Maybe<Scalars['DateTime']['output']>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority: Scalars['Int']['output'];
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours: Scalars['Int']['output'];
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocumentFilterInput = {
  and?: InputMaybe<Array<DbrCalcTenantQueueDocumentFilterInput>>;
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork?: InputMaybe<BooleanOperationFilterInput>;
  /** Natural id — the tenantId; one row per tenant. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcTenantQueueDocumentFilterInput>>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority?: InputMaybe<IntOperationFilterInput>;
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours?: InputMaybe<IntOperationFilterInput>;
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocumentSortInput = {
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled?: InputMaybe<SortEnumType>;
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork?: InputMaybe<SortEnumType>;
  /** Natural id — the tenantId; one row per tenant. */
  id?: InputMaybe<SortEnumType>;
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours?: InputMaybe<SortEnumType>;
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: InputMaybe<SortEnumType>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority?: InputMaybe<SortEnumType>;
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours?: InputMaybe<SortEnumType>;
};

/**
 * Per-tenant summary projected from RestockWorkQueueTenantDocument for
 * SuperAdmin observability of the Restock work-queue backlog.
 */
export type DbrCalcWorkSummary = {
  __typename?: 'DbrCalcWorkSummary';
  /** True when the tenant has work-queue rows pending recalculation. */
  hasPendingWork: Scalars['Boolean']['output'];
  /** Earliest pending work-queue LastCalcDate for the tenant; null when no pending rows. */
  oldestPending?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Worker fleet snapshot exposed by RestockWorkQueueFleetQuery.GetAdminRestockWorkQueueWorkerFleetStatus.
 * All counts are global (cross-tenant) — the query is SuperAdmin-gated.
 */
export type DbrCalcWorkerFleetStatusResult = {
  __typename?: 'DbrCalcWorkerFleetStatusResult';
  /** Current count of RestockWorkQueueDocument rows with a non-null LeaseId. */
  currentLeases: Scalars['Int']['output'];
  /**
   * Age in milliseconds of the oldest in-flight lease (smallest LockedDate among
   * rows with a non-null LeaseId). Null when there are no current leases.
   */
  oldestLeaseAgeMs?: Maybe<Scalars['Long']['output']>;
  /** Batch timing aggregates over the recent window. */
  recentBatchTimings: BatchTimingsResult;
  /**
   * Count of EntityType.DbrCalcDemandQuantity iteration documents whose
   * End falls inside the recent window. NOT a distinct worker count — a single
   * worker producing N batches contributes N to this value. IterationDocument
   * has no WorkerId field, so true distinct counts are out of scope here.
   */
  recentIterationCount: Scalars['Int']['output'];
};

export type DeactivateConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
};

export type DeactivateContainerConfigInput = {
  containerConfigId: Scalars['String']['input'];
};

export type DeactivateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
};

export type DeactivateCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type DeactivateItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgradeId: Scalars['String']['input'];
};

export type DeactivatePortalUserInput = {
  deactivatedBy: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
};

export type DeactivateProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type DeactivateProductionLineInput = {
  productionLineId: Scalars['String']['input'];
};

export type DeactivateProductionLotInput = {
  archiveNotes?: InputMaybe<Scalars['String']['input']>;
  consolidatedIntoProductionLotId?: InputMaybe<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type DeactivateProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type DeactivateProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type DeactivateProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type DeactivateSizeUomInput = {
  code: Scalars['String']['input'];
};

export type DeactivateTaxAuthorityInput = {
  id: Scalars['String']['input'];
};

export type DeactivateUserInput = {
  userId: Scalars['String']['input'];
};

export type DeallocatePurchaseOrderAllocationInput = {
  allocationId: Scalars['String']['input'];
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DefaultIncomeAccount = {
  __typename?: 'DefaultIncomeAccount';
  accountName: Scalars['String']['output'];
  accountRemoteId: Scalars['String']['output'];
};

export type DefineHolidayInput = {
  date: Scalars['LocalDate']['input'];
  holidayName: Scalars['String']['input'];
  isoWeek: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/**
 * Result of deleteAllStagedEntityDocuments: the per-entity
 * DeleteStagedEntityResultData for every GrowPointStagedEntity the
 * bulk purge cleared (one Results entry per member), plus TotalDeleted — the grand
 * total of staged documents removed across every entity and its backing collections — so the PWA
 * can show per-entity and overall counts. Errors is non-null only when the whole purge was
 * rejected up front (any of the caller tenant's import workers is running); in that case nothing
 * was deleted and Results is empty.
 */
export type DeleteAllStagedEntitiesResultData = {
  __typename?: 'DeleteAllStagedEntitiesResultData';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<DeleteStagedEntityResultData>;
  totalDeleted: Scalars['Long']['output'];
};

export type DeleteAllocationTemplateInput = {
  id: Scalars['String']['input'];
};

export type DeleteBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
};

export type DeleteCountBatchInput = {
  countRowIds: Array<Scalars['String']['input']>;
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DeleteCountInput = {
  countRowId: Scalars['String']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DeleteCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type DeleteErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type DeleteErpLoadListUserInput = {
  erpLoadListUserId: Scalars['String']['input'];
};

export type DeleteFavoritesListInput = {
  favoritesListId: Scalars['String']['input'];
};

export type DeleteForecastInput = {
  forecastId: Scalars['String']['input'];
};

/**
 * Result of deleteGrowPointIterations: the number of GrowPoint iteration/error documents
 * removed from the Synchronization Iterations collection for the caller's tenant.
 */
export type DeleteGrowPointIterationsResultData = {
  __typename?: 'DeleteGrowPointIterationsResultData';
  deletedCount: Scalars['Long']['output'];
};

export type DeleteHolidayInput = {
  holidayId: Scalars['String']['input'];
};

export type DeleteItemInput = {
  itemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteKitInput = {
  kitId: Scalars['String']['input'];
};

export type DeleteOrderInput = {
  orderId: Scalars['String']['input'];
};

export type DeletePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type DeletePriceLevelInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevelId: Scalars['String']['input'];
};

export type DeletePriceLevelsInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevelIds: Array<Scalars['String']['input']>;
};

export type DeleteProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type DeleteProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type DeleteProductionLotInput = {
  productionLotId: Scalars['String']['input'];
};

export type DeleteProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type DeleteProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type DeleteProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type DeleteProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type DeleteProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type DeleteProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type DeleteProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type DeleteProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type DeletePromotionRuleInput = {
  promotionRuleId: Scalars['String']['input'];
};

export type DeleteReportExecutionInput = {
  executionId: Scalars['String']['input'];
};

export type DeleteReportFolderInput = {
  folderId: Scalars['String']['input'];
};

export type DeleteReportInput = {
  reportId: Scalars['String']['input'];
};

export type DeleteReportScheduleInput = {
  scheduleId: Scalars['String']['input'];
};

export type DeleteReportTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type DeleteReserveRuleInput = {
  reserveRuleId: Scalars['String']['input'];
};

export type DeleteRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type DeleteSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type DeleteSiteLocationInput = {
  siteLocationId: Scalars['String']['input'];
};

export type DeleteSiteMapInput = {
  siteMapId: Scalars['String']['input'];
};

/**
 * Result of deleteStagedEntityDocuments: the GrowPointStagedEntity that was
 * cleared, the total number of staged documents removed across all of its backing collections, and
 * the per-collection breakdown so the caller can confirm every backing collection was touched.
 * Errors is non-null only when the purge was rejected (e.g. the staged collections are
 * locked while the tenant's import worker is running) — nothing was deleted.
 */
export type DeleteStagedEntityResultData = {
  __typename?: 'DeleteStagedEntityResultData';
  collections: Array<StagedCollectionDeletionData>;
  entity: GrowPointStagedEntity;
  errors?: Maybe<Array<ValidationError>>;
  totalDeleted: Scalars['Long']['output'];
};

export type DeleteTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type DeleteTenantIntegrationInput = {
  integrationId: Scalars['String']['input'];
};

/** Delete input data */
export type DeleteTimeEntryInput = {
  clickUpTaskId: Scalars['String']['input'];
  entryDate: Scalars['DateTime']['input'];
};

/** Delete operation result */
export type DeleteTimeEntryPayload = {
  __typename?: 'DeleteTimeEntryPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  userId: Scalars['String']['input'];
};

export type DeleteUserInviteInput = {
  inviteId: Scalars['String']['input'];
};

export type DeleteWorkerConfigInput = {
  configName: Scalars['String']['input'];
};

export type DeleteWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type DeletedStreamDocument = {
  __typename?: 'DeletedStreamDocument';
  deletedAt: Scalars['DateTime']['output'];
  streamName: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DeletedStreamDocumentFilterInput = {
  and?: InputMaybe<Array<DeletedStreamDocumentFilterInput>>;
  deletedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DeletedStreamDocumentFilterInput>>;
  streamName?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type DeletedStreamDocumentSortInput = {
  deletedAt?: InputMaybe<SortEnumType>;
  streamName?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type DeletedStreamTransactionDocument = {
  __typename?: 'DeletedStreamTransactionDocument';
  checkpointPosition?: Maybe<Scalars['Long']['output']>;
  ended?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  started: Scalars['DateTime']['output'];
  streamPrefix: Scalars['String']['output'];
  streamsDeleted: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type DeletedStreamTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<DeletedStreamTransactionDocumentFilterInput>>;
  checkpointPosition?: InputMaybe<LongOperationFilterInput>;
  ended?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeletedStreamTransactionDocumentFilterInput>>;
  started?: InputMaybe<DateTimeOperationFilterInput>;
  streamPrefix?: InputMaybe<StringOperationFilterInput>;
  streamsDeleted?: InputMaybe<IntOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type DeletedStreamTransactionDocumentSortInput = {
  checkpointPosition?: InputMaybe<SortEnumType>;
  ended?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  started?: InputMaybe<SortEnumType>;
  streamPrefix?: InputMaybe<SortEnumType>;
  streamsDeleted?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeletedStreamTransactionsConnection = {
  __typename?: 'DeletedStreamTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeletedStreamTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeletedStreamTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeletedStreamTransactionsEdge = {
  __typename?: 'DeletedStreamTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeletedStreamTransactionDocument;
};

/** A connection to a list of items. */
export type DeletedStreamsConnection = {
  __typename?: 'DeletedStreamsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeletedStreamsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeletedStreamDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeletedStreamsEdge = {
  __typename?: 'DeletedStreamsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeletedStreamDocument;
};

export type DeliveryScheduleDocument = {
  __typename?: 'DeliveryScheduleDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryScheduleId: Scalars['String']['output'];
  friday: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  locationIds: Array<Scalars['String']['output']>;
  monday: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturday: Scalars['Boolean']['output'];
  status: DeliveryScheduleStatus;
  sunday: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type DeliveryScheduleDocumentFilterInput = {
  and?: InputMaybe<Array<DeliveryScheduleDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationIds?: InputMaybe<ListStringOperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryScheduleDocumentFilterInput>>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<DeliveryScheduleStatusOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type DeliveryScheduleDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  friday?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  monday?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  saturday?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  sunday?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  thursday?: InputMaybe<SortEnumType>;
  tuesday?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  wednesday?: InputMaybe<SortEnumType>;
};

export type DeliverySchedulePayload = {
  __typename?: 'DeliverySchedulePayload';
  deliverySchedule?: Maybe<DeliveryScheduleStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type DeliveryScheduleStateData = {
  __typename?: 'DeliveryScheduleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryScheduleId: Scalars['String']['output'];
  friday: Scalars['Boolean']['output'];
  locationIds: Array<Scalars['String']['output']>;
  monday: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturday: Scalars['Boolean']['output'];
  status: DeliveryScheduleStatus;
  sunday: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export enum DeliveryScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type DeliveryScheduleStatusOperationFilterInput = {
  eq?: InputMaybe<DeliveryScheduleStatus>;
  in?: InputMaybe<Array<DeliveryScheduleStatus>>;
  neq?: InputMaybe<DeliveryScheduleStatus>;
  nin?: InputMaybe<Array<DeliveryScheduleStatus>>;
};

export enum DepositRequirementType {
  FlatAmount = 'FLAT_AMOUNT',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

/**
 * Why a price is what it is when it came from a WHOLE-GROUP derivation: "derived from
 * ReferencePriceGroupName at −PercentOff%".
 * DerivedPrice always equals the explanation's finalPrice (and therefore
 * itemPrice) — it is the number the engine charges, produced by the same resolution, not a
 * re-computation.
 */
export type DerivedPriceExplanation = {
  __typename?: 'DerivedPriceExplanation';
  /** The resulting charge price: ReferencePrice minus PercentOff percent. */
  derivedPrice: Scalars['Decimal']['output'];
  /** The percentage taken off the reference price, in percent-value form (4 = 4%). */
  percentOff: Scalars['Decimal']['output'];
  /** What the reference group itself resolved to for this item, before the percentage. */
  referencePrice: Scalars['Decimal']['output'];
  /** The price group this group derives from. */
  referencePriceGroupId: Scalars['String']['output'];
  /** Display name of the reference price group; empty when it could not be resolved. */
  referencePriceGroupName: Scalars['String']['output'];
  /**
   * Which level in the reference group produced ReferencePrice, or None when the
   * reference group itself priced through ITS own derivation (a chained derivation).
   */
  referenceWinningLevelId?: Maybe<Scalars['String']['output']>;
};

export type DestinationConfigData = {
  __typename?: 'DestinationConfigData';
  connectionString: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  schemaName: Scalars['String']['output'];
  scriptTimeout: Scalars['String']['output'];
  sqlAfterScript?: Maybe<Scalars['String']['output']>;
  sqlBeforeScript?: Maybe<Scalars['String']['output']>;
  sqlColumns: Array<SqlColumnMapData>;
  tableName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DestinationConfigDataFilterInput = {
  and?: InputMaybe<Array<DestinationConfigDataFilterInput>>;
  connectionString?: InputMaybe<StringOperationFilterInput>;
  destinationId?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DestinationConfigDataFilterInput>>;
  schemaName?: InputMaybe<StringOperationFilterInput>;
  scriptTimeout?: InputMaybe<StringOperationFilterInput>;
  sqlAfterScript?: InputMaybe<StringOperationFilterInput>;
  sqlBeforeScript?: InputMaybe<StringOperationFilterInput>;
  sqlColumns?: InputMaybe<ListFilterInputTypeOfSqlColumnMapDataFilterInput>;
  tableName?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type DestinationConfigDataInput = {
  connectionString: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  schemaName: Scalars['String']['input'];
  scriptTimeout: Scalars['String']['input'];
  sqlAfterScript?: InputMaybe<Scalars['String']['input']>;
  sqlBeforeScript?: InputMaybe<Scalars['String']['input']>;
  sqlColumns: Array<SqlColumnMapDataInput>;
  tableName: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum DimensionSource {
  CustomerOverride = 'CUSTOMER_OVERRIDE',
  CustomerSpaceTypeOverride = 'CUSTOMER_SPACE_TYPE_OVERRIDE',
  Default = 'DEFAULT',
  SiteAndCustomerOverride = 'SITE_AND_CUSTOMER_OVERRIDE',
  SiteCustomerSpaceTypeOverride = 'SITE_CUSTOMER_SPACE_TYPE_OVERRIDE',
  SiteOverride = 'SITE_OVERRIDE',
  SiteSpaceTypeOverride = 'SITE_SPACE_TYPE_OVERRIDE',
  SpaceTypeOverride = 'SPACE_TYPE_OVERRIDE'
}

export type DisableWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type DiscardFloatingTimeEntryInput = {
  floatingTimeEntryId: Scalars['String']['input'];
};

/**
 * GraphQL-output projection of a single (document type → render mode) pairing. Used both for the
 * tenant's explicitly-configured overrides and for the resolved-with-default effective set.
 */
export type DocumentRenderModeData = {
  __typename?: 'DocumentRenderModeData';
  docType: RenderDocType;
  mode: RenderMode;
};

export type DuplicatePriceGroupInput = {
  name: Scalars['String']['input'];
  newId: Scalars['String']['input'];
  originalId: Scalars['String']['input'];
};

export enum DynamicDefaultType {
  DateTime = 'DATE_TIME',
  Guid = 'GUID',
  NotSet = 'NOT_SET'
}

export type DynamicDefaultTypeOperationFilterInput = {
  eq?: InputMaybe<DynamicDefaultType>;
  in?: InputMaybe<Array<DynamicDefaultType>>;
  neq?: InputMaybe<DynamicDefaultType>;
  nin?: InputMaybe<Array<DynamicDefaultType>>;
};

export type DynamicDefaultUnitData = {
  __typename?: 'DynamicDefaultUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: DynamicDefaultType;
};

export type DynamicDefaultUnitDataFilterInput = {
  and?: InputMaybe<Array<DynamicDefaultUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DynamicDefaultUnitDataFilterInput>>;
  type?: InputMaybe<DynamicDefaultTypeOperationFilterInput>;
};

export type DynamicDefaultUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: DynamicDefaultType;
};

export type DynamicTransformUnitData = {
  __typename?: 'DynamicTransformUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: TransformType;
};

export type DynamicTransformUnitDataFilterInput = {
  and?: InputMaybe<Array<DynamicTransformUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DynamicTransformUnitDataFilterInput>>;
  type?: InputMaybe<TransformTypeOperationFilterInput>;
};

export type DynamicTransformUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: TransformType;
};

export type EditCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type EditMasterOrderInput = {
  customer: MasterOrderCustomerDataInput;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  type: OrderType;
};

export type EditOrderInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  customer: OrderCustomerDataInput;
  discountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit?: Scalars['Boolean']['input'];
  freightChargeReason?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  overrideTotal?: InputMaybe<Scalars['Decimal']['input']>;
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type EditPlanCellsInput = {
  edits: Array<PlanCellEditInput>;
  forecastId: Scalars['String']['input'];
};

export type EditScheduledLaborRateInput = {
  currentEffectiveFrom: Scalars['DateTime']['input'];
  laborTypeId: Scalars['String']['input'];
  newEffectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  newRatePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type EditScheduledOverheadRateInput = {
  currentEffectiveFrom: Scalars['DateTime']['input'];
  newCostPerSqFtPerWeek?: InputMaybe<Scalars['Decimal']['input']>;
  newEffectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type EditWeeklyCellsInput = {
  edits: Array<WeeklyCellEditInput>;
  forecastId: Scalars['String']['input'];
};

/**
 * Which tier of the live order-note inheritance chain produced an order's effective note for a
 * given NoteContext. Surfaced alongside the resolved text so the UI can label where
 * the note came from (e.g. "inherited from customer").
 */
export enum EffectiveNoteSource {
  /** The customer supplies the note for this context (tier 3). */
  Customer = 'CUSTOMER',
  /** The order's ship-to customer location supplies the note for this context (tier 2). */
  Location = 'LOCATION',
  /** No note is set on any tier for this context. */
  None = 'NONE',
  /** The order carries its own override note for this context (tier 1). */
  Order = 'ORDER'
}

/**
 * An order's effective typed note for one NoteContext, resolved by live inheritance
 * (order override → ship-to location → customer) at read time. Text is null
 * when Source is None; otherwise it is the resolving
 * tier's current note body. One entry is always returned per context so the consumer never has to
 * reason about absence by missing key.
 */
export type EffectiveOrderNote = {
  __typename?: 'EffectiveOrderNote';
  context: NoteContext;
  source: EffectiveNoteSource;
  text?: Maybe<Scalars['String']['output']>;
};

export type EmailAddressData = {
  __typename?: 'EmailAddressData';
  type: EmailAddressType;
  value: Scalars['String']['output'];
};

export type EmailAddressDataFilterInput = {
  and?: InputMaybe<Array<EmailAddressDataFilterInput>>;
  or?: InputMaybe<Array<EmailAddressDataFilterInput>>;
  type?: InputMaybe<EmailAddressTypeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type EmailAddressDataInput = {
  type: EmailAddressType;
  value: Scalars['String']['input'];
};

export enum EmailAddressType {
  Home = 'HOME',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Work = 'WORK'
}

export type EmailAddressTypeOperationFilterInput = {
  eq?: InputMaybe<EmailAddressType>;
  in?: InputMaybe<Array<EmailAddressType>>;
  neq?: InputMaybe<EmailAddressType>;
  nin?: InputMaybe<Array<EmailAddressType>>;
};

/** GraphQL data transfer object for a recorded email-delivery ledger. */
export type EmailDeliveryData = {
  __typename?: 'EmailDeliveryData';
  deliveries: Array<EmailDeliveryEntryData>;
  sendGridMessageId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** GraphQL data transfer object for a single delivery event. */
export type EmailDeliveryEntryData = {
  __typename?: 'EmailDeliveryEntryData';
  bounceClassification?: Maybe<Scalars['String']['output']>;
  bounceType?: Maybe<Scalars['String']['output']>;
  eventType: EmailDeliveryEventType;
  occurredAt: Scalars['DateTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  sgEventId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

export enum EmailDeliveryEventType {
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Opened = 'OPENED',
  SpamReport = 'SPAM_REPORT'
}

/** Payload returned from the record-email-delivery mutation. */
export type EmailDeliveryPayload = {
  __typename?: 'EmailDeliveryPayload';
  emailDelivery?: Maybe<EmailDeliveryData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum EmailDeliveryStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Failed = 'FAILED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  Pending = 'PENDING',
  SpamReport = 'SPAM_REPORT'
}

export type EmailDeliveryStatusOperationFilterInput = {
  eq?: InputMaybe<EmailDeliveryStatus>;
  in?: InputMaybe<Array<EmailDeliveryStatus>>;
  neq?: InputMaybe<EmailDeliveryStatus>;
  nin?: InputMaybe<Array<EmailDeliveryStatus>>;
};

/**
 * Recognized DMARC enforcement policies, parsed from a domain's _dmarc TXT record p=
 * tag. None here is the DMARC record's own monitor-only policy value — distinct from the
 * domain simply having no DMARC record at all, which the dmarcPolicy field represents as
 * null (a missing field over the wire).
 */
export enum EmailDmarcPolicy {
  /** DMARC p=none — monitor only, no enforcement on a failing message. */
  None = 'NONE',
  /** DMARC p=quarantine — a failing message is delivered to spam/junk. */
  Quarantine = 'QUARANTINE',
  /** DMARC p=reject — a failing message is rejected outright. */
  Reject = 'REJECT'
}

export enum EmailDomainOrigin {
  Created = 'CREATED',
  Grandfathered = 'GRANDFATHERED'
}

export enum EmailRecipientDeliveryStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Opened = 'OPENED',
  Pending = 'PENDING',
  SpamReport = 'SPAM_REPORT'
}

export enum EmailRecipientKind {
  Cc = 'CC',
  To = 'TO'
}

export type EmailRecipientKindOperationFilterInput = {
  eq?: InputMaybe<EmailRecipientKind>;
  in?: InputMaybe<Array<EmailRecipientKind>>;
  neq?: InputMaybe<EmailRecipientKind>;
  nin?: InputMaybe<Array<EmailRecipientKind>>;
};

export enum EmailRecipientSendStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

export type EmailRecipientSendStatusOperationFilterInput = {
  eq?: InputMaybe<EmailRecipientSendStatus>;
  in?: InputMaybe<Array<EmailRecipientSendStatus>>;
  neq?: InputMaybe<EmailRecipientSendStatus>;
  nin?: InputMaybe<Array<EmailRecipientSendStatus>>;
};

/** GraphQL data transfer object for a recorded email send. */
export type EmailSendData = {
  __typename?: 'EmailSendData';
  channel?: Maybe<EmailSenderChannel>;
  deliveryStatus: EmailDeliveryStatus;
  docType?: Maybe<Scalars['String']['output']>;
  emailSendId: Scalars['String']['output'];
  fromEmail: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  pdfSizeBytes?: Maybe<Scalars['Long']['output']>;
  recipients: Array<EmailSendRecipientData>;
  reportId?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  sendGridMessageId?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  sentBy: Scalars['String']['output'];
  source: EmailSendSource;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocument = {
  __typename?: 'EmailSendDocument';
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: Maybe<EmailSenderChannel>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus: EmailDeliveryStatus;
  /** Gets the document type, when order-driven. */
  docType?: Maybe<Scalars['String']['output']>;
  /** Gets the unique email-send identifier. */
  emailSendId: Scalars['String']['output'];
  /** Gets the sender email address. */
  fromEmail: Scalars['String']['output'];
  /** Gets the sender display name. */
  fromName?: Maybe<Scalars['String']['output']>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient: Scalars['Boolean']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets the order identifier, when order-driven. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the order number, when order-driven. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: Maybe<Scalars['Long']['output']>;
  /** Gets the recipients addressed by this send. */
  recipients: Array<EmailSendRecipientDocument>;
  /** Gets the report identifier, when report-driven. */
  reportId?: Maybe<Scalars['String']['output']>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp when the send occurred. */
  sentAt: Scalars['DateTime']['output'];
  /** Gets the user or worker that performed the send. */
  sentBy: Scalars['String']['output'];
  /** Gets the origin of the send. */
  source: EmailSendSource;
  /** Gets the email subject line. */
  subject: Scalars['String']['output'];
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocumentFilterInput = {
  and?: InputMaybe<Array<EmailSendDocumentFilterInput>>;
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: InputMaybe<NullableOfEmailSenderChannelOperationFilterInput>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus?: InputMaybe<EmailDeliveryStatusOperationFilterInput>;
  /** Gets the document type, when order-driven. */
  docType?: InputMaybe<StringOperationFilterInput>;
  /** Gets the unique email-send identifier. */
  emailSendId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the sender email address. */
  fromEmail?: InputMaybe<StringOperationFilterInput>;
  /** Gets the sender display name. */
  fromName?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailSendDocumentFilterInput>>;
  /** Gets the order identifier, when order-driven. */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the order number, when order-driven. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: InputMaybe<LongOperationFilterInput>;
  /** Gets the recipients addressed by this send. */
  recipients?: InputMaybe<ListFilterInputTypeOfEmailSendRecipientDocumentFilterInput>;
  /** Gets the report identifier, when report-driven. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the send occurred. */
  sentAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the user or worker that performed the send. */
  sentBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the origin of the send. */
  source?: InputMaybe<EmailSendSourceOperationFilterInput>;
  /** Gets the email subject line. */
  subject?: InputMaybe<StringOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocumentSortInput = {
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: InputMaybe<SortEnumType>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus?: InputMaybe<SortEnumType>;
  /** Gets the document type, when order-driven. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the unique email-send identifier. */
  emailSendId?: InputMaybe<SortEnumType>;
  /** Gets the sender email address. */
  fromEmail?: InputMaybe<SortEnumType>;
  /** Gets the sender display name. */
  fromName?: InputMaybe<SortEnumType>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the order identifier, when order-driven. */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the order number, when order-driven. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: InputMaybe<SortEnumType>;
  /** Gets the report identifier, when report-driven. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the send occurred. */
  sentAt?: InputMaybe<SortEnumType>;
  /** Gets the user or worker that performed the send. */
  sentBy?: InputMaybe<SortEnumType>;
  /** Gets the origin of the send. */
  source?: InputMaybe<SortEnumType>;
  /** Gets the email subject line. */
  subject?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** Payload returned from the record-email-send mutation. */
export type EmailSendPayload = {
  __typename?: 'EmailSendPayload';
  emailSend?: Maybe<EmailSendData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** GraphQL data transfer object for a single recipient of an email send. */
export type EmailSendRecipientData = {
  __typename?: 'EmailSendRecipientData';
  bounceClassification?: Maybe<Scalars['String']['output']>;
  deliveryReason?: Maybe<Scalars['String']['output']>;
  deliveryStatus: EmailRecipientDeliveryStatus;
  deliveryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  kind: EmailRecipientKind;
  sendErrorMessage?: Maybe<Scalars['String']['output']>;
  sendStatus: EmailRecipientSendStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** MongoDB sub-document for a single recipient of an email send. */
export type EmailSendRecipientDocument = {
  __typename?: 'EmailSendRecipientDocument';
  /** Gets SendGrid's human bounce category (bounce_classification, e.g. "Invalid Address"), when a hard failure. Persisted from the delivery rollup. */
  bounceClassification?: Maybe<Scalars['String']['output']>;
  /** Gets the delivery failure/deferral reason (SendGrid reason), when applicable. Persisted from the delivery rollup. */
  deliveryReason?: Maybe<Scalars['String']['output']>;
  /** Gets the per-recipient delivery status. Persisted from the EmailSendDeliveryRolledUp projection (default integer representation); defaults to Pending until the first correlated delivery event. */
  deliveryStatus: EmailRecipientDeliveryStatus;
  /** Gets the timestamp of the most recent delivery event for this recipient. Persisted from the delivery rollup. */
  deliveryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the recipient email address. */
  email: Scalars['String']['output'];
  /** Gets whether this recipient was on the To or Cc line. */
  kind: EmailRecipientKind;
  /** Gets the per-recipient send error message, when the send failed. */
  sendErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Gets the per-recipient send outcome recorded at send time. */
  sendStatus: EmailRecipientSendStatus;
  /** Gets the SMTP status code (SendGrid status, e.g. "5.1.1"), when a failure/deferral. Persisted from the delivery rollup. */
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** MongoDB sub-document for a single recipient of an email send. */
export type EmailSendRecipientDocumentFilterInput = {
  and?: InputMaybe<Array<EmailSendRecipientDocumentFilterInput>>;
  /** Gets the recipient email address. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether this recipient was on the To or Cc line. */
  kind?: InputMaybe<EmailRecipientKindOperationFilterInput>;
  or?: InputMaybe<Array<EmailSendRecipientDocumentFilterInput>>;
  /** Gets the per-recipient send error message, when the send failed. */
  sendErrorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Gets the per-recipient send outcome recorded at send time. */
  sendStatus?: InputMaybe<EmailRecipientSendStatusOperationFilterInput>;
};

export enum EmailSendSource {
  ManualReport = 'MANUAL_REPORT',
  OrderAcknowledgment = 'ORDER_ACKNOWLEDGMENT',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  PersonalAccount = 'PERSONAL_ACCOUNT',
  ScheduledReport = 'SCHEDULED_REPORT'
}

export type EmailSendSourceOperationFilterInput = {
  eq?: InputMaybe<EmailSendSource>;
  in?: InputMaybe<Array<EmailSendSource>>;
  neq?: InputMaybe<EmailSendSource>;
  nin?: InputMaybe<Array<EmailSendSource>>;
};

export enum EmailSenderChannel {
  M365 = 'M365',
  SendgridDomain = 'SENDGRID_DOMAIN',
  SendgridSingle = 'SENDGRID_SINGLE',
  Smtp = 'SMTP'
}

export enum EmailSenderVerificationMethod {
  Domain = 'DOMAIN',
  SingleSender = 'SINGLE_SENDER'
}

export type EmailSenderVerificationMethodOperationFilterInput = {
  eq?: InputMaybe<EmailSenderVerificationMethod>;
  in?: InputMaybe<Array<EmailSenderVerificationMethod>>;
  neq?: InputMaybe<EmailSenderVerificationMethod>;
  nin?: InputMaybe<Array<EmailSenderVerificationMethod>>;
};

export enum EmailSenderVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type EmailSenderVerificationStatusOperationFilterInput = {
  eq?: InputMaybe<EmailSenderVerificationStatus>;
  in?: InputMaybe<Array<EmailSenderVerificationStatus>>;
  neq?: InputMaybe<EmailSenderVerificationStatus>;
  nin?: InputMaybe<Array<EmailSenderVerificationStatus>>;
};

/** A connection to a list of items. */
export type EmailSendsConnection = {
  __typename?: 'EmailSendsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailSendsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailSendDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailSendsEdge = {
  __typename?: 'EmailSendsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailSendDocument;
};

/**
 * The four SendGrid suppression lists clearEmailSuppression can delete an address from, each
 * with its own DELETE endpoint. A recorded delivery dropped reason names the list an address
 * landed on (per the recorded drop-reason to list mapping); dropped itself stays as-is
 * (SendGrid never attempted the send — the reason names the list).
 */
export enum EmailSuppressionListType {
  /** The block suppression list (DELETE /v3/suppression/blocks/{email}) — temporary IP/reputation blocks ("Blocked"). */
  Blocks = 'BLOCKS',
  /** The bounce suppression list (DELETE /v3/suppression/bounces/{email}) — hard bounces ("Bounced Address"). */
  Bounces = 'BOUNCES',
  /** The spam-report suppression list (DELETE /v3/suppression/spam_reports/{email}) — "Spam Reporting Address". */
  SpamReports = 'SPAM_REPORTS',
  /** The global unsubscribe list (DELETE /v3/asm/suppressions/global/{email}) — "Unsubscribed Address". */
  Unsubscribes = 'UNSUBSCRIBES'
}

export type EnableWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

/**
 * GraphQL input for enqueueErpWriteBack. Primitive/non-Option fields only (HotChocolate input
 * type). The tenant is taken from the authenticated user context, never the input.
 */
export type EnqueueErpWriteBackInput = {
  changeReason: Scalars['String']['input'];
  changeType: Scalars['String']['input'];
  customerReference?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationReference: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  lotReference: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  routeLocationId?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
  unitQuantityChange?: InputMaybe<Scalars['Decimal']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
  variantReference: Scalars['String']['input'];
  workflow: ErpWriteBackWorkflow;
};

export type EntityCheckpointDocument = {
  __typename?: 'EntityCheckpointDocument';
  entityName: Scalars['String']['output'];
  position?: Maybe<Scalars['Long']['output']>;
  positionString?: Maybe<Scalars['String']['output']>;
};

export type EntityCheckpointDocumentFilterInput = {
  and?: InputMaybe<Array<EntityCheckpointDocumentFilterInput>>;
  entityName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EntityCheckpointDocumentFilterInput>>;
  position?: InputMaybe<LongOperationFilterInput>;
  positionString?: InputMaybe<StringOperationFilterInput>;
};

export type EntityCheckpointDocumentSortInput = {
  entityName?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  positionString?: InputMaybe<SortEnumType>;
};

export type EntityMappingData = {
  __typename?: 'EntityMappingData';
  enabled: Scalars['Boolean']['output'];
  entityMappingId: Scalars['String']['output'];
  entityType: WsapiImportEntityType;
  fieldMappings: Array<FieldMappingData>;
  keySourceField: Scalars['String']['output'];
  keyTargetField: Scalars['String']['output'];
  sourceTable: Scalars['String']['output'];
};

export type EntityMappingDataFilterInput = {
  and?: InputMaybe<Array<EntityMappingDataFilterInput>>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  entityMappingId?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<WsapiImportEntityTypeOperationFilterInput>;
  fieldMappings?: InputMaybe<ListFilterInputTypeOfFieldMappingDataFilterInput>;
  keySourceField?: InputMaybe<StringOperationFilterInput>;
  keyTargetField?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EntityMappingDataFilterInput>>;
  sourceTable?: InputMaybe<StringOperationFilterInput>;
};

export enum EntityType {
  ClickUpTimeAggregation = 'CLICK_UP_TIME_AGGREGATION',
  ConfirmationEmail = 'CONFIRMATION_EMAIL',
  Customer = 'CUSTOMER',
  CustomerCleaner = 'CUSTOMER_CLEANER',
  DbrCalcDemandQuantity = 'DBR_CALC_DEMAND_QUANTITY',
  DbrCalcScheduler = 'DBR_CALC_SCHEDULER',
  GrowPointCategoryImport = 'GROW_POINT_CATEGORY_IMPORT',
  GrowPointCategoryValidate = 'GROW_POINT_CATEGORY_VALIDATE',
  GrowPointCustomerExtract = 'GROW_POINT_CUSTOMER_EXTRACT',
  GrowPointCustomerImport = 'GROW_POINT_CUSTOMER_IMPORT',
  GrowPointCustomerValidate = 'GROW_POINT_CUSTOMER_VALIDATE',
  GrowPointHistoricalOrderImport = 'GROW_POINT_HISTORICAL_ORDER_IMPORT',
  GrowPointHistoricalOrderValidate = 'GROW_POINT_HISTORICAL_ORDER_VALIDATE',
  GrowPointImport = 'GROW_POINT_IMPORT',
  GrowPointInventoryImport = 'GROW_POINT_INVENTORY_IMPORT',
  GrowPointInventoryValidate = 'GROW_POINT_INVENTORY_VALIDATE',
  GrowPointItemExtract = 'GROW_POINT_ITEM_EXTRACT',
  GrowPointItemImport = 'GROW_POINT_ITEM_IMPORT',
  GrowPointPriceImport = 'GROW_POINT_PRICE_IMPORT',
  GrowPointPriceValidate = 'GROW_POINT_PRICE_VALIDATE',
  GrowPointSiteLocationImport = 'GROW_POINT_SITE_LOCATION_IMPORT',
  GrowPointSiteLocationValidate = 'GROW_POINT_SITE_LOCATION_VALIDATE',
  GrowPointTaxAuthorityImport = 'GROW_POINT_TAX_AUTHORITY_IMPORT',
  GrowPointTaxAuthorityValidate = 'GROW_POINT_TAX_AUTHORITY_VALIDATE',
  GrowPointTermsImport = 'GROW_POINT_TERMS_IMPORT',
  GrowPointTermsValidate = 'GROW_POINT_TERMS_VALIDATE',
  Item = 'ITEM',
  ItemCleaner = 'ITEM_CLEANER',
  ItemPricing = 'ITEM_PRICING',
  IterationFailureEmail = 'ITERATION_FAILURE_EMAIL',
  Job = 'JOB',
  Location = 'LOCATION',
  MergeDevImport = 'MERGE_DEV_IMPORT',
  OnHandProcessing = 'ON_HAND_PROCESSING',
  OnHandQueuing = 'ON_HAND_QUEUING',
  Order = 'ORDER',
  QuickBooks = 'QUICK_BOOKS',
  /**
   * The Restock 2.0 ROS pre-calculation iteration written per-tenant by the
   * RestockPreCalculation background service (wsapi-services). Read by the
   * adminRestockDataValidity precalc.lastrun check; the stored Entity string is
   * "RestockPreCalculation".
   */
  RestockPreCalculation = 'RESTOCK_PRE_CALCULATION',
  SalesPeople = 'SALES_PEOPLE',
  SftpSynchronization = 'SFTP_SYNCHRONIZATION',
  StationManager = 'STATION_MANAGER',
  TransferLine = 'TRANSFER_LINE',
  Unknown = 'UNKNOWN',
  WalmartOpdZero = 'WALMART_OPD_ZERO'
}

export type EntityTypeOperationFilterInput = {
  eq?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  neq?: InputMaybe<EntityType>;
  nin?: InputMaybe<Array<EntityType>>;
};

/** A connection to a list of items. */
export type ErpAvailabilityConnection = {
  __typename?: 'ErpAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpAvailabilityDocument = {
  __typename?: 'ErpAvailabilityDocument';
  id: Scalars['String']['output'];
  itemNo: Scalars['String']['output'];
  mustGoQty: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  syncDateTime: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

export type ErpAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ErpAvailabilityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemNo?: InputMaybe<StringOperationFilterInput>;
  mustGoQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpAvailabilityDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  syncDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ErpAvailabilityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  itemNo?: InputMaybe<SortEnumType>;
  mustGoQty?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  syncDateTime?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpAvailabilityEdge = {
  __typename?: 'ErpAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpAvailabilityDocument;
};

export type ErpAvailabilityItem = {
  __typename?: 'ErpAvailabilityItem';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  inTransitQty: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQty: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpAvailabilityRefreshItem = {
  __typename?: 'ErpAvailabilityRefreshItem';
  erpItemId: Scalars['String']['output'];
  inTransitQty: Scalars['Int']['output'];
  mustGoQty: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpItemPriceData = {
  __typename?: 'ErpItemPriceData';
  containerQuantity: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  erpItemId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type ErpItemPricingDocument = {
  __typename?: 'ErpItemPricingDocument';
  containerQuantity: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  erpItemId: Scalars['String']['output'];
  erpItemPricingId: Scalars['String']['output'];
  erpPriceGroupId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type ErpItemPricingDocumentFilterInput = {
  and?: InputMaybe<Array<ErpItemPricingDocumentFilterInput>>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  erpItemPricingId?: InputMaybe<StringOperationFilterInput>;
  erpPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpItemPricingDocumentFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type ErpItemPricingDocumentSortInput = {
  containerQuantity?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  erpItemPricingId?: InputMaybe<SortEnumType>;
  erpPriceGroupId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
};

export type ErpItemPricingPayload = {
  __typename?: 'ErpItemPricingPayload';
  erpItemPrice?: Maybe<ErpItemPricingStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpItemPricingStateData = {
  __typename?: 'ErpItemPricingStateData';
  erpPriceGroupId: Scalars['String']['output'];
  itemPrices: Array<ErpItemPriceData>;
  startYear: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ErpLoadListAvailabilityConnection = {
  __typename?: 'ErpLoadListAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpLoadListAvailabilityDocument = {
  __typename?: 'ErpLoadListAvailabilityDocument';
  allocatedQuantity: Scalars['Int']['output'];
  availableQuantity: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inTransitQuantity: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQuantity: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpLoadListAvailabilityDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<ErpLoadListAvailabilityDocumentFilterInput>>;
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inTransitQuantity?: InputMaybe<IntOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  mustGoQuantity?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListAvailabilityDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListAvailabilityDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  availableQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inTransitQuantity?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  mustGoQuantity?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpLoadListAvailabilityEdge = {
  __typename?: 'ErpLoadListAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListAvailabilityDocument;
};

export type ErpLoadListItemData = {
  __typename?: 'ErpLoadListItemData';
  allocatedQuantity: Scalars['Int']['output'];
  availableQuantity: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  inTransitQuantity: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQuantity: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ErpLoadListQuantitiesConnection = {
  __typename?: 'ErpLoadListQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListQuantitiesDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpLoadListQuantitiesDocument = {
  __typename?: 'ErpLoadListQuantitiesDocument';
  containerCode: Scalars['String']['output'];
  containerUtilization: Scalars['Decimal']['output'];
  erpItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  routeCode: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListQuantitiesDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListQuantitiesDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  containerUtilization?: InputMaybe<DecimalOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListQuantitiesDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListQuantitiesDocumentSortInput = {
  containerCode?: InputMaybe<SortEnumType>;
  containerUtilization?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  routeCode?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpLoadListQuantitiesEdge = {
  __typename?: 'ErpLoadListQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListQuantitiesDocument;
};

export type ErpLoadListQuantityData = {
  __typename?: 'ErpLoadListQuantityData';
  containerCode: Scalars['String']['output'];
  containerUtilization: Scalars['Decimal']['output'];
  erpItemId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  routeCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListRouteData = {
  __typename?: 'ErpLoadListRouteData';
  routeCode: Scalars['String']['output'];
};

export type ErpLoadListRouteDataFilterInput = {
  and?: InputMaybe<Array<ErpLoadListRouteDataFilterInput>>;
  or?: InputMaybe<Array<ErpLoadListRouteDataFilterInput>>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListRouteDocument = {
  __typename?: 'ErpLoadListRouteDocument';
  id: Scalars['String']['output'];
  routeCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ErpLoadListRouteDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListRouteDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListRouteDocumentFilterInput>>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListRouteDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  routeCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ErpLoadListRoutesConnection = {
  __typename?: 'ErpLoadListRoutesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListRoutesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListRouteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListRoutesEdge = {
  __typename?: 'ErpLoadListRoutesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListRouteDocument;
};

export type ErpLoadListRoutesPayload = {
  __typename?: 'ErpLoadListRoutesPayload';
  errors?: Maybe<Array<ValidationError>>;
  routesReplaced: Scalars['Int']['output'];
};

export type ErpLoadListSessionDocument = {
  __typename?: 'ErpLoadListSessionDocument';
  availabilityUpdatedAt: Scalars['DateTime']['output'];
  availabilityUpdatedBy: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  routes: Array<ErpLoadListRouteData>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  stationCode: Scalars['String']['output'];
  status: ErpLoadListSessionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ErpLoadListSessionDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListSessionDocumentFilterInput>>;
  availabilityUpdatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  availabilityUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListSessionDocumentFilterInput>>;
  routes?: InputMaybe<ListFilterInputTypeOfErpLoadListRouteDataFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  sessionName?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ErpLoadListSessionStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListSessionDocumentSortInput = {
  availabilityUpdatedAt?: InputMaybe<SortEnumType>;
  availabilityUpdatedBy?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  sessionName?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ErpLoadListSessionPayload = {
  __typename?: 'ErpLoadListSessionPayload';
  erpLoadListSession?: Maybe<ErpLoadListSessionStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpLoadListSessionStateData = {
  __typename?: 'ErpLoadListSessionStateData';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  items: Array<ErpLoadListItemData>;
  quantities: Array<ErpLoadListQuantityData>;
  routes: Array<ErpLoadListRouteData>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  stationCode: Scalars['String']['output'];
  status: ErpLoadListSessionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ErpLoadListSessionStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
  Processed = 'PROCESSED',
  Submitted = 'SUBMITTED'
}

export type ErpLoadListSessionStatusOperationFilterInput = {
  eq?: InputMaybe<ErpLoadListSessionStatus>;
  in?: InputMaybe<Array<ErpLoadListSessionStatus>>;
  neq?: InputMaybe<ErpLoadListSessionStatus>;
  nin?: InputMaybe<Array<ErpLoadListSessionStatus>>;
};

/** A connection to a list of items. */
export type ErpLoadListSessionsConnection = {
  __typename?: 'ErpLoadListSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListSessionsEdge = {
  __typename?: 'ErpLoadListSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListSessionDocument;
};

export type ErpLoadListUserDocument = {
  __typename?: 'ErpLoadListUserDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  erpLoadListUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  site: Scalars['String']['output'];
  status: ErpLoadListUserStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListUserDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListUserDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  erpLoadListUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListUserDocumentFilterInput>>;
  site?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ErpLoadListUserStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListUserDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  erpLoadListUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ErpLoadListUserPayload = {
  __typename?: 'ErpLoadListUserPayload';
  erpLoadListUser?: Maybe<ErpLoadListUserStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpLoadListUserStateData = {
  __typename?: 'ErpLoadListUserStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  erpLoadListUserId: Scalars['String']['output'];
  sites: Array<Scalars['String']['output']>;
  status: ErpLoadListUserStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ErpLoadListUserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Unknown = 'UNKNOWN'
}

export type ErpLoadListUserStatusOperationFilterInput = {
  eq?: InputMaybe<ErpLoadListUserStatus>;
  in?: InputMaybe<Array<ErpLoadListUserStatus>>;
  neq?: InputMaybe<ErpLoadListUserStatus>;
  nin?: InputMaybe<Array<ErpLoadListUserStatus>>;
};

/** A connection to a list of items. */
export type ErpLoadListUsersConnection = {
  __typename?: 'ErpLoadListUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListUserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListUsersEdge = {
  __typename?: 'ErpLoadListUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListUserDocument;
};

export type ErpManagerEmailData = {
  __typename?: 'ErpManagerEmailData';
  email: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ErpManagerEmailDataInput = {
  email: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ErpManagerEmailsPayload = {
  __typename?: 'ErpManagerEmailsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ErpManagerEmailsStateData>;
};

export type ErpManagerEmailsStateData = {
  __typename?: 'ErpManagerEmailsStateData';
  emails: Array<ErpManagerEmailData>;
  tenantId: Scalars['String']['output'];
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. The
 * receipt mutation applies an OPTIMISTIC decrement to a line's OutstandingQuantity
 * so the PWA reflects a receipt immediately; the next Nav sync reconciles any drift and
 * reconciliation always wins.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocument = {
  __typename?: 'ErpOrderDocument';
  /** Free-text order description (Nav posting description, or a sensible default). */
  description: Scalars['String']['output'];
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: Maybe<Scalars['String']['output']>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The outstanding lines on this order. Every item-bearing Nav line is retained (see class summary). */
  lines: Array<ErpOrderLine>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId: Scalars['String']['output'];
  /** Nav order date when present; null otherwise. */
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber: Scalars['String']['output'];
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType: ErpOrderType;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode: Scalars['String']['output'];
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime: Scalars['DateTime']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: Maybe<Scalars['String']['output']>;
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. The
 * receipt mutation applies an OPTIMISTIC decrement to a line's OutstandingQuantity
 * so the PWA reflects a receipt immediately; the next Nav sync reconciles any drift and
 * reconciliation always wins.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocumentFilterInput = {
  and?: InputMaybe<Array<ErpOrderDocumentFilterInput>>;
  /** Free-text order description (Nav posting description, or a sensible default). */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: InputMaybe<StringOperationFilterInput>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The outstanding lines on this order. Every item-bearing Nav line is retained (see class summary). */
  lines?: InputMaybe<ListFilterInputTypeOfErpOrderLineFilterInput>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpOrderDocumentFilterInput>>;
  /** Nav order date when present; null otherwise. */
  orderDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<ErpOrderTypeOperationFilterInput>;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode?: InputMaybe<StringOperationFilterInput>;
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: InputMaybe<StringOperationFilterInput>;
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. The
 * receipt mutation applies an OPTIMISTIC decrement to a line's OutstandingQuantity
 * so the PWA reflects a receipt immediately; the next Nav sync reconciles any drift and
 * reconciliation always wins.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocumentSortInput = {
  /** Free-text order description (Nav posting description, or a sensible default). */
  description?: InputMaybe<SortEnumType>;
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: InputMaybe<SortEnumType>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: InputMaybe<SortEnumType>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId?: InputMaybe<SortEnumType>;
  /** Nav order date when present; null otherwise. */
  orderDate?: InputMaybe<SortEnumType>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<SortEnumType>;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode?: InputMaybe<SortEnumType>;
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: InputMaybe<SortEnumType>;
};

/**
 * One outstanding line on an ErpOrderDocument — the wsapi read-side mirror of the
 * worker's ErpOrderLine. Every item-bearing Nav line is embedded, whether or not its ERP item
 * resolves to a canonical wsapi ItemId (see ItemId and the two-tier resolution
 * note on ErpOrderDocument). Query OUTPUT only — optional fields use plain T?.
 */
export type ErpOrderLine = {
  __typename?: 'ErpOrderLine';
  /** Receiving bin code when present (PO bin / transfer-to bin); null otherwise. */
  binCode?: Maybe<Scalars['String']['output']>;
  /** Line description from Nav. */
  description: Scalars['String']['output'];
  /** Raw Nav item number. */
  erpItemNo: Scalars['String']['output'];
  /**
   * The canonical wsapi ItemId when ErpItemNo resolves to a finished good
   * present in ItemSummary; otherwise the raw Nav item number is passed through unchanged (material
   * items, and any item the worker cannot resolve to a wsapi id) — an audit passthrough only. NAV
   * write-back and validation always key on ErpItemNo, never on this field.
   */
  itemId: Scalars['String']['output'];
  /** Nav Line No_ — unique within the order. */
  lineNo: Scalars['Int']['output'];
  /**
   * Outstanding quantity still to be received against this line. The receipt mutation applies an
   * OPTIMISTIC decrement here; the next Nav sync reconciles.
   */
  outstandingQuantity: Scalars['Decimal']['output'];
  /** Nav unit-of-measure code when present; null otherwise. */
  unitOfMeasureCode?: Maybe<Scalars['String']['output']>;
  /** Nav variant code when present; null otherwise. */
  variantCode?: Maybe<Scalars['String']['output']>;
  /** Vendor lot number when present (transfer lines carry Lot No_); null otherwise. */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * One outstanding line on an ErpOrderDocument — the wsapi read-side mirror of the
 * worker's ErpOrderLine. Every item-bearing Nav line is embedded, whether or not its ERP item
 * resolves to a canonical wsapi ItemId (see ItemId and the two-tier resolution
 * note on ErpOrderDocument). Query OUTPUT only — optional fields use plain T?.
 */
export type ErpOrderLineFilterInput = {
  and?: InputMaybe<Array<ErpOrderLineFilterInput>>;
  /** Receiving bin code when present (PO bin / transfer-to bin); null otherwise. */
  binCode?: InputMaybe<StringOperationFilterInput>;
  /** Line description from Nav. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Raw Nav item number. */
  erpItemNo?: InputMaybe<StringOperationFilterInput>;
  /**
   * The canonical wsapi ItemId when ErpItemNo resolves to a finished good
   * present in ItemSummary; otherwise the raw Nav item number is passed through unchanged (material
   * items, and any item the worker cannot resolve to a wsapi id) — an audit passthrough only. NAV
   * write-back and validation always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Nav Line No_ — unique within the order. */
  lineNo?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpOrderLineFilterInput>>;
  /**
   * Outstanding quantity still to be received against this line. The receipt mutation applies an
   * OPTIMISTIC decrement here; the next Nav sync reconciles.
   */
  outstandingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Nav unit-of-measure code when present; null otherwise. */
  unitOfMeasureCode?: InputMaybe<StringOperationFilterInput>;
  /** Nav variant code when present; null otherwise. */
  variantCode?: InputMaybe<StringOperationFilterInput>;
  /** Vendor lot number when present (transfer lines carry Lot No_); null otherwise. */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Type of imported inbound order — the wsapi read-side mirror of the worker's ErpOrderType.
 * Persisted as a BSON string so the material-order GraphQL layer (and operators) can filter on the
 * value directly. Outbound (ship) transfer orders are deliberately NOT a member — they are a dead
 * workflow the import worker never imports.
 */
export enum ErpOrderType {
  /** An inbound Nav transfer order — shipped but not yet completely received at this station. */
  InboundTransferOrder = 'INBOUND_TRANSFER_ORDER',
  /** An open Nav purchase order. */
  PurchaseOrder = 'PURCHASE_ORDER'
}

export type ErpOrderTypeOperationFilterInput = {
  eq?: InputMaybe<ErpOrderType>;
  in?: InputMaybe<Array<ErpOrderType>>;
  neq?: InputMaybe<ErpOrderType>;
  nin?: InputMaybe<Array<ErpOrderType>>;
};

/**
 * Payload for the worker batch-claim mutation — the set of records this worker leased in the call.
 * An empty list means there was no pending work for the workflow/tenant.
 */
export type ErpWriteBackClaimPayload = {
  __typename?: 'ErpWriteBackClaimPayload';
  claimedRecords: Array<ErpWriteBackDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocument = {
  __typename?: 'ErpWriteBackDocument';
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason: Scalars['String']['output'];
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType: Scalars['String']['output'];
  /**
   * Opaque claim token a worker writes when it leases the record for processing; null when the
   * record is not currently claimed. A concurrent worker's claim filter only picks up a record whose
   * claimedAt is null or older than the claim lease TTL (30 minutes),
   * so a live claim is never double-processed; an abandoned one (worker crash) is reclaimed with a
   * fresh token instead of being stranded forever.
   */
  claimToken?: Maybe<Scalars['String']['output']>;
  /**
   * When the current claim was taken; null when not currently claimed. A claim older than
   * the claim lease TTL (30 minutes) is treated as abandoned and becomes
   * claimable again by claimPendingErpWriteBacks.
   */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the record was enqueued. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference: Scalars['String']['output'];
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId: Scalars['String']['output'];
  /** The worker error text when Status is Failed; null otherwise. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference: Scalars['String']['output'];
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude: Scalars['Float']['output'];
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference: Scalars['String']['output'];
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude: Scalars['Float']['output'];
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference: Scalars['String']['output'];
  /** When the record reached a terminal status (Processed or Failed); null while Pending. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The signed quantity delta to post to Nav. */
  quantityChange: Scalars['Decimal']['output'];
  /** Number of times a worker has attempted to post this record to Nav. */
  retryCount: Scalars['Int']['output'];
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId: Scalars['String']['output'];
  /** Lifecycle status — Pending until a worker posts it, then Processed or Failed. */
  status: ErpWriteBackStatus;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange: Scalars['Decimal']['output'];
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc: Scalars['String']['output'];
  /** The user (email) who originated the change in the PWA. */
  user: Scalars['String']['output'];
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference: Scalars['String']['output'];
  /** The BPF business solution that produced this record (Finish / Material / Retail). */
  workflow: ErpWriteBackWorkflow;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocumentFilterInput = {
  and?: InputMaybe<Array<ErpWriteBackDocumentFilterInput>>;
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason?: InputMaybe<StringOperationFilterInput>;
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType?: InputMaybe<StringOperationFilterInput>;
  /**
   * Opaque claim token a worker writes when it leases the record for processing; null when the
   * record is not currently claimed. A concurrent worker's claim filter only picks up a record whose
   * claimedAt is null or older than the claim lease TTL (30 minutes),
   * so a live claim is never double-processed; an abandoned one (worker crash) is reclaimed with a
   * fresh token instead of being stranded forever.
   */
  claimToken?: InputMaybe<StringOperationFilterInput>;
  /**
   * When the current claim was taken; null when not currently claimed. A claim older than
   * the claim lease TTL (30 minutes) is treated as abandoned and becomes
   * claimable again by claimPendingErpWriteBacks.
   */
  claimedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When the record was enqueued. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference?: InputMaybe<StringOperationFilterInput>;
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** The worker error text when Status is Failed; null otherwise. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference?: InputMaybe<StringOperationFilterInput>;
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpWriteBackDocumentFilterInput>>;
  /** When the record reached a terminal status (Processed or Failed); null while Pending. */
  processedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The signed quantity delta to post to Nav. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** Number of times a worker has attempted to post this record to Nav. */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Lifecycle status — Pending until a worker posts it, then Processed or Failed. */
  status?: InputMaybe<ErpWriteBackStatusOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc?: InputMaybe<StringOperationFilterInput>;
  /** The user (email) who originated the change in the PWA. */
  user?: InputMaybe<StringOperationFilterInput>;
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
  /** The BPF business solution that produced this record (Finish / Material / Retail). */
  workflow?: InputMaybe<ErpWriteBackWorkflowOperationFilterInput>;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocumentSortInput = {
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason?: InputMaybe<SortEnumType>;
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType?: InputMaybe<SortEnumType>;
  /**
   * Opaque claim token a worker writes when it leases the record for processing; null when the
   * record is not currently claimed. A concurrent worker's claim filter only picks up a record whose
   * claimedAt is null or older than the claim lease TTL (30 minutes),
   * so a live claim is never double-processed; an abandoned one (worker crash) is reclaimed with a
   * fresh token instead of being stranded forever.
   */
  claimToken?: InputMaybe<SortEnumType>;
  /**
   * When the current claim was taken; null when not currently claimed. A claim older than
   * the claim lease TTL (30 minutes) is treated as abandoned and becomes
   * claimable again by claimPendingErpWriteBacks.
   */
  claimedAt?: InputMaybe<SortEnumType>;
  /** When the record was enqueued. */
  createdAt?: InputMaybe<SortEnumType>;
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference?: InputMaybe<SortEnumType>;
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** The worker error text when Status is Failed; null otherwise. */
  errorMessage?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference?: InputMaybe<SortEnumType>;
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude?: InputMaybe<SortEnumType>;
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference?: InputMaybe<SortEnumType>;
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude?: InputMaybe<SortEnumType>;
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference?: InputMaybe<SortEnumType>;
  /** When the record reached a terminal status (Processed or Failed); null while Pending. */
  processedAt?: InputMaybe<SortEnumType>;
  /** The signed quantity delta to post to Nav. */
  quantityChange?: InputMaybe<SortEnumType>;
  /** Number of times a worker has attempted to post this record to Nav. */
  retryCount?: InputMaybe<SortEnumType>;
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId?: InputMaybe<SortEnumType>;
  /** Lifecycle status — Pending until a worker posts it, then Processed or Failed. */
  status?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange?: InputMaybe<SortEnumType>;
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc?: InputMaybe<SortEnumType>;
  /** The user (email) who originated the change in the PWA. */
  user?: InputMaybe<SortEnumType>;
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
  /** The BPF business solution that produced this record (Finish / Material / Retail). */
  workflow?: InputMaybe<SortEnumType>;
};

/**
 * Standard single-record payload for the ERP write-back mutations (enqueue / markProcessed /
 * markFailed). Carries the affected record on success, or the validation error(s) on failure.
 */
export type ErpWriteBackPayload = {
  __typename?: 'ErpWriteBackPayload';
  erpWriteBack?: Maybe<ErpWriteBackDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type ErpWriteBackQueueConnection = {
  __typename?: 'ErpWriteBackQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpWriteBackQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpWriteBackDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpWriteBackQueueEdge = {
  __typename?: 'ErpWriteBackQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpWriteBackDocument;
};

export enum ErpWriteBackStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Unknown = 'UNKNOWN'
}

export type ErpWriteBackStatusOperationFilterInput = {
  eq?: InputMaybe<ErpWriteBackStatus>;
  in?: InputMaybe<Array<ErpWriteBackStatus>>;
  neq?: InputMaybe<ErpWriteBackStatus>;
  nin?: InputMaybe<Array<ErpWriteBackStatus>>;
};

export enum ErpWriteBackWorkflow {
  Finish = 'FINISH',
  Material = 'MATERIAL',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type ErpWriteBackWorkflowOperationFilterInput = {
  eq?: InputMaybe<ErpWriteBackWorkflow>;
  in?: InputMaybe<Array<ErpWriteBackWorkflow>>;
  neq?: InputMaybe<ErpWriteBackWorkflow>;
  nin?: InputMaybe<Array<ErpWriteBackWorkflow>>;
};

export type EventAssignmentOverrideData = {
  __typename?: 'EventAssignmentOverrideData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type EventAssignmentOverrideDataInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};

export type EventAssignmentOverrideDocument = {
  __typename?: 'EventAssignmentOverrideDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type EventAssignmentOverrideDocumentFilterInput = {
  and?: InputMaybe<Array<EventAssignmentOverrideDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventAssignmentOverrideDocumentFilterInput>>;
};

export enum EventChangeKind {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type EventCountDocument = {
  __typename?: 'EventCountDocument';
  count: Scalars['Long']['output'];
  eventName: Scalars['String']['output'];
};

export type EventCountDocumentFilterInput = {
  and?: InputMaybe<Array<EventCountDocumentFilterInput>>;
  count?: InputMaybe<LongOperationFilterInput>;
  eventName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventCountDocumentFilterInput>>;
};

export type EventCountDocumentSortInput = {
  count?: InputMaybe<SortEnumType>;
  eventName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EventCountsConnection = {
  __typename?: 'EventCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventCountsEdge = {
  __typename?: 'EventCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventCountDocument;
};

export type EventIdChangeProjection = {
  __typename?: 'EventIdChangeProjection';
  eventId: Scalars['String']['output'];
  eventListName: Scalars['String']['output'];
  expectedEventFingerprint?: Maybe<Scalars['String']['output']>;
  hasExistingOverride: Scalars['Boolean']['output'];
  kind: EventChangeKind;
};

export type EventRecordData = {
  __typename?: 'EventRecordData';
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventNumber: Scalars['Long']['output'];
  eventStreamId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  position: PositionData;
};

export type EventStreamAggregateDocument = {
  __typename?: 'EventStreamAggregateDocument';
  checkpointPosition?: Maybe<Scalars['Long']['output']>;
  ended?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  started: Scalars['DateTime']['output'];
};

export type EventStreamAggregateDocumentFilterInput = {
  and?: InputMaybe<Array<EventStreamAggregateDocumentFilterInput>>;
  checkpointPosition?: InputMaybe<LongOperationFilterInput>;
  ended?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventStreamAggregateDocumentFilterInput>>;
  started?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventStreamAggregateDocumentSortInput = {
  checkpointPosition?: InputMaybe<SortEnumType>;
  ended?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  started?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EventStreamAggregatesConnection = {
  __typename?: 'EventStreamAggregatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventStreamAggregatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventStreamAggregateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventStreamAggregatesEdge = {
  __typename?: 'EventStreamAggregatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventStreamAggregateDocument;
};

export type ExecuteProductionJobInput = {
  consumedMaterials: Array<ConsumedMaterialDataInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

/** A price level annotated with the reason it did or did not contribute to the resolved price. */
export type ExplainedLevel = {
  __typename?: 'ExplainedLevel';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The charged price for this level. CustomerSellPrice is never a charge source. */
  growerSellPrice: Scalars['Decimal']['output'];
  /** Fixed $/unit (default) vs percentage-off-a-reference-group. See PriceKind. */
  kind: PriceKind;
  /** LinePrice (default) vs CategoryVolume. See PriceLevelType. */
  levelType: PriceLevelType;
  /** Percentage discount value (4 = 4%). Present only for PercentOff levels. */
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  /**
   * The price group this level discounts off of. Present only for PercentOff
   * levels.
   */
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The actual charge price for this level: for Fixed this equals
   * GrowerSellPrice; for PercentOff this is the derived value — the
   * reference group's resolved price for this same target, minus PercentOff percent. Always
   * the number the pricing engine would actually charge, so a percent level's derivation is fully
   * transparent without the caller re-computing it.
   */
  resolvedPrice: Scalars['Decimal']['output'];
  startDate: Scalars['DateTime']['output'];
  /** Why this level did or did not apply to the resolution. */
  status: LevelStatus;
  targetId: Scalars['String']['output'];
  /**
   * Display name of the target: the item/material Name for item targets, the category code for
   * category targets. Empty when the referenced item/material could not be found.
   */
  targetName: Scalars['String']['output'];
  type: TargetType;
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocument = {
  __typename?: 'FavoritesListDocument';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  favoritesListId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  items: Array<FavoritesListItemDocument>;
  lastModified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['Int']['output'];
  scopeId: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocumentFilterInput = {
  and?: InputMaybe<Array<FavoritesListDocumentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  favoritesListId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfFavoritesListItemDocumentFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FavoritesListDocumentFilterInput>>;
  scope?: InputMaybe<IntOperationFilterInput>;
  scopeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  favoritesListId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  scopeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type FavoritesListItemDataInput = {
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** MongoDB read model document for a favorites list item. */
export type FavoritesListItemDocument = {
  __typename?: 'FavoritesListItemDocument';
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** MongoDB read model document for a favorites list item. */
export type FavoritesListItemDocumentFilterInput = {
  and?: InputMaybe<Array<FavoritesListItemDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FavoritesListItemDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

export type FavoritesListPayload = {
  __typename?: 'FavoritesListPayload';
  errors?: Maybe<Array<ValidationError>>;
  favoritesList?: Maybe<FavoritesListDocument>;
};

export enum FeasibilityStatus {
  FullySatisfied = 'FULLY_SATISFIED',
  Infeasible = 'INFEASIBLE',
  PartiallySatisfied = 'PARTIALLY_SATISFIED'
}

/**
 * Payload delivered to onFeatureFlagChanged subscribers. Tells the client
 * which flag to refetch. ChangedTenantIds is the tenant scope of
 * the change: null means the change is global (status toggle or global value
 * edit) and affects every tenant; otherwise it lists the tenants whose effective
 * resolution may have shifted (added or removed overrides).
 */
export type FeatureFlagChangedEvent = {
  __typename?: 'FeatureFlagChangedEvent';
  changedTenantIds?: Maybe<Array<Scalars['String']['output']>>;
  name: FeatureFlagName;
};

/** MongoDB read model document for a feature flag, including status, global value, and tenant overrides. */
export type FeatureFlagDocument = {
  __typename?: 'FeatureFlagDocument';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  id: Scalars['String']['output'];
  status: FeatureFlagStatus;
  tenantOverrideCount: Scalars['Int']['output'];
  tenantOverrides: Array<TenantOverrideDocument>;
};

export enum FeatureFlagName {
  ActivityCenter = 'ACTIVITY_CENTER',
  AiChat = 'AI_CHAT',
  CostAccounting = 'COST_ACCOUNTING',
  CustomerPortal = 'CUSTOMER_PORTAL',
  DataTransform = 'DATA_TRANSFORM',
  Edi = 'EDI',
  Engage = 'ENGAGE',
  EventsApp = 'EVENTS_APP',
  Forecast = 'FORECAST',
  FulfillDashboard = 'FULFILL_DASHBOARD',
  FulfillKits = 'FULFILL_KITS',
  FulfillMaintenanceMenu = 'FULFILL_MAINTENANCE_MENU',
  HomeDashboard = 'HOME_DASHBOARD',
  InlineInventoryEdit = 'INLINE_INVENTORY_EDIT',
  Intelligence = 'INTELLIGENCE',
  OrderCorrection = 'ORDER_CORRECTION',
  PdfGenerator = 'PDF_GENERATOR',
  PersonalizedPricingPage = 'PERSONALIZED_PRICING_PAGE',
  Produce = 'PRODUCE',
  ProducedLotFulfillInventory = 'PRODUCED_LOT_FULFILL_INVENTORY',
  ReapplyRecipes = 'REAPPLY_RECIPES',
  ReportProductionCostsEnabled = 'REPORT_PRODUCTION_COSTS_ENABLED',
  Restock = 'RESTOCK',
  RoyaltyEnabled = 'ROYALTY_ENABLED',
  StoreClasses = 'STORE_CLASSES',
  TaxCalculationEnabled = 'TAX_CALCULATION_ENABLED',
  Unknown = 'UNKNOWN',
  UseErpAvailability = 'USE_ERP_AVAILABILITY',
  Verify = 'VERIFY'
}

export type FeatureFlagNameOperationFilterInput = {
  eq?: InputMaybe<FeatureFlagName>;
  in?: InputMaybe<Array<FeatureFlagName>>;
  neq?: InputMaybe<FeatureFlagName>;
  nin?: InputMaybe<Array<FeatureFlagName>>;
};

/**
 * One row of the allFeatureFlags query result: a feature flag name with the
 * effective config and enabled state for the authenticated tenant.
 */
export type FeatureFlagResolvedItem = {
  __typename?: 'FeatureFlagResolvedItem';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: FeatureFlagName;
};

/** Data projection of feature flag state returned in mutation payloads. */
export type FeatureFlagStateData = {
  __typename?: 'FeatureFlagStateData';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  status: FeatureFlagStatus;
};

export enum FeatureFlagStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type FeatureFlagStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureFlagStatus>;
  in?: InputMaybe<Array<FeatureFlagStatus>>;
  neq?: InputMaybe<FeatureFlagStatus>;
  nin?: InputMaybe<Array<FeatureFlagStatus>>;
};

/** Result containing the resolved feature flag value for the authenticated tenant. */
export type FeatureFlagValueResult = {
  __typename?: 'FeatureFlagValueResult';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type FieldMappingData = {
  __typename?: 'FieldMappingData';
  kind: FieldMappingKind;
  sanitize: Scalars['Boolean']['output'];
  sourceField: Scalars['String']['output'];
  targetField: Scalars['String']['output'];
};

export type FieldMappingDataFilterInput = {
  and?: InputMaybe<Array<FieldMappingDataFilterInput>>;
  kind?: InputMaybe<FieldMappingKindOperationFilterInput>;
  or?: InputMaybe<Array<FieldMappingDataFilterInput>>;
  sanitize?: InputMaybe<BooleanOperationFilterInput>;
  sourceField?: InputMaybe<StringOperationFilterInput>;
  targetField?: InputMaybe<StringOperationFilterInput>;
};

export type FieldMappingInput = {
  kind: FieldMappingKind;
  sanitize: Scalars['Boolean']['input'];
  sourceField: Scalars['String']['input'];
  targetField: Scalars['String']['input'];
};

export enum FieldMappingKind {
  Column = 'COLUMN',
  Literal = 'LITERAL'
}

export type FieldMappingKindOperationFilterInput = {
  eq?: InputMaybe<FieldMappingKind>;
  in?: InputMaybe<Array<FieldMappingKind>>;
  neq?: InputMaybe<FieldMappingKind>;
  nin?: InputMaybe<Array<FieldMappingKind>>;
};

export type FinalizeImportUploadInput = {
  asyncImportJobId: Scalars['String']['input'];
};

export type FlagStaleEntriesInput = {
  floatingTimeEntryId: Scalars['String']['input'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of items. */
export type FloatingTimeEntriesConnection = {
  __typename?: 'FloatingTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FloatingTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FloatingTimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FloatingTimeEntriesEdge = {
  __typename?: 'FloatingTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FloatingTimeEntryDocument;
};

/** GraphQL data type for a floating time entry allocation. */
export type FloatingTimeEntryAllocationData = {
  __typename?: 'FloatingTimeEntryAllocationData';
  duration: Scalars['TimeSpan']['output'];
  taskAssignmentId: Scalars['String']['output'];
};

/** MongoDB sub-document for a floating time entry allocation. */
export type FloatingTimeEntryAllocationDocument = {
  __typename?: 'FloatingTimeEntryAllocationDocument';
  duration: Scalars['TimeSpan']['output'];
  taskAssignmentId: Scalars['String']['output'];
  timeEntryId: Scalars['String']['output'];
};

/** MongoDB sub-document for a floating time entry allocation. */
export type FloatingTimeEntryAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<FloatingTimeEntryAllocationDocumentFilterInput>>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<FloatingTimeEntryAllocationDocumentFilterInput>>;
  taskAssignmentId?: InputMaybe<StringOperationFilterInput>;
  timeEntryId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocument = {
  __typename?: 'FloatingTimeEntryDocument';
  allocatedDuration: Scalars['TimeSpan']['output'];
  allocations: Array<FloatingTimeEntryAllocationDocument>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  duration?: Maybe<Scalars['TimeSpan']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  floatingTimeEntryId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isStale: Scalars['Boolean']['output'];
  remainingDuration: Scalars['TimeSpan']['output'];
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: FloatingTimeEntryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocumentFilterInput = {
  allocatedDuration?: InputMaybe<TimeSpanOperationFilterInput>;
  allocations?: InputMaybe<ListFilterInputTypeOfFloatingTimeEntryAllocationDocumentFilterInput>;
  and?: InputMaybe<Array<FloatingTimeEntryDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  floatingTimeEntryId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isStale?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FloatingTimeEntryDocumentFilterInput>>;
  remainingDuration?: InputMaybe<TimeSpanOperationFilterInput>;
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FloatingTimeEntryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  workerId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocumentSortInput = {
  allocatedDuration?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  floatingTimeEntryId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isStale?: InputMaybe<SortEnumType>;
  remainingDuration?: InputMaybe<SortEnumType>;
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  workerId?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for FloatingTimeEntry mutations. */
export type FloatingTimeEntryPayload = {
  __typename?: 'FloatingTimeEntryPayload';
  errors?: Maybe<Array<ValidationError>>;
  floatingTimeEntry?: Maybe<FloatingTimeEntryStateData>;
};

/** GraphQL data type for FloatingTimeEntry state. */
export type FloatingTimeEntryStateData = {
  __typename?: 'FloatingTimeEntryStateData';
  allocatedDuration: Scalars['TimeSpan']['output'];
  allocations: Array<FloatingTimeEntryAllocationData>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  duration?: Maybe<Scalars['TimeSpan']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  floatingTimeEntryId: Scalars['String']['output'];
  isStale: Scalars['Boolean']['output'];
  remainingDuration: Scalars['TimeSpan']['output'];
  staleFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: FloatingTimeEntryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

export enum FloatingTimeEntryStatus {
  Discarded = 'DISCARDED',
  Linked = 'LINKED',
  PartiallyLinked = 'PARTIALLY_LINKED',
  Running = 'RUNNING',
  Unlinked = 'UNLINKED'
}

export type FloatingTimeEntryStatusOperationFilterInput = {
  eq?: InputMaybe<FloatingTimeEntryStatus>;
  in?: InputMaybe<Array<FloatingTimeEntryStatus>>;
  neq?: InputMaybe<FloatingTimeEntryStatus>;
  nin?: InputMaybe<Array<FloatingTimeEntryStatus>>;
};

export type ForceCancelStuckReservationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ForceReadyHandoffStuckReservationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocument = {
  __typename?: 'ForecastDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  /** The forecast customer's display name, resolved at query time from the customer's CustomersSummary row (scoped to the calling tenant) rather than stored on the forecast, so it always reflects the current customer name. Empty when the customer id has no summary row in the tenant. */
  customerName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  forecastId: Scalars['String']['output'];
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: Maybe<ForecastGenerationStatusView>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  level: ForecastLevel;
  lockedConfig: ForecastLockedConfig;
  name: Scalars['String']['output'];
  programIds: Array<Scalars['String']['output']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['output'];
  status: ForecastStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weeklyMetric: ForecastWeeklyMetric;
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocumentFilterInput = {
  and?: InputMaybe<Array<ForecastDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  forecastId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: InputMaybe<ForecastGenerationStatusViewFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  level?: InputMaybe<ForecastLevelOperationFilterInput>;
  lockedConfig?: InputMaybe<ForecastLockedConfigFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ForecastDocumentFilterInput>>;
  programIds?: InputMaybe<ListStringOperationFilterInput>;
  scenarioSlot?: InputMaybe<ForecastScenarioSlotOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ForecastStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  weeklyMetric?: InputMaybe<ForecastWeeklyMetricOperationFilterInput>;
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  forecastId?: InputMaybe<SortEnumType>;
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: InputMaybe<ForecastGenerationStatusViewSortInput>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  level?: InputMaybe<SortEnumType>;
  lockedConfig?: InputMaybe<ForecastLockedConfigSortInput>;
  name?: InputMaybe<SortEnumType>;
  scenarioSlot?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  weeklyMetric?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusView = {
  __typename?: 'ForecastGenerationStatusView';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  overwriteOverrides: Scalars['Boolean']['output'];
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount: Scalars['Int']['output'];
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase: Scalars['String']['output'];
  /** Machine plan rows written by the last completed run. */
  planRowCount: Scalars['Int']['output'];
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount: Scalars['Int']['output'];
  watermark: Scalars['DateTime']['output'];
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusViewFilterInput = {
  and?: InputMaybe<Array<ForecastGenerationStatusViewFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  currentChunk?: InputMaybe<IntOperationFilterInput>;
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: InputMaybe<StringOperationFilterInput>;
  lastProgressAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ForecastGenerationStatusViewFilterInput>>;
  overwriteOverrides?: InputMaybe<BooleanOperationFilterInput>;
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase?: InputMaybe<StringOperationFilterInput>;
  /** Machine plan rows written by the last completed run. */
  planRowCount?: InputMaybe<IntOperationFilterInput>;
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount?: InputMaybe<IntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  totalChunks?: InputMaybe<IntOperationFilterInput>;
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount?: InputMaybe<IntOperationFilterInput>;
  watermark?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusViewSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  currentChunk?: InputMaybe<SortEnumType>;
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: InputMaybe<SortEnumType>;
  lastProgressAt?: InputMaybe<SortEnumType>;
  overwriteOverrides?: InputMaybe<SortEnumType>;
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount?: InputMaybe<SortEnumType>;
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase?: InputMaybe<SortEnumType>;
  /** Machine plan rows written by the last completed run. */
  planRowCount?: InputMaybe<SortEnumType>;
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  totalChunks?: InputMaybe<SortEnumType>;
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount?: InputMaybe<SortEnumType>;
  watermark?: InputMaybe<SortEnumType>;
};

/**
 * The freshness of the tenant's natively-synced history, per ImportData source — surfaced on the plan/list
 * pages (P12) in place of the legacy manual "Import Data" step (ADR-001 §4.2). Each value is the most recent
 * transaction Date present in that source for the tenant, capped at now, or null when the source has
 * no history.
 *
 * Semantic (reconciled with W9). This is the max transaction Date — the exact quantity
 * a W9 generation run pins its inputs at (ADR-001 ARCH-3), NOT an ingest wall-clock time — so the freshness
 * shown here is the same date a generation run would consume, from one shared computation. The only
 * deliberate divergence from the generation watermark is the empty-history case: generation falls back to
 * "now" so a run can still pin a (rows-less) input, whereas a freshness display reports null — there is
 * nothing to be fresh about.
 */
export type ForecastHistoryWatermark = {
  __typename?: 'ForecastHistoryWatermark';
  /** Most recent day in ImportData.DailyInventoryStates (on-hand) for the tenant, or null. */
  dailyInventoryThrough?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent day in ImportData.DailyTransactionSummaries (sales/ships) for the tenant, or null. */
  dailyTransactionsThrough?: Maybe<Scalars['DateTime']['output']>;
  /** The later of the two source through-dates (the overall history freshness), or null when both are empty. */
  latestThrough?: Maybe<Scalars['DateTime']['output']>;
};

export enum ForecastLevel {
  Locations = 'LOCATIONS',
  Regions = 'REGIONS'
}

export type ForecastLevelOperationFilterInput = {
  eq?: InputMaybe<ForecastLevel>;
  in?: InputMaybe<Array<ForecastLevel>>;
  neq?: InputMaybe<ForecastLevel>;
  nin?: InputMaybe<Array<ForecastLevel>>;
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfig = {
  __typename?: 'ForecastLockedConfig';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfigFilterInput = {
  and?: InputMaybe<Array<ForecastLockedConfigFilterInput>>;
  compAim?: InputMaybe<DecimalOperationFilterInput>;
  compMax?: InputMaybe<DecimalOperationFilterInput>;
  compMin?: InputMaybe<DecimalOperationFilterInput>;
  excludedHistoryYears?: InputMaybe<ListIntOperationFilterInput>;
  maxYearOffset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ForecastLockedConfigFilterInput>>;
  roundingBias?: InputMaybe<DecimalOperationFilterInput>;
  shipShift?: InputMaybe<BooleanOperationFilterInput>;
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfigSortInput = {
  compAim?: InputMaybe<SortEnumType>;
  compMax?: InputMaybe<SortEnumType>;
  compMin?: InputMaybe<SortEnumType>;
  maxYearOffset?: InputMaybe<SortEnumType>;
  roundingBias?: InputMaybe<SortEnumType>;
  shipShift?: InputMaybe<SortEnumType>;
};

export type ForecastPayload = {
  __typename?: 'ForecastPayload';
  errors?: Maybe<Array<ValidationError>>;
  forecast?: Maybe<ForecastStateData>;
};

export enum ForecastPlanCell {
  ForecastSalesUnits = 'FORECAST_SALES_UNITS',
  ForecastShipUnits = 'FORECAST_SHIP_UNITS',
  PriceNy = 'PRICE_NY',
  RetailNy = 'RETAIL_NY',
  UnitSellThroughNy = 'UNIT_SELL_THROUGH_NY'
}

export enum ForecastPlanCellEditOperation {
  AddTo = 'ADD_TO',
  PercentageOf = 'PERCENTAGE_OF',
  Replace = 'REPLACE',
  SubtractFrom = 'SUBTRACT_FROM'
}

export enum ForecastScenarioSlot {
  Base = 'BASE',
  Downside = 'DOWNSIDE',
  Submitted = 'SUBMITTED',
  Upside = 'UPSIDE',
  Working = 'WORKING'
}

export type ForecastScenarioSlotOperationFilterInput = {
  eq?: InputMaybe<ForecastScenarioSlot>;
  in?: InputMaybe<Array<ForecastScenarioSlot>>;
  neq?: InputMaybe<ForecastScenarioSlot>;
  nin?: InputMaybe<Array<ForecastScenarioSlot>>;
};

export type ForecastSettingsDocument = {
  __typename?: 'ForecastSettingsDocument';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ForecastSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<ForecastSettingsDocumentFilterInput>>;
  compAim?: InputMaybe<DecimalOperationFilterInput>;
  compMax?: InputMaybe<DecimalOperationFilterInput>;
  compMin?: InputMaybe<DecimalOperationFilterInput>;
  excludedHistoryYears?: InputMaybe<ListIntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxYearOffset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ForecastSettingsDocumentFilterInput>>;
  roundingBias?: InputMaybe<DecimalOperationFilterInput>;
  shipShift?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ForecastSettingsDocumentSortInput = {
  compAim?: InputMaybe<SortEnumType>;
  compMax?: InputMaybe<SortEnumType>;
  compMin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxYearOffset?: InputMaybe<SortEnumType>;
  roundingBias?: InputMaybe<SortEnumType>;
  shipShift?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ForecastSettingsPayload = {
  __typename?: 'ForecastSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ForecastSettingsStateData>;
};

export type ForecastSettingsStateData = {
  __typename?: 'ForecastSettingsStateData';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * GraphQL output shape returned by the forecast mutations (create/update/delete). Mirrors the
 * aggregate state after the command applied.
 */
export type ForecastStateData = {
  __typename?: 'ForecastStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  forecastId: Scalars['String']['output'];
  level: ForecastLevel;
  lockedConfig: ForecastLockedConfig;
  name: Scalars['String']['output'];
  programIds: Array<Scalars['String']['output']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['output'];
  status: ForecastStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weeklyMetric: ForecastWeeklyMetric;
};

export enum ForecastStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ForecastStatusOperationFilterInput = {
  eq?: InputMaybe<ForecastStatus>;
  in?: InputMaybe<Array<ForecastStatus>>;
  neq?: InputMaybe<ForecastStatus>;
  nin?: InputMaybe<Array<ForecastStatus>>;
};

/**
 * Server-computed KPI rollup for the forecast plan grid's Summary panel (spec §3.2), over the rows in
 * the requested scope: sum of plan dollars/units, the two weighted-average sell-throughs, the top item
 * by forecast sales, and the vs-last-year deltas. Computed in a single MongoDB aggregation so the panel
 * is correct even when the grid is server-grouped beyond what the client has loaded. All divisions are
 * zero-guarded: a weighted sell-through with a zero weight is 0, and a vs-last-year percent with a zero
 * last-year base is null.
 */
export type ForecastSummary = {
  __typename?: 'ForecastSummary';
  /** Sum of ForecastSales (next-year sales dollars) across the scope. */
  forecastSales: Scalars['Decimal']['output'];
  /** Sum of ForecastSalesUnits across the scope. */
  forecastSalesUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShipUnits across the scope. */
  forecastShipUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShips (next-year ship dollars) across the scope. */
  forecastShips: Scalars['Decimal']['output'];
  /** Sum of last-year Sales dollars across the scope (the vs-last-year sales base). */
  lySales: Scalars['Decimal']['output'];
  /** Sum of last-year SalesUnits across the scope (the vs-last-year units base). */
  lySalesUnits: Scalars['Decimal']['output'];
  /** Sum of last-year ShipUnits across the scope (the vs-last-year ship-units base). */
  lyShipUnits: Scalars['Decimal']['output'];
  /**
   * Forecast retail margin dollars — the sum of (ForecastSales − ForecastSalesUnits × PriceNy) over
   * the scope (spec §3.2 Margin$).
   */
  marginNy: Scalars['Decimal']['output'];
  /** Number of plan rows aggregated into this summary. */
  rowCount: Scalars['Int']['output'];
  /** (ForecastSales − LySales) ÷ LySales, expressed as a fraction (0.1 = +10%); null when LySales is 0. */
  salesVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /** (ForecastShipUnits − LyShipUnits) ÷ LyShipUnits, as a fraction; null when LyShipUnits is 0. */
  shipUnitsVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /** The item with the greatest total ForecastSales in the scope, or null when the scope is empty. */
  topItem?: Maybe<ForecastSummaryTopItem>;
  /** (ForecastSalesUnits − LySalesUnits) ÷ LySalesUnits, as a fraction; null when LySalesUnits is 0. */
  unitsVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Next-year retail sell-through, averaged across the scope weighted by ForecastSales, where each
   * row's retail sell-through is ForecastSales ÷ max(ForecastShips, ForecastSales)
   * (Σ(retailSellThrough × ForecastSales) ÷ Σ ForecastSales); 0 when the weight is 0.
   */
  weightedRetailSellThroughNy: Scalars['Decimal']['output'];
  /**
   * Next-year unit sell-through, averaged across the scope weighted by ForecastSalesUnits
   * (Σ(UnitSellThroughNy × ForecastSalesUnits) ÷ Σ ForecastSalesUnits); 0 when the weight is 0.
   */
  weightedUnitSellThroughNy: Scalars['Decimal']['output'];
};

/**
 * Optional scope narrowing a forecast summary to the selected-or-visible rows (spec §3.2). Every list is
 * optional and additive: the supplied lists AND together, and each row must match all of them. An
 * omitted or empty scope summarizes the whole forecast. Each dimension mirrors a groupable/filterable
 * column of the plan grid, and PlanRowIds is the explicit row selection (the plan-row composite ids).
 */
export type ForecastSummaryScopeInput = {
  /** Restricts the summary to rows whose category is in this set. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose item id is in this set. */
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose merchant is in this set. */
  merchants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Explicit plan-row selection — the composite plan-row ids to include. */
  planRowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose product group is in this set. */
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose program is in this set. */
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose region is in this set. */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The top item of a forecast summary — the item with the highest total forecast sales in scope. */
export type ForecastSummaryTopItem = {
  __typename?: 'ForecastSummaryTopItem';
  /** Total ForecastSales for this item across the scope. */
  forecastSales: Scalars['Decimal']['output'];
  /** WorkSuite item id of the top item. */
  itemId: Scalars['String']['output'];
  /** Display name of the top item. */
  itemName: Scalars['String']['output'];
  /** Item SKU of the top item. */
  itemSku: Scalars['String']['output'];
};

/**
 * The weekly-cell totals for one plan row (region × item) of a forecast: the sum of every weekly cell's
 * forecast sales units and forecast ship units across the weeks (spec §3.2 Delta column). The PWA (P6)
 * computes the plan grid's Delta as the plan row's macro units minus these weekly sums, so a distribution
 * that no longer ties out to the macro plan is visible. Returned by forecastWeeklyDeltaInputs, one
 * row per (region, item) that has at least one weekly cell.
 */
export type ForecastWeeklyDeltaInput = {
  __typename?: 'ForecastWeeklyDeltaInput';
  /** WorkSuite item id of this plan row. */
  itemId: Scalars['String']['output'];
  /** Region key of this plan row. */
  region: Scalars['String']['output'];
  /** Sum of ForecastSalesUnits across this row's weekly cells. */
  weeklyForecastSalesUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShipUnits across this row's weekly cells. */
  weeklyForecastShipUnits: Scalars['Decimal']['output'];
};

/**
 * Optional scope narrowing forecastWeeklyDeltaInputs to the selected-or-visible plan rows. Both
 * lists are optional and additive: the supplied lists AND together (a row must match all of them). An
 * omitted or empty scope returns the Delta inputs for the whole forecast. The dimensions mirror the plan
 * grid's region / item scope so the PWA can fetch Delta inputs for exactly the rows it is showing.
 */
export type ForecastWeeklyDeltaScopeInput = {
  /** Restricts the Delta inputs to weekly cells whose item id is in this set. */
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the Delta inputs to weekly cells whose region is in this set. */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ForecastWeeklyHistoryRebuildPayload = {
  __typename?: 'ForecastWeeklyHistoryRebuildPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<ForecastWeeklyHistoryRebuildResult>;
};

/** Outcome of a rebuildForecastWeeklyHistory run for one customer. */
export type ForecastWeeklyHistoryRebuildResult = {
  __typename?: 'ForecastWeeklyHistoryRebuildResult';
  /** The most recent history date rolled into the cache, or null when the customer has no history. */
  builtThroughDate?: Maybe<Scalars['DateTime']['output']>;
  /** The customer whose shared weekly-history cache was rebuilt. */
  customerId: Scalars['String']['output'];
  /** Number of weekly-history buckets written (upserted) by this run. */
  rowsWritten: Scalars['Int']['output'];
  /** Daily rows dropped because their location or item did not resolve to WorkSuite master data. */
  skippedUnmappedRows: Scalars['Int']['output'];
  /** Number of stale buckets from a prior rebuild removed within the (tenant, customer) scope. */
  staleRowsRemoved: Scalars['Int']['output'];
};

export enum ForecastWeeklyMetric {
  Sales = 'SALES',
  Ships = 'SHIPS'
}

export type ForecastWeeklyMetricOperationFilterInput = {
  eq?: InputMaybe<ForecastWeeklyMetric>;
  in?: InputMaybe<Array<ForecastWeeklyMetric>>;
  neq?: InputMaybe<ForecastWeeklyMetric>;
  nin?: InputMaybe<Array<ForecastWeeklyMetric>>;
};

/** A connection to a list of items. */
export type ForecastsConnection = {
  __typename?: 'ForecastsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ForecastsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ForecastDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ForecastsEdge = {
  __typename?: 'ForecastsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ForecastDocument;
};

export enum FreightChargeType {
  FlatFee = 'FLAT_FEE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type FulfillAllocationInput = {
  allocationId: Scalars['String']['input'];
  fulfilledQty: Scalars['Decimal']['input'];
};

export enum FulfillmentSource {
  ExistingStock = 'EXISTING_STOCK',
  MakeToOrder = 'MAKE_TO_ORDER',
  Unspecified = 'UNSPECIFIED'
}

export type FulfillmentSourceOperationFilterInput = {
  eq?: InputMaybe<FulfillmentSource>;
  in?: InputMaybe<Array<FulfillmentSource>>;
  neq?: InputMaybe<FulfillmentSource>;
  nin?: InputMaybe<Array<FulfillmentSource>>;
};

export type GenerateForecastInput = {
  forecastId: Scalars['String']['input'];
  overwriteOverrides: Scalars['Boolean']['input'];
};

export type GradeInventoryItemCommandInput = {
  currentGrade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  newGrade: Scalars['Int']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

export type GradeLabelDataInput = {
  grade: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

export type GridRequestInput = {
  endRow: Scalars['Int']['input'];
  filterModel?: InputMaybe<Scalars['JSON']['input']>;
  groupKeys: Array<Scalars['String']['input']>;
  rowGroupCols: Array<GroupColumnInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortModel: Array<SortColumnInput>;
  startRow: Scalars['Int']['input'];
  valueCols: Array<ValueColumnInput>;
};

export type GridResponse = {
  __typename?: 'GridResponse';
  rowCount: Scalars['Int']['output'];
  rowData: Array<Scalars['JSON']['output']>;
};

export type GroupColumnInput = {
  field: Scalars['String']['input'];
};

/**
 * GraphQL-facing selector for a GrowPoint staged-entity type. Each member maps 1:1 to the staged
 * collection set in GrowPointCollectionNames that
 * backs it. Deliberately distinct from the domain enum
 * WorkSuite.Domain.WsapiImport.Models.WsapiImportEntityType — that enum's ordinals are
 * persisted in events and read models, so surfacing it would couple the public schema to a storage
 * detail and break on any reordering. This dedicated enum keeps the schema decoupled.
 */
export enum GrowPointStagedEntity {
  Categories = 'CATEGORIES',
  Customers = 'CUSTOMERS',
  HistoricalOrders = 'HISTORICAL_ORDERS',
  Inventory = 'INVENTORY',
  Items = 'ITEMS',
  PriceGroups = 'PRICE_GROUPS',
  SiteLocations = 'SITE_LOCATIONS',
  TaxAuthorities = 'TAX_AUTHORITIES',
  Terms = 'TERMS'
}

export type GrowWeeksOverride = {
  __typename?: 'GrowWeeksOverride';
  growWeeks: Scalars['Int']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type GrowWeeksOverrideFilterInput = {
  and?: InputMaybe<Array<GrowWeeksOverrideFilterInput>>;
  growWeeks?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<GrowWeeksOverrideFilterInput>>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Per-bin on-hand snapshot. On-hand is the absolute post-event quantity carried by
 *             (or computed as a pure function of) the originating MaterialItem count/move/adjust event.
 */
export type HardgoodsBinBreakdown = {
  __typename?: 'HardgoodsBinBreakdown';
  /**
   * When this bin was last counted (an observation). Advances only on a
   * MaterialItemCounted projection — NOT on an adjust (a correction) or a move (a
   * relocation), both of which leave this marker untouched while still updating
   * OnHand. So a null/stale bin-level LastCountedAt next to a recent
   * on-hand correctly reads as "on-hand was corrected/moved, not re-counted."
   */
  lastCountedAt?: Maybe<Scalars['DateTime']['output']>;
  onHand: Scalars['Decimal']['output'];
};

/**
 * Per-bin on-hand snapshot. On-hand is the absolute post-event quantity carried by
 *             (or computed as a pure function of) the originating MaterialItem count/move/adjust event.
 */
export type HardgoodsBinBreakdownFilterInput = {
  and?: InputMaybe<Array<HardgoodsBinBreakdownFilterInput>>;
  /**
   * When this bin was last counted (an observation). Advances only on a
   * MaterialItemCounted projection — NOT on an adjust (a correction) or a move (a
   * relocation), both of which leave this marker untouched while still updating
   * OnHand. So a null/stale bin-level LastCountedAt next to a recent
   * on-hand correctly reads as "on-hand was corrected/moved, not re-counted."
   */
  lastCountedAt?: InputMaybe<DateTimeOperationFilterInput>;
  onHand?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<HardgoodsBinBreakdownFilterInput>>;
};

/** A connection to a list of items. */
export type HardgoodsInventoryGridConnection = {
  __typename?: 'HardgoodsInventoryGridConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HardgoodsInventoryGridEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HardgoodsInventoryGridDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocument = {
  __typename?: 'HardgoodsInventoryGridDocument';
  activeAssignmentId?: Maybe<Scalars['String']['output']>;
  activeAssignmentStatus?: Maybe<CycleCountAssignmentStatus>;
  bins: Array<KeyValuePairOfStringAndHardgoodsBinBreakdown>;
  id: Scalars['String']['output'];
  lastCountedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEventAt: Scalars['DateTime']['output'];
  materialItemId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocumentFilterInput = {
  activeAssignmentId?: InputMaybe<StringOperationFilterInput>;
  activeAssignmentStatus?: InputMaybe<NullableOfCycleCountAssignmentStatusOperationFilterInput>;
  and?: InputMaybe<Array<HardgoodsInventoryGridDocumentFilterInput>>;
  bins?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastCountedAt?: InputMaybe<DateTimeOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HardgoodsInventoryGridDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocumentSortInput = {
  activeAssignmentId?: InputMaybe<SortEnumType>;
  activeAssignmentStatus?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastCountedAt?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type HardgoodsInventoryGridEdge = {
  __typename?: 'HardgoodsInventoryGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HardgoodsInventoryGridDocument;
};

/**
 * The required quantity of a single material item for a site location in a ready week,
 * summed across every scheduled production lot in that week
 * (recipe material multiple × production job lot size).
 */
export type HardgoodsRequiredItem = {
  __typename?: 'HardgoodsRequiredItem';
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /**
   * The total quantity of this material required across all scheduled production lots
   * in the queried ready week. Decimal because the recipe material multiple is decimal.
   */
  requiredQuantity: Scalars['Decimal']['output'];
};

/**
 * Result of hardgoodsRequiredByReadyWeek: the per-material-item required
 * quantities for a site location and ready week, plus the recipe-coverage metric
 * (the board's pre-flight check — what fraction of material items are recipe-covered).
 */
export type HardgoodsRequiredSummary = {
  __typename?: 'HardgoodsRequiredSummary';
  /** Required quantity per material item, one entry per distinct material item. */
  items: Array<HardgoodsRequiredItem>;
  /**
   * Count of distinct material items that are referenced by at least one production
   * recipe (via a recipe variation's material events) for the tenant.
   */
  itemsWithRecipe: Scalars['Int']['output'];
  /**
   * Recipe coverage percentage = ItemsWithRecipe / TotalItems
   * × 100, or 0 when there are no material items. Surfaced by the UI as the
   * "Recipe coverage: XX%" chip.
   */
  recipeCoveragePct: Scalars['Decimal']['output'];
  /** Count of active material items for the tenant (the coverage denominator). */
  totalItems: Scalars['Int']['output'];
};

export type HistoricalOrderImportRowError = {
  __typename?: 'HistoricalOrderImportRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type HistoricalOrderLineItemInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  addedBy: Scalars['String']['input'];
  containerCode?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  dateAdded: Scalars['DateTime']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  handlingUom?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  price: Scalars['Decimal']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  royaltyExempt: Scalars['Boolean']['input'];
  shippedQuantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Staged line-item read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Lines in the GrowPointIntegrations database —
 * a 1:1 echo of HistoricalOrderCommands.HistoricalOrderLineItemInput keyed by
 * {tenantId}-{orderId}-{lineItemId}, plus the LineTotal rollup the staged-review
 * grid displays. Read by stagedHistoricalOrderLineItems(orderId); a re-validate of the parent
 * order replaces the order's staged lines wholesale (scoped delete-then-insert), so the collection
 * never holds orphaned lines.
 */
export type HistoricalOrderStagedLineItemDocument = {
  __typename?: 'HistoricalOrderStagedLineItemDocument';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  containerCode?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  lineTotal: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  noteText?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  royaltyExempt: Scalars['Boolean']['output'];
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-row failure surfaced by validateHistoricalOrderDocuments. RowIndex is the
 * position in the posted batch (so wsapi-services / AG Grid can map back to the source row);
 * Field is the offending field name when the underlying ValidationError implements
 * IFieldValidationError, otherwise null.
 */
export type HistoricalOrderStagedRowError = {
  __typename?: 'HistoricalOrderStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocument = {
  __typename?: 'HistoricalOrderStagedSummaryDocument';
  customerName: Scalars['String']['output'];
  expectedDeliveryDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lineItemCount: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  status: OrderStatus;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentFilterInput>>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lineItemCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalAmount?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocumentSortInput = {
  customerName?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lineItemCount?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalAmount?: InputMaybe<SortEnumType>;
};

/**
 * Read-model document for one FORECAST holiday reference row, keyed {tenantId}-{holidayId}. The
 * composite _id embeds the tenant, so per-row reads filter on _id and cannot leak across tenants
 * (discipline acada0ab), and it is cheap to compute from a (tenant, holidayId) pair. The (year, ISO
 * week, date) triple is validated for W1 consistency on the write path, so the weekly-spread engine can
 * bucket a holiday by its stored ISO week without recomputing.
 *
 * Maintenance owner: pending A2 decision (spec open question 13 — who maintains the legacy
 * Config.Holidays set, seeded only through 2024).
 */
export type HolidayDocument = {
  __typename?: 'HolidayDocument';
  date: Scalars['LocalDate']['output'];
  holidayId: Scalars['String']['output'];
  holidayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isoWeek: Scalars['Int']['output'];
  status: HolidayStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type HolidayPayload = {
  __typename?: 'HolidayPayload';
  errors?: Maybe<Array<ValidationError>>;
  holiday?: Maybe<HolidayStateData>;
};

/**
 * GraphQL output shape returned by the holiday CRUD mutations: the holiday row after the command
 * applied. Mirrors the aggregate state.
 */
export type HolidayStateData = {
  __typename?: 'HolidayStateData';
  date: Scalars['LocalDate']['output'];
  holidayId: Scalars['String']['output'];
  holidayName: Scalars['String']['output'];
  isoWeek: Scalars['Int']['output'];
  status: HolidayStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum HolidayStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ImportCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress: CreateAddressInput;
  contacts?: InputMaybe<Array<ContactDataInput>>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  locations: Array<CreateCustomerLocationInput>;
  name: Scalars['String']['input'];
  orderSubmitter?: InputMaybe<OrderSubmitterDataInput>;
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type ImportHistoricalOrderInput = {
  customer: OrderCustomerDataInput;
  dateShippedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit: Scalars['Boolean']['input'];
  freightChargeReason?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  importedByEmail: Scalars['String']['input'];
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  lineItems: Array<HistoricalOrderLineItemInput>;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  overrideTotal?: InputMaybe<Scalars['Decimal']['input']>;
  poNumber: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
  statusDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type ImportHistoricalOrdersResult = {
  __typename?: 'ImportHistoricalOrdersResult';
  imported: Scalars['Int']['output'];
  rowErrors: Array<HistoricalOrderImportRowError>;
};

export type ImportItemInput = {
  categories: Array<CategoryDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productGroup?: InputMaybe<Scalars['String']['input']>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ImportPriceGroupInput = {
  id: Scalars['String']['input'];
  makeDefaultIfNoDefaultExists: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceLevels: Array<PriceLevelInputDataInput>;
};

export type ImportTaxAuthorityInput = {
  code: Scalars['String']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  erpId: Scalars['String']['input'];
  glAccount: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Decimal']['input'];
};

export type ImportTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: Scalars['Int']['input'];
  isDefault?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
  termsCode: Scalars['String']['input'];
  termsId: Scalars['String']['input'];
};

export type InactivateCategoryInput = {
  code: Scalars['String']['input'];
};

export type InactivateCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InactivateDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type InactivateFeatureFlagInput = {
  name: FeatureFlagName;
};

export type InactivateItemInput = {
  itemId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type InactivateLocationInput = {
  locationId: Scalars['String']['input'];
};

export type InactivateMaterialItemInput = {
  id: Scalars['String']['input'];
};

export type InactivatePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type InactivateProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type InactivateProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type InactivateProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type InactivateProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type InactivateProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type InactivateProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type InactivateProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type InactivateProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type InactivateProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type InactivateSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type InactivateTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type InactivateTenantInput = {
  entityId: Scalars['String']['input'];
};

export type InactivateVendorInput = {
  id: Scalars['String']['input'];
};

/**
 * A finished test run as submitted by the Playwright publisher. Mirrors the dashboard's run shape
 * minus the server-owned fields (isNew, ingestedAt).
 */
export type IngestQaTestRunInput = {
  adoUrl?: InputMaybe<Scalars['String']['input']>;
  appBuild?: InputMaybe<Scalars['String']['input']>;
  counts: QaRunCountsInput;
  dateUtc: Scalars['DateTime']['input'];
  durationSec: Scalars['Int']['input'];
  flows: Array<QaFlowInput>;
  /** ADO build id for pipeline runs, or a stamped local-… id for developer runs. */
  id: Scalars['String']['input'];
  /** Subset run — recorded so the health tiles can skip it. */
  partial: Scalars['Boolean']['input'];
  result: Scalars['String']['input'];
  /** worksuite or inventory; rejected otherwise. */
  suite: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type InitializeMasterOrderInput = {
  customer: MasterOrderCustomerDataInput;
  fromLocation: ShipFromLocationDataInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type InitializeMergeDevExportInput = {
  entityId: Scalars['String']['input'];
  entityType: MergeDevExportEntityType;
};

export type InitializeOrderInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  customer: OrderCustomerDataInput;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit?: Scalars['Boolean']['input'];
  fromLocation: ShipFromLocationDataInput;
  importId?: InputMaybe<Scalars['String']['input']>;
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export enum IntegrationCategory {
  Accounting = 'ACCOUNTING',
  Crm = 'CRM',
  Unknown = 'UNKNOWN'
}

export type IntegrationCategoryOperationFilterInput = {
  eq?: InputMaybe<IntegrationCategory>;
  in?: InputMaybe<Array<IntegrationCategory>>;
  neq?: InputMaybe<IntegrationCategory>;
  nin?: InputMaybe<Array<IntegrationCategory>>;
};

/**
 * A computed, read-only health snapshot for a single tenant's Merge.dev / accounting integration. Built
 * on demand from the connection, sync-state, WsapiImport, and accounting-policy read models — it is
 * not itself a stored document. Surfaces the "connected but never synced / mis-seeded" failure modes that
 * the per-surface signals (link present, consecutiveFailures: 0) cannot show, so a falsely-green
 * integration is caught immediately instead of by a manual cross-check of read-model counts.
 */
export type IntegrationHealthDocument = {
  __typename?: 'IntegrationHealthDocument';
  /** The Merge.dev integration id this health snapshot was computed for. */
  integrationId: Scalars['String']['output'];
  /**
   * True when a MERGE_DEV TenantIntegration link exists for this integration. When false the
   * integration is simply not connected (rather than connected-but-unhealthy) and Reasons
   * is empty — there is nothing to be unhealthy about yet.
   */
  isConnected: Scalars['Boolean']['output'];
  /**
   * True when the integration is connected and has no unhealthy reasons — it has synced at least once,
   * has an enabled import gate, and a real accounting provider. A not-connected integration is reported
   * healthy (nothing wrong) so the card only flags genuine connected-but-broken states.
   */
  isHealthy: Scalars['Boolean']['output'];
  /**
   * The distinguishable reasons the integration is unhealthy. Empty when healthy. An integration can hit
   * more than one reason at once (e.g. never-synced AND provider-none), so each finding is reported
   * independently rather than collapsed into a single status.
   */
  reasons: Array<IntegrationHealthReason>;
  /** The tenant that owns the integration this health snapshot describes. */
  tenantId: Scalars['String']['output'];
};

/**
 * A distinguishable reason a connected Merge.dev / accounting integration is unhealthy. A single
 * integration can report more than one of these at once, so Reasons
 * is a list rather than a single status. Each value names a silent failure mode that previously left the
 * integration looking falsely "green" (link present, no errors) while never actually moving any data.
 */
export enum IntegrationHealthReason {
  /**
   * The integration is linked (a MERGE_DEV TenantIntegration exists) but has never completed a
   * sync cycle: the synchronizer has captured no connection metadata (mergeDevConnection is null)
   * AND there are zero mergeDevSyncState rows for it. The integration card would otherwise show
   * "connected" while no chart-of-accounts, tax rates, items, or customers have ever been pulled.
   */
  NeverSynced = 'NEVER_SYNCED',
  /**
   * No enabled WsapiImport selects this tenant. The MergeDevImport worker's only gate is an
   * enabled WsapiImport that is RunNow or schedule-matched; with none, the worker hits
   * NoWorkIteration forever and writes nothing — no error, no sync state, no connection. The
   * link looks healthy but the worker silently skips the tenant on every cycle.
   */
  NoEnabledImport = 'NO_ENABLED_IMPORT',
  /**
   * The accounting policy provider is None while a Merge link is active. Reconnecting the Merge
   * link upserts credentials but never sets the provider, so outbound (ship→invoice) is silently
   * disabled even though the tenant appears connected.
   */
  ProviderNone = 'PROVIDER_NONE'
}

export enum IntegrationSource {
  GrowPoint = 'GROW_POINT',
  MergeDev = 'MERGE_DEV',
  OrderEase = 'ORDER_EASE',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN'
}

export type IntegrationSourceOperationFilterInput = {
  eq?: InputMaybe<IntegrationSource>;
  in?: InputMaybe<Array<IntegrationSource>>;
  neq?: InputMaybe<IntegrationSource>;
  nin?: InputMaybe<Array<IntegrationSource>>;
};

/**
 * One order line's allocation against an inventory key, including MakeToOrder produced-pegged allocations.
 * Quantity is the ABSOLUTE amount allocated to that line on this slot; AllocatedBy is the
 * acting user's email for a manual allocation or the "MakeToOrder" sentinel for a produced-lot peg.
 * LineItemId/OrderId are stored as strings so a consumer can link straight to the order line.
 */
export type InventoryAllocationDocument = {
  __typename?: 'InventoryAllocationDocument';
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  lineItemId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocation against an inventory key, including MakeToOrder produced-pegged allocations.
 * Quantity is the ABSOLUTE amount allocated to that line on this slot; AllocatedBy is the
 * acting user's email for a manual allocation or the "MakeToOrder" sentinel for a produced-lot peg.
 * LineItemId/OrderId are stored as strings so a consumer can link straight to the order line.
 */
export type InventoryAllocationDocumentFilterInput = {
  allocatedBy?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<InventoryAllocationDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

export type InventoryAvailabilityData = {
  __typename?: 'InventoryAvailabilityData';
  comment: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
};

export type InventoryItemDocument = {
  __typename?: 'InventoryItemDocument';
  allocatedQuantity: Scalars['Decimal']['output'];
  /**
   * Per-order allocation breakdown for this inventory key — one entry per allocated
   * (orderId, lineItemId), INCLUDING MakeToOrder produced-pegged allocations. Powers the FULFILL
   * inventory item "allocated orders" side panel (read in one query, collapsing the per-order GetOrder
   * N+1). Written by InventoryItemProjectionService from the InventoryItem stream's
   * ItemAllocated/ItemDeallocated events as an idempotent, replay-safe absolute rewrite;
   * empty for unallocated keys.
   */
  allocations: Array<InventoryAllocationDocument>;
  availableQuantity: Scalars['Decimal']['output'];
  category: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  grade: Scalars['Int']['output'];
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemType: ItemType;
  lastTransactionDate: Scalars['DateTime']['output'];
  lastTransactionType: Scalars['String']['output'];
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: Maybe<InventoryNoteDocument>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /**
   * All free-text notes on this inventory key (item + location + grade), in append order, written
   * by the inventory-note projection.
   * Multiple notes are allowed per key and the live set (history minus cleared notes) is retained
   * here; the full KurrentDB event history is always available on the stream. Notes are
   * independent of quantity — they survive a depletion to zero and reappear on re-add — and play
   * no part in the inventory uniqueness/grouping key. Empty until a note is added.
   */
  notes: Array<InventoryNoteDocument>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity: Scalars['Decimal']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  reasonCode: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  /**
   * The production jobs that fed this Live Goods inventory key, one entry per job (jobId, quantity
   * contributed, the job's ready week). Written by the produced-lot → Live Goods feed projection as an
   * absolute overwrite of the full set the increment/decrement event carries, so it stays idempotent on
   * replay. Empty for inventory keys that no production job has fed (e.g. a manually-added line). Powers
   * the FULFILL inventory item "Jobs feeding this item" tab and grid. The item's `readyDate`
   * (and derived `readyWeek`) is the earliest `jobReadyWeekDate` across this set.
   */
  sourceJobContributions: Array<InventorySourceJobContributionDocument>;
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

export type InventoryItemDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Per-order allocation breakdown for this inventory key — one entry per allocated
   * (orderId, lineItemId), INCLUDING MakeToOrder produced-pegged allocations. Powers the FULFILL
   * inventory item "allocated orders" side panel (read in one query, collapsing the per-order GetOrder
   * N+1). Written by InventoryItemProjectionService from the InventoryItem stream's
   * ItemAllocated/ItemDeallocated events as an idempotent, replay-safe absolute rewrite;
   * empty for unallocated keys.
   */
  allocations?: InputMaybe<ListFilterInputTypeOfInventoryAllocationDocumentFilterInput>;
  and?: InputMaybe<Array<InventoryItemDocumentFilterInput>>;
  availableQuantity?: InputMaybe<DecimalOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemType?: InputMaybe<ItemTypeOperationFilterInput>;
  lastTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastTransactionType?: InputMaybe<StringOperationFilterInput>;
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: InputMaybe<InventoryNoteDocumentFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * All free-text notes on this inventory key (item + location + grade), in append order, written
   * by the inventory-note projection.
   * Multiple notes are allowed per key and the live set (history minus cleared notes) is retained
   * here; the full KurrentDB event history is always available on the stream. Notes are
   * independent of quantity — they survive a depletion to zero and reappear on re-add — and play
   * no part in the inventory uniqueness/grouping key. Empty until a note is added.
   */
  notes?: InputMaybe<ListFilterInputTypeOfInventoryNoteDocumentFilterInput>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InventoryItemDocumentFilterInput>>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: InputMaybe<LocalDateOperationFilterInput>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: InputMaybe<IntOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production jobs that fed this Live Goods inventory key, one entry per job (jobId, quantity
   * contributed, the job's ready week). Written by the produced-lot → Live Goods feed projection as an
   * absolute overwrite of the full set the increment/decrement event carries, so it stays idempotent on
   * replay. Empty for inventory keys that no production job has fed (e.g. a manually-added line). Powers
   * the FULFILL inventory item "Jobs feeding this item" tab and grid. The item's `readyDate`
   * (and derived `readyWeek`) is the earliest `jobReadyWeekDate` across this set.
   */
  sourceJobContributions?: InputMaybe<ListFilterInputTypeOfInventorySourceJobContributionDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  why?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryItemDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  availableQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemType?: InputMaybe<SortEnumType>;
  lastTransactionDate?: InputMaybe<SortEnumType>;
  lastTransactionType?: InputMaybe<SortEnumType>;
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: InputMaybe<InventoryNoteDocumentSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: InputMaybe<SortEnumType>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  why?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL payload returned from grade change mutations, containing both source (old grade)
 * and destination (new grade) inventory item states.
 */
export type InventoryItemGradePayload = {
  __typename?: 'InventoryItemGradePayload';
  destinationInventoryItem?: Maybe<InventoryItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  sourceInventoryItem?: Maybe<InventoryItemStateData>;
};

/**
 * GraphQL payload returned from move mutations, containing both source and destination
 * inventory item states so the frontend can update both in the cache without a refetch.
 */
export type InventoryItemMovePayload = {
  __typename?: 'InventoryItemMovePayload';
  destinationInventoryItem?: Maybe<InventoryItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  sourceInventoryItem?: Maybe<InventoryItemStateData>;
};

/**
 * GraphQL payload returned from inventory item mutations, containing either
 * the updated state data or validation errors.
 */
export type InventoryItemPayload = {
  __typename?: 'InventoryItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  inventoryItem?: Maybe<InventoryItemStateData>;
};

/**
 * Per-row failure surfaced by validateInventoryItemDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type InventoryItemStagedRowError = {
  __typename?: 'InventoryItemStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

/**
 * Inventory item state returned from mutations. Display fields (item name, location name, UPC)
 * are resolved lazily via DataLoader on InventoryItemStateDataType — no follow-up
 * query needed for frontend cache updates.
 */
export type InventoryItemStateData = {
  __typename?: 'InventoryItemStateData';
  availableQuantity: Scalars['Decimal']['output'];
  /**
   * Destination location ID for Move mutations. Used by the DataLoader resolver
   * to resolve DestinationLocationName. Null for all other mutation types.
   */
  destinationLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Display name of the destination location, resolved via DataLoader.
   * Populated only for Move mutations (when DestinationLocationId is set).
   */
  destinationLocationName?: Maybe<Scalars['String']['output']>;
  grade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  /**
   * Display name of the item, resolved via DataLoader from the ItemSummary projection.
   * Null when the item is not yet projected or the read model is unavailable.
   */
  itemName?: Maybe<Scalars['String']['output']>;
  itemType: ItemType;
  lastTransactionDate: Scalars['DateTime']['output'];
  locationId: Scalars['String']['output'];
  /**
   * Display name of the location, resolved via DataLoader from SubLocations or SiteLocations.
   * Null when the location is not yet projected or the read model is unavailable.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * All free-text notes currently on this inventory key (item + location + grade), in append
   * order. Multiple notes are allowed and the full history is retained; Notes here
   * is the live set after the mutation (a cleared note is absent). Notes are independent of
   * quantity and never affect the inventory uniqueness/grouping key.
   */
  notes: Array<InventoryNoteData>;
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional, manually-entered date the live goods are projected to be ready.
   * Null when no ready date was supplied on the add.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed, never stored,
   * so it cannot drift from the date. Null when there is no ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * UPC code of the item, resolved via DataLoader from the ItemSummary projection.
   * Null when the item is not yet projected or the read model is unavailable.
   */
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type InventoryItemsConnection = {
  __typename?: 'InventoryItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InventoryItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InventoryItemsEdge = {
  __typename?: 'InventoryItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/**
 * GraphQL representation of a single free-text inventory note: its stable id (used to clear it),
 * body, and the recorded author and timestamp.
 */
export type InventoryNoteData = {
  __typename?: 'InventoryNoteData';
  noteId: Scalars['UUID']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocument = {
  __typename?: 'InventoryNoteDocument';
  noteId: Scalars['UUID']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocumentFilterInput = {
  and?: InputMaybe<Array<InventoryNoteDocumentFilterInput>>;
  noteId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<InventoryNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocumentSortInput = {
  noteId?: InputMaybe<SortEnumType>;
  submitDate?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
  text?: InputMaybe<SortEnumType>;
};

/**
 * Read-model representation of a single production job's contribution to a Live Goods inventory key.
 * Document-only sub-record (the parent InventoryItemDocument is itself the read-model boundary
 * type). Carries the feeding job's id, the quantity it contributed, and the job's ready week (the Monday
 * of its ISO ready week). The item rolls the earliest `jobReadyWeekDate` up onto its ready
 * date.
 */
export type InventorySourceJobContributionDocument = {
  __typename?: 'InventorySourceJobContributionDocument';
  contributedQuantity: Scalars['Decimal']['output'];
  /**
   * ISO 8601 week number (1–53) DERIVED from `jobReadyWeekDate`. Computed on read so it can
   * never drift from the date — it is never stored independently.
   */
  jobReadyWeek: Scalars['Int']['output'];
  jobReadyWeekDate: Scalars['LocalDate']['output'];
  productionJobId: Scalars['String']['output'];
};

/**
 * Read-model representation of a single production job's contribution to a Live Goods inventory key.
 * Document-only sub-record (the parent InventoryItemDocument is itself the read-model boundary
 * type). Carries the feeding job's id, the quantity it contributed, and the job's ready week (the Monday
 * of its ISO ready week). The item rolls the earliest `jobReadyWeekDate` up onto its ready
 * date.
 */
export type InventorySourceJobContributionDocumentFilterInput = {
  and?: InputMaybe<Array<InventorySourceJobContributionDocumentFilterInput>>;
  contributedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * ISO 8601 week number (1–53) DERIVED from `jobReadyWeekDate`. Computed on read so it can
   * never drift from the date — it is never stored independently.
   */
  jobReadyWeek?: InputMaybe<IntOperationFilterInput>;
  jobReadyWeekDate?: InputMaybe<LocalDateOperationFilterInput>;
  or?: InputMaybe<Array<InventorySourceJobContributionDocumentFilterInput>>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryTransactionDocument = {
  __typename?: 'InventoryTransactionDocument';
  grade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  reasonCode: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionType: InventoryTransactionType;
  userId: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

export type InventoryTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<InventoryTransactionDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryTransactionDocumentFilterInput>>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  transactionType?: InputMaybe<InventoryTransactionTypeOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  why?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryTransactionDocumentSortInput = {
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  why?: InputMaybe<SortEnumType>;
};

export enum InventoryTransactionType {
  Allocated = 'ALLOCATED',
  Created = 'CREATED',
  Decremented = 'DECREMENTED',
  GradeChanged = 'GRADE_CHANGED',
  Incremented = 'INCREMENTED',
  Moved = 'MOVED',
  Scrapped = 'SCRAPPED',
  Set = 'SET',
  Unknown = 'UNKNOWN'
}

export type InventoryTransactionTypeOperationFilterInput = {
  eq?: InputMaybe<InventoryTransactionType>;
  in?: InputMaybe<Array<InventoryTransactionType>>;
  neq?: InputMaybe<InventoryTransactionType>;
  nin?: InputMaybe<Array<InventoryTransactionType>>;
};

/** A connection to a list of items. */
export type InventoryTransactionsConnection = {
  __typename?: 'InventoryTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InventoryTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InventoryTransactionsEdge = {
  __typename?: 'InventoryTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryTransactionDocument;
};

export type ItemAttributesData = {
  __typename?: 'ItemAttributesData';
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  containerConfigOverrides: Array<ItemContainerConfigOverrideData>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  discountable: Scalars['Boolean']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  royalty?: Maybe<RoyaltyConfig>;
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<Substitution>;
  taxable: Scalars['Boolean']['output'];
  upgrades: Array<ItemUpgrade>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One location/grade row of ALLOCATION-AWARE availability for an item. Quantity mirrors
 * InventoryItemDocument.AvailableQuantity (the live on-hand Quantity minus
 * AllocatedQuantity, reconciled by InventoryItemProjectionService) for that exact
 * (item, location, grade) key — the same number InventoryItemQuery.GetInventoryItems /
 * GetAvailableInventory already return to the add-items dialog (worksuite-pwa PR 13016), so
 * the order-line surfaces and the add-items dialog agree.
 */
export type ItemAvailabilityByLocationData = {
  __typename?: 'ItemAvailabilityByLocationData';
  grade: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
};

export type ItemAvailabilityDocument = {
  __typename?: 'ItemAvailabilityDocument';
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ItemAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ItemAvailabilityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemAvailabilityDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type ItemAvailabilityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  recordedAt?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

export type ItemBulkActionPayload = {
  __typename?: 'ItemBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  items?: Maybe<Array<ItemPayload>>;
};

export type ItemContainerConfigOverrideData = {
  __typename?: 'ItemContainerConfigOverrideData';
  containerCode: Scalars['String']['output'];
  maxLayersPerContainer?: Maybe<Scalars['Int']['output']>;
  maxTraysPerLayer?: Maybe<Scalars['Int']['output']>;
  shipFactor?: Maybe<Scalars['Int']['output']>;
  shipMinimum?: Maybe<Scalars['Int']['output']>;
  shippingConfigCategoryCode: Scalars['String']['output'];
  siteCode: Scalars['String']['output'];
  sizeUomCode: Scalars['String']['output'];
};

/**
 * Projection-side representation of an item-level ContainerConfig override.
 * Nullable numeric fields fall back to the inherited ContainerConfig value
 * when the user did not override them.
 */
export type ItemContainerConfigOverrideDocument = {
  __typename?: 'ItemContainerConfigOverrideDocument';
  containerCode: Scalars['String']['output'];
  maxLayersPerContainer?: Maybe<Scalars['Int']['output']>;
  maxTraysPerLayer?: Maybe<Scalars['Int']['output']>;
  shipFactor?: Maybe<Scalars['Int']['output']>;
  shipMinimum?: Maybe<Scalars['Int']['output']>;
  shippingConfigCategoryCode: Scalars['String']['output'];
  siteCode: Scalars['String']['output'];
  sizeUomCode: Scalars['String']['output'];
};

/**
 * Projection-side representation of an item-level ContainerConfig override.
 * Nullable numeric fields fall back to the inherited ContainerConfig value
 * when the user did not override them.
 */
export type ItemContainerConfigOverrideDocumentFilterInput = {
  and?: InputMaybe<Array<ItemContainerConfigOverrideDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  maxLayersPerContainer?: InputMaybe<IntOperationFilterInput>;
  maxTraysPerLayer?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ItemContainerConfigOverrideDocumentFilterInput>>;
  shipFactor?: InputMaybe<IntOperationFilterInput>;
  shipMinimum?: InputMaybe<IntOperationFilterInput>;
  shippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  siteCode?: InputMaybe<StringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
};

export type ItemContextNoteData = {
  __typename?: 'ItemContextNoteData';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ItemDocumentSize = {
  __typename?: 'ItemDocumentSize';
  code: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  uom: Scalars['Int']['output'];
};

export type ItemDocumentSizeFilterInput = {
  and?: InputMaybe<Array<ItemDocumentSizeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  eaches?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ItemDocumentSizeFilterInput>>;
  uom?: InputMaybe<IntOperationFilterInput>;
};

/**
 * A single erpId-to-itemId resolution returned by the itemIdsByErpId query.
 * Single-purpose by design (per the wsapi single-use type convention) — do not reuse for other surfaces.
 */
export type ItemErpIdPair = {
  __typename?: 'ItemErpIdPair';
  erpId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
};

export type ItemErpIdPayload = {
  __typename?: 'ItemErpIdPayload';
  erpId: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * One group header for the Fulfill Items list pane: the group's Key (also used as the
 * where equality value when lazy-loading the group's children via the items query), a
 * display Label, and the server-computed Count of items in the group under
 * the active search. For the Status dimension the Key is the
 * canonical GraphQL enum value (e.g. ACTIVE) the status eq filter expects.
 */
export type ItemGroupBucket = {
  __typename?: 'ItemGroupBucket';
  /** Number of items in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /**
   * Raw group key — the scalar sort-category string, the item group, or (for the Status dimension)
   * the canonical enum value. Doubles as the where: { <field>: { eq: Key } } filter value
   * the items list applies when lazy-loading the group's children.
   */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for the itemListGroups resolver. Mirrors the Fulfill Items list-pane
 * group-by options so the client can render server-computed group headers instead of loading every
 * item and grouping in memory. Each value buckets on a FLAT scalar field of
 * ItemSummaryDocument (no $lookup/$unwind), so every in-scope item lands
 * in exactly one bucket and sum(count) equals the unfiltered item total.
 */
export enum ItemGroupField {
  /**
   * One bucket per distinct SortCategory (the scalar sort-category
   * string — the item's category codes joined and ordered — NOT the multi-valued
   * Categories array).
   */
  Category = 'CATEGORY',
  /** One bucket per distinct Group (the item group). */
  Group = 'GROUP',
  /** One bucket per distinct Status (item lifecycle status). */
  Status = 'STATUS'
}

export type ItemLocationAvailabilityDocument = {
  __typename?: 'ItemLocationAvailabilityDocument';
  comment: Scalars['String']['output'];
  grade?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ItemLocationAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ItemLocationAvailabilityDocumentFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemLocationAvailabilityDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type ItemLocationAvailabilityDocumentSortInput = {
  comment?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  recordedAt?: InputMaybe<SortEnumType>;
  recordedBy?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

export type ItemPayload = {
  __typename?: 'ItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  item?: Maybe<ItemStateData>;
};

/** Represents the resolved price for a single item in a bulk pricing query. */
export type ItemPriceData = {
  __typename?: 'ItemPriceData';
  itemId: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

/**
 * Read-only diagnostic trace of how itemPrice resolved (or failed to resolve) a price for a
 * single item at a given location, date, and quantity. Surfaced by the itemPriceExplanation
 * query so a user can see exactly why an item priced the way it did (or didn't). The engine is not
 * changed: finalPrice here always equals what itemPrice returns for identical
 * inputs — this type only explains that number, it never alters it.
 */
export type ItemPriceExplanation = {
  __typename?: 'ItemPriceExplanation';
  /**
   * Levels in the resolved group targeting THIS item or one of its categories, each annotated with
   * why it did or didn't apply.
   */
  candidateLevels: Array<ExplainedLevel>;
  /**
   * Present exactly when the price came from the group's WHOLE-GROUP derivation ("this group =
   * group X minus N%") rather than from any of the group's own levels — i.e. exactly when
   * Outcome is PricedByDerivation. Carries the
   * reference group, the percentage, what the reference itself resolved to (and which of ITS levels
   * won), and the derived result, so the derivation is fully transparent without the caller
   * re-deriving it. None whenever the group's own levels priced the item, or nothing priced it.
   */
  derivation?: Maybe<DerivedPriceExplanation>;
  /**
   * The internal resolution error text — surfaced here instead of being swallowed to 0 by
   * itemPrice — or None when no error occurred.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * The resolved charge price. Always equal to what itemPrice returns for identical inputs
   * (0 when nothing priced, including the error and no-group cases).
   */
  finalPrice: Scalars['Decimal']['output'];
  /** The single, distinguishable reason this item did or did not price. */
  outcome: PriceResolutionOutcome;
  /**
   * The price group resolution landed on (id, name, hierarchy source), or None when no group was
   * found or resolution errored before a group could be resolved.
   */
  priceGroup?: Maybe<ResolvedPriceGroup>;
  /**
   * Levels in the resolved group targeting OTHER items (the near-duplicate hint). Each carries
   * DIFFERENT_TARGET and includes its targetName so a user can spot
   * a level configured on a near-identical item.
   */
  siblingLevels: Array<ExplainedLevel>;
  /** The price level whose grower sell price was charged, or None when nothing applied. */
  winningLevelId?: Maybe<Scalars['String']['output']>;
};

export type ItemPriceInput = {
  containerQuantity: Scalars['Int']['input'];
  endDate: Scalars['DateTime']['input'];
  erpItemId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  unitPrice: Scalars['Decimal']['input'];
};

/**
 * Flattened row for the Items page Pricing tab: a PriceLevel targeting the item
 * (directly or via one of its categories), joined with its parent PriceGroup
 * and the target's display name.
 */
export type ItemPriceLevelRow = {
  __typename?: 'ItemPriceLevelRow';
  /** Customer sell price override for this price level; null to fall back to default. */
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Effective end date of the price level; null for open-ended. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Grower cost for this price level; null when not configured. */
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  /** Grower sell price for this price level. */
  growerSellPrice: Scalars['Decimal']['output'];
  /** Fixed $/unit (default) vs percentage-off-a-reference-group. See PriceKind. */
  kind: PriceKind;
  /** Percentage discount value (4 = 4%); null for Fixed levels. */
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  /** Identifier of the parent PriceGroup. */
  priceGroupId: Scalars['String']['output'];
  /** Display name of the parent PriceGroup; empty string if the group is missing. */
  priceGroupName: Scalars['String']['output'];
  /** Identifier of the PriceLevel row. */
  priceLevelId: Scalars['String']['output'];
  /** Minimum quantity required to trigger this price level. */
  quantityThreshold: Scalars['Decimal']['output'];
  /** The price group this level discounts off of; null for Fixed levels. */
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  /** Effective start date of the price level. */
  startDate: Scalars['DateTime']['output'];
  /**
   * Target identifier. An item id when Type is TargetType.Item,
   * or a category code when Type is TargetType.Category.
   */
  targetId: Scalars['String']['output'];
  /**
   * Resolved display name for the target — the item's Name for item targets, the category Code
   * for category targets. Empty string when the referenced target is missing or soft-deleted.
   */
  targetName: Scalars['String']['output'];
  /**
   * Whether the PriceLevel targets an individual item or a category.
   * Determines how TargetId and TargetName are interpreted.
   */
  type: TargetType;
};

/**
 * Payload returned by the GetItemPrices bulk pricing query.
 * Contains either a list of item prices or validation errors.
 */
export type ItemPricesPayload = {
  __typename?: 'ItemPricesPayload';
  errors?: Maybe<Array<ValidationError>>;
  itemPrices?: Maybe<Array<ItemPriceData>>;
};

/**
 * Read-model document for one sales item's production mapping, keyed {tenantId}-{salesItemId}. The
 * composite _id embeds the tenant, so per-item reads filter on _id and cannot leak across tenants
 * (discipline acada0ab), and the id is cheap to compute from a (tenant, salesItemId) pair — the shape
 * W9 (Generate Forecast) and W17 (To PRODUCE export) join against. Taxonomy is never copied onto the
 * lines; each line carries only ProductionItemId and is enriched from the native ProductionItems
 * catalog at query time (W5).
 */
export type ItemProductionMappingDocument = {
  __typename?: 'ItemProductionMappingDocument';
  id: Scalars['String']['output'];
  lines: Array<ItemProductionMappingLineDocument>;
  salesItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * One mapping line of an item's production mapping. The optional ISO week window is stored as flat
 * nullable endpoints (all four set together or none); an empty regions list means all regions. The
 * production item taxonomy is resolved from the native catalog at query time, not stored on the line.
 */
export type ItemProductionMappingLineDocument = {
  __typename?: 'ItemProductionMappingLineDocument';
  endIsoWeek?: Maybe<Scalars['Int']['output']>;
  endIsoYear?: Maybe<Scalars['Int']['output']>;
  mixPct: Scalars['Decimal']['output'];
  /**
   * Resolves this mapping line's production item taxonomy from the native ProductionItems catalog,
   * batched and scoped to the calling tenant. Null when the referenced production item no longer exists.
   */
  productionItem?: Maybe<ProductionItemCatalogEntry>;
  productionItemId: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
  startIsoWeek?: Maybe<Scalars['Int']['output']>;
  startIsoYear?: Maybe<Scalars['Int']['output']>;
};

export type ItemProductionMappingLineStateData = {
  __typename?: 'ItemProductionMappingLineStateData';
  endIsoWeek?: Maybe<Scalars['Int']['output']>;
  endIsoYear?: Maybe<Scalars['Int']['output']>;
  mixPct: Scalars['Decimal']['output'];
  productionItemId: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
  startIsoWeek?: Maybe<Scalars['Int']['output']>;
  startIsoYear?: Maybe<Scalars['Int']['output']>;
};

export type ItemProductionMappingPayload = {
  __typename?: 'ItemProductionMappingPayload';
  errors?: Maybe<Array<ValidationError>>;
  mapping?: Maybe<ItemProductionMappingStateData>;
};

/**
 * GraphQL output shape returned by the setItemProductionMappings mutation: the item's full
 * mapping set after the command applied. Mirrors the aggregate state.
 */
export type ItemProductionMappingStateData = {
  __typename?: 'ItemProductionMappingStateData';
  lines: Array<ItemProductionMappingLineStateData>;
  salesItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ItemProgramDocument = {
  __typename?: 'ItemProgramDocument';
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  program: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ItemProgramDocumentFilterInput = {
  and?: InputMaybe<Array<ItemProgramDocumentFilterInput>>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemProgramDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ItemProgramDocumentSortInput = {
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ItemProgramsConnection = {
  __typename?: 'ItemProgramsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemProgramsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemProgramDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemProgramsEdge = {
  __typename?: 'ItemProgramsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemProgramDocument;
};

export type ItemRestockMetricsData = {
  __typename?: 'ItemRestockMetricsData';
  allocated: Scalars['Int']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

/**
 * Per-row failure surfaced by validateItemsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the
 * underlying ValidationError implements IFieldValidationError,
 * otherwise null.
 */
export type ItemStagedRowError = {
  __typename?: 'ItemStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type ItemStateData = {
  __typename?: 'ItemStateData';
  attributes: ItemAttributesData;
  availability: Array<InventoryAvailabilityData>;
  categories: Array<CategoryData>;
  cogs?: Maybe<Scalars['Decimal']['output']>;
  cogsGlAccountId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Array<ItemContextNoteData>;
  productGroup: Scalars['String']['output'];
  programs: Array<Scalars['String']['output']>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  sku: Scalars['String']['output'];
  status: ItemStatus;
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export enum ItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ItemStatusOperationFilterInput = {
  eq?: InputMaybe<ItemStatus>;
  in?: InputMaybe<Array<ItemStatus>>;
  neq?: InputMaybe<ItemStatus>;
  nin?: InputMaybe<Array<ItemStatus>>;
};

/**
 * HotChocolate join resolvers that inline the linked MergeDevAccountDocument
 * onto ItemSummaryDocument for the item's QuickBooks Income / COGS mappings.
 * Both resolvers return null when the corresponding id is unset or when the
 * referenced account is missing from the read model — the GraphQL field is nullable so
 * the unset case is observable to clients. Re-key (Helm 5c56fe08): the stored FK is the
 * target account's stable ImportId (the Merge.dev document id), so the lookup goes
 * through the shared MergeDevAccountsByImportId DataLoader keyed on
 * (TenantId, ImportId) — the mapping therefore survives the account being deleted
 * and recreated under a new random internal id. The tenant-scoped key keeps a batch from
 * leaking one tenant's account to another.
 */
export type ItemSummaryDocument = {
  __typename?: 'ItemSummaryDocument';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: Maybe<Scalars['Decimal']['output']>;
  cogsGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: Maybe<Scalars['String']['output']>;
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides: Array<ItemContainerConfigOverrideDocument>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  group: Scalars['String']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  programs?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  royalty?: Maybe<RoyaltyConfigDocument>;
  /** @deprecated Use RetailPrice instead. */
  sellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Array<ItemDocumentSize>>;
  sku: Scalars['String']['output'];
  sortCategory?: Maybe<Scalars['String']['output']>;
  status: ItemStatus;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<SubstitutionDocument>;
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

export type ItemSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<ItemSummaryDocumentFilterInput>>;
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: InputMaybe<StringOperationFilterInput>;
  commissionable?: InputMaybe<BooleanOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides?: InputMaybe<ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountable?: InputMaybe<BooleanOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  heightInches?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemLookupCode?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lengthInches?: InputMaybe<DecimalOperationFilterInput>;
  loadFactor?: InputMaybe<DecimalOperationFilterInput>;
  minShipQty?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemSummaryDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  royalty?: InputMaybe<RoyaltyConfigDocumentFilterInput>;
  sellPrice?: InputMaybe<DecimalOperationFilterInput>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes?: InputMaybe<ListStringOperationFilterInput>;
  shippingIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  sortCategory?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ItemStatusOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  substitution?: InputMaybe<SubstitutionDocumentFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  usedForRetail?: InputMaybe<BooleanOperationFilterInput>;
  weightLbs?: InputMaybe<DecimalOperationFilterInput>;
  widthInches?: InputMaybe<DecimalOperationFilterInput>;
};

export type ItemSummaryDocumentSortInput = {
  availableQuantity?: InputMaybe<SortEnumType>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: InputMaybe<SortEnumType>;
  commissionable?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discountable?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  heightInches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemLookupCode?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lengthInches?: InputMaybe<SortEnumType>;
  loadFactor?: InputMaybe<SortEnumType>;
  minShipQty?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  retailPrice?: InputMaybe<SortEnumType>;
  royalty?: InputMaybe<RoyaltyConfigDocumentSortInput>;
  sellPrice?: InputMaybe<SortEnumType>;
  shippingIncrement?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  sortCategory?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  substitution?: InputMaybe<SubstitutionDocumentSortInput>;
  taxable?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  usedForRetail?: InputMaybe<SortEnumType>;
  weightLbs?: InputMaybe<SortEnumType>;
  widthInches?: InputMaybe<SortEnumType>;
};

export enum ItemType {
  GrowItem = 'GROW_ITEM',
  MaterialItem = 'MATERIAL_ITEM',
  ReadyItem = 'READY_ITEM',
  Unknown = 'UNKNOWN'
}

export type ItemTypeOperationFilterInput = {
  eq?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  neq?: InputMaybe<ItemType>;
  nin?: InputMaybe<Array<ItemType>>;
};

export type ItemUpgrade = {
  __typename?: 'ItemUpgrade';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  isDefault: Scalars['Boolean']['output'];
  isExclusiveInCategory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pricing?: Maybe<ItemUpgradePricing>;
  status: ItemUpgradeStatus;
  upgradeId: Scalars['String']['output'];
};

export type ItemUpgradeCost = {
  __typename?: 'ItemUpgradeCost';
  labor?: Maybe<LaborMetric>;
  materialCost?: Maybe<Scalars['Decimal']['output']>;
};

export type ItemUpgradeCostDataInput = {
  labor?: InputMaybe<LaborMetricDataInput>;
  materialCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ItemUpgradeCostFilterInput = {
  and?: InputMaybe<Array<ItemUpgradeCostFilterInput>>;
  labor?: InputMaybe<OptionOfLaborMetricFilterInput>;
  materialCost?: InputMaybe<OptionOfDecimalFilterInput>;
  or?: InputMaybe<Array<ItemUpgradeCostFilterInput>>;
};

export type ItemUpgradeDataInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<ItemUpgradeCostDataInput>;
  isDefault?: Scalars['Boolean']['input'];
  isExclusiveInCategory?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pricing?: InputMaybe<ItemUpgradePricingDataInput>;
  upgradeId: Scalars['String']['input'];
};

export type ItemUpgradePricing = {
  __typename?: 'ItemUpgradePricing';
  flatPrice?: Maybe<Scalars['Decimal']['output']>;
  markupPercent?: Maybe<Scalars['Decimal']['output']>;
  mode: PricingMode;
};

export type ItemUpgradePricingDataInput = {
  flatPrice?: InputMaybe<Scalars['Decimal']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  mode: PricingMode;
};

export type ItemUpgradePricingFilterInput = {
  and?: InputMaybe<Array<ItemUpgradePricingFilterInput>>;
  flatPrice?: InputMaybe<OptionOfDecimalFilterInput>;
  markupPercent?: InputMaybe<OptionOfDecimalFilterInput>;
  mode?: InputMaybe<PricingModeOperationFilterInput>;
  or?: InputMaybe<Array<ItemUpgradePricingFilterInput>>;
};

export enum ItemUpgradeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocument = {
  __typename?: 'ItemWithRestockAvailabilityDocument';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: Maybe<Scalars['Decimal']['output']>;
  cogsGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: Maybe<Scalars['String']['output']>;
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides: Array<ItemContainerConfigOverrideDocument>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  group: Scalars['String']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  programs?: Maybe<Array<Scalars['String']['output']>>;
  restockAvailabilityByItemId?: Maybe<RestockAvailabilityByItemIdSummary>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  royalty?: Maybe<RoyaltyConfigDocument>;
  /** @deprecated Use RetailPrice instead. */
  sellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Array<ItemDocumentSize>>;
  sku: Scalars['String']['output'];
  sortCategory?: Maybe<Scalars['String']['output']>;
  status: ItemStatus;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<SubstitutionDocument>;
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentFilterInput>>;
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: InputMaybe<StringOperationFilterInput>;
  commissionable?: InputMaybe<BooleanOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides?: InputMaybe<ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountable?: InputMaybe<BooleanOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  heightInches?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemLookupCode?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lengthInches?: InputMaybe<DecimalOperationFilterInput>;
  loadFactor?: InputMaybe<DecimalOperationFilterInput>;
  minShipQty?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  restockAvailabilityByItemId?: InputMaybe<RestockAvailabilityByItemIdSummaryFilterInput>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  royalty?: InputMaybe<RoyaltyConfigDocumentFilterInput>;
  sellPrice?: InputMaybe<DecimalOperationFilterInput>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes?: InputMaybe<ListStringOperationFilterInput>;
  shippingIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  sortCategory?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ItemStatusOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  substitution?: InputMaybe<SubstitutionDocumentFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  usedForRetail?: InputMaybe<BooleanOperationFilterInput>;
  weightLbs?: InputMaybe<DecimalOperationFilterInput>;
  widthInches?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocumentSortInput = {
  availableQuantity?: InputMaybe<SortEnumType>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value and is distinct from
   * CogsGlAccountId, which is the QuickBooks GL account that this cost books to.
   */
  cogs?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) COGS GL-account id this item's cost-of-goods expense posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * cogsGlAccount resolver field.
   */
  cogsGlAccountId?: InputMaybe<SortEnumType>;
  commissionable?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discountable?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  heightInches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemLookupCode?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lengthInches?: InputMaybe<SortEnumType>;
  loadFactor?: InputMaybe<SortEnumType>;
  minShipQty?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  restockAvailabilityByItemId?: InputMaybe<RestockAvailabilityByItemIdSummarySortInput>;
  retailPrice?: InputMaybe<SortEnumType>;
  royalty?: InputMaybe<RoyaltyConfigDocumentSortInput>;
  sellPrice?: InputMaybe<SortEnumType>;
  shippingIncrement?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  sortCategory?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  substitution?: InputMaybe<SubstitutionDocumentSortInput>;
  taxable?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  usedForRetail?: InputMaybe<SortEnumType>;
  weightLbs?: InputMaybe<SortEnumType>;
  widthInches?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type ItemsWithBaseRateOfSaleConnection = {
  __typename?: 'ItemsWithBaseRateOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsWithBaseRateOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsWithBaseRateOfSaleEdge = {
  __typename?: 'ItemsWithBaseRateOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type ItemsWithRestockAvailabilityConnection = {
  __typename?: 'ItemsWithRestockAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsWithRestockAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemWithRestockAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsWithRestockAvailabilityEdge = {
  __typename?: 'ItemsWithRestockAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemWithRestockAvailabilityDocument;
};

export type IterationDocument = {
  __typename?: 'IterationDocument';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  entity: EntityType;
  erpBatchSize: Scalars['Int']['output'];
  erpFetchMs: Scalars['Long']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  items: Array<IterationItem>;
  itemsProcessed: Scalars['Long']['output'];
  retries: Scalars['Int']['output'];
  skippedItems: Array<IterationItem>;
  start: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  totalMs: Scalars['Long']['output'];
  workSuiteProcessMs: Scalars['Long']['output'];
};

export type IterationDocumentFilterInput = {
  and?: InputMaybe<Array<IterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  erpBatchSize?: InputMaybe<IntOperationFilterInput>;
  erpFetchMs?: InputMaybe<LongOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfIterationItemFilterInput>;
  itemsProcessed?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<IterationDocumentFilterInput>>;
  retries?: InputMaybe<IntOperationFilterInput>;
  skippedItems?: InputMaybe<ListFilterInputTypeOfIterationItemFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
  workSuiteProcessMs?: InputMaybe<LongOperationFilterInput>;
};

export type IterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  erpBatchSize?: InputMaybe<SortEnumType>;
  erpFetchMs?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemsProcessed?: InputMaybe<SortEnumType>;
  retries?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
  workSuiteProcessMs?: InputMaybe<SortEnumType>;
};

export type IterationItem = {
  __typename?: 'IterationItem';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IterationItemFilterInput = {
  and?: InputMaybe<Array<IterationItemFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IterationItemFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type JobCostPayload = {
  __typename?: 'JobCostPayload';
  errors?: Maybe<Array<ValidationError>>;
  jobCostRecord?: Maybe<JobCostRecordDocument>;
};

/**
 * Read-model projection of a single recorded job cost, written from the job cost ledger events
 * and queried to build a job's cost summary, breakdown, and timeline.
 */
export type JobCostRecordDocument = {
  __typename?: 'JobCostRecordDocument';
  /** Recorded cost amount. */
  amount: Scalars['Decimal']['output'];
  /** Accounting bucket (material, labor, or overhead) the cost rolls up into. */
  costCategory: CostCategory;
  /** Timestamp the record was created in the read model. */
  createdDate: Scalars['DateTime']['output'];
  /** Free-text description of the cost; None when not provided. */
  description?: Maybe<Scalars['String']['output']>;
  /** Headcount associated with a labor cost; None for non-labor costs. */
  headcount?: Maybe<Scalars['Int']['output']>;
  /** Composite primary key, {tenantId}-{recordId}. */
  id: Scalars['String']['output'];
  /** True when the amount is an estimate rather than a settled actual. */
  isEstimated: Scalars['Boolean']['output'];
  /**
   * True when this record is a compensating reversal of an earlier cost. A reversal carries a
   * negative amount that nets the reversed cost to zero. Additive — pre-feature documents missing
   * the field deserialize to false.
   */
  isReversal: Scalars['Boolean']['output'];
  /** Id of the production job the cost is attributed to. */
  jobId: Scalars['String']['output'];
  /** Quantity associated with the cost when applicable; None otherwise. */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  /** Unique id of this cost record. */
  recordId: Scalars['String']['output'];
  /** Business date the cost was incurred, used to bucket the cost timeline by week. */
  recordedDate: Scalars['DateTime']['output'];
  /** Id of the source record in the originating workflow. */
  sourceId: Scalars['String']['output'];
  /** Upstream workflow that produced the cost (purchase order, time entry, manual, etc.). */
  sourceType: CostSourceType;
  /** Optional subcategory used to group the cost in breakdowns; None when unspecified. */
  subcategory?: Maybe<Scalars['String']['output']>;
  /** The owning tenant id. */
  tenantId: Scalars['String']['output'];
  /** Unit of measure for Quantity; None when not unit-based. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Per-unit cost when applicable; None for costs that are not unit-priced. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Aggregated cost picture for a production job or lot — budget, actual, variance, and projected
 * figures per cost category plus completion context — surfaced to the cost-tracking UI.
 */
export type JobCostSummary = {
  __typename?: 'JobCostSummary';
  /** Alias for TotalBudget, exposed for callers expecting a single budget figure. */
  budgetAmount: Scalars['Decimal']['output'];
  /** Actual total cost per completed unit, or null when nothing has been produced yet. */
  effectiveCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /** True when any underlying cost record is an estimate rather than an actual. */
  hasEstimatedCosts: Scalars['Boolean']['output'];
  /** Labor budget/actual/variance/projected figures. */
  labor: JobCostValueModel;
  /** Actual labor cost incurred to date (flattened from Labor). */
  laborActual: Scalars['Decimal']['output'];
  /** Budgeted labor cost (flattened from Labor). */
  laborBudget: Scalars['Decimal']['output'];
  /** Projected labor cost at completion (flattened from Labor). */
  laborProjected: Scalars['Decimal']['output'];
  /** Labor cost variance, budget minus actual (flattened from Labor). */
  laborVariance: Scalars['Decimal']['output'];
  /** Material (raw goods) budget/actual/variance/projected figures. */
  material: JobCostValueModel;
  /** Actual material cost incurred to date (flattened from Material). */
  materialActual: Scalars['Decimal']['output'];
  /** Budgeted material cost (flattened from Material). */
  materialBudget: Scalars['Decimal']['output'];
  /** Projected material cost at completion (flattened from Material). */
  materialProjected: Scalars['Decimal']['output'];
  /** Material cost variance, budget minus actual (flattened from Material). */
  materialVariance: Scalars['Decimal']['output'];
  /** Overhead budget/actual/variance/projected figures. */
  overhead: JobCostValueModel;
  /** Actual overhead cost incurred to date (flattened from Overhead). */
  overheadActual: Scalars['Decimal']['output'];
  /** Budgeted overhead cost (flattened from Overhead). */
  overheadBudget: Scalars['Decimal']['output'];
  /** Projected overhead cost at completion (flattened from Overhead). */
  overheadProjected: Scalars['Decimal']['output'];
  /** Overhead cost variance, budget minus actual (flattened from Overhead). */
  overheadVariance: Scalars['Decimal']['output'];
  /** Quantity produced so far, used to weight the projected-at-completion figures. */
  quantityCompleted: Scalars['Decimal']['output'];
  /** Target quantity for the job or lot. */
  quantityTarget: Scalars['Decimal']['output'];
  /** Combined material, labor, and overhead figures. */
  total: JobCostValueModel;
  /** Total actual cost incurred to date across all categories (flattened from Total). */
  totalActual: Scalars['Decimal']['output'];
  /** Total budgeted cost across all categories (flattened from Total). */
  totalBudget: Scalars['Decimal']['output'];
  /** Total projected cost at completion across all categories (flattened from Total). */
  totalProjected: Scalars['Decimal']['output'];
  /** Total cost variance, budget minus actual (flattened from Total). */
  totalVariance: Scalars['Decimal']['output'];
};

/**
 * Budget-versus-actual figures for a single cost category (or the rolled-up total), used to
 * drive the per-category breakdown on a JobCostSummary.
 */
export type JobCostValueModel = {
  __typename?: 'JobCostValueModel';
  /** Actual cost incurred to date, summed from recorded cost entries. */
  actual: Scalars['Decimal']['output'];
  /** Budgeted cost for the category, resolved from recipe/site pricing. */
  budget: Scalars['Decimal']['output'];
  /** Projected cost at completion: actual plus the budgeted cost of the remaining (not-yet-produced) quantity. */
  projected: Scalars['Decimal']['output'];
  /** Budget minus actual; positive when under budget, negative when over. */
  variance: Scalars['Decimal']['output'];
};

export type JobData = {
  __typename?: 'JobData';
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  item: JobItem;
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrders: Array<WorkOrderData>;
};

export type JobDiffProjection = {
  __typename?: 'JobDiffProjection';
  changedVariations: Array<VariationDiffProjection>;
  currentRecipeVersion: Scalars['Int']['output'];
  removedVariations: Array<RemovedVariationProjection>;
};

export type JobDocument = {
  __typename?: 'JobDocument';
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  item: JobItem;
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderCount: Scalars['Int']['output'];
};

export type JobDocumentFilterInput = {
  and?: InputMaybe<Array<JobDocumentFilterInput>>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  item?: InputMaybe<JobItemFilterInput>;
  jobStatus?: InputMaybe<JobStatusOperationFilterInput>;
  jobType?: InputMaybe<JobTypeOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobDocumentFilterInput>>;
  productionQuantity?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  workOrderCount?: InputMaybe<IntOperationFilterInput>;
};

export type JobDocumentSortInput = {
  containerQuantity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<JobItemSortInput>;
  jobStatus?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionQuantity?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitOfMeasure?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  workOrderCount?: InputMaybe<SortEnumType>;
};

export enum JobExecutionStatus {
  Executed = 'EXECUTED',
  Executing = 'EXECUTING',
  Pending = 'PENDING'
}

export type JobExecutionStatusOperationFilterInput = {
  eq?: InputMaybe<JobExecutionStatus>;
  in?: InputMaybe<Array<JobExecutionStatus>>;
  neq?: InputMaybe<JobExecutionStatus>;
  nin?: InputMaybe<Array<JobExecutionStatus>>;
};

export type JobItem = {
  __typename?: 'JobItem';
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  genusCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type JobItemFilterInput = {
  and?: InputMaybe<Array<JobItemFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  genusCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobItemFilterInput>>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JobItemSortInput = {
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genusCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type JobPayload = {
  __typename?: 'JobPayload';
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<JobData>;
};

export enum JobPostingStatus {
  Closed = 'CLOSED',
  NotPosted = 'NOT_POSTED',
  PartiallyPosted = 'PARTIALLY_POSTED'
}

export type JobPostingStatusOperationFilterInput = {
  eq?: InputMaybe<JobPostingStatus>;
  in?: InputMaybe<Array<JobPostingStatus>>;
  neq?: InputMaybe<JobPostingStatus>;
  nin?: InputMaybe<Array<JobPostingStatus>>;
};

export enum JobStatus {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Finished = 'FINISHED',
  InProduction = 'IN_PRODUCTION',
  Planned = 'PLANNED',
  Released = 'RELEASED',
  Unknown = 'UNKNOWN'
}

export type JobStatusOperationFilterInput = {
  eq?: InputMaybe<JobStatus>;
  in?: InputMaybe<Array<JobStatus>>;
  neq?: InputMaybe<JobStatus>;
  nin?: InputMaybe<Array<JobStatus>>;
};

export enum JobType {
  Conventional = 'CONVENTIONAL',
  Organic = 'ORGANIC',
  Unknown = 'UNKNOWN'
}

export type JobTypeOperationFilterInput = {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
};

/** A connection to a list of items. */
export type JobsConnection = {
  __typename?: 'JobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<JobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type JobsEdge = {
  __typename?: 'JobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: JobDocument;
};

export type KeyValuePairOfStringAndAssignmentTaskSummary = {
  __typename?: 'KeyValuePairOfStringAndAssignmentTaskSummary';
  key: Scalars['String']['output'];
  value: AssignmentTaskSummary;
};

export type KeyValuePairOfStringAndHardgoodsBinBreakdown = {
  __typename?: 'KeyValuePairOfStringAndHardgoodsBinBreakdown';
  key: Scalars['String']['output'];
  value: HardgoodsBinBreakdown;
};

export type KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>>;
  value?: InputMaybe<HardgoodsBinBreakdownFilterInput>;
};

export type KeyValuePairOfStringAndInt32 = {
  __typename?: 'KeyValuePairOfStringAndInt32';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type KeyValuePairOfStringAndInt32FilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndInt32FilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndInt32FilterInput>>;
  value?: InputMaybe<IntOperationFilterInput>;
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines held against one
 * site, served by the kits and kit queries.
 */
export type KitDocument = {
  __typename?: 'KitDocument';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  kitId: Scalars['String']['output'];
  lines: Array<KitLineDocument>;
  name: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines held against one
 * site, served by the kits and kit queries.
 */
export type KitDocumentFilterInput = {
  and?: InputMaybe<Array<KitDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  kitId?: InputMaybe<StringOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfKitLineDocumentFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KitDocumentFilterInput>>;
  siteId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines held against one
 * site, served by the kits and kit queries.
 */
export type KitDocumentSortInput = {
  containerCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  kitId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type KitLineDataInput = {
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  eachesPerTray?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  kind: KitLineKind;
  label: Scalars['String']['input'];
  multiple: Scalars['Int']['input'];
  refId: Scalars['String']['input'];
  secondaryLabel?: InputMaybe<Scalars['String']['input']>;
  sizeCode?: InputMaybe<Scalars['String']['input']>;
  uomCode: KitLineUom;
};

/**
 * One line of a kit: either a catalog item or another kit nested inside it, with the multiple and
 * unit it is counted in plus the display snapshot captured when the line was saved.
 */
export type KitLineDocument = {
  __typename?: 'KitLineDocument';
  categoryCode?: Maybe<Scalars['String']['output']>;
  eachesPerTray?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind: KitLineKind;
  label: Scalars['String']['output'];
  multiple: Scalars['Int']['output'];
  refId: Scalars['String']['output'];
  secondaryLabel: Scalars['String']['output'];
  sizeCode?: Maybe<Scalars['String']['output']>;
  uomCode: KitLineUom;
};

/**
 * One line of a kit: either a catalog item or another kit nested inside it, with the multiple and
 * unit it is counted in plus the display snapshot captured when the line was saved.
 */
export type KitLineDocumentFilterInput = {
  and?: InputMaybe<Array<KitLineDocumentFilterInput>>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  eachesPerTray?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<KitLineKindOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  multiple?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<KitLineDocumentFilterInput>>;
  refId?: InputMaybe<StringOperationFilterInput>;
  secondaryLabel?: InputMaybe<StringOperationFilterInput>;
  sizeCode?: InputMaybe<StringOperationFilterInput>;
  uomCode?: InputMaybe<KitLineUomOperationFilterInput>;
};

export enum KitLineKind {
  Item = 'ITEM',
  Kit = 'KIT'
}

export type KitLineKindOperationFilterInput = {
  eq?: InputMaybe<KitLineKind>;
  in?: InputMaybe<Array<KitLineKind>>;
  neq?: InputMaybe<KitLineKind>;
  nin?: InputMaybe<Array<KitLineKind>>;
};

export type KitLineStateData = {
  __typename?: 'KitLineStateData';
  categoryCode?: Maybe<Scalars['String']['output']>;
  eachesPerTray?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind: KitLineKind;
  label: Scalars['String']['output'];
  multiple: Scalars['Int']['output'];
  refId: Scalars['String']['output'];
  secondaryLabel: Scalars['String']['output'];
  sizeCode?: Maybe<Scalars['String']['output']>;
  uomCode: KitLineUom;
};

export enum KitLineUom {
  Each = 'EACH',
  Kit = 'KIT',
  Layer = 'LAYER',
  Tray = 'TRAY'
}

export type KitLineUomOperationFilterInput = {
  eq?: InputMaybe<KitLineUom>;
  in?: InputMaybe<Array<KitLineUom>>;
  neq?: InputMaybe<KitLineUom>;
  nin?: InputMaybe<Array<KitLineUom>>;
};

export type KitPayload = {
  __typename?: 'KitPayload';
  errors?: Maybe<Array<ValidationError>>;
  kit?: Maybe<KitStateData>;
};

export type KitStateData = {
  __typename?: 'KitStateData';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  kitId: Scalars['String']['output'];
  lines: Array<KitLineStateData>;
  name: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type KitsConnection = {
  __typename?: 'KitsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KitsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KitDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KitsEdge = {
  __typename?: 'KitsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KitDocument;
};

export type LaborDemandCalcStep = {
  __typename?: 'LaborDemandCalcStep';
  code: Scalars['String']['output'];
  context: Array<LaborDemandCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: LaborDemandCalcStepSeverity;
};

export type LaborDemandCalcStepContextEntry = {
  __typename?: 'LaborDemandCalcStepContextEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum LaborDemandCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type LaborDemandEntry = {
  __typename?: 'LaborDemandEntry';
  blockName: Scalars['String']['output'];
  calcSteps: Array<LaborDemandCalcStep>;
  date: Scalars['DateTime']['output'];
  eventSource: LaborDemandEventSource;
  plannedCost: Scalars['Decimal']['output'];
  plannedHours: Scalars['Decimal']['output'];
  productionJobId: Scalars['String']['output'];
  productionJobName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  taskEventTypeId: Scalars['String']['output'];
  taskEventTypeName: Scalars['String']['output'];
  /**
   * The resolved trigger date for this event on this job (anchor week date ± the event's trigger
   * offset), computed via ProductionTriggerDateResolver. Null when the event has no active
   * detail with a resolvable trigger — callers then fall back to Date (WeekReady).
   */
  triggerDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum LaborDemandEventSource {
  AdHoc = 'AD_HOC',
  Manual = 'MANUAL',
  Recipe = 'RECIPE'
}

export type LaborDemandSummary = {
  __typename?: 'LaborDemandSummary';
  entries: Array<LaborDemandEntry>;
  totalPlannedCost: Scalars['Decimal']['output'];
  totalPlannedHours: Scalars['Decimal']['output'];
};

export type LaborMetric = {
  __typename?: 'LaborMetric';
  laborTypeCode: Scalars['String']['output'];
  minutes: Scalars['Decimal']['output'];
};

export type LaborMetricDataInput = {
  laborTypeCode: Scalars['String']['input'];
  minutes: Scalars['Decimal']['input'];
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocument = {
  __typename?: 'LaborRateDocument';
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocumentFilterInput = {
  and?: InputMaybe<Array<LaborRateDocumentFilterInput>>;
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaborRateDocumentFilterInput>>;
  ratePerHour?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocumentSortInput = {
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveTo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborTypeId?: InputMaybe<SortEnumType>;
  ratePerHour?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LaborRatesConnection = {
  __typename?: 'LaborRatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LaborRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LaborRateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LaborRatesEdge = {
  __typename?: 'LaborRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LaborRateDocument;
};

export type LaborTypeDataInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Denormalized labor type reference stored within a site location document. */
export type LaborTypeDocumentData = {
  __typename?: 'LaborTypeDocumentData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Denormalized labor type reference stored within a site location document. */
export type LaborTypeDocumentDataFilterInput = {
  and?: InputMaybe<Array<LaborTypeDocumentDataFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaborTypeDocumentDataFilterInput>>;
};

export type LaborTypeStateData = {
  __typename?: 'LaborTypeStateData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguagePreference {
  En = 'EN',
  Es = 'ES'
}

export type LanguagePreferenceOperationFilterInput = {
  eq?: InputMaybe<LanguagePreference>;
  in?: InputMaybe<Array<LanguagePreference>>;
  neq?: InputMaybe<LanguagePreference>;
  nin?: InputMaybe<Array<LanguagePreference>>;
};

/** Why a single price level did or did not contribute to the resolved price. */
export enum LevelStatus {
  /** Applied — in the winning tier and passing the date and quantity filters. */
  Applied = 'APPLIED',
  /** A sibling level targeting a different item (near-duplicate hint). */
  DifferentTarget = 'DIFFERENT_TARGET',
  /** The order date is after the level's end date. */
  Ended = 'ENDED',
  /**
   * A CategoryVolume level — never a candidate for a per-line
   * price. Evaluated only order-wide by the volume-discount engine, so it always shows here as
   * excluded even when its own date/quantity clauses would otherwise pass.
   */
  ExcludedCategoryVolume = 'EXCLUDED_CATEGORY_VOLUME',
  /** The order date is before the level's start date. */
  NotStarted = 'NOT_STARTED',
  /** A category-tier level shadowed by an item-specific level (most-specific-wins). */
  OutrankedByItemTier = 'OUTRANKED_BY_ITEM_TIER',
  /** The order quantity is below the level's quantity threshold. */
  QtyBelowThreshold = 'QTY_BELOW_THRESHOLD'
}

/** Represents the actual quantity available for a line item after considering allocations */
export type LineItemActualQuantityDocument = {
  __typename?: 'LineItemActualQuantityDocument';
  actualQuantity: Scalars['Decimal']['output'];
  availableQuantity: Scalars['Decimal']['output'];
  grade?: Maybe<Scalars['Int']['output']>;
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  reservedQuantity: Scalars['Decimal']['output'];
};

export type LineItemData = {
  __typename?: 'LineItemData';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  /**
   * The quantity of this line's item currently available across all locations and grades — the
   * per-line "Available Number", matching OrderLineItemDocument.available exactly. Resolved
   * at read time from the live, ALLOCATION-AWARE InventoryItem read model (summed over
   * every location/grade row for the item) via the shared, batched availability DataLoader. The
   * sum is rounded to the nearest whole unit to preserve this field's existing Int shape;
   * see availableByLocation for the un-rounded, per-location breakdown. A site-assigned
   * caller only sees rows for their assigned locations (same fail-closed scope as the add-items
   * dialog). Returns 0 when the line carries no item id or the item has no inventory rows
   * in scope.
   */
  available: Scalars['Int']['output'];
  /**
   * The allocation-aware available quantity for this line's item, broken out per location/grade —
   * the un-summed rows behind available. Sourced from the same InventoryItemDocument
   * read model as the add-items dialog, via a batched DataLoader (no N+1 across order lines), and
   * scoped to the caller's assigned locations exactly as the dialog is. Returns an empty list when
   * the line carries no item id or the item has no inventory rows in scope.
   */
  availableByLocation: Array<ItemAvailabilityByLocationData>;
  capturedTaxAuthorities: Array<OrderLineTaxCaptureData>;
  category?: Maybe<Scalars['String']['output']>;
  containerCode?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eaches: Scalars['Int']['output'];
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  fulfillmentSource: FulfillmentSource;
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * The line item's Item Income GL account resolved to its Merge.dev account RemoteId, for the
   * outbound order export. Null when the line item has no matching Item, the Item has no
   * IncomeGlAccountId, or no MergeDevAccount matches — the downstream wsapi-services handler
   * owns the unmapped fallback (warn + omit). Output-only field (never on LineItemDataInput);
   * the resolver is tenant-scoped, so a batch cannot leak one tenant's account into another.
   */
  incomeGlAccountRemoteId?: Maybe<Scalars['String']['output']>;
  isTaxableInPricing?: Maybe<Scalars['Boolean']['output']>;
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  kitGroupId?: Maybe<Scalars['String']['output']>;
  kitId?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteData>;
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  productionCatalogId?: Maybe<Scalars['String']['output']>;
  productionCategoryId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  royalty?: Maybe<LineItemRoyaltyData>;
  royaltyExempt: Scalars['Boolean']['output'];
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  upgrades: Array<OrderLineUpgradeData>;
};

export type LineItemNoteData = {
  __typename?: 'LineItemNoteData';
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type LineItemNoteDocument = {
  __typename?: 'LineItemNoteDocument';
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type LineItemNoteDocumentFilterInput = {
  and?: InputMaybe<Array<LineItemNoteDocumentFilterInput>>;
  noteText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LineItemNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
};

export type LineItemNoteDocumentSortInput = {
  noteText?: InputMaybe<SortEnumType>;
  submitDate?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
};

export type LineItemRoyaltyData = {
  __typename?: 'LineItemRoyaltyData';
  amount: Scalars['Decimal']['output'];
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/**
 * Frozen snapshot of an item's royalty terms at line-add time. Amount is the
 * calculated royalty amount for the line at that moment.
 */
export type LineItemRoyaltyDocument = {
  __typename?: 'LineItemRoyaltyDocument';
  amount: Scalars['Decimal']['output'];
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/**
 * Frozen snapshot of an item's royalty terms at line-add time. Amount is the
 * calculated royalty amount for the line at that moment.
 */
export type LineItemRoyaltyDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<LineItemRoyaltyDocumentFilterInput>>;
  or?: InputMaybe<Array<LineItemRoyaltyDocumentFilterInput>>;
  payeeName?: InputMaybe<StringOperationFilterInput>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
  rateType?: InputMaybe<RoyaltyRateTypeOperationFilterInput>;
};

/**
 * Frozen snapshot of an item's royalty terms at line-add time. Amount is the
 * calculated royalty amount for the line at that moment.
 */
export type LineItemRoyaltyDocumentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  payeeName?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  rateType?: InputMaybe<SortEnumType>;
};

export type LineItemUpdateDataInput = {
  department: Scalars['String']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  notes: Array<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type LinkAllocationDataInput = {
  duration: Scalars['TimeSpan']['input'];
  taskAssignmentId: Scalars['String']['input'];
  timeEntryId: Scalars['String']['input'];
};

export type LinkFloatingTimeEntryInput = {
  allocations: Array<LinkAllocationDataInput>;
  floatingTimeEntryId: Scalars['String']['input'];
};

export type LinkFusionAuthUserByEmailInput = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type LinkFusionAuthUserInput = {
  fusionAuthUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Input for linking multiple production items to one sales item. */
export type LinkProductionItemsToSalesItemInput = {
  productionItemIds: Array<Scalars['String']['input']>;
  salesItemId: Scalars['String']['input'];
};

/** Bulk payload returning the resulting production item states and any per-command errors. */
export type LinkProductionItemsToSalesItemPayload = {
  __typename?: 'LinkProductionItemsToSalesItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionItems: Array<ProductionItemStateData>;
};

export type LinksOverride = {
  __typename?: 'LinksOverride';
  linkId: Scalars['String']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type LinksOverrideFilterInput = {
  and?: InputMaybe<Array<LinksOverrideFilterInput>>;
  linkId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LinksOverrideFilterInput>>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

export type ListAllocationPriorityDimensionOperationFilterInput = {
  all?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
  some?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
};

export type ListFilterInputTypeOfAdminRestockCalcResultInputDocumentFilterInput = {
  all?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
  some?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
};

export type ListFilterInputTypeOfAllocationLineItemDataFilterInput = {
  all?: InputMaybe<AllocationLineItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AllocationLineItemDataFilterInput>;
  some?: InputMaybe<AllocationLineItemDataFilterInput>;
};

export type ListFilterInputTypeOfBpfStartingNodeDocumentFilterInput = {
  all?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
  some?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
};

export type ListFilterInputTypeOfCustomerCommissionOverrideDataFilterInput = {
  all?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
  some?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
};

export type ListFilterInputTypeOfCustomerLocationContextNoteDocumentFilterInput = {
  all?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
  some?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfCustomerLocationNoteDocumentFilterInput = {
  all?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
  some?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfCycleCountLogItemFilterInput = {
  all?: InputMaybe<CycleCountLogItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CycleCountLogItemFilterInput>;
  some?: InputMaybe<CycleCountLogItemFilterInput>;
};

export type ListFilterInputTypeOfDbrCalcResultInputDocumentFilterInput = {
  all?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
  some?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
};

export type ListFilterInputTypeOfDestinationConfigDataFilterInput = {
  all?: InputMaybe<DestinationConfigDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DestinationConfigDataFilterInput>;
  some?: InputMaybe<DestinationConfigDataFilterInput>;
};

export type ListFilterInputTypeOfEmailSendRecipientDocumentFilterInput = {
  all?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
  some?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
};

export type ListFilterInputTypeOfEntityMappingDataFilterInput = {
  all?: InputMaybe<EntityMappingDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EntityMappingDataFilterInput>;
  some?: InputMaybe<EntityMappingDataFilterInput>;
};

export type ListFilterInputTypeOfErpLoadListRouteDataFilterInput = {
  all?: InputMaybe<ErpLoadListRouteDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErpLoadListRouteDataFilterInput>;
  some?: InputMaybe<ErpLoadListRouteDataFilterInput>;
};

export type ListFilterInputTypeOfErpOrderLineFilterInput = {
  all?: InputMaybe<ErpOrderLineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErpOrderLineFilterInput>;
  some?: InputMaybe<ErpOrderLineFilterInput>;
};

export type ListFilterInputTypeOfEventAssignmentOverrideDocumentFilterInput = {
  all?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
  some?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
};

export type ListFilterInputTypeOfFavoritesListItemDocumentFilterInput = {
  all?: InputMaybe<FavoritesListItemDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FavoritesListItemDocumentFilterInput>;
  some?: InputMaybe<FavoritesListItemDocumentFilterInput>;
};

export type ListFilterInputTypeOfFieldMappingDataFilterInput = {
  all?: InputMaybe<FieldMappingDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldMappingDataFilterInput>;
  some?: InputMaybe<FieldMappingDataFilterInput>;
};

export type ListFilterInputTypeOfFloatingTimeEntryAllocationDocumentFilterInput = {
  all?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
  some?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
};

export type ListFilterInputTypeOfGrowWeeksOverrideFilterInput = {
  all?: InputMaybe<GrowWeeksOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GrowWeeksOverrideFilterInput>;
  some?: InputMaybe<GrowWeeksOverrideFilterInput>;
};

export type ListFilterInputTypeOfInventoryAllocationDocumentFilterInput = {
  all?: InputMaybe<InventoryAllocationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryAllocationDocumentFilterInput>;
  some?: InputMaybe<InventoryAllocationDocumentFilterInput>;
};

export type ListFilterInputTypeOfInventoryNoteDocumentFilterInput = {
  all?: InputMaybe<InventoryNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryNoteDocumentFilterInput>;
  some?: InputMaybe<InventoryNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfInventorySourceJobContributionDocumentFilterInput = {
  all?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
  some?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput = {
  all?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
  some?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemDocumentSizeFilterInput = {
  all?: InputMaybe<ItemDocumentSizeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemDocumentSizeFilterInput>;
  some?: InputMaybe<ItemDocumentSizeFilterInput>;
};

export type ListFilterInputTypeOfIterationItemFilterInput = {
  all?: InputMaybe<IterationItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IterationItemFilterInput>;
  some?: InputMaybe<IterationItemFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndInt32FilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
};

export type ListFilterInputTypeOfKitLineDocumentFilterInput = {
  all?: InputMaybe<KitLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KitLineDocumentFilterInput>;
  some?: InputMaybe<KitLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfLaborTypeDocumentDataFilterInput = {
  all?: InputMaybe<LaborTypeDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LaborTypeDocumentDataFilterInput>;
  some?: InputMaybe<LaborTypeDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfLinksOverrideFilterInput = {
  all?: InputMaybe<LinksOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LinksOverrideFilterInput>;
  some?: InputMaybe<LinksOverrideFilterInput>;
};

export type ListFilterInputTypeOfLockedLocationOverrideFilterInput = {
  all?: InputMaybe<LockedLocationOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LockedLocationOverrideFilterInput>;
  some?: InputMaybe<LockedLocationOverrideFilterInput>;
};

export type ListFilterInputTypeOfMatchCandidateDocumentFilterInput = {
  all?: InputMaybe<MatchCandidateDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MatchCandidateDocumentFilterInput>;
  some?: InputMaybe<MatchCandidateDocumentFilterInput>;
};

export type ListFilterInputTypeOfMaterialVendorDataFilterInput = {
  all?: InputMaybe<MaterialVendorDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MaterialVendorDataFilterInput>;
  some?: InputMaybe<MaterialVendorDataFilterInput>;
};

export type ListFilterInputTypeOfMergeDevPaymentAppliedLineDocumentFilterInput = {
  all?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
  some?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfMongoAggregationFieldDocumentDataFilterInput = {
  all?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
  some?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMongoColumnMapDocumentDataFilterInput = {
  all?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
  some?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMongoDestinationDocumentDataFilterInput = {
  all?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
  some?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput = {
  all?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
  some?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeDiscountDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeLineDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeProgressDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderContextNoteDocumentFilterInput = {
  all?: InputMaybe<OrderContextNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderContextNoteDocumentFilterInput>;
  some?: InputMaybe<OrderContextNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderLineTaxCaptureDocumentFilterInput = {
  all?: InputMaybe<OrderLineTaxCaptureDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderLineTaxCaptureDocumentFilterInput>;
  some?: InputMaybe<OrderLineTaxCaptureDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderLineUpgradeDocumentFilterInput = {
  all?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
  some?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderNonDiscountableLineDocumentFilterInput = {
  all?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
  some?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderPaymentEntryDocumentFilterInput = {
  all?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
  some?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderTaxAuthorityTotalDocumentFilterInput = {
  all?: InputMaybe<OrderTaxAuthorityTotalDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderTaxAuthorityTotalDocumentFilterInput>;
  some?: InputMaybe<OrderTaxAuthorityTotalDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderVolumeLineDocumentFilterInput = {
  all?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
  some?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfPendingTransferOrderLineDocumentFilterInput = {
  all?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
  some?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfPlantsPerPotOverrideFilterInput = {
  all?: InputMaybe<PlantsPerPotOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PlantsPerPotOverrideFilterInput>;
  some?: InputMaybe<PlantsPerPotOverrideFilterInput>;
};

export type ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput = {
  all?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
  some?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfProductionItemEventAttachmentDocumentFilterInput = {
  all?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
  some?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobAdjustmentDocumentFilterInput = {
  all?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
  some?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput = {
  all?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
  some?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobPostedLineDocumentFilterInput = {
  all?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
  some?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobShrinkEventDocumentFilterInput = {
  all?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
  some?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionRecipeLinkDataFilterInput = {
  all?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
  some?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceFieldFilterInput = {
  all?: InputMaybe<ReportDataSourceFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceFieldFilterInput>;
  some?: InputMaybe<ReportDataSourceFieldFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceParameterFilterInput = {
  all?: InputMaybe<ReportDataSourceParameterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceParameterFilterInput>;
  some?: InputMaybe<ReportDataSourceParameterFilterInput>;
};

export type ListFilterInputTypeOfRestockCalcStepContextEntryFilterInput = {
  all?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
  some?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
};

export type ListFilterInputTypeOfRestockCalcStepFilterInput = {
  all?: InputMaybe<RestockCalcStepFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockCalcStepFilterInput>;
  some?: InputMaybe<RestockCalcStepFilterInput>;
};

export type ListFilterInputTypeOfRestockSessionReserveRuleDocumentFilterInput = {
  all?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
  some?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
};

export type ListFilterInputTypeOfSalesPersonDataFilterInput = {
  all?: InputMaybe<SalesPersonDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesPersonDataFilterInput>;
  some?: InputMaybe<SalesPersonDataFilterInput>;
};

export type ListFilterInputTypeOfScheduledOrderDataFilterInput = {
  all?: InputMaybe<ScheduledOrderDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ScheduledOrderDataFilterInput>;
  some?: InputMaybe<ScheduledOrderDataFilterInput>;
};

export type ListFilterInputTypeOfSiteContactDocumentDataFilterInput = {
  all?: InputMaybe<SiteContactDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteContactDocumentDataFilterInput>;
  some?: InputMaybe<SiteContactDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfSiteLaborRateDocumentDataFilterInput = {
  all?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
  some?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfSqlColumnMapDataFilterInput = {
  all?: InputMaybe<SqlColumnMapDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SqlColumnMapDataFilterInput>;
  some?: InputMaybe<SqlColumnMapDataFilterInput>;
};

export type ListFilterInputTypeOfTaxRateEntryDocumentFilterInput = {
  all?: InputMaybe<TaxRateEntryDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TaxRateEntryDocumentFilterInput>;
  some?: InputMaybe<TaxRateEntryDocumentFilterInput>;
};

export type ListFilterInputTypeOfTenantSubscriptionItemDataFilterInput = {
  all?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
  some?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
};

export type ListFilterInputTypeOfUserInviteRegistrationDocumentDataFilterInput = {
  all?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
  some?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderItemDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderReceiptDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
};

export type ListFilterInputTypeOfVerifyContainerOrderAssociationDocumentFilterInput = {
  all?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
  some?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
};

export type ListFilterInputTypeOfVerifyContainerScanDocumentFilterInput = {
  all?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
  some?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderBuildItemDataFilterInput = {
  all?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
  some?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListUserRoleOperationFilterInput = {
  all?: InputMaybe<UserRoleOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserRoleOperationFilterInput>;
  some?: InputMaybe<UserRoleOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocationData = {
  __typename?: 'LocationData';
  adGroup: Scalars['String']['output'];
  address: CreateAddress;
  allowOrderBillingAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  allowOrderLocationAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  locationLookupCode?: Maybe<Scalars['String']['output']>;
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  salesPeople: Array<SalesPersonData>;
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<CustomerLocationSettingsData>;
  storeNumber: Scalars['String']['output'];
  taxAuthorityIds?: Maybe<Array<Scalars['String']['output']>>;
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
};

export type LocationDataInput = {
  adGroup: Scalars['String']['input'];
  address: CreateAddressInput;
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  globalLocationNumber: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  locationLookupCode?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  name: Scalars['String']['input'];
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  priceGroupName?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPeople: Array<SalesPersonDataInput>;
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CustomerLocationSettingsDataInput>;
  storeNumber: Scalars['String']['input'];
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  termsName?: InputMaybe<Scalars['String']['input']>;
};

export type LocationDocument = {
  __typename?: 'LocationDocument';
  address?: Maybe<AddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationType: LocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  siteParentId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LocationDocumentFilterInput = {
  address?: InputMaybe<AddressDataFilterInput>;
  and?: InputMaybe<Array<LocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<LocationTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationDocumentFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  siteParentId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type LocationDocumentSortInput = {
  address?: InputMaybe<AddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  siteParentId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocument = {
  __typename?: 'LocationOverheadRateDocument';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocumentFilterInput = {
  and?: InputMaybe<Array<LocationOverheadRateDocumentFilterInput>>;
  costPerSqFtPerWeek?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationOverheadRateDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocumentSortInput = {
  costPerSqFtPerWeek?: InputMaybe<SortEnumType>;
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveTo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationOverheadRatesConnection = {
  __typename?: 'LocationOverheadRatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationOverheadRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationOverheadRateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationOverheadRatesEdge = {
  __typename?: 'LocationOverheadRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationOverheadRateDocument;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  location?: Maybe<LocationDocument>;
};

export type LocationStateData = {
  __typename?: 'LocationStateData';
  capacity: Scalars['Decimal']['output'];
  erpId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationType: SiteLocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  status: LocationStatus;
};

export enum LocationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type LocationStatusOperationFilterInput = {
  eq?: InputMaybe<LocationStatus>;
  in?: InputMaybe<Array<LocationStatus>>;
  neq?: InputMaybe<LocationStatus>;
  nin?: InputMaybe<Array<LocationStatus>>;
};

export enum LocationType {
  Aisle = 'AISLE',
  Bay = 'BAY',
  Bin = 'BIN',
  Customer = 'CUSTOMER',
  Field = 'FIELD',
  House = 'HOUSE',
  Section = 'SECTION',
  ShipTo = 'SHIP_TO',
  Site = 'SITE',
  Staging = 'STAGING',
  Unknown = 'UNKNOWN',
  Warehouse = 'WAREHOUSE'
}

export type LocationTypeOperationFilterInput = {
  eq?: InputMaybe<LocationType>;
  in?: InputMaybe<Array<LocationType>>;
  neq?: InputMaybe<LocationType>;
  nin?: InputMaybe<Array<LocationType>>;
};

/** A connection to a list of items. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationDocument;
};

/** A connection to a list of items. */
export type LocationsSalesPeopleConnection = {
  __typename?: 'LocationsSalesPeopleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsSalesPeopleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationsSalesPersonDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsSalesPeopleEdge = {
  __typename?: 'LocationsSalesPeopleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationsSalesPersonDocument;
};

export type LocationsSalesPersonDocument = {
  __typename?: 'LocationsSalesPersonDocument';
  code: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  salesPersonEmails: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type LocationsSalesPersonDocumentFilterInput = {
  and?: InputMaybe<Array<LocationsSalesPersonDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationsSalesPersonDocumentFilterInput>>;
  salesPersonEmails?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type LocationsSalesPersonDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type LockedAlgorithmSettings = {
  __typename?: 'LockedAlgorithmSettings';
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  trailingDaysThisYear: Scalars['Int']['output'];
};

export type LockedAlgorithmSettingsFilterInput = {
  and?: InputMaybe<Array<LockedAlgorithmSettingsFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LockedAlgorithmSettingsFilterInput>>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
};

export type LockedAlgorithmSettingsSortInput = {
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
};

export type LockedBusinessRules = {
  __typename?: 'LockedBusinessRules';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  roundToFullCart: Scalars['Boolean']['output'];
  shipmentIncrement: Scalars['Int']['output'];
};

export type LockedBusinessRulesFilterInput = {
  allocationPriorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  allocationReservationPercentage?: InputMaybe<DecimalOperationFilterInput>;
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<LockedBusinessRulesFilterInput>>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LockedBusinessRulesFilterInput>>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
};

export type LockedBusinessRulesSortInput = {
  allocationReservationPercentage?: InputMaybe<SortEnumType>;
  allocationType?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
};

export type LockedLocationOverride = {
  __typename?: 'LockedLocationOverride';
  customerLocationId: Scalars['String']['output'];
};

export type LockedLocationOverrideFilterInput = {
  and?: InputMaybe<Array<LockedLocationOverrideFilterInput>>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LockedLocationOverrideFilterInput>>;
};

export type LockedRestockConfig = {
  __typename?: 'LockedRestockConfig';
  algorithmSettings: LockedAlgorithmSettings;
  businessRules: LockedBusinessRules;
  locationOverrides: Array<LockedLocationOverride>;
  providerConfigJson: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
};

export type LockedRestockConfigFilterInput = {
  algorithmSettings?: InputMaybe<LockedAlgorithmSettingsFilterInput>;
  and?: InputMaybe<Array<LockedRestockConfigFilterInput>>;
  businessRules?: InputMaybe<LockedBusinessRulesFilterInput>;
  locationOverrides?: InputMaybe<ListFilterInputTypeOfLockedLocationOverrideFilterInput>;
  or?: InputMaybe<Array<LockedRestockConfigFilterInput>>;
  providerConfigJson?: InputMaybe<StringOperationFilterInput>;
  providerKey?: InputMaybe<StringOperationFilterInput>;
};

export type LockedRestockConfigSortInput = {
  algorithmSettings?: InputMaybe<LockedAlgorithmSettingsSortInput>;
  businessRules?: InputMaybe<LockedBusinessRulesSortInput>;
  providerConfigJson?: InputMaybe<SortEnumType>;
  providerKey?: InputMaybe<SortEnumType>;
};

export type LogoImageDataInput = {
  image: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export enum LotClosedStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  PartiallyPosted = 'PARTIALLY_POSTED'
}

export type LotClosedStatusOperationFilterInput = {
  eq?: InputMaybe<LotClosedStatus>;
  in?: InputMaybe<Array<LotClosedStatus>>;
  neq?: InputMaybe<LotClosedStatus>;
  nin?: InputMaybe<Array<LotClosedStatus>>;
};

/**
 * Result of a connect/disconnect mutation: the resulting mailbox status (connected flag + address,
 * never tokens) or the validation error(s) that stopped it.
 */
export type M365MailboxConnectPayload = {
  __typename?: 'M365MailboxConnectPayload';
  errors?: Maybe<Array<ValidationError>>;
  status?: Maybe<M365MailboxStatus>;
};

/**
 * GraphQL view of a user's M365 mailbox connection: whether it is connected and, when it is, the
 * mailbox address. Never carries tokens.
 */
export type M365MailboxStatus = {
  __typename?: 'M365MailboxStatus';
  connected: Scalars['Boolean']['output'];
  mailboxAddress?: Maybe<Scalars['String']['output']>;
};

export type MakeSessionLiveInput = {
  comment: Scalars['String']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocument = {
  __typename?: 'MakeToOrderPlanDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: Maybe<Scalars['String']['output']>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  /** The unmet remainder this plan covers. */
  quantity: Scalars['Int']['output'];
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: Maybe<Scalars['String']['output']>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocumentFilterInput = {
  and?: InputMaybe<Array<MakeToOrderPlanDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: InputMaybe<OptionOfStringFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MakeToOrderPlanDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderLineId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: InputMaybe<OptionOfStringFilterInput>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** The unmet remainder this plan covers. */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: InputMaybe<OptionOfStringFilterInput>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderLineId?: InputMaybe<SortEnumType>;
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: InputMaybe<SortEnumType>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  /** The unmet remainder this plan covers. */
  quantity?: InputMaybe<SortEnumType>;
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: InputMaybe<SortEnumType>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MakeToOrderPlansConnection = {
  __typename?: 'MakeToOrderPlansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MakeToOrderPlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MakeToOrderPlanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MakeToOrderPlansEdge = {
  __typename?: 'MakeToOrderPlansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MakeToOrderPlanDocument;
};

/**
 * Reason a ManifestChangedEvent was published. Lets consumers
 * distinguish a direct service-config edit from a worker-config edit that
 * fanned out to every pod referencing the worker.
 */
export enum ManifestChangeTrigger {
  BackgroundServiceConfig = 'BACKGROUND_SERVICE_CONFIG',
  WorkerConfig = 'WORKER_CONFIG'
}

/**
 * Payload delivered to manifestChanged subscribers. Intentionally minimal —
 * consumers re-fetch the manifest and re-fingerprint to filter false positives,
 * so the event only needs to say "something might have changed for this pod".
 */
export type ManifestChangedEvent = {
  __typename?: 'ManifestChangedEvent';
  runsOn: Scalars['String']['output'];
  triggeredBy: ManifestChangeTrigger;
};

export type MapMergeDevTaxRateInput = {
  id: Scalars['String']['input'];
  mergeDevTaxRateId: Scalars['String']['input'];
};

/** GraphQL input for markErpWriteBackFailed. */
export type MarkErpWriteBackFailedInput = {
  erpWriteBackId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
};

/** GraphQL input for markErpWriteBackProcessed. */
export type MarkErpWriteBackProcessedInput = {
  erpWriteBackId: Scalars['String']['input'];
};

export type MarkMergeDevExportCompletedInput = {
  entityId: Scalars['String']['input'];
  mergeInvoiceId: Scalars['String']['input'];
  resolvedRevenueAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  resolvedRevenueRung?: InputMaybe<MergeDevRevenueRung>;
};

export type MarkMergeDevExportFailedPermanentInput = {
  entityId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
};

export type MarkMergeDevExportFailedTransientInput = {
  entityId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

export type MarkProductionLotReadyInput = {
  productionLotId: Scalars['String']['input'];
};

/** Mark as synced operation result */
export type MarkRfidScansAsSyncedPayload = {
  __typename?: 'MarkRfidScansAsSyncedPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

/** WORKER input recording provisioning success and the tenant provisioned into. */
export type MarkTrialRequestProvisionedInput = {
  requestId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** WORKER input recording a (retryable) provisioning failure. */
export type MarkTrialRequestProvisioningFailedInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

/**
 * WORKER input to stamp the generated tenant code and begin provisioning, keyed by the public
 * requestId. TenantCode is optional: supply it on the new-tenant (Approve) path;
 * omit it on the Link path or a retry to reuse the already-stamped code.
 */
export type MarkTrialRequestProvisioningInput = {
  requestId: Scalars['String']['input'];
  tenantCode?: InputMaybe<Scalars['String']['input']>;
};

export type MarkUserInviteCompletedInput = {
  fusionAuthUserId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};

export type MarkUserInviteEmailFailedInput = {
  error: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};

export type MarkUserInviteEmailSentInput = {
  changePasswordId?: InputMaybe<Scalars['String']['input']>;
  fusionAuthUserId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['String']['input'];
};

export type MarkUserInviteFailedInput = {
  error: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};

export type MassUpdatePayload = {
  __typename?: 'MassUpdatePayload';
  /**
   * Count of items that failed processing. A value of -1 means the count is unknown
   * because the queue fetch failed before per-item processing began.
   */
  failedCount: Scalars['Int']['output'];
  /** True when every queued item processed successfully; false otherwise. */
  success: Scalars['Boolean']['output'];
  /** Tenant whose queue was processed. */
  tenantId: Scalars['String']['output'];
  /** Count of items successfully processed. */
  updatedCount: Scalars['Int']['output'];
};

export type MasterLineItemData = {
  __typename?: 'MasterLineItemData';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eaches: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteData>;
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Decimal']['output'];
  scheduledQuantity?: Maybe<Scalars['Int']['output']>;
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type MasterLineItemUpdateDataInput = {
  department: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']>;
  orderedQuantity: Scalars['Int']['input'];
};

export type MasterOrderContactData = {
  __typename?: 'MasterOrderContactData';
  emailAddress: EmailAddressData;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: PhoneNumberData;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type MasterOrderContactDataInput = {
  emailAddress: EmailAddressDataInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: PhoneNumberDataInput;
  title: Scalars['String']['input'];
  type: ContactType;
};

export type MasterOrderCustomerData = {
  __typename?: 'MasterOrderCustomerData';
  billToAddress: AddressData;
  contact: MasterOrderContactData;
  id: Scalars['String']['output'];
  location: LocationData;
  name: Scalars['String']['output'];
};

export type MasterOrderCustomerDataInput = {
  billToAddress: AddressDataInput;
  contact: MasterOrderContactDataInput;
  id: Scalars['String']['input'];
  location: LocationDataInput;
  name: Scalars['String']['input'];
};

export type MasterOrderPayload = {
  __typename?: 'MasterOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  masterOrder?: Maybe<MasterOrderStateData>;
};

export type MasterOrderStateData = {
  __typename?: 'MasterOrderStateData';
  confirmationEmails: Array<ConfirmationEmailData>;
  customer: MasterOrderCustomerData;
  masterLineItems: Array<MasterLineItemData>;
  masterOrderId: Scalars['String']['output'];
  masterOrderNumber: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  salesPerson: Scalars['String']['output'];
  scheduledOrders: Array<ScheduledOrderData>;
  shipFromLocation: ShipFromLocationData;
  status: MasterOrderStatus;
  tenantId: Scalars['String']['output'];
  type: OrderType;
};

export enum MasterOrderStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Closed = 'CLOSED',
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

export type MasterOrderStatusOperationFilterInput = {
  eq?: InputMaybe<MasterOrderStatus>;
  in?: InputMaybe<Array<MasterOrderStatus>>;
  neq?: InputMaybe<MasterOrderStatus>;
  nin?: InputMaybe<Array<MasterOrderStatus>>;
};

/** A connection to a list of items. */
export type MasterOrdersConnection = {
  __typename?: 'MasterOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MasterOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MasterOrdersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type MasterOrdersDocument = {
  __typename?: 'MasterOrdersDocument';
  billingAddress: AddressData;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemIds: Scalars['String']['output'];
  locations: OrderLocationDocumentData;
  masterOrderId: Scalars['String']['output'];
  masterOrderNumber: Scalars['String']['output'];
  masterOrderStatus: MasterOrderStatus;
  numberOfLines: Scalars['Int']['output'];
  orderTotal: MoneyData;
  orderType: OrderType;
  poNumber: Scalars['String']['output'];
  salesPerson?: Maybe<Scalars['String']['output']>;
  scheduledOrders: Array<ScheduledOrderData>;
  tenantId: Scalars['String']['output'];
};

export type MasterOrdersDocumentFilterInput = {
  and?: InputMaybe<Array<MasterOrdersDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemIds?: InputMaybe<StringOperationFilterInput>;
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  masterOrderId?: InputMaybe<StringOperationFilterInput>;
  masterOrderNumber?: InputMaybe<StringOperationFilterInput>;
  masterOrderStatus?: InputMaybe<MasterOrderStatusOperationFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MasterOrdersDocumentFilterInput>>;
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  scheduledOrders?: InputMaybe<ListFilterInputTypeOfScheduledOrderDataFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type MasterOrdersDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemIds?: InputMaybe<SortEnumType>;
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  masterOrderId?: InputMaybe<SortEnumType>;
  masterOrderNumber?: InputMaybe<SortEnumType>;
  masterOrderStatus?: InputMaybe<SortEnumType>;
  numberOfLines?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type MasterOrdersEdge = {
  __typename?: 'MasterOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MasterOrdersDocument;
};

/** Read-model shape of a single existing-tenant match annotation. Context for the approver only. */
export type MatchCandidateDocument = {
  __typename?: 'MatchCandidateDocument';
  /** TrialRequestMatchedOn ordinal. */
  matchedOn: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** Read-model shape of a single existing-tenant match annotation. Context for the approver only. */
export type MatchCandidateDocumentFilterInput = {
  and?: InputMaybe<Array<MatchCandidateDocumentFilterInput>>;
  /** TrialRequestMatchedOn ordinal. */
  matchedOn?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MatchCandidateDocumentFilterInput>>;
  requestId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocument = {
  __typename?: 'MaterialAllocationDocument';
  confirmedQty: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  fulfilledQty: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  requiredQty: Scalars['Decimal']['output'];
  status: MaterialAllocationStatus;
  targetLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialAllocationDocumentFilterInput>>;
  confirmedQty?: InputMaybe<DecimalOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  fulfilledQty?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialAllocationDocumentFilterInput>>;
  requiredQty?: InputMaybe<DecimalOperationFilterInput>;
  status?: InputMaybe<MaterialAllocationStatusOperationFilterInput>;
  targetLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocumentSortInput = {
  confirmedQty?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  fulfilledQty?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  requiredQty?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  targetLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for material-allocation operations: carries either the
 * resulting allocation document or the validation errors, never both.
 */
export type MaterialAllocationPayload = {
  __typename?: 'MaterialAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialAllocation?: Maybe<MaterialAllocationDocument>;
};

export enum MaterialAllocationStatus {
  Confirmed = 'CONFIRMED',
  Fulfilled = 'FULFILLED',
  Released = 'RELEASED',
  Requested = 'REQUESTED'
}

export type MaterialAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<MaterialAllocationStatus>;
  in?: InputMaybe<Array<MaterialAllocationStatus>>;
  neq?: InputMaybe<MaterialAllocationStatus>;
  nin?: InputMaybe<Array<MaterialAllocationStatus>>;
};

/** A connection to a list of items. */
export type MaterialAllocationsConnection = {
  __typename?: 'MaterialAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialAllocationsEdge = {
  __typename?: 'MaterialAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialAllocationDocument;
};

/**
 * A single material demand entry representing the quantity of a specific material
 * needed for a production job in a given week.
 */
export type MaterialDemandEntry = {
  __typename?: 'MaterialDemandEntry';
  /** Whether this material event came from the recipe or was ad-hoc. */
  eventSource: MaterialDemandEventSource;
  /** The production job quantity. */
  jobQuantity: Scalars['Int']['output'];
  /** The location name where the job is scheduled. */
  locationName: Scalars['String']['output'];
  /** The production material event detail identifier (unique per material within an event). */
  materialEventDetailId: Scalars['String']['output'];
  /** The production material event identifier that defines this material usage. */
  materialEventId: Scalars['String']['output'];
  /** The production material event name (denormalized for display). */
  materialEventName: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /** The material multiple from the material event detail. */
  multiple: Scalars['Decimal']['output'];
  /** The production job identifier. */
  productionJobId: Scalars['String']['output'];
  /** The production job display name. */
  productionJobName: Scalars['String']['output'];
  /** The recipe variation ID that was matched for this job (null if no variation found). */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /** The quantity of material required (job quantity x material multiple). */
  requiredQuantity: Scalars['Decimal']['output'];
  /** The week start date for which this material is needed. */
  weekStartDate: Scalars['DateTime']['output'];
  /** The ISO week number of the week start date. */
  weekStartIsoWeek: Scalars['Int']['output'];
  /** The ISO year of the week start date. */
  weekStartIsoYear: Scalars['Int']['output'];
};

/**
 * Represents the material demand source — whether the material event came from
 * the recipe definition or was attached ad-hoc to the production job.
 */
export enum MaterialDemandEventSource {
  /** Material event was attached ad-hoc directly to the job. */
  AdHoc = 'AD_HOC',
  /** Material event originated from the recipe variation. */
  Recipe = 'RECIPE'
}

/** Summary of material demand across all jobs in the queried range. */
export type MaterialDemandSummary = {
  __typename?: 'MaterialDemandSummary';
  /** The number of distinct material items in the result. */
  distinctMaterialCount: Scalars['Int']['output'];
  /** Individual material demand entries. */
  entries: Array<MaterialDemandEntry>;
  /** The total quantity of all material demanded across all entries. */
  totalRequiredQuantity: Scalars['Decimal']['output'];
};

/**
 * One group header for the Material Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionMaterialEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type MaterialEventGroupBucket = {
  __typename?: 'MaterialEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for materialEventGroups. Mirrors the Material Events sidebar's group-by
 * options so the client can render server-computed group headers instead of grouping the full event
 * list in memory: Status buckets on the event lifecycle status, Name buckets on the
 * event name. Both are flat scalar fields on ProductionMaterialEventDocument.
 */
export enum MaterialEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Deleted / Unknown). */
  Status = 'STATUS'
}

export type MaterialImageData = {
  __typename?: 'MaterialImageData';
  image: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  mime: Scalars['String']['output'];
};

export type MaterialImageDataFilterInput = {
  and?: InputMaybe<Array<MaterialImageDataFilterInput>>;
  image?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  mime?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialImageDataFilterInput>>;
};

export type MaterialImageDataSortInput = {
  image?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  mime?: InputMaybe<SortEnumType>;
};

export type MaterialItemBulkActionPayload = {
  __typename?: 'MaterialItemBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialItems?: Maybe<Array<MaterialItemPayload>>;
};

export enum MaterialItemCountType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Set = 'SET',
  Unknown = 'UNKNOWN'
}

export type MaterialItemCountTypeOperationFilterInput = {
  eq?: InputMaybe<MaterialItemCountType>;
  in?: InputMaybe<Array<MaterialItemCountType>>;
  neq?: InputMaybe<MaterialItemCountType>;
  nin?: InputMaybe<Array<MaterialItemCountType>>;
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocument = {
  __typename?: 'MaterialItemDocument';
  accountingId?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOrganic: Scalars['Boolean']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  materialImage?: Maybe<MaterialImageData>;
  name: Scalars['String']['output'];
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable: Scalars['Boolean']['output'];
  status: MaterialItemStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendors: Array<MaterialVendorData>;
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocumentFilterInput = {
  accountingId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MaterialItemDocumentFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemType?: InputMaybe<StringOperationFilterInput>;
  materialImage?: InputMaybe<MaterialImageDataFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemDocumentFilterInput>>;
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<MaterialItemStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendors?: InputMaybe<ListFilterInputTypeOfMaterialVendorDataFilterInput>;
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocumentSortInput = {
  accountingId?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemType?: InputMaybe<SortEnumType>;
  materialImage?: InputMaybe<MaterialImageDataSortInput>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MaterialItemLocationQuantitiesConnection = {
  __typename?: 'MaterialItemLocationQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemLocationQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemLocationQuantityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemLocationQuantitiesEdge = {
  __typename?: 'MaterialItemLocationQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemLocationQuantityDocument;
};

export type MaterialItemLocationQuantityDocument = {
  __typename?: 'MaterialItemLocationQuantityDocument';
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type MaterialItemLocationQuantityDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialItemLocationQuantityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemLocationQuantityDocumentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MaterialItemLocationQuantityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type MaterialItemLocationQuantityPayload = {
  __typename?: 'MaterialItemLocationQuantityPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialItemLocationQuantity?: Maybe<Array<MaterialItemLocationQuantityDocument>>;
};

export type MaterialItemPayload = {
  __typename?: 'MaterialItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialItem?: Maybe<MaterialItemDocument>;
};

/** A connection to a list of items. */
export type MaterialItemSiteLocationQuantitiesConnection = {
  __typename?: 'MaterialItemSiteLocationQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemSiteLocationQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemSiteLocationQuantityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemSiteLocationQuantitiesEdge = {
  __typename?: 'MaterialItemSiteLocationQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemSiteLocationQuantityDocument;
};

export type MaterialItemSiteLocationQuantityDocument = {
  __typename?: 'MaterialItemSiteLocationQuantityDocument';
  id: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type MaterialItemSiteLocationQuantityDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MaterialItemSiteLocationQuantityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export enum MaterialItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MaterialItemStatusOperationFilterInput = {
  eq?: InputMaybe<MaterialItemStatus>;
  in?: InputMaybe<Array<MaterialItemStatus>>;
  neq?: InputMaybe<MaterialItemStatus>;
  nin?: InputMaybe<Array<MaterialItemStatus>>;
};

/** A connection to a list of items. */
export type MaterialItemsConnection = {
  __typename?: 'MaterialItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemsEdge = {
  __typename?: 'MaterialItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/** A connection to a list of items. */
export type MaterialOrdersConnection = {
  __typename?: 'MaterialOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialOrdersEdge = {
  __typename?: 'MaterialOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpOrderDocument;
};

/** A connection to a list of items. */
export type MaterialOrdersForLocationConnection = {
  __typename?: 'MaterialOrdersForLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialOrdersForLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialOrdersForLocationEdge = {
  __typename?: 'MaterialOrdersForLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpOrderDocument;
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped); never updated after creation. The
 * optimistic decrement of the order line's outstanding quantity and the Material ERP write-back
 * enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocument = {
  __typename?: 'MaterialReceiptDocument';
  /** The receiving bin code; empty when not supplied. */
  binCode: Scalars['String']['output'];
  /** When the receipt was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo: Scalars['String']['output'];
  /** The Material ERP write-back queue record id this receipt enqueued. */
  erpWriteBackId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic decrement or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-receives.
   */
  idempotencyKey: Scalars['String']['output'];
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId: Scalars['String']['output'];
  /** The Nav line number the receipt is against. */
  lineNo: Scalars['Int']['output'];
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId: Scalars['String']['output'];
  /** Free-form field-user notes; empty when none. */
  notes: Scalars['String']['output'];
  /** The Nav order number the receipt is against. */
  orderNumber: Scalars['String']['output'];
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType: ErpOrderType;
  /** The line's outstanding quantity at the moment the receipt was recorded (pre-decrement). */
  outstandingBefore: Scalars['Decimal']['output'];
  /** The quantity received (always positive). */
  quantityReceived: Scalars['Decimal']['output'];
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit: Scalars['String']['output'];
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user: Scalars['String']['output'];
  /** The vendor / lot number captured for the receipt; empty when not supplied. */
  vendorLotNumber: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped); never updated after creation. The
 * optimistic decrement of the order line's outstanding quantity and the Material ERP write-back
 * enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialReceiptDocumentFilterInput>>;
  /** The receiving bin code; empty when not supplied. */
  binCode?: InputMaybe<StringOperationFilterInput>;
  /** When the receipt was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo?: InputMaybe<StringOperationFilterInput>;
  /** The Material ERP write-back queue record id this receipt enqueued. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic decrement or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-receives.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The Nav line number the receipt is against. */
  lineNo?: InputMaybe<IntOperationFilterInput>;
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialReceiptDocumentFilterInput>>;
  /** The Nav order number the receipt is against. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<ErpOrderTypeOperationFilterInput>;
  /** The line's outstanding quantity at the moment the receipt was recorded (pre-decrement). */
  outstandingBefore?: InputMaybe<DecimalOperationFilterInput>;
  /** The quantity received (always positive). */
  quantityReceived?: InputMaybe<DecimalOperationFilterInput>;
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
  /** The vendor / lot number captured for the receipt; empty when not supplied. */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped); never updated after creation. The
 * optimistic decrement of the order line's outstanding quantity and the Material ERP write-back
 * enqueue both follow this write.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocumentSortInput = {
  /** The receiving bin code; empty when not supplied. */
  binCode?: InputMaybe<SortEnumType>;
  /** When the receipt was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo?: InputMaybe<SortEnumType>;
  /** The Material ERP write-back queue record id this receipt enqueued. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record without re-applying the optimistic decrement or re-enqueuing a write-back, so a
   * PWA retry / offline replay never double-receives.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<SortEnumType>;
  /** The Nav line number the receipt is against. */
  lineNo?: InputMaybe<SortEnumType>;
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId?: InputMaybe<SortEnumType>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<SortEnumType>;
  /** The Nav order number the receipt is against. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<SortEnumType>;
  /** The line's outstanding quantity at the moment the receipt was recorded (pre-decrement). */
  outstandingBefore?: InputMaybe<SortEnumType>;
  /** The quantity received (always positive). */
  quantityReceived?: InputMaybe<SortEnumType>;
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
  /** The vendor / lot number captured for the receipt; empty when not supplied. */
  vendorLotNumber?: InputMaybe<SortEnumType>;
};

/**
 * Single-record payload for the material-receipt mutation. Carries the receipt audit record on
 * success, or the validation error(s) on failure (including the BPF-only tenant rejection and the
 * order/line/quantity validation errors).
 */
export type MaterialReceiptPayload = {
  __typename?: 'MaterialReceiptPayload';
  errors?: Maybe<Array<ValidationError>>;
  receipt?: Maybe<MaterialReceiptDocument>;
};

/** A connection to a list of items. */
export type MaterialReceiptsConnection = {
  __typename?: 'MaterialReceiptsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialReceiptsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialReceiptDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialReceiptsEdge = {
  __typename?: 'MaterialReceiptsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialReceiptDocument;
};

/**
 * Read-model document representing a single material transaction (count, move, or receive).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocument = {
  __typename?: 'MaterialTransactionDocument';
  countType: MaterialItemCountType;
  id: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  reasonCode: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  /** Destination location for move transactions. */
  toLocationId: Scalars['String']['output'];
  /** Destination location name for move transactions. */
  toLocationName: Scalars['String']['output'];
  transactionType: MaterialTransactionType;
  userEmail: Scalars['String']['output'];
  /** Vendor name for receive transactions. */
  vendorName: Scalars['String']['output'];
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId: Scalars['String']['output'];
};

/**
 * Read-model document representing a single material transaction (count, move, or receive).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialTransactionDocumentFilterInput>>;
  countType?: InputMaybe<MaterialItemCountTypeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialTransactionDocumentFilterInput>>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  /** Destination location for move transactions. */
  toLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Destination location name for move transactions. */
  toLocationName?: InputMaybe<StringOperationFilterInput>;
  transactionType?: InputMaybe<MaterialTransactionTypeOperationFilterInput>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  /** Vendor name for receive transactions. */
  vendorName?: InputMaybe<StringOperationFilterInput>;
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document representing a single material transaction (count, move, or receive).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocumentSortInput = {
  countType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  /** Destination location for move transactions. */
  toLocationId?: InputMaybe<SortEnumType>;
  /** Destination location name for move transactions. */
  toLocationName?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
  userEmail?: InputMaybe<SortEnumType>;
  /** Vendor name for receive transactions. */
  vendorName?: InputMaybe<SortEnumType>;
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId?: InputMaybe<SortEnumType>;
};

/** Discriminator for the type of material transaction. */
export enum MaterialTransactionType {
  Counted = 'COUNTED',
  Moved = 'MOVED',
  Received = 'RECEIVED',
  ReceivedCorrection = 'RECEIVED_CORRECTION',
  Unknown = 'UNKNOWN'
}

export type MaterialTransactionTypeOperationFilterInput = {
  eq?: InputMaybe<MaterialTransactionType>;
  in?: InputMaybe<Array<MaterialTransactionType>>;
  neq?: InputMaybe<MaterialTransactionType>;
  nin?: InputMaybe<Array<MaterialTransactionType>>;
};

/** A connection to a list of items. */
export type MaterialTransactionsConnection = {
  __typename?: 'MaterialTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialTransactionsEdge = {
  __typename?: 'MaterialTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialTransactionDocument;
};

export type MaterialVendorData = {
  __typename?: 'MaterialVendorData';
  isDefault: Scalars['Boolean']['output'];
  vendorId: Scalars['String']['output'];
  vendorItemId?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

export type MaterialVendorDataFilterInput = {
  and?: InputMaybe<Array<MaterialVendorDataFilterInput>>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MaterialVendorDataFilterInput>>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  vendorItemId?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
};

export type MaterialVendorInput = {
  isDefault: Scalars['Boolean']['input'];
  vendorId: Scalars['String']['input'];
  vendorItemId?: InputMaybe<Scalars['String']['input']>;
  vendorName: Scalars['String']['input'];
};

export type MergeBackgroundServiceConfigInput = {
  displayName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podAssignments: Array<PodAssignmentDataInput>;
  scope?: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['input'];
  workerConfigs: Array<Scalars['String']['input']>;
};

export type MergeCategoryInput = {
  code: Scalars['String']['input'];
  eaches?: Scalars['Int']['input'];
};

/**
 * The explicit connect-time setup choices the FULFILL-source-of-truth accounting wizard sends with
 * completeMergeLink / reconnectMergeLink. The seeder honours these instead of the
 * hardcoded MergeDevFlowDefaults, so a tenant opts into exactly the QuickBooks import flows
 * it wants (a one-time bootstrap) while Order Export stays on by default.
 */
export type MergeConnectSetupInput = {
  defaultIncomeAccountName?: InputMaybe<Scalars['String']['input']>;
  defaultIncomeAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  enabledImportFlows?: InputMaybe<Array<WsapiImportEntityType>>;
  outboundDetail: OutboundDetailLevel;
};

export type MergeContainerConfigInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type MergeCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<CreateAddressInput>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ContactDataInput>>;
  crmImportId?: InputMaybe<Scalars['String']['input']>;
  crmRecordUrl?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  importId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<CreateCustomerLocationInput>;
  name: Scalars['String']['input'];
  orderSubmitter?: InputMaybe<OrderSubmitterDataInput>;
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeDeliveryScheduleInput = {
  friday: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
  monday: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type MergeDevAccountDocument = {
  __typename?: 'MergeDevAccountDocument';
  accountNumber: Scalars['String']['output'];
  classification: AccountClassification;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevAccountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: MergeDevAccountStatus;
  tenantId: Scalars['String']['output'];
};

export type MergeDevAccountDocumentFilterInput = {
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MergeDevAccountDocumentFilterInput>>;
  classification?: InputMaybe<AccountClassificationOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  mergeDevAccountId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevAccountDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<MergeDevAccountStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type MergeDevAccountDocumentSortInput = {
  accountNumber?: InputMaybe<SortEnumType>;
  classification?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  mergeDevAccountId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  remoteId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MergeDevAccountPayload = {
  __typename?: 'MergeDevAccountPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevAccount?: Maybe<MergeDevAccountStateData>;
};

export type MergeDevAccountStateData = {
  __typename?: 'MergeDevAccountStateData';
  accountNumber: Scalars['String']['output'];
  classification: AccountClassification;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mergeDevAccountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: MergeDevAccountStatus;
  tenantId: Scalars['String']['output'];
};

export enum MergeDevAccountStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type MergeDevAccountStatusOperationFilterInput = {
  eq?: InputMaybe<MergeDevAccountStatus>;
  in?: InputMaybe<Array<MergeDevAccountStatus>>;
  neq?: InputMaybe<MergeDevAccountStatus>;
  nin?: InputMaybe<Array<MergeDevAccountStatus>>;
};

/** A connection to a list of items. */
export type MergeDevAccountsConnection = {
  __typename?: 'MergeDevAccountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevAccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevAccountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevAccountsEdge = {
  __typename?: 'MergeDevAccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevAccountDocument;
};

/**
 * MongoDB read model holding per-integration Merge.dev connection metadata that is not part of the
 * per-entity sync checkpoint — currently the friendly QuickBooks company name shown on the
 * Integrations connected-state card. One document exists per (IntegrationId, TenantId). Written by
 * the synchronizer (wsapi-services) from Merge.dev CompanyInfo; read here by the
 * mergeDevConnection query. wsapi's global IgnoreExtraElementsConvention tolerates any
 * additional fields the synchronizer adds later.
 */
export type MergeDevConnectionDocument = {
  __typename?: 'MergeDevConnectionDocument';
  /**
   * The friendly QuickBooks company name (e.g. "Bonnie Plants, LLC"), captured from Merge.dev
   * CompanyInfo during sync. None until the synchronizer has captured it — the
   * OptionTypeInterceptor surfaces it as a nullable GraphQL String so older clients and
   * never-synced integrations are unaffected.
   */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Composite key: "{integrationId}:{tenantId}". Built via the GetDocumentId helper. */
  connectionId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

/** Per-entity sync metrics within a sync cycle. */
export type MergeDevEntitySyncMetricDocument = {
  __typename?: 'MergeDevEntitySyncMetricDocument';
  /** Number of API calls made for this entity type. */
  apiCalls: Scalars['Int']['output'];
  /** Time spent processing this entity type. */
  duration: Scalars['TimeSpan']['output'];
  /** The Merge.dev model name (e.g., "Contact", "Item"). */
  model: Scalars['String']['output'];
  /** Records that failed validation or upsert. */
  recordsFailed: Scalars['Int']['output'];
  /** Total records fetched from Merge.dev. */
  recordsProcessed: Scalars['Int']['output'];
  /** Records successfully upserted into WorkSuite. */
  recordsSucceeded: Scalars['Int']['output'];
};

/**
 * Batch mutation result. One MergeDevExportPayload per input row, in the same
 * order the worker submitted them. Per-row errors (validation, discriminator violations, entity
 * not found, etc.) land in that row's MergeDevExportPayload.Errors; the worker can
 * inspect each row to decide which entities to retry next cycle.
 * Errors is reserved for whole-batch failures — empty updates today, and
 * future quota / size-limit rejections. When Errors is non-null
 * MergeDevExports is null; the two are mutually exclusive.
 */
export type MergeDevExportBatchPayload = {
  __typename?: 'MergeDevExportBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevExports?: Maybe<Array<MergeDevExportPayload>>;
};

/**
 * Discriminator payload for a successful export attempt.
 * ResolvedRevenueAccountRemoteId (the Merge.dev RemoteId of the revenue GL account the
 * invoice posted to) and ResolvedRevenueRung (the winning precedence rung) are optional so
 * older callers that omit them still succeed; the worker in wsapi-services supplies both when it
 * reports the outcome, making the CMG GL-routing result queryable from WorkSuite.
 */
export type MergeDevExportCompletedUpdateDataInput = {
  mergeInvoiceId: Scalars['String']['input'];
  resolvedRevenueAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  resolvedRevenueRung?: InputMaybe<MergeDevRevenueRung>;
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocument = {
  __typename?: 'MergeDevExportDocument';
  entityId: Scalars['String']['output'];
  entityType: MergeDevExportEntityType;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportStatus: MergeDevExportStatus;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id: Scalars['String']['output'];
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: Maybe<Scalars['String']['output']>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: Maybe<MergeDevRevenueRung>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocumentFilterInput = {
  and?: InputMaybe<Array<MergeDevExportDocumentFilterInput>>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<MergeDevExportEntityTypeOperationFilterInput>;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: InputMaybe<OptionOfStringFilterInput>;
  exportStatus?: InputMaybe<MergeDevExportStatusOperationFilterInput>;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevExportDocumentFilterInput>>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: InputMaybe<OptionOfMergeDevRevenueRungFilterInput>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocumentSortInput = {
  entityId?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: InputMaybe<SortEnumType>;
  exportStatus?: InputMaybe<SortEnumType>;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id?: InputMaybe<SortEnumType>;
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: InputMaybe<SortEnumType>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: InputMaybe<SortEnumType>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: InputMaybe<SortEnumType>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum MergeDevExportEntityType {
  Order = 'ORDER'
}

export type MergeDevExportEntityTypeOperationFilterInput = {
  eq?: InputMaybe<MergeDevExportEntityType>;
  in?: InputMaybe<Array<MergeDevExportEntityType>>;
  neq?: InputMaybe<MergeDevExportEntityType>;
  nin?: InputMaybe<Array<MergeDevExportEntityType>>;
};

/** Discriminator payload for a terminal failure. */
export type MergeDevExportFailedPermanentUpdateDataInput = {
  errorMessage: Scalars['String']['input'];
};

/**
 * Discriminator payload for a retryable failure. The worker computed RetryCount
 * (new total after this attempt) and NextRetryAt (earliest next attempt) from its
 * own retry-budget policy.
 */
export type MergeDevExportFailedTransientUpdateDataInput = {
  errorMessage: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

export type MergeDevExportPayload = {
  __typename?: 'MergeDevExportPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevExport?: Maybe<MergeDevExportStateData>;
};

export type MergeDevExportStateData = {
  __typename?: 'MergeDevExportStateData';
  entityId: Scalars['String']['output'];
  entityType: MergeDevExportEntityType;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportStatus: MergeDevExportStatus;
  mergeInvoiceId?: Maybe<Scalars['String']['output']>;
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedRevenueAccountRemoteId?: Maybe<Scalars['String']['output']>;
  resolvedRevenueRung?: Maybe<MergeDevRevenueRung>;
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export enum MergeDevExportStatus {
  Completed = 'COMPLETED',
  /** @deprecated Use FailedPermanent for non-retryable failures and FailedTransient for retryable ones. Retained for BSON ordinal stability per discipline bf43effe. */
  Failed = 'FAILED',
  FailedPermanent = 'FAILED_PERMANENT',
  FailedTransient = 'FAILED_TRANSIENT',
  Pending = 'PENDING'
}

export type MergeDevExportStatusOperationFilterInput = {
  eq?: InputMaybe<MergeDevExportStatus>;
  in?: InputMaybe<Array<MergeDevExportStatus>>;
  neq?: InputMaybe<MergeDevExportStatus>;
  nin?: InputMaybe<Array<MergeDevExportStatus>>;
};

/**
 * One row in the batch. Exactly one of Completed / FailedTransient /
 * FailedPermanent must be set; the others must be null.
 */
export type MergeDevExportStatusUpdateRowInput = {
  completed?: InputMaybe<MergeDevExportCompletedUpdateDataInput>;
  entityId: Scalars['String']['input'];
  failedPermanent?: InputMaybe<MergeDevExportFailedPermanentUpdateDataInput>;
  failedTransient?: InputMaybe<MergeDevExportFailedTransientUpdateDataInput>;
};

/** A connection to a list of items. */
export type MergeDevExportsConnection = {
  __typename?: 'MergeDevExportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevExportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevExportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevExportsEdge = {
  __typename?: 'MergeDevExportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevExportDocument;
};

/** A single field definition discovered from Merge.dev's /meta and /remote-fields endpoints. */
export type MergeDevFieldDefinitionDocument = {
  __typename?: 'MergeDevFieldDefinitionDocument';
  /** Human-readable description of the field from the accounting system. */
  description: Scalars['String']['output'];
  /** Valid values when the field is an enumeration type. */
  enumValues: Array<Scalars['String']['output']>;
  /** Indicates whether this field originates from Merge.dev's /remote-fields endpoint rather than /meta. */
  isRemoteField: Scalars['Boolean']['output'];
  /** The field name as reported by Merge.dev. */
  name: Scalars['String']['output'];
  /** Whether the field is required when creating records. */
  required: Scalars['Boolean']['output'];
  /** The field data type (e.g., "string", "number", "date"). */
  type: Scalars['String']['output'];
};

/**
 * Entity types supported by the Merge.dev Accounting API import. Mirrors the
 * synchronizer's MergeDevImportEntityType on wsapi-services. The numeric values
 * MUST stay identical to the synchronizer's enum because the value is persisted to Mongo
 * by its ordinal (no [BsonRepresentation(BsonType.String)] on the source field).
 */
export enum MergeDevImportEntityType {
  /** QuickBooks chart-of-accounts accounts. */
  Account = 'ACCOUNT',
  /** QuickBooks contacts (customers/vendors). */
  Contact = 'CONTACT',
  /** QuickBooks invoices imported into WorkSuite. */
  InvoiceImport = 'INVOICE_IMPORT',
  /** QuickBooks items / products. */
  Item = 'ITEM',
  /** QuickBooks journal entries. */
  JournalEntry = 'JOURNAL_ENTRY',
  /** Outbound WorkSuite orders exported as QuickBooks invoices. */
  OrderExport = 'ORDER_EXPORT',
  /** QuickBooks payments. */
  Payment = 'PAYMENT',
  /** Accounting provider → WorkSuite unit-price import (inbound). Runs inside the item handler on the synchronizer; mirrors wsapi-services MergeDevImportEntityType.PricingImport. Surfaced here so a pricing-import failure row (or sync-state row) the synchronizer writes by ordinal 8 serializes instead of nulling out the whole result. */
  PricingImport = 'PRICING_IMPORT',
  /** QuickBooks tax rates. */
  TaxRate = 'TAX_RATE'
}

/**
 * MongoDB document mirroring the synchronizer's MergeDevImportFailureDocument on
 * wsapi-services. Holds a single genuine per-record Merge.dev import failure — the data behind the
 * Integrations "Errors" tab that tells operators why a record was dropped. One document
 * exists per (integration × entity-type × source record id); a re-run of the same record upserts the
 * reason and timestamp in place, so the collection is bounded by the distinct set of currently-failing
 * records rather than an unbounded history. Only genuine failures land here (validation errors, 4xx/5xx
 * from wsapi, exceptions, records with no resolvable name); benign/idempotent rejections are classified
 * as success upstream and never produce a row. wsapi's global IgnoreExtraElementsConvention
 * tolerates the synchronizer's composite-key and any later-added fields on read.
 */
export type MergeDevImportFailureDocument = {
  __typename?: 'MergeDevImportFailureDocument';
  /** The human-readable entity label as logged (e.g. "Customer", "Vendor", "Item"). Finer than EntityType: a Contact import can fail as either a Customer or a Vendor for the same source record. */
  entityLabel: Scalars['String']['output'];
  /** The Merge.dev entity type whose import produced this failure. */
  entityType: MergeDevImportEntityType;
  /** The human-readable failure reason (the wsapi payload error text, the transport error message, or a data-gap description such as "contact has no resolvable name"). */
  reason: Scalars['String']['output'];
  /** The Merge.dev source record id this failure is for. */
  recordId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
  /** When this failure was last observed. */
  timestamp: Scalars['DateTime']['output'];
};

export type MergeDevPaymentAppliedLine = {
  __typename?: 'MergeDevPaymentAppliedLine';
  appliedAmount: Scalars['Decimal']['output'];
  creditNoteRemoteId: Scalars['String']['output'];
  invoiceRemoteId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

export type MergeDevPaymentAppliedLineDataInput = {
  appliedAmount: Scalars['Decimal']['input'];
  creditNoteRemoteId?: InputMaybe<Scalars['String']['input']>;
  invoiceRemoteId?: InputMaybe<Scalars['String']['input']>;
  remoteId: Scalars['String']['input'];
};

export type MergeDevPaymentAppliedLineDocument = {
  __typename?: 'MergeDevPaymentAppliedLineDocument';
  appliedAmount: Scalars['Decimal']['output'];
  creditNoteRemoteId: Scalars['String']['output'];
  invoiceRemoteId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

export type MergeDevPaymentAppliedLineDocumentFilterInput = {
  and?: InputMaybe<Array<MergeDevPaymentAppliedLineDocumentFilterInput>>;
  appliedAmount?: InputMaybe<DecimalOperationFilterInput>;
  creditNoteRemoteId?: InputMaybe<StringOperationFilterInput>;
  invoiceRemoteId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevPaymentAppliedLineDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
};

export type MergeDevPaymentDocument = {
  __typename?: 'MergeDevPaymentDocument';
  account: Scalars['String']['output'];
  appliedToLines: Array<MergeDevPaymentAppliedLineDocument>;
  company: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  exchangeRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevPaymentId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export type MergeDevPaymentDocumentFilterInput = {
  account?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MergeDevPaymentDocumentFilterInput>>;
  appliedToLines?: InputMaybe<ListFilterInputTypeOfMergeDevPaymentAppliedLineDocumentFilterInput>;
  company?: InputMaybe<StringOperationFilterInput>;
  contact?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  mergeDevPaymentId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevPaymentDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalAmount?: InputMaybe<DecimalOperationFilterInput>;
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MergeDevPaymentDocumentSortInput = {
  account?: InputMaybe<SortEnumType>;
  company?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  mergeDevPaymentId?: InputMaybe<SortEnumType>;
  remoteId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalAmount?: InputMaybe<SortEnumType>;
  transactionDate?: InputMaybe<SortEnumType>;
};

export type MergeDevPaymentPayload = {
  __typename?: 'MergeDevPaymentPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevPayment?: Maybe<MergeDevPaymentStateData>;
};

export type MergeDevPaymentStateData = {
  __typename?: 'MergeDevPaymentStateData';
  account: Scalars['String']['output'];
  appliedToLines: Array<MergeDevPaymentAppliedLine>;
  company: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  exchangeRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  mergeDevPaymentId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type MergeDevPaymentsConnection = {
  __typename?: 'MergeDevPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevPaymentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevPaymentsEdge = {
  __typename?: 'MergeDevPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevPaymentDocument;
};

export enum MergeDevRevenueRung {
  CustomerType = 'CUSTOMER_TYPE',
  Item = 'ITEM',
  TenantDefault = 'TENANT_DEFAULT',
  Unmapped = 'UNMAPPED'
}

/** MongoDB document mirroring the synchronizer's MergeDevModelSchema for cached field definitions. */
export type MergeDevSchemaDocument = {
  __typename?: 'MergeDevSchemaDocument';
  /** When this schema was last discovered from Merge.dev's /meta endpoint. */
  discoveredAt: Scalars['DateTime']['output'];
  /** The field definitions discovered for this model. */
  fields: Array<MergeDevFieldDefinitionDocument>;
  /** The Merge.dev model name (e.g., "Contact", "Item", "Account"). */
  model: Scalars['String']['output'];
  /** Composite key: "{accountToken}:{model}". */
  schemaId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

/** MongoDB document mirroring the synchronizer's MergeDevSyncMetricsDocument for rate limiting and throughput metrics. */
export type MergeDevSyncMetricsDocument = {
  __typename?: 'MergeDevSyncMetricsDocument';
  /** Average requests per minute across the sync cycle. */
  avgRequestsPerMinute: Scalars['Float']['output'];
  /** The configured maximum requests per minute ceiling. */
  configuredMaxPerMinute: Scalars['Int']['output'];
  /** When the sync cycle completed. */
  cycleCompletedAt: Scalars['DateTime']['output'];
  /** When the sync cycle began. */
  cycleStartedAt: Scalars['DateTime']['output'];
  /** Per-entity breakdown of sync metrics for this cycle. */
  entityMetrics: Array<MergeDevEntitySyncMetricDocument>;
  /** Composite key: "{accountToken}:{timestamp}". */
  metricsId: Scalars['String']['output'];
  /** Peak requests per minute observed during the sync cycle. */
  peakRequestsPerMinute: Scalars['Float']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
  /** Number of HTTP 429 (rate-limited) responses received from Merge.dev. */
  throttledRequests: Scalars['Int']['output'];
  /** Total number of API calls made to Merge.dev during this sync cycle. */
  totalApiCalls: Scalars['Int']['output'];
  /** Cumulative time the synchronizer waited due to rate-limit throttling. */
  totalThrottleWaitTime: Scalars['TimeSpan']['output'];
};

/**
 * MongoDB document mirroring the synchronizer's MergeDevSyncStateDocument. Holds the
 * authoritative per-entity sync checkpoint for a Merge.dev integration: the last successful
 * sync time and the consecutive-failure count. One document exists per (TenantId, EntityType).
 * The synchronizer's pagination Cursor is intentionally not surfaced here; wsapi's global
 * IgnoreExtraElementsConvention tolerates the unmapped field on read.
 */
export type MergeDevSyncStateDocument = {
  __typename?: 'MergeDevSyncStateDocument';
  /** Number of consecutive failed sync attempts for this entity type. A non-zero value signals degraded connection health. */
  consecutiveFailures: Scalars['Int']['output'];
  /** The Merge.dev entity type this sync state tracks. */
  entityType: MergeDevImportEntityType;
  /** Wall-clock duration of the last successful sync cycle in milliseconds. Stamped by the synchronizer's success path; documents written before the field existed read back as 0. */
  lastSyncDurationMs: Scalars['Long']['output'];
  /** The last time this entity type completed a successful sync, or null if it has never synced. */
  lastSyncTime?: Maybe<Scalars['DateTime']['output']>;
  /** Records that failed validation/upsert for this entity type on the last completed sync cycle. */
  recordsFailed: Scalars['Int']['output'];
  /** Records imported from Merge.dev for this entity type on the last completed sync cycle. */
  recordsProcessed: Scalars['Int']['output'];
  /** Records successfully upserted into WorkSuite for this entity type on the last completed sync cycle. */
  recordsSucceeded: Scalars['Int']['output'];
  /** Composite key: "{integrationId}:{entityType}". */
  stateId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

export type MergeDevTaxRateDocument = {
  __typename?: 'MergeDevTaxRateDocument';
  company: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  effectiveTaxRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this tax rate was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevTaxRate resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on, and so the
   * TaxAuthority auto-seed gate can key off ImportId existence. Empty for rates imported before
   * ImportId existed. Distinct from RemoteId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevTaxRateId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  status: MergeDevTaxRateStatus;
  tenantId: Scalars['String']['output'];
  totalTaxRate: Scalars['Decimal']['output'];
};

export type MergeDevTaxRateDocumentFilterInput = {
  and?: InputMaybe<Array<MergeDevTaxRateDocumentFilterInput>>;
  company?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  effectiveTaxRate?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this tax rate was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevTaxRate resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on, and so the
   * TaxAuthority auto-seed gate can key off ImportId existence. Empty for rates imported before
   * ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  mergeDevTaxRateId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevTaxRateDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
  reportId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<MergeDevTaxRateStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalTaxRate?: InputMaybe<DecimalOperationFilterInput>;
};

export type MergeDevTaxRateDocumentSortInput = {
  company?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  effectiveTaxRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this tax rate was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevTaxRate resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on, and so the
   * TaxAuthority auto-seed gate can key off ImportId existence. Empty for rates imported before
   * ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  mergeDevTaxRateId?: InputMaybe<SortEnumType>;
  remoteId?: InputMaybe<SortEnumType>;
  reportId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalTaxRate?: InputMaybe<SortEnumType>;
};

export type MergeDevTaxRatePayload = {
  __typename?: 'MergeDevTaxRatePayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevTaxRate?: Maybe<MergeDevTaxRateStateData>;
};

export type MergeDevTaxRateStateData = {
  __typename?: 'MergeDevTaxRateStateData';
  company: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  effectiveTaxRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  mergeDevTaxRateId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  status: MergeDevTaxRateStatus;
  tenantId: Scalars['String']['output'];
  totalTaxRate: Scalars['Decimal']['output'];
};

export enum MergeDevTaxRateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type MergeDevTaxRateStatusOperationFilterInput = {
  eq?: InputMaybe<MergeDevTaxRateStatus>;
  in?: InputMaybe<Array<MergeDevTaxRateStatus>>;
  neq?: InputMaybe<MergeDevTaxRateStatus>;
  nin?: InputMaybe<Array<MergeDevTaxRateStatus>>;
};

/** A connection to a list of items. */
export type MergeDevTaxRatesConnection = {
  __typename?: 'MergeDevTaxRatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevTaxRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevTaxRateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevTaxRatesEdge = {
  __typename?: 'MergeDevTaxRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevTaxRateDocument;
};

export type MergeErpLoadListUserInput = {
  email: Scalars['String']['input'];
  erpLoadListUserId: Scalars['String']['input'];
  sites: Array<Scalars['String']['input']>;
};

export type MergeForecastSettingsInput = {
  compAim: Scalars['Decimal']['input'];
  compMax: Scalars['Decimal']['input'];
  compMin: Scalars['Decimal']['input'];
  excludedHistoryYears: Array<Scalars['Int']['input']>;
  maxYearOffset: Scalars['Int']['input'];
  roundingBias: Scalars['Decimal']['input'];
  shipShift: Scalars['Boolean']['input'];
};

export type MergeItemInput = {
  categories: Array<CategoryDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productGroup?: InputMaybe<Scalars['String']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type MergeJobWorkOrdersInput = {
  containerQuantity: Scalars['Int']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemErpId?: Scalars['String']['input'];
  itemGenusCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemRecordId: Scalars['String']['input'];
  itemUPC: Scalars['String']['input'];
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  unitOfMeasure: Scalars['String']['input'];
  workOrders: Array<WorkOrderInput>;
};

/** The Merge.dev product category a link token is scoped to. */
export enum MergeLinkCategory {
  Accounting = 'ACCOUNTING',
  Crm = 'CRM'
}

export type MergeLinkTokenPayload = {
  __typename?: 'MergeLinkTokenPayload';
  errors?: Maybe<Array<ValidationError>>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

export type MergeMaterialItemByErpIdInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MergeMergeDevAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  classification: AccountClassification;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  status: MergeDevAccountStatus;
};

export type MergeMergeDevPaymentInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  appliedToLines: Array<MergeDevPaymentAppliedLineDataInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate: Scalars['Decimal']['input'];
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  remoteId: Scalars['String']['input'];
  totalAmount: Scalars['Decimal']['input'];
  transactionDate: Scalars['DateTime']['input'];
};

export type MergeMergeDevTaxRateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveTaxRate: Scalars['Decimal']['input'];
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  remoteId: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  status: MergeDevTaxRateStatus;
  totalTaxRate: Scalars['Decimal']['input'];
};

export type MergePriceGroupInput = {
  id: Scalars['String']['input'];
  makeDefaultIfNoDefaultExists: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type MergePriceLevelInput = {
  customerSellPrice?: InputMaybe<Scalars['Decimal']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  growerCost?: InputMaybe<Scalars['Decimal']['input']>;
  growerSellPrice: Scalars['Decimal']['input'];
  kind?: PriceKind;
  levelType?: InputMaybe<PriceLevelType>;
  percentOff?: InputMaybe<Scalars['Decimal']['input']>;
  priceGroupId: Scalars['String']['input'];
  priceLevelId: Scalars['String']['input'];
  quantityThreshold: Scalars['Decimal']['input'];
  referencePriceGroupId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  targetId: Scalars['String']['input'];
  type: TargetType;
};

export type MergeProductionCategoryInput = {
  code: Scalars['String']['input'];
  eaches: Scalars['Int']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type MergeProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type MergeProductionPlanInput = {
  name: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type MergeProductionSpaceCategoryInput = {
  code: Scalars['String']['input'];
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type MergeProductionSpaceTypeInput = {
  code: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
};

export type MergeReplenishmentSettingsInput = {
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['input'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['input'];
  forwardDaysLastYear: Scalars['Int']['input'];
  inventoryTrailingDays: Scalars['Int']['input'];
  minUsableDaysThreshold?: InputMaybe<Scalars['Int']['input']>;
  programWindowConfigs: Array<ProgramWindowConfigDataInput>;
  roundToFullCart: Scalars['Boolean']['input'];
  sellThroughThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentIncrement: Scalars['Int']['input'];
  trailingDaysThisYear: Scalars['Int']['input'];
};

export type MergeSiteLocationInput = {
  address?: InputMaybe<CreateAddressInput>;
  erpId: Scalars['String']['input'];
  locations: Array<SubLocationDataInput>;
  name: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  status: LocationStatus;
};

export type MergeVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MergeWorkerConfigInput = {
  configName: Scalars['String']['input'];
  tenantValues: Array<TenantValueDataInput>;
};

/**
 * A single restock metric expressed as both a physical Quantity and a
 * wholesale dollar Value. Used by RestockMetricsData to
 * pair a quantity and a value under each of the six physical concepts (Available,
 * Allocated, In Transit, Available for Orders, On Order, Remaining Availability).
 * The GraphQL type is exposed as MetricValue to match the unified frontend
 * contract and RTK Query cache-tag strategy.
 */
export type MetricValue = {
  __typename?: 'MetricValue';
  quantity: Scalars['Int']['output'];
  value: Scalars['Decimal']['output'];
};

export type MoneyData = {
  __typename?: 'MoneyData';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
};

export type MoneyDataFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<MoneyDataFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MoneyDataFilterInput>>;
};

export type MoneyDataSortInput = {
  amount?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
};

export type MongoAggregationConfigData = {
  __typename?: 'MongoAggregationConfigData';
  aggregationFields: Array<MongoAggregationFieldData>;
  groupFields: Array<Scalars['String']['output']>;
  mergeOnFields: Array<Scalars['String']['output']>;
  targetCollection: Scalars['String']['output'];
  useAccumulativeMerge: Scalars['Boolean']['output'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationConfigDataInput = {
  aggregationFields: Array<MongoAggregationFieldDataInput>;
  groupFields: Array<Scalars['String']['input']>;
  mergeOnFields: Array<Scalars['String']['input']>;
  targetCollection: Scalars['String']['input'];
  useAccumulativeMerge: Scalars['Boolean']['input'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationDocumentData = {
  __typename?: 'MongoAggregationDocumentData';
  aggregationFields: Array<MongoAggregationFieldDocumentData>;
  groupFields: Array<Scalars['String']['output']>;
  mergeOnFields: Array<Scalars['String']['output']>;
  targetCollection: Scalars['String']['output'];
  useAccumulativeMerge: Scalars['Boolean']['output'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationDocumentDataFilterInput = {
  aggregationFields?: InputMaybe<ListFilterInputTypeOfMongoAggregationFieldDocumentDataFilterInput>;
  and?: InputMaybe<Array<MongoAggregationDocumentDataFilterInput>>;
  groupFields?: InputMaybe<ListStringOperationFilterInput>;
  mergeOnFields?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<MongoAggregationDocumentDataFilterInput>>;
  targetCollection?: InputMaybe<StringOperationFilterInput>;
  useAccumulativeMerge?: InputMaybe<BooleanOperationFilterInput>;
  whenMatched?: InputMaybe<MongoMergeWhenMatchedOperationFilterInput>;
  whenNotMatched?: InputMaybe<MongoMergeWhenNotMatchedOperationFilterInput>;
};

export type MongoAggregationFieldData = {
  __typename?: 'MongoAggregationFieldData';
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
};

export type MongoAggregationFieldDataInput = {
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['input'];
  sourceFieldName: Scalars['String']['input'];
};

export type MongoAggregationFieldDocumentData = {
  __typename?: 'MongoAggregationFieldDocumentData';
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
};

export type MongoAggregationFieldDocumentDataFilterInput = {
  and?: InputMaybe<Array<MongoAggregationFieldDocumentDataFilterInput>>;
  operator?: InputMaybe<MongoAggregationOperatorOperationFilterInput>;
  or?: InputMaybe<Array<MongoAggregationFieldDocumentDataFilterInput>>;
  outputFieldName?: InputMaybe<StringOperationFilterInput>;
  sourceFieldName?: InputMaybe<StringOperationFilterInput>;
};

export enum MongoAggregationOperator {
  AddToSet = 'ADD_TO_SET',
  Avg = 'AVG',
  Count = 'COUNT',
  First = 'FIRST',
  Last = 'LAST',
  Max = 'MAX',
  Min = 'MIN',
  NotSet = 'NOT_SET',
  Push = 'PUSH',
  Sum = 'SUM'
}

export type MongoAggregationOperatorOperationFilterInput = {
  eq?: InputMaybe<MongoAggregationOperator>;
  in?: InputMaybe<Array<MongoAggregationOperator>>;
  neq?: InputMaybe<MongoAggregationOperator>;
  nin?: InputMaybe<Array<MongoAggregationOperator>>;
};

export type MongoColumnMapData = {
  __typename?: 'MongoColumnMapData';
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  fieldName: Scalars['String']['output'];
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: BsonDataType;
};

export type MongoColumnMapDataInput = {
  csvHeader?: InputMaybe<Scalars['String']['input']>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataInput>;
  fieldName: Scalars['String']['input'];
  staticDefault?: InputMaybe<StaticDefaultUnitDataInput>;
  transform?: InputMaybe<DynamicTransformUnitDataInput>;
  type: BsonDataType;
};

export type MongoColumnMapDocumentData = {
  __typename?: 'MongoColumnMapDocumentData';
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  fieldName: Scalars['String']['output'];
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: BsonDataType;
};

export type MongoColumnMapDocumentDataFilterInput = {
  and?: InputMaybe<Array<MongoColumnMapDocumentDataFilterInput>>;
  csvHeader?: InputMaybe<StringOperationFilterInput>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataFilterInput>;
  fieldName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MongoColumnMapDocumentDataFilterInput>>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataFilterInput>;
  transform?: InputMaybe<DynamicTransformUnitDataFilterInput>;
  type?: InputMaybe<BsonDataTypeOperationFilterInput>;
};

export type MongoDestinationConfigData = {
  __typename?: 'MongoDestinationConfigData';
  aggregation?: Maybe<MongoAggregationConfigData>;
  collectionName: Scalars['String']['output'];
  connectionString: Scalars['String']['output'];
  databaseName: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  mongoColumns: Array<MongoColumnMapData>;
};

export type MongoDestinationConfigDataInput = {
  aggregation?: InputMaybe<MongoAggregationConfigDataInput>;
  collectionName: Scalars['String']['input'];
  connectionString: Scalars['String']['input'];
  databaseName: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  mongoColumns: Array<MongoColumnMapDataInput>;
};

export type MongoDestinationDocumentData = {
  __typename?: 'MongoDestinationDocumentData';
  aggregation?: Maybe<MongoAggregationDocumentData>;
  collectionName: Scalars['String']['output'];
  connectionString: Scalars['String']['output'];
  databaseName: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  mongoColumns: Array<MongoColumnMapDocumentData>;
};

export type MongoDestinationDocumentDataFilterInput = {
  aggregation?: InputMaybe<MongoAggregationDocumentDataFilterInput>;
  and?: InputMaybe<Array<MongoDestinationDocumentDataFilterInput>>;
  collectionName?: InputMaybe<StringOperationFilterInput>;
  connectionString?: InputMaybe<StringOperationFilterInput>;
  databaseName?: InputMaybe<StringOperationFilterInput>;
  destinationId?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  mongoColumns?: InputMaybe<ListFilterInputTypeOfMongoColumnMapDocumentDataFilterInput>;
  or?: InputMaybe<Array<MongoDestinationDocumentDataFilterInput>>;
};

export enum MongoMergeWhenMatched {
  Fail = 'FAIL',
  KeepExisting = 'KEEP_EXISTING',
  Merge = 'MERGE',
  NotSet = 'NOT_SET',
  Replace = 'REPLACE'
}

export type MongoMergeWhenMatchedOperationFilterInput = {
  eq?: InputMaybe<MongoMergeWhenMatched>;
  in?: InputMaybe<Array<MongoMergeWhenMatched>>;
  neq?: InputMaybe<MongoMergeWhenMatched>;
  nin?: InputMaybe<Array<MongoMergeWhenMatched>>;
};

export enum MongoMergeWhenNotMatched {
  Discard = 'DISCARD',
  Fail = 'FAIL',
  Insert = 'INSERT',
  NotSet = 'NOT_SET'
}

export type MongoMergeWhenNotMatchedOperationFilterInput = {
  eq?: InputMaybe<MongoMergeWhenNotMatched>;
  in?: InputMaybe<Array<MongoMergeWhenNotMatched>>;
  neq?: InputMaybe<MongoMergeWhenNotMatched>;
  nin?: InputMaybe<Array<MongoMergeWhenNotMatched>>;
};

export type MoveInventoryItemCommandInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  toLocationId: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

export type MoveMaterialItemInput = {
  countedRecorded: Scalars['DateTime']['input'];
  fromLocationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  movedByUserEmail: Scalars['String']['input'];
  quantityMoved: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocument = {
  __typename?: 'MovementOrderHistoryDocument';
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the movement order. */
  createdBy: Scalars['String']['output'];
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId: Scalars['String']['output'];
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName: Scalars['String']['output'];
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id: Scalars['String']['output'];
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId: Scalars['String']['output'];
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderReceived (the actual received quantities). */
  receivedLines: Array<MovementOrderHistoryLineDocument>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderCreated (the ordered/requested quantities). */
  requestedLines: Array<MovementOrderHistoryLineDocument>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderShipped (the actual shipped quantities). */
  shippedLines: Array<MovementOrderHistoryLineDocument>;
  /**
   * Lifecycle status, derived from the lifecycle timestamps rather than persisted — see the
   * class remarks. Mirrors the inferred-status approach of
   * WorkSuite.Domain.MovementOrder.MovementOrderState.
   */
  status: MovementOrderStatus;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId: Scalars['String']['output'];
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName: Scalars['String']['output'];
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber: Scalars['String']['output'];
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocumentFilterInput = {
  and?: InputMaybe<Array<MovementOrderHistoryDocumentFilterInput>>;
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id?: InputMaybe<StringOperationFilterInput>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MovementOrderHistoryDocumentFilterInput>>;
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderReceived (the actual received quantities). */
  receivedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderCreated (the ordered/requested quantities). */
  requestedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderShipped (the actual shipped quantities). */
  shippedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocumentSortInput = {
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt?: InputMaybe<SortEnumType>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<SortEnumType>;
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id?: InputMaybe<SortEnumType>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<SortEnumType>;
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: InputMaybe<SortEnumType>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: InputMaybe<SortEnumType>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: InputMaybe<SortEnumType>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: InputMaybe<SortEnumType>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: InputMaybe<SortEnumType>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: InputMaybe<SortEnumType>;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber?: InputMaybe<SortEnumType>;
};

/**
 * Per-line snapshot persisted on the create / ship / receive line lists of
 * MovementOrderHistoryDocument. Its own dedicated type (Atlas df828612 —
 * separate types per architectural layer): not shared with
 * PendingTransferOrderDocument or the events-only line record.
 */
export type MovementOrderHistoryLineDocument = {
  __typename?: 'MovementOrderHistoryLineDocument';
  /** Locked-at-receive-time organic flag carried verbatim from the event record. */
  isOrganicAtReceive: Scalars['Boolean']['output'];
  /** Stable client-supplied line-item id (matches the event record's LineItemId). */
  lineItemId: Scalars['String']['output'];
  /** MaterialItem moving on this line. */
  materialItemId: Scalars['String']['output'];
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: Maybe<Scalars['String']['output']>;
  /** Quantity recorded by the originating event (created = requested, shipped/received = actual). */
  quantity: Scalars['Decimal']['output'];
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-line snapshot persisted on the create / ship / receive line lists of
 * MovementOrderHistoryDocument. Its own dedicated type (Atlas df828612 —
 * separate types per architectural layer): not shared with
 * PendingTransferOrderDocument or the events-only line record.
 */
export type MovementOrderHistoryLineDocumentFilterInput = {
  and?: InputMaybe<Array<MovementOrderHistoryLineDocumentFilterInput>>;
  /** Locked-at-receive-time organic flag carried verbatim from the event record. */
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  /** Stable client-supplied line-item id (matches the event record's LineItemId). */
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  /** MaterialItem moving on this line. */
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MovementOrderHistoryLineDocumentFilterInput>>;
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  /** Quantity recorded by the originating event (created = requested, shipped/received = actual). */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * Per-line input shape used by every MovementOrder mutation. Mirrors the domain
 * command's MovementOrderLineData but lives at the GraphQL boundary so
 * future GraphQL-only field additions (e.g. a derived display label) do not bleed
 * into the durable domain command. HotChocolate auto-appends Input, so the SDL
 * type is MovementOrderLineInput — the Data suffix is reserved for
 * cross-layer shapes per the WSAPI convention.
 */
export type MovementOrderLineInput = {
  isOrganicAtReceive: Scalars['Boolean']['input'];
  lineItemId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  organicLotCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  vendorLotNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GraphQL projection of a single MovementOrder line snapshot (Created / Shipped /
 * Received). Carries the organic-at-receive flag and lot codes that downstream
 * material projections rely on (see MTR-04 and MTR-07).
 */
export type MovementOrderLineStateData = {
  __typename?: 'MovementOrderLineStateData';
  isOrganicAtReceive: Scalars['Boolean']['output'];
  lineItemId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  organicLotCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Decimal']['output'];
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL payload returned by every MovementOrder mutation. Follows the standard
 * mutation payload convention: nullable state on success, ValidationError array on failure
 * (see Atlas `cd1f708de28e44f8ae6d21f9a20f2212` — Payload Error Convention).
 */
export type MovementOrderPayload = {
  __typename?: 'MovementOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  movementOrder?: Maybe<MovementOrderStateData>;
};

/**
 * GraphQL boundary projection of MovementOrderState. Returned as the
 * state field on every MovementOrderPayload.
 * Optional timestamps from the state (MovementOrderState.ShippedAt etc.)
 * are declared as Option<DateTimeOffset>; the schema-build OptionTypeInterceptor
 * rewrites them to nullable in the emitted SDL for client consumption.
 */
export type MovementOrderStateData = {
  __typename?: 'MovementOrderStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  fromSiteLocationId: Scalars['String']['output'];
  lines: Array<MovementOrderLineStateData>;
  movementOrderId: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedBy: Scalars['String']['output'];
  receivedLines: Array<MovementOrderLineStateData>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Scalars['String']['output'];
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shippedBy: Scalars['String']['output'];
  shippedLines: Array<MovementOrderLineStateData>;
  status: MovementOrderStatus;
  tenantId: Scalars['String']['output'];
  toSiteLocationId: Scalars['String']['output'];
  varianceResolutions: Array<VarianceResolutionStateData>;
};

export enum MovementOrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Received = 'RECEIVED',
  Reconciled = 'RECONCILED',
  Shipped = 'SHIPPED',
  Unknown = 'UNKNOWN'
}

export type MovementOrderStatusOperationFilterInput = {
  eq?: InputMaybe<MovementOrderStatus>;
  in?: InputMaybe<Array<MovementOrderStatus>>;
  neq?: InputMaybe<MovementOrderStatus>;
  nin?: InputMaybe<Array<MovementOrderStatus>>;
};

/** A connection to a list of items. */
export type MovementOrderTransactionsConnection = {
  __typename?: 'MovementOrderTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MovementOrderTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MovementOrderHistoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MovementOrderTransactionsEdge = {
  __typename?: 'MovementOrderTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MovementOrderHistoryDocument;
};

/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Activates a feature flag, enabling its configured value for all tenants. */
  activateAdminFeatureFlag: AdminFeatureFlagPayload;
  activateAdminTenant: AdminTenantPayload;
  activateCategory: CategoryPayload;
  activateConfigCategory: ConfigCategoryPayload;
  activateContainerConfig: ContainerConfigPayload;
  activateCustomer: CustomerPayload;
  activateCustomerItem: CustomerItemPayload;
  /** @deprecated Use deleteCustomerType. The active/inactive toggle is being retired in favor of delete (AI Helm fd75fc05) -- this mutation is deprecated but still functional. */
  activateCustomerType: CustomerTypePayload;
  activateDeliverySchedule: DeliverySchedulePayload;
  activateItem: ItemPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  activateLocation: LocationPayload;
  activateMaterialItem: MaterialItemPayload;
  activatePriceGroup: PriceGroupPayload;
  activateProductionCategory: ProductionCategoryPayload;
  activateProductionItem: ProductionItemPayload;
  activateProductionLot: ProductionLotPayload;
  activateProductionMaterialEvent: ProductionMaterialEventPayload;
  activateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  activateProductionPlan: ProductionPlanPayload;
  activateProductionRecipe: ProductionRecipePayload;
  activateProductionSpaceCategory: ProductionSpaceCategoryPayload;
  activateProductionSpaceEvent: ProductionSpaceEventPayload;
  activateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  activateProductionSpaceType: ProductionSpaceTypePayload;
  activateProductionTaskEvent: ProductionTaskEventPayload;
  activateProductionTaskEventDetail: ProductionTaskEventPayload;
  activateProductionTrigger: ProductionTriggerPayload;
  /** @deprecated Status-based activation is deprecated. Use the Enabled flag instead. */
  activateSftpTenantConfig: SftpTenantConfigPayload;
  activateSizeUom: SizeUomPayload;
  activateTaskEventType: TaskEventTypePayload;
  activateTaxAuthority: TaxAuthorityPayload;
  activateTerms: TermsPayload;
  activateVendor: VendorPayload;
  addAdminTenant: AdminTenantPayload;
  addAvailabilitySessionCount: AvailabilitySessionPayload;
  addBillingAddress: CustomerPayload;
  addBlockingRuleLinkedItems: BlockingRulePayload;
  addBlockingRuleLinkedLocations: BlockingRulePayload;
  /**
   * Records a single lot change (move / add / subtract / output / confirm / add-inventory /
   * back-to-grow) for the calling BPF field user. Validates against current read state, writes an
   * immutable audit record, applies an optimistic delta to the BpfLotCounts read model, and
   * enqueues an ERP write-back for the post-back worker. Idempotent on IdempotencyKey: a
   * duplicate submit returns the existing audit record without re-applying or re-enqueuing.
   */
  addBpfLotChange: BpfLotChangePayload;
  addCategory: CategoryPayload;
  addConfigCategory: ConfigCategoryPayload;
  addContact: CustomerPayload;
  addContainerConfig: ContainerConfigPayload;
  /**
   * Coordinated mutation backing the wireframe's "Add New" button on the
   * ConfigCategory detail → Container Configs sub-tab. Creates the
   * ContainerConfig and then attaches its id to the ConfigCategory's
   * ContainerConfigIds list. If the second write fails the first stays;
   * the caller can retry the attach by id.
   */
  addContainerConfigForConfigCategory: ConfigCategoryPayload;
  addContainerConfigToConfigCategory: ConfigCategoryPayload;
  addCustomerItem: CustomerItemPayload;
  /**
   * The customer-type name field moved to Program-style free-solo creation: addCustomerType
   * now fires implicitly whenever a typed name does not match an existing option, rather than
   * from a deliberate "create new type" dialog. That makes same-name collisions routine instead
   * of exceptional, so this resolves them instead of erroring:
   *
   * An ACTIVE type with the same case-insensitive trimmed name already exists -> return
   * its current state (idempotent) instead of creating a duplicate or failing. Checked FIRST,
   * ahead of any inactive match, so a tenant that (via update-rename) ends up with both an
   * active and an inactive type sharing a name always converges on the active one.
   * No active match, but an INACTIVE (deactivated) type with that name exists ->
   * reactivate it and return the reactivated state. Chosen over rejecting: the free-solo UI has
   * no way to show the caller a deactivated type, so a rejection would be a dead end with no
   * path to recover the name. Reactivation only flips CustomerTypeStatus back to Active
   * -- it does not apply the incoming payload's RevenueGlAccountId to the reactivated
   * type, matching plain ActivateCustomerType's existing semantics. Reactivation runs
   * through a dedicated optimistic-concurrency entity function, so two callers racing the same
   * deactivated name cannot both append: the losing writer's append is rejected rather than
   * silently succeeding, and that rejection is recovered into the current state instead of
   * surfacing as an error -- exactly one CustomerTypeActivated event is written and every
   * racing caller returns the same id.
   * No match at all -> create as before.
   */
  addCustomerType: CustomerTypePayload;
  /**
   * Adds a free-text note to an inventory key (item + location + grade). Multiple notes are
   * allowed on the same key and the full history is retained; the author and timestamp are
   * recorded server-side. Notes are independent of quantity and never affect the inventory
   * uniqueness/grouping key. The resulting full note set is returned on the payload's inventory item.
   */
  addInventoryNote: InventoryItemPayload;
  addItem: ItemPayload;
  addItemAvailability: AvailabilitySessionPayload;
  addItemAvailabilityBatch: AvailabilitySessionPayload;
  /** Adds an upgrade ("Value Add") definition to the item's Attributes.Upgrades collection. */
  addItemUpgrade: ItemPayload;
  addLineItems: OrderPayload;
  /** Bulk adds hundreds of line items with optimized price resolution processing */
  addLineItemsWithPricing: OrderPayload;
  addLocation: CustomerPayload;
  addMasterLineItems: MasterOrderPayload;
  /**
   * Records a BATCH of retail product counts in one request — the PWA's offline-replay flush path.
   * The BPF-only tenant hard-gate runs once for the whole batch (a non-BPF tenant is rejected
   * wholesale); each count is then validated, written, and enqueued independently and idempotently,
   * so a per-count failure surfaces against that count rather than failing the batch. Returns one
   * result per input count, in input order.
   */
  addMultipleRetailProductCount: RetailProductCountBatchPayload;
  /** Attaches an upgrade ("Value Add") to an order line. */
  addOrderLineUpgrade: OrderPayload;
  /**
   * Claims input.domain for the calling tenant's portal and returns the DNS TXT record the
   * tenant must publish to prove ownership (read back off the returned settings). The domain is
   * PENDING until verified: it serves nothing and can trigger no certificate issuance.
   */
  addPortalCustomDomain: PortalSettingsPayload;
  addPriceGroup: PriceGroupPayload;
  addProductionLotAsyncImportJobRows: AsyncImportJobPayload;
  addProductionMaterialEventDetails: ProductionMaterialEventPayload;
  addProductionMaterialEventToCategory: ProductionCategoryPayload;
  addProductionRecipeVariation: ProductionRecipePayload;
  addProductionSpaceEventDetails: ProductionSpaceEventPayload;
  addProductionSpaceEventToCategory: ProductionCategoryPayload;
  addProductionTaskEventDetails: ProductionTaskEventPayload;
  addProductionTaskEventToCategory: ProductionCategoryPayload;
  /** Attaches a production task event to a production item with optional default assignment. */
  addProductionTaskEventToItem: ProductionItemPayload;
  addPromotionRuleLinkedItems: PromotionRulePayload;
  addPromotionRuleLinkedLocations: PromotionRulePayload;
  addPurchaseOrderLineItem: VendorPurchaseOrderPayload;
  addReserveRuleLinkedItems: ReserveRulePayload;
  addReserveRuleLinkedLocations: ReserveRulePayload;
  /**
   * Records a single retail product count (drop-off / credit / cycle-count / must-go) at a retail
   * customer location for the calling BPF field user. Validates the input, writes an immutable audit
   * record, and enqueues an ERP write-back (workflow = Retail) for the post-back worker → Nav
   * CustomerInventoryLog. Idempotent on IdempotencyKey: a duplicate submit returns the
   * existing audit record without re-enqueuing.
   */
  addRetailProductCount: RetailProductCountPayload;
  addSftpDestination: SftpTenantConfigPayload;
  addSftpMongoDestination: SftpTenantConfigPayload;
  addSftpTenantConfig: SftpTenantConfigPayload;
  addShipFromLocation: CustomerPayload;
  addSignatureImage: OrderPayload;
  addSiteLocationAsyncImportJobRows: AsyncImportJobPayload;
  addSizeUom: SizeUomPayload;
  addSizeUomToConfigCategory: ConfigCategoryPayload;
  /** Add a note to a task assignment. */
  addTaskAssignmentNote: TaskAssignmentPayload;
  /**
   * Binds an email-authentication domain to this tenant. The created path (the domain is not yet
   * authenticated account-wide with SendGrid) creates a SendGrid domain authentication and starts
   * Pending until its CNAME records validate — SendGrid's CNAME proof establishes ownership there.
   * The grandfather path (the domain is already SendGrid-authenticated account-wide and unclaimed)
   * no longer binds as Verified immediately: it starts Pending with a per-tenant ownership-challenge
   * TXT token that must be published at _worksuite.{domain} and confirmed via
   * validateTenantEmailDomain before it becomes Verified. A tenant may only have one bound
   * domain at a time, and a domain (or its underlying SendGrid authentication) may only be Verified
   * to one tenant at a time; a stale unverified pending claim stops reserving the domain after the
   * squat-relief window so it can never permanently block the rightful owner. The platform default
   * sender domain (silverfern.group) is rejected outright and can never be bound — no tenant
   * could publish its ownership TXT even absent that guard.
   */
  addTenantEmailDomain: TenantEmailDomainPayload;
  /** Adds a new sender identity (starts Pending). A same-address re-add is a no-op. */
  addTenantEmailSender: TenantEmailSenderPayload;
  addTerms: TermsPayload;
  addWsapiImportEntityMapping: WsapiImportPayload;
  adjustAvailabilitySessionCounts: AvailabilitySessionPayload;
  /** Adjusts the quantity of an existing inventory item. */
  adjustInventoryItem: InventoryItemPayload;
  /**
   * Adjusts the required quantity of an allocation that is still Requested or Confirmed,
   * recording the adjustment reason. A no-op (no event) when the new quantity equals the
   * current required quantity.
   *
   *
   * **Returns:**
   * The adjusted allocation, or validation/no-change errors.
   */
  adjustMaterialAllocation: MaterialAllocationPayload;
  /**
   * Adjusts (corrects) a material item's on-hand quantity at a bin to a new absolute value
   * with a reason. Distinct from countMaterialItem (an observation) and moveMaterialItem (a
   * relocation); mirrors FULFILL's adjustInventoryItem. The acting user is resolved from the
   * request context.
   */
  adjustMaterialItem: MaterialItemLocationQuantityPayload;
  adjustPostedProduction: ProductionLotPayload;
  /**
   * Adjusts the allocated quantity of an existing order-production-lot allocation. A no-op
   * (no event) when the new quantity equals the current allocated quantity. Rejected when
   * the allocation is Cancelled.
   */
  adjustProductionLotAllocation: OrderProductionLotAllocationPayload;
  adminCreateUserInvites: AdminCreateUserInvitesPayload;
  adminDbrCalcForceRecalcByCustomer: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByItem: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByLocation: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByTenant: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcRow: AdminDbrCalcWorkPayload;
  adminDeleteUserInvite: UserInvitePayload;
  adminResendUserInvite: UserInvitePayload;
  adminRestockCalcForceRecalcByCustomer: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByItem: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByLocation: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByTenant: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcRow: AdminRestockCalcPayload;
  adminRestockSeedImportData: AdminRestockSeedImportDataPayload;
  /**
   * Makes already-seeded import data flow the same day: clears today's RestockPreCalculation
   * success marker and satisfies the InventoryState dependency with a synthetic successful
   * iteration so the next worker tick re-runs the pre-calc for the tenant. Pairs with
   * adminRestockSeedImportData; poll adminRestockSeedingPipelineStatus after.
   */
  adminRestockSeedingKickPipeline: AdminRestockSeedingKickPipelinePayload;
  /**
   * Coarse, page-scoped advance of a single ProductionLot async-import job, driven by the external
   * wsapi-services scheduler. One call claims the job (if needed) and processes AT MOST one page of
   * the current phase, then returns — so request time is bounded and the scheduler loops while
   * hasMoreWork is true. The phase logic itself lives in the shared
   * ProductionLotAsyncImportAdvanceService (the same code the in-process worker runs).
   */
  advanceProductionLotAsyncImportJob: AdvanceProductionLotAsyncImportJobPayload;
  allocateLineItems: OrderPayload;
  /**
   * Allocates an order line against a spec production lot (CustomerId == null), creating
   * a new allocation stream with an absolute quantity reservation. The lot is looked up
   * in the read model to snapshot its Quantity (server-authoritative LotQty)
   * and FinishJobWeekReadyDate onto the event and to enforce the spec-lot constraint.
   * OrderedQty is a caller-supplied snapshot; LotQty is always resolved from
   * the lot document so the per-lot availability denominator cannot be corrupted by client input.
   * A lot with no FinishJobWeekReadyDate is rejected — spec lots are resolved via a
   * FinishJob, so a ready date must exist.
   * The chosen lot's production item must be linked to the order line's sales item: the order
   * line's ItemId is resolved from the read model and must equal the sales item linked to
   * the production item at the lot's FinishJob (catalog, category). This makes the T5d
   * single-writer rule (PRODUCE only allocates where FULFILL designated, against linked lots)
   * non-bypassable server-side, independent of any client-supplied scoping.
   */
  allocateProductionLotToOrderLine: OrderProductionLotAllocationPayload;
  allocateRestockSessionInventory: AllocationPayload;
  amendPurchaseOrderLineItem: VendorPurchaseOrderPayload;
  appendTaxAuthorityRate: TaxAuthorityPayload;
  applyConsolidation: ApplyConsolidationPayload;
  approvePurchaseOrder: VendorPurchaseOrderPayload;
  /**
   * Assigns the QuickBooks (Merge.dev) Income and COGS GL-account ids for an item.
   * Both ids are nullable — null clears the mapping. Each non-null id is validated
   * against MongoMergeDevAccount to ensure it exists and carries the
   * expected classification (Revenue for Income, Expense for COGS) before the
   * V1.ItemGlAccountsAssigned event is appended.
   */
  assignItemGlAccounts: ItemPayload;
  assignMaterialItemToVendor: MaterialItemPayload;
  /**
   * Scopes the user to a customer (the Portal/Buyer scope). Re-assigning the same
   * customer writes no event and reports "no changes". Staff users normally have no
   * customer scope.
   */
  assignUserCustomer: UserPayload;
  /**
   * Assigns the user a multi-value customer access limiter — the resolved customer scope used to
   * limit what the user can see (consumed by B2/C2/C3). An empty list clears the limit ("sees all");
   * re-assigning the same set (order-insensitive) writes no event and reports "no changes". This is
   * purely an access limiter: it NEVER adds the Portal role (Portal is an explicit role only).
   *
   * Admin/SuperAdmin gated: the outer RestockWriter policy excludes portal callers, and
   * RequireTenantAdmin requires either a platform superadmin JWT or the caller's own Active
   * directory entry holding the tenant Admin role. Tenant isolation comes from the caller's JWT.
   */
  assignUserCustomers: UserPayload;
  /**
   * Assigns the user a multi-value route access limiter (D2 keystone; blocks D3/D4) — a resolved
   * set of route CODE strings used to limit what the user can see (consumed by D3). An empty list
   * clears the limit ("sees all"); re-assigning the same set (order-insensitive) writes no event
   * and reports "no changes". This is purely an access limiter and never touches roles.
   *
   * Admin/SuperAdmin gated: the outer RestockWriter policy excludes portal callers, and
   * RequireTenantAdmin requires either a platform superadmin JWT or the caller's own Active
   * directory entry holding the tenant Admin role. Tenant isolation comes from the caller's JWT.
   */
  assignUserRoutes: UserPayload;
  /**
   * Scopes the user to a set of site/location nodes (parent-and-below access): the user gains
   * access to each assigned node and every descendant beneath it. An empty list clears the scope
   * ("no site limit" — the user sees all sites). Re-assigning the identical set writes no event
   * and reports "no changes". This axis is independent of roles and customer scope — the mutation
   * never touches either. Gated to tenant Admins (or a platform superadmin), matching the
   * invite/portal-provisioning surface, since site assignment grants access scope.
   */
  assignUserSites: UserPayload;
  /**
   * Atomic bench-to-bench move: emits Created + Shipped + Received in a single
   * KurrentDB transaction with one shared OccurredAt timestamp. Used by the Move
   * tab for same-site moves where there is no in-transit phase (~90% of greenhouse
   * volume per the MTR-01 board verdict). GraphQL field name is atomicMove
   * per the MTR-03 task spec.
   */
  atomicMove: MovementOrderPayload;
  /**
   * Attaches a grower availability photo to an item: validates the payload (jpeg/png/webp, up to
   * 5MB), stores the bytes in the shared public-read "item-images" Azure Blob container under a
   * tenant/item-scoped, content-addressed path, then records the returned RELATIVE path on a
   * session-less per-item photo stream with its recorded time — a configured public base URL
   * composes the absolute URL at resolve time. The image bytes never enter the event store — only
   * the resulting path is persisted and projected. The portal item image then resolves to the
   * newest availability photo, falling back to the item's own image. SessionId on input is
   * accepted but ignored: availability capture no longer flows through staged sessions, so no
   * session is resolved or required here.
   */
  attachAvailabilitySessionPhoto: AvailabilitySessionPayload;
  autoAllocateRestockSessionOrderQuantities: RestockSessionPayload;
  /**
   * Backfills the Stripe customer for a pre-existing tenant that was created before Stripe
   * provisioning (or while Stripe was unavailable). Idempotent — a tenant that already has a Stripe
   * customer is returned unchanged with no duplicate created. Unlike the create hook this surfaces a
   * Stripe failure as an error on the payload so an admin can retry.
   */
  backfillAdminTenantStripeCustomer: AdminTenantPayload;
  /**
   * Stamps trialKind = Standard on every existing trial tenant that carries no kind, so the
   * admin surfaces, the per-tenant override editor and any kind-conditional logic read a concrete
   * value instead of each re-deriving the same default. Idempotent: a tenant that already carries a
   * kind is left exactly as it is, and a re-run stamps nothing.
   *
   * Only the kind is written. trialLimits is left null — null already means "use the policy
   * default for this kind" — and restockCalcEnabled is never touched, because a backfill must
   * not retroactively flip configuration an existing tenant is already running on.
   *
   *
   * Nothing distinguishes a migrating customer's trial from an ordinary one retroactively, so EVERY
   * kind-less trial is stamped Standard, the restrictive kind. Known migrators are re-flagged
   * afterwards by hand from the Trial Tenants grid; the stamped ids are returned for exactly that
   * review.
   *
   *
   * tenantIds narrows the run to those tenants — useful for a small verification run before
   * the full one; omitted or empty runs across every trial tenant. Non-trial and deleted tenants are
   * never stamped, even when named explicitly.
   */
  backfillTrialKinds: TrialKindBackfillPayload;
  batchActivateCategories: CategoryBulkActionPayload;
  batchActivateCustomers: CustomerBulkActionPayload;
  batchActivateItems: ItemBulkActionPayload;
  batchActivatePriceGroups: PriceGroupBulkActionPayload;
  batchAddCategories: CategoryBulkActionPayload;
  batchDeactivateProductionLots: BatchDeactivateProductionLotsPayload;
  batchDeleteCustomers: CustomerBulkActionPayload;
  batchDeleteItems: ItemBulkActionPayload;
  batchDeletePriceGroups: PriceGroupBulkActionPayload;
  batchDeleteSiteLocations: SiteLocationBulkActionPayload;
  batchInactivateCategories: CategoryBulkActionPayload;
  batchInactivateCustomers: CustomerBulkActionPayload;
  batchInactivateItems: ItemBulkActionPayload;
  batchInactivatePriceGroups: PriceGroupBulkActionPayload;
  batchRemoveCategories: CategoryBulkActionPayload;
  batchUpdateCategories: CategoryBulkActionPayload;
  /**
   * Batch entry point for the wsapi-services CRM export worker. Each row carries exactly one
   * outcome (Completed / FailedTransient / FailedPermanent) for one customer. A row with a bad
   * outcome shape, an unknown customer, or a write failure lands in that row's
   * errors so one bad row never strands the rest of the cycle;
   * only an empty batch surfaces on the batch payload's errors.
   */
  batchUpdateCrmExportStatuses: CrmExportBatchPayload;
  /**
   * Batch entry point for the wsapi-services worker. Each row carries exactly one outcome
   * discriminator (Completed / FailedTransient / FailedPermanent). Rows with bad
   * discriminator shape land in that row's MergeDevExportPayload.Errors; the
   * whole batch never rejects, so a single bad row doesn't strand the rest of the cycle.
   * Whole-batch failures (empty updates, future quota / size limits) surface on
   * MergeDevExportBatchPayload.Errors instead.
   */
  batchUpdateMergeDevExportStatuses: MergeDevExportBatchPayload;
  /**
   * Atomically reassigns a single worker to multiple task assignments in one operation.
   * All reassignments are written in a single KurrentDB multi-stream append — either every
   * task is reassigned or none are persisted. No partial application on mid-batch failure.
   */
  bulkAssignTasks: BulkAssignTasksPayload;
  bulkCreateMaterialItem: MaterialItemBulkActionPayload;
  calculateRestockOrderQuantity: RestockCalculationPayload;
  /** Cancel an assignment. The caller's userId becomes the CancelledBy. */
  cancelAssignment: CycleCountAssignmentPayload;
  cancelErpLoadListSession: ErpLoadListSessionPayload;
  /**
   * Cancels an existing order-production-lot allocation, releasing the reserved quantity.
   * A no-op (no event) when the allocation is already Cancelled.
   */
  cancelProductionLotAllocation: OrderProductionLotAllocationPayload;
  cancelPurchaseOrder: VendorPurchaseOrderPayload;
  cancelRestockSession: RestockSessionPayload;
  /**
   * Cancels a scheduled future labor rate before it takes effect. Same error surface as
   * CancelScheduledOverheadRate.
   */
  cancelScheduledLaborRate: SiteLocationPayload;
  /**
   * Cancels a scheduled future overhead rate before it takes effect. Returns the post-cancel
   * aggregate state. Errors: RATE_CANCEL_CURRENT, RATE_CANCEL_HISTORICAL,
   * RATE_NOT_FOUND.
   */
  cancelScheduledOverheadRate: SiteLocationPayload;
  /** Cancel a task assignment. */
  cancelTask: TaskAssignmentPayload;
  /** Changes the status of a production catalog entry. */
  changeProductionCatalogStatus: ProductionCatalogPayload;
  changeVendorPurchaseOrderItems: VendorPurchaseOrderPayload;
  changeVendorPurchaseOrderStatus: VendorPurchaseOrderPayload;
  changeWorkOrderQuantityProduced: JobPayload;
  changeWorkOrderStatus: JobPayload;
  /**
   * Atomically claims up to batchSize Pending records for the given workflow and the calling
   * tenant — unclaimed, or whose existing claim has aged past
   * the claim lease TTL (30 minutes) and is presumed abandoned — leasing each
   * with a fresh claim token so concurrent workers do not double-process a live claim. Worker-facing:
   * wsapi-services calls this via the CallWorkSuite typed client, processes the returned
   * records against Nav, then calls markProcessed / markFailed per record.
   */
  claimPendingErpWriteBacks: ErpWriteBackClaimPayload;
  cleanCustomers: Array<CustomerErpIdPayload>;
  cleanItems: Array<ItemErpIdPayload>;
  clearActiveCountSession: ProductionLinePayload;
  /**
   * Removes a per-customer commission rate override, so the customer falls back to
   * the user's default rate.
   */
  clearCustomerCommissionOverride: CommissionConfigPayload;
  /**
   * Clears the typed note for a single NoteContext on one of
   * a customer's locations. Rejected as a no-op when that location/context has no current note.
   */
  clearCustomerLocationNote: CustomerPayload;
  /**
   * Clears the customer-level typed note for a single
   * NoteContext. Rejected as a no-op when that context has
   * no current note.
   */
  clearCustomerNote: CustomerPayload;
  /**
   * Clears a recipient address from a SendGrid suppression list (bounces / blocks / spam_reports /
   * unsubscribes) so future sends to it are attempted again. Staff-authorized (RestockWriter
   * parity — no portal callers). The target list comes from an explicit listType, or is
   * resolved from a recorded dropReason via the recorded drop-reason to list mapping
   * ("Bounced Address"→bounces, "Blocked"→blocks, "Unsubscribed Address"→unsubscribes,
   * "Spam Reporting Address"→spam_reports). Fails closed on any non-2xx with a sanitized error in
   * the payload.
   */
  clearEmailSuppression: ClearEmailSuppressionPayload;
  /**
   * Clears a single inventory note from a key (item + location + grade) by its note id. Rejected
   * as a no-op when the key has no note with that id. Other notes on the key are untouched.
   */
  clearInventoryNote: InventoryItemPayload;
  clearItemContainerConfigOverride: ItemPayload;
  /** Clears a production item's labor-cost override, reverting it to inherit from its category. */
  clearItemLaborCost: ProductionItemPayload;
  /**
   * Clears the item-level typed note for a single
   * NoteContext. Rejected as a no-op when that context has
   * no current note.
   */
  clearItemNote: ItemPayload;
  clearJobGrowWeeksOverride: ProductionLotPayload;
  clearJobLinksOverride: ProductionLotPayload;
  clearJobPlannedHoursOverride: ProductionLotPayload;
  clearJobPlantsPerPotOverride: ProductionLotPayload;
  /**
   * Clears the CALLING user's own profile picture. Resolves the caller's own directory entry from the
   * JWT and reports "no changes" (framework no-op) when no picture is currently set. No admin path.
   */
  clearMyProfileImage: UserPayload;
  clearOnHandAdjustmentQueue: MassUpdatePayload;
  /**
   * Clears the tenant's routing entry for one doc-type, reverting it to the built-in default
   * recipient contact type. Not idempotent: clearing a doc-type that has no tenant override
   * (never set, or already cleared) is a no-op that returns an EntityCommandHasNoChangesError
   * in `errors` with a null `orderEmailRecipientRouting`, rather than succeeding silently.
   * Mirrors setOrderEmailRecipientRouting.
   */
  clearOrderEmailRecipientRouting: OrderEmailRecipientRoutingPayload;
  /**
   * Clears the order-level typed note for a single
   * NoteContext. Rejected with a specific
   * "No <context> note exists to clear" ValidationError when that context has no current note.
   */
  clearOrderNote: OrderPayload;
  /** @deprecated Use clearSpaceDimensionOverride, which supports customer-scoped overrides. */
  clearSpaceCategorySiteOverride: ProductionSpaceCategoryPayload;
  clearSpaceDimensionOverride: ProductionSpaceCategoryPayload;
  clearTaskEventDirectCost: ProductionTaskEventPayload;
  /**
   * Clears a tenant's platform-billing rate card, returning it to the unoffered/no-rate-card state
   * (superadmin) — the counterpart to setTenantBillingRateCard, which cannot express an all-null card.
   * Every cadence is reset to not-offered, the currency to the default, and the active cadence cleared,
   * so the tenant sees the contact-your-representative alert again. Rejected with a validation error
   * when the tenant has an active Stripe subscription — the rate card cannot be pulled out from under a
   * live sub. Audited on the tenant stream like every other rate-card change; a tenant already unoffered
   * is a no-op.
   */
  clearTenantBillingRateCard: AdminTenantPayload;
  /**
   * Read-model-only reset of the calling tenant's Merge.dev integration data — the supported
   * "reset before recreate" step (reset → reconnect → re-sync). Deletes ONLY the tenant's
   * Merge-populated MongoDB read-model documents (customers + locations / contacts / sales-person,
   * vendors, item summaries incl. GL mappings, MergeDevAccount / MergeDevTaxRate / TaxAuthority,
   * orders + line items, MergeDevPayment, and the Merge sync-state / connection / sync-metrics
   * docs). It does NOT delete KurrentDB streams, reset projection checkpoints, or trigger a replay;
   * on reconnect the importer creates fresh random-id entities the live projection writes forward.
   * Idempotent and strictly scoped to the calling tenant. SuperAdmin only — a destructive
   * tenant-wide purge. See docs/runbooks/clear-tenant-integration-data.md.
   */
  clearTenantIntegrationData: ClearTenantIntegrationDataPayload;
  closeAvailabilitySession: AvailabilitySessionPayload;
  commitSpaceRebalance: CommitSpaceRebalancePayload;
  /**
   * Complete a task. On the transition from non-Completed -> Completed, atomically
   * emits a cross-aggregate CountMaterialItem with
   * MaterialItemCountType.Set against the MaterialItem aggregate so
   * the inventory snapshot reflects the worker's recorded count. Implemented as a
   * single KurrentDB.Client.KurrentDBClient multi-stream append via
   * WorkSuite.Domain.CycleCountAssignment.CompleteAssignmentTaskWithCount:
   *
   * * Serial identical retries are deterministic no-ops: the second call
   *   reads the already-Completed aggregate, IfChangedPer produces
   *   zero primary events, and the dynamic multi-stream builder
   *   short-circuits the secondary MaterialItemCounted.
   * * Primary-success + secondary-failure can no longer leave the cycle-count
   *   permanently uncounted — both writes are atomic in one KurrentDB
   *   transaction (multi-stream append).
   * * Both streams share the same client-IdempotentKey-derived
   *   EventMetadata for retry/correlation audit (cycle-2 Codex F3).
   *
   *
   * Concurrent completes (B25-A). The primary stream opts into optimistic
   * concurrency (WithOptimisticConcurrency()): the multi-stream append is
   * pinned to the assignment stream's revision observed at state-load time. Two
   * TRULY CONCURRENT requests against the same task both read the non-Completed
   * aggregate at the same revision; KurrentDB serializes the atomic multi-stream
   * appends and rejects the loser with WrongExpectedVersion (surfaced as
   * EntityAlreadyExists), rolling back BOTH its primary
   * AssignmentTaskCompleted and its secondary MaterialItemCounted.
   * The rejected writer is then reconciled against the now-Completed aggregate by
   * ReconcileAlreadyAppliedCompletion:
   *
   *
   * * an identical concurrent retry resolves to idempotent success — exactly one
   *   AssignmentTaskCompleted and one MaterialItemCounted are recorded;
   * * a concurrent retry carrying a DIFFERENT quantity surfaces a clean
   *   EntityAlreadyExists error (never a raw WrongExpectedVersionException),
   *   and the MaterialItem ledger is never double-counted.
   */
  completeAssignmentTask: CycleCountAssignmentPayload;
  completeCountSession: CountSessionPayload;
  /**
   * Completes an OAuth connect: validates the signed state against the caller, exchanges the
   * authorization code for tokens, resolves the mailbox address, and persists the connection to
   * the calling user's aggregate. The tenant and user are taken from the caller's JWT — never from
   * input.
   */
  completeM365MailboxConnect: M365MailboxConnectPayload;
  /**
   * Exchanges the Merge.dev public_token returned by the frontend Merge Link widget for a durable
   * account_token, then persists the integration via the existing UpsertMergeTenantIntegration
   * command. The public_token is single-use and is never stored.
   */
  completeMergeLink: TenantPayload;
  /** Complete a task assignment. Transitions from InProgress to Completed. */
  completeTask: TaskAssignmentPayload;
  /**
   * Completes a sender's verification from the link (or raw token) pasted out of the SendGrid
   * confirmation email: extracts the token, calls SendGrid verify-by-token with our API key (no
   * SendGrid login), then re-polls and records the status through the existing refresh path.
   */
  completeTenantEmailSenderVerification: TenantEmailSenderPayload;
  /**
   * Confirms a MaterialAllocationStatus.Requested allocation, moving it to
   * MaterialAllocationStatus.Confirmed and recording the confirmed quantity.
   * Rejected if the allocation is not currently Requested.
   *
   *
   * **Returns:**
   * The confirmed allocation, or validation errors.
   */
  confirmMaterialAllocation: MaterialAllocationPayload;
  confirmReceipt: VendorPurchaseOrderPayload;
  /**
   * Connects the current tenant to OrderEase. The supplied client key/secret are VALIDATED with a
   * live server-side grant against OrderEase (POST /api/v3/Auth/grant, platform X-Integration-Key
   * from server config); on success the credentials plus the returned refresh token #1 are stored
   * per-tenant via the UpsertOrderEaseTenantIntegration command, and a connection-status payload is
   * returned. The client secret and refresh token are never echoed back.
   */
  connectOrderEaseIntegration: OrderEaseConnectionPayload;
  consumeProductionJobsMaterials: ConsumeProductionJobsMaterialsPayload;
  /**
   * Internal wrong-customer correction (Bonnie-flagged UI). Atomically creates a
   * replacement order for newCustomerId and a credit for the source order's
   * customer from the source order's data via the multi-stream save — all-or-nothing.
   * The source order is left untouched. Purpose-built and intentionally specific: this is
   * NOT a generic duplicate-order or bulk-submit surface.
   */
  correctOrder: CorrectOrderPayload;
  countMaterialItem: MaterialItemLocationQuantityPayload;
  createAdHocVendorPurchaseOrder: VendorPurchaseOrderPayload;
  createAllocationTemplate: AllocationTemplatePayload;
  /**
   * Creates a Stripe Customer Billing Portal session for the calling tenant's own Stripe customer,
   * returning to returnUrl (tenant-scoped, not superadmin — the surface a tenant
   * uses to manage its own subscription in T7). A customer-type portal JWT is rejected. Returns the
   * hosted portal URL.
   */
  createBillingPortalSession: StripeBillingPortalSessionPayload;
  createBlockingRule: BlockingRulePayload;
  /**
   * Creates the commission configuration for a user. The user must exist in the
   * tenant's directory, be active, and hold the Sales or Sales Manager role. A user
   * can have only one commission configuration; creating a second one is rejected.
   */
  createCommissionConfig: CommissionConfigPayload;
  /**
   * Create a new cycle-count assignment. Server-side fan-out: each input item is
   * joined against MaterialItemLocationQuantityDocument to produce
   * one task per bin where the material is stocked. The supervisor nominates
   * items, the server materializes the (item × bin) tuples.
   */
  createCountAssignment: CycleCountAssignmentPayload;
  createCustomer: CustomerPayload;
  createErpLoadListSession: ErpLoadListSessionPayload;
  /**
   * Creates a forecast: Monday-snapped 1-53 week window, unique active name, customer and programs
   * required, Regions level only, with the tenant's comp settings captured into LockedConfig.
   */
  createForecast: ForecastPayload;
  /** Creates a new inventory item at the specified location. */
  createInventoryItem: InventoryItemPayload;
  /**
   * Renders the order's invoice PDF and creates a prefilled draft (with the PDF attached) in the
   * calling user's connected M365 mailbox, returning the draft's Outlook webLink. Worksuite
   * sends nothing — draft creation only. The order must belong to the caller's resolved tenant (a
   * foreign-tenant orderId is rejected as not-found), and the mailbox token is fetched for the
   * caller's own JWT identity; neither tenant nor user id is ever accepted from input.
   */
  createInvoiceEmailDraft: CreateInvoiceEmailDraftPayload;
  createJob: JobPayload;
  /**
   * Creates a kit for the caller's tenant. The tenant always comes from the JWT; the client
   * supplies only the site, and a caller restricted to specific sites cannot create a kit outside
   * them. The read-model scope snapshot is taken before the write so the nesting rules (container
   * hierarchy, cycle prevention) run against the surrounding kits.
   */
  createKit: KitPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  createLocation: LocationPayload;
  createMakeToOrderPlan: ProductionLotPayload;
  createMaterialItem: MaterialItemPayload;
  /** Create a new MovementOrder in Created state. Emits MovementOrderCreated. */
  createMovementOrder: MovementOrderPayload;
  /**
   * Starts a Stripe Checkout session so the signed-in tenant can pay for its own platform subscription
   * at the price set for the chosen billing frequency (tenant-scoped — the account is the caller's own,
   * taken from the sign-in, never supplied). The amount is set on the server from the account's agreed
   * pricing; the client never supplies a charge, and bank (ACH) payment is offered by default. This is
   * available only when the account has no active subscription, the chosen frequency has a published price,
   * and that price is below the online-payment limit — larger subscriptions are arranged directly with
   * Silver Fern. Returns the hosted Checkout URL to send the payer to.
   */
  createMySubscriptionCheckoutSession: StripeCheckoutSessionPayload;
  /**
   * Provisions a customer-portal (Buyer) user through the unified WorkSuiteUser
   * path — the single write path for portal users. Creates one directory user carrying
   * Portal, scopes it to the customer via AssignUserCustomer, then
   * emits a linked, portal-scoped UserInvite (LinkedUserId = the new user,
   * UserType.Customer + CustomerId). The wsapi-services invite worker then creates
   * the FusionAuth login stamped with the wsCustomerId/wsUserType=customer claims
   * and sends the set-password email, so the buyer signs in customer-scoped — no separate portal
   * user record. The auto-link of the FusionAuth user back onto this directory entry is chained
   * by MarkUserInviteCompleted exactly as for staff invites.
   *
   * Failure atomicity. Every command is validated (and the email-in-use guard run)
   * before any event is appended, so malformed input cannot persist a half-provisioned
   * user. The directory user and its customer scope are then written in ONE atomic append on the
   *  stream (), so a
   * fault can never leave an Active, scope-less Portal user. The invite is a second stream and
   * KurrentDB appends are single-stream-atomic, so it cannot join that append — that is the only
   * residual boundary, and it is reached solely with fully validated input.
   *
   *
   * Gated like createUserInvite:  excludes portal
   * callers, and the caller must be a platform superadmin JWT OR hold the Admin role in its own
   * directory entry (the superadmin arm lets a superadmin bootstrap the first portal user into an
   * empty tenant). The customer scope comes from the input; the tenant comes from the caller's JWT.
   */
  createPortalUser: UserPayload;
  /** Creates a new production catalog entry. */
  createProductionCatalog: ProductionCatalogPayload;
  createProductionItem: ProductionItemPayload;
  createProductionLine: ProductionLinePayload;
  createProductionLot: ProductionLotPayload;
  createProductionLotAsyncImportJob: AsyncImportJobPayload;
  createProductionMaterialEvent: ProductionMaterialEventPayload;
  createProductionRecipe: ProductionRecipePayload;
  createProductionRecipeWithVariation: ProductionRecipePayload;
  createProductionSpaceEvent: ProductionSpaceEventPayload;
  createProductionTaskEvent: ProductionTaskEventPayload;
  createProductionTrigger: ProductionTriggerPayload;
  createPromotionRule: PromotionRulePayload;
  createPurchaseOrderAllocation: PurchaseOrderAllocationPayload;
  createReport: ReportPayload;
  createReportFolder: ReportFolderPayload;
  /** Creates a new report schedule. */
  createReportSchedule: ReportSchedulePayload;
  /** Creates a new report template. */
  createReportTemplate: ReportTemplatePayload;
  createReserveRule: ReserveRulePayload;
  /**
   * Creates a Restock 2.0 session and immediately hands the heavy hydrate/populate/persist work
   * to the asynchronous RestockSessionCreationWorkflowWorker. The mutation appends
   * SessionCreated + SessionCreationStarted in one atomic batch and returns the
   * freshly-created (non-terminal, Populating phase) session — sub-second p95 even for
   * ~10k (location × item) sessions. Progress and terminal state are owned by the worker and the
   * projection (which drives the onRestockSessionBatchProgress contract); the PWA observes
   * completion via that subscription rather than blocking on this call.
   */
  createRestockSession: RestockSessionPayload;
  createScheduledOrder: MasterOrderPayload;
  createSiteLocationAsyncImportJob: AsyncImportJobPayload;
  /**
   * Creates a site map mapping a customer location and program to the grower site that produces for
   * it, with an optional exclude-from-distribution flag. Rejected when a mapping for the same location
   * and program already exists for the tenant.
   */
  createSiteMap: SiteMapPayload;
  /**
   * Starts a Stripe Checkout session (subscription mode) for the tenant at the rate-card amount for the
   * chosen cadence (superadmin). The charge is priced inline against the configured product and set
   * server-side. ACH is the default payment method. A charge at or above the configured online-payment
   * ceiling is rejected — no Stripe session is created — so the admin collects it offline instead.
   * Returns the hosted Checkout URL to hand the tenant.
   */
  createSubscriptionCheckoutSession: StripeCheckoutSessionPayload;
  /**
   * Simplified task creation mutation for the Events App.
   * Resolves the TaskEventType name from its ID and creates a TaskAssignment.
   */
  createTask: TaskAssignmentPayload;
  /** Creates a new task assignment for a given task event. */
  createTaskAssignment: TaskAssignmentPayload;
  createTaskEventType: TaskEventTypePayload;
  createTaxAuthority: TaxAuthorityPayload;
  /**
   * Creates a user in the tenant's directory. The email must not belong to another
   * active user in the tenant. Roles may be empty; they can be assigned later.
   *
   * Re-adding a previously DELETED user REVIVES them: when the email matches a tombstone in this
   * tenant, the original aggregate is restored on its existing stream instead of a second one being
   * started, and the payload returns that original userId — which may differ from the one the
   * caller supplied. Deactivated users are untouched by this: deactivation frees the email and a
   * re-add there still creates a new entry, exactly as before.
   */
  createUser: UserPayload;
  /**
   * Tenant-scoped invite creation for the worksuite app's Administration > Users page
   * ("Send invite"). Unlike the SuperAdmin-only Admin* console surface, this is callable
   * by any tenant user whose WorkSuiteUser directory entry is Active and holds the Admin role;
   * the tenant comes from the caller's JWT. Optionally carries the WorkSuiteUser to auto-link
   * when the worker reports provisioning completion.
   */
  createUserInvite: UserInvitePayload;
  createVendor: VendorPayload;
  createVendorPurchaseOrder: VendorPurchaseOrderPayload;
  createWorkOrder: JobPayload;
  createWsapiImport: WsapiImportPayload;
  /**
   * Creates one new Credit-type order from an existing order ("correct order with
   * credit"). Omit lines to credit the whole order; provide it to credit specific
   * lines/quantities. The source order is never modified — the credit links back to it via
   * creditedFromOrderId and a V1.OrderCreditedFromSource audit event.
   * Deliberately a dedicated mutation (not the generic duplicate flow) per architecture
   * guidance for order/money corrections.
   */
  creditExistingOrder: OrderPayload;
  /** Adds an item to an existing shopping cart for the authenticated tenant. */
  customerPortalAddItemToShoppingCart: ShoppingCartPayload;
  /** Adds line items to an order for the authenticated tenant. */
  customerPortalAddLineItems: OrderPayload;
  /** Adjusts availability session counts for the authenticated tenant. */
  customerPortalAdjustAvailabilitySessionCounts: AvailabilitySessionPayload;
  /**
   * Creates a new favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is
   * written — favorites lists are tenant-wide quick-order lists administered by staff.
   */
  customerPortalCreateFavoritesList: FavoritesListPayload;
  /**
   * Creates a customer-portal user, backed by the unified WorkSuiteUser aggregate.
   * Staff-only: a customer-type portal JWT is rejected with CUSTOMER_PORTAL_UNAUTHORIZED and
   * no event is written. Routes through the single shared PortalUserProvisioning
   * write path (Portal role + customer scope in one atomic append + a linked portal
   * UserInvite), so the customer must exist in the tenant and a FusionAuth login is
   * provisioned by the wsapi-services worker exactly as for the unified createPortalUser.
   *
   * Facade boundaries (see the @deprecated reason). The unified model has no free-form role
   * and a single display name, so the legacy Role string is ignored (the user is the Portal
   * role), FirstName/LastName are composed into the unified FullName, the
   * server generates the user id (the legacy caller-supplied PortalUserId is ignored), and a
   * customer scope is always required (Tenant-type portal users are no longer supported here).
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalCreatePortalUser: PortalUserPayload;
  /** Creates a new shopping cart for the authenticated tenant. */
  customerPortalCreateShoppingCart: ShoppingCartPayload;
  /**
   * Deactivates a customer-portal user, backed by the unified WorkSuiteUser aggregate.
   * Staff-only: a customer-type portal JWT is rejected with CUSTOMER_PORTAL_UNAUTHORIZED and
   * no event is written — this prevents a portal buyer from triggering an irreversible deactivation.
   * Maps onto the unified DeactivateUser command; an already-inactive user is rejected,
   * matching the legacy contract.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalDeactivatePortalUser: PortalUserPayload;
  /**
   * Soft-deletes a favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is written.
   */
  customerPortalDeleteFavoritesList: FavoritesListPayload;
  /** Initializes a new order from a shopping cart for the authenticated tenant. */
  customerPortalInitializeOrder: OrderPayload;
  /**
   * ANONYMOUS, rate-limited customer self-registration. Provisions a customer-portal (Buyer) user
   * through the SAME unified WorkSuiteUser composition the admin
   * createPortalUser mutation uses (PortalUserProvisioning): one directory
   * user carrying Portal + the customer scope, plus a single linked,
   * portal-scoped UserInvite so the wsapi-services worker creates the FusionAuth login with
   * the wsCustomerId/wsUserType=customer claims and sends the set-password email.
   *
   * Authorization. The caller is unauthenticated, so there is no JWT to scope the tenant —
   * the tenant is an explicit argument (the worksuite-pwa resolves it from its host/config exactly
   * as the other customer-portal entry points pass tenantId). Two gates stand in for the
   * missing JWT, both read straight from the tenant's PortalSettings KurrentDB stream (no
   * projection lag):  and
   *  must both be true. This reads
   * PortalEnabled directly rather than through the shared  gate —
   * that helper's staff bypass (!user.IsCustomer) would incorrectly ALLOW an anonymous
   * caller, which has no  at all. Both gates return the SAME
   * neutral, tenant-id-free error so an anonymous probe cannot distinguish "portal disabled" from
   * "self-registration disabled". When either gate fails the mutation is rejected with no event
   * written.
   *
   *
   * Untrusted input is server-bounded. Because the caller is unauthenticated, the FusionAuth
   * application + roles the new user is registered to are NOT taken from client input — they are
   * fixed server-side from  (portal application id +
   * a non-privileged role), so a caller cannot request registration into an arbitrary application
   * or a privileged role. The client-supplied CustomerId is additionally checked for
   * tenant-scoped existence inside the shared provisioning composition, so a buyer cannot scope
   * their new user to a customer they have no relationship with. Abuse resistance: per-client rate
   * limiting () plus the shared
   * active-email-in-use guard. The registrant's own (sanitized) email is recorded as the directory
   * user's and invite's CreatedBy, since a self-registered user is its own provisioner.
   *
   *
   * Live portal sign-in for a self-registered user additionally requires the wsapi-services
   * FusionAuth claim-stamping worker (PR-B); this mutation only writes the unified shape that
   * worker consumes.
   */
  customerPortalSelfRegister: UserPayload;
  /** Atomically increments and returns the next order number for the authenticated tenant. */
  customerPortalUpdateAndGetNextOrderNumber?: Maybe<NextOrderNumberPayload>;
  /**
   * Updates an existing favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is written.
   */
  customerPortalUpdateFavoritesList: FavoritesListPayload;
  /** Updates the status of an order for the authenticated tenant. */
  customerPortalUpdateOrderStatus: OrderPayload;
  /**
   * Updates a customer-portal user's name and customer scope, backed by the unified
   * WorkSuiteUser aggregate. Staff-only: a customer-type portal JWT is rejected with
   * CUSTOMER_PORTAL_UNAUTHORIZED and no event is written. The legacy single-shot update is
   * decomposed onto the unified stream (UpdateUserFullName + AssignUserCustomer) in
   * one atomic append; a fully unchanged request surfaces the unified "command data has no changes"
   * error, and an update against a deactivated user is rejected — matching the legacy contract.
   *
   * Facade boundaries. The free-form Role string and UserType on the legacy
   * input have no unified representation and are ignored; FirstName/LastName are
   * composed into the unified FullName.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalUpdatePortalUser: PortalUserPayload;
  /** Updates an existing shopping cart for the authenticated tenant. */
  customerPortalUpdateShoppingCart: ShoppingCartPayload;
  deactivateConfigCategory: ConfigCategoryPayload;
  deactivateContainerConfig: ContainerConfigPayload;
  deactivateCustomerItem: CustomerItemPayload;
  /** @deprecated Use deleteCustomerType. The active/inactive toggle is being retired in favor of delete (AI Helm fd75fc05) -- this mutation is deprecated but still functional. */
  deactivateCustomerType: CustomerTypePayload;
  /** Marks an upgrade Inactive (soft-deactivate); the definition is retained for replay/history. */
  deactivateItemUpgrade: ItemPayload;
  deactivateProductionCategory: ProductionCategoryPayload;
  deactivateProductionLine: ProductionLinePayload;
  deactivateProductionLot: ProductionLotPayload;
  deactivateProductionPlan: ProductionPlanPayload;
  deactivateProductionSpaceCategory: ProductionSpaceCategoryPayload;
  deactivateProductionSpaceType: ProductionSpaceTypePayload;
  deactivateSizeUom: SizeUomPayload;
  deactivateTaxAuthority: TaxAuthorityPayload;
  deactivateTerms: TermsPayload;
  /**
   * Deactivates the user. Deactivated users keep their history but no longer appear
   * as active directory entries.
   */
  deactivateUser: UserPayload;
  deallocatePurchaseOrderAllocation: PurchaseOrderAllocationPayload;
  /**
   * Creates or updates one holiday reference row for the calling tenant. The row's stream is keyed by
   * the (holiday name, year) pair, so redefining the same holiday for a year updates it in place.
   * Rejected when the (year, ISO week, date) triple is inconsistent per the W1 calendar, or when the
   * Forecast flag is disabled (no event written).
   */
  defineForecastHoliday: HolidayPayload;
  deleteAdminTenantIntegration: AdminTenantPayload;
  deleteAdminTenantPricingPage: TenantPricingPagePayload;
  /**
   * SuperAdmin-only bulk purge of every staged GrowPoint document for the caller's tenant — the
   * backend for the PWA "Delete All" button. Runs a single up-front import-lock check across all
   * GrowPointStagedEntity members (GrowPointImportLock); if any of the
   * tenant's import workers is running the whole operation is refused and nothing is deleted.
   * Otherwise it fans out over every enum member calling the same per-entity
   * DeleteStagedEntityForTenantAsync plumbing (each scoped to TenantId == user.TenantId)
   * and returns the aggregated per-entity results plus the grand total deleted.
   */
  deleteAllStagedEntityDocuments: DeleteAllStagedEntitiesResultData;
  deleteAllocationTemplate: AllocationTemplatePayload;
  deleteAvailabilitySessionCount: AvailabilitySessionPayload;
  deleteAvailabilitySessionCountBatch: AvailabilitySessionPayload;
  deleteBlockingRule: BlockingRulePayload;
  deleteCustomer: CustomerPayload;
  /**
   * Soft-deletes a customer type (AI Helm fd75fc05). Blocked while any customer is still
   * assigned to the type -- the in-use guard runs BEFORE the entity
   * transition and returns a payload error naming the assigned-customer count, never an
   * exception, and never silently clears the assignments. Deleting an already-deleted type is
   * an idempotent no-op, not an error.
   */
  deleteCustomerType: CustomerTypePayload;
  deleteDeliverySchedule: DeliverySchedulePayload;
  deleteErpLoadListSession: ErpLoadListSessionPayload;
  deleteErpLoadListUser: ErpLoadListUserPayload;
  /**
   * Soft-deletes a forecast (creator-only, guarded in the aggregate). The forecast drops out of
   * queries and no longer counts toward name uniqueness, but its stream and audit history remain.
   */
  deleteForecast: ForecastPayload;
  /**
   * Soft-deletes one holiday reference row (status flipped to Deleted; the query hides it). Rejected
   * when the Forecast flag is disabled (no event written).
   */
  deleteForecastHoliday: HolidayPayload;
  /**
   * SuperAdmin-only purge of the caller tenant's GrowPoint iteration/error records — the backend
   * for the PWA Integrations "Delete Errors" button. Runs a single DeleteManyAsync on the
   * Synchronization Iterations collection (database: Synchronization, collection: Iterations)
   * filtered on TenantId == user.TenantId AND the GrowPoint scope — never a tenant-less delete.
   *
   * The GrowPoint scope is Description contains "GrowPoint" OR Entity beginning with
   * GrowPoint. The first branch is exactly the population the Errors tab shows (its
   * synchronizationIterations query is filtered client-side by description contains
   * "GrowPoint"), so the tab empties after deletion; the second branch also clears any GrowPoint
   * worker iteration whose free-text description happens not to contain the word — including future
   * worker names the deployed enum has not learned yet, since Entity is persisted as its raw
   * string. Both branches are GrowPoint-specific, so non-GrowPoint synchronization iterations and
   * other tenants are never touched. Returns the deleted-document count.
   */
  deleteGrowPointIterations: DeleteGrowPointIterationsResultData;
  deleteItem: ItemPayload;
  /**
   * Soft-deletes a kit and strips every line that referenced it from the other kits in the same
   * tenant + site scope, atomically. The referencing kits are resolved from the read model; the
   * site comes from the kit's own stored scope, never from the client.
   */
  deleteKit: KitPayload;
  deleteOrder: OrderPayload;
  deletePriceGroup: PriceGroupPayload;
  /** Removes a single price level from a price group by id, leaving every other level in the group untouched. */
  deletePriceLevel: PriceGroupPayload;
  /** Removes one or more price levels from a single price group in one atomic update, leaving every other level in the group untouched. */
  deletePriceLevels: PriceGroupPayload;
  deleteProductionCategory: ProductionCategoryPayload;
  deleteProductionItem: ProductionItemPayload;
  deleteProductionLot: ProductionLotPayload;
  deleteProductionMaterialEvent: ProductionMaterialEventPayload;
  deleteProductionPlan: ProductionPlanPayload;
  deleteProductionRecipe: ProductionRecipePayload;
  deleteProductionSpaceCategory: ProductionSpaceCategoryPayload;
  deleteProductionSpaceEvent: ProductionSpaceEventPayload;
  deleteProductionSpaceType: ProductionSpaceTypePayload;
  deleteProductionTaskEvent: ProductionTaskEventPayload;
  deleteProductionTrigger: ProductionTriggerPayload;
  deletePromotionRule: PromotionRulePayload;
  deleteReport: ReportPayload;
  /** Deletes a report execution record (soft delete). */
  deleteReportExecution: ReportExecutionPayload;
  deleteReportFolder: ReportFolderPayload;
  /** Deletes a report schedule (soft delete). */
  deleteReportSchedule: ReportSchedulePayload;
  /** Deletes a report template (soft delete). */
  deleteReportTemplate: ReportTemplatePayload;
  deleteReserveRule: ReserveRulePayload;
  deleteRestockSession: RestockSessionPayload;
  deleteSftpTenantConfig: SftpTenantConfigPayload;
  deleteSiteLocation: SiteLocationPayload;
  /**
   * Soft-deletes a site map. The mapping drops out of queries and stops counting toward coverage, but
   * its stream and audit history remain, and its location/program natural key is freed for reuse.
   */
  deleteSiteMap: SiteMapPayload;
  /**
   * SuperAdmin-only purge of every staged GrowPoint document for one staged-entity type, scoped
   * to the caller's tenant. Clears each Mongo collection that backs the chosen
   * entity (e.g. Items clears both Items.Staged.Summary and
   * Items.Staged.ImportCommand) filtered on TenantId == user.TenantId — never a
   * tenant-less delete. Returns the per-collection and total deleted counts.
   */
  deleteStagedEntityDocuments: DeleteStagedEntityResultData;
  deleteTaskEventType: TaskEventTypePayload;
  deleteTenantIntegration: TenantPayload;
  deleteTenantPricingPage: TenantPricingPagePayload;
  deleteTerms: TermsPayload;
  /** Delete a time entry */
  deleteTimeEntry: DeleteTimeEntryPayload;
  /**
   * DELETES the user's directory entry — a distinct concept from deactivateUser.
   * Deactivation hides an otherwise-live user and keeps the read-model row (Status =
   * Inactive); deletion retires the entry, so the projection REMOVES the WorkSuiteUsers
   * row and leaves only a tombstone. Allowed from Active OR Inactive; rejected once the user is
   * already Deleted. Built for operator cleanup of the hundreds of FusionAuth-disconnected users.
   *
   * Gated to the SuperAdmin policy ONLY — deliberately tighter than deactivateUser's
   * RestockWriter, which is unchanged: deletion is destructive and irreversible from the
   * tenant UI's point of view. Tenant isolation still comes from the caller's JWT, so a superadmin
   * only ever deletes within the tenant they present.
   *
   *
   * Self-delete is rejected so an operator cannot lock themselves out mid-cleanup: the caller may
   * not delete the entry carrying their own email (case-insensitively) or their own FusionAuth
   * subject. The check is enforced against authoritative event-sourced state, so it holds even
   * while the user directory is still catching up.
   */
  deleteUser: UserPayload;
  /**
   * Tenant-scoped invite delete for the worksuite app's Administration > Users page. Unlike the
   * SuperAdmin-only adminDeleteUserInvite, the tenant comes from the caller's JWT and
   * the command stream is keyed by that tenant, so a tenant can only delete its OWN invites — an
   * inviteId belonging to another tenant resolves to a non-existent stream and is rejected. Gated
   * in code on the caller's Active Admin directory entry, like createUserInvite.
   */
  deleteUserInvite: UserInvitePayload;
  deleteWorkerConfig: AdminWorkerConfigPayload;
  deleteWsapiImport: WsapiImportPayload;
  disableWsapiImport: WsapiImportPayload;
  /** Discard an unlinked floating time entry. Transitions to Discarded status. */
  discardFloatingTimeEntry: FloatingTimeEntryPayload;
  /** Disconnects the calling user's mailbox (idempotent). Tenant and user come from the JWT. */
  disconnectM365Mailbox: M365MailboxConnectPayload;
  /**
   * Disconnects the current tenant from OrderEase: best-effort revokes the grant upstream
   * (POST /api/v3/Auth/revoke) then clears the stored credentials via deleteTenantIntegration.
   * Idempotent — disconnecting a tenant that is not connected is a clean success, not an error —
   * and it never blocks on the upstream revoke outcome, so a grower can always clear stale local
   * credentials.
   */
  disconnectOrderEaseIntegration: OrderEaseConnectionPayload;
  duplicatePriceGroup: PriceGroupPayload;
  editMasterOrder: MasterOrderPayload;
  editOrder: OrderPayload;
  /**
   * Commits one or more macro plan-cell edits. Each edit names a row (region + item), an editable cell,
   * an operation (Replace / AddTo / SubtractFrom / PercentageOf), and an operand; the server applies the
   * operation to the row's current value and re-derives the dependent cells per spec §4.4 (ships/sales
   * unit CEILING/FLOOR identities, last-year realization ratio for dollars, zero-guards), marking the
   * touched cells as user overrides so the next generation preserves them. At most one edit per row
   * (region + item) is allowed per call, so each row lands from one consistent recalc; a batch that
   * edits the same row twice is rejected. Rejects an edit to a row that does not exist in the forecast;
   * an all-no-op batch appends nothing.
   */
  editPlanCells: ForecastPayload;
  /**
   * Atomically edits a scheduled future labor rate. Same error surface as
   * EditScheduledOverheadRate.
   */
  editScheduledLaborRate: SiteLocationPayload;
  /**
   * Atomically edits a scheduled future overhead rate by emitting a cancel + insert event pair
   * in one command. Errors: RATE_NOT_FOUND, RATE_CANCEL_CURRENT,
   * RATE_CANCEL_HISTORICAL, RATE_EDIT_RETROACTIVE, RATE_EDIT_NOOP.
   */
  editScheduledOverheadRate: SiteLocationPayload;
  /**
   * Commits one or more weekly-cell edits. Each edit names a cell (ISO year + ISO week + region + item),
   * the metric to set (Sales or Ships units), and the absolute value; the server writes that metric's
   * value, marks it as a user override so the next weekly-distribution regeneration preserves it, and —
   * if the cell does not exist — creates it with all four values 0 plus the edited value (the two
   * Original* machine-baseline twins start at 0 for a user-invented week). It NEVER touches
   * Original*. At most one edit per weekly cell is allowed per call; a batch that edits the same
   * cell twice is rejected. An edit equal to the cell's current value is a no-op that appends nothing.
   */
  editWeeklyCells: ForecastPayload;
  enableWsapiImport: WsapiImportPayload;
  /**
   * Enqueues a single ERP write-back record (status Pending) for the calling tenant. Called by the
   * PWA-facing inventory mutation slices (Finish / Material / Retail) after they apply their
   * optimistic delta. Idempotent on IdempotencyKey: a duplicate enqueue with the same key
   * returns the existing record, so a retry never double-posts to Nav.
   */
  enqueueErpWriteBack: ErpWriteBackPayload;
  executeProductionJob: ProductionLotPayload;
  finalizeImportUpload: AsyncImportJobPayload;
  /** Flag a floating time entry as stale when it exceeds the linking window. */
  flagStaleEntry: FloatingTimeEntryPayload;
  /**
   * ADMIN ESCAPE HATCH — force-resolves a stuck make-to-order reservation to the Cancelled terminal
   * state, emitting a distinct audited cancellation event (recording the acting admin and the required
   * reason). SuperAdmin-only. Rejected unless the allocation is in a non-terminal reservation state
   * (Reserved or ProducedPegged); a terminal or manual-allocation state rejects, so the escape hatch
   * never races the saga to a resolved allocation.
   */
  forceCancelStuckMtoReservation: OrderProductionLotAllocationPayload;
  /**
   * ADMIN ESCAPE HATCH — force-resolves a stuck make-to-order reservation to the ReadyHandedOff terminal
   * state, emitting a distinct audited ready-handoff event (recording the acting admin and the required
   * reason). SuperAdmin-only. Rejected unless the allocation is in a non-terminal reservation state
   * (Reserved or ProducedPegged).
   */
  forceReadyHandoffStuckMtoReservation: OrderProductionLotAllocationPayload;
  /**
   * Fulfills a MaterialAllocationStatus.Confirmed allocation, moving it to
   * MaterialAllocationStatus.Fulfilled and recording the fulfilled quantity.
   * Rejected if the allocation is not currently Confirmed.
   *
   *
   * **Returns:**
   * The fulfilled allocation, or validation errors.
   */
  fulfillMaterialAllocation: MaterialAllocationPayload;
  /**
   * Kicks off a server-driven generation run for a forecast (W9). Runs the feature gate first, computes
   * the history freshness watermark this run pins its inputs at (ADR-001 §5.3, ARCH-3 — so repeat
   * generation over unchanged inputs is deterministic), then appends Forecast.V1.GenerationStarted
   * with an expected-version check. The aggregate rejects a second run while one is in flight (serialized
   * per forecastId, §5.1) and refuses a non-Regions or soft-deleted forecast. The background generation
   * worker picks the event up, runs the pure engine, and MERGE-upserts plan rows preserving planner
   * overrides unless overwriteOverrides. Progress and the final preserved/overwritten counts are
   * observable on the
   * forecast document's generationStatus.
   */
  generateForecast: ForecastPayload;
  /** Changes the grade of an inventory item. */
  gradeInventoryItem: InventoryItemGradePayload;
  /**
   * Atomic create-or-merge of a customer plus N ship-to locations in a single
   * write. Equivalent to MergeCustomerAsync followed by N
   * addLocation calls — but transactional. Locations[0] is the
   * primary ship-to; the rest are additional ship-to locations.
   */
  importCustomer: CustomerPayload;
  importHistoricalOrders: ImportHistoricalOrdersResult;
  /**
   * GrowPoint production import of one artax tax-authority row — the promotion the import
   * worker commits staged rows through. Dedupes by the GrowPoint natural key
   * (ErpId = artax.CODE) against the production TaxAuthorities read model: a
   * code unseen for the tenant starts a NEW aggregate stream (Created + RateAppended), while a
   * seen code re-keys onto the existing stream and appends a conditional Updated + RateAppended.
   * Idempotent — re-importing identical data emits zero new events (the domain's
   * IfChangedPer guards). COMMITS events via KurrentDB. Tenant [Authorize] (NOT
   * SuperAdmin): the import worker authenticates as the tenant. Still gated by
   * TaxCalculationGate — the import requires TaxCalculationEnabled;
   * glAccountId is left empty so the TaxAuthorityGlAccountGate never trips.
   */
  importTaxAuthority: TaxAuthorityPayload;
  /**
   * GrowPoint production import of one payment-terms row. Dedupes by the GrowPoint
   * terms-master natural key (TermsCode = artrm.CODE) against the production
   * terms read model: a code unseen for the tenant starts a NEW Terms aggregate stream
   * (addTerms), while a seen code re-keys onto the existing stream and appends edit
   * events (updateTerms). Idempotent — re-importing identical data emits zero new
   * events (the domain's IfChangedPer guard). COMMITS events via KurrentDB; this is the
   * promotion the staged validateTermsDocuments mutation defers to. Tenant
   * [Authorize] (NOT SuperAdmin): the import worker authenticates as the tenant.
   */
  importTerms: TermsPayload;
  /** Inactivates a feature flag, forcing it to return defaults regardless of configured values. */
  inactivateAdminFeatureFlag: AdminFeatureFlagPayload;
  inactivateAdminTenant: AdminTenantPayload;
  inactivateCategory: CategoryPayload;
  inactivateCustomer: CustomerPayload;
  inactivateDeliverySchedule: DeliverySchedulePayload;
  inactivateItem: ItemPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  inactivateLocation: LocationPayload;
  inactivateMaterialItem: MaterialItemPayload;
  inactivatePriceGroup: PriceGroupPayload;
  inactivateProductionItem: ProductionItemPayload;
  inactivateProductionMaterialEvent: ProductionMaterialEventPayload;
  inactivateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  inactivateProductionRecipe: ProductionRecipePayload;
  inactivateProductionSpaceEvent: ProductionSpaceEventPayload;
  inactivateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  inactivateProductionTaskEvent: ProductionTaskEventPayload;
  inactivateProductionTaskEventDetail: ProductionTaskEventPayload;
  inactivateProductionTrigger: ProductionTriggerPayload;
  /** @deprecated Status-based inactivation is deprecated. Use the Enabled flag instead. */
  inactivateSftpTenantConfig: SftpTenantConfigPayload;
  inactivateTaskEventType: TaskEventTypePayload;
  inactivateVendor: VendorPayload;
  /**
   * Stores one finished test run, overwriting any existing run with the same id so a publisher
   * that retries after a network failure converges rather than duplicating.
   *
   * Open to SuperAdmin OR the workerservice tier (the QaPublisher policy): the ADO pipeline
   * publishes with a service account, while a developer publishing a local run authenticates as
   * themselves.
   */
  ingestQaTestRun: QaTestRunPayload;
  initializeMasterOrder: MasterOrderPayload;
  /**
   * Records the intent to export a WorkSuite entity to Merge.dev. Typically called from the
   * Order aggregate transitioning into the tenant's configured trigger status; the
   * wsapi-services worker reads the resulting MergeDevExports read-model row.
   */
  initializeMergeDevExport: MergeDevExportPayload;
  initializeOrder: OrderPayload;
  /**
   * Link a floating time entry to one or more task assignments with split support.
   * Replay-idempotent: when every incoming TimeEntryId is already present on the
   * aggregate with the same TaskAssignmentId/Duration/order (or the FTE has reached
   * the terminal Linked status), the domain handler short-circuits via the primary
   * builder's AllowNoOp() opt-in and returns the unchanged current state.
   * No events are appended on the FTE primary stream or on any TaskAssignment
   * secondary stream. MixedReplay (partial overlap, or same TimeEntryId with a
   * mutated payload) is rejected upstream in Ensure as a ValidationError
   * and surfaces here in the payload's Errors array, unchanged.
   */
  linkFloatingTimeEntry: FloatingTimeEntryPayload;
  /**
   * Links the user to a FusionAuth login. Linking is rejected when the user is already
   * linked to a different FusionAuth user; re-linking the same FusionAuth user writes
   * no event and reports "no changes".
   */
  linkFusionAuthUser: UserPayload;
  /**
   * Links the user to an existing FusionAuth login resolved by email instead of a raw
   * FusionAuth user id. The email is resolved against the existing FusionAuth integration scoped
   * to the caller's tenant; the resolved id is then dispatched through the SAME
   * LinkFusionAuthUser command/event as the GUID-based mutation. When no in-tenant
   * FusionAuth user matches the email, a typed NotFound error is returned in
   * errors (no exception). Linking is rejected when the user is already linked to a
   * different FusionAuth user; re-linking the same FusionAuth user writes no event and reports
   * "no changes".
   */
  linkFusionAuthUserByEmail: UserPayload;
  /** Links one or more production items to a single sales item. Each link overwrites any prior link on that production item. */
  linkProductionItemsToSalesItem: LinkProductionItemsToSalesItemPayload;
  makeLiveAvailabilitySession: AvailabilitySessionPayload;
  /**
   * Links a tax authority to an imported QuickBooks tax rate (MergeDevTaxRate) for
   * the QB→WS reconciliation. Permissive by design (Phase 1): the backend does not verify
   * the rate exists or enforce one-rate-per-authority uniqueness — the PWA warns on
   * conflicts. Re-mapping to the same id is a no-op via IfChangedPer.
   */
  mapTaxAuthorityToMergeDevTaxRate: TaxAuthorityPayload;
  /**
   * Marks the universal one-time inbound pull as completed for the calling tenant, stamping the
   * completion time from Clock. Idempotent: re-invocation after completion is a no-op. The
   * inbound sync worker drives this once its first pull cycle finishes (§4.2+).
   */
  markAccountingOneTimePullCompleted: AccountingIntegrationConfigPayload;
  /**
   * Marks a claimed record Failed (recording the worker error and incrementing the retry count)
   * after a non-retryable Nav post failure. Worker-facing. Surfaces
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION if the record is no longer Pending — same
   * double-terminalization guard as markErpWriteBackProcessed.
   */
  markErpWriteBackFailed: ErpWriteBackPayload;
  /**
   * Marks a claimed record Processed after the worker successfully posted it to Nav. Worker-facing.
   * Surfaces ERP_WRITE_BACK_INVALID_STATUS_TRANSITION if the record is no longer Pending — including
   * a late call from a worker whose lease was reclaimed and already terminalized by another worker,
   * which this rejects instead of corrupting the already-terminal record.
   */
  markErpWriteBackProcessed: ErpWriteBackPayload;
  /**
   * Marks a Merge.dev export attempt successful with the Merge.dev-side invoice id. Called
   * by the wsapi-services worker after a successful CreateInvoice.
   */
  markMergeDevExportCompleted: MergeDevExportPayload;
  /**
   * Records a terminal (non-retryable) failure. Used both for inherently non-retryable
   * failures (validation, auth, 4xx-non-429) and for retry-budget exhaustion. Surfaces in the
   * admin UI for human review.
   */
  markMergeDevExportFailedPermanent: MergeDevExportPayload;
  /**
   * Records a transient (retryable) failure. The worker computed RetryCount and
   * NextRetryAt from its own budget (1m → 5m → 30m → 2h, 5 attempts) and is just
   * reporting; wsapi is purely a recorder. Re-submitting the same values is a no-op via
   * IfChangedPer.
   */
  markMergeDevExportFailedTransient: MergeDevExportPayload;
  markProductionLotReady: ProductionLotPayload;
  /** Mark RFID scan records as synced to external system */
  markRfidScansAsSynced: MarkRfidScansAsSyncedPayload;
  /** WORKER: records provisioning success and the provisioned tenant, keyed by requestId. */
  markTrialRequestProvisioned: TrialRequestPayload;
  /**
   * WORKER: stamps the generated tenant code on an Approved/Linked (or previously Failed) request
   * and moves it to Provisioning, keyed by the public requestId. The stamp is idempotent —
   * re-stamping the same code is a no-op success; a different code is rejected — so the worker can
   * safely retry. Omit tenantCode on the Link path or a retry to reuse the stamped code.
   */
  markTrialRequestProvisioning: TrialRequestPayload;
  /**
   * WORKER: records a (retryable) provisioning failure, keyed by requestId. The stamped
   * tenant code is preserved so the next provisioning attempt reuses it.
   */
  markTrialRequestProvisioningFailed: TrialRequestPayload;
  markUserInviteCompleted: UserInvitePayload;
  markUserInviteEmailFailed: UserInvitePayload;
  markUserInviteEmailSent: UserInvitePayload;
  markUserInviteFailed: UserInvitePayload;
  mergeBackgroundServiceConfig: AdminBackgroundServiceConfigPayload;
  mergeContainerConfig: ContainerConfigPayload;
  mergeCustomer: CustomerPayload;
  mergeDeliverySchedule: DeliverySchedulePayload;
  mergeErpLoadListUser: ErpLoadListUserPayload;
  /**
   * Upserts the calling tenant's forecast comp settings (one doc per tenant). Refused with a
   * ForecastDisabled error — no event written — when the tenant's
   * Forecast flag is disabled.
   */
  mergeForecastSettings: ForecastSettingsPayload;
  mergeItem: ItemPayload;
  mergeJobWorkOrders: JobPayload;
  /**
   * Issues a Merge.dev link_token for the current tenant. The frontend Merge Link widget consumes
   * this token to launch the connect flow; which connectors the widget offers is controlled entirely
   * in the SF Merge dashboard. The org Merge API key never leaves wsapi. The category argument
   * selects the Merge product category the link is scoped to — accounting (default, unchanged) or
   * CRM.
   */
  mergeLinkToken: MergeLinkTokenPayload;
  mergeMaterialItemByErpId: MaterialItemPayload;
  mergeMergeDevAccount: MergeDevAccountPayload;
  mergeMergeDevPayment: MergeDevPaymentPayload;
  mergeMergeDevTaxRate: MergeDevTaxRatePayload;
  /**
   * Sync-style upsert wrapper around initializeOrder. Returns the existing order
   * unchanged when one already exists at the deterministic OrderId; otherwise runs
   * the full initialize flow. Designed for MergeDev invoice import where the same
   * deterministic OrderId is emitted every sync cycle.
   */
  mergeOrder: OrderPayload;
  mergePriceGroup: PriceGroupPayload;
  mergePriceLevel: PriceGroupPayload;
  mergeProductionCategory: ProductionCategoryPayload;
  /** Upserts a production item from an external sync, creating it if new or merging changes if it already exists. */
  mergeProductionItem: ProductionItemPayload;
  mergeProductionPlan: ProductionPlanPayload;
  mergeProductionSpaceCategory: ProductionSpaceCategoryPayload;
  mergeProductionSpaceType: ProductionSpaceTypePayload;
  mergeReplenishmentSettings: ReplenishmentSettingsPayload;
  mergeSiteLocation: SiteLocationPayload;
  mergeVendor: VendorPayload;
  mergeWorkerConfig: AdminWorkerConfigPayload;
  /** Moves inventory from one location to another. */
  moveInventoryItem: InventoryItemMovePayload;
  moveMaterialItem: MaterialItemLocationQuantityPayload;
  /** Overrides the pricing of an existing order-line upgrade. */
  overrideOrderLineUpgradePricing: OrderPayload;
  overrideProducedQuantity: ProductionLotPayload;
  overrideProductionJobLocation: ProductionLotPayload;
  overrideProductionJobQuantity: ProductionLotPayload;
  overrideProductionJobWeekReady: ProductionLotPayload;
  overrideProductionJobWeekStart: ProductionLotPayload;
  overrideProductionJobYield: ProductionLotPayload;
  overrideProductionLotCustomer: ProductionLotPayload;
  overrideProductionLotQuantity: ProductionLotPayload;
  /**
   * Consolidated override mutation covering six per-row bulk operations: Add, Subtract,
   * Replace, ToDemand, ToAchievable, ToTargetWeeksOfSupply. Replaces the seven per-operation
   * mutations from Restock 1.x. When RestockOverrideType.ToTargetWeeksOfSupply is
   * selected the handler resolves quantities from the on-demand calc lane —
   * RestockCalcResults at the target weeks of supply, enqueueing cache misses for the
   * wsapi-services drain — so override, recalc, and session creation share one quantity
   * source; for all other types the entity computes the new per-row quantity inline. Undo
   * continues to flow through UndoRestockSessionOrderQuantityOverride pending
   * semantics redesign — see helm task 89e727277e9640228e5d23e22a646911.
   */
  overrideRestockSessionOrderQuantities: RestockSessionPayload;
  patchBatchAdminTenant: Array<AdminTenantPayload>;
  patchItem: ItemPayload;
  pauseCountSession: CountSessionPayload;
  /**
   * Posts a set of cycle counts for a store location.
   * Each count SETS (hard-counts) the inventory quantity for that item at that location.
   * Items not included in the submission are unaffected — a separate scheduled process
   * handles the zero-out window.
   */
  postCycleCounts: CycleCountPayload;
  postProductionJob: ProductionLotPayload;
  postProductionJobs: PostProductionJobsPayload;
  processErpLoadListSession: ErpLoadListSessionPayload;
  processOnHandAdjustment: OnHandProcessPayload;
  /**
   * UNAUTHENTICATED acceptance. Validates the code against the read model, then appends the
   * acceptance to the aggregate via a revision-pinned (optimistic-concurrency) append: the
   * expected stream revision is captured when state is loaded, so two concurrent accepts that
   * both observe the Unused revision cannot both append — the loser fails
   * WrongExpectedVersion (surfaced as EntityAlreadyExists) and receives the
   * terminal validity from the read model, never Valid. Single-use is therefore enforced at the
   * aggregate (atomic, not merely by the EnsureCanAccept guard), keyed by the 154-bit
   * unguessable code. No password is collected: the wsapi-services worker creates the
   * FusionAuth user with sendSetPasswordEmail = true within ~one tick.
   */
  publicUserInviteAccept: PublicUserInviteAcceptPayload;
  publishRestockWorkQueueResultBatch: RestockWorkQueueResultBatchPublishedPayload;
  queueOnHandAdjustment: OnHandProcessPayload;
  /**
   * Reactivates a previously deactivated user, restoring the directory entry to Active.
   * Reactivating a user that is already active is rejected with a typed error.
   */
  reactivateUser: UserPayload;
  reapplyRecipes: ReapplyRecipesPayload;
  /** Reassign a task assignment to a different worker. */
  reassignTask: TaskAssignmentPayload;
  reassignWsapiImportIntegration: WsapiImportPayload;
  /**
   * Rebuilds the weekly retail-history cache for customerId in the calling tenant and reports how many
   * buckets were written, how many stale buckets were removed, how many unmapped daily rows were skipped,
   * and the history through-date. Replay-idempotent: a re-run over unchanged ImportData leaves
   * byte-identical documents.
   */
  rebuildForecastWeeklyHistory: ForecastWeeklyHistoryRebuildPayload;
  /**
   * BYOA-v1 recalc (RC5). Enumerates the session's existing rows, enqueues each
   * (tenant, customer, item, location, wos) tuple into RestockCalcOnDemandWork
   * for the wsapi-services drain, polls RestockCalcResults until every row has a
   * CalcDate at or after the request stamp, then appends a single
   * OrderItemsPatched event carrying the fresh demand/achievable values. Per-row user
   * overrides survive: the patch record carries no OrderQuantity, so
   * WorkSuite.Domain.Restock.Session.RestockSessionState's patch apply leaves
   * existing override state untouched.
   */
  recalculateRestockSession: RestockSessionPayload;
  /**
   * Record receipt of an in-flight MovementOrder. Transitions Shipped → Received.
   * Identical retries are deterministic no-ops.
   */
  receiveMovementOrder: MovementOrderPayload;
  receiveVendorPurchaseOrderItems: VendorPurchaseOrderPayload;
  /**
   * Resolve a shipped-vs-received variance on a received MovementOrder. Transitions
   * Received → Reconciled; the aggregate is terminal after reconciliation.
   */
  reconcileMovementOrder: MovementOrderPayload;
  /**
   * Resolves the tenant's existing Merge.dev linked account server-side and reactivates the
   * integration with no public-token exchange. Covers the disconnect-then-reconnect path: when
   * Merge still holds the link, the Merge Link widget shows "You're connected!" and closes
   * firing only onExit, so the frontend never receives a public token for completeMergeLink.
   * The account token retained on TenantState (it survives deleteTenantIntegration; Merge
   * tokens do not rotate) is verified against Merge's account-details endpoint before the
   * integration is upserted. A tenant with no still-valid Merge linked account gets a clear
   * GraphQL error, never a silent no-op; the deterministic IntegrationId plus the upsert's
   * change guard make the reconnect idempotent when the integration is already active.
   */
  reconnectMergeLink: TenantPayload;
  recordAvailabilitySessionCounts: AvailabilitySessionPayload;
  /**
   * Records a SendGrid delivery event, correlating it to a send by message id. When a correlated
   * send is found, the delivery ledger write AND an absolute delivery rollup onto the send are
   * emitted in one atomic multi-stream transaction (Atlas 2a4e5847), so the send's persisted
   * DeliveryStatus is failure-filterable by an indexed query. When no send is found yet
   * (a delivery that raced ahead of its send), only the ledger is written and the query-time read
   * fallback surfaces the outcome until a later event rolls up.
   * Worker-tier only via [Authorize(Policy = Policies.WorkerService)] (role
   * workerservice), mirroring the MergeDevExport worker-outcome mutations: its
   * FindCorrelatedSend lookup is deliberately NOT tenant-scoped (the SendGrid webhook
   * responder authenticates as the System tenant and correlates cross-tenant by the globally-unique
   * message id), so a tenant JWT is rejected here rather than being able to forge
   * DeliveryStatus/classification onto another tenant's send read-model.
   */
  recordEmailDelivery: EmailDeliveryPayload;
  /** Records a single email send. Called by each send path after dispatching to SendGrid. */
  recordEmailSend: EmailSendPayload;
  /**
   * Records a manually-entered cost against a production job. The command is validated, appended
   * to the job cost ledger stream, and the persisted cost record is returned in the payload.
   *
   *
   * **Returns:**
   * A payload containing the recorded cost record, or validation errors.
   */
  recordManualJobCost: JobCostPayload;
  /**
   * Records a single receipt against an open material order line for the calling BPF field user.
   * Validates against the worker-owned ErpOrders read model (order + line exist, quantity
   * > 0 and ≤ outstanding), writes an immutable receipt audit record, enqueues a Material ERP
   * write-back for the receipt post-back worker, and applies an optimistic decrement to the order
   * line's outstanding quantity. Idempotent on IdempotencyKey: a duplicate submit returns
   * the existing receipt without re-applying or re-enqueuing.
   */
  recordMaterialReceipt: MaterialReceiptPayload;
  /**
   * Records a deposit against an order. The deposit is written as a Kind = Deposit entry on
   * the order's payment ledger (a FULFILL-local concept, not pulled from an accounting
   * integration), counts toward the order's amount paid, and can satisfy the customer's deposit
   * requirement so the order can be allocated.
   */
  recordOrderDeposit: OrderPayload;
  /**
   * Records a manual payment against an order's payment ledger (full or partial amount),
   * appending a manual entry and recomputing the order's amount-paid, balance, and payment
   * status. Restricted to tenants with no accounting integration — for integrated tenants
   * payments are read-only and sourced from the accounting software, so the mutation is
   * rejected with no write-back. Multiple manual payments accumulate into a payment history.
   */
  recordOrderPayment: OrderPayload;
  /** Records a new report execution. */
  recordReportExecution: ReportExecutionPayload;
  recordShrinkEvent: ProductionLotPayload;
  /**
   * Stamps the calling staff user's own directory record with the current time as their last-active
   * moment, throttled server-side to once per hour so a misbehaving client cannot spam writes.
   * Always reports success -- an activity heartbeat must never surface an error to the caller, so
   * any failure (no directory entry, a transient write error) is logged and swallowed internally.
   */
  recordUserActivity: Scalars['Boolean']['output'];
  /**
   * Applies a batch of FusionAuth last-login instants to the caller's tenant. The tenant is always
   * the caller's own JWT tenant, never part of the input -- an entry cannot reach another tenant's
   * document. Each entry's fusionAuthUserId is validated as a GUID before anything is
   * written; a malformed id fails the whole batch loudly (a populated errors array), naming
   * the offending index and value, rather than silently reporting updatedCount = 0. Entries
   * sharing the same fusionAuthUserId within one batch are collapsed to the single LATEST
   * instant before the write, so a duplicated id can never inflate updatedCount. A monotonic
   * guard (lastLoginAt unset, or strictly older than the incoming instant -- an EQUAL instant
   * does not re-advance) is re-asserted atomically at the database via the filter on each per-row
   * update, so a stale or replayed page can never move a user's last-login backwards; an entry whose
   * fusionAuthUserId matches no row in the tenant is likewise excluded from the match, not an
   * error. One bulk write carries every row in a single round-trip rather than looping per entry.
   *
   * Gated to the wsapi-services worker tier (a service-account JWT), NOT the broader staff
   * gate recordUserActivity uses: that mutation only ever stamps the CALLER's own row, so any
   * staff JWT is safe; this mutation writes OTHER users' rows keyed by a client-supplied
   * fusionAuthUserId, so an ordinary staff caller must not be able to forge another user's
   * last-login.
   */
  recordUserLastLogins: RecordUserLastLoginsPayload;
  /** Refreshes (polls) a sender's verification status from SendGrid. */
  refreshTenantEmailSenderStatus: TenantEmailSenderPayload;
  refreshTenantIntegrationTokens: TenantIntegrationTokensPayload;
  registerCount: CountSessionPayload;
  /**
   * Releases an allocation, moving it to MaterialAllocationStatus.Released
   * and recording the release reason. Rejected if the allocation is already Fulfilled;
   * a no-op (no event) when the allocation is already Released.
   *
   *
   * **Returns:**
   * The released allocation, or validation/no-change errors.
   */
  releaseMaterialAllocation: MaterialAllocationPayload;
  removeBillingAddress: CustomerPayload;
  removeBlockingRuleLinkedItems: BlockingRulePayload;
  removeBlockingRuleLinkedLocations: BlockingRulePayload;
  removeCategory: CategoryPayload;
  removeContact: CustomerPayload;
  removeContainerConfigFromConfigCategory: ConfigCategoryPayload;
  removeImportRows: AsyncImportJobPayload;
  /**
   * Explicitly clears the item's minimum ship quantity. UpdateItemAttributes / PatchItem treat an
   * omitted MinShipQty as "preserve existing", so this dedicated mutation is the only way to REMOVE
   * it once set. No-op (EntityCommandHasNoChanges) when none is currently set.
   */
  removeItemMinShipQty: ItemPayload;
  /**
   * Explicitly clears the item's royalty configuration. UpdateItemAttributes / PatchItem treat an
   * omitted royalty as "preserve existing", so this dedicated mutation is the only way to REMOVE a
   * royalty once set. No-op (EntityCommandHasNoChanges) when no royalty is currently set.
   */
  removeItemRoyalty: ItemPayload;
  /**
   * Explicitly clears the item's substitution. UpdateItemAttributes / PatchItem treat an omitted
   * substitution as "preserve existing", so this dedicated mutation is the only way to REMOVE a
   * substitution once set. No-op (EntityCommandHasNoChanges) when none is currently set.
   */
  removeItemSubstitution: ItemPayload;
  removeLineItem: OrderPayload;
  removeLineItemAllocations: OrderPayload;
  removeLocation: CustomerPayload;
  removeMasterLineItem: MasterOrderPayload;
  /** Removes an upgrade from an order line. */
  removeOrderLineUpgrade: OrderPayload;
  /**
   * Withdraws a custom portal domain: the host stops resolving and stops being approved for
   * certificate issuance immediately, and the host is released for any tenant to claim.
   */
  removePortalCustomDomain: PortalSettingsPayload;
  removeProductionMaterialEventDetail: ProductionMaterialEventPayload;
  removeProductionMaterialEventFromCategory: ProductionCategoryPayload;
  removeProductionRecipeVariation: ProductionRecipePayload;
  removeProductionSpaceEventDetail: ProductionSpaceEventPayload;
  removeProductionSpaceEventFromCategory: ProductionCategoryPayload;
  removeProductionTaskEventDetail: ProductionTaskEventPayload;
  removeProductionTaskEventFromCategory: ProductionCategoryPayload;
  /** Detaches a production task event from a production item. */
  removeProductionTaskEventFromItem: ProductionItemPayload;
  removePromotionRuleLinkedItems: PromotionRulePayload;
  removePromotionRuleLinkedLocations: PromotionRulePayload;
  removePurchaseOrderLineItem: VendorPurchaseOrderPayload;
  removeReserveRuleLinkedItems: ReserveRulePayload;
  removeReserveRuleLinkedLocations: ReserveRulePayload;
  removeSftpDestination: SftpTenantConfigPayload;
  removeSftpMongoDestination: SftpTenantConfigPayload;
  removeShrinkEvent: ProductionLotPayload;
  removeSizeUomFromConfigCategory: ConfigCategoryPayload;
  /**
   * Removes a space-capacity window by its full key (sub-location, space type, year-scope, week range).
   * A no-op when the window does not exist.
   */
  removeSpaceCapacityWindow: SiteLocationPayload;
  /** Remove a completed time entry from a task assignment. */
  removeTaskAssignmentTimeEntry: TaskAssignmentPayload;
  /**
   * Unbinds this tenant's email-authentication domain. Blocked with a payload error while any
   * DOMAIN-method sender still depends on it (remove or re-verify those senders first). The
   * underlying SendGrid domain authentication is only deleted when it was created for this tenant
   * (the created path); a grandfathered account-wide authentication is left intact.
   */
  removeTenantEmailDomain: TenantEmailDomainPayload;
  /**
   * Removes a sender identity. When the sender carries a SendGrid id its verified-sender record is
   * deleted from SendGrid first; orphans (never registered with SendGrid) are removed locally only.
   */
  removeTenantEmailSender: TenantEmailSenderPayload;
  /** Removes the tenant's SMTP connection (idempotent). Returns a null connection on success. */
  removeTenantSmtpConnection: TenantSmtpConnectionPayload;
  removeVerifyContainer: VerifyContainerPayload;
  removeWsapiImportEntityMapping: WsapiImportPayload;
  renameReportFolder: ReportFolderPayload;
  reopenProductionJob: ProductionLotPayload;
  replaceCustomerSalesPeople: CustomerPayload;
  replaceErpLoadListRoutes: ErpLoadListRoutesPayload;
  replaceSalesPeople: CustomerPayload;
  /**
   * Requests a new material allocation, creating the aggregate in the
   * MaterialAllocationStatus.Requested state.
   *
   *
   * **Returns:**
   * The created allocation, or validation errors.
   */
  requestMaterialAllocation: MaterialAllocationPayload;
  /**
   * Requests server-side Restock calculation for a session. Emits a RestockCalculationRequested
   * event and returns immediately; the background orchestrator routes the requested scope through
   * the on-demand calc lane (wsapi-services drain) and patches the fresh results back onto the
   * session's rows. Empty itemIds/locationIds means all rows on the session. Track completion via
   * the session's calculationStatus (InProgress to Idle, or Failed with lastCalculationError).
   */
  requestRestockCalculation: RestockSessionPayload;
  requestRestockDashboardRecalc: RestockDashboardRecalcPayload;
  /** Triggers SendGrid verification for a sender and records the returned handle + status. */
  requestTenantEmailSenderVerification: TenantEmailSenderPayload;
  /**
   * ANONYMOUS: issues a short-lived email-verification code for a trial prospect. Rate-limited on
   * BOTH caller IP and submitted email (the reusable identity path), and disposable domains are
   * rejected up front. wsapi writes the code to the verification stream; the wsapi-services
   * delivery worker sends the email — wsapi never sends mail directly (the same split as
   * UserInvite). The response is uniform: it never reveals whether the address is already known.
   */
  requestTrialSignupVerification: RequestTrialSignupVerificationPayload;
  /**
   * Tenant-scoped invite resend for the worksuite app's Administration > Users page. Unlike the
   * SuperAdmin-only adminResendUserInvite, the tenant comes from the caller's JWT and
   * the command stream is keyed by that tenant, so a tenant can only resend its OWN invites — an
   * inviteId belonging to another tenant resolves to a non-existent stream and is rejected. Gated
   * in code on the caller's Active Admin directory entry, like createUserInvite.
   *
   * This is also the chosen re-invite path for an EXPIRED invite. The aggregate's
   * EnsureCanResend guard only checks !Deleted && Status == Unused — it does
   * not check ExpiresAt — and the resent event always sets
   * ExpiresAt = now.AddDays(state.ExpiresInDays), so calling this on an invite that is
   * Unused-but-expired already works today with no aggregate change: it resets the expiry (and
   * re-queues the send by resetting EmailStatus to PendingSend) on the SAME invite
   * row, reusing the SAME code. A tenant admin finds the expired invite's id via
   * userInvites(includeExpired: true) and calls this exactly as for a still-pending invite.
   * The alternative path — calling createUserInvite again for that email — is deliberately
   * rejected instead (TenantInviteAccess.EnsureNoExpiredInviteAwaitingResend) so a
   * caller who tries that gets an actionable error pointing back here, rather than silently
   * accumulating a second, independent invite for the same recipient.
   */
  resendUserInvite: UserInvitePayload;
  resetAcknowledgmentEmail: Array<OrderPayload>;
  /**
   * Cross-tenant admin mutation that clears ALL of a tenant's integration links plus the retained
   * Merge account token from the Tenant aggregate. This is the compensating transition for the
   * tenant-reset flow: the reset preserves the Tenant aggregate stream (so benign tenant config
   * survives) but the integration link lives on that same stream, so without this it survives as a
   * "zombie" connected integration while every read model is wiped. Idempotent — a tenant with no
   * integrations and no retained Merge token is a no-op. Unlike deleteTenantIntegration
   * (single link, token kept for reconnect), this deliberately also clears the Merge account token
   * so a full reset leaves a completely clean slate. SuperAdmin only.
   */
  resetAdminTenantIntegrations: AdminTenantPayload;
  resetConfirmationEmail: Array<OrderPayload>;
  resetOrderSyncStatus: Array<OrderPayload>;
  /**
   * Recovers a user whose FusionAuth login is dead or stale — the FusionAuth account was deleted
   * out-of-band, leaving a dangling fusionAuthUserId on the directory row that makes the
   * Users page report a (false) "Active login" and hide the invite action. In ONE call the stale
   * link is cleared and a fresh invite linked to the SAME directory row is issued, so the user is
   * never deactivated and never forked into a duplicate row.
   *
   * Why unlink and invite must be one mutation. Both existing invariants point the same
   * way. EnsureEmailHasNoActiveAccount blocks a plain
   * createUserInvite while the row is Active with a non-empty FusionAuthUserId —
   * the unlink is exactly what flips that guard to pass — and, at the other end,
   * MarkUserInviteCompleted's auto-link is rejected by
   * EnsureActiveAndNotLinkedToAnotherUser when a DIFFERENT FusionAuth id already sits on
   * the user, so the new login could never bind while the dead id remained. This resolver
   * therefore performs the unlink itself and does NOT run the active-account guard; that guard's
   * semantics on the plain createUserInvite path are untouched.
   *
   *
   * A dead link is indistinguishable from a live one here. Nothing on the directory row
   * records whether the FusionAuth account still exists — that is precisely why the incident's
   * Users page reported a working "Active login" — and this surface issues no FusionAuth traffic
   * (the worker holds the only FusionAuth API key). So a reset is deliberately allowed against a
   * healthy login too, and its effect there is the same recoverable one: the login is replaced by
   * a set-password invite to the row's own address. It grants a tenant Admin nothing they could
   * not already do by deactivating and re-adding the user — only without forking the row.
   *
   *
   * Duplicate pending invites: revoke-and-replace. Any pending, unexpired invite for the
   * same email is deleted before the replacement is created (rather than erroring like
   * EnsureNoPendingInvite does for createUserInvite). A
   * broken login is precisely the state that accumulates dead pending invites, so refusing to
   * reset until an admin hand-deletes them would re-create the dead end this recovery exists to
   * break; the outcome is always exactly one live invite for the address.
   *
   *
   * Atomicity. Both commands built from caller input are validated before any event is
   * appended, so malformed input can never clear a link and then fail to issue the replacement.
   * (The revoke leg's own validation runs later, since its ids come from a read that follows the
   * unlink; those ids are database-derived and always well-formed, so no caller input reaches an
   * append unvalidated.) The three appends
   * (user, revoked invites, new invite) are issued sequentially rather than through
   * SaveEventsToMultipleStreams, matching how PortalUserProvisioning composes the
   * same user-plus-invite pair. The chain is therefore deliberately retry-safe: an already-clear
   * link is a success, not a "no changes" failure, so re-running after a partial failure
   * completes the recovery.
   *
   *
   * Gated exactly like createUserInvite: RestockWriter excludes
   * portal principals and the in-code RequireTenantAdmin gate
   * requires a superadmin JWT or the caller's own Active Admin directory entry. The tenant comes
   * from the caller's JWT, so a reset can only ever target the caller's own tenant.
   */
  resetUserLogin: UserInvitePayload;
  resetWorkOrderQuantityProduced: JobPayload;
  /**
   * Clears the per-tenant RunNow trigger on a worker config after a triggered run.
   * Gated to the wsapi-services worker tier via the WorkerService policy so workers can only
   * clear the flag — setting it stays a SuperAdmin operation (setWorkerConfigRunNow).
   * When the flag is already clear the change detector returns the standard "no changes"
   * validation error and no event is written.
   */
  resetWorkerConfigRunNow: AdminWorkerConfigPayload;
  resetWsapiImportRunNow: WsapiImportPayload;
  /**
   * SUPERADMIN: resolves a pending trial request — Approve (new tenant, cold-trial length),
   * LinkToExisting (admin invite into an existing tenant + longer GP trial), or Reject. The
   * worker provisions only Approved/Linked outcomes. Matching only ever annotated the request;
   * Link is always this explicit human decision, never an auto-join.
   */
  resolveTrialRequest: TrialRequestPayload;
  resumeCountSession: CountSessionPayload;
  revalidateImport: AsyncImportJobPayload;
  /**
   * Reverts a report to an earlier version. This is forward-only: the target version's full
   * snapshot is read from the report's event stream and re-applied as a normal update, appending a
   * new version at the head (attributed to the caller) rather than truncating history. The read
   * model self-heals via the report projection. Reverting to the current head is a no-op (no event
   * is written) because the underlying update only fires when something changed.
   *
   *
   * **Returns:**
   * A payload containing the reverted report, or validation errors.
   */
  revertReport: ReportPayload;
  roundRestockSessionOrderQuantityToFullCart: RestockSessionPayload;
  /** Scraps inventory, removing it from stock. */
  scrapInventoryItem: InventoryItemPayload;
  /**
   * Seeds the legacy holiday reference set for the calling tenant, from the 2018 legacy floor through
   * the requested year (default 2035). Idempotent: only holidays the tenant does not already have are
   * created, so re-running preserves any admin edits and deletes. Returns how many holidays the range
   * produced, how many new rows were written, and how many were already present. Returns an error when
   * the FORECAST flag is disabled (nothing is written).
   */
  seedForecastHolidays: SeedForecastHolidaysPayload;
  /**
   * Sends the one-time invoice email from the calling user's own connected M365 mailbox ("From: me"
   * — same compose dialog as createInvoiceEmailDraft, real send instead of a draft), returning
   * whether it was sent and the sent message's Outlook draftWebLink. The
   * input subject/body arrive RAW (unrendered Handlebars) and are rendered
   * server-side over the order token context before sending — the dialog never sends pre-rendered
   * text. Recipients, subject, and body are all OPTIONAL: omitting recipients resolves every
   * email of every AccountsPayable-typed contact on the order's customer, falling back to the
   * order's own contact email when the customer has none; omitting subject/body seeds the
   * Invoice {{orderNumber}} defaults. The order must belong to the caller's resolved tenant (a foreign-tenant orderId is rejected
   * as not-found), and the mailbox token is fetched for the caller's own JWT identity; neither tenant
   * nor user id is ever accepted from input. A mailbox that has not granted send permission yields
   * SEND_PERMISSION_MISSING (the pwa walks the user through a one-time reconnect); a draft that
   * was created but could not be sent yields DRAFT_CREATED_SEND_FAILED with the draft link so the
   * user can finish it in Outlook. On Graph success (and ONLY then) the send is recorded in EmailSends
   * as PERSONAL_ACCOUNT — a draft never reaches this mutation's audit write.
   */
  sendInvoiceEmail: SendInvoiceEmailPayload;
  /**
   * Sets/replaces the calling tenant's accounting integration policy (provider, outbound detail
   * level, and the optional Merge.dev linked-account id) wholesale. Additive surface for §4.3a;
   * connection secrets are unaffected and remain on MergeTenantIntegration.
   */
  setAccountingIntegrationConfig: AccountingIntegrationConfigPayload;
  setActiveCountSession: ProductionLinePayload;
  /** Sets the global config and enabled state of a feature flag. */
  setAdminFeatureFlagGlobalValue: AdminFeatureFlagPayload;
  /** Sets tenant-specific overrides for a feature flag, replacing all existing overrides. */
  setAdminFeatureFlagTenantOverrides: AdminFeatureFlagPayload;
  setBackgroundServiceEnabled: AdminBackgroundServiceConfigPayload;
  /**
   * Replaces a user's full set of BPF starting-node grants (PUT). Tenant-scoped via the caller's
   * JWT; the target user is the userId on the input, matching the legacy importer that
   * rewrote a user's StartingNodes set wholesale. Pass an empty startingNodes list to clear
   * a user's entry points.
   */
  setBpfUserStartingNodes: BpfUserStartingNodePayload;
  /** Sets or updates the labor cost per unit for a production category. */
  setCategoryLaborCost: ProductionCategoryPayload;
  setCheckpoint: CheckpointPayload;
  /**
   * Sets the user's default commission rate (percent, 0–100), which applies to every
   * customer without an override.
   */
  setCommissionDefaultRate: CommissionConfigPayload;
  /**
   * Replaces the tenant's consolidation rule set wholesale (PUT semantics). All seven
   * rule fields are required on every call; resubmitting the identical rule set is a
   * no-op that surfaces EntityCommandHasNoChanges in the payload errors.
   */
  setConsolidationRuleSet: ConsolidationRuleSetPayload;
  setContactCrmLink: CustomerPayload;
  setCountSessionTarget: CountSessionPayload;
  /**
   * Sets a per-customer commission rate override (percent, 0–100) on the user's
   * configuration. Setting an override for a customer that already has one replaces it.
   */
  setCustomerCommissionOverride: CommissionConfigPayload;
  setCustomerCrmLink: CustomerPayload;
  /**
   * Sets or clears the customer's order-deposit requirement. Pass
   * depositRequirementType: NONE (or null) to clear the requirement so the customer's
   * orders are never deposit-blocked; pass PERCENTAGE (value 0–100) or FLAT_AMOUNT
   * (non-negative amount) to require a deposit of that size before an order can be allocated.
   */
  setCustomerDepositRequirement: CustomerPayload;
  setCustomerItemEffectiveDates: CustomerItemPayload;
  setCustomerItemRetailPrice: CustomerItemPayload;
  /**
   * Sets (creates or replaces) the typed note for a single
   * NoteContext (Ship/Pull/General) on one of a customer's
   * locations. One current value per context per location. The Ship-context note is the single
   * source of truth for the legacy flat settings.shippingNotes read. Exposed back on
   * getCustomerLocations' settings.contextNotes. Separate from the legacy append-only
   * location note list.
   */
  setCustomerLocationNote: CustomerPayload;
  /**
   * Sets or clears the servicing site of one of a customer's locations — "which site services this
   * ship-to". Pass servicingSiteLocationId: null (or an empty string) to clear the link.
   * A non-empty id is rejected unless it resolves to a SiteLocation on the caller's tenant.
   * Re-submitting the link already stored succeeds without emitting an event.
   */
  setCustomerLocationServicingSite: CustomerPayload;
  /**
   * Sets (creates or replaces) the customer-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value per
   * context; the customer's notes default into orders via live inheritance. Exposed back on
   * getCustomer's contextNotes field. Separate from the legacy append-only note
   * list.
   */
  setCustomerNote: CustomerPayload;
  /**
   * Sets or clears a customer's Customer Type with just (customerId, customerTypeId?) — the
   * narrow, event-sourced setter behind the bulk-assign flow. Pass a customerTypeId to
   * assign that type (validated to exist and be active, exactly as updateCustomer does);
   * pass null (or omit it) to CLEAR the assignment. Additive to — and independent of — the
   * full-customer updateCustomer edit path, which continues to carry customerTypeId as one
   * PATCH field among many. A route/customer scope guard mirrors updateCustomer's write side.
   */
  setCustomerType: CustomerPayload;
  /**
   * Dedicated set/clear mutation for the revenue GL mapping (Helm 33293b5e — the "unmap
   * path" fast-follow). A value replaces the mapping (Revenue-classification gate enforced
   * via CustomerTypeGlAccountGate); null/empty clears it, requiring no gate.
   * Leaves UpdateCustomerType)'s PATCH/preserve-on-omit semantics untouched.
   */
  setCustomerTypeRevenueGlAccount: CustomerTypePayload;
  setDefaultGroup: PriceGroupPayload;
  setDefaultTerms: TermsPayload;
  setDefaultVendor: MaterialItemPayload;
  /**
   * Flips a sender's admin-only restriction (Decision D). Admin-authorized: only an unrestricted
   * staff (admin) caller may change this. Defaults to false (anyone-can-send) when a sender is
   * first added; setting the same value twice is a successful no-op.
   */
  setEmailSenderAdminOnly: TenantEmailSenderPayload;
  /**
   * Sets or changes the manually-entered ready date on an existing live-goods inventory item,
   * scoped to the caller's tenant. The derived ISO ready week updates with it (it is never set
   * directly). Setting the same date is a no-op. Scope is the ready date only.
   */
  setInventoryItemReadyDate: InventoryItemPayload;
  setItemContainerConfigOverride: ItemPayload;
  /** Sets or updates the labor cost per unit for a production item. */
  setItemLaborCost: ProductionItemPayload;
  /**
   * Sets (creates or replaces) the item-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value per
   * context; the item's General note auto-populates an order line's note when the item is added
   * to an order. Exposed back on getItem's notes field.
   */
  setItemNote: ItemPayload;
  /**
   * Sets the complete set of production mapping lines for a sales item (replace semantics; an empty
   * list clears the item's mapping). Rejected when the mix percentages do not sum to exactly 100 per
   * (region, week) across the set, or when a line is malformed.
   */
  setItemProductionMappings: ItemProductionMappingPayload;
  setJobGrowWeeksOverride: ProductionLotPayload;
  setJobLinksOverride: ProductionLotPayload;
  setJobPlannedHoursOverride: ProductionLotPayload;
  setJobPlantsPerPotOverride: ProductionLotPayload;
  setLaborTypes: SiteLocationPayload;
  setLineItemOverridePrice: OrderPayload;
  /**
   * Sets the overhead rate for a location. Returns state from the aggregate.
   * Clients should use the locationOverheadRate query for read-after-write,
   * not the siteLocation query, which reads from a separate projection
   * that does not include overhead fields.
   */
  setLocationOverheadRate: SiteLocationPayload;
  /**
   * Sets the CALLING user's own language preference (EN or ES) for the Work Suite UI. Resolves the
   * caller's own directory entry from the JWT exactly like setMyProfileImage — there is no
   * admin-sets-others path. An invalid enum value never reaches this resolver (GraphQL rejects an
   * out-of-schema literal at request-validation time); re-setting the SAME preference writes no
   * event and reports "no changes" (framework no-op).
   */
  setMyLanguagePreference: UserPayload;
  /**
   * Sets (creates or replaces) the CALLING user's own profile picture. The image is validated
   * (jpeg/png/webp, <= 5 MB), staged to the shared public-read "user-avatars" Azure Blob container
   * under a tenant/user-scoped, content-addressed path ({tenantId}/{userId}/{contentHash}.{ext})
   * exactly as item photos are stored, then the returned RELATIVE path is persisted via the
   * SetUserProfileImage event — a configured public base URL composes the absolute URL at
   * resolve time. The image bytes never enter the event store. The target is always the caller's own
   * directory entry (resolved from the JWT); there is no admin-sets-others in v1. Invalid type/size is
   * rejected with a clear error before any blob write.
   */
  setMyProfileImage: UserPayload;
  /**
   * Sets (replaces) the tenant's routed contact type for one doc-type. Re-setting the value a
   * doc-type already has is a no-op that returns an EntityCommandHasNoChangesError with a null
   * payload. The Confirmation doc-type is rejected. Mirrors setTenantDefaultRoute.
   */
  setOrderEmailRecipientRouting: OrderEmailRecipientRoutingPayload;
  /**
   * Sets (replaces) the authorable recipients + subject + body for a tenant + doc-type. Subject
   * and body are Handlebars strings (tokens + inline {{#if}}) rendered at send time;
   * null/empty subject or body means "not authored" and the send worker falls back to today's
   * behavior (hardcoded subject / per-tenant SendGrid template body). The confirmation subject
   * branches invoice-vs-credit on orderType within one config, e.g.
   * {{#if (eq orderType "Credit")}}Bonnie Plants Credit Memo No. {{orderNumber}}{{else}}Bonnie
   * Plants Document No. {{orderNumber}}{{/if}}.
   */
  setOrderEmailSettings: OrderEmailSettingsPayload;
  /**
   * Sets (creates or replaces) the order-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value
   * per context; the resulting raw notes are exposed on the order's orderNotes field.
   */
  setOrderNote: OrderPayload;
  /**
   * Sets or changes an order's structured ship-from site post-create. shipFromSiteLocationId is
   * the WorkSuite-native SiteLocationId the FULFILL container / ContainerConfig /
   * config-category surfaces key on (NOT the ERP station code); the site must exist (by native id) and
   * be active for the tenant. Additive companion to the legacy name-only ship-from location.
   */
  setOrderShipFromSite: OrderPayload;
  /**
   * Sets or clears the tenant's Orderful API key secret-name reference (a @keyvault(...)
   * reference string into ws-tenant-secrets; clear by omitting the value). Stores the
   * reference only — wsapi never resolves, mints, or deletes the underlying secret.
   */
  setOrderfulApiKeySecretName: OrderfulIntegrationConfigPayload;
  /** Sets or clears the tenant to Orderful Organization mapping (clear by omitting the name). */
  setOrderfulIntegrationMapping: OrderfulIntegrationConfigPayload;
  /** Sets the tenant's Orderful integration status (Active / Inactive / Deleted). */
  setOrderfulIntegrationStatus: OrderfulIntegrationConfigPayload;
  /**
   * Sets or clears the tenant's own Orderful Organization ISA id(s) (clear by passing an empty list).
   * These identify the tenant so transaction direction (inbound/outbound) can be derived by matching
   * against sender/receiver ISA. Entries are trimmed, blanks dropped, and deduped case-insensitively.
   */
  setOrderfulOrganizationIsaIds: OrderfulIntegrationConfigPayload;
  setPodAssignmentReplicas: AdminBackgroundServiceConfigPayload;
  /**
   * Sets — or clears — a price group's whole-group percentage derivation ("this group = group X
   * minus N%"). Supply both derivedFromPriceGroupId and derivedPercentOff to derive;
   * supply neither to clear. Deliberately a mutation of its own rather than fields on
   * updatePriceGroup: that whole-record write carries only id+name, so folding the derivation
   * into it would let any existing caller silently clear a configured one.
   * derivedPercentOff is a percent VALUE (4 = 4%), matching the price LEVEL surface.
   * Managed (QB-sync-owned) groups are read-only here for the same reason their name and levels are.
   */
  setPriceGroupDerivation: PriceGroupPayload;
  /**
   * Sets — or clears — a price group's ORDER VOLUME discount rule: "an order of ≥N units (or ≥$X)
   * gets P% (or $Y) off". Supply all four fields to configure it; supply none to clear it.
   * value is a percent VALUE (10 = 10%) for a percentage rule and dollars for a flat one,
   * matching the rest of the pricing surface — never a 0–1 fraction.
   *
   * Its own mutation rather than fields on updatePriceGroup, and its own section rather than
   * a row in the price-level grid: the rule targets no item and no category, and it produces a
   * DISCOUNT rather than a charge. It is not GrowPoint's whole-order price-level jump — no line
   * price moves.
   *
   *
   * Staff-only. Bare [Authorize] puts this on the same internal surface as every
   * other price-group mutation, which the customer portal's schema does not expose — a portal user
   * configuring the volume discount their own orders receive is the failure mode this excludes.
   * Managed (QB-sync-owned) groups are read-only here for the same reason their name and levels
   * are.
   *
   *
   * A PERCENTAGE rule is validated against the tenant's MaxDiscountPercentage here, where
   * the person typing it can be told. A FLAT rule has no order to measure a percentage against at
   * this point ("$500 off" is legal on a $5,000 order), so it is bounded at order-evaluation time
   * instead — by the tenant cap as well as by the discountable base. Every rule is capped; only
   * the moment of enforcement differs.
   */
  setPriceGroupOrderVolumeDiscount: PriceGroupPayload;
  setProductionLotAsyncImportJobRowIds: AsyncImportJobPayload;
  setProductionRecipeTaskEventIds: ProductionRecipePayload;
  setPropagationYield: ProductionLotPayload;
  setPurchaseOrderUrgent: VendorPurchaseOrderPayload;
  setRecipeLaborSource: ProductionRecipePayload;
  /**
   * Sets the authorable email subject/body (Handlebars, tokens + inline {{#if}}) on an
   * existing schedule. Null/empty clears a field back to the "not authored" fallback, which the
   * downstream send worker resolves to the report name (subject) / per-tenant template (body).
   */
  setReportScheduleEmailSettings: ReportSchedulePayload;
  /**
   * PWA AG-grid manual-edit path. Each cell change posts the new OrderQuantity for
   * one or more (ItemId, CustomerLocationId) rows. The event payload carries every
   * absolute the projections write (post-event OverrideCount and full per-item
   * allocation snapshot), so projections perform pure $set/upsert writes — see
   * atlas standard accaf08f270b40efa04fbbcdd605fc1c.
   */
  setRestockSessionOrderQuantities: RestockSessionPayload;
  /**
   * Replaces the site's entire contact list (role, name, email, phone). An empty list clears
   * every contact. Email is required per contact; name and phone are optional.
   */
  setSiteContacts: SiteLocationPayload;
  setSiteLaborRate: SiteLocationPayload;
  setSiteLocationAsyncImportJobRowIds: AsyncImportJobPayload;
  /**
   * Sets the IANA time-zone id on a SiteLocation. Required before rate mutations
   * (setLocationOverheadRate, setSiteLaborRate) are accepted.
   */
  setSiteTimeZone: SiteLocationPayload;
  /**
   * Creates or updates a space-capacity window on a site's leaf sub-location for a space type, over an
   * ISO-week range (wrap-aware) and an optional year (null = recurring/seasonal). Rejects a window that
   * overlaps another in the same (sub-location, space type, year-scope) bucket, an inactive space type,
   * or a non-leaf sub-location.
   */
  setSpaceCapacityWindow: SiteLocationPayload;
  /** @deprecated Use setSpaceDimensionOverride, which supports customer-scoped overrides. */
  setSpaceCategorySiteOverride: ProductionSpaceCategoryPayload;
  setSpaceDimensionOverride: ProductionSpaceCategoryPayload;
  setStoreClasses: StoreClassPayload;
  setTaskEventDirectCost: ProductionTaskEventPayload;
  setTaskEventLaborTypeTag: ProductionTaskEventPayload;
  setTaskEventThroughput: ProductionTaskEventPayload;
  /**
   * Selects a tenant's active billing cadence (superadmin). The cadence must be one the rate card
   * offers (or None to clear it); otherwise the mutation is rejected with no event written.
   */
  setTenantBillingFrequency: AdminTenantPayload;
  /**
   * Sets a tenant's per-cadence platform-billing rate card (superadmin). Amounts are in minor units;
   * a null cadence is not offered. Audited on the tenant stream. Resubmitting the same prices is a no-op.
   */
  setTenantBillingRateCard: AdminTenantPayload;
  /**
   * Sets or clears the tenant's default carrier — tier 0 of the hierarchical carrier setting
   * (tenant default → customer → ship-to → order). Carrier is a free-text scalar; an empty/blank
   * value clears the default. Mirrors SetTenantDefaultRoute.
   */
  setTenantDefaultCarrier: TenantCarrierConfigPayload;
  /** Marks an existing sender as the tenant default (clearing any previous default). */
  setTenantDefaultEmailSender: TenantEmailSenderPayload;
  /**
   * Sets or clears the tenant's default route — tier 0 of the hierarchical route setting
   * (tenant default → customer → ship-to → order). Route is a free-text scalar; an empty/blank
   * value clears the default. Mirrors SetTenantTaxDefaultAuthorities.
   */
  setTenantDefaultRoute: TenantRouteConfigPayload;
  /**
   * Sets (creates or replaces) the tenant's SMTP connection. The password is encrypted at rest before
   * the event is written; the config change resets verification to unverified.
   */
  setTenantSmtpConnection: TenantSmtpConnectionPayload;
  /**
   * Replaces the tenant's full default tax-authority list. Per Decisions #1 + #2 the
   * list is order-sensitive — the first entry is the primary fallback. Gated by the
   * TaxCalculationEnabled feature flag.
   */
  setTenantTaxDefaultAuthorities: TenantTaxConfigPayload;
  setVendorMaterialCost: MaterialItemPayload;
  setWorkOrderLineNumber: JobPayload;
  setWorkerConfigRunNow: AdminWorkerConfigPayload;
  setWsapiImportRunNow: WsapiImportPayload;
  /**
   * Ship an existing MovementOrder. Transitions Created → Shipped. Identical
   * retries are deterministic no-ops thanks to IfChangedPer in the aggregate.
   */
  shipMovementOrder: MovementOrderPayload;
  shipPurchaseOrder: VendorPurchaseOrderPayload;
  /** Skip a task. Idempotent: identical reason replayed is a no-op. */
  skipAssignmentTask: CycleCountAssignmentPayload;
  splitProductionLot: SplitProductionLotPayload;
  /**
   * Records the wsapi-services worker's FusionAuth login-redirect sync outcome for a custom portal
   * domain — the only writer that records a REAL worker-observed outcome for
   * loginRedirectRegistered / loginSyncFailureReason. Both fields are also assigned by
   * the PortalCustomDomainVerified and PortalCustomDomainRemoved folds on their own transitions,
   * from values hardcoded false/null in this release.
   * Gated to the worker's service-account JWT (WorkerService policy); never reachable by a staff or
   * customer JWT.
   */
  stampPortalCustomDomainLoginRedirectSync: PortalSettingsPayload;
  /** Start a task. Idempotent: an identical retry is a deterministic no-op. */
  startAssignmentTask: CycleCountAssignmentPayload;
  startAvailabilitySession: AvailabilitySessionPayload;
  startCountSession: CountSessionPayload;
  /**
   * Start a floating timer for a worker without selecting a task.
   * Enforces the global one-timer-per-worker rule across both FloatingTimeEntry and TaskAssignment aggregates.
   */
  startFloatingTimer: FloatingTimeEntryPayload;
  /**
   * Begins a server-driven Restock session creation workflow. Emits SessionCreationStarted
   * immediately; the BackgroundWorkflows.RestockSessionCreation.RestockSessionCreationWorkflowWorker
   * then chunks by location, runs populate→calculate→persist per chunk, and emits progress/completion
   * events that subscribers observe via onRestockSessionBatchProgress.
   */
  startRestockSessionCreation: RestockSessionPayload;
  /** Start working on a task assignment. Transitions from Open to InProgress. */
  startTask: TaskAssignmentPayload;
  /**
   * Start a timer on a task assignment.
   * Enforces the global one-timer-per-worker rule: checks for running floating timers
   * and other running task assignment timers before allowing start.
   */
  startTaskAssignmentTimer: TaskAssignmentPayload;
  /**
   * ANONYMOUS: submits a trial signup. Guarded by the reusable per-IP + per-email rate limit,
   * disposable-email blocklist, optional email verification (RequireVerification, default
   * off — the human approval gate is the control), and the daily new-tenant cap. Records a
   * TrialRequest in PendingApproval — NOTHING ever auto-creates a tenant — annotated with
   * existing-tenant match candidates for the human approver. Idempotent on email+company: a
   * duplicate submit returns the existing request. When RequireApproval is off AND there
   * were NO match candidates, the request is auto-approved (still via a recorded Approved event
   * the worker consumes). The response is deliberately uniform for every accepted signup.
   */
  startTrial: StartTrialPayload;
  /** Stop a running floating timer. Transitions the entry to Unlinked status. */
  stopFloatingTimer: FloatingTimeEntryPayload;
  /** Stop a running timer on a task assignment. */
  stopTaskAssignmentTimer: TaskAssignmentPayload;
  submitErpLoadListSession: ErpLoadListSessionPayload;
  submitFullOrder: OrderPayload;
  /**
   * The supervisor's per-order verification commit (the heart of the Verify manager flow). Gated to
   * VerifyManager regardless of the tenant's staged/direct mode. In one atomic
   * commit it emits V1.OrderVerified (setting each line's ShippedQuantity), transitions the
   * order picked → shipped through the existing inventory-release path (decrement + deallocate), and
   * then marks every consumed container Verified via the existing VerifyVerifyContainer
   * aggregate function — the container projection flips the document to Verified and publishes the
   * Verified status to the dashboard subscription. SubmittedBy is the authenticated submitter
   * (in direct mode, the worker — recorded as the verifier). Substitutions are accepted as empty
   * arrays in v1.
   */
  submitOrderVerification: OrderPayload;
  submitRestockSession: RestockSessionPayload;
  submitVerifyContainer: VerifyContainerPayload;
  synchronizeErpItemPrices: ErpItemPricingPayload;
  synchronizeRestockSession: RestockSessionPayload;
  synchronizeSalesPeople: Array<CustomerPayload>;
  /** Toggles an upgrade's IsDefault flag, enforcing the exclusive-category single-default invariant. */
  toggleItemUpgradeDefault: ItemPayload;
  toggleSftpDestination: SftpTenantConfigPayload;
  toggleSftpMongoDestination: SftpTenantConfigPayload;
  unassignMaterialItemToVendor: MaterialItemPayload;
  undoRestockSessionOrderQuantityOverride: RestockSessionPayload;
  /** Removes the user's FusionAuth login link. The directory entry remains. */
  unlinkFusionAuthUser: UserPayload;
  /** Unlinks one or more production items from their sales items. */
  unlinkProductionItemsFromSalesItem: LinkProductionItemsToSalesItemPayload;
  /**
   * Removes a tax authority's link to an imported QuickBooks tax rate, clearing the FK.
   * A no-op (via IfChangedPer) when the authority is not currently mapped.
   */
  unmapTaxAuthorityFromMergeDevTaxRate: TaxAuthorityPayload;
  unsetDefaultGroup: PriceGroupPayload;
  unsetDefaultTerms: TermsPayload;
  unsetDefaultVendor: MaterialItemPayload;
  updateAcknowledgedQuantity: OrderPayload;
  updateAcknowledgmentEmail: OrderPayload;
  /**
   * Cross-tenant admin mutation to flip a tenant's OrganicReceiveMode. Used by
   * the wsapi admin console once a tenant's organic-lot populate-rate meets the
   * rollout threshold (e.g. Bonnie flips to Block after 60%).
   */
  updateAdminTenantOrganicReceiveMode: AdminTenantPayload;
  /**
   * Cross-tenant admin mutation to set the per-tenant Restock IRosProvider selection
   * (key + opaque per-provider JSON). Snapshotted into LockedRestockConfig at each
   * future session creation; in-flight sessions are not affected. Validates the provider key
   * against the keyed-DI registration before dispatching the command.
   */
  updateAdminTenantRestockProviderSettings: AdminTenantPayload;
  updateAllocationTemplate: AllocationTemplatePayload;
  updateAndGetNextOrderNumber: NextOrderNumberPayload;
  updateAsyncImportJobStatus: AsyncImportJobPayload;
  updateAvailabilitySessionCount: AvailabilitySessionPayload;
  updateBillingAddress: CustomerPayload;
  updateBlockingRule: BlockingRulePayload;
  updateCategory: CategoryPayload;
  updateConfigCategory: ConfigCategoryPayload;
  updateConfirmationEmail: OrderPayload;
  updateContact: CustomerPayload;
  updateContainerConfigDetails: ContainerConfigPayload;
  updateCustomer: CustomerPayload;
  updateCustomerItem: CustomerItemPayload;
  updateCustomerItemAdditionalSkus: CustomerItemPayload;
  updateCustomerItemAdditionalUpcs: CustomerItemPayload;
  updateCustomerLocationOrderAddressEditPermissions: CustomerPayload;
  /**
   * Sets or clears a specific customer location's send-order-emails override.
   * Pass sendOrderEmails: null to clear the override (inherit from customer).
   */
  updateCustomerLocationSendOrderEmails: CustomerPayload;
  updateCustomerOrderAddressEditPermissions: CustomerPayload;
  /**
   * Toggles the customer-level master flag controlling order confirmation emails.
   * The cascade order ?? location ?? customer at read time decides whether
   * emails actually send for any given order.
   */
  updateCustomerSendOrderEmails: CustomerPayload;
  updateCustomerType: CustomerTypePayload;
  /**
   * Updates the tenant-level default freight charge configuration.
   * Used as the third-tier fallback when no customer or location freight is configured.
   */
  updateDefaultFreightCharge: TenantPayload;
  updateDefaultOrderSubmitter: CustomerPayload;
  /**
   * Updates the per-tenant default weeks-of-supply applied by the Restock dashboard's
   * restockDailyDemand query when no explicit override is supplied. Must be
   * between 0.01 and 100 inclusive.
   */
  updateDefaultWeeksOfSupply: TenantPayload;
  updateDeliveryScheduleLocations: DeliverySchedulePayload;
  /**
   * Sets the render mode for one order document type (invoice/confirmation, acknowledgement,
   * credit) for the current tenant. Legacy keeps the QuestPDF generator, ReportEngine
   * renders via the report engine + tenant binding, and Parallel renders both for artifact
   * comparison (only one is sent). Any unset (tenant, docType) pair defaults to Legacy, so
   * enabling this never silently changes current behavior. Authorized identically to the
   * report-binding mutations (current-tenant scoped).
   */
  updateDocumentRenderMode: TenantPayload;
  updateErpId: OrderPayload;
  updateErpLoadListQuantities: ErpLoadListSessionPayload;
  updateErpLoadListSessionItemAvailability: ErpLoadListSessionPayload;
  updateErpLoadListSessionName: ErpLoadListSessionPayload;
  updateErpLoadListSessionRoutes: ErpLoadListSessionPayload;
  updateErpLoadListSessionShipDate: ErpLoadListSessionPayload;
  updateErpManagerEmails: ErpManagerEmailsPayload;
  updateFinalCreditEnabled: TenantPayload;
  /**
   * Updates a forecast's header (name, description, programs, Monday-snapped window, weekly metric,
   * scenario slot). LockedConfig, customer, and level are fixed at creation. Rejected if the
   * forecast is soft-deleted or the new name collides with another active forecast.
   */
  updateForecast: ForecastPayload;
  updateImportRowImportResults: AsyncImportJobPayload;
  updateImportRowValidationResults: AsyncImportJobPayload;
  updateItem: ItemPayload;
  updateItemAttributes: ItemPayload;
  updateItemImageUrl: ItemPayload;
  updateItemRetailPrice: ItemPayload;
  /** Replaces an existing upgrade definition in full (PUT); IsDefault and Status are preserved. */
  updateItemUpgrade: ItemPayload;
  /**
   * Full-replace update of a kit, including its complete line list. A kit's site is fixed at
   * creation and cannot be changed by an update.
   */
  updateKit: KitPayload;
  updateLineItem: OrderPayload;
  updateLineItemNote: OrderPayload;
  /**
   * Bulk-sets ContainerCode on existing order lines. Handles both the single-line edit
   * and the PWA "Apply to all lines" case (the input simply carries one or many items). The
   * command is idempotent — re-applying the same code on every targeted line is a safe no-op.
   */
  updateLineItemsContainerCode: OrderPayload;
  updateLocation: CustomerPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  updateLocationAddress: LocationPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  updateLocationName: LocationPayload;
  updateMasterAcknowledgedQuantity: MasterOrderPayload;
  updateMasterConfirmationEmail: MasterOrderPayload;
  updateMasterLineItem: MasterOrderPayload;
  updateMasterOrderContact: MasterOrderPayload;
  updateMasterOrderStatus: MasterOrderPayload;
  updateMasterSalesPerson: MasterOrderPayload;
  updateMaterialItemDetails: MaterialItemPayload;
  /**
   * Updates the maximum discount percentage for a tenant.
   * Percent is expressed as a decimal value between 0 and 1.
   */
  updateMaxDiscountPercentage: TenantPayload;
  updateMissingItemGroups: OrderPayload;
  updateMissingMasterItemGroups: MasterOrderPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page acknowledgement PDF for the
   * current tenant. Pass null or empty to clear the binding.
   * BPF retains the hardcoded Bonnie acknowledgement and ignores this setting.
   */
  updateOrderAcknowledgementReport: TenantPayload;
  updateOrderAddressEditPermissions: TenantPayload;
  updateOrderBillingAddress: OrderPayload;
  updateOrderContact: OrderPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page invoice PDF for the current tenant.
   * Pass null or empty to clear the binding (hides the View Invoice action).
   * BPF retains the hardcoded Bonnie PDF and ignores this setting.
   */
  updateOrderInvoiceReport: TenantPayload;
  updateOrderLocationAddress: OrderPayload;
  /**
   * Sets or clears an order's route override — tier 1 of the hierarchical route setting
   * (tenant default → customer → ship-to → order, most-specific-wins). Route is a free-text
   * scalar (not a managed aggregate), so there is no existence gate. An empty/blank value clears
   * the override so the effective route inherits down the chain. Mirrors UpdateTermsId).
   */
  updateOrderRoute: OrderPayload;
  /**
   * Sets or clears the per-order send-order-emails override.
   * Pass sendOrderEmails: null to clear the override (inherit from
   * location/customer). Useful for historical-import flows that should not
   * trigger confirmation emails.
   */
  updateOrderSendOrderEmails: OrderPayload;
  updateOrderStatus: OrderPayload;
  updateOrderSyncAttempt: OrderPayload;
  /**
   * Sets the per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Warn surfaces a warning (allow submit). Block rejects the receive with a
   * ValidationError.
   */
  updateOrganicReceiveMode: TenantPayload;
  /**
   * Updates the tenant-configured maximum length for sales-order and master-order PO numbers
   * (initializeOrder, submitFullOrder, and master-order create/edit). Must be between
   * 1 and 64 inclusive — it can only tighten below the absolute PO-number ceiling of 64 (purchase
   * orders and production lots always validate against that ceiling and are unaffected). Default 64
   * preserves today's behavior for every tenant that has not configured this.
   */
  updatePoNumberMaxLength: TenantPayload;
  /**
   * Upserts the calling tenant's portal settings (full-replace). Staff-only: a
   * customer-type portal JWT is rejected with a PORTAL_SETTINGS_STAFF_ONLY error
   * and no event is written. Tenant-scoped — settings are written to the caller's own
   * tenant stream, so one tenant cannot write another's settings. Same-value
   * re-submissions are a no-op (no phantom event).
   *
   * The company slug rides on this save: an explicit companySlug is format-validated and
   * rejected if already claimed by another tenant (CompanySlugTaken); an omitted slug reuses
   * the tenant's existing one, or — on the first save with none — is assigned a collision-safe
   * random 8-char default. The current slug is read from the KurrentDB stream (no projection lag),
   * so the reuse decision is authoritative even if the slug projection is still catching up.
   */
  updatePortalSettings: PortalSettingsPayload;
  updatePriceGroup: PriceGroupPayload;
  updatePriceLevels: PriceGroupPayload;
  updateProduceEnabled: TenantPayload;
  /** Updates an existing production catalog entry. */
  updateProductionCatalog: ProductionCatalogPayload;
  updateProductionCategoryDetails: ProductionCategoryPayload;
  updateProductionItem: ProductionItemPayload;
  updateProductionJobLocation: UpdateProductionJobLocationPayload;
  updateProductionLine: ProductionLinePayload;
  updateProductionLotAsyncImportJobRows: AsyncImportJobPayload;
  updateProductionLotCustomer: UpdateProductionLotCustomerPayload;
  updateProductionLotPlan: UpdateProductionLotPlanPayload;
  updateProductionMaterialEvent: ProductionMaterialEventPayload;
  updateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  updateProductionPlanDetails: ProductionPlanPayload;
  updateProductionRecipeVariation: ProductionRecipePayload;
  updateProductionSpaceCategoryDetails: ProductionSpaceCategoryPayload;
  updateProductionSpaceEvent: ProductionSpaceEventPayload;
  updateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  updateProductionSpaceTypeDetails: ProductionSpaceTypePayload;
  updateProductionTaskEvent: ProductionTaskEventPayload;
  /** Updates the default assignee for a task event already attached to a production item. */
  updateProductionTaskEventAssignee: ProductionItemPayload;
  /**
   * PUT semantics: this mutation fully replaces the targeted detail's mutable
   * fields with the supplied payload. All scalars on
   * ProductionTaskEventCommands.UpdateProductionTaskEventDetailData
   * are required; callers must supply the current values for any field they wish
   * to leave unchanged (no PATCH/merge semantics).
   */
  updateProductionTaskEventDetail: ProductionTaskEventPayload;
  updateProductionTrigger: ProductionTriggerPayload;
  updatePromotionRule: PromotionRulePayload;
  updatePublicScore: UpdatePublicScoreResult;
  updateReport: ReportPayload;
  /** Updates an existing report schedule. */
  updateReportSchedule: ReportSchedulePayload;
  /** Updates an existing report template. */
  updateReportTemplate: ReportTemplatePayload;
  updateReserveRule: ReserveRulePayload;
  updateRestockSession: RestockSessionPayload;
  updateRestockSessionOrderQuantities: RestockSessionPayload;
  updateRestockSessionReserveRules: RestockSessionPayload;
  updateSalesPerson: OrderPayload;
  updateSftpAggregationConfig: SftpTenantConfigPayload;
  updateSftpDestination: SftpTenantConfigPayload;
  updateSftpMongoColumnMaps: SftpTenantConfigPayload;
  updateSftpMongoDestination: SftpTenantConfigPayload;
  updateSftpSqlColumnMaps: SftpTenantConfigPayload;
  updateSftpSystemSettings: SftpSystemSettingsPayload;
  updateSftpTenantConfig: SftpTenantConfigPayload;
  updateShippedQuantity: OrderPayload;
  updateSiteLocationAsyncImportJobRows: AsyncImportJobPayload;
  /**
   * Updates a site map's target site and exclude-from-distribution flag. The mapped location and
   * program are fixed at creation. Rejected if the mapping is soft-deleted.
   */
  updateSiteMap: SiteMapPayload;
  updateSizeUom: SizeUomPayload;
  /**
   * Changes the cadence/amount of a tenant's existing Stripe subscription by swapping its item to the
   * rate-card price for the new cadence (superadmin), re-checking the online-payment ceiling first.
   * The new active cadence is persisted to the tenant so its rate reflects the change immediately.
   */
  updateSubscription: AdminTenantPayload;
  updateTaskEventType: TaskEventTypePayload;
  updateTaxAuthority: TaxAuthorityPayload;
  /**
   * Updates the tenant-level "tax on royalty" setting. When enabled, the order tax engine folds
   * each line's royalty into the taxable base; default OFF, since most tenants do NOT tax royalty.
   */
  updateTaxRoyalty: TenantPayload;
  /**
   * Replaces the calling tenant's portal branding (PUT): the four text fields plus an optional logo
   * image; an omitted, null, or empty image clears it. On success, tenant.portalBranding
   * reflects the new values; None is only returned for tenants that have never called this
   * mutation — clients should fall back to platform defaults.
   */
  updateTenantBranding: TenantPayload;
  /**
   * Replaces the calling tenant's custom grade labels (PUT semantics). Each entry's grade must be
   * 1–5; labels are trimmed and capped at 50 characters. An entry with an empty label clears that
   * grade's label, and grades omitted from the input are left unset. On success,
   * tenant.gradeLabels reflects the configured set; unset grades are absent (clients fall
   * back to the numeric grade). This is display only — grade values stay int 1–5.
   */
  updateTenantGradeLabels: TenantPayload;
  /**
   * Sets the tenant-level opt-in master switch for order/confirmation/acknowledgement emails —
   * the settings-driven replacement for the wsapi-services Background Service Config
   * tenant-allowlist. Pass null to clear the setting back to "never configured"; pass
   * true/false to explicitly opt in/out. Read effectiveOrderEmailsEnabled
   * for the resolved value (unset defaults to false). Transitioning into enabled stamps
   * orderEmailsEnabledAt to now, unless the optional enabledAt input is supplied
   * (used by the current-sender backfill to stamp a past sentinel).
   */
  updateTenantOrderEmailsEnabled: TenantPayload;
  /**
   * Updates the per-tenant unit configuration for the restock / replenishment pipeline.
   * All six ingest + display unit fields are replaced atomically.
   */
  updateTenantUnitConfig: TenantPayload;
  updateTerms: TermsPayload;
  updateTermsId: OrderPayload;
  updateUseErpPricing: TenantPayload;
  updateUserAppSetting: UserAppSettingPayload;
  /** Updates the user's display name. */
  updateUserFullName: UserPayload;
  /**
   * Replaces the user's business roles with the given set. An empty set is allowed
   * and removes all roles.
   */
  updateUserRoles: UserPayload;
  updateVendor: VendorPayload;
  updateVendorPurchaseOrderSiteLocation: VendorPurchaseOrderPayload;
  /**
   * Sets the tenant-level Verify routing preference. Staged (default) routes submitted
   * containers to the supervisor review queue. Direct is owner-operator mode where the
   * worker's "Finished" also fires submitOrderVerification. Presentation routing for
   * worksuite-pwa only — the API enforces roles regardless of mode.
   */
  updateVerifyMode: TenantPayload;
  updateWsapiImportEntityMapping: WsapiImportPayload;
  updateWsapiImportSchedule: WsapiImportPayload;
  /**
   * Uploads a primary portal photo for the item: validates the payload (jpeg/png/webp, <= 5MB),
   * stores the bytes in the single shared public-read "item-images" Azure Blob container under a
   * tenant/item-scoped, content-addressed path ({tenantId}/{itemId}/{contentHash}.{ext}), then
   * applies the returned RELATIVE path via the existing updateItemImageUrl flow — a configured
   * public base URL composes the absolute URL at resolve time. The image bytes never enter the event
   * store — only the resulting path is persisted and projected to the read model.
   */
  uploadItemImage: ItemPayload;
  upsertAdminTenantIntegration: AdminTenantPayload;
  upsertAdminTenantPricingPage: TenantPricingPagePayload;
  /**
   * Creates or updates the Merge.dev CRM integration configuration for the current tenant (Salesforce
   * / HubSpot). Coexists with an accounting Merge integration under a distinct IntegrationId and, like
   * the accounting connect, seeds an enabled RunNow WsapiImport with the default CRM flows so the
   * MergeDevCrmImport worker selects the tenant on its next tick.
   */
  upsertMergeCrmTenantIntegration: TenantPayload;
  /** Creates or updates the Merge.dev integration configuration for the current tenant. */
  upsertMergeTenantIntegration: TenantPayload;
  upsertMySqlAdminTenantIntegration: AdminTenantPayload;
  upsertMySqlTenantIntegration: TenantPayload;
  /** Create or update RFID scan records (one per serial/location/date) */
  upsertRfidScans: UpsertRfidScansPayload;
  upsertTenantPricingPage: TenantPricingPagePayload;
  /** Create or update time entries (one per user/task/date) */
  upsertTimeEntries: TimeEntryPayload;
  /**
   * Creates or replaces the policy for one trial kind. PUT semantics — the allow-list and every
   * cap are replaced together, so clearing one entry means resending the full policy without it.
   * Re-sending an unchanged policy writes no event.
   */
  upsertTrialPolicy: AdminTrialPolicyPayload;
  /**
   * Strong-DTO entry point wsapi-services posts against. Validates a batch of
   * CategoryCommands.MergeCategory commands; successes are projected
   * synchronously to the production CategoryDocument shape and
   * written to Category.Staged.Summary in the GrowPointIntegrations
   * Mongo db. The pwa staged-review page queries this collection using the same
   * fragments as the production categories/category queries.
   * Failures partition into ValidateCategoryDocumentsResult.RowErrors
   * keyed by source row index — the batch is never aborted by a row-level failure.
   */
  validateCategoryDocuments: ValidateCategoryDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint customers import: wsapi-services posts a
   * batch of already-shaped CustomerCommands.ImportCustomer (parent +
   * nested locations together). Each is validated via
   * CustomerCommands.ValidImportCustomer.Create; successes are
   * projected synchronously to the production document shapes — one
   * CustomersSummaryDocument and one CustomerLocationDocument
   * per ship-to — and written to the staged collections in the
   * GrowPointIntegrations Mongo db (Customers.Staged.Summary +
   * Customers.Staged.Locations). The pwa staged-review pages query these
   * collections using the same fragments as the production
   * customers/customer/customerLocations queries. Failures
   * partition into ValidateCustomerDocumentsResult.RowErrors keyed
   * by source row index — the batch is never aborted by a row-level failure.
   */
  validateCustomerDocuments: ValidateCustomerDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint historical-orders import: wsapi-services posts a
   * batch of already-shaped ImportHistoricalOrder commands. Each is validated via
   * Clock); successes are projected synchronously to the
   * HistoricalOrderStagedSummaryDocument shape written to
   * HistoricalOrders.Staged.Summary plus one HistoricalOrderStagedLineItemDocument
   * per line written to HistoricalOrders.Staged.Lines in the GrowPointIntegrations
   * Mongo db, where the pwa staged-review grid reads them via the stagedHistoricalOrders /
   * stagedHistoricalOrderLineItems queries. Failures partition into
   * RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure. Mirrors validateItemsDocuments;
   * no event-store writes occur.
   */
  validateHistoricalOrderDocuments: ValidateHistoricalOrderDocumentsResult;
  validateHistoricalOrders: ValidateHistoricalOrdersResult;
  /**
   * Strong-DTO entry point for the GrowPoint inventory import: wsapi-services posts a
   * batch of already-shaped InventoryCommands.SetInventoryItem rows. Each is
   * validated via InventoryCommands.ValidSetInventoryItem.Create — the exact
   * rule graph the production adjustInventoryItem mutation runs; successes are
   * projected synchronously to the production document shape
   * (InventoryItemDocument) plus the 1:1 import-command echo
   * (InventoryItemImportCommandDocument), then written to the staged
   * collections in the GrowPointIntegrations Mongo db
   * (Inventory.Staged.Summary + Inventory.Staged.ImportCommand).
   * ZERO event-store writes — promotion is the existing
   * createInventoryItem/adjustInventoryItem mutations. Failures
   * partition into ValidateInventoryItemDocumentsResult.RowErrors keyed by
   * source row index — the batch is never aborted by a row-level failure.
   */
  validateInventoryItemDocuments: ValidateInventoryItemDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint items import: wsapi-services posts a
   * batch of already-shaped ItemCommands.ImportItem. Each is validated
   * via ItemCommands.ValidImportItem.Create; successes are projected
   * synchronously to the production document shape — one
   * WorkSuite.GraphQl.Features.Products.ItemSummaryDocument — and to the
   * 1:1 import-command echo (WorkSuite.GraphQl.Features.Products.ItemImportCommandDocument),
   * then written to the staged collections in the GrowPointIntegrations Mongo
   * db (Items.Staged.Summary + Items.Staged.ImportCommand). The pwa
   * staged-review pages query these collections using the same fragments as the
   * production items/item queries. Failures partition into
   * ValidateItemsDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure.
   */
  validateItemsDocuments: ValidateItemsDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint prices import: wsapi-services posts a
   * batch of already-shaped PriceGroupCommands.ImportPriceGroup (group +
   * full level list together). Each is validated via
   * PriceGroupCommands.ValidImportPriceGroup.Create — the exact
   * ValidAddPriceGroup + ValidUpdatePriceLevels rule graph the
   * production addPriceGroup/updatePriceLevels promote path runs;
   * successes are projected synchronously to the production document shapes — one
   * PriceGroupDocument and one PriceLevelDocument per level — plus the
   * 1:1 import-command echo (PriceGroupImportCommandDocument), then written to
   * the staged collections in the GrowPointIntegrations Mongo db
   * (PriceGroups.Staged.Summary + PriceGroups.Staged.Levels +
   * PriceGroups.Staged.ImportCommand). ZERO event-store writes — promotion is
   * the existing addPriceGroup + updatePriceLevels (+
   * setDefaultGroup) mutations. Failures partition into
   * ValidatePriceGroupDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure.
   *
   * Helm 019582ab: before validating, batch-loads every PREVIOUSLY-staged level for the group
   * ids in this batch (PriceGroupMutationsExtensions.LoadStagedPriceLevelsForGroupsAsync)
   * so a re-validate of an already-staged group — the PWA's "Validate Data" resubmit — resolves
   * an omitted trap field (levelType/kind/percentOff/
   * referencePriceGroupId) against what is already staged instead of silently downgrading
   * it to the wire-level schema default. A group id with nothing previously staged (a genuine
   * first-time import) simply has no entries for it in the lookup, so its levels resolve exactly
   * as they did before this fix.
   */
  validatePriceGroupDocuments: ValidatePriceGroupDocumentsResult;
  validateProductionLot: ValidateProductionLotPayload;
  /**
   * Strong-DTO entry point for the GrowPoint site-locations import: wsapi-services posts
   * a batch of already-shaped SiteLocationCommands.MergeSiteLocation (one per
   * derived greenhouse, sub-locations nested). Each is validated via
   * SiteLocationCommands.ValidMergeSiteLocation.Create — the same parse the
   * production mergeSiteLocation mutation runs; successes are projected
   * synchronously to the production document shapes — one
   * WorkSuite.GraphQl.Features.SiteLocation.SiteLocationDocument and one
   * SubLocationDocument per sub-location — plus the 1:1 import-command echo,
   * then written to the staged collections in the GrowPointIntegrations Mongo db
   * (SiteLocations.Staged.Summary + SiteLocations.Staged.Locations +
   * SiteLocations.Staged.ImportCommand). The pwa staged-review pages query these
   * collections using the same fragments as the production
   * siteLocations/subLocations queries. Failures partition into
   * ValidateSiteLocationsDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure.
   */
  validateSiteLocationsDocuments: ValidateSiteLocationsDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint tax-authority import: wsapi-services posts a
   * batch of already-shaped TaxAuthorityCommands.ImportTaxAuthority. Each is validated via
   * TaxAuthorityCommands.ValidImportTaxAuthority.Create (the SAME validation the production
   * importTaxAuthority promotion runs); successes are projected synchronously to the
   * production document shape — one WorkSuite.GraphQl.Features.TaxAuthority.TaxAuthorityDocument —
   * and to the 1:1 import-command echo
   * (WorkSuite.GraphQl.Features.TaxAuthority.TaxAuthorityImportCommandDocument), then written
   * to the staged collections in the GrowPointIntegrations Mongo db
   * (TaxAuthority.Staged.Summary + TaxAuthority.Staged.ImportCommand). Writes ZERO
   * event-store events — promotion is the separate production importTaxAuthority mutation.
   * Failures partition into ValidateTaxAuthorityDocumentsResult.RowErrors keyed by source
   * row index — the batch is never aborted by a row-level failure.
   */
  validateTaxAuthorityDocuments: ValidateTaxAuthorityDocumentsResult;
  /**
   * Re-checks this tenant's bound domain and records the current status. On the created path this
   * polls SendGrid: Verified when SendGrid confirms the CNAME records validate, Pending otherwise. On
   * the grandfather path this confirms the ownership-challenge TXT record (worksuite-domain-verify=
   * + the token) is published at _worksuite.{domain} via the shared DNS resolver: Verified when
   * present, Pending when absent or wrong; a DNS lookup failure fails closed with no status change.
   * A flip to Verified is rejected if another tenant is already Verified on the same domain or SendGrid
   * authentication. Call this after the records exposed by the tenantEmailDomain query
   * (dnsRecords on the created path, challengeTxtHost/challengeTxtRecord on the
   * grandfather path) have been published at the domain's DNS provider.
   */
  validateTenantEmailDomain: TenantEmailDomainPayload;
  /**
   * Strong-DTO entry point for the GrowPoint terms import: wsapi-services posts a
   * batch of already-shaped TermsCommands.ImportTerms. Each is validated via
   * TermsCommands.ValidImportTerms.Create (the SAME validation the production
   * importTerms promotion runs); successes are projected synchronously to the
   * production document shape — one WorkSuite.GraphQl.Features.Terms.TermsDocument —
   * and to the 1:1 import-command echo
   * (WorkSuite.GraphQl.Features.Terms.TermsImportCommandDocument), then written to the
   * staged collections in the GrowPointIntegrations Mongo db
   * (Terms.Staged.Summary + Terms.Staged.ImportCommand). Writes ZERO
   * event-store events — promotion is the separate production importTerms mutation.
   * Failures partition into ValidateTermsDocumentsResult.RowErrors keyed by source
   * row index — the batch is never aborted by a row-level failure.
   */
  validateTermsDocuments: ValidateTermsDocumentsResult;
  /**
   * Proves ownership of a claimed domain from its DNS TXT record and brings it into service. On
   * success the domain serves the tenant's portal and is approved for on-demand TLS issuance.
   */
  verifyPortalCustomDomain: PortalSettingsPayload;
  /**
   * Verifies the tenant's stored SMTP connection with a live connect + AUTH + test message to the
   * supplied recipient. Success marks it verified; a rejected connect / AUTH / send marks it failed with
   * a sanitized, non-secret reason. Both outcomes are a successful mutation returning the new status.
   */
  verifyTenantSmtpConnection: TenantSmtpConnectionPayload;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateAdminFeatureFlagArgs = {
  input: ActivateFeatureFlagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateAdminTenantArgs = {
  input: ActivateTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCategoryArgs = {
  input: ActivateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateConfigCategoryArgs = {
  input: ActivateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateContainerConfigArgs = {
  input: ActivateContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerArgs = {
  input: ActivateCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerItemArgs = {
  input: ActivateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerTypeArgs = {
  input: ActivateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateDeliveryScheduleArgs = {
  input: ActivateDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateItemArgs = {
  input: ActivateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateLocationArgs = {
  input: ActivateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateMaterialItemArgs = {
  input: ActivateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivatePriceGroupArgs = {
  input: ActivatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionCategoryArgs = {
  input: ActivateProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionItemArgs = {
  input: ActivateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionLotArgs = {
  input: ActivateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionMaterialEventArgs = {
  input: ActivateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionMaterialEventDetailArgs = {
  input: ActivateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionPlanArgs = {
  input: ActivateProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionRecipeArgs = {
  input: ActivateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceCategoryArgs = {
  input: ActivateProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceEventArgs = {
  input: ActivateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceEventDetailArgs = {
  input: ActivateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceTypeArgs = {
  input: ActivateProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTaskEventArgs = {
  input: ActivateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTaskEventDetailArgs = {
  input: ActivateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTriggerArgs = {
  input: ActivateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateSftpTenantConfigArgs = {
  input: ActivateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateSizeUomArgs = {
  input: ActivateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateTaskEventTypeArgs = {
  input: ActivateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateTaxAuthorityArgs = {
  input: ActivateTaxAuthorityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateVendorArgs = {
  input: ActivateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddAdminTenantArgs = {
  input: AddTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddAvailabilitySessionCountArgs = {
  input: AddCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBillingAddressArgs = {
  input: AddBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBlockingRuleLinkedItemsArgs = {
  input: AddBlockingRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBlockingRuleLinkedLocationsArgs = {
  input: AddBlockingRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBpfLotChangeArgs = {
  input: AddBpfLotChangeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCategoryArgs = {
  input: AddCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddConfigCategoryArgs = {
  input: AddConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContactArgs = {
  input: AddContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigArgs = {
  input: AddContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigForConfigCategoryArgs = {
  input: AddContainerConfigForConfigCategoryDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigToConfigCategoryArgs = {
  input: AddContainerConfigToConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerItemArgs = {
  input: AddCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerTypeArgs = {
  input: AddCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddInventoryNoteArgs = {
  input: AddInventoryNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemArgs = {
  input: AddItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemAvailabilityArgs = {
  input: AddItemAvailabilityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemAvailabilityBatchArgs = {
  input: Array<AddItemAvailabilityInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemUpgradeArgs = {
  input: AddItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLineItemsArgs = {
  input: AddLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLineItemsWithPricingArgs = {
  input: AddLineItemsWithPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLocationArgs = {
  input: AddLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddMasterLineItemsArgs = {
  input: AddMasterLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddMultipleRetailProductCountArgs = {
  input: Array<AddRetailProductCountInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddOrderLineUpgradeArgs = {
  input: AddOrderLineUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPortalCustomDomainArgs = {
  input: AddPortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPriceGroupArgs = {
  input: AddPriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionLotAsyncImportJobRowsArgs = {
  input: AddProductionLotAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionMaterialEventDetailsArgs = {
  input: AddProductionMaterialEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionMaterialEventToCategoryArgs = {
  input: AddProductionMaterialEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionRecipeVariationArgs = {
  input: AddProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionSpaceEventDetailsArgs = {
  input: AddProductionSpaceEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionSpaceEventToCategoryArgs = {
  input: AddProductionSpaceEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventDetailsArgs = {
  input: AddProductionTaskEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventToCategoryArgs = {
  input: AddProductionTaskEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventToItemArgs = {
  input: AddProductionTaskEventToItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPromotionRuleLinkedItemsArgs = {
  input: AddPromotionRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPromotionRuleLinkedLocationsArgs = {
  input: AddPromotionRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPurchaseOrderLineItemArgs = {
  input: AddPurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddReserveRuleLinkedItemsArgs = {
  input: AddReserveRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddReserveRuleLinkedLocationsArgs = {
  input: AddReserveRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddRetailProductCountArgs = {
  input: AddRetailProductCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpDestinationArgs = {
  input: AddSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpMongoDestinationArgs = {
  input: AddSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpTenantConfigArgs = {
  input: AddSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddShipFromLocationArgs = {
  input: AddShipFromLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSignatureImageArgs = {
  input: AddSignatureImageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSiteLocationAsyncImportJobRowsArgs = {
  input: AddSiteLocationAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSizeUomArgs = {
  input: AddSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSizeUomToConfigCategoryArgs = {
  input: AddSizeUomToConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTaskAssignmentNoteArgs = {
  input: AddNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTenantEmailDomainArgs = {
  input: AddTenantEmailDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTenantEmailSenderArgs = {
  input: AddTenantEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTermsArgs = {
  input: AddTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddWsapiImportEntityMappingArgs = {
  input: AddWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustAvailabilitySessionCountsArgs = {
  input: RecordAdjustmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustInventoryItemArgs = {
  input: SetInventoryItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustMaterialAllocationArgs = {
  input: AdjustAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustMaterialItemArgs = {
  input: AdjustMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustPostedProductionArgs = {
  input: AdjustPostedProductionDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustProductionLotAllocationArgs = {
  input: AdjustProductionLotAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminCreateUserInvitesArgs = {
  input: CreateUserInvitesInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByCustomerArgs = {
  input: AdminDbrCalcForceRecalcByCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByItemArgs = {
  input: AdminDbrCalcForceRecalcByItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByLocationArgs = {
  input: AdminDbrCalcForceRecalcByLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByTenantArgs = {
  input: AdminDbrCalcForceRecalcByTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcRowArgs = {
  input: AdminDbrCalcForceRecalcRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDeleteUserInviteArgs = {
  input: DeleteUserInviteInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminResendUserInviteArgs = {
  input: ResendUserInviteInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByCustomerArgs = {
  input: AdminRestockCalcForceRecalcByCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByItemArgs = {
  input: AdminRestockCalcForceRecalcByItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByLocationArgs = {
  input: AdminRestockCalcForceRecalcByLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByTenantArgs = {
  input: AdminRestockCalcForceRecalcByTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcRowArgs = {
  input: AdminRestockCalcForceRecalcRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockSeedImportDataArgs = {
  input: AdminRestockSeedImportDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockSeedingKickPipelineArgs = {
  input: AdminRestockSeedingKickPipelineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceProductionLotAsyncImportJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateLineItemsArgs = {
  input: AllocateLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateProductionLotToOrderLineArgs = {
  input: AllocateProductionLotToOrderLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateRestockSessionInventoryArgs = {
  input: AllocateCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAmendPurchaseOrderLineItemArgs = {
  input: AmendPurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAppendTaxAuthorityRateArgs = {
  input: AppendTaxAuthorityRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyConsolidationArgs = {
  input: ApplyConsolidationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApprovePurchaseOrderArgs = {
  input: ApprovePurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignItemGlAccountsArgs = {
  input: AssignItemGlAccountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignMaterialItemToVendorArgs = {
  input: AssignMaterialItemToVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserCustomerArgs = {
  input: AssignUserCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserCustomersArgs = {
  input: AssignUserCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserRoutesArgs = {
  input: AssignUserRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserSitesArgs = {
  input: AssignUserSitesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAtomicMoveArgs = {
  input: AtomicMoveMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAttachAvailabilitySessionPhotoArgs = {
  input: AttachAvailabilityPhotoInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAutoAllocateRestockSessionOrderQuantitiesArgs = {
  input: AutoAllocateRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillAdminTenantStripeCustomerArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillTrialKindsArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateCategoriesArgs = {
  input: BatchActivateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateCustomersArgs = {
  input: BatchActivateCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateItemsArgs = {
  input: BatchActivateItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivatePriceGroupsArgs = {
  input: BatchActivatePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchAddCategoriesArgs = {
  input: BatchAddCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeactivateProductionLotsArgs = {
  input: BatchDeactivateProductionLotsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteCustomersArgs = {
  input: BatchDeleteCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteItemsArgs = {
  input: BatchDeleteItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeletePriceGroupsArgs = {
  input: BatchDeletePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteSiteLocationsArgs = {
  input: BatchDeleteSiteLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateCategoriesArgs = {
  input: BatchInactivateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateCustomersArgs = {
  input: BatchInactivateCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateItemsArgs = {
  input: BatchInactivateItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivatePriceGroupsArgs = {
  input: BatchInactivatePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchRemoveCategoriesArgs = {
  input: BatchRemoveCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateCategoriesArgs = {
  input: BatchUpdateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateCrmExportStatusesArgs = {
  input: BatchUpdateCrmExportStatusesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateMergeDevExportStatusesArgs = {
  input: BatchUpdateMergeDevExportStatusesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBulkAssignTasksArgs = {
  input: BulkAssignTasksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBulkCreateMaterialItemArgs = {
  input: BulkCreateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCalculateRestockOrderQuantityArgs = {
  input: RestockCalculationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelAssignmentArgs = {
  input: CancelAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelErpLoadListSessionArgs = {
  input: CancelErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelProductionLotAllocationArgs = {
  input: CancelProductionLotAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelPurchaseOrderArgs = {
  input: CancelPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelRestockSessionArgs = {
  input: CancelRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelScheduledLaborRateArgs = {
  input: CancelScheduledLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelScheduledOverheadRateArgs = {
  input: CancelScheduledOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelTaskArgs = {
  input: CancelTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeProductionCatalogStatusArgs = {
  input: ChangeProductionCatalogStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeVendorPurchaseOrderItemsArgs = {
  input: ChangeVendorPurchaseOrderItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeVendorPurchaseOrderStatusArgs = {
  input: ChangeVendorPurchaseOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeWorkOrderQuantityProducedArgs = {
  input: ChangeWorkOrderQuantityProducedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeWorkOrderStatusArgs = {
  input: ChangeWorkOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimPendingErpWriteBacksArgs = {
  input: ClaimPendingErpWriteBacksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCleanCustomersArgs = {
  input: CleanCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCleanItemsArgs = {
  input: CleanItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearActiveCountSessionArgs = {
  input: ClearActiveCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerCommissionOverrideArgs = {
  input: ClearCustomerCommissionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerLocationNoteArgs = {
  input: ClearCustomerLocationNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerNoteArgs = {
  input: ClearCustomerNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearEmailSuppressionArgs = {
  input: ClearEmailSuppressionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearInventoryNoteArgs = {
  input: ClearInventoryNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemContainerConfigOverrideArgs = {
  input: ClearItemContainerConfigOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemLaborCostArgs = {
  input: ClearItemLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemNoteArgs = {
  input: ClearItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobGrowWeeksOverrideArgs = {
  input: ClearJobGrowWeeksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobLinksOverrideArgs = {
  input: ClearJobLinksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobPlannedHoursOverrideArgs = {
  input: ClearJobPlannedHoursOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobPlantsPerPotOverrideArgs = {
  input: ClearJobPlantsPerPotOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOnHandAdjustmentQueueArgs = {
  input: ClearOnHandAdjustmentQueueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderEmailRecipientRoutingArgs = {
  input: ClearOrderEmailRecipientRoutingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderNoteArgs = {
  input: ClearOrderNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearSpaceCategorySiteOverrideArgs = {
  input: ClearSpaceCategorySiteOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearSpaceDimensionOverrideArgs = {
  input: ClearSpaceDimensionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTaskEventDirectCostArgs = {
  input: ClearTaskEventDirectCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTenantBillingRateCardArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCloseAvailabilitySessionArgs = {
  input: CloseSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCommitSpaceRebalanceArgs = {
  input: CommitSpaceRebalanceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteAssignmentTaskArgs = {
  input: CompleteAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteCountSessionArgs = {
  input: CompleteCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteM365MailboxConnectArgs = {
  input: CompleteM365MailboxConnectInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteMergeLinkArgs = {
  input: CompleteMergeLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteTaskArgs = {
  input: CompleteTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteTenantEmailSenderVerificationArgs = {
  input: CompleteTenantEmailSenderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmMaterialAllocationArgs = {
  input: ConfirmAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmReceiptArgs = {
  input: ConfirmReceiptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConnectOrderEaseIntegrationArgs = {
  input: ConnectOrderEaseIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConsumeProductionJobsMaterialsArgs = {
  input: ConsumeProductionJobsMaterialsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCorrectOrderArgs = {
  input: CorrectOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCountMaterialItemArgs = {
  input: CountMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateAdHocVendorPurchaseOrderArgs = {
  input: CreateAdHocVendorPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateAllocationTemplateArgs = {
  input: CreateAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateBillingPortalSessionArgs = {
  returnUrl: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateBlockingRuleArgs = {
  input: CreateBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCommissionConfigArgs = {
  input: CreateCommissionConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCountAssignmentArgs = {
  input: CreateCountAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCustomerArgs = {
  input: AddCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateErpLoadListSessionArgs = {
  input: CreateErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateForecastArgs = {
  input: CreateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateInventoryItemArgs = {
  input: CreateInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateInvoiceEmailDraftArgs = {
  input: CreateInvoiceEmailDraftInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateKitArgs = {
  input: CreateKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMakeToOrderPlanArgs = {
  input: CreateMakeToOrderPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMaterialItemArgs = {
  input: CreateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMovementOrderArgs = {
  input: CreateMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMySubscriptionCheckoutSessionArgs = {
  frequency: BillingFrequency;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePortalUserArgs = {
  input: CreatePortalUserDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionCatalogArgs = {
  input: CreateProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionItemArgs = {
  input: CreateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLineArgs = {
  input: CreateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLotArgs = {
  input: CreateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLotAsyncImportJobArgs = {
  input: CreateProductionLotAsyncImportJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionMaterialEventArgs = {
  input: CreateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionRecipeArgs = {
  input: CreateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionRecipeWithVariationArgs = {
  input: CreateProductionRecipeWithVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionSpaceEventArgs = {
  input: CreateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionTaskEventArgs = {
  input: CreateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionTriggerArgs = {
  input: CreateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePromotionRuleArgs = {
  input: CreatePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePurchaseOrderAllocationArgs = {
  input: CreatePurchaseOrderAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportFolderArgs = {
  input: CreateReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReserveRuleArgs = {
  input: CreateReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateRestockSessionArgs = {
  input: CreateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateScheduledOrderArgs = {
  input: CreateScheduledOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSiteLocationAsyncImportJobArgs = {
  input: CreateSiteLocationAsyncImportJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSiteMapArgs = {
  input: CreateSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSubscriptionCheckoutSessionArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskAssignmentArgs = {
  input: CreateTaskAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskEventTypeArgs = {
  input: CreateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaxAuthorityArgs = {
  input: CreateTaxAuthorityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateUserInviteArgs = {
  input: CreateUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateVendorPurchaseOrderArgs = {
  input: CreateVendorPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateWorkOrderArgs = {
  input: CreateWorkOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateWsapiImportArgs = {
  input: CreateWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreditExistingOrderArgs = {
  input: CreditExistingOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAddItemToShoppingCartArgs = {
  input: AddItemToCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAddLineItemsArgs = {
  input: AddLineItemsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAdjustAvailabilitySessionCountsArgs = {
  input: RecordAdjustmentInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreateFavoritesListArgs = {
  input: CreateFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreatePortalUserArgs = {
  input: CreatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreateShoppingCartArgs = {
  input: CreateCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalDeactivatePortalUserArgs = {
  input: DeactivatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalDeleteFavoritesListArgs = {
  input: DeleteFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalInitializeOrderArgs = {
  input: InitializeOrderInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalSelfRegisterArgs = {
  input: SelfRegisterPortalUserDataInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateAndGetNextOrderNumberArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateFavoritesListArgs = {
  input: UpdateFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdatePortalUserArgs = {
  input: UpdatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateShoppingCartArgs = {
  input: UpdateCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateConfigCategoryArgs = {
  input: DeactivateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateContainerConfigArgs = {
  input: DeactivateContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerItemArgs = {
  input: DeactivateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerTypeArgs = {
  input: DeactivateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateItemUpgradeArgs = {
  input: DeactivateItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionCategoryArgs = {
  input: DeactivateProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionLineArgs = {
  input: DeactivateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionLotArgs = {
  input: DeactivateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionPlanArgs = {
  input: DeactivateProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionSpaceCategoryArgs = {
  input: DeactivateProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionSpaceTypeArgs = {
  input: DeactivateProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateSizeUomArgs = {
  input: DeactivateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateTaxAuthorityArgs = {
  input: DeactivateTaxAuthorityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeallocatePurchaseOrderAllocationArgs = {
  input: DeallocatePurchaseOrderAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDefineForecastHolidayArgs = {
  input: DefineHolidayInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAdminTenantIntegrationArgs = {
  input: DeleteTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAdminTenantPricingPageArgs = {
  input: AdminTenantPricingPageDeleteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAllocationTemplateArgs = {
  input: DeleteAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAvailabilitySessionCountArgs = {
  input: DeleteCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAvailabilitySessionCountBatchArgs = {
  input: DeleteCountBatchInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteBlockingRuleArgs = {
  input: DeleteBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCustomerTypeArgs = {
  input: DeleteCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteDeliveryScheduleArgs = {
  input: DeleteDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteErpLoadListSessionArgs = {
  input: DeleteErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteErpLoadListUserArgs = {
  input: DeleteErpLoadListUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteForecastArgs = {
  input: DeleteForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteForecastHolidayArgs = {
  input: DeleteHolidayInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteKitArgs = {
  input: DeleteKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceGroupArgs = {
  input: DeletePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceLevelArgs = {
  input: DeletePriceLevelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceLevelsArgs = {
  input: DeletePriceLevelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionCategoryArgs = {
  input: DeleteProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionItemArgs = {
  input: DeleteProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionLotArgs = {
  input: DeleteProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionMaterialEventArgs = {
  input: DeleteProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionPlanArgs = {
  input: DeleteProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionRecipeArgs = {
  input: DeleteProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceCategoryArgs = {
  input: DeleteProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceEventArgs = {
  input: DeleteProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceTypeArgs = {
  input: DeleteProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionTaskEventArgs = {
  input: DeleteProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionTriggerArgs = {
  input: DeleteProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePromotionRuleArgs = {
  input: DeletePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportExecutionArgs = {
  input: DeleteReportExecutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportFolderArgs = {
  input: DeleteReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportScheduleArgs = {
  input: DeleteReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportTemplateArgs = {
  input: DeleteReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReserveRuleArgs = {
  input: DeleteReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteRestockSessionArgs = {
  input: DeleteRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSftpTenantConfigArgs = {
  input: DeleteSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSiteLocationArgs = {
  input: DeleteSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSiteMapArgs = {
  input: DeleteSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteStagedEntityDocumentsArgs = {
  entity: GrowPointStagedEntity;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTaskEventTypeArgs = {
  input: DeleteTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTenantIntegrationArgs = {
  input: DeleteTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTimeEntryArgs = {
  input: DeleteTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteUserInviteArgs = {
  input: DeleteUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteWorkerConfigArgs = {
  input: DeleteWorkerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteWsapiImportArgs = {
  input: DeleteWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDisableWsapiImportArgs = {
  input: DisableWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDiscardFloatingTimeEntryArgs = {
  input: DiscardFloatingTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDuplicatePriceGroupArgs = {
  input: DuplicatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditMasterOrderArgs = {
  input: EditMasterOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditOrderArgs = {
  input: EditOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditPlanCellsArgs = {
  input: EditPlanCellsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditScheduledLaborRateArgs = {
  input: EditScheduledLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditScheduledOverheadRateArgs = {
  input: EditScheduledOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditWeeklyCellsArgs = {
  input: EditWeeklyCellsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEnableWsapiImportArgs = {
  input: EnableWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEnqueueErpWriteBackArgs = {
  input: EnqueueErpWriteBackInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationExecuteProductionJobArgs = {
  input: ExecuteProductionJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFinalizeImportUploadArgs = {
  input: FinalizeImportUploadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFlagStaleEntryArgs = {
  input: FlagStaleEntriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationForceCancelStuckMtoReservationArgs = {
  input: ForceCancelStuckReservationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationForceReadyHandoffStuckMtoReservationArgs = {
  input: ForceReadyHandoffStuckReservationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFulfillMaterialAllocationArgs = {
  input: FulfillAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGenerateForecastArgs = {
  input: GenerateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGradeInventoryItemArgs = {
  input: GradeInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportCustomerArgs = {
  input: ImportCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportHistoricalOrdersArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportTaxAuthorityArgs = {
  input: ImportTaxAuthorityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportTermsArgs = {
  input: ImportTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateAdminFeatureFlagArgs = {
  input: InactivateFeatureFlagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateAdminTenantArgs = {
  input: InactivateTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateCategoryArgs = {
  input: InactivateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateCustomerArgs = {
  input: InactivateCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateDeliveryScheduleArgs = {
  input: InactivateDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateItemArgs = {
  input: InactivateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateLocationArgs = {
  input: InactivateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateMaterialItemArgs = {
  input: InactivateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivatePriceGroupArgs = {
  input: InactivatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionItemArgs = {
  input: InactivateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionMaterialEventArgs = {
  input: InactivateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionMaterialEventDetailArgs = {
  input: InactivateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionRecipeArgs = {
  input: InactivateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionSpaceEventArgs = {
  input: InactivateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionSpaceEventDetailArgs = {
  input: InactivateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTaskEventArgs = {
  input: InactivateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTaskEventDetailArgs = {
  input: InactivateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTriggerArgs = {
  input: InactivateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateSftpTenantConfigArgs = {
  input: InactivateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateTaskEventTypeArgs = {
  input: InactivateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateVendorArgs = {
  input: InactivateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIngestQaTestRunArgs = {
  input: IngestQaTestRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeMasterOrderArgs = {
  input: InitializeMasterOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeMergeDevExportArgs = {
  input: InitializeMergeDevExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeOrderArgs = {
  input: InitializeOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFloatingTimeEntryArgs = {
  input: LinkFloatingTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFusionAuthUserArgs = {
  input: LinkFusionAuthUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFusionAuthUserByEmailArgs = {
  input: LinkFusionAuthUserByEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkProductionItemsToSalesItemArgs = {
  input: LinkProductionItemsToSalesItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMakeLiveAvailabilitySessionArgs = {
  input: MakeSessionLiveInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMapTaxAuthorityToMergeDevTaxRateArgs = {
  input: MapMergeDevTaxRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackFailedArgs = {
  input: MarkErpWriteBackFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackProcessedArgs = {
  input: MarkErpWriteBackProcessedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportCompletedArgs = {
  input: MarkMergeDevExportCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportFailedPermanentArgs = {
  input: MarkMergeDevExportFailedPermanentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportFailedTransientArgs = {
  input: MarkMergeDevExportFailedTransientInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkProductionLotReadyArgs = {
  input: MarkProductionLotReadyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRfidScansAsSyncedArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisionedArgs = {
  input: MarkTrialRequestProvisionedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisioningArgs = {
  input: MarkTrialRequestProvisioningInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisioningFailedArgs = {
  input: MarkTrialRequestProvisioningFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteCompletedArgs = {
  input: MarkUserInviteCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteEmailFailedArgs = {
  input: MarkUserInviteEmailFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteEmailSentArgs = {
  input: MarkUserInviteEmailSentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteFailedArgs = {
  input: MarkUserInviteFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeBackgroundServiceConfigArgs = {
  input: MergeBackgroundServiceConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeContainerConfigArgs = {
  input: MergeContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeCustomerArgs = {
  input: MergeCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeDeliveryScheduleArgs = {
  input: MergeDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeErpLoadListUserArgs = {
  input: MergeErpLoadListUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeForecastSettingsArgs = {
  input: MergeForecastSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeItemArgs = {
  input: MergeItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeJobWorkOrdersArgs = {
  input: MergeJobWorkOrdersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLinkTokenArgs = {
  category?: MergeLinkCategory;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMaterialItemByErpIdArgs = {
  input: MergeMaterialItemByErpIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMergeDevAccountArgs = {
  input: MergeMergeDevAccountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMergeDevPaymentArgs = {
  input: MergeMergeDevPaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMergeDevTaxRateArgs = {
  input: MergeMergeDevTaxRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeOrderArgs = {
  input: InitializeOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergePriceGroupArgs = {
  input: MergePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergePriceLevelArgs = {
  input: MergePriceLevelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionCategoryArgs = {
  input: MergeProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionItemArgs = {
  input: MergeProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionPlanArgs = {
  input: MergeProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionSpaceCategoryArgs = {
  input: MergeProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionSpaceTypeArgs = {
  input: MergeProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeReplenishmentSettingsArgs = {
  input: MergeReplenishmentSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeSiteLocationArgs = {
  input: MergeSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeVendorArgs = {
  input: MergeVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeWorkerConfigArgs = {
  input: MergeWorkerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMoveInventoryItemArgs = {
  input: MoveInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMoveMaterialItemArgs = {
  input: MoveMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideOrderLineUpgradePricingArgs = {
  input: OverrideOrderLineUpgradePricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProducedQuantityArgs = {
  input: OverrideProducedQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobLocationArgs = {
  input: OverrideProductionJobLocationDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobQuantityArgs = {
  input: OverrideProductionJobQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobWeekReadyArgs = {
  input: OverrideProductionJobWeekReadyDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobWeekStartArgs = {
  input: OverrideProductionJobWeekStartDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobYieldArgs = {
  input: OverrideProductionJobYieldDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionLotCustomerArgs = {
  input: OverrideProductionLotCustomerDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionLotQuantityArgs = {
  input: OverrideProductionLotQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideRestockSessionOrderQuantitiesArgs = {
  input: OverrideRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPatchBatchAdminTenantArgs = {
  input: PatchBatchAdminTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPatchItemArgs = {
  input: PatchItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPauseCountSessionArgs = {
  input: PauseCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostCycleCountsArgs = {
  input: PostCycleCountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostProductionJobArgs = {
  input: PostProductionJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostProductionJobsArgs = {
  input: PostProductionJobsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationProcessErpLoadListSessionArgs = {
  input: ProcessErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationProcessOnHandAdjustmentArgs = {
  input: ProcessOnHandAdjustmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublicUserInviteAcceptArgs = {
  input: AcceptUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishRestockWorkQueueResultBatchArgs = {
  input: PublishRestockWorkQueueResultBatchInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationQueueOnHandAdjustmentArgs = {
  input: QueueOnHandAdjustmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReactivateUserArgs = {
  input: ReactivateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReapplyRecipesArgs = {
  input: ReapplyRecipesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReassignTaskArgs = {
  input: ReassignTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReassignWsapiImportIntegrationArgs = {
  input: ReassignWsapiImportIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRebuildForecastWeeklyHistoryArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecalculateRestockSessionArgs = {
  input: RecalculateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReceiveMovementOrderArgs = {
  input: ReceiveMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReceiveVendorPurchaseOrderItemsArgs = {
  input: ReceiveVendorPurchaseOrderItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconcileMovementOrderArgs = {
  input: ReconcileMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconnectMergeLinkArgs = {
  input?: InputMaybe<ReconnectMergeLinkInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordAvailabilitySessionCountsArgs = {
  input: RecordCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordEmailDeliveryArgs = {
  input: RecordEmailDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordEmailSendArgs = {
  input: RecordEmailSendInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordManualJobCostArgs = {
  amount: Scalars['Decimal']['input'];
  costCategory: CostCategory;
  description: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMaterialReceiptArgs = {
  input: RecordMaterialReceiptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOrderDepositArgs = {
  input: RecordOrderDepositInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOrderPaymentArgs = {
  input: RecordOrderPaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordReportExecutionArgs = {
  input: RecordReportExecutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordShrinkEventArgs = {
  input: RecordShrinkEventDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordUserLastLoginsArgs = {
  input: RecordUserLastLoginsDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefreshTenantEmailSenderStatusArgs = {
  input: RefreshTenantEmailSenderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefreshTenantIntegrationTokensArgs = {
  input: RefreshTenantIntegrationTokensInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterCountArgs = {
  input: RegisterCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseMaterialAllocationArgs = {
  input: ReleaseAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBillingAddressArgs = {
  input: RemoveBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBlockingRuleLinkedItemsArgs = {
  input: RemoveBlockingRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBlockingRuleLinkedLocationsArgs = {
  input: RemoveBlockingRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveCategoryArgs = {
  input: RemoveCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveContactArgs = {
  input: RemoveContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveContainerConfigFromConfigCategoryArgs = {
  input: RemoveContainerConfigFromConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveImportRowsArgs = {
  input: RemoveImportRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemMinShipQtyArgs = {
  input: RemoveItemMinShipQtyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemRoyaltyArgs = {
  input: RemoveItemRoyaltyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemSubstitutionArgs = {
  input: RemoveItemSubstitutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLineItemArgs = {
  input: RemoveLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLineItemAllocationsArgs = {
  input: RemoveLineItemAllocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLocationArgs = {
  input: RemoveLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveMasterLineItemArgs = {
  input: RemoveMasterLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveOrderLineUpgradeArgs = {
  input: RemoveOrderLineUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePortalCustomDomainArgs = {
  input: RemovePortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionMaterialEventDetailArgs = {
  input: RemoveProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionMaterialEventFromCategoryArgs = {
  input: RemoveProductionMaterialEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionRecipeVariationArgs = {
  input: RemoveProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionSpaceEventDetailArgs = {
  input: RemoveProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionSpaceEventFromCategoryArgs = {
  input: RemoveProductionSpaceEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventDetailArgs = {
  input: RemoveProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventFromCategoryArgs = {
  input: RemoveProductionTaskEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventFromItemArgs = {
  input: RemoveProductionTaskEventFromItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePromotionRuleLinkedItemsArgs = {
  input: RemovePromotionRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePromotionRuleLinkedLocationsArgs = {
  input: RemovePromotionRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePurchaseOrderLineItemArgs = {
  input: RemovePurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveReserveRuleLinkedItemsArgs = {
  input: RemoveReserveRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveReserveRuleLinkedLocationsArgs = {
  input: RemoveReserveRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSftpDestinationArgs = {
  input: RemoveSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSftpMongoDestinationArgs = {
  input: RemoveSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveShrinkEventArgs = {
  input: RemoveShrinkEventDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSizeUomFromConfigCategoryArgs = {
  input: RemoveSizeUomFromConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSpaceCapacityWindowArgs = {
  input: RemoveSpaceCapacityWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveTaskAssignmentTimeEntryArgs = {
  input: RemoveTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveTenantEmailSenderArgs = {
  input: RemoveTenantEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveVerifyContainerArgs = {
  input: RemoveVerifyContainerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveWsapiImportEntityMappingArgs = {
  input: RemoveWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenameReportFolderArgs = {
  input: RenameReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReopenProductionJobArgs = {
  input: ReopenProductionJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceCustomerSalesPeopleArgs = {
  input: ReplaceCustomerSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceErpLoadListRoutesArgs = {
  input: ReplaceErpLoadListRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceSalesPeopleArgs = {
  input: ReplaceSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestMaterialAllocationArgs = {
  input: RequestAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestRestockCalculationArgs = {
  input: RequestRestockCalculationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestRestockDashboardRecalcArgs = {
  input: RequestRestockDashboardRecalcInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestTenantEmailSenderVerificationArgs = {
  input: RequestTenantEmailSenderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestTrialSignupVerificationArgs = {
  input: RequestTrialSignupVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResendUserInviteArgs = {
  input: ResendUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetAcknowledgmentEmailArgs = {
  input: ResetAcknowledgmentEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetAdminTenantIntegrationsArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetConfirmationEmailArgs = {
  input: ResetConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetOrderSyncStatusArgs = {
  input: ResetSyncStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetUserLoginArgs = {
  input: ResetUserLoginInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWorkOrderQuantityProducedArgs = {
  input: ResetWorkOrderQuantityProducedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWorkerConfigRunNowArgs = {
  input: ResetWorkerConfigRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWsapiImportRunNowArgs = {
  input: ResetWsapiImportRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveTrialRequestArgs = {
  input: ResolveTrialRequestInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResumeCountSessionArgs = {
  input: ResumeCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevalidateImportArgs = {
  input: RevalidateImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertReportArgs = {
  reportId: Scalars['String']['input'];
  version: Scalars['Long']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRoundRestockSessionOrderQuantityToFullCartArgs = {
  input: RoundRestockSessionOrderQuantityToFullCartInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScrapInventoryItemArgs = {
  input: ScrapInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSeedForecastHolidaysArgs = {
  input: SeedForecastHolidaysInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSendInvoiceEmailArgs = {
  input: SendInvoiceEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAccountingIntegrationConfigArgs = {
  input: SetAccountingIntegrationConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetActiveCountSessionArgs = {
  input: SetActiveCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminFeatureFlagGlobalValueArgs = {
  input: SetGlobalValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminFeatureFlagTenantOverridesArgs = {
  input: SetTenantOverridesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetBackgroundServiceEnabledArgs = {
  input: SetBackgroundServiceEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetBpfUserStartingNodesArgs = {
  input: SetBpfUserStartingNodesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCategoryLaborCostArgs = {
  input: SetCategoryLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCheckpointArgs = {
  input: SetCheckpointInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCommissionDefaultRateArgs = {
  input: SetCommissionDefaultRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetConsolidationRuleSetArgs = {
  input: SetConsolidationRuleSetInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetContactCrmLinkArgs = {
  input: SetContactCrmLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCountSessionTargetArgs = {
  input: SetCountSessionTargetInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerCommissionOverrideArgs = {
  input: SetCustomerCommissionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerCrmLinkArgs = {
  input: SetCustomerCrmLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerDepositRequirementArgs = {
  input: SetCustomerDepositRequirementInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerItemEffectiveDatesArgs = {
  input: SetCustomerItemEffectiveDatesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerItemRetailPriceArgs = {
  input: SetCustomerItemRetailPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationNoteArgs = {
  input: SetCustomerLocationNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationServicingSiteArgs = {
  input: SetCustomerLocationServicingSiteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerNoteArgs = {
  input: SetCustomerNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerTypeArgs = {
  input: SetCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerTypeRevenueGlAccountArgs = {
  input: SetCustomerTypeRevenueGlAccountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultGroupArgs = {
  input: SetDefaultGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultVendorArgs = {
  input: SetDefaultVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetEmailSenderAdminOnlyArgs = {
  input: SetEmailSenderAdminOnlyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetInventoryItemReadyDateArgs = {
  input: SetInventoryItemReadyDateCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemContainerConfigOverrideArgs = {
  input: SetItemContainerConfigOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemLaborCostArgs = {
  input: SetItemLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemNoteArgs = {
  input: SetItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemProductionMappingsArgs = {
  input: SetItemProductionMappingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobGrowWeeksOverrideArgs = {
  input: SetJobGrowWeeksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobLinksOverrideArgs = {
  input: SetJobLinksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobPlannedHoursOverrideArgs = {
  input: SetJobPlannedHoursOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobPlantsPerPotOverrideArgs = {
  input: SetJobPlantsPerPotOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLaborTypesArgs = {
  input: SetLaborTypesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLineItemOverridePriceArgs = {
  input: SetLineItemOverridePriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLocationOverheadRateArgs = {
  input: SetLocationOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyLanguagePreferenceArgs = {
  input: SetMyLanguagePreferenceDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyProfileImageArgs = {
  input: SetMyProfileImageDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderEmailRecipientRoutingArgs = {
  input: SetOrderEmailRecipientRoutingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderEmailSettingsArgs = {
  input: SetOrderEmailSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderNoteArgs = {
  input: SetOrderNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderShipFromSiteArgs = {
  input: SetOrderShipFromSiteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulApiKeySecretNameArgs = {
  input: SetOrderfulApiKeySecretNameInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulIntegrationMappingArgs = {
  input: SetOrderfulIntegrationMappingInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulIntegrationStatusArgs = {
  input: SetOrderfulIntegrationStatusInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulOrganizationIsaIdsArgs = {
  input: SetOrderfulOrganizationIsaIdsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPodAssignmentReplicasArgs = {
  input: SetPodAssignmentReplicasInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceGroupDerivationArgs = {
  input: SetPriceGroupDerivationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceGroupOrderVolumeDiscountArgs = {
  input: SetPriceGroupOrderVolumeDiscountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionLotAsyncImportJobRowIdsArgs = {
  input: SetProductionLotAsyncImportJobRowIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionRecipeTaskEventIdsArgs = {
  input: SetRecipeTaskEventIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPropagationYieldArgs = {
  input: SetProductionJobPropagationYieldDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPurchaseOrderUrgentArgs = {
  input: SetPurchaseOrderUrgentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRecipeLaborSourceArgs = {
  input: SetRecipeLaborSourceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetReportScheduleEmailSettingsArgs = {
  input: SetReportScheduleEmailSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRestockSessionOrderQuantitiesArgs = {
  input: SetRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteContactsArgs = {
  input: SetSiteContactsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteLaborRateArgs = {
  input: SetSiteLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteLocationAsyncImportJobRowIdsArgs = {
  input: SetSiteLocationAsyncImportJobRowIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteTimeZoneArgs = {
  input: SetSiteTimeZoneInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceCapacityWindowArgs = {
  input: SetSpaceCapacityWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceCategorySiteOverrideArgs = {
  input: SetSpaceCategorySiteOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceDimensionOverrideArgs = {
  input: SetSpaceDimensionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetStoreClassesArgs = {
  input: SetStoreClassesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventDirectCostArgs = {
  input: SetTaskEventDirectCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventLaborTypeTagArgs = {
  input: SetTaskEventLaborTypeTagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventThroughputArgs = {
  input: SetTaskEventThroughputInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantBillingFrequencyArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantBillingRateCardArgs = {
  input: SetTenantBillingRateCardInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultCarrierArgs = {
  input: SetTenantDefaultCarrierInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultEmailSenderArgs = {
  input: SetTenantDefaultEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultRouteArgs = {
  input: SetTenantDefaultRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantSmtpConnectionArgs = {
  input: SetTenantSmtpConnectionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantTaxDefaultAuthoritiesArgs = {
  input: SetTenantTaxDefaultAuthoritiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetVendorMaterialCostArgs = {
  input: SetVendorMaterialCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWorkOrderLineNumberArgs = {
  input: SetWorkOrderLineNumberInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWorkerConfigRunNowArgs = {
  input: SetWorkerConfigRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWsapiImportRunNowArgs = {
  input: SetWsapiImportRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShipMovementOrderArgs = {
  input: ShipMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShipPurchaseOrderArgs = {
  input: ShipPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSkipAssignmentTaskArgs = {
  input: SkipAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSplitProductionLotArgs = {
  input: SplitProductionLotDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStampPortalCustomDomainLoginRedirectSyncArgs = {
  input: StampPortalCustomDomainLoginRedirectSyncInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartAssignmentTaskArgs = {
  input: StartAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartAvailabilitySessionArgs = {
  input: StartAvailabilitySessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartCountSessionArgs = {
  input: StartCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartFloatingTimerArgs = {
  input: StartFloatingTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartRestockSessionCreationArgs = {
  input: StartRestockSessionCreationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTaskArgs = {
  input: StartTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTaskAssignmentTimerArgs = {
  input: StartTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTrialArgs = {
  input: StartTrialInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStopFloatingTimerArgs = {
  input: StopFloatingTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStopTaskAssignmentTimerArgs = {
  input: StopTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitErpLoadListSessionArgs = {
  input: SubmitErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitFullOrderArgs = {
  input: SubmitFullOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitOrderVerificationArgs = {
  input: SubmitOrderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitRestockSessionArgs = {
  input: SubmitRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitVerifyContainerArgs = {
  input: SubmitVerifyContainerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeErpItemPricesArgs = {
  input: SynchronizeErpItemPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeRestockSessionArgs = {
  input: SynchronizeRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeSalesPeopleArgs = {
  input: SynchronizeSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleItemUpgradeDefaultArgs = {
  input: ToggleItemUpgradeDefaultInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleSftpDestinationArgs = {
  input: ToggleSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleSftpMongoDestinationArgs = {
  input: ToggleSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnassignMaterialItemToVendorArgs = {
  input: UnassignMaterialItemToVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoRestockSessionOrderQuantityOverrideArgs = {
  input: UndoRestockSessionOrderQuantityOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkFusionAuthUserArgs = {
  input: UnlinkFusionAuthUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkProductionItemsFromSalesItemArgs = {
  input: UnlinkProductionItemsFromSalesItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnmapTaxAuthorityFromMergeDevTaxRateArgs = {
  input: UnmapMergeDevTaxRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetDefaultGroupArgs = {
  input: UnsetDefaultGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetDefaultTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetDefaultVendorArgs = {
  input: UnsetDefaultVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAcknowledgedQuantityArgs = {
  input: UpdateAcknowledgedQuantityItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAcknowledgmentEmailArgs = {
  input: UpdateAcknowledgmentEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminTenantOrganicReceiveModeArgs = {
  input: UpdateOrganicReceiveModeInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminTenantRestockProviderSettingsArgs = {
  input: UpdateTenantRestockProviderSettingsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAllocationTemplateArgs = {
  input: UpdateAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAsyncImportJobStatusArgs = {
  input: UpdateAsyncImportJobStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAvailabilitySessionCountArgs = {
  input: UpdateCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateBillingAddressArgs = {
  input: UpdateBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateBlockingRuleArgs = {
  input: UpdateBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateConfigCategoryArgs = {
  input: UpdateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateConfirmationEmailArgs = {
  input: UpdateConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateContainerConfigDetailsArgs = {
  input: UpdateContainerConfigDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerArgs = {
  input: EditCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemArgs = {
  input: UpdateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemAdditionalSkusArgs = {
  input: UpdateCustomerItemAdditionalSkusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemAdditionalUpcsArgs = {
  input: UpdateCustomerItemAdditionalUpcsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerLocationOrderAddressEditPermissionsArgs = {
  input: UpdateCustomerLocationOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerLocationSendOrderEmailsArgs = {
  input: UpdateCustomerLocationSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerOrderAddressEditPermissionsArgs = {
  input: UpdateCustomerOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerSendOrderEmailsArgs = {
  input: UpdateCustomerSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerTypeArgs = {
  input: UpdateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultFreightChargeArgs = {
  input: UpdateDefaultFreightChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultOrderSubmitterArgs = {
  input: UpdateDefaultOrderSubmitterInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultWeeksOfSupplyArgs = {
  input: UpdateDefaultWeeksOfSupplyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDeliveryScheduleLocationsArgs = {
  input: UpdateDeliveryScheduleLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDocumentRenderModeArgs = {
  input: UpdateDocumentRenderModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpIdArgs = {
  input: UpdateErpIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListQuantitiesArgs = {
  input: UpdateErpLoadListQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionItemAvailabilityArgs = {
  input: UpdateErpLoadListSessionItemAvailabilityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionNameArgs = {
  input: UpdateErpLoadListSessionNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionRoutesArgs = {
  input: UpdateErpLoadListSessionRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionShipDateArgs = {
  input: UpdateErpLoadListSessionShipDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpManagerEmailsArgs = {
  input: UpdateErpManagerEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateFinalCreditEnabledArgs = {
  input: UpdateFinalCreditEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateForecastArgs = {
  input: UpdateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateImportRowImportResultsArgs = {
  input: UpdateImportRowImportResultsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateImportRowValidationResultsArgs = {
  input: UpdateImportRowValidationResultsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemArgs = {
  input: UpdateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemAttributesArgs = {
  input: UpdateItemAttributesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemImageUrlArgs = {
  input: UpdateImageUrlInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemRetailPriceArgs = {
  input: UpdateRetailPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemUpgradeArgs = {
  input: UpdateItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateKitArgs = {
  input: UpdateKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemNoteArgs = {
  input: UpdateLineItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemsContainerCodeArgs = {
  input: UpdateLineItemsContainerCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationAddressArgs = {
  input: UpdateLocationAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationNameArgs = {
  input: UpdateLocationNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterAcknowledgedQuantityArgs = {
  input: UpdateAcknowledgedQuantityMasterItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterConfirmationEmailArgs = {
  input: UpdateMasterConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterLineItemArgs = {
  input: UpdateMasterLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterOrderContactArgs = {
  input: UpdateMasterOrderContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterOrderStatusArgs = {
  input: UpdateMasterOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterSalesPersonArgs = {
  input: UpdateMasterOrderSalesPersonInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMaterialItemDetailsArgs = {
  input: UpdateMaterialItemDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMaxDiscountPercentageArgs = {
  input: UpdateMaxDiscountPercentageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMissingItemGroupsArgs = {
  input: UpdateMissingItemGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMissingMasterItemGroupsArgs = {
  input: UpdateMissingMasterItemGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderAcknowledgementReportArgs = {
  input: UpdateOrderAcknowledgementReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderAddressEditPermissionsArgs = {
  input: UpdateOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderBillingAddressArgs = {
  input: UpdateOrderBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderContactArgs = {
  input: UpdateOrderContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderInvoiceReportArgs = {
  input: UpdateOrderInvoiceReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderLocationAddressArgs = {
  input: UpdateOrderLocationAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderRouteArgs = {
  input: UpdateRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderSendOrderEmailsArgs = {
  input: UpdateOrderSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderSyncAttemptArgs = {
  input: UpdateSyncAttemptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrganicReceiveModeArgs = {
  input: UpdateOrganicReceiveModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePoNumberMaxLengthArgs = {
  input: UpdatePoNumberMaxLengthInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePortalSettingsArgs = {
  input: UpdatePortalSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePriceGroupArgs = {
  input: UpdatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePriceLevelsArgs = {
  input: UpdatePriceLevelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceEnabledArgs = {
  input: UpdateProduceEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionCatalogArgs = {
  input: UpdateProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionCategoryDetailsArgs = {
  input: UpdateProductionCategoryDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionItemArgs = {
  input: UpdateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionJobLocationArgs = {
  input: UpdateProductionJobLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLineArgs = {
  input: UpdateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotAsyncImportJobRowsArgs = {
  input: UpdateProductionLotAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotCustomerArgs = {
  input: UpdateProductionLotCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotPlanArgs = {
  input: UpdateProductionLotPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionMaterialEventArgs = {
  input: UpdateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionMaterialEventDetailArgs = {
  input: UpdateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionPlanDetailsArgs = {
  input: UpdateProductionPlanDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionRecipeVariationArgs = {
  input: UpdateProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceCategoryDetailsArgs = {
  input: UpdateProductionSpaceCategoryDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceEventArgs = {
  input: UpdateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceEventDetailArgs = {
  input: UpdateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceTypeDetailsArgs = {
  input: UpdateProductionSpaceTypeDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventArgs = {
  input: UpdateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventAssigneeArgs = {
  input: UpdateProductionTaskEventAssigneeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventDetailArgs = {
  input: UpdateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTriggerArgs = {
  input: UpdateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePromotionRuleArgs = {
  input: UpdatePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePublicScoreArgs = {
  increment: Scalars['Int']['input'];
  taskId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportScheduleArgs = {
  input: UpdateReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReserveRuleArgs = {
  input: UpdateReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionArgs = {
  input: UpdateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionOrderQuantitiesArgs = {
  input: UpdateRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionReserveRulesArgs = {
  input: UpdateRestockSessionReserveRulesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSalesPersonArgs = {
  input: UpdateSalesPersonInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpAggregationConfigArgs = {
  input: UpdateSftpAggregationConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpDestinationArgs = {
  input: UpdateSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpMongoColumnMapsArgs = {
  input: UpdateSftpMongoColumnMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpMongoDestinationArgs = {
  input: UpdateSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpSqlColumnMapsArgs = {
  input: UpdateSftpSqlColumnMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpSystemSettingsArgs = {
  input: UpdateSftpSystemSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpTenantConfigArgs = {
  input: UpdateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateShippedQuantityArgs = {
  input: UpdateShippedQuantityItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSiteLocationAsyncImportJobRowsArgs = {
  input: UpdateSiteLocationAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSiteMapArgs = {
  input: UpdateSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSizeUomArgs = {
  input: UpdateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSubscriptionArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTaskEventTypeArgs = {
  input: UpdateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTaxAuthorityArgs = {
  input: UpdateTaxAuthorityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTaxRoyaltyArgs = {
  input: UpdateTaxRoyaltyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantBrandingArgs = {
  input: UpdateTenantBrandingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantGradeLabelsArgs = {
  input: UpdateTenantGradeLabelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantOrderEmailsEnabledArgs = {
  input: UpdateOrderEmailsEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantUnitConfigArgs = {
  input: UpdateTenantUnitConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTermsArgs = {
  input: UpdateTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTermsIdArgs = {
  input: UpdateTermsIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUseErpPricingArgs = {
  input: UpdateUseErpPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserAppSettingArgs = {
  input: UpdateUserAppSettingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserFullNameArgs = {
  input: UpdateUserFullNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVendorPurchaseOrderSiteLocationArgs = {
  input: UpdateVendorPurchaseOrderSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVerifyModeArgs = {
  input: UpdateVerifyModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateWsapiImportEntityMappingArgs = {
  input: UpdateWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateWsapiImportScheduleArgs = {
  input: UpdateWsapiImportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUploadItemImageArgs = {
  input: UploadItemImageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertAdminTenantIntegrationArgs = {
  input: UpsertTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertAdminTenantPricingPageArgs = {
  input: AdminTenantPricingPageUpsertInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMergeCrmTenantIntegrationArgs = {
  input: UpsertMergeCrmTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMergeTenantIntegrationArgs = {
  input: UpsertMergeTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMySqlAdminTenantIntegrationArgs = {
  input: UpsertMySqlTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMySqlTenantIntegrationArgs = {
  input: UpsertMySqlTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertRfidScansArgs = {
  input: Array<RfidScanInputDataInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTenantPricingPageArgs = {
  input: UpsertTenantPricingPageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTimeEntriesArgs = {
  input: Array<UpsertTimeEntryInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTrialPolicyArgs = {
  input: UpsertTrialPolicyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateCategoryDocumentsArgs = {
  input: Array<MergeCategoryInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateCustomerDocumentsArgs = {
  input: Array<ImportCustomerInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateHistoricalOrderDocumentsArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateHistoricalOrdersArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateInventoryItemDocumentsArgs = {
  input: Array<SetInventoryItemInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateItemsDocumentsArgs = {
  input: Array<ImportItemInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidatePriceGroupDocumentsArgs = {
  input: Array<ImportPriceGroupInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateProductionLotArgs = {
  input: CreateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateSiteLocationsDocumentsArgs = {
  input: Array<MergeSiteLocationInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateTaxAuthorityDocumentsArgs = {
  input: Array<ImportTaxAuthorityInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateTermsDocumentsArgs = {
  input: Array<ImportTermsInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVerifyPortalCustomDomainArgs = {
  input: VerifyPortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVerifyTenantSmtpConnectionArgs = {
  input: VerifyTenantSmtpConnectionInput;
};

/** A connection to a list of items. */
export type MyAssignedCountTasksConnection = {
  __typename?: 'MyAssignedCountTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAssignedCountTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MyCountTaskDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAssignedCountTasksEdge = {
  __typename?: 'MyAssignedCountTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MyCountTaskDocument;
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocument = {
  __typename?: 'MyCountTaskDocument';
  assignmentId: Scalars['String']['output'];
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  dueBy: Scalars['DateTime']['output'];
  expectedQty: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
  workerUserId: Scalars['String']['output'];
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocumentFilterInput = {
  and?: InputMaybe<Array<MyCountTaskDocumentFilterInput>>;
  assignmentId?: InputMaybe<StringOperationFilterInput>;
  binLocationId?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedQty?: InputMaybe<DecimalOperationFilterInput>;
  dueBy?: InputMaybe<DateTimeOperationFilterInput>;
  expectedQty?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MyCountTaskDocumentFilterInput>>;
  overrideQty?: InputMaybe<DecimalOperationFilterInput>;
  skipReason?: InputMaybe<StringOperationFilterInput>;
  skippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<CycleCountTaskStatusOperationFilterInput>;
  taskId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  varianceReasonCode?: InputMaybe<IntOperationFilterInput>;
  workerUserId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocumentSortInput = {
  assignmentId?: InputMaybe<SortEnumType>;
  binLocationId?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  completedQty?: InputMaybe<SortEnumType>;
  dueBy?: InputMaybe<SortEnumType>;
  expectedQty?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  overrideQty?: InputMaybe<SortEnumType>;
  skipReason?: InputMaybe<SortEnumType>;
  skippedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  varianceReasonCode?: InputMaybe<SortEnumType>;
  workerUserId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MyTaskAssignmentsConnection = {
  __typename?: 'MyTaskAssignmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyTaskAssignmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskAssignmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyTaskAssignmentsEdge = {
  __typename?: 'MyTaskAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskAssignmentDocument;
};

export type NextOrderNumberPayload = {
  __typename?: 'NextOrderNumberPayload';
  nextOrderNumber: Scalars['Long']['output'];
};

export enum NoteContext {
  General = 'GENERAL',
  Pull = 'PULL',
  Ship = 'SHIP'
}

export type NoteContextOperationFilterInput = {
  eq?: InputMaybe<NoteContext>;
  in?: InputMaybe<Array<NoteContext>>;
  neq?: InputMaybe<NoteContext>;
  nin?: InputMaybe<Array<NoteContext>>;
};

export type NoteData = {
  __typename?: 'NoteData';
  id: Scalars['String']['output'];
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type NoteDataInput = {
  id: Scalars['String']['input'];
  noteText: Scalars['String']['input'];
  submitDate: Scalars['DateTime']['input'];
  submittedBy: Scalars['String']['input'];
};

export type NullableOfCycleCountAssignmentStatusOperationFilterInput = {
  eq?: InputMaybe<CycleCountAssignmentStatus>;
  in?: InputMaybe<Array<InputMaybe<CycleCountAssignmentStatus>>>;
  neq?: InputMaybe<CycleCountAssignmentStatus>;
  nin?: InputMaybe<Array<InputMaybe<CycleCountAssignmentStatus>>>;
};

export type NullableOfDepositRequirementTypeOperationFilterInput = {
  eq?: InputMaybe<DepositRequirementType>;
  in?: InputMaybe<Array<InputMaybe<DepositRequirementType>>>;
  neq?: InputMaybe<DepositRequirementType>;
  nin?: InputMaybe<Array<InputMaybe<DepositRequirementType>>>;
};

export type NullableOfDimensionSourceOperationFilterInput = {
  eq?: InputMaybe<DimensionSource>;
  in?: InputMaybe<Array<InputMaybe<DimensionSource>>>;
  neq?: InputMaybe<DimensionSource>;
  nin?: InputMaybe<Array<InputMaybe<DimensionSource>>>;
};

export type NullableOfEmailSenderChannelOperationFilterInput = {
  eq?: InputMaybe<EmailSenderChannel>;
  in?: InputMaybe<Array<InputMaybe<EmailSenderChannel>>>;
  neq?: InputMaybe<EmailSenderChannel>;
  nin?: InputMaybe<Array<InputMaybe<EmailSenderChannel>>>;
};

export type NullableOfOrderEmailDocTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEmailDocType>;
  in?: InputMaybe<Array<InputMaybe<OrderEmailDocType>>>;
  neq?: InputMaybe<OrderEmailDocType>;
  nin?: InputMaybe<Array<InputMaybe<OrderEmailDocType>>>;
};

export type NullableOfShrinkTypeOperationFilterInput = {
  eq?: InputMaybe<ShrinkType>;
  in?: InputMaybe<Array<InputMaybe<ShrinkType>>>;
  neq?: InputMaybe<ShrinkType>;
  nin?: InputMaybe<Array<InputMaybe<ShrinkType>>>;
};

export type NullableOfTrialKindOperationFilterInput = {
  eq?: InputMaybe<TrialKind>;
  in?: InputMaybe<Array<InputMaybe<TrialKind>>>;
  neq?: InputMaybe<TrialKind>;
  nin?: InputMaybe<Array<InputMaybe<TrialKind>>>;
};

export type ObjectIdOperationFilterInput = {
  eq?: InputMaybe<Scalars['ObjectId']['input']>;
  gt?: InputMaybe<Scalars['ObjectId']['input']>;
  gte?: InputMaybe<Scalars['ObjectId']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  lt?: InputMaybe<Scalars['ObjectId']['input']>;
  lte?: InputMaybe<Scalars['ObjectId']['input']>;
  neq?: InputMaybe<Scalars['ObjectId']['input']>;
  ngt?: InputMaybe<Scalars['ObjectId']['input']>;
  ngte?: InputMaybe<Scalars['ObjectId']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  nlt?: InputMaybe<Scalars['ObjectId']['input']>;
  nlte?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type OnHandAdjustmentDocument = {
  __typename?: 'OnHandAdjustmentDocument';
  attemptCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  externalCustomerId: Scalars['String']['output'];
  externalItemId: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  processed?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  retailerId: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: OnHandAdjustmentType;
};

export type OnHandAdjustmentDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandAdjustmentDocumentFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  externalCustomerId?: InputMaybe<StringOperationFilterInput>;
  externalItemId?: InputMaybe<StringOperationFilterInput>;
  gtin?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OnHandAdjustmentDocumentFilterInput>>;
  processed?: InputMaybe<DateTimeOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  resultMessage?: InputMaybe<StringOperationFilterInput>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  traceId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<OnHandAdjustmentTypeOperationFilterInput>;
};

export type OnHandAdjustmentDocumentSortInput = {
  attemptCount?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  externalCustomerId?: InputMaybe<SortEnumType>;
  externalItemId?: InputMaybe<SortEnumType>;
  gtin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  processed?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  resultMessage?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  traceId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum OnHandAdjustmentType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Set = 'SET'
}

export type OnHandAdjustmentTypeOperationFilterInput = {
  eq?: InputMaybe<OnHandAdjustmentType>;
  in?: InputMaybe<Array<OnHandAdjustmentType>>;
  neq?: InputMaybe<OnHandAdjustmentType>;
  nin?: InputMaybe<Array<OnHandAdjustmentType>>;
};

export type OnHandProcessIterationDocument = {
  __typename?: 'OnHandProcessIterationDocument';
  description: Scalars['String']['output'];
  entity: EntityType;
  errorCount: Scalars['Long']['output'];
  failCount: Scalars['Long']['output'];
  fatalError: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  retailerId: Scalars['String']['output'];
  retailerProcessorEnd: Scalars['DateTime']['output'];
  retailerProcessorStart: Scalars['DateTime']['output'];
  retries: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Long']['output'];
  tenantId: Scalars['String']['output'];
  totalItems: Scalars['Long']['output'];
  totalMs: Scalars['Long']['output'];
};

export type OnHandProcessIterationDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandProcessIterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  errorCount?: InputMaybe<LongOperationFilterInput>;
  failCount?: InputMaybe<LongOperationFilterInput>;
  fatalError?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  or?: InputMaybe<Array<OnHandProcessIterationDocumentFilterInput>>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  retailerProcessorEnd?: InputMaybe<DateTimeOperationFilterInput>;
  retailerProcessorStart?: InputMaybe<DateTimeOperationFilterInput>;
  retries?: InputMaybe<IntOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  successCount?: InputMaybe<LongOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalItems?: InputMaybe<LongOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
};

export type OnHandProcessIterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  errorCount?: InputMaybe<SortEnumType>;
  failCount?: InputMaybe<SortEnumType>;
  fatalError?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerProcessorEnd?: InputMaybe<SortEnumType>;
  retailerProcessorStart?: InputMaybe<SortEnumType>;
  retries?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  successCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalItems?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
};

export type OnHandProcessPayload = {
  __typename?: 'OnHandProcessPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<OnHandProcessStateData>;
};

/** A connection to a list of items. */
export type OnHandProcessQueueConnection = {
  __typename?: 'OnHandProcessQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OnHandProcessQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandAdjustmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OnHandProcessQueueEdge = {
  __typename?: 'OnHandProcessQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandAdjustmentDocument;
};

export type OnHandProcessStateData = {
  __typename?: 'OnHandProcessStateData';
  attemptCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  externalCustomerId: Scalars['String']['output'];
  externalItemId: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  note: Scalars['String']['output'];
  processed?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  retailerId: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: OnHandAdjustmentType;
};

export type OnHandQueueIterationDocument = {
  __typename?: 'OnHandQueueIterationDocument';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  endItemId: Scalars['Long']['output'];
  entity: EntityType;
  errors: Array<Scalars['String']['output']>;
  failCount: Scalars['Long']['output'];
  id: Scalars['ObjectId']['output'];
  retailerId: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  startItemId: Scalars['Long']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  totalItems: Scalars['Long']['output'];
  totalMs: Scalars['Long']['output'];
};

export type OnHandQueueIterationDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandQueueIterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  endItemId?: InputMaybe<LongOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  errors?: InputMaybe<ListStringOperationFilterInput>;
  failCount?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  or?: InputMaybe<Array<OnHandQueueIterationDocumentFilterInput>>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  startItemId?: InputMaybe<LongOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalItems?: InputMaybe<LongOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
};

export type OnHandQueueIterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  endItemId?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  failCount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
  startItemId?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalItems?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
};

export type OptionOfDecimalFilterInput = {
  and?: InputMaybe<Array<OptionOfDecimalFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfDecimalFilterInput>>;
};

export type OptionOfInt32FilterInput = {
  and?: InputMaybe<Array<OptionOfInt32FilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfInt32FilterInput>>;
};

export type OptionOfLaborMetricFilterInput = {
  and?: InputMaybe<Array<OptionOfLaborMetricFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfLaborMetricFilterInput>>;
};

export type OptionOfMergeDevRevenueRungFilterInput = {
  and?: InputMaybe<Array<OptionOfMergeDevRevenueRungFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMergeDevRevenueRungFilterInput>>;
};

export type OptionOfMoneyDataFilterInput = {
  and?: InputMaybe<Array<OptionOfMoneyDataFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMoneyDataFilterInput>>;
};

export type OptionOfStringFilterInput = {
  and?: InputMaybe<Array<OptionOfStringFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfStringFilterInput>>;
};

/** Represents the aggregated address edit permissions for orders at the tenant, customer, and location levels. */
export type OrderAddressEditPermissions = {
  __typename?: 'OrderAddressEditPermissions';
  /**
   * Gets a value indicating whether billing addresses can be edited for orders.
   * This is an aggregate of tenant, customer, and location level permissions - all must be true for this to be true.
   */
  billingAddressEditable: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether location addresses can be edited for orders.
   * This is an aggregate of tenant, customer, and location level permissions - all must be true for this to be true.
   */
  locationAddressEditable: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type OrderAllocationsConnection = {
  __typename?: 'OrderAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AllocationItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderAllocationsEdge = {
  __typename?: 'OrderAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AllocationItemDocument;
};

export type OrderAssociationDataInput = {
  orderId: Scalars['String']['input'];
};

export type OrderCategoryVolumeDiscountData = {
  __typename?: 'OrderCategoryVolumeDiscountData';
  amount: Scalars['Decimal']['output'];
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  discountedQuantity: Scalars['Decimal']['output'];
  lines: Array<OrderCategoryVolumeLineData>;
  matchedThreshold: Scalars['Decimal']['output'];
  qualifyingQuantity: Scalars['Decimal']['output'];
  tierPrice?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's tier-derived volume discount as stored on OrdersDocument and exposed
 * to clients. Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and
 * nothing else, so a future field here can never break another type's backward compatibility.
 *
 * Mirrors the domain's OrderCategoryVolumeDiscount, with two boundary conversions: the
 * domain's Option<decimal> tier price becomes a nullable TierPrice
 * (null = the tier derives a different price per item, NOT a free tier), and dollar figures are
 * plain decimal rather than MoneyData because every amount on an order shares the
 * order's single currency, already carried on the document's money fields.
 */
export type OrderCategoryVolumeDiscountDocument = {
  __typename?: 'OrderCategoryVolumeDiscountDocument';
  /** This category's total discount in dollars — the sum of Lines. */
  amount: Scalars['Decimal']['output'];
  /**
   * The category's CODE — the same string a TargetType.Category price level stores in its
   * TargetId.
   */
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  /**
   * Quantity of the lines actually ASSIGNED to this category. Differs from
   * QualifyingQuantity only for an item belonging to several categories: such a
   * line counts toward every category's qualifying quantity but is PAID by exactly one.
   */
  discountedQuantity: Scalars['Decimal']['output'];
  /** Per-line receipts, for the explainer and for the tax base's exact apportionment. */
  lines: Array<OrderCategoryVolumeLineDocument>;
  /** The winning tier's threshold — the highest one ≤ the qualifying quantity. */
  matchedThreshold: Scalars['Decimal']['output'];
  /**
   * The order's total ELIGIBLE quantity in this category — the number qualified against the tier
   * thresholds, and the popover's "2,550 / 2,550" numerator. Lines excluded from the mechanism
   * (item-priced, overridden, non-discountable) are already omitted.
   */
  qualifyingQuantity: Scalars['Decimal']['output'];
  /**
   * The winning tier's unit price when every contributing line resolved the SAME one. null
   * when they did not; the exact per-line prices remain on Lines. Null rather than
   * 0 deliberately — a zero here would read as a free tier.
   */
  tierPrice?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's tier-derived volume discount as stored on OrdersDocument and exposed
 * to clients. Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and
 * nothing else, so a future field here can never break another type's backward compatibility.
 *
 * Mirrors the domain's OrderCategoryVolumeDiscount, with two boundary conversions: the
 * domain's Option<decimal> tier price becomes a nullable TierPrice
 * (null = the tier derives a different price per item, NOT a free tier), and dollar figures are
 * plain decimal rather than MoneyData because every amount on an order shares the
 * order's single currency, already carried on the document's money fields.
 */
export type OrderCategoryVolumeDiscountDocumentFilterInput = {
  /** This category's total discount in dollars — the sum of Lines. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderCategoryVolumeDiscountDocumentFilterInput>>;
  /**
   * The category's CODE — the same string a TargetType.Category price level stores in its
   * TargetId.
   */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Quantity of the lines actually ASSIGNED to this category. Differs from
   * QualifyingQuantity only for an item belonging to several categories: such a
   * line counts toward every category's qualifying quantity but is PAID by exactly one.
   */
  discountedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Per-line receipts, for the explainer and for the tax base's exact apportionment. */
  lines?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeLineDocumentFilterInput>;
  /** The winning tier's threshold — the highest one ≤ the qualifying quantity. */
  matchedThreshold?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeDiscountDocumentFilterInput>>;
  /**
   * The order's total ELIGIBLE quantity in this category — the number qualified against the tier
   * thresholds, and the popover's "2,550 / 2,550" numerator. Lines excluded from the mechanism
   * (item-priced, overridden, non-discountable) are already omitted.
   */
  qualifyingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The winning tier's unit price when every contributing line resolved the SAME one. null
   * when they did not; the exact per-line prices remain on Lines. Null rather than
   * 0 deliberately — a zero here would read as a free tier.
   */
  tierPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderCategoryVolumeLineData = {
  __typename?: 'OrderCategoryVolumeLineData';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  linePrice: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  tierPrice: Scalars['Decimal']['output'];
};

/**
 * One order line's contribution to a category's volume discount. Amount is
 * (LinePrice − TierPrice) × Quantity, floored at zero — a line already priced at or below
 * the tier contributes exactly 0, never a negative "discount".
 */
export type OrderCategoryVolumeLineDocument = {
  __typename?: 'OrderCategoryVolumeLineDocument';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  /** The unit price the line is charged, which this discount does NOT change. */
  linePrice: Scalars['Decimal']['output'];
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on.
   */
  quantity: Scalars['Decimal']['output'];
  tierPrice: Scalars['Decimal']['output'];
};

/**
 * One order line's contribution to a category's volume discount. Amount is
 * (LinePrice − TierPrice) × Quantity, floored at zero — a line already priced at or below
 * the tier contributes exactly 0, never a negative "discount".
 */
export type OrderCategoryVolumeLineDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderCategoryVolumeLineDocumentFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  /** The unit price the line is charged, which this discount does NOT change. */
  linePrice?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeLineDocumentFilterInput>>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on.
   */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  tierPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderCategoryVolumeProgressData = {
  __typename?: 'OrderCategoryVolumeProgressData';
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  matchedThreshold?: Maybe<Scalars['Decimal']['output']>;
  matchedTierPrice?: Maybe<Scalars['Decimal']['output']>;
  nextThreshold?: Maybe<Scalars['Decimal']['output']>;
  nextTierPrice?: Maybe<Scalars['Decimal']['output']>;
  qualified: Scalars['Boolean']['output'];
  qualifyingQuantity: Scalars['Decimal']['output'];
  quantityToNextThreshold?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's LIVE tier progress as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderCategoryVolumeProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> members become nullable decimal?.
 * null means the value does not exist (no tier reached, no tier ahead, or a tier whose price
 * differs per item) — never zero. A 0m here would read as a free tier or a reached target.
 */
export type OrderCategoryVolumeProgressDocument = {
  __typename?: 'OrderCategoryVolumeProgressDocument';
  /**
   * The category's CODE — the same string the matching OrderCategoryVolumeDiscountDocument
   * carries when one exists, and the same string a TargetType.Category price level stores in
   * its TargetId.
   */
  categoryCode: Scalars['String']['output'];
  /** Display label; equal to CategoryCode today. */
  categoryName: Scalars['String']['output'];
  /** The threshold of the tier currently reached; null when none is. */
  matchedThreshold?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The reached tier's unit price when it resolves one price across this order's items in the
   * category; null when it does not, and null when nothing is reached.
   */
  matchedTierPrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The lowest threshold STRICTLY above QualifyingQuantity — the progress
   * denominator ("2,550"). null when the highest configured tier is already reached, which is
   * the signal to render "top tier reached" instead of a progress bar.
   */
  nextThreshold?: Maybe<Scalars['Decimal']['output']>;
  /** The next tier's unit price — the "$0.99" in the enticement copy. */
  nextTierPrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Whether the order currently reaches any tier in this category. true does not imply a
   * discount row exists — a category can qualify and still save nothing, and such a category is
   * deliberately omitted from CategoryVolumeDiscounts.
   */
  qualified: Scalars['Boolean']['output'];
  /**
   * The order's total ELIGIBLE quantity in this category — the progress numerator ("1,700"). Already
   * excludes item-priced, overridden and non-discountable lines, because it is the very number the
   * discount qualified against. Zero is a real value, not a missing one.
   */
  qualifyingQuantity: Scalars['Decimal']['output'];
  /**
   * NextThreshold minus QualifyingQuantity, always positive
   * when present — the "850 more units". Server-computed so the remaining figure can never be derived
   * against a differently-filtered numerator.
   */
  quantityToNextThreshold?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's LIVE tier progress as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderCategoryVolumeProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> members become nullable decimal?.
 * null means the value does not exist (no tier reached, no tier ahead, or a tier whose price
 * differs per item) — never zero. A 0m here would read as a free tier or a reached target.
 */
export type OrderCategoryVolumeProgressDocumentFilterInput = {
  and?: InputMaybe<Array<OrderCategoryVolumeProgressDocumentFilterInput>>;
  /**
   * The category's CODE — the same string the matching OrderCategoryVolumeDiscountDocument
   * carries when one exists, and the same string a TargetType.Category price level stores in
   * its TargetId.
   */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  /** Display label; equal to CategoryCode today. */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /** The threshold of the tier currently reached; null when none is. */
  matchedThreshold?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The reached tier's unit price when it resolves one price across this order's items in the
   * category; null when it does not, and null when nothing is reached.
   */
  matchedTierPrice?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The lowest threshold STRICTLY above QualifyingQuantity — the progress
   * denominator ("2,550"). null when the highest configured tier is already reached, which is
   * the signal to render "top tier reached" instead of a progress bar.
   */
  nextThreshold?: InputMaybe<DecimalOperationFilterInput>;
  /** The next tier's unit price — the "$0.99" in the enticement copy. */
  nextTierPrice?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeProgressDocumentFilterInput>>;
  /**
   * Whether the order currently reaches any tier in this category. true does not imply a
   * discount row exists — a category can qualify and still save nothing, and such a category is
   * deliberately omitted from CategoryVolumeDiscounts.
   */
  qualified?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's total ELIGIBLE quantity in this category — the progress numerator ("1,700"). Already
   * excludes item-priced, overridden and non-discountable lines, because it is the very number the
   * discount qualified against. Zero is a real value, not a missing one.
   */
  qualifyingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * NextThreshold minus QualifyingQuantity, always positive
   * when present — the "850 more units". Server-computed so the remaining figure can never be derived
   * against a differently-filtered numerator.
   */
  quantityToNextThreshold?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderContactData = {
  __typename?: 'OrderContactData';
  emailAddress: EmailAddressData;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: PhoneNumberData;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type OrderContactDataInput = {
  emailAddress: EmailAddressDataInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: PhoneNumberDataInput;
  title: Scalars['String']['input'];
  type: ContactType;
};

/**
 * Read-model representation of a single order-level typed note. Document-only sub-record
 * (boundary type suffix not applied because the parent OrdersDocument is itself the
 * read-model boundary type). Context is persisted as its string name per the
 * document-enum discipline so stored notes stay human-readable and resilient to reordering.
 */
export type OrderContextNoteDocument = {
  __typename?: 'OrderContextNoteDocument';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single order-level typed note. Document-only sub-record
 * (boundary type suffix not applied because the parent OrdersDocument is itself the
 * read-model boundary type). Context is persisted as its string name per the
 * document-enum discipline so stored notes stay human-readable and resilient to reordering.
 */
export type OrderContextNoteDocumentFilterInput = {
  and?: InputMaybe<Array<OrderContextNoteDocumentFilterInput>>;
  context?: InputMaybe<NoteContextOperationFilterInput>;
  or?: InputMaybe<Array<OrderContextNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type OrderCorrectionData = {
  __typename?: 'OrderCorrectionData';
  counterpartOrderId: Scalars['String']['output'];
  linkedAt: Scalars['DateTime']['output'];
  newCustomerId: Scalars['String']['output'];
  originalCustomerId: Scalars['String']['output'];
  role: OrderCorrectionRole;
  sourceOrderId: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
};

export type OrderCorrectionDataFilterInput = {
  and?: InputMaybe<Array<OrderCorrectionDataFilterInput>>;
  counterpartOrderId?: InputMaybe<StringOperationFilterInput>;
  linkedAt?: InputMaybe<DateTimeOperationFilterInput>;
  newCustomerId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderCorrectionDataFilterInput>>;
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<OrderCorrectionRoleOperationFilterInput>;
  sourceOrderId?: InputMaybe<StringOperationFilterInput>;
  sourceOrderNumber?: InputMaybe<StringOperationFilterInput>;
};

export type OrderCorrectionDataSortInput = {
  counterpartOrderId?: InputMaybe<SortEnumType>;
  linkedAt?: InputMaybe<SortEnumType>;
  newCustomerId?: InputMaybe<SortEnumType>;
  originalCustomerId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  sourceOrderId?: InputMaybe<SortEnumType>;
  sourceOrderNumber?: InputMaybe<SortEnumType>;
};

export enum OrderCorrectionRole {
  NewCustomerOrder = 'NEW_CUSTOMER_ORDER',
  OriginalCustomerCredit = 'ORIGINAL_CUSTOMER_CREDIT',
  Unknown = 'UNKNOWN'
}

export type OrderCorrectionRoleOperationFilterInput = {
  eq?: InputMaybe<OrderCorrectionRole>;
  in?: InputMaybe<Array<OrderCorrectionRole>>;
  neq?: InputMaybe<OrderCorrectionRole>;
  nin?: InputMaybe<Array<OrderCorrectionRole>>;
};

export type OrderCustomerData = {
  __typename?: 'OrderCustomerData';
  billToAddress: AddressData;
  contact: OrderContactData;
  erpId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location: LocationData;
  name: Scalars['String']['output'];
};

export type OrderCustomerDataInput = {
  billToAddress: AddressDataInput;
  contact: OrderContactDataInput;
  erpId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  location: LocationDataInput;
  name: Scalars['String']['input'];
};

export type OrderDetailsPdfData = {
  __typename?: 'OrderDetailsPdfData';
  base64Pdf: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export type OrderDiscountComponentData = {
  __typename?: 'OrderDiscountComponentData';
  amount: Scalars['Decimal']['output'];
  categoryCode?: Maybe<Scalars['String']['output']>;
  kind: OrderDiscountComponentKind;
  label: Scalars['String']['output'];
};

export enum OrderDiscountComponentKind {
  CategoryVolume = 'CATEGORY_VOLUME',
  CustomerDefault = 'CUSTOMER_DEFAULT',
  Manual = 'MANUAL',
  OrderVolume = 'ORDER_VOLUME'
}

/** Result of the connect/disconnect mutations: the resulting status, or validation errors. */
export type OrderEaseConnectionPayload = {
  __typename?: 'OrderEaseConnectionPayload';
  errors?: Maybe<Array<ValidationError>>;
  integration?: Maybe<OrderEaseConnectionStatus>;
};

/**
 * Non-secret OrderEase connection status surfaced to the pwa. Returned by the
 * orderEaseIntegration query and embedded in the connect/disconnect payloads. Carries a MASKED
 * client key only — the client secret and refresh token never leave wsapi.
 */
export type OrderEaseConnectionStatus = {
  __typename?: 'OrderEaseConnectionStatus';
  connected: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedClientKey?: Maybe<Scalars['String']['output']>;
};

export enum OrderEmailDocType {
  Acknowledgment = 'ACKNOWLEDGMENT',
  Confirmation = 'CONFIRMATION'
}

export type OrderEmailDocTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEmailDocType>;
  in?: InputMaybe<Array<OrderEmailDocType>>;
  neq?: InputMaybe<OrderEmailDocType>;
  nin?: InputMaybe<Array<OrderEmailDocType>>;
};

/**
 * The order document type a recipient resolution is keyed against. Distinct from
 * OrderEmailDocType (which governs the tenant-authored
 * subject/body settings and treats invoice + credit-memo as one "Confirmation" config) — this enum keys
 * ONLY the doc-type -> ContactType recipient-routing table on
 * IOrderEmailRecipientResolver.
 */
export enum OrderEmailRecipientDocType {
  /**
   * The order-confirmation email. NOT wired to any call site — no production code passes this
   * member; the only exercise is OrderEmailRecipientResolverTests. Present so the doc-type
   * -> ContactType routing table on DocTypeContactTypes is provably a table
   * (a future doc-type is a new entry, not a new call-site edit) rather than a single-purpose if.
   *
   * wsapi does not resolve the confirmation recipient at all: it RECORDS a send that already
   * happened, via the updateConfirmationEmail mutation whose address is supplied by the
   * caller and stored verbatim on OrderState.ConfirmationEmails. Wiring the confirmation
   * cascade to this resolver means changing whoever picks that address upstream, not this file.
   * Until then this row is deliberately dead and its unit test pins the mapping only, not a
   * reachable behaviour.
   */
  Confirmation = 'CONFIRMATION',
  /**
   * The on-demand AP invoice email — the compose-dialog prefill, the Outlook draft flow, and the
   * personal-send no-recipients fallback (which transitively fixes the scheduled/system-sender
   * snapshot, since it seeds from the same prefill).
   */
  Invoice = 'INVOICE'
}

/**
 * MongoDB read-model document for a tenant's order-email recipient-routing overrides — the sparse
 * doc-type -> ContactType map that OrderEmailRecipientResolver consults before
 * falling back to its built-in default. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes. Mirrors
 * TenantRouteConfigDocument.
 */
export type OrderEmailRecipientRoutingDocument = {
  __typename?: 'OrderEmailRecipientRoutingDocument';
  entries: Array<OrderEmailRecipientRoutingEntryDocument>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

/** One doc-type -> contact-type routing entry, as exposed on the GraphQL contract. */
export type OrderEmailRecipientRoutingEntryData = {
  __typename?: 'OrderEmailRecipientRoutingEntryData';
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

/**
 * One sparse-map entry: a doc-type explicitly routed to a contact type. Absent from
 * Entries means "use the built-in default" — there
 * is no row for every doc-type, only the ones a tenant has configured.
 */
export type OrderEmailRecipientRoutingEntryDocument = {
  __typename?: 'OrderEmailRecipientRoutingEntryDocument';
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

export type OrderEmailRecipientRoutingPayload = {
  __typename?: 'OrderEmailRecipientRoutingPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderEmailRecipientRouting?: Maybe<OrderEmailRecipientRoutingStateData>;
};

/**
 * A tenant's order-email recipient routing: the sparse set of doc-types that have an explicit
 * contact-type override. A doc-type absent from Entries uses the built-in default recipient.
 */
export type OrderEmailRecipientRoutingStateData = {
  __typename?: 'OrderEmailRecipientRoutingStateData';
  entries: Array<OrderEmailRecipientRoutingEntryData>;
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OrderEmailSettingsConnection = {
  __typename?: 'OrderEmailSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderEmailSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderEmailSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** GraphQL data transfer record for a tenant's order-email settings. */
export type OrderEmailSettingsData = {
  __typename?: 'OrderEmailSettingsData';
  /** Gets the doc-type these settings apply to. */
  docType: OrderEmailDocType;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the authorable Handlebars email subject (tokens + inline {{#if}}), or null when
   * not authored. Rendered at send time; supports invoice-vs-credit branching on orderType.
   */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc: Scalars['Boolean']['output'];
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc: Scalars['Boolean']['output'];
  /** Gets the recipient list. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp when the settings were last set. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last set the settings. */
  updatedBy: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocument = {
  __typename?: 'OrderEmailSettingsDocument';
  /** Gets the doc-type these settings apply to. */
  docType: OrderEmailDocType;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc: Scalars['Boolean']['output'];
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc: Scalars['Boolean']['output'];
  /** Gets the recipient list. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp when the settings were last set. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last set the settings. */
  updatedBy: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<OrderEmailSettingsDocumentFilterInput>>;
  /** Gets the doc-type these settings apply to. */
  docType?: InputMaybe<OrderEmailDocTypeOperationFilterInput>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<StringOperationFilterInput>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderEmailSettingsDocumentFilterInput>>;
  /** Gets the recipient list. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the settings were last set. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who last set the settings. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocumentSortInput = {
  /** Gets the doc-type these settings apply to. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc?: InputMaybe<SortEnumType>;
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc?: InputMaybe<SortEnumType>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the settings were last set. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who last set the settings. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OrderEmailSettingsEdge = {
  __typename?: 'OrderEmailSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderEmailSettingsDocument;
};

/** Payload returned from order-email settings mutations. */
export type OrderEmailSettingsPayload = {
  __typename?: 'OrderEmailSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderEmailSettings?: Maybe<OrderEmailSettingsData>;
};

export enum OrderEntityType {
  MasterOrder = 'MASTER_ORDER',
  Order = 'ORDER'
}

export type OrderEntityTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEntityType>;
  in?: InputMaybe<Array<OrderEntityType>>;
  neq?: InputMaybe<OrderEntityType>;
  nin?: InputMaybe<Array<OrderEntityType>>;
};

export enum OrderExportTriggerStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Closed = 'CLOSED',
  Picked = 'PICKED',
  Shipped = 'SHIPPED'
}

/**
 * Compose-dialog defaults for a one-off order invoice email: the invoice recipients (see the
 * recipients field), the tenant's effective verified sender, and the authored confirmation
 * subject/body (raw Handlebars, or sensible raw defaults when not authored). All values are editable
 * by the client before sending.
 */
export type OrderInvoiceEmailDraftData = {
  __typename?: 'OrderInvoiceEmailDraftData';
  /**
   * Gets the raw (unrendered) Handlebars body: the tenant's authored confirmation body when set,
   * otherwise a simple raw default.
   */
  emailBody: Scalars['String']['output'];
  /**
   * Gets the raw (unrendered) Handlebars subject: the tenant's authored confirmation subject when
   * set, otherwise a raw default (Invoice {{orderNumber}}).
   */
  emailSubject: Scalars['String']['output'];
  /**
   * Gets the default recipients — every email of every AccountsPayable-typed contact on the
   * order's customer, falling back to the order's own contact email when the customer has none. Empty
   * only when neither exists (the client shows an empty field rather than erroring).
   */
  recipients: Array<Scalars['String']['output']>;
  /**
   * Gets the tenant's effective order invoice report id, or null when no invoice report is bound
   * (the client disables send with guidance).
   */
  reportId?: Maybe<Scalars['String']['output']>;
  /** Gets the effective sender (verified default, else earliest verified, else platform default). */
  sender: TenantEmailSenderData;
};

export type OrderLineItemDocument = {
  __typename?: 'OrderLineItemDocument';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  /**
   * The quantity of this line's item currently available across all locations and grades — the
   * per-line "Available Number". Resolved at read time from the live, ALLOCATION-AWARE
   * InventoryItem read model (InventoryItemDocument.AvailableQuantity, summed over
   * every location/grade row for the item), so it agrees with what the add-items dialog already
   * shows via GetInventoryItems. The sum is rounded to the nearest whole unit to preserve
   * this field's existing Int shape; see availableByLocation for the un-rounded,
   * per-location breakdown. A site-assigned caller only sees rows for their assigned locations
   * (same fail-closed scope as the add-items dialog). Returns 0 when the item has no
   * inventory rows in scope.
   */
  available: Scalars['Int']['output'];
  /**
   * The allocation-aware available quantity for this line's item, broken out per location/grade —
   * the un-summed rows behind available. Sourced from the same InventoryItemDocument
   * read model as the add-items dialog, via a batched DataLoader (no N+1 across order lines), and
   * scoped to the caller's assigned locations exactly as the dialog is. Returns an empty list when
   * the item has no inventory rows in scope.
   */
  availableByLocation: Array<ItemAvailabilityByLocationData>;
  /**
   * Per-authority tax captures for this line at the moment of the most recent
   * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated. Empty until
   * the first tax calculation runs, or when the kill switch was off at calc time.
   */
  capturedTaxAuthorities: Array<OrderLineTaxCaptureDocument>;
  /**
   * The line's assigned container code, or null when no container is assigned. Set on line
   * add (V1.LineItemsAdded) and updated via the bulk
   * WorkSuite.Domain.Orders.OrderEvents.V1.LineItemContainerCodeUpdated projection arm.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource: FulfillmentSource;
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /**
   * Whether the line counted as taxable at the moment of the most recent
   * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated. null
   * means the line has never been tax-calculated (legacy or freshly-added line). Mirrors
   * LineItem.IsTaxableInPricing tri-state: null (None) / true / false.
   */
  isTaxableInPricing?: Maybe<Scalars['Boolean']['output']>;
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteDocument>;
  orderId: Scalars['String']['output'];
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  royalty?: Maybe<LineItemRoyaltyDocument>;
  royaltyExempt: Scalars['Boolean']['output'];
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  /**
   * Computed pricing adjustment contributed by this line's upgrades, NOT persisted (resolved
   * at read time so it always reflects the stored upgrades and pricing fields). Shares the
   * OrderState.CalculateUpgradeAdjustment kernel with the order subtotal/total and taxable
   * base, so the adjustment surfaced here is exactly what the order total includes.
   */
  upgradeSubtotalAdjustment: Scalars['Decimal']['output'];
  /**
   * Per-line upgrade ("Value Add") snapshots frozen onto this line. Empty for lines added
   * before upgrades existed. Each snapshot is immutable with respect to the originating item.
   */
  upgrades: Array<OrderLineUpgradeDocument>;
};

export type OrderLineItemDocumentFilterInput = {
  acknowledgedQuantity?: InputMaybe<IntOperationFilterInput>;
  addedBy?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrderLineItemDocumentFilterInput>>;
  /**
   * Per-authority tax captures for this line at the moment of the most recent
   * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated. Empty until
   * the first tax calculation runs, or when the kill switch was off at calc time.
   */
  capturedTaxAuthorities?: InputMaybe<ListFilterInputTypeOfOrderLineTaxCaptureDocumentFilterInput>;
  /**
   * The line's assigned container code, or null when no container is assigned. Set on line
   * add (V1.LineItemsAdded) and updated via the bulk
   * WorkSuite.Domain.Orders.OrderEvents.V1.LineItemContainerCodeUpdated projection arm.
   */
  containerCode?: InputMaybe<StringOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  eachesQuantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource?: InputMaybe<FulfillmentSourceOperationFilterInput>;
  handlingUom?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the line counted as taxable at the moment of the most recent
   * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated. null
   * means the line has never been tax-calculated (legacy or freshly-added line). Mirrors
   * LineItem.IsTaxableInPricing tri-state: null (None) / true / false.
   */
  isTaxableInPricing?: InputMaybe<BooleanOperationFilterInput>;
  itemGroup?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<LineItemNoteDocumentFilterInput>;
  or?: InputMaybe<Array<OrderLineItemDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderedQuantity?: InputMaybe<IntOperationFilterInput>;
  overridePrice?: InputMaybe<DecimalOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  royalty?: InputMaybe<LineItemRoyaltyDocumentFilterInput>;
  royaltyExempt?: InputMaybe<BooleanOperationFilterInput>;
  shippedQuantity?: InputMaybe<IntOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-line upgrade ("Value Add") snapshots frozen onto this line. Empty for lines added
   * before upgrades existed. Each snapshot is immutable with respect to the originating item.
   */
  upgrades?: InputMaybe<ListFilterInputTypeOfOrderLineUpgradeDocumentFilterInput>;
};

export type OrderLineItemDocumentSortInput = {
  acknowledgedQuantity?: InputMaybe<SortEnumType>;
  addedBy?: InputMaybe<SortEnumType>;
  /**
   * The line's assigned container code, or null when no container is assigned. Set on line
   * add (V1.LineItemsAdded) and updated via the bulk
   * WorkSuite.Domain.Orders.OrderEvents.V1.LineItemContainerCodeUpdated projection arm.
   */
  containerCode?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  eachesQuantity?: InputMaybe<SortEnumType>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource?: InputMaybe<SortEnumType>;
  handlingUom?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * Whether the line counted as taxable at the moment of the most recent
   * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated. null
   * means the line has never been tax-calculated (legacy or freshly-added line). Mirrors
   * LineItem.IsTaxableInPricing tri-state: null (None) / true / false.
   */
  isTaxableInPricing?: InputMaybe<SortEnumType>;
  itemGroup?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: InputMaybe<SortEnumType>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: InputMaybe<SortEnumType>;
  lineItemId?: InputMaybe<SortEnumType>;
  lineNumber?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  note?: InputMaybe<LineItemNoteDocumentSortInput>;
  orderId?: InputMaybe<SortEnumType>;
  orderedQuantity?: InputMaybe<SortEnumType>;
  overridePrice?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  royalty?: InputMaybe<LineItemRoyaltyDocumentSortInput>;
  royaltyExempt?: InputMaybe<SortEnumType>;
  shippedQuantity?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrderLineItemsConnection = {
  __typename?: 'OrderLineItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderLineItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderLineItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderLineItemsEdge = {
  __typename?: 'OrderLineItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderLineItemDocument;
};

export type OrderLineTaxCaptureData = {
  __typename?: 'OrderLineTaxCaptureData';
  authorityId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateEffectiveDate: Scalars['DateTime']['output'];
  taxAmount: Scalars['Decimal']['output'];
};

/**
 * Per-authority capture of a line's tax contribution at the moment
 * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated was emitted.
 * Document-only sub-record.
 */
export type OrderLineTaxCaptureDocument = {
  __typename?: 'OrderLineTaxCaptureDocument';
  authorityId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  lineTax: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
};

/**
 * Per-authority capture of a line's tax contribution at the moment
 * WorkSuite.Domain.Orders.OrderEvents.V1.OrderTaxesCalculated was emitted.
 * Document-only sub-record.
 */
export type OrderLineTaxCaptureDocumentFilterInput = {
  and?: InputMaybe<Array<OrderLineTaxCaptureDocumentFilterInput>>;
  authorityId?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  lineTax?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderLineTaxCaptureDocumentFilterInput>>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderLineUpgradeCostDataInput = {
  laborMinutes?: InputMaybe<Scalars['Decimal']['input']>;
  laborTypeCode?: InputMaybe<Scalars['String']['input']>;
  materialCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderLineUpgradeData = {
  __typename?: 'OrderLineUpgradeData';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  lineItemUpgradeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricing: ItemUpgradePricing;
  source: OrderLineUpgradeSource;
  sourceItemUpgradeId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model snapshot of a per-line upgrade ("Value Add"). Document-only sub-record. Enums are
 * stored as strings per the pinned document-enum discipline so stored rows stay readable if
 * ordinals ever shift — Source via BsonRepresentation here, the nested
 * Pricing.Mode via the ItemUpgradePricing class map registered in
 * Mongo (the shared record cannot carry the attribute) — and are surfaced to
 * GraphQL by name; Option<T> optionals render as nullable GraphQL fields via the
 * registered Option converters.
 */
export type OrderLineUpgradeDocument = {
  __typename?: 'OrderLineUpgradeDocument';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  lineItemUpgradeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricing: ItemUpgradePricing;
  source: OrderLineUpgradeSource;
  sourceItemUpgradeId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model snapshot of a per-line upgrade ("Value Add"). Document-only sub-record. Enums are
 * stored as strings per the pinned document-enum discipline so stored rows stay readable if
 * ordinals ever shift — Source via BsonRepresentation here, the nested
 * Pricing.Mode via the ItemUpgradePricing class map registered in
 * Mongo (the shared record cannot carry the attribute) — and are surfaced to
 * GraphQL by name; Option<T> optionals render as nullable GraphQL fields via the
 * registered Option converters.
 */
export type OrderLineUpgradeDocumentFilterInput = {
  and?: InputMaybe<Array<OrderLineUpgradeDocumentFilterInput>>;
  categoryLabel?: InputMaybe<OptionOfStringFilterInput>;
  cost?: InputMaybe<ItemUpgradeCostFilterInput>;
  lineItemUpgradeId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderLineUpgradeDocumentFilterInput>>;
  pricing?: InputMaybe<ItemUpgradePricingFilterInput>;
  source?: InputMaybe<OrderLineUpgradeSourceOperationFilterInput>;
  sourceItemUpgradeId?: InputMaybe<OptionOfStringFilterInput>;
};

export type OrderLineUpgradePricingDataInput = {
  flatPrice?: InputMaybe<Scalars['Decimal']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  mode: PricingMode;
};

export enum OrderLineUpgradeSource {
  AddedByUser = 'ADDED_BY_USER',
  AdHoc = 'AD_HOC',
  ItemDefault = 'ITEM_DEFAULT'
}

export type OrderLineUpgradeSourceOperationFilterInput = {
  eq?: InputMaybe<OrderLineUpgradeSource>;
  in?: InputMaybe<Array<OrderLineUpgradeSource>>;
  neq?: InputMaybe<OrderLineUpgradeSource>;
  nin?: InputMaybe<Array<OrderLineUpgradeSource>>;
};

export type OrderLocationDocumentData = {
  __typename?: 'OrderLocationDocumentData';
  adGroup: Scalars['String']['output'];
  address: CreateAddress;
  allowOrderBillingAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  allowOrderLocationAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: Maybe<Scalars['String']['output']>;
  salesPeople: Array<SalesPersonData>;
  storeNumber: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
};

export type OrderLocationDocumentDataFilterInput = {
  adGroup?: InputMaybe<StringOperationFilterInput>;
  address?: InputMaybe<CreateAddressFilterInput>;
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrderLocationDocumentDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  globalLocationNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderLocationDocumentDataFilterInput>>;
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPeople?: InputMaybe<ListFilterInputTypeOfSalesPersonDataFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
};

export type OrderLocationDocumentDataSortInput = {
  adGroup?: InputMaybe<SortEnumType>;
  address?: InputMaybe<CreateAddressSortInput>;
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  globalLocationNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  poRequired?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
};

export type OrderNonDiscountableLineData = {
  __typename?: 'OrderNonDiscountableLineData';
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  lineSubtotal: Scalars['Decimal']['output'];
};

/**
 * One order line excluded from the customer/manual discount base because its item carries
 * Discountable = false. Document-only sub-record, used by this document and nothing else, so
 * a future field here can never break another type's backward compatibility.
 *
 * A receipt, NOT a discount: lineSubtotal is money the customer still owes in full.
 */
export type OrderNonDiscountableLineDocument = {
  __typename?: 'OrderNonDiscountableLineDocument';
  /** The item whose Discountable flag excluded the line. */
  itemId: Scalars['String']['output'];
  /** The order line this receipt belongs to. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber: Scalars['Int']['output'];
  /** The line's money as the order's subtotal counts it — the dollars withheld from the discount base. */
  lineSubtotal: Scalars['Decimal']['output'];
};

/**
 * One order line excluded from the customer/manual discount base because its item carries
 * Discountable = false. Document-only sub-record, used by this document and nothing else, so
 * a future field here can never break another type's backward compatibility.
 *
 * A receipt, NOT a discount: lineSubtotal is money the customer still owes in full.
 */
export type OrderNonDiscountableLineDocumentFilterInput = {
  and?: InputMaybe<Array<OrderNonDiscountableLineDocumentFilterInput>>;
  /** The item whose Discountable flag excluded the line. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The order line this receipt belongs to. */
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  /** The line's money as the order's subtotal counts it — the dollars withheld from the discount base. */
  lineSubtotal?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderNonDiscountableLineDocumentFilterInput>>;
};

export type OrderPayload = {
  __typename?: 'OrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
  warnings?: Maybe<Array<OverAllocationWarningData>>;
};

/**
 * A single entry on the order's payment ledger as stored on the read model. Document-only
 * sub-record (boundary type suffix not applied because the parent OrdersDocument is
 * itself the read-model boundary type).
 */
export type OrderPaymentEntryDocument = {
  __typename?: 'OrderPaymentEntryDocument';
  amount: MoneyData;
  externalRemoteId?: Maybe<Scalars['String']['output']>;
  kind: OrderPaymentKind;
  occurredAt: Scalars['DateTime']['output'];
  recordedBy?: Maybe<Scalars['String']['output']>;
  source: OrderPaymentSource;
};

/**
 * A single entry on the order's payment ledger as stored on the read model. Document-only
 * sub-record (boundary type suffix not applied because the parent OrdersDocument is
 * itself the read-model boundary type).
 */
export type OrderPaymentEntryDocumentFilterInput = {
  amount?: InputMaybe<MoneyDataFilterInput>;
  and?: InputMaybe<Array<OrderPaymentEntryDocumentFilterInput>>;
  externalRemoteId?: InputMaybe<OptionOfStringFilterInput>;
  kind?: InputMaybe<OrderPaymentKindOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderPaymentEntryDocumentFilterInput>>;
  recordedBy?: InputMaybe<OptionOfStringFilterInput>;
  source?: InputMaybe<OrderPaymentSourceOperationFilterInput>;
};

export enum OrderPaymentKind {
  Deposit = 'DEPOSIT',
  Payment = 'PAYMENT'
}

export type OrderPaymentKindOperationFilterInput = {
  eq?: InputMaybe<OrderPaymentKind>;
  in?: InputMaybe<Array<OrderPaymentKind>>;
  neq?: InputMaybe<OrderPaymentKind>;
  nin?: InputMaybe<Array<OrderPaymentKind>>;
};

export enum OrderPaymentSource {
  Imported = 'IMPORTED',
  Manual = 'MANUAL'
}

export type OrderPaymentSourceOperationFilterInput = {
  eq?: InputMaybe<OrderPaymentSource>;
  in?: InputMaybe<Array<OrderPaymentSource>>;
  neq?: InputMaybe<OrderPaymentSource>;
  nin?: InputMaybe<Array<OrderPaymentSource>>;
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocument = {
  __typename?: 'OrderProductionLotAllocationDocument';
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty: Scalars['Int']['output'];
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek: Scalars['DateTime']['output'];
  status: OrderProductionLotAllocationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocumentFilterInput = {
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<OrderProductionLotAllocationDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderProductionLotAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderLineId?: InputMaybe<StringOperationFilterInput>;
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty?: InputMaybe<IntOperationFilterInput>;
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty?: InputMaybe<IntOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<OrderProductionLotAllocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocumentSortInput = {
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderLineId?: InputMaybe<SortEnumType>;
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty?: InputMaybe<SortEnumType>;
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** GraphQL mutation payload for order-production-lot-allocation operations. */
export type OrderProductionLotAllocationPayload = {
  __typename?: 'OrderProductionLotAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderProductionLotAllocation?: Maybe<OrderProductionLotAllocationDocument>;
};

export enum OrderProductionLotAllocationStatus {
  Active = 'ACTIVE',
  Adjusted = 'ADJUSTED',
  Cancelled = 'CANCELLED',
  ProducedPegged = 'PRODUCED_PEGGED',
  ReadyHandedOff = 'READY_HANDED_OFF',
  Reserved = 'RESERVED'
}

export type OrderProductionLotAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<OrderProductionLotAllocationStatus>;
  in?: InputMaybe<Array<OrderProductionLotAllocationStatus>>;
  neq?: InputMaybe<OrderProductionLotAllocationStatus>;
  nin?: InputMaybe<Array<OrderProductionLotAllocationStatus>>;
};

/** A connection to a list of items. */
export type OrderProductionLotAllocationsConnection = {
  __typename?: 'OrderProductionLotAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderProductionLotAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderProductionLotAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderProductionLotAllocationsEdge = {
  __typename?: 'OrderProductionLotAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderProductionLotAllocationDocument;
};

export type OrderStateData = {
  __typename?: 'OrderStateData';
  acknowledgmentEmails: Array<ConfirmationEmailData>;
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  allocations: Array<AllocationItemData>;
  capturedTaxExemptNumber?: Maybe<Scalars['String']['output']>;
  carrier: Scalars['String']['output'];
  categoryVolumeDiscounts: Array<OrderCategoryVolumeDiscountData>;
  categoryVolumeProgress: Array<OrderCategoryVolumeProgressData>;
  confirmationEmails: Array<ConfirmationEmailData>;
  correction?: Maybe<OrderCorrectionData>;
  creditedFromOrderId?: Maybe<Scalars['String']['output']>;
  creditedFromOrderNumber?: Maybe<Scalars['String']['output']>;
  customer: OrderCustomerData;
  /**
   * The order's customer-type revenue GL account resolved to its Merge.dev account RemoteId,
   * for the outbound order export's customer-type routing tier. Null when the customer has no
   * type assigned, the type has no RevenueGlAccountId, or no MergeDevAccount matches — the
   * downstream wsapi-services handler owns the unmapped fallback (item income account ->
   * tenant default -> omit). Output-only field; every hop is tenant-scoped, so a batch cannot
   * leak one tenant's account into another.
   */
  customerTypeIncomeGlAccountRemoteId?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Decimal']['output'];
  discountBreakdown: Array<OrderDiscountComponentData>;
  discountPercent: Scalars['Decimal']['output'];
  discountReason: Scalars['String']['output'];
  /** Resolved boolean controlling whether the order-confirmation email should be sent. Cascade is order ?? location ?? customer (most-specific-wins). True means send; false means skip. */
  effectiveSendOrderEmails: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  expectedDeliveryDate: Scalars['DateTime']['output'];
  finalCredit?: Maybe<Scalars['Boolean']['output']>;
  freightAdjustedAt: Scalars['DateTime']['output'];
  freightAdjustedBy: Scalars['String']['output'];
  freightChargeAmount: Scalars['Decimal']['output'];
  freightChargeReason: Scalars['String']['output'];
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  initializationDate: Scalars['DateTime']['output'];
  lineItems: Array<LineItemData>;
  nonDiscountableLines: Array<OrderNonDiscountableLineData>;
  nonDiscountableSubtotal: Scalars['Decimal']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderVolumeDiscount?: Maybe<OrderVolumeDiscountData>;
  overrideTotal?: Maybe<Scalars['Decimal']['output']>;
  poNumber: Scalars['String']['output'];
  produceAllocate?: Maybe<Scalars['Boolean']['output']>;
  route: Scalars['String']['output'];
  salesPerson: Scalars['String']['output'];
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  shipFromLocation: ShipFromLocationData;
  shipFromSiteLocationId: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  signatureImage?: Maybe<SignatureImageData>;
  status: OrderStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  subtotal: Scalars['Decimal']['output'];
  syncAttempts: Array<SyncAttemptData>;
  taxAuthorityTotals: Array<OrderTaxAuthorityTotalData>;
  taxCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  taxCalculationEnabledAtCalc: Scalars['Boolean']['output'];
  taxableSubtotal: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  termsDiscountMessage?: Maybe<Scalars['String']['output']>;
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
  totalTax: Scalars['Decimal']['output'];
  type: OrderType;
};

export enum OrderStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Initialized = 'INITIALIZED',
  Open = 'OPEN',
  Picked = 'PICKED',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED',
  Synchronized = 'SYNCHRONIZED',
  SyncError = 'SYNC_ERROR'
}

export type OrderStatusOperationFilterInput = {
  eq?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  neq?: InputMaybe<OrderStatus>;
  nin?: InputMaybe<Array<OrderStatus>>;
};

export type OrderSubmitterData = {
  __typename?: 'OrderSubmitterData';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderSubmitterDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OrderTaxAuthorityTotalData = {
  __typename?: 'OrderTaxAuthorityTotalData';
  authorityId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateEffectiveDate: Scalars['DateTime']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxableBase: Scalars['Decimal']['output'];
};

/**
 * Per-authority order-level tax rollup captured on
 * OrderEvents.V1.OrderTaxesCalculated. Document-only sub-record (boundary type
 * suffix not applied because the parent OrdersDocument is itself the read-model
 * boundary type).
 */
export type OrderTaxAuthorityTotalDocument = {
  __typename?: 'OrderTaxAuthorityTotalDocument';
  authorityId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxableBase: Scalars['Decimal']['output'];
};

/**
 * Per-authority order-level tax rollup captured on
 * OrderEvents.V1.OrderTaxesCalculated. Document-only sub-record (boundary type
 * suffix not applied because the parent OrdersDocument is itself the read-model
 * boundary type).
 */
export type OrderTaxAuthorityTotalDocumentFilterInput = {
  and?: InputMaybe<Array<OrderTaxAuthorityTotalDocumentFilterInput>>;
  authorityId?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderTaxAuthorityTotalDocumentFilterInput>>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
  taxAmount?: InputMaybe<DecimalOperationFilterInput>;
  taxableBase?: InputMaybe<DecimalOperationFilterInput>;
};

export enum OrderType {
  Credit = 'CREDIT',
  MasterOrder = 'MASTER_ORDER',
  Po = 'PO',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type OrderTypeOperationFilterInput = {
  eq?: InputMaybe<OrderType>;
  in?: InputMaybe<Array<OrderType>>;
  neq?: InputMaybe<OrderType>;
  nin?: InputMaybe<Array<OrderType>>;
};

/**
 * The supervisor dashboard's reconciliation view for one order: the containers' raw scans summed by
 * resolved item and compared, line by line, against the order's CURRENT lines. This shape is
 * derived and never stored — orderVerificationComparison recomputes it on every read, so
 * it can never be stale if the order changes between a worker's container submit and the supervisor's
 * review. The only persisted record of a verification remains the V1.OrderVerified event the
 * supervisor's submitOrderVerification emits.
 *
 *  carries the per-order-line classification.  carries the
 * two kinds of rows that have no matching order line: scans whose barcode never resolved to an item
 * (blind-count unknowns) and resolved items that are not on the order.  is the
 * contributing-container roster for drill-in. The line/unknown rows are shaped so the PWA can map them
 * straight into submitOrderVerification input (the direct-mode defaults are these rows
 * unmodified): itemId + orderLineNumber + scannedQuantity mirror
 * SubmitVerifyLineData.
 */
export type OrderVerificationComparison = {
  __typename?: 'OrderVerificationComparison';
  /** The active containers that contributed scans to this comparison, for drill-in. */
  containers: Array<VerifyComparisonContainer>;
  /** Per-order-line comparison rows (one per current order line), ordered by line number. */
  lines: Array<OrderVerificationComparisonLine>;
  /** The order this comparison was computed for. */
  orderId: Scalars['String']['output'];
  /**
   * Rows with no matching order line: unresolved-barcode scans (ItemId
   * is None) and resolved items that are not on the order (ItemId present). Ordered by item id then barcode.
   */
  unknownItems: Array<VerifyComparisonUnknownItem>;
};

/**
 * One current order line compared against the summed scans for its item across every active container.
 * OrderedQuantity is the order line's ordered amount; ScannedQuantity is the
 * summed scan quantity for the line's ItemId across all contributing containers (0 when
 * nothing scanned for that item). Variance classifies the two.
 */
export type OrderVerificationComparisonLine = {
  __typename?: 'OrderVerificationComparisonLine';
  itemId: Scalars['String']['output'];
  orderLineNumber: Scalars['Int']['output'];
  orderedQuantity: Scalars['Int']['output'];
  scannedQuantity: Scalars['Int']['output'];
  variance: VerifyLineVariance;
};

export type OrderVolumeDiscountData = {
  __typename?: 'OrderVolumeDiscountData';
  amount: Scalars['Decimal']['output'];
  configuredValue: Scalars['Decimal']['output'];
  lines: Array<OrderVolumeLineData>;
  qualifyingSubtotal: Scalars['Decimal']['output'];
  qualifyingUnits: Scalars['Decimal']['output'];
  threshold: Scalars['Decimal']['output'];
  thresholdType: OrderVolumeThresholdType;
  uncappedAmount: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocument = {
  __typename?: 'OrderVolumeDiscountDocument';
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount: Scalars['Decimal']['output'];
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue: Scalars['Decimal']['output'];
  /** Per-line allocated shares, for the explainer and for the tax base's exact apportionment. */
  lines: Array<OrderVolumeLineDocument>;
  /**
   * The order's GROSS subtotal — before either volume component and before the manual discount. What a
   * dollar-threshold rule was qualified against.
   */
  qualifyingSubtotal: Scalars['Decimal']['output'];
  /**
   * The order's total units across EVERY line, regardless of category or discountability — the number
   * a unit-count rule was qualified against, and the explainer's "512 / 500 ✓" numerator.
   */
  qualifyingUnits: Scalars['Decimal']['output'];
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold: Scalars['Decimal']['output'];
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType: OrderVolumeThresholdType;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount: Scalars['Decimal']['output'];
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocumentFilterInput = {
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderVolumeDiscountDocumentFilterInput>>;
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Per-line allocated shares, for the explainer and for the tax base's exact apportionment. */
  lines?: InputMaybe<ListFilterInputTypeOfOrderVolumeLineDocumentFilterInput>;
  or?: InputMaybe<Array<OrderVolumeDiscountDocumentFilterInput>>;
  /**
   * The order's GROSS subtotal — before either volume component and before the manual discount. What a
   * dollar-threshold rule was qualified against.
   */
  qualifyingSubtotal?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The order's total units across EVERY line, regardless of category or discountability — the number
   * a unit-count rule was qualified against, and the explainer's "512 / 500 ✓" numerator.
   */
  qualifyingUnits?: InputMaybe<DecimalOperationFilterInput>;
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold?: InputMaybe<DecimalOperationFilterInput>;
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType?: InputMaybe<OrderVolumeThresholdTypeOperationFilterInput>;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount?: InputMaybe<DecimalOperationFilterInput>;
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType?: InputMaybe<OrderVolumeDiscountValueTypeOperationFilterInput>;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocumentSortInput = {
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount?: InputMaybe<SortEnumType>;
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue?: InputMaybe<SortEnumType>;
  /**
   * The order's GROSS subtotal — before either volume component and before the manual discount. What a
   * dollar-threshold rule was qualified against.
   */
  qualifyingSubtotal?: InputMaybe<SortEnumType>;
  /**
   * The order's total units across EVERY line, regardless of category or discountability — the number
   * a unit-count rule was qualified against, and the explainer's "512 / 500 ✓" numerator.
   */
  qualifyingUnits?: InputMaybe<SortEnumType>;
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold?: InputMaybe<SortEnumType>;
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType?: InputMaybe<SortEnumType>;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount?: InputMaybe<SortEnumType>;
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType?: InputMaybe<SortEnumType>;
};

export enum OrderVolumeDiscountValueType {
  FlatAmount = 'FLAT_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type OrderVolumeDiscountValueTypeOperationFilterInput = {
  eq?: InputMaybe<OrderVolumeDiscountValueType>;
  in?: InputMaybe<Array<OrderVolumeDiscountValueType>>;
  neq?: InputMaybe<OrderVolumeDiscountValueType>;
  nin?: InputMaybe<Array<OrderVolumeDiscountValueType>>;
};

export type OrderVolumeLineData = {
  __typename?: 'OrderVolumeLineData';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineBase: Scalars['Decimal']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocated share of the order-wide volume discount. Allocated from an order-level
 * figure (not derived per line), with the rounding residual distributed so Σ Amount equals
 * the component's Amount exactly.
 */
export type OrderVolumeLineDocument = {
  __typename?: 'OrderVolumeLineDocument';
  /** This line's allocated share of the component, in dollars. */
  amount: Scalars['Decimal']['output'];
  /** The item on that line. */
  itemId: Scalars['String']['output'];
  /** The line's subtotal net of its own category-volume discount — the allocation basis. */
  lineBase: Scalars['Decimal']['output'];
  /** The order line this receipt belongs to. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber: Scalars['Int']['output'];
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on and the unit-count threshold is summed on.
   */
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocated share of the order-wide volume discount. Allocated from an order-level
 * figure (not derived per line), with the rounding residual distributed so Σ Amount equals
 * the component's Amount exactly.
 */
export type OrderVolumeLineDocumentFilterInput = {
  /** This line's allocated share of the component, in dollars. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderVolumeLineDocumentFilterInput>>;
  /** The item on that line. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The line's subtotal net of its own category-volume discount — the allocation basis. */
  lineBase?: InputMaybe<DecimalOperationFilterInput>;
  /** The order line this receipt belongs to. */
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderVolumeLineDocumentFilterInput>>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on and the unit-count threshold is summed on.
   */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

export enum OrderVolumeThresholdType {
  OrderSubtotal = 'ORDER_SUBTOTAL',
  UnitCount = 'UNIT_COUNT'
}

export type OrderVolumeThresholdTypeOperationFilterInput = {
  eq?: InputMaybe<OrderVolumeThresholdType>;
  in?: InputMaybe<Array<OrderVolumeThresholdType>>;
  neq?: InputMaybe<OrderVolumeThresholdType>;
  nin?: InputMaybe<Array<OrderVolumeThresholdType>>;
};

/**
 * Trading-partner functional-acknowledgment (X12 997) state of a transaction.
 * Maps from the v3 transaction acknowledgmentStatus field
 * (NOT_ACKNOWLEDGED | ACCEPTED | REJECTED | OVERDUE | ACCEPTED_WITH_ERRORS).
 */
export enum OrderfulAcknowledgmentStatus {
  /** The partner accepted the transaction (997 code A). Wire value ACCEPTED. */
  Accepted = 'ACCEPTED',
  /** The partner accepted with errors (997 code E). Wire value ACCEPTED_WITH_ERRORS. */
  AcceptedWithErrors = 'ACCEPTED_WITH_ERRORS',
  /** No 997 has been received yet. Wire value NOT_ACKNOWLEDGED. */
  NotAcknowledged = 'NOT_ACKNOWLEDGED',
  /** No 997 arrived within the configured window. Wire value OVERDUE. */
  Overdue = 'OVERDUE',
  /** The partner rejected the transaction (997 code R). Wire value REJECTED. */
  Rejected = 'REJECTED'
}

/**
 * Orderful delivery lifecycle of a transaction to its destination.
 * Maps from the v3 transaction deliveryStatus field (PENDING | SENT | DELIVERED | FAILED).
 */
export enum OrderfulDeliveryStatus {
  /** The transaction reached its destination. Wire value DELIVERED. */
  Delivered = 'DELIVERED',
  /** Delivery failed. Wire value FAILED. */
  Failed = 'FAILED',
  /** Delivery has not started. Wire value PENDING. */
  Pending = 'PENDING',
  /** The transaction has been sent toward its destination. Wire value SENT. */
  Sent = 'SENT'
}

/**
 * One row of the cross-tenant admin overview returned by orderfulIntegrationConfigs. Single-use
 * query-output type — only that query returns it, so its shape can change without breaking shared
 * contracts. Key status is exposed as the derived ApiKeyPresent flag only; the
 * @keyvault(...) reference is never carried on this type, so the admin overview can never leak it.
 */
export type OrderfulIntegrationConfigAdminRow = {
  __typename?: 'OrderfulIntegrationConfigAdminRow';
  /** True when an Orderful API key reference is configured for the tenant — never the value itself. */
  apiKeyPresent: Scalars['Boolean']['output'];
  /** The tenant's own Organization ISA id(s); empty when none are configured. */
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  /** Tenant display name from our own registry; empty when the tenant has no registry entry. */
  tenantName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * MongoDB read-model document for a tenant's Orderful integration config. There is exactly one
 * document per tenant; Id equals the tenant id today, but use GetDocumentId for all
 * reads/writes so that invariant can evolve without breaking call sites. OrderfulApiKeySecretName
 * is a @keyvault(...) reference string only — never the secret value.
 */
export type OrderfulIntegrationConfigDocument = {
  __typename?: 'OrderfulIntegrationConfigDocument';
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  orderfulApiKeySecretName?: Maybe<Scalars['String']['output']>;
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderfulIntegrationConfigPayload = {
  __typename?: 'OrderfulIntegrationConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderfulIntegrationConfig?: Maybe<OrderfulIntegrationConfigStateData>;
};

export type OrderfulIntegrationConfigStateData = {
  __typename?: 'OrderfulIntegrationConfigStateData';
  orderfulApiKeySecretName?: Maybe<Scalars['String']['output']>;
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderfulIntegrationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

/** A single EDI control reference. Maps from an Orderful referenceIdentifiers[] entry. */
export type OrderfulReferenceIdentifierApiData = {
  __typename?: 'OrderfulReferenceIdentifierApiData';
  /** Owning party of the reference. Maps from owner. */
  owner: OrderfulReferenceOwner;
  /** Envelope level of the reference. Maps from type. */
  type: OrderfulReferenceIdentifierType;
  /** The control number / reference value. Maps from value. */
  value: Scalars['String']['output'];
};

/**
 * Which EDI envelope level a reference identifier belongs to.
 * Maps from the v3 transaction referenceIdentifiers[].type field
 * (INTERCHANGE | GROUP | TRANSACTION).
 */
export enum OrderfulReferenceIdentifierType {
  /** Functional-group-level (GS) control reference. Wire value GROUP. */
  Group = 'GROUP',
  /** Interchange-level (ISA) control reference. Wire value INTERCHANGE. */
  Interchange = 'INTERCHANGE',
  /** Transaction-set-level (ST) control reference. Wire value TRANSACTION. */
  Transaction = 'TRANSACTION'
}

/**
 * Which party owns a reference identifier.
 * Maps from the v3 transaction referenceIdentifiers[].owner field (SENDER | RECEIVER).
 */
export enum OrderfulReferenceOwner {
  /** The reference belongs to the receiver. Wire value RECEIVER. */
  Receiver = 'RECEIVER',
  /** The reference belongs to the sender. Wire value SENDER. */
  Sender = 'SENDER'
}

/**
 * Orderful environment stream a transaction belongs to.
 * Maps from the v3 transaction stream field (TEST | LIVE).
 */
export enum OrderfulStream {
  /** Production traffic. Wire value LIVE. */
  Live = 'LIVE',
  /** Test/sandbox traffic. Wire value TEST. */
  Test = 'TEST'
}

/**
 * Reference to a transaction's 997 acknowledgment. Maps from the Orderful transaction
 * acknowledgment object. Only the href is exposed; full acknowledgment detail lives at a
 * separate Orderful endpoint and is out of scope for this slice.
 */
export type OrderfulTransactionAcknowledgmentRefApiData = {
  __typename?: 'OrderfulTransactionAcknowledgmentRefApiData';
  /** URL of the acknowledgment endpoint. Maps from acknowledgment.href. */
  href: Scalars['String']['output'];
};

/**
 * An Orderful EDI transaction. Serves both the list (summary) and single (detail) surfaces: Orderful
 * returns the same object for GET /v3/transactions and GET /v3/transactions/{id}; the
 * only difference is that detail expands message.transactionSets with the parsed EDI content.
 * That parsed segment payload is partner- and transaction-type-specific and is intentionally NOT
 * modeled here — Message exposes its href only.
 */
export type OrderfulTransactionApiData = {
  __typename?: 'OrderfulTransactionApiData';
  /**
   * Reference to the 997 acknowledgment, present only once an acknowledgment exists.
   * Maps from acknowledgment.
   */
  acknowledgment?: Maybe<OrderfulTransactionAcknowledgmentRefApiData>;
  /** 997 acknowledgment lifecycle. Maps from acknowledgmentStatus. */
  acknowledgmentStatus: OrderfulAcknowledgmentStatus;
  /** Partner-facing business number, when present. Maps from businessNumber. */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** When Orderful created the transaction. Maps from createdAt. */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery lifecycle. Maps from deliveryStatus. */
  deliveryStatus: OrderfulDeliveryStatus;
  /**
   * Direction relative to the calling organization. DERIVED — not an Orderful field; computed by the
   * mapper from sender/receiver versus the organization's identity.
   */
  direction: OrderfulTransactionDirection;
  /** Canonical Orderful URL for this transaction. Maps from href. */
  href: Scalars['String']['output'];
  /** Orderful transaction id. Maps from id. */
  id: Scalars['String']['output'];
  /** When Orderful last updated the transaction. Maps from lastUpdatedAt. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Reference to the EDI message content. Maps from message. */
  message: OrderfulTransactionMessageApiData;
  /** Receiving party identity. Maps from receiver. */
  receiver: OrderfulTransactionPartyApiData;
  /**
   * Interchange/group/transaction control references. Maps from referenceIdentifiers;
   * empty when none are present.
   */
  referenceIdentifiers: Array<OrderfulReferenceIdentifierApiData>;
  /** Sending party identity. Maps from sender. */
  sender: OrderfulTransactionPartyApiData;
  /** Environment stream. Maps from stream. */
  stream: OrderfulStream;
  /** EDI transaction type (e.g. 850_PURCHASE_ORDER). Maps from type. */
  type: OrderfulTransactionTypeApiData;
  /** Validation lifecycle. Maps from validationStatus. */
  validationStatus: OrderfulValidationStatus;
  /** Orderful API version that produced this object (e.g. v3). Maps from version. */
  version: Scalars['String']['output'];
};

/**
 * Direction of a transaction relative to the calling Orderful organization. This is a DERIVED proxy
 * field — Orderful exposes no native direction field; the mapper (T5) computes it from whether the
 * organization is the transaction's sender (OUTBOUND) or receiver (INBOUND).
 */
export enum OrderfulTransactionDirection {
  /** The organization is the receiver of the transaction. */
  Inbound = 'INBOUND',
  /** The organization is the sender of the transaction. */
  Outbound = 'OUTBOUND'
}

/**
 * Reference to a transaction's EDI message content. Maps from the Orderful transaction message
 * object. Only the content href is exposed; the parsed transactionSets segment tree is
 * intentionally not modeled in this slice.
 */
export type OrderfulTransactionMessageApiData = {
  __typename?: 'OrderfulTransactionMessageApiData';
  /** URL of the message content endpoint. Maps from message.href. */
  href: Scalars['String']['output'];
};

/**
 * Identity of a transaction's sender or receiver. Maps from the Orderful transaction sender /
 * receiver objects. (The relationship endpoint uses a different identity shape and is modeled
 * separately by the relationships task.)
 */
export type OrderfulTransactionPartyApiData = {
  __typename?: 'OrderfulTransactionPartyApiData';
  /** Live interchange (ISA) id. Maps from isaId. */
  isaId: Scalars['String']['output'];
  /** Live interchange id qualifier. Maps from isaIdQualifier. */
  isaIdQualifier: Scalars['String']['output'];
  /** Human-readable party name, when present. Maps from name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Test interchange id, when configured. Maps from testIsaId. */
  testIsaId?: Maybe<Scalars['String']['output']>;
  /** Test interchange id qualifier, when configured. Maps from testIsaIdQualifier. */
  testIsaIdQualifier?: Maybe<Scalars['String']['output']>;
};

/** The EDI transaction type of a transaction. Maps from the Orderful type object. */
export type OrderfulTransactionTypeApiData = {
  __typename?: 'OrderfulTransactionTypeApiData';
  /** Orderful transaction-type name, e.g. 850_PURCHASE_ORDER. Maps from type.name. */
  name: Scalars['String']['output'];
};

/**
 * Filter input for the orderfulTransactions proxy query. Every field is optional; supplied
 * fields are forwarded to Orderful's GET /v3/transactions as the matching wire query
 * parameters. Input boundary type: optional fields use T? (HotChocolate input
 * deserialization has no Option<T> support).
 */
export type OrderfulTransactionsFilterInput = {
  /** 997 acknowledgment lifecycle filter. Forwarded as repeated acknowledgmentStatus parameters. */
  acknowledgmentStatuses?: InputMaybe<Array<OrderfulAcknowledgmentStatus>>;
  /**
   * Inclusive lower bound of the created-at range. Orderful only accepts a closed-open range, so
   * this requires CreatedAtTo.
   */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Exclusive upper bound of the created-at range. Orderful only accepts a closed-open range, so
   * this requires CreatedAtFrom.
   */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Delivery lifecycle filter. Forwarded as repeated deliveryStatus parameters. */
  deliveryStatuses?: InputMaybe<Array<OrderfulDeliveryStatus>>;
  /** Receiver interchange (ISA) ids, at most 5. Forwarded as repeated receiverIsaId parameters. */
  receiverIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sender interchange (ISA) ids, at most 5. Forwarded as repeated senderIsaId parameters. */
  senderIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Environment stream filter. Forwarded as the stream parameter. */
  stream?: InputMaybe<OrderfulStream>;
  /**
   * EDI transaction-type names (e.g. 850_PURCHASE_ORDER), at most 5. Forwarded as repeated
   * transactionType parameters.
   */
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Validation lifecycle filter. Forwarded as repeated validationStatus parameters. */
  validationStatuses?: InputMaybe<Array<OrderfulValidationStatus>>;
};

/**
 * One page of Orderful transactions plus the opaque cursors for the adjacent pages. Cursors are
 * extracted from the metadata.pagination.links URLs Orderful returns; None when no
 * adjacent page exists. Orderful caps a page at 100 transactions — there is no page-size knob.
 */
export type OrderfulTransactionsPageData = {
  __typename?: 'OrderfulTransactionsPageData';
  /**
   * Opaque cursor for the next page; pass back as the query's nextCursor argument.
   * None on the last page.
   */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /**
   * Opaque cursor for the previous page; pass back as the query's prevCursor argument.
   * None on the first page.
   */
  prevCursor?: Maybe<Scalars['String']['output']>;
  /** The transactions on this page, in the order Orderful returned them. */
  transactions: Array<OrderfulTransactionApiData>;
};

/**
 * Payload for the orderfulTransactions proxy query: the requested page on success, payload
 * errors (never exceptions) on any gating, transport, or mapping failure.
 */
export type OrderfulTransactionsPayload = {
  __typename?: 'OrderfulTransactionsPayload';
  errors?: Maybe<Array<ValidationError>>;
  transactionsPage?: Maybe<OrderfulTransactionsPageData>;
};

/**
 * Orderful validation lifecycle of a transaction's EDI content.
 * Maps from the v3 transaction validationStatus field (PROCESSING | VALID | INVALID).
 */
export enum OrderfulValidationStatus {
  /** The EDI content failed validation. Wire value INVALID. */
  Invalid = 'INVALID',
  /** Orderful is still validating the EDI content. Wire value PROCESSING. */
  Processing = 'PROCESSING',
  /** The EDI content passed validation. Wire value VALID. */
  Valid = 'VALID'
}

/** A connection to a list of items. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrdersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** MongoDB document representing an order. */
export type OrdersDocument = {
  __typename?: 'OrdersDocument';
  acknowledgmentEmail?: Maybe<ConfirmationEmailData>;
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  /**
   * Total of every ledger entry (payments and deposits) applied to the order. None until
   * the first payment event is projected; consumers treat None as zero.
   */
  amountPaid?: Maybe<MoneyData>;
  /**
   * Outstanding balance (order total less amount paid). None until the first payment event
   * is projected.
   */
  balance?: Maybe<MoneyData>;
  billingAddress: AddressData;
  /** The customer's tax-exempt number captured at the moment of the most recent calc, if any. */
  capturedTaxExemptNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: Maybe<Scalars['String']['output']>;
  /**
   * The order's tier-derived CATEGORY VOLUME discount components — one row per category whose
   * CategoryVolume tier the order's summed quantity qualified for. Feeds the PWA's "why this
   * price?" popover ("2,550/2,550 ✓, 6 contributing lines").
   *
   * A PLANE-2 component, distinct from DiscountAmount/DiscountPercent
   * (the manual/customer discount), which it never touches. The two stack in a fixed order:
   * line prices → category volume → customer/manual on the resulting net → tenant cap. Every
   * amount here is PLAIN DOLLARS, never a percent or fraction.
   *
   *
   * Empty means the order qualifies for no tier — which is also how the discount disappears when
   * a line is removed below a threshold. The projection $sets the whole array absolutely from the
   * event, so it can never drift from the OrderTotal stamped by the same event.
   */
  categoryVolumeDiscounts: Array<OrderCategoryVolumeDiscountDocument>;
  /**
   * LIVE per-category progress toward the order's CategoryVolume tiers — one row per category
   * that has a usable tier configured and at least one item on this order, present WHETHER OR NOT
   * any tier is currently reached.
   *
   * This is the field the "why this price?" popover reads to render the not-yet-reached case
   * ("1,700 / 2,550 — 850 more units to reach the $0.99 tier").
   * CategoryVolumeDiscounts cannot answer that question: it holds only categories that
   * already qualified AND saved money, so the category a customer is closest to buying into is
   * precisely the one missing from it.
   *
   *
   * Carries no money that any total is derived from — OrderTotal is unaffected by every
   * value here. QualifyingQuantity is the SAME number the discount qualified against,
   * produced by the same kernel pass under the same exclusions (item-priced, overridden and
   * non-discountable lines omitted), so a tier this promises is a tier the order will actually
   * receive.
   *
   *
   * Empty means no reachable tier is configured for anything on the order — NOT that the order
   * qualifies for nothing. An order that qualifies for nothing has rows here, each with
   * qualified: false. The projection $sets the whole array absolutely from the same
   * event that stamps the discounts, so the two can never be one mutation apart.
   */
  categoryVolumeProgress: Array<OrderCategoryVolumeProgressDocument>;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: Maybe<OrderCorrectionData>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: Maybe<Scalars['String']['output']>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /** Total of the order's Kind=Deposit ledger entries — the deposit received so far. Zero when no deposit has been recorded. */
  depositReceived: Scalars['Decimal']['output'];
  /** The deposit required before this order can be allocated, derived live from the customer's current deposit requirement applied to the order total (percent) or the flat amount. Zero when the customer requires no deposit. */
  depositRequired: Scalars['Decimal']['output'];
  /** True when the deposit received meets or exceeds the deposit required (always true for customers with no requirement). When false, the order is deposit-blocked from allocation. */
  depositSatisfied: Scalars['Boolean']['output'];
  discountAmount: MoneyData;
  /** Itemized discount components for this order — one labelled row per source (category volume, order volume, and the customer-default or manual discount), in the order they were applied. Rows worth $0 are omitted, so an order with no discount returns an empty list. The amounts sum to exactly the dollars the discounts took off the subtotal, i.e. to categoryVolumeDiscounts + orderVolumeDiscount + effectiveDiscountAmount. That is NOT (subtotal - orderTotal) in general: orderTotal additionally carries freight, royalty and tax, which are added after the discounts and are not discounts. The one exception is an order with overrideTotal set — an override replaces the total outright rather than discounting it, so the rows stay true about what the order qualified for but no longer reconcile against the computed totals. Every amount is plain dollars and non-negative: the amount that source took off, not a signed adjustment. */
  discountBreakdown: Array<OrderDiscountComponentData>;
  discountPercent: Scalars['Decimal']['output'];
  discountReason: Scalars['String']['output'];
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: Maybe<MoneyData>;
  /** The order's effective typed notes (Ship/Pull/General), resolved live at read time by inheritance: order override → ship-to customer location → customer. Each entry also reports which tier supplied the note (Order/Location/Customer, or None when no tier has one) so the UI can label the source. Always returns one entry per NoteContext. */
  effectiveNotes: Array<EffectiveOrderNote>;
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: Maybe<Scalars['String']['output']>;
  /** Resolved boolean controlling whether the order-confirmation email should be sent. Cascade is order ?? location ?? customer (most-specific-wins). True means send; false means skip. */
  effectiveSendOrderEmails: Scalars['Boolean']['output'];
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: Maybe<Scalars['String']['output']>;
  erpId?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  finalCredit: Scalars['Boolean']['output'];
  /** When the freight charge was last changed. */
  freightAdjustedAt: Scalars['DateTime']['output'];
  /** Who last changed the freight charge. */
  freightAdjustedBy: Scalars['String']['output'];
  /** The computed freight dollar amount. */
  freightChargeAmount?: Maybe<MoneyData>;
  /** The reason for the freight charge override. */
  freightChargeReason: Scalars['String']['output'];
  /** The freight charge type applied to this order. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine: Scalars['Boolean']['output'];
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  initializedDate: Scalars['DateTime']['output'];
  itemIds: Scalars['String']['output'];
  locations: OrderLocationDocumentData;
  /**
   * The order's lines whose item carries Discountable = false. NOT a discount component:
   * nothing here is taken off the order. It is the record of which dollars a discretionary
   * discount may not be taken FROM, and it is what explains a percentage that came out smaller
   * than the headline rate. Empty means every line on the order is discountable.
   */
  nonDiscountableLines: Array<OrderNonDiscountableLineDocument>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: Maybe<MoneyData>;
  numberOfLines: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  /**
   * Raw order-level typed notes (one current value per NoteContext), written by
   * the OrderEvents.V1.OrderNoteSet / OrderEvents.V1.OrderNoteCleared projection.
   * These are the order's own overrides only — effective-note inheritance (order → location →
   * customer) is resolved by a separate task. Empty until a note is set.
   */
  orderNotes: Array<OrderContextNoteDocument>;
  orderNumber: Scalars['String']['output'];
  orderStatus: OrderStatus;
  orderTotal: MoneyData;
  orderType: OrderType;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: Maybe<OrderVolumeDiscountDocument>;
  overrideTotal?: Maybe<MoneyData>;
  /**
   * The order's payment standing derived from amount paid versus order total. Defaults to
   * Unpaid for orders that have never had a payment applied.
   */
  paymentStatus: PaymentStatus;
  /**
   * The order's unified payment ledger — every payment and deposit applied to the order, in
   * apply order. Empty for orders that have never had a payment applied.
   */
  payments: Array<OrderPaymentEntryDocument>;
  poNumber: Scalars['String']['output'];
  produceAllocate: Scalars['Boolean']['output'];
  /**
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount: Scalars['Int']['output'];
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level aggregate royalty — the sum of every line's frozen royalty snapshot
   * (LineItem.Royalty.Amount), sourced from OrderState.CalculateRoyalty. A plain
   * dollar amount (not a percent/fraction). Changes only when lines are added or removed — a
   * line's royalty is frozen at add time and never re-derived by quantity/price edits. Null until
   * the order's first line-item event projects it; zero for a historical (GrowPoint) import,
   * which carries no per-line royalty snapshot to sum.
   */
  royalty?: Maybe<MoneyData>;
  salesPerson?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /** SiteLocationId of the site that services this order's SHIP-TO customer location, read live from the customer-location read model. Empty when the ship-to has no servicing site assigned, or when the order has no ship-to location. Exposed here so the order-email workers can resolve a ship-to's servicing site from the same orders query they already read. Distinct from shipFromSiteLocationId, which is the site the order ships FROM. */
  servicingSiteLocationId: Scalars['String']['output'];
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  signatureImage?: Maybe<SignatureImageData>;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, tax recalculation, and any line-item change (add, quantity
   * update, merge, removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: Maybe<MoneyData>;
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Per-authority order-level tax rollups captured from the most recent
   * OrderEvents.V1.OrderTaxesCalculated. Empty when the order has never been
   * tax-calculated, or when the tax-calculation kill switch was off at calc time.
   */
  taxAuthorityTotals: Array<OrderTaxAuthorityTotalDocument>;
  /** When the most recent OrderEvents.V1.OrderTaxesCalculated was emitted. */
  taxCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the tax-calculation kill switch was on at the moment of the most recent calc. */
  taxCalculationEnabledAtCalc: Scalars['Boolean']['output'];
  /** The discounted line subtotal that served as the tax base on the most recent calc. */
  taxableSubtotal: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: Maybe<Scalars['Int']['output']>;
  /** Customer-facing early-pay incentive message derived from the order's Terms snapshot, ExpectedDeliveryDate, and computed OrderTotal. Null when the order has no Terms assigned, or when DiscountDays/AccrueInterestPercentage is zero. */
  termsDiscountMessage?: Maybe<Scalars['String']['output']>;
  termsId?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: Maybe<Scalars['Int']['output']>;
  /** Total tax dollars captured from the most recent OrderEvents.V1.OrderTaxesCalculated. */
  totalTax: Scalars['Decimal']['output'];
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber: Scalars['Int']['output'];
};

/** MongoDB document representing an order. */
export type OrdersDocumentFilterInput = {
  acknowledgmentEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  adjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  adjustedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Total of every ledger entry (payments and deposits) applied to the order. None until
   * the first payment event is projected; consumers treat None as zero.
   */
  amountPaid?: InputMaybe<OptionOfMoneyDataFilterInput>;
  and?: InputMaybe<Array<OrdersDocumentFilterInput>>;
  /**
   * Outstanding balance (order total less amount paid). None until the first payment event
   * is projected.
   */
  balance?: InputMaybe<OptionOfMoneyDataFilterInput>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  /** The customer's tax-exempt number captured at the moment of the most recent calc, if any. */
  capturedTaxExemptNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  /**
   * The order's tier-derived CATEGORY VOLUME discount components — one row per category whose
   * CategoryVolume tier the order's summed quantity qualified for. Feeds the PWA's "why this
   * price?" popover ("2,550/2,550 ✓, 6 contributing lines").
   *
   * A PLANE-2 component, distinct from DiscountAmount/DiscountPercent
   * (the manual/customer discount), which it never touches. The two stack in a fixed order:
   * line prices → category volume → customer/manual on the resulting net → tenant cap. Every
   * amount here is PLAIN DOLLARS, never a percent or fraction.
   *
   *
   * Empty means the order qualifies for no tier — which is also how the discount disappears when
   * a line is removed below a threshold. The projection $sets the whole array absolutely from the
   * event, so it can never drift from the OrderTotal stamped by the same event.
   */
  categoryVolumeDiscounts?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeDiscountDocumentFilterInput>;
  /**
   * LIVE per-category progress toward the order's CategoryVolume tiers — one row per category
   * that has a usable tier configured and at least one item on this order, present WHETHER OR NOT
   * any tier is currently reached.
   *
   * This is the field the "why this price?" popover reads to render the not-yet-reached case
   * ("1,700 / 2,550 — 850 more units to reach the $0.99 tier").
   * CategoryVolumeDiscounts cannot answer that question: it holds only categories that
   * already qualified AND saved money, so the category a customer is closest to buying into is
   * precisely the one missing from it.
   *
   *
   * Carries no money that any total is derived from — OrderTotal is unaffected by every
   * value here. QualifyingQuantity is the SAME number the discount qualified against,
   * produced by the same kernel pass under the same exclusions (item-priced, overridden and
   * non-discountable lines omitted), so a tier this promises is a tier the order will actually
   * receive.
   *
   *
   * Empty means no reachable tier is configured for anything on the order — NOT that the order
   * qualifies for nothing. An order that qualifies for nothing has rows here, each with
   * qualified: false. The projection $sets the whole array absolutely from the same
   * event that stamps the discounts, so the two can never be one mutation apart.
   */
  categoryVolumeProgress?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeProgressDocumentFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: InputMaybe<OrderCorrectionDataFilterInput>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  discountAmount?: InputMaybe<MoneyDataFilterInput>;
  discountPercent?: InputMaybe<PercentValueOperationFilterInput>;
  discountReason?: InputMaybe<StringOperationFilterInput>;
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: InputMaybe<MoneyDataFilterInput>;
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  finalCredit?: InputMaybe<BooleanOperationFilterInput>;
  /** When the freight charge was last changed. */
  freightAdjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who last changed the freight charge. */
  freightAdjustedBy?: InputMaybe<StringOperationFilterInput>;
  /** The computed freight dollar amount. */
  freightChargeAmount?: InputMaybe<MoneyDataFilterInput>;
  /** The reason for the freight charge override. */
  freightChargeReason?: InputMaybe<StringOperationFilterInput>;
  /** The freight charge type applied to this order. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine?: InputMaybe<BooleanOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  initializedDate?: InputMaybe<DateTimeOperationFilterInput>;
  itemIds?: InputMaybe<StringOperationFilterInput>;
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  /**
   * The order's lines whose item carries Discountable = false. NOT a discount component:
   * nothing here is taken off the order. It is the record of which dollars a discretionary
   * discount may not be taken FROM, and it is what explains a percentage that came out smaller
   * than the headline rate. Empty means every line on the order is discountable.
   */
  nonDiscountableLines?: InputMaybe<ListFilterInputTypeOfOrderNonDiscountableLineDocumentFilterInput>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: InputMaybe<MoneyDataFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrdersDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Raw order-level typed notes (one current value per NoteContext), written by
   * the OrderEvents.V1.OrderNoteSet / OrderEvents.V1.OrderNoteCleared projection.
   * These are the order's own overrides only — effective-note inheritance (order → location →
   * customer) is resolved by a separate task. Empty until a note is set.
   */
  orderNotes?: InputMaybe<ListFilterInputTypeOfOrderContextNoteDocumentFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  orderStatus?: InputMaybe<OrderStatusOperationFilterInput>;
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: InputMaybe<OrderVolumeDiscountDocumentFilterInput>;
  overrideTotal?: InputMaybe<MoneyDataFilterInput>;
  /**
   * The order's payment standing derived from amount paid versus order total. Defaults to
   * Unpaid for orders that have never had a payment applied.
   */
  paymentStatus?: InputMaybe<PaymentStatusOperationFilterInput>;
  /**
   * The order's unified payment ledger — every payment and deposit applied to the order, in
   * apply order. Empty for orders that have never had a payment applied.
   */
  payments?: InputMaybe<ListFilterInputTypeOfOrderPaymentEntryDocumentFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  produceAllocate?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName?: InputMaybe<StringOperationFilterInput>;
  shippedDate?: InputMaybe<DateTimeOperationFilterInput>;
  signatureImage?: InputMaybe<SignatureImageDataFilterInput>;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, tax recalculation, and any line-item change (add, quantity
   * update, merge, removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: InputMaybe<MoneyDataFilterInput>;
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Per-authority order-level tax rollups captured from the most recent
   * OrderEvents.V1.OrderTaxesCalculated. Empty when the order has never been
   * tax-calculated, or when the tax-calculation kill switch was off at calc time.
   */
  taxAuthorityTotals?: InputMaybe<ListFilterInputTypeOfOrderTaxAuthorityTotalDocumentFilterInput>;
  /** When the most recent OrderEvents.V1.OrderTaxesCalculated was emitted. */
  taxCalculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether the tax-calculation kill switch was on at the moment of the most recent calc. */
  taxCalculationEnabledAtCalc?: InputMaybe<BooleanOperationFilterInput>;
  /** The discounted line subtotal that served as the tax base on the most recent calc. */
  taxableSubtotal?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: InputMaybe<IntOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: InputMaybe<IntOperationFilterInput>;
  /** Total tax dollars captured from the most recent OrderEvents.V1.OrderTaxesCalculated. */
  totalTax?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber?: InputMaybe<IntOperationFilterInput>;
};

/** MongoDB document representing an order. */
export type OrdersDocumentSortInput = {
  acknowledgmentEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  adjustedAt?: InputMaybe<SortEnumType>;
  adjustedBy?: InputMaybe<SortEnumType>;
  /**
   * Total of every ledger entry (payments and deposits) applied to the order. None until
   * the first payment event is projected; consumers treat None as zero.
   */
  amountPaid?: InputMaybe<SortEnumType>;
  /**
   * Outstanding balance (order total less amount paid). None until the first payment event
   * is projected.
   */
  balance?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressDataSortInput>;
  /** The customer's tax-exempt number captured at the moment of the most recent calc, if any. */
  capturedTaxExemptNumber?: InputMaybe<SortEnumType>;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: InputMaybe<SortEnumType>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: InputMaybe<OrderCorrectionDataSortInput>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: InputMaybe<SortEnumType>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  discountAmount?: InputMaybe<MoneyDataSortInput>;
  discountPercent?: InputMaybe<SortEnumType>;
  discountReason?: InputMaybe<SortEnumType>;
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: InputMaybe<MoneyDataSortInput>;
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: InputMaybe<SortEnumType>;
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  finalCredit?: InputMaybe<SortEnumType>;
  /** When the freight charge was last changed. */
  freightAdjustedAt?: InputMaybe<SortEnumType>;
  /** Who last changed the freight charge. */
  freightAdjustedBy?: InputMaybe<SortEnumType>;
  /** The computed freight dollar amount. */
  freightChargeAmount?: InputMaybe<MoneyDataSortInput>;
  /** The reason for the freight charge override. */
  freightChargeReason?: InputMaybe<SortEnumType>;
  /** The freight charge type applied to this order. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  initializedDate?: InputMaybe<SortEnumType>;
  itemIds?: InputMaybe<SortEnumType>;
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: InputMaybe<MoneyDataSortInput>;
  numberOfLines?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  orderStatus?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: InputMaybe<OrderVolumeDiscountDocumentSortInput>;
  overrideTotal?: InputMaybe<MoneyDataSortInput>;
  /**
   * The order's payment standing derived from amount paid versus order total. Defaults to
   * Unpaid for orders that have never had a payment applied.
   */
  paymentStatus?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  produceAllocate?: InputMaybe<SortEnumType>;
  /**
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount?: InputMaybe<SortEnumType>;
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName?: InputMaybe<SortEnumType>;
  shippedDate?: InputMaybe<SortEnumType>;
  signatureImage?: InputMaybe<SignatureImageDataSortInput>;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: InputMaybe<SortEnumType>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, tax recalculation, and any line-item change (add, quantity
   * update, merge, removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: InputMaybe<MoneyDataSortInput>;
  syncDate?: InputMaybe<SortEnumType>;
  /** When the most recent OrderEvents.V1.OrderTaxesCalculated was emitted. */
  taxCalculatedAt?: InputMaybe<SortEnumType>;
  /** Whether the tax-calculation kill switch was on at the moment of the most recent calc. */
  taxCalculationEnabledAtCalc?: InputMaybe<SortEnumType>;
  /** The discounted line subtotal that served as the tax base on the most recent calc. */
  taxableSubtotal?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: InputMaybe<SortEnumType>;
  /** Total tax dollars captured from the most recent OrderEvents.V1.OrderTaxesCalculated. */
  totalTax?: InputMaybe<SortEnumType>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrdersDocument;
};

export enum OrganicReceiveMode {
  Block = 'BLOCK',
  Warn = 'WARN'
}

export type OrganicReceiveModeOperationFilterInput = {
  eq?: InputMaybe<OrganicReceiveMode>;
  in?: InputMaybe<Array<OrganicReceiveMode>>;
  neq?: InputMaybe<OrganicReceiveMode>;
  nin?: InputMaybe<Array<OrganicReceiveMode>>;
};

/**
 * Soft per-item warning surfaced by ReceiveVendorPurchaseOrderItems when the tenant
 * has OrganicReceiveMode = Warn and an organic item arrives with a missing
 * OrganicLotCode. The receive succeeds; the warning is shown to the operator.
 */
export type OrganicReceiveWarning = {
  __typename?: 'OrganicReceiveWarning';
  itemId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum OutboundDetailLevel {
  ItemLevelDetail = 'ITEM_LEVEL_DETAIL',
  SummaryOnly = 'SUMMARY_ONLY'
}

/**
 * A permitted-but-flagged over-allocation on a single inventory key (item + location + grade).
 * Mirrors the domain over-allocation warning: availableQuantity is the resulting available
 * (on-hand minus allocated) AFTER the allocation and is negative when over-allocated — its
 * magnitude is the shortfall against requestedQuantity.
 */
export type OverAllocationWarningData = {
  __typename?: 'OverAllocationWarningData';
  availableQuantity: Scalars['Decimal']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  requestedQuantity: Scalars['Decimal']['output'];
};

export type OverheadRateHistoryStateData = {
  __typename?: 'OverheadRateHistoryStateData';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  subLocationId?: Maybe<Scalars['String']['output']>;
};

export type OverheadRateStateData = {
  __typename?: 'OverheadRateStateData';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Canonical kind classification for a historical order-quantity override entry. The owning
 * document property is annotated [BsonRepresentation(BsonType.String)], so values are
 * persisted as BSON strings by member name; explicit integer assignments are retained for
 * JSON-side stability and future-safe migrations. Do not insert, reorder, or reassign existing
 * members. The Reverted name deliberately differs from the originating event class
 * OrderQuantityOverrideUndone because the product copy for the history surface uses
 * "Reverted".
 */
export enum OverrideKind {
  /** Originated from OrderQuantityAutoAllocated (T0b). */
  AutoAllocate = 'AUTO_ALLOCATE',
  /** Originated from OrderQuantityAdded — a bulk additive adjustment. */
  BulkAdd = 'BULK_ADD',
  /** Originated from OrderQuantitySubtracted — a bulk subtractive adjustment. */
  BulkSubtract = 'BULK_SUBTRACT',
  /** Originated from OrderQuantityReplaced — a direct manual edit of the order quantity. */
  ManualEdit = 'MANUAL_EDIT',
  /** Originated from OrderQuantityOverrideUndone. Product copy: "Reverted". */
  Reverted = 'REVERTED',
  /** Originated from OrderQuantityRoundedToFullCart. */
  RoundedToFullCart = 'ROUNDED_TO_FULL_CART',
  /** Originated from OrderQuantitySetToAchievable. */
  SetToAchievable = 'SET_TO_ACHIEVABLE',
  /** Originated from OrderQuantitySetToDemand. */
  SetToDemand = 'SET_TO_DEMAND',
  /** Originated from OrderQuantitySetToTargetWeeksOfSupply. */
  SetToTargetWeeksOfSupply = 'SET_TO_TARGET_WEEKS_OF_SUPPLY'
}

export type OverrideKindOperationFilterInput = {
  eq?: InputMaybe<OverrideKind>;
  in?: InputMaybe<Array<OverrideKind>>;
  neq?: InputMaybe<OverrideKind>;
  nin?: InputMaybe<Array<OverrideKind>>;
};

export type OverrideOrderLineUpgradePricingInput = {
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  pricing: OrderLineUpgradePricingDataInput;
};

export type OverrideProducedQuantityDataInput = {
  newProducedLocationId?: InputMaybe<Scalars['String']['input']>;
  newProducedQuantity: Scalars['Decimal']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobLocationDataInput = {
  newLocationId: Scalars['String']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobQuantityDataInput = {
  newQuantity: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobWeekReadyDataInput = {
  newWeekReadyDate: Scalars['DateTime']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobWeekStartDataInput = {
  newWeekStartDate: Scalars['DateTime']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobYieldDataInput = {
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
  yieldPercentage: Scalars['Decimal']['input'];
};

export type OverrideProductionLotCustomerDataInput = {
  newCustomerId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionLotQuantityDataInput = {
  newQuantity: Scalars['Int']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideRestockSessionOrderQuantitiesInput = {
  items: Array<RestockOrderQuantityOverrideItemDataInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['String']['input'];
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  type: RestockOverrideType;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentChildRelationship = {
  __typename?: 'ParentChildRelationship';
  parent: SiteLocationType;
  validChildren: Array<SiteLocationType>;
};

/**
 * GraphQL input for patching a single tenant. Null fields are not changed.
 * TrialExpirationDate sets the trial expiry; ClearTrialExpirationDate: true
 * removes it (the two are mutually exclusive — null on a patch input means "unchanged",
 * so clearing needs the explicit flag). TrialKind, TrialLimits and
 * TrialDataDeletedDate follow the same set/clear convention.
 */
export type PatchAdminTenantDataInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialDataDeletedDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialLimits?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['String']['input'];
  finalCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  poNumberMaxLength?: InputMaybe<Scalars['Int']['input']>;
  produceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restockCalcEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restockCalcMaxStalenessHours?: InputMaybe<Scalars['Int']['input']>;
  restockCalcRefreshHours?: InputMaybe<Scalars['Int']['input']>;
  restockCalcStrategyKey?: InputMaybe<Scalars['String']['input']>;
  trialDataDeletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialKind?: InputMaybe<TrialKind>;
  trialLimits?: InputMaybe<TrialLimitsDataInput>;
  unitConfig?: InputMaybe<TenantUnitConfigDataInput>;
  useErpPricing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** GraphQL input for batch-patching multiple tenants in a single request. */
export type PatchBatchAdminTenantInput = {
  tenants: Array<PatchAdminTenantDataInput>;
};

export type PatchItemInput = {
  categories?: InputMaybe<Array<CategoryDataInput>>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PauseCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

export enum PaymentStatus {
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type PaymentStatusOperationFilterInput = {
  eq?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  neq?: InputMaybe<PaymentStatus>;
  nin?: InputMaybe<Array<PaymentStatus>>;
};

/** A connection to a list of items. */
export type PendingErpWriteBacksConnection = {
  __typename?: 'PendingErpWriteBacksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PendingErpWriteBacksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpWriteBackDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PendingErpWriteBacksEdge = {
  __typename?: 'PendingErpWriteBacksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpWriteBackDocument;
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocument = {
  __typename?: 'PendingTransferOrderDocument';
  /** Timestamp from the originating create event. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the movement order. */
  createdBy: Scalars['String']['output'];
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate: Scalars['DateTime']['output'];
  /** Source site (where stock is shipping from). */
  fromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName: Scalars['String']['output'];
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived: Scalars['Boolean']['output'];
  /** Per-line snapshot from the most recent create-or-ship event. */
  lines: Array<PendingTransferOrderLineDocument>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId: Scalars['String']['output'];
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: Maybe<Scalars['String']['output']>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status: MovementOrderStatus;
  /** Owning tenant. */
  tenantId: Scalars['String']['output'];
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName: Scalars['String']['output'];
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber: Scalars['String']['output'];
  /** Timestamp of the most recent event that updated this document. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocumentFilterInput = {
  and?: InputMaybe<Array<PendingTransferOrderDocumentFilterInput>>;
  /** Timestamp from the originating create event. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Source site (where stock is shipping from). */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived?: InputMaybe<BooleanOperationFilterInput>;
  /** Per-line snapshot from the most recent create-or-ship event. */
  lines?: InputMaybe<ListFilterInputTypeOfPendingTransferOrderLineDocumentFilterInput>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PendingTransferOrderDocumentFilterInput>>;
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status?: InputMaybe<MovementOrderStatusOperationFilterInput>;
  /** Owning tenant. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Timestamp of the most recent event that updated this document. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocumentSortInput = {
  /** Timestamp from the originating create event. */
  createdAt?: InputMaybe<SortEnumType>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate?: InputMaybe<SortEnumType>;
  /** Source site (where stock is shipping from). */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived?: InputMaybe<SortEnumType>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<SortEnumType>;
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: InputMaybe<SortEnumType>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: InputMaybe<SortEnumType>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: InputMaybe<SortEnumType>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: InputMaybe<SortEnumType>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status?: InputMaybe<SortEnumType>;
  /** Owning tenant. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber?: InputMaybe<SortEnumType>;
  /** Timestamp of the most recent event that updated this document. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/**
 * Per-line snapshot persisted on PendingTransferOrderDocument.Lines.
 * Field-for-field mirror of MovementOrderEvents.V1.MovementOrderLineEventRecord
 * so the projection only has to translate the language-ext Option{T}
 * shape that is registered for Mongo serialization, plus denormalized
 * MaterialItemName / MaterialItemErpId resolved by the mutation
 * layer at command time and carried on the event payload (fail-soft to empty string when the
 * MaterialItem reference could not be resolved).
 */
export type PendingTransferOrderLineDocument = {
  __typename?: 'PendingTransferOrderLineDocument';
  /** Locked-at-receive-time organic flag (false until receipt — included for snapshot completeness). */
  isOrganicAtReceive: Scalars['Boolean']['output'];
  /** Stable line-item id (matches the event's LineItemId). */
  lineItemId: Scalars['String']['output'];
  /**
   * Denormalized MaterialItem.ErpId resolved by the mutation layer at command time
   * and carried on the event payload. Empty string under the same fail-soft contract as
   * MaterialItemName.
   */
  materialItemErpId: Scalars['String']['output'];
  /** MaterialItem moving on this line. */
  materialItemId: Scalars['String']['output'];
  /**
   * Denormalized MaterialItem.Name resolved by the mutation layer at command time
   * (MovementOrderMutation.ResolveMaterialEnrichment) and carried on the event
   * payload; written through by the projection with no external reads (discipline accaf08f).
   * Empty string when the MaterialItem reference could not be resolved at command time.
   */
  materialItemName: Scalars['String']['output'];
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: Maybe<Scalars['String']['output']>;
  /** Quantity recorded by the originating event (Created = ordered; Shipped = actual shipped). */
  quantity: Scalars['Decimal']['output'];
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-line snapshot persisted on PendingTransferOrderDocument.Lines.
 * Field-for-field mirror of MovementOrderEvents.V1.MovementOrderLineEventRecord
 * so the projection only has to translate the language-ext Option{T}
 * shape that is registered for Mongo serialization, plus denormalized
 * MaterialItemName / MaterialItemErpId resolved by the mutation
 * layer at command time and carried on the event payload (fail-soft to empty string when the
 * MaterialItem reference could not be resolved).
 */
export type PendingTransferOrderLineDocumentFilterInput = {
  and?: InputMaybe<Array<PendingTransferOrderLineDocumentFilterInput>>;
  /** Locked-at-receive-time organic flag (false until receipt — included for snapshot completeness). */
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  /** Stable line-item id (matches the event's LineItemId). */
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized MaterialItem.ErpId resolved by the mutation layer at command time
   * and carried on the event payload. Empty string under the same fail-soft contract as
   * MaterialItemName.
   */
  materialItemErpId?: InputMaybe<StringOperationFilterInput>;
  /** MaterialItem moving on this line. */
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized MaterialItem.Name resolved by the mutation layer at command time
   * (MovementOrderMutation.ResolveMaterialEnrichment) and carried on the event
   * payload; written through by the projection with no external reads (discipline accaf08f).
   * Empty string when the MaterialItem reference could not be resolved at command time.
   */
  materialItemName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PendingTransferOrderLineDocumentFilterInput>>;
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  /** Quantity recorded by the originating event (Created = ordered; Shipped = actual shipped). */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

/** A connection to a list of items. */
export type PendingTransferOrdersByDestinationConnection = {
  __typename?: 'PendingTransferOrdersByDestinationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PendingTransferOrdersByDestinationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PendingTransferOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PendingTransferOrdersByDestinationEdge = {
  __typename?: 'PendingTransferOrdersByDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PendingTransferOrderDocument;
};

/** Filter operations on a percent-value-at-boundary decimal field. Operand semantics mirror the displayed unit (e.g. 5 means 5%, not 5× the value). The Mongo provider divides operands by 100 before comparing against the stored fraction. */
export type PercentValueOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PhoneNumberData = {
  __typename?: 'PhoneNumberData';
  type: PhoneNumberType;
  value: Scalars['String']['output'];
};

export type PhoneNumberDataInput = {
  type: PhoneNumberType;
  value: Scalars['String']['input'];
};

export enum PhoneNumberType {
  Fax = 'FAX',
  Home = 'HOME',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Work = 'WORK'
}

export type PlanCellEditInput = {
  cell: ForecastPlanCell;
  itemId: Scalars['String']['input'];
  operation: ForecastPlanCellEditOperation;
  region: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

/**
 * Provenance of a job's effective planned labor hours, surfaced via the computed
 * plannedHoursSource field. Ordinals are wire values — do not renumber.
 */
export enum PlannedHoursSource {
  Manual = 'MANUAL',
  Recipe = 'RECIPE'
}

export type PlantsPerPotOverride = {
  __typename?: 'PlantsPerPotOverride';
  plantsPerPot: Scalars['Int']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type PlantsPerPotOverrideFilterInput = {
  and?: InputMaybe<Array<PlantsPerPotOverrideFilterInput>>;
  or?: InputMaybe<Array<PlantsPerPotOverrideFilterInput>>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Pod assignment embedded in the admin background service config document.
 * When NotTenants is true, the pod runs for all active tenants EXCEPT
 * those in TenantIds (exclusion mode); when false, only for the listed tenants.
 * Replicas is the deployment replica count for this assignment.
 */
export type PodAssignmentData = {
  __typename?: 'PodAssignmentData';
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  replicas: Scalars['Int']['output'];
  tenantIds: Array<Scalars['String']['output']>;
};

export type PodAssignmentDataInput = {
  notTenants?: Scalars['Boolean']['input'];
  podName: Scalars['String']['input'];
  replicas?: Scalars['Int']['input'];
  tenantIds: Array<Scalars['String']['input']>;
};

export type PodAssignmentStateData = {
  __typename?: 'PodAssignmentStateData';
  /**
   * When true, the pod runs for all active tenants EXCEPT those in TenantIds
   * (exclusion mode). When false, the pod runs only for tenants in TenantIds.
   */
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  /**
   * Deployment replica count for this assignment. 1 unless the parent service is
   * multi-replica capable, in which case any odd value in [1, 33] is allowed.
   */
  replicas: Scalars['Int']['output'];
  tenantIds: Array<Scalars['String']['output']>;
};

/** GraphQL-side mirror of TenantPortalBranding, mapped in TenantState). */
export type PortalBrandingData = {
  __typename?: 'PortalBrandingData';
  displayName: Scalars['String']['output'];
  logoImage?: Maybe<PortalLogoImageData>;
  logoUrl: Scalars['String']['output'];
  palette: PortalPaletteData;
  primaryColorHex: Scalars['String']['output'];
  styleTokens: PortalStyleTokensData;
  tagline: Scalars['String']['output'];
};

/** GraphQL-side mirror of the portal button tokens. */
export type PortalButtonData = {
  __typename?: 'PortalButtonData';
  borderRadius?: Maybe<Scalars['Decimal']['output']>;
  textTransform: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type PortalButtonDataInput = {
  borderRadius?: InputMaybe<Scalars['Decimal']['input']>;
  textTransform?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GraphQL-output projection of one custom portal domain, including everything the Portal Settings
 * screen needs to walk an admin through setup: the exact DNS records to publish, where the claim is
 * in its lifecycle, and whether login on the domain actually works yet.
 */
export type PortalCustomDomainData = {
  __typename?: 'PortalCustomDomainData';
  domain: Scalars['String']['output'];
  /**
   * Whether the domain's OAuth redirect URL is currently registered for login. Stamped by the
   * wsapi-services worker via stampPortalCustomDomainLoginRedirectSync after it attempts the
   * FusionAuth sync; false until that worker reports a successful registration.
   */
  loginRedirectRegistered: Scalars['Boolean']['output'];
  /**
   * Structured classification of why the last redirect sync attempt failed (see
   * PortalLoginRedirectSyncFailureKind); null when the last stamped attempt
   * succeeded (or none has been stamped yet). Persisted alongside loginSyncFailureReason —
   * the enum names the failure CATEGORY without the null-overloading a bare optional HTTP status
   * carried, while the sanitized string stays the human-readable summary.
   */
  loginSyncFailureKind?: Maybe<PortalLoginRedirectSyncFailureKind>;
  /**
   * Sanitized reason the last redirect sync attempt failed, as stamped by the wsapi-services
   * worker; null when the last stamped attempt succeeded (or none has been stamped yet).
   * Never carries a provider response body or credential.
   */
  loginSyncFailureReason?: Maybe<Scalars['String']['output']>;
  status: PortalCustomDomainStatus;
  /** Host the ownership-proof TXT record must be published at. */
  verificationRecordHost: Scalars['String']['output'];
  /** Exact TXT value to publish at verificationRecordHost. */
  verificationRecordValue: Scalars['String']['output'];
  /** When ownership was last proven; null while the claim is unproven. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PortalCustomDomainStatus {
  PendingVerification = 'PENDING_VERIFICATION',
  Removed = 'REMOVED',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

/** Which portal a host serves, and under which layer it was matched. */
export type PortalHostTenantView = {
  __typename?: 'PortalHostTenantView';
  /** The tenant's vanity slug — empty when a custom domain resolved it. */
  companySlug: Scalars['String']['output'];
  /** The normalized host that resolved. */
  host: Scalars['String']['output'];
  /** True when the host is a tenant-owned custom domain (layer 2). */
  isCustomDomain: Scalars['Boolean']['output'];
  /** The tenant the host resolves to. */
  tenantId: Scalars['String']['output'];
};

export enum PortalLoginRedirectSyncFailureKind {
  ConnectionFailure = 'CONNECTION_FAILURE',
  DnsFailure = 'DNS_FAILURE',
  HttpStatus = 'HTTP_STATUS',
  MalformedResponse = 'MALFORMED_RESPONSE',
  Timeout = 'TIMEOUT',
  TlsFailure = 'TLS_FAILURE',
  Unknown = 'UNKNOWN'
}

export enum PortalLoginRedirectSyncOperation {
  Register = 'REGISTER',
  Remove = 'REMOVE'
}

/**
 * GraphQL-side mirror of the optional base64 portal logo image.
 * None renders as a null logoImage; clients display it as data:{mime};base64,{image}.
 */
export type PortalLogoImageData = {
  __typename?: 'PortalLogoImageData';
  image: Scalars['String']['output'];
  mime: Scalars['String']['output'];
};

/**
 * GraphQL-side mirror of the structured portal palette. Each role is a hex string, empty when
 * unset (the portal PWA fills unset roles from primaryColorHex). primary mirrors
 * primaryColorHex for back-compat.
 */
export type PortalPaletteData = {
  __typename?: 'PortalPaletteData';
  accent: Scalars['String']['output'];
  primary: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
  surface: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PortalPaletteDataInput = {
  accent?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PortalSettingsPayload = {
  __typename?: 'PortalSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalSettings?: Maybe<PortalSettingsStateData>;
};

/**
 * GraphQL-output projection of the portal settings state. This is the shape the
 * worksuite-pwa portal consumer (task eded2645) reads from getPortalSettings
 * and the payload of updatePortalSettings. CatalogDisplayMode is the
 * domain enum, surfaced as a GraphQL enum (GRID/LIST).
 */
export type PortalSettingsStateData = {
  __typename?: 'PortalSettingsStateData';
  /**
   * Location filter of the FULFILL Customer Portal "Availability rule"; nullable — null
   * means "all locations".
   */
  availabilityLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Minimum inventory grade (grade-or-better) of the FULFILL Customer Portal "Availability rule",
   * surfaced as a non-null Int; staff read/write this via portalSettings /
   * updatePortalSettings. 0 is the "Any" option (no grade floor, so gradeless
   * hard-good inventory is included); a tenant that has never saved settings reads the documented
   * default of 2.
   */
  availabilityMinGrade: Scalars['Int']['output'];
  catalogDisplayMode: CatalogDisplayMode;
  /**
   * Per-tenant portal vanity-subdomain slug (DNS-label safe). Empty on a tenant that has never
   * saved settings; a random 8-char default is assigned — and returned here — the first time
   * settings are saved. Unique across all tenants.
   */
  companySlug: Scalars['String']['output'];
  /**
   * The tenant's own domains claimed for its portal, each carrying the DNS records to publish and
   * its verification/login-readiness state. Empty on a tenant that never added one; withdrawn
   * domains stay listed as REMOVED so the screen can show what was detached.
   */
  customDomains: Array<PortalCustomDomainData>;
  /**
   * "Include sellable hard goods" option of the FULFILL Customer Portal "Availability rule".
   * When true, gradeless sellable hard goods are included in availability; defaults to
   * false on a tenant that has never opted in.
   */
  includeSellableHardGoods: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Decimal']['output'];
  portalEnabled: Scalars['Boolean']['output'];
  /**
   * Governs the portal item-image resolver's precedence between the curated/staff-uploaded item
   * image and the newest grower availability photo. Defaults to false (curated image
   * primary — the fixed, correct default) on a tenant that has never opted in; true restores
   * the pre-fix behavior where the newest availability photo wins. Staff read/write this via
   * portalSettings / updatePortalSettings.
   */
  preferAvailabilityImage: Scalars['Boolean']['output'];
  selfRegistrationEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

/** GraphQL-side mirror of the portal shape (corner radius) tokens. */
export type PortalShapeData = {
  __typename?: 'PortalShapeData';
  borderRadius?: Maybe<Scalars['Decimal']['output']>;
};

export type PortalShapeDataInput = {
  borderRadius?: InputMaybe<Scalars['Decimal']['input']>;
};

/** GraphQL-side mirror of the portal spacing tokens. */
export type PortalSpacingData = {
  __typename?: 'PortalSpacingData';
  unit?: Maybe<Scalars['Decimal']['output']>;
};

export type PortalSpacingDataInput = {
  unit?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * GraphQL-side mirror of the structured portal style tokens. Each token is optional (empty string /
 * null = unset); the portal PWA fills unset tokens from its base theme.
 */
export type PortalStyleTokensData = {
  __typename?: 'PortalStyleTokensData';
  button: PortalButtonData;
  shape: PortalShapeData;
  spacing: PortalSpacingData;
  typography: PortalTypographyData;
};

export type PortalStyleTokensDataInput = {
  button?: InputMaybe<PortalButtonDataInput>;
  shape?: InputMaybe<PortalShapeDataInput>;
  spacing?: InputMaybe<PortalSpacingDataInput>;
  typography?: InputMaybe<PortalTypographyDataInput>;
};

/** GraphQL-side mirror of the portal typography tokens. */
export type PortalTypographyData = {
  __typename?: 'PortalTypographyData';
  baseFontSize?: Maybe<Scalars['Decimal']['output']>;
  baseFontWeight?: Maybe<Scalars['Decimal']['output']>;
  fontFamily: Scalars['String']['output'];
};

export type PortalTypographyDataInput = {
  baseFontSize?: InputMaybe<Scalars['Decimal']['input']>;
  baseFontWeight?: InputMaybe<Scalars['Decimal']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
};

export type PortalUserDocument = {
  __typename?: 'PortalUserDocument';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  userType: UserType;
};

export type PortalUserDocumentFilterInput = {
  and?: InputMaybe<Array<PortalUserDocumentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PortalUserDocumentFilterInput>>;
  portalUserId?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userType?: InputMaybe<UserTypeOperationFilterInput>;
};

export type PortalUserDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  portalUserId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userType?: InputMaybe<SortEnumType>;
};

export type PortalUserPayload = {
  __typename?: 'PortalUserPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalUser?: Maybe<PortalUserDocument>;
};

export type PortalUserStateData = {
  __typename?: 'PortalUserStateData';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  userType: UserType;
};

export type PositionData = {
  __typename?: 'PositionData';
  commitPosition: Scalars['Long']['output'];
  preparePosition: Scalars['Long']['output'];
};

/** Input for a full cycle count submission at a store location. */
export type PostCycleCountsInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  items: Array<CycleCountItemInput>;
  locationId: Scalars['String']['input'];
};

export type PostProductionJobDataInput = {
  complete: Scalars['Boolean']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type PostProductionJobEntryInput = {
  complete: Scalars['Boolean']['input'];
  postings: Array<PostProductionJobPostingLineInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  shrinkReasonCode?: InputMaybe<Scalars['Int']['input']>;
};

export type PostProductionJobPostingLineInput = {
  grade: Scalars['Int']['input'];
  producedLocationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type PostProductionJobResult = {
  __typename?: 'PostProductionJobResult';
  errors?: Maybe<Array<ValidationError>>;
  productionJobId: Scalars['String']['output'];
  productionLot?: Maybe<ProductionLotStateData>;
};

export type PostProductionJobsInput = {
  jobs: Array<PostProductionJobEntryInput>;
};

export type PostProductionJobsPayload = {
  __typename?: 'PostProductionJobsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<PostProductionJobResult>;
};

export type PostedProductionLine = {
  __typename?: 'PostedProductionLine';
  grade: Scalars['Int']['output'];
  producedLocationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type PriceGroupBulkActionPayload = {
  __typename?: 'PriceGroupBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  priceGroups?: Maybe<Array<PriceGroupPayload>>;
};

export type PriceGroupDocument = {
  __typename?: 'PriceGroupDocument';
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfLevels: Scalars['Int']['output'];
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: Maybe<PriceGroupOrderVolumeDiscountDocument>;
  priceId: Scalars['String']['output'];
  status: PricingStatus;
  tenantId: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type PriceGroupDocumentFilterInput = {
  and?: InputMaybe<Array<PriceGroupDocumentFilterInput>>;
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfLevels?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceGroupDocumentFilterInput>>;
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: InputMaybe<PriceGroupOrderVolumeDiscountDocumentFilterInput>;
  priceId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<PricingStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type PriceGroupDocumentSortInput = {
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: InputMaybe<SortEnumType>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfLevels?: InputMaybe<SortEnumType>;
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: InputMaybe<PriceGroupOrderVolumeDiscountDocumentSortInput>;
  priceId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type PriceGroupOrderVolumeDiscountData = {
  __typename?: 'PriceGroupOrderVolumeDiscountData';
  thresholdType: OrderVolumeThresholdType;
  thresholdValue: Scalars['Decimal']['output'];
  value: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocument = {
  __typename?: 'PriceGroupOrderVolumeDiscountDocument';
  thresholdType: OrderVolumeThresholdType;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue: Scalars['Decimal']['output'];
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocumentFilterInput = {
  and?: InputMaybe<Array<PriceGroupOrderVolumeDiscountDocumentFilterInput>>;
  or?: InputMaybe<Array<PriceGroupOrderVolumeDiscountDocumentFilterInput>>;
  thresholdType?: InputMaybe<OrderVolumeThresholdTypeOperationFilterInput>;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value?: InputMaybe<DecimalOperationFilterInput>;
  valueType?: InputMaybe<OrderVolumeDiscountValueTypeOperationFilterInput>;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocumentSortInput = {
  thresholdType?: InputMaybe<SortEnumType>;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue?: InputMaybe<SortEnumType>;
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value?: InputMaybe<SortEnumType>;
  valueType?: InputMaybe<SortEnumType>;
};

export type PriceGroupPayload = {
  __typename?: 'PriceGroupPayload';
  errors?: Maybe<Array<ValidationError>>;
  pricing?: Maybe<PriceGroupStateData>;
};

/** Which tier of the Location → Customer → Default hierarchy supplied the resolved price group. */
export enum PriceGroupSource {
  Customer = 'CUSTOMER',
  Default = 'DEFAULT',
  Location = 'LOCATION'
}

/**
 * Per-row failure surfaced by validatePriceGroupDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type PriceGroupStagedRowError = {
  __typename?: 'PriceGroupStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type PriceGroupStateData = {
  __typename?: 'PriceGroupStateData';
  derivedFromPriceGroupId?: Maybe<Scalars['String']['output']>;
  derivedPercentOff?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderVolumeDiscount?: Maybe<PriceGroupOrderVolumeDiscountData>;
  priceLevels: Array<PriceLevelData>;
  status: PricingStatus;
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PriceGroupsConnection = {
  __typename?: 'PriceGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PriceGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceGroupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PriceGroupsEdge = {
  __typename?: 'PriceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceGroupDocument;
};

export enum PriceKind {
  Fixed = 'FIXED',
  PercentOff = 'PERCENT_OFF'
}

export type PriceKindOperationFilterInput = {
  eq?: InputMaybe<PriceKind>;
  in?: InputMaybe<Array<PriceKind>>;
  neq?: InputMaybe<PriceKind>;
  nin?: InputMaybe<Array<PriceKind>>;
};

export type PriceLevelData = {
  __typename?: 'PriceLevelData';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  growerSellPrice: Scalars['Decimal']['output'];
  kind: PriceKind;
  levelType: PriceLevelType;
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  type: TargetType;
};

export type PriceLevelDocument = {
  __typename?: 'PriceLevelDocument';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  growerSellPrice: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  kind: PriceKind;
  levelType: PriceLevelType;
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceGroupId: Scalars['String']['output'];
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: TargetType;
};

export type PriceLevelDocumentFilterInput = {
  and?: InputMaybe<Array<PriceLevelDocumentFilterInput>>;
  customerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  growerCost?: InputMaybe<DecimalOperationFilterInput>;
  growerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<PriceKindOperationFilterInput>;
  levelType?: InputMaybe<PriceLevelTypeOperationFilterInput>;
  or?: InputMaybe<Array<PriceLevelDocumentFilterInput>>;
  percentOff?: InputMaybe<DecimalOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceLevelId?: InputMaybe<StringOperationFilterInput>;
  quantityThreshold?: InputMaybe<DecimalOperationFilterInput>;
  referencePriceGroupId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  targetId?: InputMaybe<StringOperationFilterInput>;
  targetName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<TargetTypeOperationFilterInput>;
};

export type PriceLevelDocumentSortInput = {
  customerSellPrice?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  growerCost?: InputMaybe<SortEnumType>;
  growerSellPrice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  levelType?: InputMaybe<SortEnumType>;
  percentOff?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceLevelId?: InputMaybe<SortEnumType>;
  quantityThreshold?: InputMaybe<SortEnumType>;
  referencePriceGroupId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  targetId?: InputMaybe<SortEnumType>;
  targetName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** Boundary input for a whole-set-replace price level (updatePriceLevels). `kind`, `percentOff`, `referencePriceGroupId`, and `levelType` are all OPTIONAL: omitting one on a level that matches an existing level (by target + quantity threshold + overlapping dates) PRESERVES that existing level's value instead of resetting it to the field's schema default. A level with no existing match (a brand-new level) falls back to the default (kind: FIXED, levelType: LINE_PRICE) when omitted, same as before. Send an explicit value to always win outright over the preserved one, including to deliberately clear a PercentOff configuration back to Fixed. Note: an explicit `null` is indistinguishable from an omitted field on all four — sending `null` also preserves rather than clears. */
export type PriceLevelInputDataInput = {
  customerSellPrice?: InputMaybe<Scalars['Decimal']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  growerCost?: InputMaybe<Scalars['Decimal']['input']>;
  growerSellPrice: Scalars['Decimal']['input'];
  /** Fixed (default) or PercentOff. OPTIONAL: omitting this on a level that matches an existing level PRESERVES that level's current Kind instead of resetting it to Fixed. Send `FIXED` explicitly to switch a PercentOff level back to Fixed even while omitting percentOff/referencePriceGroupId — a non-zero growerSellPrice has the same effect. */
  kind?: InputMaybe<PriceKind>;
  /** LinePrice (default) or CategoryVolume. OPTIONAL: omitting this on a level that matches an existing level (same target + quantity threshold + overlapping dates) PRESERVES that level's current LevelType instead of resetting it to LinePrice. A level with no existing match at that exact tier still defaults to LinePrice when omitted. */
  levelType?: InputMaybe<PriceLevelType>;
  percentOff?: InputMaybe<Scalars['Decimal']['input']>;
  quantityThreshold: Scalars['Decimal']['input'];
  referencePriceGroupId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  targetId: Scalars['String']['input'];
  targetName: Scalars['String']['input'];
  type: TargetType;
};

/**
 * Single sort directive for a priceLevelsBlock request. Multiple directives combine into a
 * composite sort in the order supplied. Field must be a GraphQL camelCase field name from the
 * server's allow-list; unknown fields produce a GraphQL error.
 * An ascending Id tiebreaker is always appended after the caller's directives, so this input never
 * needs to (and cannot) name it directly.
 */
export type PriceLevelSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

export enum PriceLevelType {
  CategoryVolume = 'CATEGORY_VOLUME',
  LinePrice = 'LINE_PRICE'
}

export type PriceLevelTypeOperationFilterInput = {
  eq?: InputMaybe<PriceLevelType>;
  in?: InputMaybe<Array<PriceLevelType>>;
  neq?: InputMaybe<PriceLevelType>;
  nin?: InputMaybe<Array<PriceLevelType>>;
};

/**
 * Windowed result for a single AG Grid SSRM block request against the price levels grid.
 * TotalCount is the count of rows matching the request's filters across every page, computed in
 * the SAME aggregation pass as Nodes (single $facet) so the two values can never drift from each
 * other the way two separate queries could.
 */
export type PriceLevelsBlockPayload = {
  __typename?: 'PriceLevelsBlockPayload';
  /** Rows for the requested offset/limit window. */
  nodes: Array<PriceLevelDocument>;
  /** Total rows matching the request's filters, independent of the current window. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type PriceLevelsConnection = {
  __typename?: 'PriceLevelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PriceLevelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceLevelDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PriceLevelsEdge = {
  __typename?: 'PriceLevelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceLevelDocument;
};

/** The one distinguishable reason an item priced or failed to price. */
export enum PriceResolutionOutcome {
  /** Resolution errored internally (surfaced here instead of being swallowed to 0). */
  Error = 'ERROR',
  /** A group resolved, but it holds no level targeting this item or any of its categories. */
  NoLevelsForItem = 'NO_LEVELS_FOR_ITEM',
  /** Candidate levels exist, but none matched the order date and quantity. */
  NoLevelMatches = 'NO_LEVEL_MATCHES',
  /** No price group resolved anywhere in the Location → Customer → Default hierarchy. */
  NoPriceGroup = 'NO_PRICE_GROUP',
  /** A level applied and the charged grower sell price is greater than 0. */
  Priced = 'PRICED',
  /**
   * No level of the group's OWN priced this item, but the group's whole-group derivation did:
   * the reference group's winner minus the configured percentage. See
   * Derivation for the full trace. Distinct from
   * Priced so a user can tell "this group prices this item" from "this group inherits
   * this item's price from another group", and from NoLevelsForItem /
   * NoLevelMatches, which would be dishonest labels for a price that WAS charged.
   * Appended last, so the ordinals of the existing values are unchanged.
   */
  PricedByDerivation = 'PRICED_BY_DERIVATION',
  /** A level applied and its grower sell price is exactly 0 (a valid, orderable price). */
  ZeroPrice = 'ZERO_PRICE'
}

export enum PricingMode {
  FlatPrice = 'FLAT_PRICE',
  MarkupPercent = 'MARKUP_PERCENT'
}

export type PricingModeOperationFilterInput = {
  eq?: InputMaybe<PricingMode>;
  in?: InputMaybe<Array<PricingMode>>;
  neq?: InputMaybe<PricingMode>;
  nin?: InputMaybe<Array<PricingMode>>;
};

export enum PricingStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type PricingStatusOperationFilterInput = {
  eq?: InputMaybe<PricingStatus>;
  in?: InputMaybe<Array<PricingStatus>>;
  neq?: InputMaybe<PricingStatus>;
  nin?: InputMaybe<Array<PricingStatus>>;
};

export type ProcessErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type ProcessOnHandAdjustmentInput = {
  externalCustomerId: Scalars['String']['input'];
  externalItemId: Scalars['String']['input'];
  gtin: Scalars['String']['input'];
  processedDate: Scalars['DateTime']['input'];
  quantity: Scalars['Int']['input'];
  resultMessage: Scalars['String']['input'];
  retailerId: Scalars['String']['input'];
  storeNumber: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  type: OnHandAdjustmentType;
};

export enum ProductionAdjustmentReason {
  CountCorrection = 'COUNT_CORRECTION',
  Damage = 'DAMAGE',
  Miscount = 'MISCOUNT',
  ShrinkActual = 'SHRINK_ACTUAL'
}

export type ProductionAdjustmentReasonOperationFilterInput = {
  eq?: InputMaybe<ProductionAdjustmentReason>;
  in?: InputMaybe<Array<ProductionAdjustmentReason>>;
  neq?: InputMaybe<ProductionAdjustmentReason>;
  nin?: InputMaybe<Array<ProductionAdjustmentReason>>;
};

/**
 * Response data model for production catalog.
 * Maps from the domain state to GraphQL response.
 */
export type ProductionCatalogData = {
  __typename?: 'ProductionCatalogData';
  /** Gets the color. */
  color: Scalars['String']['output'];
  /** Gets the genus. */
  genus: Scalars['String']['output'];
  /** Gets the production catalog ID. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the series. */
  series: Scalars['String']['output'];
  /** Gets the status. */
  status: ProductionCatalogStatus;
  /** Gets the tenant ID. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocument = {
  __typename?: 'ProductionCatalogDocument';
  /** Gets the color of the production catalog. */
  color: Scalars['String']['output'];
  /** Gets the genus of the production catalog. */
  genus: Scalars['String']['output'];
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id: Scalars['String']['output'];
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the series of the production catalog. */
  series: Scalars['String']['output'];
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status: ProductionCatalogStatus;
  /** Gets the tenant ID that owns this catalog. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionCatalogDocumentFilterInput>>;
  /** Gets the color of the production catalog. */
  color?: InputMaybe<StringOperationFilterInput>;
  /** Gets the genus of the production catalog. */
  genus?: InputMaybe<StringOperationFilterInput>;
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionCatalogDocumentFilterInput>>;
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the series of the production catalog. */
  series?: InputMaybe<StringOperationFilterInput>;
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status?: InputMaybe<ProductionCatalogStatusOperationFilterInput>;
  /** Gets the tenant ID that owns this catalog. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocumentSortInput = {
  /** Gets the color of the production catalog. */
  color?: InputMaybe<SortEnumType>;
  /** Gets the genus of the production catalog. */
  genus?: InputMaybe<SortEnumType>;
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id?: InputMaybe<SortEnumType>;
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId?: InputMaybe<SortEnumType>;
  /** Gets the series of the production catalog. */
  series?: InputMaybe<SortEnumType>;
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status?: InputMaybe<SortEnumType>;
  /** Gets the tenant ID that owns this catalog. */
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL response payload for production catalog operations.
 * Contains either successful data or validation errors.
 */
export type ProductionCatalogPayload = {
  __typename?: 'ProductionCatalogPayload';
  catalog?: Maybe<ProductionCatalogData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum ProductionCatalogStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionCatalogStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionCatalogStatus>;
  in?: InputMaybe<Array<ProductionCatalogStatus>>;
  neq?: InputMaybe<ProductionCatalogStatus>;
  nin?: InputMaybe<Array<ProductionCatalogStatus>>;
};

/** A connection to a list of items. */
export type ProductionCatalogsConnection = {
  __typename?: 'ProductionCatalogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionCatalogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionCatalogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionCatalogsEdge = {
  __typename?: 'ProductionCatalogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionCatalogDocument;
};

/** A connection to a list of items. */
export type ProductionCategoriesConnection = {
  __typename?: 'ProductionCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionCategoriesEdge = {
  __typename?: 'ProductionCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionCategoryDocument;
};

export type ProductionCategoryDocument = {
  __typename?: 'ProductionCategoryDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  materialEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  materialEventNames: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionSpaceCategoryCode: Scalars['String']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  spaceEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  spaceEventNames: Scalars['String']['output'];
  status: ProductionCategoryStatus;
  taskEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  taskEventNames: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  eaches?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborCostEffectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  laborCostPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  materialEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  materialEventNames?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionCategoryDocumentFilterInput>>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceCategoryCode?: InputMaybe<StringOperationFilterInput>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  spaceEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  spaceEventNames?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionCategoryStatusOperationFilterInput>;
  taskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  taskEventNames?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  eaches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborCostEffectiveDate?: InputMaybe<SortEnumType>;
  laborCostPerUnit?: InputMaybe<SortEnumType>;
  materialEventNames?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionSpaceCategoryCode?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  spaceEventNames?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventNames?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionCategoryPayload = {
  __typename?: 'ProductionCategoryPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionCategory?: Maybe<ProductionCategoryStateData>;
};

export type ProductionCategoryStateData = {
  __typename?: 'ProductionCategoryStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  productionCategoryId: Scalars['String']['output'];
  productionMaterialEventAttachments: Array<ProductionEventAttachmentData>;
  productionMaterialEventIds: Array<Scalars['String']['output']>;
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventAttachments: Array<ProductionEventAttachmentData>;
  productionSpaceEventIds: Array<Scalars['String']['output']>;
  productionTaskEventAttachments: Array<ProductionEventAttachmentData>;
  productionTaskEventIds: Array<Scalars['String']['output']>;
  status: ProductionCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionCategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionCategoryStatus>;
  in?: InputMaybe<Array<ProductionCategoryStatus>>;
  neq?: InputMaybe<ProductionCategoryStatus>;
  nin?: InputMaybe<Array<ProductionCategoryStatus>>;
};

export type ProductionEventAttachmentData = {
  __typename?: 'ProductionEventAttachmentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionEventAttachmentDocumentData = {
  __typename?: 'ProductionEventAttachmentDocumentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionEventAttachmentDocumentDataFilterInput = {
  and?: InputMaybe<Array<ProductionEventAttachmentDocumentDataFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionEventAttachmentDocumentDataFilterInput>>;
};

/**
 * One entry of the production items catalog: a native ProductionItem's id and number with its
 * denormalized taxonomy (Genus / Series / Color / Category). Returned by the
 * productionItemsCatalog query and by each mapping line's taxonomy resolver — the taxonomy is
 * always read from the native ProductionItems collection, never copied onto the mapping (W5).
 */
export type ProductionItemCatalogEntry = {
  __typename?: 'ProductionItemCatalogEntry';
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

export type ProductionItemDocument = {
  __typename?: 'ProductionItemDocument';
  catalogColor: Scalars['String']['output'];
  catalogGenus: Scalars['String']['output'];
  catalogSeries: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  productionTaskEventAttachments: Array<ProductionItemEventAttachmentDocument>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: Maybe<Scalars['String']['output']>;
  status: ProductionItemStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionItemDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionItemDocumentFilterInput>>;
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborCostEffectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  laborCostPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionItemDocumentFilterInput>>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionItemId?: InputMaybe<StringOperationFilterInput>;
  productionItemNumber?: InputMaybe<StringOperationFilterInput>;
  productionTaskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionItemEventAttachmentDocumentFilterInput>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionItemStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionItemDocumentSortInput = {
  catalogColor?: InputMaybe<SortEnumType>;
  catalogGenus?: InputMaybe<SortEnumType>;
  catalogSeries?: InputMaybe<SortEnumType>;
  categoryCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborCostEffectiveDate?: InputMaybe<SortEnumType>;
  laborCostPerUnit?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionItemId?: InputMaybe<SortEnumType>;
  productionItemNumber?: InputMaybe<SortEnumType>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionItemEventAttachmentData = {
  __typename?: 'ProductionItemEventAttachmentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionItemEventAttachmentDocument = {
  __typename?: 'ProductionItemEventAttachmentDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionItemEventAttachmentDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionItemEventAttachmentDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionItemEventAttachmentDocumentFilterInput>>;
};

export type ProductionItemPayload = {
  __typename?: 'ProductionItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionItem?: Maybe<ProductionItemStateData>;
};

export type ProductionItemStateData = {
  __typename?: 'ProductionItemStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  productionTaskEventAttachments: Array<ProductionItemEventAttachmentData>;
  salesItemId?: Maybe<Scalars['String']['output']>;
  status: ProductionItemStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type ProductionItemStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionItemStatus>;
  in?: InputMaybe<Array<ProductionItemStatus>>;
  neq?: InputMaybe<ProductionItemStatus>;
  nin?: InputMaybe<Array<ProductionItemStatus>>;
};

/** A connection to a list of items. */
export type ProductionItemsConnection = {
  __typename?: 'ProductionItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionItemsEdge = {
  __typename?: 'ProductionItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionItemDocument;
};

/**
 * Read-model row for one entry of a job's auditable adjustments trail (Post Jobs post-hoc corrections): a
 * signed Delta applied to the posted quantity at a (Grade x ProducedLocationId) slot, with its Reason and
 * optional Note. Set absolutely by the projection from Production.V1.JobProductionAdjusted (the event carries
 * the full trail). AppliedWhileClosed flags a correction made against an already-Closed job.
 */
export type ProductionJobAdjustmentDocument = {
  __typename?: 'ProductionJobAdjustmentDocument';
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  adjustmentId: Scalars['String']['output'];
  appliedWhileClosed: Scalars['Boolean']['output'];
  delta: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  producedLocationId: Scalars['String']['output'];
  reason: ProductionAdjustmentReason;
  resultingSlotQuantity: Scalars['Int']['output'];
};

/**
 * Read-model row for one entry of a job's auditable adjustments trail (Post Jobs post-hoc corrections): a
 * signed Delta applied to the posted quantity at a (Grade x ProducedLocationId) slot, with its Reason and
 * optional Note. Set absolutely by the projection from Production.V1.JobProductionAdjusted (the event carries
 * the full trail). AppliedWhileClosed flags a correction made against an already-Closed job.
 */
export type ProductionJobAdjustmentDocumentFilterInput = {
  adjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  adjustedBy?: InputMaybe<StringOperationFilterInput>;
  adjustmentId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionJobAdjustmentDocumentFilterInput>>;
  appliedWhileClosed?: InputMaybe<BooleanOperationFilterInput>;
  delta?: InputMaybe<IntOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<ProductionJobAdjustmentDocumentFilterInput>>;
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  reason?: InputMaybe<ProductionAdjustmentReasonOperationFilterInput>;
  resultingSlotQuantity?: InputMaybe<IntOperationFilterInput>;
};

/** The consumption manifest across the requested jobs, plus whether any row is short on-hand. */
export type ProductionJobConsumptionManifest = {
  __typename?: 'ProductionJobConsumptionManifest';
  /** True when any row across any job is short on-hand (a batch-level pre-flight signal). */
  hasAnyShortage: Scalars['Boolean']['output'];
  /** Per-job computed consumption rows, in the order the jobs were requested. */
  jobs: Array<ProductionJobConsumptionManifestJob>;
};

/** The computed consumption rows for one production job. */
export type ProductionJobConsumptionManifestJob = {
  __typename?: 'ProductionJobConsumptionManifestJob';
  /** The produced quantity supplied by the caller that drove the computed quantities. */
  producedQuantity: Scalars['Int']['output'];
  /** The production job identifier. */
  productionJobId: Scalars['String']['output'];
  /** The computed consumption rows (one per distinct material item the job's recipe requires). */
  rows: Array<ProductionJobConsumptionManifestRow>;
};

/**
 * One computed consumption row of the manifest: a material required by a job, the recipe multiple, the
 * computed quantity (producedQuantity × multiple, summed across the job's recipe details for that
 * material), the suggested stock bin to draw from, the on-hand available for the material, and whether the
 * computed quantity exceeds on-hand (the step-③ pre-flight shortage signal).
 */
export type ProductionJobConsumptionManifestRow = {
  __typename?: 'ProductionJobConsumptionManifestRow';
  /**
   * The computed quantity to consume: producedQuantity × multiple, summed across the job's recipe
   * material details for this material. Matches the HardgoodsRequiredByReadyWeek math when the produced
   * quantity equals the job's planned quantity.
   */
  computedQuantity: Scalars['Decimal']['output'];
  /**
   * True when `computedQuantity` exceeds `onHandAvailable` — the pre-flight shortage warning the PWA
   * surfaces before posting.
   */
  hasShortage: Scalars['Boolean']['output'];
  /**
   * Suggested stock bin (location) to draw the material from — the material's stock location holding the
   * most on-hand. Empty when the material has no recorded on-hand anywhere.
   */
  locationId: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier to decrement. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /** The recipe material multiple (units of material per produced plant). */
  multiple: Scalars['Decimal']['output'];
  /** Total on-hand available for the material across all its stock bins for the tenant. */
  onHandAvailable: Scalars['Decimal']['output'];
  /** The site location of the suggested stock bin (empty when there is none). */
  siteLocationId: Scalars['String']['output'];
};

/**
 * Request row for productionJobConsumptionManifest: the production job to build a hardgoods
 * consumption manifest for, and the produced quantity that drives the computed material quantities
 * (producedQuantity × recipe material multiple). Produced quantity is the caller-supplied Post
 * Jobs value, which may differ from the job's planned quantity.
 */
export type ProductionJobConsumptionRequestInput = {
  producedQuantity: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
};

/** Cost breakdown for a single production job, resolved from its recipe variation and site location. */
export type ProductionJobCostResult = {
  __typename?: 'ProductionJobCostResult';
  /** Step-by-step audit trail showing how each cost was calculated. */
  calcSteps: Array<CostCalcStep>;
  /** Reasons why individual cost components could not be resolved. */
  incompleteCostReasons: Array<Scalars['String']['output']>;
  /** True when all cost components could be fully resolved. */
  isComplete: Scalars['Boolean']['output'];
  /** Total labor cost resolved via the recipe's labor source mode. */
  laborCost: Scalars['Decimal']['output'];
  /** Itemized labor cost events with human-readable names. */
  laborEvents: Array<CostEventResult>;
  /** Itemized material cost events with human-readable names. */
  materialEvents: Array<CostEventResult>;
  /** Total material cost from default vendor pricing across all BOM items. */
  materialsCost: Scalars['Decimal']['output'];
  /** Overall calculation status derived from step severities. */
  overallStatus: CostCalcStepSeverity;
  /** Overhead cost per square foot for the recipe's grow duration. */
  overheadCost: Scalars['Decimal']['output'];
  /** Itemized overhead cost events with human-readable names. */
  overheadEvents: Array<CostEventResult>;
  /** The production job this cost was calculated for. */
  productionJobId: Scalars['String']['output'];
  /** The production recipe used for cost resolution. */
  productionRecipeId: Scalars['String']['output'];
  /** The recipe variation selected for this job's week range. Null when variation could not be resolved. */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /** The site location used for labor and overhead rates. Null when site could not be resolved. */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  /** Sum of materials, labor, and overhead costs. */
  totalCost: Scalars['Decimal']['output'];
};

export type ProductionJobData = {
  __typename?: 'ProductionJobData';
  childJobs: Array<ProductionJobData>;
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  growWeeksOverrides: Array<GrowWeeksOverride>;
  jobExecutionStatus: JobExecutionStatus;
  jobNumber: Scalars['Int']['output'];
  lastReconciledRecipeVersion: Scalars['Int']['output'];
  linksOverrides: Array<LinksOverride>;
  locationId?: Maybe<Scalars['String']['output']>;
  materialEventAttachments: Array<ProductionEventAttachmentData>;
  notes?: Maybe<Scalars['String']['output']>;
  plannedHoursOverride?: Maybe<Scalars['Decimal']['output']>;
  plantsPerPotOverrides: Array<PlantsPerPotOverride>;
  postedProductionLines: Array<PostedProductionLine>;
  postedShrinkReason?: Maybe<ShrinkType>;
  postingStatus: JobPostingStatus;
  producedFromCountSessionId?: Maybe<Scalars['String']['output']>;
  producedLocationId?: Maybe<Scalars['String']['output']>;
  producedQuantity?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shrinkEvents: Array<ShrinkEvent>;
  spaceEventAttachments: Array<ProductionEventAttachmentData>;
  taskEventAttachments: Array<ProductionEventAttachmentData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weekReadyDate: Scalars['DateTime']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  yield: Scalars['Decimal']['output'];
};

export type ProductionJobDocument = {
  __typename?: 'ProductionJobDocument';
  /**
   * Actual output quantity after subtracting recorded shrink events from the job's expected
   * output. Computed as (Quantity * Yield) - sum(ShrinkEvents.Quantity), clamped to
   * never go negative.
   */
  actualYield: Scalars['Decimal']['output'];
  categoryName: Scalars['String']['output'];
  color: Scalars['String']['output'];
  /** Count of completed task assignments on this job. */
  completedTaskCount: Scalars['Int']['output'];
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer name for the job's lot-derived CustomerId, or null when the job's lot carries no customer
   * (CustomerId null) or the customer summary is absent. Mirrors the retired customer join, which read the
   * unwound lot's CustomerId (surfaced here as the aggregation-projected customerId field).
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /**
   * The effective grow-weeks in force for this job: the most-recently-set grow-weeks override for the
   * week-selected recipe variation, else that variation's recipe-default grow-weeks; null when the job's
   * ready week resolves to no applicable variation. Computed at read time against the current recipe —
   * never persisted by the projection, so the accaf08f replay-purity constraint does not apply. Variation
   * selection uses ProductionVariationSelector.SelectForWeek, the same rule the CountSession
   * snapshot and reapply-recipes preview use, so all three report the effective value for the same variation.
   * Emits a nullable Int at the schema (null = no applicable variation), matching the codebase's async
   * field-resolver convention (e.g. RestockDailyDemandRowResolvers.GetStoreRanking).
   */
  effectiveGrowWeeks?: Maybe<Scalars['Int']['output']>;
  /**
   * The effective plants-per-pot in force for this job: the most-recently-set plants-per-pot override for
   * the week-selected recipe variation, else that variation's recipe-default plants-per-pot; null when the
   * job's ready week resolves to no applicable variation. Computed at read time against the current recipe —
   * never persisted by the projection, so the accaf08f replay-purity constraint does not apply. Variation
   * selection uses ProductionVariationSelector.SelectForWeek, the same rule the CountSession
   * snapshot and reapply-recipes preview use, so all three report the effective value for the same variation.
   * Emits a nullable Int at the schema (null = no applicable variation), matching the codebase's async
   * field-resolver convention (e.g. RestockDailyDemandRowResolvers.GetStoreRanking).
   */
  effectivePlantsPerPot?: Maybe<Scalars['Int']['output']>;
  genus: Scalars['String']['output'];
  /**
   * The most-recently-set grow-weeks override value (the override with the latest
   * SetAt) across this job's per-variation overrides, or None when no override is set.
   * Lets the inline-edit UI surface the raw override value and detect the cleared state.
   * Option<T> per the active null-safety standard (5a153a33); OptionTypeInterceptor emits a
   * nullable Int at the schema, so this is schema-neutral.
   */
  growWeeksOverride?: Maybe<Scalars['Int']['output']>;
  growWeeksOverrides: Array<GrowWeeksOverride>;
  id: Scalars['String']['output'];
  /**
   * True when this job carries any per-variation grow-weeks override (i.e. the planner has
   * overridden grow weeks for at least one recipe variation). Drives the inline-edit "overridden"
   * badge. Computed live from the persisted GrowWeeksOverrides
   * collection — no projection state of its own, so it is replay-safe.
   */
  isGrowWeeksOverridden: Scalars['Boolean']['output'];
  /**
   * True when this job carries any per-variation plants-per-pot override. Drives the inline-edit
   * "overridden" badge. Computed live from the persisted
   * PlantsPerPotOverrides collection.
   */
  isPlantsPerPotOverridden: Scalars['Boolean']['output'];
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden: Scalars['Boolean']['output'];
  isRecipeStale: Scalars['Boolean']['output'];
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden: Scalars['Boolean']['output'];
  jobExecutionStatus: JobExecutionStatus;
  jobNumber: Scalars['Int']['output'];
  lastReconciledRecipeVersion: Scalars['Int']['output'];
  linksOverrides: Array<LinksOverride>;
  locationId?: Maybe<Scalars['String']['output']>;
  /**
   * The job's location name: the sub-location's name when the job's LocationId resolves to a sub-location,
   * else the site-location's name when it resolves to a site, else null. Mirrors the retired aggregation's
   * SubLocation ?? SiteLocation ?? null precedence exactly (both were joined on the job's LocationId).
   */
  locationName?: Maybe<Scalars['String']['output']>;
  lotClosedStatus: LotClosedStatus;
  lotStatus: ProductionLotStatus;
  materialEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  notes?: Maybe<Scalars['String']['output']>;
  parentProductionJobId?: Maybe<Scalars['String']['output']>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Provenance of this job's effective planned labor hours: 'Manual' when a manual planned-hours
   * override is set on the job (and therefore wins in LaborDemand), else 'Recipe' (hours derive from
   * the recipe's per-task-event throughput). Computed live from the persisted override, so it is
   * replay-safe with no projection state of its own. Pair with the raw plannedHoursOverride value the
   * document exposes directly so the PWA can render the override and its source.
   */
  plannedHoursSource: PlannedHoursSource;
  /**
   * The most-recently-set plants-per-pot override value (latest SetAt) across this job's
   * per-variation overrides, or None when no override is set. Option<T> per the active
   * null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Int at the schema.
   */
  plantsPerPotOverride?: Maybe<Scalars['Int']['output']>;
  plantsPerPotOverrides: Array<PlantsPerPotOverride>;
  postedAdjustments: Array<ProductionJobAdjustmentDocument>;
  postedProductionLines: Array<ProductionJobPostedLineDocument>;
  postedShrinkReason?: Maybe<ShrinkType>;
  postingStatus: JobPostingStatus;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: Maybe<Scalars['Decimal']['output']>;
  quantity: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  /**
   * Shrink/loss events recorded against this job during production. Defaults to
   * empty array; pre-existing documents missing this field deserialize naturally.
   */
  shrinkEvents: Array<ProductionJobShrinkEventDocument>;
  /**
   * SC-WSAPI-B — the space-category dimensions snapshotted onto this job at creation, or null when
   * the job has no resolved dimensions. Composed live from the persisted scalars, so it is
   * replay-safe (no projection state of its own). Pair with
   * SpaceDimensionsSource for provenance (site override vs default).
   */
  spaceDimensions?: Maybe<ProductionJobSpaceDimensionsData>;
  spaceDimensionsSource?: Maybe<DimensionSource>;
  spaceEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  taskEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  tenantId: Scalars['String']['output'];
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits: Scalars['Int']['output'];
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds: Scalars['Long']['output'];
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weekReadyDate: Scalars['DateTime']['output'];
  weekReadyIsoWeek: Scalars['Int']['output'];
  weekReadyIsoYear: Scalars['Int']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  weekStartIsoWeek: Scalars['Int']['output'];
  weekStartIsoYear: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductionJobDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobDocumentFilterInput>>;
  /** Count of completed task assignments on this job. */
  completedTaskCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  growWeeksOverrides?: InputMaybe<ListFilterInputTypeOfGrowWeeksOverrideFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden?: InputMaybe<BooleanOperationFilterInput>;
  jobExecutionStatus?: InputMaybe<JobExecutionStatusOperationFilterInput>;
  jobNumber?: InputMaybe<IntOperationFilterInput>;
  lastReconciledRecipeVersion?: InputMaybe<IntOperationFilterInput>;
  linksOverrides?: InputMaybe<ListFilterInputTypeOfLinksOverrideFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  lotClosedStatus?: InputMaybe<LotClosedStatusOperationFilterInput>;
  lotStatus?: InputMaybe<ProductionLotStatusOperationFilterInput>;
  materialEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobDocumentFilterInput>>;
  parentProductionJobId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: InputMaybe<OptionOfDecimalFilterInput>;
  plantsPerPotOverrides?: InputMaybe<ListFilterInputTypeOfPlantsPerPotOverrideFilterInput>;
  postedAdjustments?: InputMaybe<ListFilterInputTypeOfProductionJobAdjustmentDocumentFilterInput>;
  postedProductionLines?: InputMaybe<ListFilterInputTypeOfProductionJobPostedLineDocumentFilterInput>;
  postedShrinkReason?: InputMaybe<NullableOfShrinkTypeOperationFilterInput>;
  postingStatus?: InputMaybe<JobPostingStatusOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: InputMaybe<OptionOfDecimalFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Shrink/loss events recorded against this job during production. Defaults to
   * empty array; pre-existing documents missing this field deserialize naturally.
   */
  shrinkEvents?: InputMaybe<ListFilterInputTypeOfProductionJobShrinkEventDocumentFilterInput>;
  spaceDimensionsSource?: InputMaybe<NullableOfDimensionSourceOperationFilterInput>;
  spaceEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  taskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits?: InputMaybe<IntOperationFilterInput>;
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds?: InputMaybe<LongOperationFilterInput>;
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  weekReadyDate?: InputMaybe<DateTimeOperationFilterInput>;
  weekReadyIsoWeek?: InputMaybe<IntOperationFilterInput>;
  weekReadyIsoYear?: InputMaybe<IntOperationFilterInput>;
  weekStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  weekStartIsoWeek?: InputMaybe<IntOperationFilterInput>;
  weekStartIsoYear?: InputMaybe<IntOperationFilterInput>;
  yield?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: InputMaybe<OptionOfDecimalFilterInput>;
};

export type ProductionJobDocumentSortInput = {
  /** Count of completed task assignments on this job. */
  completedTaskCount?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden?: InputMaybe<SortEnumType>;
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden?: InputMaybe<SortEnumType>;
  jobExecutionStatus?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  lastReconciledRecipeVersion?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  lotClosedStatus?: InputMaybe<SortEnumType>;
  lotStatus?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  parentProductionJobId?: InputMaybe<SortEnumType>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: InputMaybe<SortEnumType>;
  postedShrinkReason?: InputMaybe<SortEnumType>;
  postingStatus?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionJobId?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  spaceDimensionsSource?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits?: InputMaybe<SortEnumType>;
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds?: InputMaybe<SortEnumType>;
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  weekReadyDate?: InputMaybe<SortEnumType>;
  weekReadyIsoWeek?: InputMaybe<SortEnumType>;
  weekReadyIsoYear?: InputMaybe<SortEnumType>;
  weekStartDate?: InputMaybe<SortEnumType>;
  weekStartIsoWeek?: InputMaybe<SortEnumType>;
  weekStartIsoYear?: InputMaybe<SortEnumType>;
  yield?: InputMaybe<SortEnumType>;
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: InputMaybe<SortEnumType>;
};

export type ProductionJobEventAttachmentDocument = {
  __typename?: 'ProductionJobEventAttachmentDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionJobEventAttachmentDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobEventAttachmentDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobEventAttachmentDocumentFilterInput>>;
};

/**
 * Read-model row for one line of a job's last posting (Post Jobs batch close-out, task 30a36865): a
 * quantity produced at a grade × produced location. Grade 1–5 is a sellable live-goods grade
 * that fed FULFILL inventory; Grade == DumpShrinkGrade is
 * a dump/shrink line (no inventory). Set absolutely by the projection from Production.V1.JobProductionPosted.
 */
export type ProductionJobPostedLineDocument = {
  __typename?: 'ProductionJobPostedLineDocument';
  grade: Scalars['Int']['output'];
  producedLocationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/**
 * Read-model row for one line of a job's last posting (Post Jobs batch close-out, task 30a36865): a
 * quantity produced at a grade × produced location. Grade 1–5 is a sellable live-goods grade
 * that fed FULFILL inventory; Grade == DumpShrinkGrade is
 * a dump/shrink line (no inventory). Set absolutely by the projection from Production.V1.JobProductionPosted.
 */
export type ProductionJobPostedLineDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobPostedLineDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobPostedLineDocumentFilterInput>>;
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
};

export type ProductionJobShrinkEventDocument = {
  __typename?: 'ProductionJobShrinkEventDocument';
  date: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  shrinkEventId: Scalars['String']['output'];
  shrinkType: ShrinkType;
};

export type ProductionJobShrinkEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobShrinkEventDocumentFilterInput>>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<ProductionJobShrinkEventDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  shrinkEventId?: InputMaybe<StringOperationFilterInput>;
  shrinkType?: InputMaybe<ShrinkTypeOperationFilterInput>;
};

export type ProductionJobSpaceDimensionsData = {
  __typename?: 'ProductionJobSpaceDimensionsData';
  length: Scalars['Decimal']['output'];
  width: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type ProductionJobsConnection = {
  __typename?: 'ProductionJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionJobsEdge = {
  __typename?: 'ProductionJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionJobDocument;
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocument = {
  __typename?: 'ProductionLineDocument';
  activeCountSessionId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: ProductionLineStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocumentFilterInput = {
  activeCountSessionId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionLineDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceIds?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLineDocumentFilterInput>>;
  status?: InputMaybe<ProductionLineStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocumentSortInput = {
  activeCountSessionId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type ProductionLinePayload = {
  __typename?: 'ProductionLinePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLine?: Maybe<ProductionLineStateData>;
};

export type ProductionLineStateData = {
  __typename?: 'ProductionLineStateData';
  activeCountSessionId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  productionLineId: Scalars['String']['output'];
  status: ProductionLineStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionLineStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ProductionLineStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionLineStatus>;
  in?: InputMaybe<Array<ProductionLineStatus>>;
  neq?: InputMaybe<ProductionLineStatus>;
  nin?: InputMaybe<Array<ProductionLineStatus>>;
};

/**
 * The phase a single advanceProductionLotAsyncImportJob call ran. None means the call
 * was a no-op (the job was not in a driveable state, or a claim race was lost).
 */
export enum ProductionLotAdvancePhase {
  Import = 'IMPORT',
  None = 'NONE',
  Validate = 'VALIDATE'
}

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocument = {
  __typename?: 'ProductionLotAllocationRollupDocument';
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty: Scalars['Int']['output'];
  /** Net quantity still available to allocate against the lot — derived on read, never stored. */
  netAvailableQty: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionLotAllocationRollupDocumentFilterInput>>;
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAllocationRollupDocumentFilterInput>>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocumentSortInput = {
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionLotAllocationRollupsConnection = {
  __typename?: 'ProductionLotAllocationRollupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotAllocationRollupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotAllocationRollupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotAllocationRollupsEdge = {
  __typename?: 'ProductionLotAllocationRollupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotAllocationRollupDocument;
};

export type ProductionLotAsyncImportJobRow = {
  __typename?: 'ProductionLotAsyncImportJobRow';
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdEntityId?: Maybe<Scalars['String']['output']>;
  customer: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  genus: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  productionCatalogId?: Maybe<Scalars['String']['output']>;
  productionCategoryId?: Maybe<Scalars['String']['output']>;
  productionPlanId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  rowIndex: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  status: AsyncImportRowStatus;
  sublocation: Scalars['String']['output'];
  sublocationId?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
  weekReady: Scalars['String']['output'];
};

export type ProductionLotAsyncImportJobRowFilterInput = {
  and?: InputMaybe<Array<ProductionLotAsyncImportJobRowFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  createdEntityId?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  isAd?: InputMaybe<BooleanOperationFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAsyncImportJobRowFilterInput>>;
  plan?: InputMaybe<StringOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  rowIndex?: InputMaybe<IntOperationFilterInput>;
  series?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AsyncImportRowStatusOperationFilterInput>;
  sublocation?: InputMaybe<StringOperationFilterInput>;
  sublocationId?: InputMaybe<StringOperationFilterInput>;
  warning?: InputMaybe<StringOperationFilterInput>;
  weekReady?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionLotAsyncImportJobRowSortInput = {
  category?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  createdEntityId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  isAd?: InputMaybe<SortEnumType>;
  isTrial?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  plan?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  rowIndex?: InputMaybe<SortEnumType>;
  series?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  sublocation?: InputMaybe<SortEnumType>;
  sublocationId?: InputMaybe<SortEnumType>;
  warning?: InputMaybe<SortEnumType>;
  weekReady?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionLotAsyncImportJobRowsConnection = {
  __typename?: 'ProductionLotAsyncImportJobRowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotAsyncImportJobRowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotAsyncImportJobRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotAsyncImportJobRowsEdge = {
  __typename?: 'ProductionLotAsyncImportJobRowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotAsyncImportJobRow;
};

export type ProductionLotDocument = {
  __typename?: 'ProductionLotDocument';
  archiveNotes?: Maybe<Scalars['String']['output']>;
  closedStatus: LotClosedStatus;
  consolidatedIntoProductionLotId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: Maybe<Scalars['String']['output']>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty: Scalars['Int']['output'];
  status: ProductionLotStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionLotDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionLotDocumentFilterInput>>;
  archiveNotes?: InputMaybe<StringOperationFilterInput>;
  closedStatus?: InputMaybe<LotClosedStatusOperationFilterInput>;
  consolidatedIntoProductionLotId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: InputMaybe<StringOperationFilterInput>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isAd?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady?: InputMaybe<BooleanOperationFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  lotNumber?: InputMaybe<IntOperationFilterInput>;
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotDocumentFilterInput>>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  productionPlanName?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<ProductionLotStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionLotDocumentSortInput = {
  archiveNotes?: InputMaybe<SortEnumType>;
  closedStatus?: InputMaybe<SortEnumType>;
  consolidatedIntoProductionLotId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: InputMaybe<SortEnumType>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: InputMaybe<SortEnumType>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAd?: InputMaybe<SortEnumType>;
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady?: InputMaybe<SortEnumType>;
  isTrial?: InputMaybe<SortEnumType>;
  lotNumber?: InputMaybe<SortEnumType>;
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  productionPlanName?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Resolved entity IDs set by the worker after successful lookups. */
export type ProductionLotImportRowIdsInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  sublocationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * User-provided field values during upload or correction.
 * Does not include resolved IDs - those are set separately by the worker.
 * Converted to ProductionLotImportRowData via named init-only assignment so
 * adjacent string columns cannot be silently swapped at the boundary.
 */
export type ProductionLotImportRowValuesInput = {
  category: Scalars['String']['input'];
  color: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  genus: Scalars['String']['input'];
  isAd: Scalars['Boolean']['input'];
  isTrial: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  plan: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
  series: Scalars['String']['input'];
  sublocation?: Scalars['String']['input'];
  weekReady: Scalars['String']['input'];
};

export type ProductionLotPayload = {
  __typename?: 'ProductionLotPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLot?: Maybe<ProductionLotStateData>;
};

export type ProductionLotStateData = {
  __typename?: 'ProductionLotStateData';
  closedStatus: LotClosedStatus;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  finishJob: ProductionJobData;
  isAd: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  status: ProductionLotStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionLotStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionLotStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionLotStatus>;
  in?: InputMaybe<Array<ProductionLotStatus>>;
  neq?: InputMaybe<ProductionLotStatus>;
  nin?: InputMaybe<Array<ProductionLotStatus>>;
};

/** A connection to a list of items. */
export type ProductionLotsConnection = {
  __typename?: 'ProductionLotsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotsEdge = {
  __typename?: 'ProductionLotsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotDocument;
};

export type ProductionMappingLineDataInput = {
  endIsoWeek?: InputMaybe<Scalars['Int']['input']>;
  endIsoYear?: InputMaybe<Scalars['Int']['input']>;
  mixPct?: InputMaybe<Scalars['Decimal']['input']>;
  productionItemId: Scalars['String']['input'];
  regions: Array<Scalars['String']['input']>;
  startIsoWeek?: InputMaybe<Scalars['Int']['input']>;
  startIsoYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductionMaterialEventDetailData = {
  __typename?: 'ProductionMaterialEventDetailData';
  description: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  multiple: Scalars['Decimal']['output'];
  productionMaterialEventDetailId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  triggerId: Scalars['String']['output'];
};

export type ProductionMaterialEventDetailDocument = {
  __typename?: 'ProductionMaterialEventDetailDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materialItemDescription: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  multiple: Scalars['Decimal']['output'];
  productionMaterialEventDetailId: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionMaterialEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionMaterialEventDetailDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  materialItemDescription?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  multiple?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionMaterialEventDetailDocumentFilterInput>>;
  productionMaterialEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionMaterialEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  triggerName?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionMaterialEventDetailDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materialItemDescription?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  multiple?: InputMaybe<SortEnumType>;
  productionMaterialEventDetailId?: InputMaybe<SortEnumType>;
  productionMaterialEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  triggerName?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionMaterialEventDetailsConnection = {
  __typename?: 'ProductionMaterialEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionMaterialEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionMaterialEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionMaterialEventDetailsEdge = {
  __typename?: 'ProductionMaterialEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionMaterialEventDetailDocument;
};

export type ProductionMaterialEventDocument = {
  __typename?: 'ProductionMaterialEventDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionMaterialEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionMaterialEventDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionMaterialEventDocumentFilterInput>>;
  productionMaterialEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionMaterialEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionMaterialEventDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionMaterialEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionMaterialEventPayload = {
  __typename?: 'ProductionMaterialEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionMaterialEventStateData>;
};

export type ProductionMaterialEventStateData = {
  __typename?: 'ProductionMaterialEventStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionMaterialEventDetailData>;
  name: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionMaterialEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionMaterialEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionMaterialEventStatus>;
  in?: InputMaybe<Array<ProductionMaterialEventStatus>>;
  neq?: InputMaybe<ProductionMaterialEventStatus>;
  nin?: InputMaybe<Array<ProductionMaterialEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionMaterialEventsConnection = {
  __typename?: 'ProductionMaterialEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionMaterialEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionMaterialEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionMaterialEventsEdge = {
  __typename?: 'ProductionMaterialEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionMaterialEventDocument;
};

export type ProductionPlanDocument = {
  __typename?: 'ProductionPlanDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  status: ProductionPlanStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionPlanDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionPlanDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionPlanDocumentFilterInput>>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionPlanStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionPlanDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionPlanPayload = {
  __typename?: 'ProductionPlanPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionPlan?: Maybe<ProductionPlanStateData>;
};

export type ProductionPlanStateData = {
  __typename?: 'ProductionPlanStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  status: ProductionPlanStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionPlanStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionPlanStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionPlanStatus>;
  in?: InputMaybe<Array<ProductionPlanStatus>>;
  neq?: InputMaybe<ProductionPlanStatus>;
  nin?: InputMaybe<Array<ProductionPlanStatus>>;
};

/** A connection to a list of items. */
export type ProductionPlansConnection = {
  __typename?: 'ProductionPlansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionPlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionPlanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionPlansEdge = {
  __typename?: 'ProductionPlansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionPlanDocument;
};

/**
 * The computed Bill-of-Materials for a production recipe variation. Derived from the
 * variation's referenced material events (excluding any explicitly excluded ones) by
 * flattening their details and joining with the material item catalog. There is no
 * dedicated BOM storage — this result is computed on demand.
 */
export type ProductionRecipeBom = {
  __typename?: 'ProductionRecipeBom';
  /** The number of distinct material items in the BOM. */
  distinctMaterialCount: Scalars['Int']['output'];
  /** The individual BOM entries (one per active material event detail). */
  entries: Array<ProductionRecipeBomEntry>;
  /** The production recipe identifier that owns this variation. */
  productionRecipeId: Scalars['String']['output'];
  /** The production recipe variation identifier the BOM was computed for. */
  productionRecipeVariationId: Scalars['String']['output'];
};

/**
 * A single Bill-of-Materials entry for a production recipe variation. Represents one
 * material item required by the variation via its referenced material events, with the
 * per-unit quantity (Multiple) pulled from the underlying material event detail.
 */
export type ProductionRecipeBomEntry = {
  __typename?: 'ProductionRecipeBomEntry';
  /** The detail description (denormalized from the material event detail). */
  description: Scalars['String']['output'];
  /** The production material event detail identifier that contributes this entry. */
  materialEventDetailId: Scalars['String']['output'];
  /** The production material event identifier that contributes this entry. */
  materialEventId: Scalars['String']['output'];
  /** The production material event name (denormalized for display). */
  materialEventName: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /** The quantity multiple from the material event detail (quantity per produced unit). */
  quantity: Scalars['Decimal']['output'];
};

/**
 * Denormalized default-variation scalars carried on the recipe summary document so the PWA
 * recipes grid can display growWeeks, plantsPerPot, and yield without an
 * N+1 variation fetch. "Default" follows the approved rule: the first variation ordered by
 * WeekRange.StartWeek ascending; a rangeless (base) variation sorts last. Recipes with
 * no variations resolve to None.
 */
export type ProductionRecipeDefaultVariationSummary = {
  __typename?: 'ProductionRecipeDefaultVariationSummary';
  growWeeks: Scalars['Int']['output'];
  plantsPerPot: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
};

/**
 * Per-page field resolvers for ProductionRecipeDocument. The defaultVariation
 * summary used to be enriched by a correlated $lookup inside BaseRecipeAggregate that
 * ran for EVERY recipe in the tenant before HotChocolate's paging $limit could cut the page —
 * on a large tenant (SFG, ~3,968 recipes) that whole-tenant fan-out (run twice thanks to
 * totalCount) blew red's ~5s request budget and hard-cancelled the query. Mirroring the
 * productionJobs fix (task 6ce6af8c / ProductionJobGraphType), the lookup is now a per-page,
 * [DataLoader]-batched resolver: it reads only the ≤page-size recipes HotChocolate actually
 * returns, so enrichment cost is O(pageSize), not O(all tenant recipes). Query-time semantics are
 * unchanged — the resolved value is byte-identical to the retired pipeline
 * (ProductionRecipeDefaultVariationSelector applies the same StartWeek/id ordering).
 */
export type ProductionRecipeDocument = {
  __typename?: 'ProductionRecipeDocument';
  /**
   * Task event IDs representing additional flat-rate costs (packaging, shipping, etc.).
   * Defaults to empty array for existing documents that predate this field (no migration required).
   */
  additionalCostEventIds: Array<Scalars['String']['output']>;
  catalogColor: Scalars['String']['output'];
  catalogGenus: Scalars['String']['output'];
  catalogSeries: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The recipe's default-variation scalars (grow weeks / plants-per-pot / yield), or null when the
   * recipe has no variations. Resolved per page from the variations read model via a batched
   * DataLoader; never persisted by the projection, so no replay-purity constraint applies. Returns a
   * nullable reference (not Option<T>) because HotChocolate cannot infer an output schema
   * type from an Option of a complex type — the nullable maps to the same
   * defaultVariation: ProductionRecipeDefaultVariationSummary field the document property
   * previously produced, so the output surface is unchanged.
   */
  defaultVariation?: Maybe<ProductionRecipeDefaultVariationSummary>;
  id: Scalars['String']['output'];
  isCombo: Scalars['Boolean']['output'];
  isStartRecipe: Scalars['Boolean']['output'];
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource: RecipeLaborSource;
  numberOfVariations: Scalars['Int']['output'];
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  status: ProductionRecipeStatus;
  /**
   * Recipe-level task event IDs available for the recipe. The effective list of
   * task events for a variation is
   * (recipe.TaskEventIds ∪ variation.TaskEventIds) − variation.ExcludedTaskEventIds,
   * and this resolution is the responsibility of the frontend.
   *
   * The PWA is the source of truth for the effective list: at variation-save time it
   * merges the recipe header and variation lists and persists the merged result into
   * ProductionRecipeVariationDocument.TaskEventIds. All backend readers
   * (cost resolution, labor demand, job/work-order generation, item-program projection)
   * therefore read only the variation-level list — they must NOT re-merge recipe-header
   * IDs, or they would duplicate the frontend's responsibility and create two sources
   * of truth.
   *
   *
   * The recipe-header field is kept so the PWA can round-trip the authored list
   * independently of any specific variation. Introducing a backend merge helper is
   * explicitly out of scope for this audit.
   *
   *
   * Defaults to empty array for existing documents that predate this field
   * (no migration required).
   */
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version: Scalars['Int']['output'];
};

export type ProductionRecipeDocumentFilterInput = {
  /**
   * Task event IDs representing additional flat-rate costs (packaging, shipping, etc.).
   * Defaults to empty array for existing documents that predate this field (no migration required).
   */
  additionalCostEventIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionRecipeDocumentFilterInput>>;
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isCombo?: InputMaybe<BooleanOperationFilterInput>;
  isStartRecipe?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource?: InputMaybe<RecipeLaborSourceOperationFilterInput>;
  numberOfVariations?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeDocumentFilterInput>>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionRecipeStatusOperationFilterInput>;
  /**
   * Recipe-level task event IDs available for the recipe. The effective list of
   * task events for a variation is
   * (recipe.TaskEventIds ∪ variation.TaskEventIds) − variation.ExcludedTaskEventIds,
   * and this resolution is the responsibility of the frontend.
   *
   * The PWA is the source of truth for the effective list: at variation-save time it
   * merges the recipe header and variation lists and persists the merged result into
   * ProductionRecipeVariationDocument.TaskEventIds. All backend readers
   * (cost resolution, labor demand, job/work-order generation, item-program projection)
   * therefore read only the variation-level list — they must NOT re-merge recipe-header
   * IDs, or they would duplicate the frontend's responsibility and create two sources
   * of truth.
   *
   *
   * The recipe-header field is kept so the PWA can round-trip the authored list
   * independently of any specific variation. Introducing a backend merge helper is
   * explicitly out of scope for this audit.
   *
   *
   * Defaults to empty array for existing documents that predate this field
   * (no migration required).
   */
  taskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ProductionRecipeDocumentSortInput = {
  catalogColor?: InputMaybe<SortEnumType>;
  catalogGenus?: InputMaybe<SortEnumType>;
  catalogSeries?: InputMaybe<SortEnumType>;
  categoryCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCombo?: InputMaybe<SortEnumType>;
  isStartRecipe?: InputMaybe<SortEnumType>;
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource?: InputMaybe<SortEnumType>;
  numberOfVariations?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version?: InputMaybe<SortEnumType>;
};

/**
 * One group header for the Recipes sidebar: the group's Key (also used as the
 * where value when lazy-loading the group's children), a display Label, and
 * the server-computed Count of recipes in the group under the active search.
 */
export type ProductionRecipeGroupBucket = {
  __typename?: 'ProductionRecipeGroupBucket';
  /** Number of recipes in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — category code, or "{genus} {series}" for catalog. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for productionRecipeGroups. Mirrors the Recipes sidebar's group-by
 * options so the client can render server-computed group headers instead of grouping the full
 * catalog in memory: Category buckets on the joined category code, Catalog buckets
 * on the joined catalog "{genus} {series}" identity.
 */
export enum ProductionRecipeGroupField {
  /** One bucket per distinct catalog identity ("{genus} {series}"). */
  Catalog = 'CATALOG',
  /** One bucket per distinct category code. */
  Category = 'CATEGORY'
}

/**
 * A single entry in the production recipe audit history, derived from the recipe event stream.
 * Each record corresponds to one event stored in KurrentDB for the recipe.
 */
export type ProductionRecipeHistoryRecord = {
  __typename?: 'ProductionRecipeHistoryRecord';
  /** The domain event type name (e.g. "Production.V1.RecipeCreated"). */
  eventType: Scalars['String']['output'];
  /** The unique event identifier from the event store. */
  id: Scalars['String']['output'];
  /** When the event was originally recorded. */
  occurredAt: Scalars['DateTime']['output'];
  /** The user (email or id) that performed the action, if known. */
  occurredBy: Scalars['String']['output'];
  /** A human-readable description of the action. */
  summary: Scalars['String']['output'];
};

export type ProductionRecipeLink = {
  __typename?: 'ProductionRecipeLink';
  componentsPerPot?: Maybe<Scalars['Int']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
};

export type ProductionRecipeLinkData = {
  __typename?: 'ProductionRecipeLinkData';
  catalogColor: Scalars['String']['output'];
  catalogGenus: Scalars['String']['output'];
  catalogSeries: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  componentsPerPot?: Maybe<Scalars['Int']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCatalogIdWithTenant: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionCategoryIdWithTenant: Scalars['String']['output'];
};

export type ProductionRecipeLinkDataFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeLinkDataFilterInput>>;
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  componentsPerPot?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeLinkDataFilterInput>>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCatalogIdWithTenant?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryIdWithTenant?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionRecipeLinkInput = {
  componentsPerPot?: InputMaybe<Scalars['Int']['input']>;
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
};

export type ProductionRecipePayload = {
  __typename?: 'ProductionRecipePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
};

export type ProductionRecipeStateData = {
  __typename?: 'ProductionRecipeStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  isCombo: Scalars['Boolean']['output'];
  isStartRecipe: Scalars['Boolean']['output'];
  laborSource: RecipeLaborSource;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  status: ProductionRecipeStatus;
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  variations: Array<ProductionRecipeVariationData>;
  version: Scalars['Int']['output'];
};

export enum ProductionRecipeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionRecipeStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionRecipeStatus>;
  in?: InputMaybe<Array<ProductionRecipeStatus>>;
  neq?: InputMaybe<ProductionRecipeStatus>;
  nin?: InputMaybe<Array<ProductionRecipeStatus>>;
};

export type ProductionRecipeVariationData = {
  __typename?: 'ProductionRecipeVariationData';
  customerId?: Maybe<Scalars['String']['output']>;
  excludedMaterialEventIds: Array<Scalars['String']['output']>;
  excludedSpaceEventIds: Array<Scalars['String']['output']>;
  excludedTaskEventIds: Array<Scalars['String']['output']>;
  growWeeks: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  links: Array<ProductionRecipeLink>;
  materialEventIds: Array<Scalars['String']['output']>;
  plantsPerPot: Scalars['Int']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  spaceEventIds: Array<Scalars['String']['output']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideData>;
  taskEventIds: Array<Scalars['String']['output']>;
  weekRange?: Maybe<ProductionRecipeWeekRange>;
  yield: Scalars['Decimal']['output'];
};

export type ProductionRecipeVariationDataInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  excludedMaterialEventIds: Array<Scalars['String']['input']>;
  excludedSpaceEventIds: Array<Scalars['String']['input']>;
  excludedTaskEventIds: Array<Scalars['String']['input']>;
  growWeeks: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  links: Array<ProductionRecipeLinkInput>;
  materialEventIds: Array<Scalars['String']['input']>;
  plantsPerPot: Scalars['Int']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceEventIds: Array<Scalars['String']['input']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideDataInput>;
  taskEventIds: Array<Scalars['String']['input']>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeInput>;
  yield: Scalars['Decimal']['input'];
};

export type ProductionRecipeVariationDocument = {
  __typename?: 'ProductionRecipeVariationDocument';
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: Maybe<Scalars['String']['output']>;
  excludedMaterialEventIds: Array<Scalars['String']['output']>;
  excludedSpaceEventIds: Array<Scalars['String']['output']>;
  excludedTaskEventIds: Array<Scalars['String']['output']>;
  growWeeks: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  links: Array<ProductionRecipeLinkData>;
  materialEventIds: Array<Scalars['String']['output']>;
  plantsPerPot: Scalars['Int']['output'];
  productionRecipeId: Scalars['String']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  spaceEventIds: Array<Scalars['String']['output']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideDocument>;
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  weekRange?: Maybe<ProductionRecipeWeekRange>;
  yield: Scalars['Decimal']['output'];
};

export type ProductionRecipeVariationDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeVariationDocumentFilterInput>>;
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  excludedMaterialEventIds?: InputMaybe<ListStringOperationFilterInput>;
  excludedSpaceEventIds?: InputMaybe<ListStringOperationFilterInput>;
  excludedTaskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  growWeeks?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  links?: InputMaybe<ListFilterInputTypeOfProductionRecipeLinkDataFilterInput>;
  materialEventIds?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeVariationDocumentFilterInput>>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  spaceEventIds?: InputMaybe<ListStringOperationFilterInput>;
  taskEventAssignmentOverrides?: InputMaybe<ListFilterInputTypeOfEventAssignmentOverrideDocumentFilterInput>;
  taskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeFilterInput>;
  yield?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductionRecipeVariationDocumentSortInput = {
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: InputMaybe<SortEnumType>;
  growWeeks?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  plantsPerPot?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  productionRecipeVariationId?: InputMaybe<SortEnumType>;
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeSortInput>;
  yield?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionRecipeVariationsConnection = {
  __typename?: 'ProductionRecipeVariationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionRecipeVariationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionRecipeVariationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionRecipeVariationsEdge = {
  __typename?: 'ProductionRecipeVariationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionRecipeVariationDocument;
};

export type ProductionRecipeWeekRange = {
  __typename?: 'ProductionRecipeWeekRange';
  endWeek: Scalars['Int']['output'];
  startWeek: Scalars['Int']['output'];
};

export type ProductionRecipeWeekRangeFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeWeekRangeFilterInput>>;
  endWeek?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeWeekRangeFilterInput>>;
  startWeek?: InputMaybe<IntOperationFilterInput>;
};

export type ProductionRecipeWeekRangeInput = {
  endWeek: Scalars['Int']['input'];
  startWeek: Scalars['Int']['input'];
};

export type ProductionRecipeWeekRangeSortInput = {
  endWeek?: InputMaybe<SortEnumType>;
  startWeek?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionRecipesConnection = {
  __typename?: 'ProductionRecipesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionRecipesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionRecipeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionRecipesEdge = {
  __typename?: 'ProductionRecipesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionRecipeDocument;
};

/** A connection to a list of items. */
export type ProductionSpaceCategoriesConnection = {
  __typename?: 'ProductionSpaceCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceCategoriesEdge = {
  __typename?: 'ProductionSpaceCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceCategoryDocument;
};

export type ProductionSpaceCategoryDimensionOverrideData = {
  __typename?: 'ProductionSpaceCategoryDimensionOverrideData';
  customerId?: Maybe<Scalars['String']['output']>;
  length: Scalars['Decimal']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  spaceTypeId?: Maybe<Scalars['String']['output']>;
  stagger: Scalars['Boolean']['output'];
  width: Scalars['Decimal']['output'];
};

export type ProductionSpaceCategoryDocument = {
  __typename?: 'ProductionSpaceCategoryDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** The default length applied when no site-specific override exists. */
  defaultLength?: Maybe<Scalars['Decimal']['output']>;
  /** The default hex-packing (stagger) flag applied when no override exists. */
  defaultStagger: Scalars['Boolean']['output'];
  /** The default width applied when no site-specific override exists. */
  defaultWidth?: Maybe<Scalars['Decimal']['output']>;
  /** All dimension overrides for this category, one row per (site?, customer?, spaceType?) override scope. */
  dimensionOverrides: Array<ProductionSpaceCategoryDimensionOverrideData>;
  /** Returns the effective dimensions for a site, customer, and/or space type, applying the most-specific-wins precedence with the tie-break customer > site > space type. */
  effectiveDimensions?: Maybe<SpaceCategoryDimensionsData>;
  id: Scalars['String']['output'];
  /** @deprecated Use defaultLength. */
  length?: Maybe<Scalars['Decimal']['output']>;
  productionSpaceCategoryId: Scalars['String']['output'];
  /** @deprecated Use dimensionOverrides, which also includes customer-scoped overrides. */
  siteOverrides: Array<ProductionSpaceCategorySiteOverrideData>;
  status: ProductionSpaceCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  /** @deprecated Use defaultWidth. */
  width?: Maybe<Scalars['Decimal']['output']>;
};


export type ProductionSpaceCategoryDocumentEffectiveDimensionsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionSpaceCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceCategoryDocumentFilterInput>>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceCategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductionSpaceCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceCategoryPayload = {
  __typename?: 'ProductionSpaceCategoryPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionSpaceCategory?: Maybe<ProductionSpaceCategoryStateData>;
};

export type ProductionSpaceCategorySiteOverrideData = {
  __typename?: 'ProductionSpaceCategorySiteOverrideData';
  length: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

export type ProductionSpaceCategoryStateData = {
  __typename?: 'ProductionSpaceCategoryStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  length: Scalars['Decimal']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  stagger: Scalars['Boolean']['output'];
  status: ProductionSpaceCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

export enum ProductionSpaceCategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceCategoryStatus>;
  in?: InputMaybe<Array<ProductionSpaceCategoryStatus>>;
  neq?: InputMaybe<ProductionSpaceCategoryStatus>;
  nin?: InputMaybe<Array<ProductionSpaceCategoryStatus>>;
};

export type ProductionSpaceEventDetailData = {
  __typename?: 'ProductionSpaceEventDetailData';
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventDetailId: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  triggerId: Scalars['String']['output'];
};

export type ProductionSpaceEventDetailDocument = {
  __typename?: 'ProductionSpaceEventDetailDocument';
  categoryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventDetailId: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  typeCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionSpaceEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceEventDetailDocumentFilterInput>>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceEventDetailDocumentFilterInput>>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceEventId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceTypeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  triggerName?: InputMaybe<StringOperationFilterInput>;
  typeCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionSpaceEventDetailDocumentSortInput = {
  categoryCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  productionSpaceEventDetailId?: InputMaybe<SortEnumType>;
  productionSpaceEventId?: InputMaybe<SortEnumType>;
  productionSpaceTypeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  triggerName?: InputMaybe<SortEnumType>;
  typeCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionSpaceEventDetailsConnection = {
  __typename?: 'ProductionSpaceEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceEventDetailsEdge = {
  __typename?: 'ProductionSpaceEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceEventDetailDocument;
};

export type ProductionSpaceEventDocument = {
  __typename?: 'ProductionSpaceEventDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionSpaceEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceEventDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceEventDocumentFilterInput>>;
  productionSpaceEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionSpaceEventDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionSpaceEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceEventPayload = {
  __typename?: 'ProductionSpaceEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionSpaceEventStateData>;
};

export type ProductionSpaceEventStateData = {
  __typename?: 'ProductionSpaceEventStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionSpaceEventDetailData>;
  name: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionSpaceEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceEventStatus>;
  in?: InputMaybe<Array<ProductionSpaceEventStatus>>;
  neq?: InputMaybe<ProductionSpaceEventStatus>;
  nin?: InputMaybe<Array<ProductionSpaceEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionSpaceEventsConnection = {
  __typename?: 'ProductionSpaceEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceEventsEdge = {
  __typename?: 'ProductionSpaceEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceEventDocument;
};

export type ProductionSpaceTypeDocument = {
  __typename?: 'ProductionSpaceTypeDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceTypeStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionSpaceTypeDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceTypeDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceTypeDocumentFilterInput>>;
  productionSpaceTypeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceTypeStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionSpaceTypeDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productionSpaceTypeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceTypePayload = {
  __typename?: 'ProductionSpaceTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionSpaceType?: Maybe<ProductionSpaceTypeStateData>;
};

export type ProductionSpaceTypeStateData = {
  __typename?: 'ProductionSpaceTypeStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceTypeStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionSpaceTypeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceTypeStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceTypeStatus>;
  in?: InputMaybe<Array<ProductionSpaceTypeStatus>>;
  neq?: InputMaybe<ProductionSpaceTypeStatus>;
  nin?: InputMaybe<Array<ProductionSpaceTypeStatus>>;
};

/** A connection to a list of items. */
export type ProductionSpaceTypesConnection = {
  __typename?: 'ProductionSpaceTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceTypesEdge = {
  __typename?: 'ProductionSpaceTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceTypeDocument;
};

export type ProductionTaskEventDetailData = {
  __typename?: 'ProductionTaskEventDetailData';
  description: Scalars['String']['output'];
  materialItemId?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Decimal']['output'];
  productionTaskEventDetailId: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: ProductionTaskEventStatus;
  taskEventType?: Maybe<TaskEventTypeDocument>;
  taskEventTypeId: Scalars['String']['output'];
  /**
   * Resolved name of the referenced TaskEventType, denormalized into the mutation
   * response. Resolved synchronously in the mutation post-pipeline from
   * TaskEventTypeDocument; empty when the id has not yet been projected
   * or the document is unavailable.
   */
  taskEventTypeName: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
};

export type ProductionTaskEventDetailDocument = {
  __typename?: 'ProductionTaskEventDetailDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materialItemDescription?: Maybe<Scalars['String']['output']>;
  materialItemId?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Decimal']['output'];
  productionTaskEventDetailId: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  taskEventType?: Maybe<TaskEventTypeDocument>;
  taskEventTypeId: Scalars['String']['output'];
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTaskEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTaskEventDetailDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  materialItemDescription?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  multiple?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTaskEventDetailDocumentFilterInput>>;
  productionTaskEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionTaskEventId?: InputMaybe<StringOperationFilterInput>;
  sequence?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  taskEventTypeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  triggerName?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTaskEventDetailDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materialItemDescription?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  multiple?: InputMaybe<SortEnumType>;
  productionTaskEventDetailId?: InputMaybe<SortEnumType>;
  productionTaskEventId?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventTypeId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  triggerName?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionTaskEventDetailsConnection = {
  __typename?: 'ProductionTaskEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTaskEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTaskEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTaskEventDetailsEdge = {
  __typename?: 'ProductionTaskEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTaskEventDetailDocument;
};

export type ProductionTaskEventDocument = {
  __typename?: 'ProductionTaskEventDocument';
  costEffectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  costEffectiveTo?: Maybe<Scalars['DateTime']['output']>;
  costPerEvent?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborTypeTagId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  status: ProductionTaskEventStatus;
  tenantId: Scalars['String']['output'];
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTaskEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTaskEventDocumentFilterInput>>;
  costEffectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  costEffectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  costPerEvent?: InputMaybe<DecimalOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborTypeTagId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTaskEventDocumentFilterInput>>;
  productionTaskEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionTaskEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitsPerHour?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTaskEventDocumentSortInput = {
  costEffectiveFrom?: InputMaybe<SortEnumType>;
  costEffectiveTo?: InputMaybe<SortEnumType>;
  costPerEvent?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborTypeTagId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionTaskEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitsPerHour?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionTaskEventPayload = {
  __typename?: 'ProductionTaskEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionTaskEventStateData>;
};

export type ProductionTaskEventStateData = {
  __typename?: 'ProductionTaskEventStateData';
  costEffectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  costEffectiveTo?: Maybe<Scalars['DateTime']['output']>;
  costPerEvent?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionTaskEventDetailData>;
  laborTypeTagId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  status: ProductionTaskEventStatus;
  tenantId: Scalars['String']['output'];
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionTaskEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionTaskEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionTaskEventStatus>;
  in?: InputMaybe<Array<ProductionTaskEventStatus>>;
  neq?: InputMaybe<ProductionTaskEventStatus>;
  nin?: InputMaybe<Array<ProductionTaskEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionTaskEventsConnection = {
  __typename?: 'ProductionTaskEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTaskEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTaskEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTaskEventsEdge = {
  __typename?: 'ProductionTaskEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTaskEventDocument;
};

export type ProductionTriggerDocument = {
  __typename?: 'ProductionTriggerDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expireBy: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  productionTriggerId: Scalars['String']['output'];
  source: ProductionTriggerSource;
  status: ProductionTriggerStatus;
  tenantId: Scalars['String']['output'];
  unit: ProductionTriggerUnit;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTriggerDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTriggerDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  expireBy?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  offset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTriggerDocumentFilterInput>>;
  productionTriggerId?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<ProductionTriggerSourceOperationFilterInput>;
  status?: InputMaybe<ProductionTriggerStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unit?: InputMaybe<ProductionTriggerUnitOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTriggerDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  expireBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  offset?: InputMaybe<SortEnumType>;
  productionTriggerId?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionTriggerPayload = {
  __typename?: 'ProductionTriggerPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionTrigger?: Maybe<ProductionTriggerStateData>;
};

export enum ProductionTriggerSource {
  ReadyWeek = 'READY_WEEK',
  StartWeek = 'START_WEEK'
}

export type ProductionTriggerSourceOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerSource>;
  in?: InputMaybe<Array<ProductionTriggerSource>>;
  neq?: InputMaybe<ProductionTriggerSource>;
  nin?: InputMaybe<Array<ProductionTriggerSource>>;
};

export type ProductionTriggerStateData = {
  __typename?: 'ProductionTriggerStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expireBy: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  productionTriggerId: Scalars['String']['output'];
  source: ProductionTriggerSource;
  status: ProductionTriggerStatus;
  tenantId: Scalars['String']['output'];
  unit: ProductionTriggerUnit;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionTriggerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionTriggerStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerStatus>;
  in?: InputMaybe<Array<ProductionTriggerStatus>>;
  neq?: InputMaybe<ProductionTriggerStatus>;
  nin?: InputMaybe<Array<ProductionTriggerStatus>>;
};

export enum ProductionTriggerUnit {
  Day = 'DAY',
  Week = 'WEEK'
}

export type ProductionTriggerUnitOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerUnit>;
  in?: InputMaybe<Array<ProductionTriggerUnit>>;
  neq?: InputMaybe<ProductionTriggerUnit>;
  nin?: InputMaybe<Array<ProductionTriggerUnit>>;
};

/** A connection to a list of items. */
export type ProductionTriggersConnection = {
  __typename?: 'ProductionTriggersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTriggersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTriggerDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTriggersEdge = {
  __typename?: 'ProductionTriggersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTriggerDocument;
};

export type ProgramDocument = {
  __typename?: 'ProgramDocument';
  id: Scalars['String']['output'];
  program: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ProgramDocumentFilterInput = {
  and?: InputMaybe<Array<ProgramDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProgramDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ProgramDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type ProgramReplenishmentSettingsDocument = {
  __typename?: 'ProgramReplenishmentSettingsDocument';
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  program: Scalars['String']['output'];
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProgramReplenishmentSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProgramReplenishmentSettingsDocumentSortInput = {
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProgramWindowConfigDataInput = {
  minUsableDaysThreshold?: InputMaybe<Scalars['Int']['input']>;
  program: Scalars['String']['input'];
  sellThroughThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  trailingDaysThisYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramWindowConfigStateData = {
  __typename?: 'ProgramWindowConfigStateData';
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  program: Scalars['String']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  trailingDaysThisYear?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type ProgramsConnection = {
  __typename?: 'ProgramsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProgramsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProgramDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProgramsEdge = {
  __typename?: 'ProgramsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProgramDocument;
};

export enum ProjectionHealth {
  Error = 'ERROR',
  Running = 'RUNNING',
  Stopped = 'STOPPED'
}

export type ProjectionHealthOperationFilterInput = {
  eq?: InputMaybe<ProjectionHealth>;
  in?: InputMaybe<Array<ProjectionHealth>>;
  neq?: InputMaybe<ProjectionHealth>;
  nin?: InputMaybe<Array<ProjectionHealth>>;
};

export type ProjectionStatusDocument = {
  __typename?: 'ProjectionStatusDocument';
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastProcessedPosition?: Maybe<Scalars['Long']['output']>;
  lastUpdated: Scalars['DateTime']['output'];
  projectionName: Scalars['String']['output'];
  status: ProjectionHealth;
};

export type ProjectionStatusDocumentFilterInput = {
  and?: InputMaybe<Array<ProjectionStatusDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastError?: InputMaybe<StringOperationFilterInput>;
  lastProcessedPosition?: InputMaybe<LongOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProjectionStatusDocumentFilterInput>>;
  projectionName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProjectionHealthOperationFilterInput>;
};

export type ProjectionStatusDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  lastError?: InputMaybe<SortEnumType>;
  lastProcessedPosition?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  projectionName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type PromotionRulePayload = {
  __typename?: 'PromotionRulePayload';
  errors?: Maybe<Array<ValidationError>>;
  promotionRule?: Maybe<PromotionRuleStateData>;
};

export type PromotionRuleStateData = {
  __typename?: 'PromotionRuleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  promotionRuleId: Scalars['String']['output'];
  quantityFloor: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: PromotionRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum PromotionRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type PublicUserInviteAcceptPayload = {
  __typename?: 'PublicUserInviteAcceptPayload';
  accepted: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ValidationError>>;
  validity: UserInviteValidity;
};

/**
 * Public code-lookup payload. RecipientEmail and ChangePasswordId are populated only
 * when the code is Valid; unknown and deleted codes both return
 * NotFound so the anonymous surface is not an enumeration oracle.
 * ChangePasswordId is the FusionAuth one-time set-password token the registration page uses
 * to set the password inline — it is a single-use token scoped to this invite's user, released
 * only to the holder of the (CSPRNG) invite code, the same trust boundary the code already gates.
 */
export type PublicUserInvitePayload = {
  __typename?: 'PublicUserInvitePayload';
  changePasswordId?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  validity: UserInviteValidity;
};

/** Service-to-service publish input. One call per BulkWriteAsync batch. */
export type PublishRestockWorkQueueResultBatchInput = {
  calcDate: Scalars['DateTime']['input'];
  rows: Array<RestockWorkQueueResultBatchRowDataInput>;
  tenantId: Scalars['String']['input'];
};

export type PurchaseOrderAllocationDocument = {
  __typename?: 'PurchaseOrderAllocationDocument';
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  items: Array<AllocationLineItemData>;
  orderId: Scalars['String']['output'];
  purchaseOrderId: Scalars['String']['output'];
  status: PurchaseOrderAllocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type PurchaseOrderAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderAllocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfAllocationLineItemDataFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  purchaseOrderId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<PurchaseOrderAllocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PurchaseOrderAllocationDocumentSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  purchaseOrderId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type PurchaseOrderAllocationPayload = {
  __typename?: 'PurchaseOrderAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  purchaseOrderAllocation?: Maybe<PurchaseOrderAllocationDocument>;
};

export enum PurchaseOrderAllocationStatus {
  Active = 'ACTIVE',
  Deallocated = 'DEALLOCATED'
}

export type PurchaseOrderAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<PurchaseOrderAllocationStatus>;
  in?: InputMaybe<Array<PurchaseOrderAllocationStatus>>;
  neq?: InputMaybe<PurchaseOrderAllocationStatus>;
  nin?: InputMaybe<Array<PurchaseOrderAllocationStatus>>;
};

/** A connection to a list of items. */
export type PurchaseOrderAllocationsConnection = {
  __typename?: 'PurchaseOrderAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PurchaseOrderAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PurchaseOrderAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PurchaseOrderAllocationsEdge = {
  __typename?: 'PurchaseOrderAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PurchaseOrderAllocationDocument;
};

/**
 * One spec file's results. Video and Screenshots are RELATIVE blob
 * paths within the qa-media container — the publisher uploads the files itself and sends
 * only their paths, so large videos never travel through GraphQL.
 */
export type QaFlowInput = {
  durationSec: Scalars['Int']['input'];
  module: Scalars['String']['input'];
  screenshots: Array<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
  status: Scalars['String']['input'];
  tests: Array<QaFlowTestInput>;
  title: Scalars['String']['input'];
  video?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One spec file's results, with Video/Screenshots already composed into
 * absolute URLs so the client never has to know the storage layout.
 */
export type QaFlowResult = {
  __typename?: 'QaFlowResult';
  durationSec: Scalars['Int']['output'];
  module: Scalars['String']['output'];
  screenshots: Array<Scalars['String']['output']>;
  spec: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tests: Array<QaFlowTestResult>;
  title: Scalars['String']['output'];
  video?: Maybe<Scalars['String']['output']>;
};

/**
 * One test result submitted by the publisher. There is no isNew field: regression status is
 * computed server-side at ingest, so a publisher cannot assert it.
 */
export type QaFlowTestInput = {
  /** Relative blob path of this test's cut video segment, if one was produced. */
  clip?: InputMaybe<Scalars['String']['input']>;
  durationMs: Scalars['Long']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  skipReason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  videoStart?: InputMaybe<Scalars['Float']['input']>;
};

/** One test within a flow, as returned to the dashboard. */
export type QaFlowTestResult = {
  __typename?: 'QaFlowTestResult';
  /** Absolute URL of this failing test's cut video segment. */
  clip?: Maybe<Scalars['String']['output']>;
  durationMs: Scalars['Long']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  videoStart?: Maybe<Scalars['Float']['output']>;
};

/**
 * Aggregate tallies submitted with a run. Sent by the publisher rather than derived here so the
 * dashboard reports exactly what Playwright reported, including outcomes wsapi does not model.
 */
export type QaRunCountsInput = {
  failed: Scalars['Int']['input'];
  flaky: Scalars['Int']['input'];
  passed: Scalars['Int']['input'];
  skipped: Scalars['Int']['input'];
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResult = {
  __typename?: 'QaRunCountsResult';
  failed: Scalars['Int']['output'];
  flaky: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResultFilterInput = {
  and?: InputMaybe<Array<QaRunCountsResultFilterInput>>;
  failed?: InputMaybe<IntOperationFilterInput>;
  flaky?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<QaRunCountsResultFilterInput>>;
  passed?: InputMaybe<IntOperationFilterInput>;
  skipped?: InputMaybe<IntOperationFilterInput>;
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResultSortInput = {
  failed?: InputMaybe<SortEnumType>;
  flaky?: InputMaybe<SortEnumType>;
  passed?: InputMaybe<SortEnumType>;
  skipped?: InputMaybe<SortEnumType>;
};

/**
 * Result of an ingest. Follows the repo's payload convention: Data on success,
 * Errors on a validation failure, never both.
 */
export type QaTestRunPayload = {
  __typename?: 'QaTestRunPayload';
  data?: Maybe<QaTestRunResult>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Full detail for a single run — the summary fields plus every flow. */
export type QaTestRunResult = {
  __typename?: 'QaTestRunResult';
  adoUrl?: Maybe<Scalars['String']['output']>;
  appBuild?: Maybe<Scalars['String']['output']>;
  counts: QaRunCountsResult;
  dateUtc: Scalars['DateTime']['output'];
  durationSec: Scalars['Int']['output'];
  flows: Array<QaFlowResult>;
  id: Scalars['String']['output'];
  ingestedAt: Scalars['DateTime']['output'];
  partial: Scalars['Boolean']['output'];
  result: Scalars['String']['output'];
  suite: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResult = {
  __typename?: 'QaTestRunSummaryResult';
  adoUrl?: Maybe<Scalars['String']['output']>;
  appBuild?: Maybe<Scalars['String']['output']>;
  counts: QaRunCountsResult;
  dateUtc: Scalars['DateTime']['output'];
  durationSec: Scalars['Int']['output'];
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  partial: Scalars['Boolean']['output'];
  result: Scalars['String']['output'];
  suite: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResultFilterInput = {
  adoUrl?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<QaTestRunSummaryResultFilterInput>>;
  appBuild?: InputMaybe<StringOperationFilterInput>;
  counts?: InputMaybe<QaRunCountsResultFilterInput>;
  dateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  durationSec?: InputMaybe<IntOperationFilterInput>;
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QaTestRunSummaryResultFilterInput>>;
  partial?: InputMaybe<BooleanOperationFilterInput>;
  result?: InputMaybe<StringOperationFilterInput>;
  suite?: InputMaybe<StringOperationFilterInput>;
  trigger?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResultSortInput = {
  adoUrl?: InputMaybe<SortEnumType>;
  appBuild?: InputMaybe<SortEnumType>;
  counts?: InputMaybe<QaRunCountsResultSortInput>;
  dateUtc?: InputMaybe<SortEnumType>;
  durationSec?: InputMaybe<SortEnumType>;
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  partial?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  suite?: InputMaybe<SortEnumType>;
  trigger?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type QaTestRunsConnection = {
  __typename?: 'QaTestRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<QaTestRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<QaTestRunSummaryResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type QaTestRunsEdge = {
  __typename?: 'QaTestRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QaTestRunSummaryResult;
};

/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Returns the calling tenant's accounting integration policy. Never null: when nothing has been
   * persisted the per-tenant defaults are applied (provider-agnostic + summary-out + no pull yet)
   * via String). The tenant is resolved from the
   * caller's context (no tenant-id parameter) so a tenant can never read another tenant's policy.
   */
  accountingIntegrationConfig: AccountingIntegrationConfigDocument;
  /**
   * Returns the authenticated user's in-flight import jobs — those in
   * AsyncImportJobStatus.Uploading, AsyncImportJobStatus.Pending,
   * AsyncImportJobStatus.Validating, AsyncImportJobStatus.Validated,
   * AsyncImportJobStatus.ReadyForImport, or AsyncImportJobStatus.Importing
   * status. AsyncImportJobStatus.Uploading is the first pre-completion active state —
   * a job is Uploading from creation until finalizeImportUpload; including it closes the
   * cross-tab/reload race where a second concurrent import could start during the upload window.
   * Scoped to the caller's tenant and the caller's own jobs (matched on
   * AsyncImportJobDocument.CreatedBy) so the UI can detect and block concurrent
   * import starts across the full active workflow.
   */
  activeImportJobs?: Maybe<ActiveImportJobsConnection>;
  /**
   * All active portal-user mappings across tenants for a given email, read from the unified
   * WorkSuiteUsers read model (active Portal users). SuperAdmin-only.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  activePortalUsersByEmail: Array<ActivePortalUserMapping>;
  /** Returns the full admin background service config document for a given service name. */
  adminBackgroundServiceConfig?: Maybe<AdminBackgroundServiceConfigDocument>;
  /** Lists all background service configs with filtering, sorting, and paging for admin management. */
  adminBackgroundServiceConfigs?: Maybe<AdminBackgroundServiceConfigsConnection>;
  /**
   * Returns one row per (pod x background service) pair so the admin PWA "Pods" tab can
   * render services grouped by pod without N+1 detail calls. Services with empty
   * PodAssignments produce no rows. AdminBackgroundServicePodResult.NotTenants
   * is the raw flag — exclusion math is left to the manifest query for runtime use.
   */
  adminBackgroundServicePods: Array<AdminBackgroundServicePodResult>;
  /**
   * Most recent CalcDate produced for a tenant. Powers the SLO/freshness indicator.
   * Returns null when the tenant has no results yet.
   */
  adminDbrCalcLatestResultDate?: Maybe<Scalars['DateTime']['output']>;
  /** Single result for a (tenant, customer, item, location) key. Returns null when no result has been computed. */
  adminDbrCalcResult?: Maybe<DbrCalcResultDocument>;
  /** All results for a single customer across the tenant's items and locations. */
  adminDbrCalcResultsByCustomer?: Maybe<AdminDbrCalcResultsByCustomerConnection>;
  /** All results for a single item across the tenant's locations. */
  adminDbrCalcResultsByItem?: Maybe<AdminDbrCalcResultsByItemConnection>;
  /** All results for a single location across the tenant's items. */
  adminDbrCalcResultsByLocation?: Maybe<AdminDbrCalcResultsByLocationConnection>;
  /** Paginated cursor connection of all results for a tenant. Supports filtering and sorting. */
  adminDbrCalcResultsByTenant?: Maybe<AdminDbrCalcResultsByTenantConnection>;
  /**
   * Scheduler heartbeat status: most recent EntityType.DbrCalcScheduler
   * iteration timestamp, and the configured tick interval from the admin background
   * service config. Either field is null when the corresponding source has no data.
   */
  adminDbrCalcSchedulerStatus: DbrCalcSchedulerStatusResult;
  /**
   * Full queue across all tenants. Powers the SuperAdmin queue inspector;
   * supports filtering, sorting, and paging via HotChocolate middleware.
   */
  adminDbrCalcTenantQueue?: Maybe<AdminDbrCalcTenantQueueConnection>;
  /**
   * Per-tenant calculation backlog summary. Returns null when the tenant has
   * no queue row (i.e. the scheduler has not yet observed it) or when the
   * supplied tenantId is not a valid tenant id.
   */
  adminDbrCalcWorkSummary?: Maybe<DbrCalcWorkSummary>;
  /**
   * Aggregated worker fleet snapshot: recent iteration count, current lease count,
   * oldest in-flight lease age, and recent batch timing percentiles. recentMinutes
   * bounds the iteration window (default 5; clamped to [1, 60] to bound the scan).
   */
  adminDbrCalcWorkerFleetStatus: DbrCalcWorkerFleetStatusResult;
  /**
   * Returns the full feature flag document for a given feature name, including all tenant overrides.
   * Returns null if the feature flag has not been created.
   */
  adminFeatureFlag?: Maybe<FeatureFlagDocument>;
  /** Lists all feature flags with filtering, sorting, and paging for admin management. */
  adminFeatureFlags?: Maybe<AdminFeatureFlagsConnection>;
  /** Retrieves all tenant integrations across tenants with filtering and sorting. */
  adminIntegrations: Array<TenantIntegrationDocument>;
  adminRestockCalcLatestResultDate?: Maybe<Scalars['DateTime']['output']>;
  adminRestockCalcResult?: Maybe<AdminRestockCalcResultDocument>;
  adminRestockCalcResultsByCustomer?: Maybe<AdminRestockCalcResultsByCustomerConnection>;
  adminRestockCalcResultsByItem?: Maybe<AdminRestockCalcResultsByItemConnection>;
  adminRestockCalcResultsByLocation?: Maybe<AdminRestockCalcResultsByLocationConnection>;
  adminRestockCalcResultsByTenant?: Maybe<AdminRestockCalcResultsByTenantConnection>;
  adminRestockCalcSchedulerStatus: AdminRestockCalcSchedulerStatusResult;
  adminRestockCalcTenantQueue?: Maybe<AdminRestockCalcTenantQueueConnection>;
  adminRestockCalcWorkSummary?: Maybe<AdminRestockCalcWorkSummary>;
  adminRestockCalcWorkerFleetStatus: AdminRestockCalcWorkerFleetStatusResult;
  adminRestockDataValidity: AdminRestockDataValidityPayload;
  /**
   * Restock-configured customers (with nested configured locations) for the seeding
   * dropdowns. search matches customer lookup code or name, case-insensitive.
   */
  adminRestockSeedingCustomerLocations?: Maybe<AdminRestockSeedingCustomerLocationsConnection>;
  /**
   * Whether the seeding mutation is enabled in this environment. The admin PWA hides the
   * seeding page when false (prod).
   */
  adminRestockSeedingEnabled: Scalars['Boolean']['output'];
  /**
   * Tenant items for the seeding dropdown, badged with hasAvailability so the UI can
   * flag items whose achievable will stay null. search matches item lookup code or
   * name, case-insensitive.
   */
  adminRestockSeedingItems?: Maybe<AdminRestockSeedingItemsConnection>;
  /**
   * Last-iteration state per daily-chain entity (UnitsShippedSync, InventoryState,
   * RestockCalcWorkMembershipUpserter, RestockPreCalculation) with today-UTC guard
   * satisfaction — explains why seeded data is not flowing and shows post-kick progress.
   */
  adminRestockSeedingPipelineStatus: AdminRestockSeedingPipelineStatusResult;
  /** Retrieves a single tenant by ID from KurrentDB event stream. Excludes deleted tenants. */
  adminTenant?: Maybe<TenantStateData>;
  /** Returns the pricing page document for tenantId, or null if none is set. */
  adminTenantPricingPage?: Maybe<TenantPricingPageDocument>;
  /** Retrieves all non-deleted tenants from the MongoDB projection with paging, filtering, and sorting. */
  adminTenants?: Maybe<AdminTenantsConnection>;
  /**
   * Lists user invites for the admin surface. An explicit tenantId scopes
   * results to that tenant; a null/empty/whitespace tenantId returns invites
   * across ALL tenants. Gated by SuperAdmin — the same audience that can
   * already query any single tenant, so the all-tenants path adds no new data boundary.
   */
  adminUserInvites?: Maybe<AdminUserInvitesConnection>;
  /**
   * Cross-tenant WorkSuiteUsers directory lookup for the SuperAdmin console's User Health
   * card. Finds directory rows across ALL tenants filtered by email (case-insensitive, via a
   * secondary-strength email collation) and/or fusionAuthUserId. This is the detection read
   * the tenant-scoped users (GetUsers) query cannot serve: it deliberately drops the
   * TenantId == caller.TenantId filter so it can surface an orphan / wrong-tenant row that
   * lives under a DIFFERENT tenant than the caller's. Both parameters are optional and AND-combined;
   * a null/empty/whitespace parameter drops that predicate, so passing neither returns every
   * directory row (bounded by paging). Gated by the SuperAdmin policy — the same audience that
   * already queries any single tenant via adminUserInvites, so the all-tenants path adds no
   * new data boundary (see atlas standard "SuperAdmin Authorization Policy for Cross-Tenant
   * Operations": a cross-tenant lookup by email cannot be safely filtered by the caller's tenant
   * context).
   */
  adminUsers?: Maybe<AdminUsersConnection>;
  /** Returns the full admin worker config document for a given config name. */
  adminWorkerConfig?: Maybe<AdminWorkerConfigDocument>;
  /** Lists all worker configs with filtering, sorting, and paging for admin management. */
  adminWorkerConfigs?: Maybe<AdminWorkerConfigsConnection>;
  agGridRows: AgGridRowsResult;
  agGridSetValues: AgGridSetValuesResult;
  allBaseRatesOfSale?: Maybe<AllBaseRatesOfSaleConnection>;
  allContainerConfigs?: Maybe<AllContainerConfigsConnection>;
  allDailySalesProportions?: Maybe<AllDailySalesProportionsConnection>;
  allDeliverySchedules?: Maybe<AllDeliverySchedulesConnection>;
  /**
   * Resolves every known feature flag for the authenticated tenant in a single round-trip.
   * Intended for SPAs that want to load all flags at startup and react to subsequent
   * changes via the onFeatureFlagChanged subscription.
   */
  allFeatureFlags: Array<FeatureFlagResolvedItem>;
  /**
   * Returns the forecast-settings read-model document for the calling tenant (one doc per tenant).
   * Tenant-scoped via the load-bearing Eq(TenantId, ...) filter — guarded by a cross-tenant
   * leak integration test. Returns no rows when the Forecast flag is
   * disabled for the tenant.
   */
  allForecastSettings?: Maybe<AllForecastSettingsConnection>;
  allProgramReplenishmentSettings?: Maybe<AllProgramReplenishmentSettingsConnection>;
  allReplenishmentSettings?: Maybe<AllReplenishmentSettingsConnection>;
  allWeeklySlopeFactors?: Maybe<AllWeeklySlopeFactorsConnection>;
  allocationTemplate?: Maybe<AllocationTemplateDocument>;
  allocationTemplates?: Maybe<AllocationTemplatesConnection>;
  allottedTimeBaseline?: Maybe<AllottedTimeBaselineDocument>;
  /**
   * Recent-first history of assignments touching a given material item. B4-E
   * pushes the filter to Mongo via $in over the projected
   * MaterialItemIds array, replacing the prior tenant-wide
   * AssignmentHistoryFetchCap scan + in-memory filter (which could
   * truncate history beyond the cap). The bounded limit
   * (default 25, max MaxAssignmentHistoryLimit) is applied as a
   * Mongo $limit after SortByDescending(CreatedAt), so only the
   * requested page of matching assignments is materialized. Backed by the
   * idx_assignmentsummaries_tenant_materialitems_createdat compound index
   * declared in ConfigureMongoDbIndexesService.
   */
  assignmentHistoryByItem: Array<AssignmentSummaryDocument>;
  /**
   * Supervisor-scoped query — returns the assignments on the caller's tenant whose
   * flattened SiteLocationIds array contains the requested site, optionally
   * filtered by status. B4-E pushes the filter to Mongo via $in over the
   * projected array, eliminating the prior two-stage tenant-scan + post-fetch
   * in-memory bin-set match. Backed by the
   * idx_assignmentsummaries_tenant_sitelocations compound index declared in
   * ConfigureMongoDbIndexesService.
   */
  assignmentsByLocation: Array<AssignmentSummaryDocument>;
  asyncImportJob?: Maybe<AsyncImportJobDocument>;
  /**
   * Returns async import jobs across all tenants (no tenant filter).
   * This is intentional: the external worker needs to discover pending jobs across all tenants,
   * then use an appropriate tenant-specific token to access the detail rows.
   * No customer data is exposed - only job metadata (status, counts, timestamps).
   */
  asyncImportJobs?: Maybe<AsyncImportJobsConnection>;
  availabilitySession?: Maybe<AvailabilitySessionStateData>;
  availabilitySessions?: Maybe<AvailabilitySessionsConnection>;
  availableInventory?: Maybe<AvailableInventoryConnection>;
  /**
   * Returns the registered IRosProvider keys (alphabetical, stable).
   * Admin-pwa binds its provider-selection dropdown to this. Companion to
   * updateAdminTenantRestockProviderSettings (R39).
   */
  availableRestockProviderKeys: Array<Scalars['String']['output']>;
  /**
   * Returns all enabled background service configs for a given pod.
   * This is what wsapi-services calls on startup to get its manifest.
   */
  backgroundServiceManifest: Array<BackgroundServiceConfigManifestResult>;
  blockingRule?: Maybe<BlockingRuleStateData>;
  blockingRuleItemLocations?: Maybe<BlockingRuleItemLocationsConnection>;
  /**
   * The task list for a single BPF material cycle-count mission — the surface the inventory PWA
   * pages, searches and sorts against. Tenant-scoped; optionally scoped to a single
   * siteLocationId. Paged, filterable, sortable so the PWA can server-side sort
   * on the denormalised itemDescription / categoryDescription / binDescription
   * fields (the legacy assignmentSortSelections.json options).
   */
  bpfCycleCountMissionTasks?: Maybe<BpfCycleCountMissionTasksConnection>;
  /**
   * BPF material cycle-count missions for the calling tenant — the surface the inventory PWA's
   * assignment list reads. Tenant-scoped (the in-query Eq(TenantId, ...) filter is the
   * load-bearing isolation boundary — no query in wsapi calls BpfTenantGuard.EnsureBpf, that
   * is a mutation-only pattern); paged, filterable, sortable. "Currently open" missions are scoped
   * via the standard where: { endDate: { gte: ... } } filter over endDate
   * rather than a bespoke argument.
   */
  bpfCycleCountMissions?: Maybe<BpfCycleCountMissionsConnection>;
  /**
   * The lot-change reason codes for the calling tenant — the parity replacement for the legacy
   * countReasons query that populates the PWA's reason dropdown. Tenant-scoped reference
   * data synced from Nav Reason Codes.
   */
  bpfLotChangeReasons?: Maybe<BpfLotChangeReasonsConnection>;
  /**
   * The BPF lot-change audit history for the calling tenant — the immutable record of every change
   * recorded by field users. Tenant-scoped; paged, filterable, sortable for triage.
   */
  bpfLotChanges?: Maybe<BpfLotChangesConnection>;
  /**
   * Lot counts by stage (GROW / READY / MATERIAL) per location node for the calling tenant — the
   * surface the inventory PWA reads to display Finish/Material counts. Tenant-scoped (the in-query
   * Eq(TenantId, ...) filter is the load-bearing isolation boundary); paged, filterable,
   * sortable so the PWA can scope by stage and station/house/section.
   */
  bpfLotCounts?: Maybe<BpfLotCountsConnection>;
  /**
   * Lot counts for a single stage for the calling tenant — convenience over the filterable
   * bpfLotCounts query for the PWA's per-stage views.
   */
  bpfLotCountsByStage?: Maybe<BpfLotCountsByStageConnection>;
  /**
   * All BPF user starting-node assignments for the tenant (admin/management surface). Tenant-scoped;
   * paged, filterable, sortable.
   */
  bpfUserStartingNodes?: Maybe<BpfUserStartingNodesConnection>;
  /**
   * Calculates cost summaries for a batch of production jobs by resolving each job's
   * recipe variation and site location, then running cost resolution.
   */
  calculateProductionJobCosts: Array<ProductionJobCostResult>;
  /**
   * Calculates a cost summary for a production recipe variation at a specific site location.
   * Orchestrates materials, labor, and overhead cost resolution services.
   * For combo recipes, also traverses linked sub-recipes and aggregates their scaled costs.
   * When productionRecipeVariationId is null or empty, selects the first
   * variation for the recipe (sorted by ID) as the default.
   */
  calculateRecipeCost?: Maybe<RecipeCostSummaryResult>;
  categories?: Maybe<CategoriesConnection>;
  checkpoint: CheckpointStateData;
  clickUpRoadmapTasks: Array<ClickUpRoadmapTaskData>;
  clickUpTimeLoggerTasks: Array<ClickUpTaskData>;
  combinedOrders?: Maybe<CombinedOrdersConnection>;
  commandBarOptions?: Maybe<CommandBarOptionsConnection>;
  /**
   * A single user's commission configuration. Null when none exists, or when the
   * caller's directory roles do not allow seeing it: Sales users may only read
   * their own configuration; Sales Managers and Admins may read any.
   */
  commissionConfig?: Maybe<CommissionConfigDocument>;
  /**
   * The tenant's commission configurations. Visibility follows the caller's
   * directory roles: Sales users see only their own configuration, Sales Managers
   * and Admins see every configuration, and callers without a commission-relevant
   * role get an empty result.
   */
  commissionConfigs?: Maybe<CommissionConfigsConnection>;
  configCategories?: Maybe<ConfigCategoriesConnection>;
  configCategory?: Maybe<ConfigCategoryStateData>;
  /**
   * Returns the consolidation preview for the calling tenant. Tenant id is
   * taken from the JWT via TenantId; the input
   * has no tenant field by design — every request is scoped to the caller.
   */
  consolidationPreview: ConsolidationPreviewPayload;
  /**
   * Returns the calling tenant's consolidation rule set, or null when the
   * tenant has not yet configured one. Tenant identity is sourced from the JWT via
   * UserResolverContext.TenantId; the caller cannot read another
   * tenant's rule set.
   */
  consolidationRuleSet?: Maybe<ConsolidationRuleSetDocument>;
  containerConfig?: Maybe<ContainerConfigStateData>;
  /**
   * Resolves the single active ContainerConfigDocument matching a
   * (categoryCode × containerCode × siteLocationId)
   * key, or null when none matches. siteLocationId is the WorkSuite-native
   * site-location identifier (the same token the ship-from rework stores as
   * OrderState.ShipFromSiteLocationId), matched against each config's site list. Backs the
   * PWA "Packing Config" side-panel: querying this field once per order line batches into a single
   * MongoDB round-trip via the batched DataLoader (no N+1).
   */
  containerConfigByCategoryContainerSite?: Maybe<ContainerConfigDocument>;
  /**
   * Returns one row per distinct ContainerCode by aggregating over
   * ContainerConfig documents. The most recent metadata (by UpdatedAt)
   * wins for the per-container fields. Unknown-status documents are
   * excluded server-side so uninitialized projection state never leaks.
   */
  containers: Array<ContainerRow>;
  countProductionLines?: Maybe<CountProductionLinesConnection>;
  countReasons: Array<CountReasonData>;
  countRegistrations?: Maybe<CountRegistrationsConnection>;
  countSessions?: Maybe<CountSessionsConnection>;
  /**
   * Reads the tenant's outbound CRM export outbox from the CrmExports collection.
   * Paginated, filterable, and sortable so the wsapi-services worker drains starvation-free —
   * it filters to the eligible statuses with NextRetryAt <= now
   * (where: { and: [{ exportStatus: { in: [PENDING, FAILED_TRANSIENT] } },
   * { or: [{ nextRetryAt: { eq: null } }, { nextRetryAt: { lte: $now } }] }] }),
   * sorts customerId ascending, and takes a page. Bare UsePaging caps first
   * at 50 — fine, the worker batches. Authorization mirrors the accounting worker query
   * (getMergeDevExports): plain [Authorize], tenant-scoped by the in-query
   * Eq(TenantId, ...) filter (worker presents a per-tenant token, same as accounting);
   * only the outcome-reporting mutation is gated to Policies.WorkerService.
   */
  crmExports?: Maybe<CrmExportsConnection>;
  customer?: Maybe<CustomerStateData>;
  /**
   * Returns one customer's activity timeline as a cursor-paged connection, newest first, merging order
   * milestones (placed, submitted, shipped, synchronized), every payment and deposit on those orders'
   * payment ledgers (imported from accounting and recorded manually alike), and the customer's notes —
   * both the historical activity-log notes and the current per-context notes, each timestamped when it
   * was written. The read is tenant-scoped, and the two sources are narrowed on DIFFERENT axes: orders by
   * the caller's full order-visibility precedence (customer, explicit assignment, route and salesperson),
   * so an order outside that scope contributes nothing; notes by the customer, explicit-assignment and
   * route axes only, because customers carry no salesperson visibility scope — a sales-scoped caller
   * reads any tenant customer's notes here exactly as it already does on customers and customer.
   * Deleted orders are excluded; cancelled orders are DELIBERATELY kept, unlike the two aggregate reads on
   * this panel, which exclude them — a feed records what happened rather than deriving a total, and a
   * cancelled row explains itself where a silently missing one does not. A customer with no activity
   * yields an empty connection rather than null. Requests for more than 200 entries in a page are
   * rejected.
   */
  customerActivityFeed?: Maybe<CustomerActivityFeedConnection>;
  /**
   * Resolves the invoice recipients for customerId: every non-blank email of
   * every contact currently routed to receive this customer's invoices, plus why that list is empty
   * when it is. Null when customerId is not found in the caller's tenant.
   */
  customerInvoiceRecipients?: Maybe<CustomerInvoiceRecipientsData>;
  customerItem?: Maybe<CustomerItemStateData>;
  /** @deprecated Use skuUpcMappings instead. Will be removed in next release. */
  customerItems?: Maybe<CustomerItemsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Restock Locations sidebar, so the
   * client renders grouping over the full location list without loading every location and grouping
   * in memory. Groups the SAME tenant-scoped RestockCustomerLocationDocument read model
   * the list pane pages (restockCustomerLocations), so each bucket's
   * Key is usable verbatim as the list where eq-value.
   * groupBy selects the bucket key (Region or Market). search is
   * the same case-insensitive OR-contains over the searchable fields the sidebar applies, so counts
   * reflect the active search. The group's children are then lazy-loaded via
   * restockCustomerLocations filtered to the bucket key.
   */
  customerLocationGroups: Array<CustomerLocationGroupBucket>;
  /** Retrieves the resolved purchase-order-required flag for a location using two-tier fallback: Location override, then Customer (default false) */
  customerLocationPoRequiredInherited: Scalars['Boolean']['output'];
  customerLocationRetailerNames: Array<Scalars['String']['output']>;
  /** Retrieves resolved terms ID for a location using three-tier fallback: Location → Customer → Default */
  customerLocationTermsIdInherited?: Maybe<Scalars['String']['output']>;
  customerLocations?: Maybe<CustomerLocationsConnection>;
  /**
   * Returns the caller's tenant's CustomerLocationDocument rows that have at
   * least one BaseRatesOfSale row — an existence gate, not a value filter. The Restock
   * orders wizard uses this surface to populate its store selector, which must only offer
   * locations the system can actually compute a replenishment for (i.e. those with a Base Rate
   * of Sale on file). Returns the SAME CustomerLocationDocument type as the
   * customerLocations query so the PWA can reuse its existing fragment, filter, and sort.
   */
  customerLocationsWithBaseRateOfSale?: Maybe<CustomerLocationsWithBaseRateOfSaleConnection>;
  /**
   * Computes the Customer 360 order-history and accounts-receivable rollup for one customer in a single
   * MongoDB aggregation over the combined-orders read model. STAFF-ONLY: the bare Authorize attribute
   * resolves to the default policy, which only the user, admin and superadmin roles satisfy, so a
   * portal-user JWT is rejected before this resolver runs and the own-customer (customer-portal) branch of
   * the shared order visibility scope is unreachable here. The Customer 360 panel this serves is the
   * Health tab of the Fulfill customer detail page, whose audience is salespeople and managers; the
   * customer portal is out of scope for this surface. The customer id is validated, the read is scoped to
   * the caller's tenant and to whatever staff order visibility the caller carries (assigned customers,
   * assigned routes, or own salesperson), and every division is zero-guarded.
   *
   * ONE order set feeds every accumulator: the customer's orders excluding master orders (recurring
   * templates, not purchases), cancelled orders and deleted orders — see the shared customer-scoped match
   * on OrderVisibilityScope. Within that set two narrower partitions apply and they are deliberately
   * different from each other: openOrderCount counts drafts, active orders and sync-error orders, while
   * arBalance and the aging buckets count only the AR-bearing statuses, which exclude drafts. A draft
   * order is open but nothing is owed on it. An order with no expected delivery date has no due date and
   * is counted as most-overdue rather than current. A well-formed customer id with no orders in scope
   * returns a zeroed rollup (not null) so the panel can render zeros; null is reserved for a malformed id.
   */
  customerOrderStats?: Maybe<CustomerOrderStats>;
  /**
   * Retrieves the customer account for the authenticated portal user.
   * The customer ID is resolved from the portal user's JWT claims.
   */
  customerPortalAccount?: Maybe<CustomerStateData>;
  /** Retrieves a single favorites list by ID for the authenticated tenant. */
  customerPortalFavoritesList?: Maybe<FavoritesListDocument>;
  /** Returns a paged, filterable list of favorites lists for the authenticated tenant. */
  customerPortalFavoritesLists?: Maybe<CustomerPortalFavoritesListsConnection>;
  /** Returns a paged, filterable list of inventory availability for the authenticated tenant. */
  customerPortalInventoryAvailability?: Maybe<CustomerPortalInventoryAvailabilityConnection>;
  /** Returns filterable item availability data for the authenticated tenant. */
  customerPortalItemAvailability?: Maybe<Array<ItemAvailabilityDocument>>;
  /** Returns a paged, filterable list of items available to the authenticated tenant. */
  customerPortalItems?: Maybe<CustomerPortalItemsConnection>;
  /**
   * Retrieves a single portal user's current state by reading directly from the unified
   * WorkSuiteUser event stream, bypassing read-model projection lag. Returns null if
   * not found or inactive. Staff-only: a customer-type portal JWT gets null, consistent with
   * the portal authz pattern — a portal buyer may not read another portal user's PII. Tenant-scoped.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  customerPortalPortalUserByStream?: Maybe<PortalUserStateData>;
  /**
   * Returns a paged, filterable list of the tenant's sellable, active hard goods for the customer
   * portal. Results are gated on the tenant's portal "Include sellable hard goods" setting; when
   * the tenant has not opted in (or never saved settings), an empty result is returned. Cross-tenant
   * requests or portal-disabled tenants return null.
   */
  customerPortalSellableHardgoods?: Maybe<CustomerPortalSellableHardgoodsConnection>;
  /**
   * Returns the read-only portal-enforcement settings for the authenticated portal user's
   * tenant, reading current state directly from the KurrentDB stream (no projection lag). When
   * the tenant has never saved settings the documented defaults are returned (portal enabled,
   * no minimum order, grid catalog). Deliberately NOT gated by PortalAccess — the
   * storefront relies on this field to detect a disabled portal and render its own "portal
   * unavailable" page, so it must stay readable even when PortalEnabled is false. Mirrors
   * the customer-portal authz gate used across the portal queries only for cross-tenant access: a
   * tenantId arg that does not match the caller's own tenant returns null.
   * Tenant-scoped — the stream is keyed by the caller's own tenant id, so one tenant can never
   * read another's settings.
   */
  customerPortalSettings?: Maybe<CustomerPortalSettingsData>;
  /** Retrieves a shopping cart by ID for the authenticated tenant. Requires authorization. */
  customerPortalShoppingCart?: Maybe<ShoppingCartStateData>;
  /**
   * Lists the tenant's portal users, read from the unified WorkSuiteUsers read model
   * (active Portal users) and projected onto the legacy
   * PortalUserDocument shape. Staff-only: a customer-type portal JWT gets
   * null, consistent with the portal authz pattern — a portal buyer may not read the
   * tenant's full portal-user roster (PII), and so cannot see another customer's users.
   * Tenant-scoped — only the caller's own tenant. The free-form legacy role collapses to
   * "Portal" and the single unified FullName is split back into first/last
   * (see WorkSuiteUserPortalFacadeMapping).
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  customerPortalUsers?: Maybe<CustomerPortalUsersConnection>;
  /** Get all time entries with customer filtering support */
  customerTimeEntries?: Maybe<CustomerTimeEntriesConnection>;
  /**
   * Computes the customer's top-N SKUs by total quantity, with accompanying revenue, in a single
   * MongoDB aggregation. STAFF-ONLY (bare Authorize) — mirrors customerOrderStats; the
   * customer portal is out of scope for this Health-tab surface. The read honours the same
   * server-enforced order visibility scope every other order read entry point uses (tenant, plus any
   * explicit customer/route/salesperson restriction on the caller) — a caller outside their own scope
   * for the requested customer sees an empty list, never that customer's data. The order set is the SAME
   * one customerOrderStats aggregates — deleted and cancelled orders excluded — because the two are
   * read side by side on one panel and an aggregate over money and quantity must agree with the counters
   * beside it. Revenue honours OverridePrice over Price where set, matching how the order
   * itself values the line; quantity falls back to OrderedQuantity when null. Ties are broken by
   * SKU ascending for a deterministic order. top is clamped to [1, 50] so a caller cannot request
   * an unbounded result. A customer with no qualifying line items — or a malformed customerId —
   * returns an empty list, never null.
   */
  customerTopSkus: Array<CustomerTopSku>;
  /**
   * Returns the tenant-scoped, paged customer types over the CustomerTypes summary
   * read model. [UseFiltering] exposes a status filter (plus every other
   * document field) so callers can request active-only, inactive-only, or unfiltered results.
   * Soft-deleted types (AI Helm fd75fc05) are excluded unconditionally in the base Find
   * filter, not via a [UseFiltering] pass-through predicate -- a deleted type can never
   * be fetched back through this query by any caller-supplied filter combination.
   */
  customerTypes?: Maybe<CustomerTypesConnection>;
  customers?: Maybe<CustomersConnection>;
  customersGrid?: Maybe<GridResponse>;
  /**
   * Single-assignment detail. Returns null when the id does not match a
   * document on the caller's tenant.
   */
  cycleCountAssignment?: Maybe<AssignmentSummaryDocument>;
  /**
   * Returns cycle count submissions for the current tenant.
   * Supports optional filtering by location and/or recorded-by email.
   * Defaults to the last 7 days when no date filter is applied.
   */
  cycleCountHistory?: Maybe<CycleCountHistoryConnection>;
  deletedStreamTransactions?: Maybe<DeletedStreamTransactionsConnection>;
  deletedStreams?: Maybe<DeletedStreamsConnection>;
  deliverySchedule?: Maybe<DeliveryScheduleStateData>;
  /**
   * Returns the tax-authority documents that resolve for a (customer, optional ship-to)
   * pair, walking ship-to → customer → tenant default. Authority order is
   * preserved exactly as configured at whichever level resolved (the first id is the
   * primary fallback). Returns an empty list when the flag is disabled, when the
   * customer id is malformed, or when no authorities resolve at any level.
   * Deactivated authorities are excluded from the response so order display only
   * shows currently-applicable authorities (historical orders consult their captured
   * rate via the order's snapshot, not this resolver).
   */
  effectiveCustomerTaxAuthorities: Array<TaxAuthorityDocument>;
  /**
   * Resolves the effective sender for the current tenant across all channels: the selectable
   * default if set, else the earliest selectable sender, else the synthesized platform-default
   * fallback. Never returns a non-selectable sender; the default may be any channel. Deliberately
   * UNCHANGED by Decision D's adminOnly flag and the caller's role — the tenant default may
   * be admin-only because background/automatic sends are system acts, not user acts.
   */
  effectiveEmailSender: TenantEmailSenderData;
  /**
   * Gets email-send records for the current tenant, most recent first, optionally filtered by
   * order identifier, order number, report identifier, schedule identifier, or a sentAt
   * range. The sentAt range is an explicit server-built arg (not the generated where-input)
   * because SentAt is persisted as a BSON date for correct DESC
   * paging, and HotChocolate's generated DateTimeOffset where-filter serializes to a
   * {DateTime,Ticks,Offset} document shape that never matches that stored BSON date. Pairs
   * with the persisted, indexed deliveryStatus where-filter (Email Issues failure grid).
   */
  emailSends?: Maybe<EmailSendsConnection>;
  entityCheckpoints: Array<EntityCheckpointDocument>;
  /**
   * This does not follow the pattern: pull tenantId from accessToken.
   * UPDATE: When ready (requires the ability to easily change tenant authorization), update to follow current pattern.
   */
  entityEvents: Array<ResolvedEventData>;
  erpAvailability?: Maybe<ErpAvailabilityConnection>;
  erpFinishAvailability: Array<ErpAvailabilityRefreshItem>;
  erpItemPrices: Array<ErpItemPricingDocument>;
  erpItemPricing?: Maybe<ErpItemPricingStateData>;
  erpLoadListAvailability?: Maybe<ErpLoadListAvailabilityConnection>;
  erpLoadListQuantities?: Maybe<ErpLoadListQuantitiesConnection>;
  erpLoadListRoutes?: Maybe<ErpLoadListRoutesConnection>;
  erpLoadListSession?: Maybe<ErpLoadListSessionStateData>;
  erpLoadListSessions?: Maybe<ErpLoadListSessionsConnection>;
  erpLoadListUser?: Maybe<ErpLoadListUserStateData>;
  erpLoadListUsers?: Maybe<ErpLoadListUsersConnection>;
  erpManagerEmails?: Maybe<ErpManagerEmailsStateData>;
  erpPriceGroups: Array<Maybe<Scalars['String']['output']>>;
  erpStationRoutes: Array<Scalars['String']['output']>;
  erpStations: Array<Scalars['String']['output']>;
  /**
   * Returns the calling tenant's ERP write-back records, filterable and sortable for inspection
   * (queue depth, failure triage). Scoped to the caller's tenant. Worker consumption uses the
   * claimPendingErpWriteBacks mutation (atomic lease), NOT this query.
   */
  erpWriteBackQueue?: Maybe<ErpWriteBackQueueConnection>;
  eventCounts?: Maybe<EventCountsConnection>;
  eventStreamAggregates?: Maybe<EventStreamAggregatesConnection>;
  /**
   * Resolves the effective feature flag value for the authenticated tenant.
   * Returns the tenant override if one exists, otherwise the global value.
   * Returns defaults if the flag is inactive or not found.
   */
  featureFlag: FeatureFlagValueResult;
  /** Get all floating time entries for the tenant from MongoDB with paging, filtering, and sorting. */
  floatingTimeEntries?: Maybe<FloatingTimeEntriesConnection>;
  /** Get a single floating time entry by ID from the event store. */
  floatingTimeEntry?: Maybe<FloatingTimeEntryStateData>;
  /**
   * Returns a single active forecast by id for the calling tenant, or null when it does not exist,
   * is soft-deleted, or the Forecast flag is disabled. The read filters on the composite
   * _id ({tenantId}-{forecastId}), which embeds the tenant, so it cannot return
   * another tenant's forecast (discipline acada0ab).
   */
  forecast?: Maybe<ForecastDocument>;
  /**
   * The per-source freshness watermark of the calling tenant's synced history (W6): the latest transaction
   * Date in each ImportData source, capped at now. The Forecast feature gate is checked FIRST — a
   * tenant without the flag gets null, never a peek at ImportData. The read is scoped to the caller's
   * tenant (guarded by a cross-tenant leak test). This is the same max-transaction-date a generation run
   * pins its inputs at (ADR-001 ARCH-3), from one shared computation; an empty source reports null.
   */
  forecastHistoryWatermark?: Maybe<ForecastHistoryWatermark>;
  /**
   * Returns one holiday reference row by id for the calling tenant, or null when it does not exist, is
   * soft-deleted, or the FORECAST flag is disabled. Reads by the tenant-scoped composite _id, so the
   * read cannot cross tenants by construction.
   */
  forecastHoliday?: Maybe<HolidayDocument>;
  /**
   * Returns the calling tenant's active holiday reference rows (soft-deleted rows excluded), ordered by
   * date. Tenant-scoped via the stored TenantId, guarded by a cross-tenant leak integration test.
   * Returns an empty list when the FORECAST flag is disabled (the module is dark, nothing is exposed).
   */
  forecastHolidays: Array<HolidayDocument>;
  /**
   * Returns the calling tenant's forecast comp settings, or the A2 defaults when the tenant has
   * never saved (so the Assumptions page and generation always have a full config to snapshot).
   * When the Forecast flag resolves to disabled the
   * module is dark for the tenant and the query returns null — no settings are exposed.
   */
  forecastSettings?: Maybe<ForecastSettingsStateData>;
  /**
   * Computes the plan-grid Summary panel KPIs (spec §3.2) for a forecast over an optional scope, in a
   * single MongoDB aggregation. The FORECAST feature gate is checked FIRST: a tenant without the flag
   * gets null (no read-model rows are exposed), never a computed rollup. The forecast id is validated,
   * the read is scoped to the caller's tenant AND the forecast (guarded by a cross-tenant leak test),
   * and every weighted-average / vs-last-year division is zero-guarded. A well-formed forecast with no
   * rows in scope returns a zeroed summary (not null) so the panel can render zeros; null is reserved
   * for the feature-disabled and malformed-id cases.
   */
  forecastSummary?: Maybe<ForecastSummary>;
  /**
   * Returns the weekly-cell totals per plan row (region × item) for a forecast — the Σ-weeks-by-metric
   * inputs the PWA plan grid's Delta column needs (spec §3.2, W12 DoD), in a single MongoDB aggregation
   * over the worker-owned ForecastWeeklyCells collection. The FORECAST feature gate is checked
   * FIRST: a tenant without the flag gets an empty list (no read-model rows are exposed). The forecast id
   * is validated, the read is scoped to the caller's tenant AND the forecast (guarded by a cross-tenant
   * leak test), and the compound (TenantId, ForecastId, Region, ItemId) index serves both the
   * $match and the group-by-(region, item). An optional scope narrows to a subset of regions/items.
   */
  forecastWeeklyDeltaInputs: Array<ForecastWeeklyDeltaInput>;
  /**
   * Lists the calling tenant's active (non-soft-deleted) forecasts. Tenant-scoped via the
   * load-bearing TenantId filter, guarded by a cross-tenant leak integration test. Returns no rows
   * when the Forecast flag is disabled for the tenant.
   */
  forecasts?: Maybe<ForecastsConnection>;
  /**
   * Generates a CSV for the specified report with optional parameter overrides.
   *
   *
   * **Returns:**
   * Payload with Success=true and CsvBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportCsv: ReportCsvPayload;
  /**
   * Generates an Excel workbook for the specified report with optional parameter overrides.
   *
   *
   * **Returns:**
   * Payload with Success=true and ExcelBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportExcel: ReportExcelPayload;
  /**
   * Generates a PDF for the specified report with optional parameter overrides.
   *
   *
   * **Returns:**
   * Payload with Success=true and PdfBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportPdf: ReportPdfPayload;
  /**
   * Returns the rows of the Hardgoods Inventory grid for the calling tenant. When
   * siteLocationId is provided, rows are scoped to that site; when
   * omitted (null), rows across all sites for the tenant are returned.
   * One row per (MaterialItemId, SiteLocationId), carrying the per-bin on-hand
   * breakdown, the last-counted timestamp, and the active cycle-count assignment (if any).
   */
  hardgoodsInventoryGrid?: Maybe<HardgoodsInventoryGridConnection>;
  /**
   * Returns the required quantity per material item for a ready week (recipe material
   * multiple × scheduled production job lot size, summed), plus the recipe-coverage
   * percentage for the tenant.
   */
  hardgoodsRequiredByReadyWeek: HardgoodsRequiredSummary;
  /**
   * Returns a computed health snapshot for the caller's Merge.dev / accounting integration so a
   * "connected but never synced" or mis-seeded integration is visible instead of falsely green.
   * Tenant-scoped: every read is filtered to the caller's tenant; the integration is identified by the
   * supplied integrationId. Flags three distinguishable, independently-reported reasons — the
   * integration has never completed a sync cycle (no connection metadata and zero sync-state rows), no
   * enabled WsapiImport selects the tenant (so the import worker silently does nothing forever), and the
   * accounting provider is None while the Merge link is active (so outbound invoicing is silently off).
   * An integration that is not linked at all is reported healthy (nothing to fix) with no reasons.
   */
  integrationHealth: IntegrationHealthDocument;
  integrations: Array<TenantIntegrationDocument>;
  inventoryItems?: Maybe<InventoryItemsConnection>;
  inventoryTransactions?: Maybe<InventoryTransactionsConnection>;
  item?: Maybe<ItemStateData>;
  itemAvailability: Array<ItemAvailabilityDocument>;
  itemCategories: Array<Scalars['String']['output']>;
  itemGroups: Array<Scalars['String']['output']>;
  itemIdsByErpId: Array<ItemErpIdPair>;
  /**
   * Server-computed group headers (with per-group counts) for the Fulfill Items list pane, so the
   * client renders grouping over the full catalog without loading every item and grouping in memory.
   * groupBy selects the bucket key (scalar sort-category, item group, or canonical
   * status). search is the same case-insensitive OR-contains the list pane applies,
   * so counts reflect the active search. The group's children are then lazy-loaded via the items
   * query filtered to the bucket key (where: { <field>: { eq: Key } }). Scoped to the same
   * tenant + non-deleted set as items, so the per-bucket counts sum to that query's total.
   */
  itemListGroups: Array<ItemGroupBucket>;
  itemLocationAvailability: Array<ItemLocationAvailabilityDocument>;
  itemPrice: Scalars['Decimal']['output'];
  /**
   * Read-only diagnostic companion to itemPrice: returns the full pricing-resolution
   * trace (resolved price group + source, per-candidate-level status, sibling levels on other items,
   * winning level, final price, and any internal error) so the UI can tell a user exactly why an item
   * priced the way it did — or didn't. The finalPrice always agrees with itemPrice for
   * identical inputs; this query never changes the resolved price, it only explains it. Same tenant
   * isolation and authorization as itemPrice.
   */
  itemPriceExplanation: ItemPriceExplanation;
  /**
   * Inverted pricing view for the Items page Pricing tab.
   * Returns every non-deleted PriceLevel targeting the given item — either directly
   * (Type == Item, TargetId == itemId) or via any category the item belongs to
   * (Type == Category, TargetId ∈ item.Categories). Each row is joined with its
   * parent PriceGroup and with the target (Item or Category) for display names.
   * All joins are tenant-scoped; deleted items, categories, and price groups
   * are excluded. Read-only; does not mutate the Pricing domain.
   */
  itemPriceLevels: Array<ItemPriceLevelRow>;
  /**
   * Returns prices for multiple items in a single call.
   * When locationId is omitted, falls back to the tenant's default price group.
   * Supports quantity break pricing via the quantity parameter.
   */
  itemPrices: ItemPricesPayload;
  /**
   * Returns the calling tenant's production mapping for one sales item (its full set of lines, each
   * with taxonomy resolved from the native catalog), or null when the item has no mapping. Tenant-scoped
   * via the composite _id, guarded by a cross-tenant leak integration test. Returns null when the
   * FORECAST flag is disabled for the tenant.
   */
  itemProductionMappings?: Maybe<ItemProductionMappingDocument>;
  itemPrograms?: Maybe<ItemProgramsConnection>;
  /**
   * Returns inventory restock metrics for a single item within a DBR session.
   * Branches on session.StationCode: non-null routes to the ERP-tenant path
   * (RestockAvailabilityDocument keyed by the synthetic ERP key, pricing
   * from ErpItemPricing); null routes to the inventory-tenant path
   * (RestockAvailabilityDocument with Source=Inventory aggregated
   * across internal locations, pricing via MongoPricingService).
   * Returns null when the session does not exist or is soft-deleted.
   */
  itemRestockMetrics?: Maybe<ItemRestockMetricsData>;
  itemSubcategories: Array<Scalars['String']['output']>;
  items?: Maybe<ItemsConnection>;
  itemsGrid?: Maybe<GridResponse>;
  itemsWithBaseRateOfSale?: Maybe<ItemsWithBaseRateOfSaleConnection>;
  /**
   * Returns every non-deleted item for the caller's tenant joined with a per-item
   * sum of RestockAvailabilityDocument.Quantity and
   * RestockAvailabilityDocument.MustGoQty. Items with no
   * RestockAvailability rows return null for the joined sub-document
   * (preserved via $unwind with preserveNullAndEmptyArrays) — the
   * Restock UI uses this surface to populate the "add items" picker, which needs
   * items even when no availability has been ingested yet.
   */
  itemsWithRestockAvailability?: Maybe<ItemsWithRestockAvailabilityConnection>;
  job: JobDocument;
  /**
   * Returns the subcategory cost breakdown for a single production job within one cost category.
   *
   *
   * **Returns:**
   * The per-subcategory cost breakdown rows.
   */
  jobCostBreakdown: Array<CostCategoryBreakdown>;
  /**
   * Returns the raw recorded cost entries for a production job, optionally filtered by cost
   * category and source type.
   *
   *
   * **Returns:**
   * The matching job cost records, ordered by recorded date.
   */
  jobCostRecords: Array<JobCostRecordDocument>;
  /**
   * Returns the budget-versus-actual cost summary for a single production job, combining its
   * recorded costs with resolved budget totals and production progress.
   *
   *
   * **Returns:**
   * The budget-versus-actual cost summary for the job.
   */
  jobCostSummary: JobCostSummary;
  /**
   * Returns the weekly cost timeline for a production job over the requested number of recent
   * weeks (bounded to a safe maximum).
   *
   *
   * **Returns:**
   * The weekly cost timeline entries.
   */
  jobCostTimeline: Array<CostTimelineEntry>;
  jobs?: Maybe<JobsConnection>;
  /** A single kit by id, scoped to the caller's tenant and assigned sites, excluding deleted kits. */
  kit?: Maybe<KitDocument>;
  /**
   * The site's kits, excluding deleted ones, ordered by name ascending unless another order is
   * requested. The optional search argument is a case-insensitive "contains" over the kit name
   * and container code.
   */
  kits?: Maybe<KitsConnection>;
  /** One currently-active, non-deactivated labor rate per labor type at asOf. */
  laborActiveRates: Array<LaborRateDocument>;
  laborDemand: LaborDemandSummary;
  /**
   * Paginated labor rate history (desc by EffectiveFrom). Filters deactivated rows by default;
   * pass includeDeactivated: true for admin/audit views.
   */
  laborRates?: Maybe<LaborRatesConnection>;
  lastPosition?: Maybe<Scalars['Long']['output']>;
  /**
   * The newest run for a suite — what the dashboard's health tiles read on load. Prefers a
   * complete run and only falls back to a partial one when that is all that exists, because a
   * subset run would otherwise shrink the exec view to whichever specs happened to be re-run.
   *
   * That preference is a compound sort rather than a query-then-fallback: Partial == false
   * sorts ahead of true, so one round-trip yields the newest complete run when one exists
   * and the newest partial run otherwise.
   */
  latestQaTestRun?: Maybe<QaTestRunResult>;
  /**
   * Gets actual quantities for line items (Available - Reserved) aggregated at the line item level
   * Uses MongoDB aggregation pipeline for optimal performance
   * @deprecated Uses $lookup against removed OrderAllocations collection. Migrate to InventoryItem-based allocation tracking.
   */
  lineItemActualQuantities: Array<LineItemActualQuantityDocument>;
  /**
   * Obsolete: previously returned per-location/grade actual quantities by joining the removed
   * OrderAllocations collection. It can no longer produce data, so it now signals with a
   * RESOLVER_OBSOLETE error instead of degrading to a silent empty list.
   * @deprecated Uses $lookup against removed OrderAllocations collection. Migrate to InventoryItem-based allocation tracking.
   */
  lineItemActualQuantitiesByLocationGrade: Array<LineItemActualQuantityDocument>;
  /** @deprecated Use SiteLocation queries instead. */
  location?: Maybe<LocationDocument>;
  /**
   * Pagination-free resolver for the currently-active overhead rate with most-granular-wins:
   * when subLocationId is provided and a matching open, non-deactivated
   * sub-location rate exists at asOf, it wins. Otherwise the site-level rate
   * is returned. Deactivated rows (from a cascade) never resolve as active. Returns null when
   * neither parent nor sub-location has an active non-deactivated row.
   */
  locationActiveOverheadRate?: Maybe<LocationOverheadRateDocument>;
  /**
   * Returns the most recently-written site-level overhead rate row (SubLocationId is null).
   * Pre-PR contract was a single-doc upsert; post-PR each EffectiveFrom is its own row in
   * append-only history. The latest-EffectiveFrom site-level row preserves read-after-write
   * behavior for both open-ended and bounded (closed-range) rates. For sub-location-aware
   * lookups with most-granular-wins + asOf, use locationActiveOverheadRate.
   */
  locationOverheadRate?: Maybe<LocationOverheadRateDocument>;
  /**
   * Paginated overhead rate history (desc by EffectiveFrom, default page size 50).
   * Filtering inputs derive from LocationOverheadRateDocument including
   * SubLocationId and EffectiveFrom ranges. Filters deactivated rows by default;
   * pass includeDeactivated: true for admin/audit views.
   */
  locationOverheadRates?: Maybe<LocationOverheadRatesConnection>;
  /** @deprecated Use SiteLocation queries instead. */
  locations?: Maybe<LocationsConnection>;
  locationsSalesPeople?: Maybe<LocationsSalesPeopleConnection>;
  /**
   * Returns the subcategory cost breakdown aggregated across every production job in a lot for
   * one cost category.
   *
   *
   * **Returns:**
   * The per-subcategory cost breakdown rows aggregated across the lot.
   */
  lotCostBreakdown: Array<CostCategoryBreakdown>;
  /**
   * Returns the raw recorded cost entries across every production job in a lot, optionally
   * filtered by cost category.
   *
   *
   * **Returns:**
   * The matching job cost records across the lot, ordered by recorded date.
   */
  lotCostRecords: Array<JobCostRecordDocument>;
  /**
   * Returns the budget-versus-actual cost summary aggregated across every production job in a lot.
   *
   *
   * **Returns:**
   * The aggregated budget-versus-actual cost summary for the lot.
   */
  lotCostSummary: JobCostSummary;
  /**
   * Returns the weekly cost timeline aggregated across every production job in a lot over the
   * requested number of recent weeks (bounded to a safe maximum).
   *
   *
   * **Returns:**
   * The weekly cost timeline entries aggregated across the lot.
   */
  lotCostTimeline: Array<CostTimelineEntry>;
  /**
   * Builds the Microsoft authorize URL the browser is sent to for a mailbox connect: the multitenant
   * authorize endpoint with the app client id, the delegated scopes, the redirect URI (the caller's,
   * or the configured default), and a signed, time-limited state value bound to the calling
   * user, which the connect mutation validates.
   */
  m365MailboxAuthorizeUrl: Scalars['String']['output'];
  /**
   * The current user's mailbox connection status (connected flag + address), read from the read model.
   * Returns a not-connected status when the user has never connected.
   */
  m365MailboxStatus: M365MailboxStatus;
  /**
   * Returns all make-to-order plan bindings for the caller's tenant, with paging, filtering, and
   * sorting. Filter by orderId, orderLineId, or productionLotId to scope to a
   * specific order line or minted lot.
   */
  makeToOrderPlans?: Maybe<MakeToOrderPlansConnection>;
  masterOrder?: Maybe<MasterOrderStateData>;
  masterOrders?: Maybe<MasterOrdersConnection>;
  /**
   * Returns a single material allocation by id, scoped to the caller's tenant so an
   * allocation belonging to another tenant is never disclosed.
   *
   *
   * **Returns:**
   * The matching document, or null when no allocation exists for that id in the tenant.
   */
  materialAllocationById?: Maybe<MaterialAllocationDocument>;
  /**
   * Returns the projected material allocations for the caller's tenant, with paging,
   * filtering, and sorting applied by the GraphQL middleware.
   *
   *
   * **Returns:**
   * An executable, tenant-filtered query over the MaterialAllocations read model.
   */
  materialAllocations?: Maybe<MaterialAllocationsConnection>;
  /**
   * Returns material demand entries for a given site location and date range,
   * computed from production jobs and their material event attachments.
   */
  materialDemand: MaterialDemandSummary;
  /**
   * Server-computed group headers (with per-group counts) for the Material Events sidebar, so the
   * client renders grouping over the full event list without loading every event and grouping in
   * memory. groupBy selects the bucket key dimension (event Status or
   * event Name). search is the same case-insensitive OR-contains over the
   * event name the sidebar applies, so counts reflect the active search. The group's children are
   * then lazy-loaded via productionMaterialEvents filtered to the bucket key — each bucket's
   * Key equals that list's where eq-value for the
   * dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  materialEventGroups: Array<MaterialEventGroupBucket>;
  materialItem?: Maybe<MaterialItemDocument>;
  materialItemLocationQuantities?: Maybe<MaterialItemLocationQuantitiesConnection>;
  materialItemLocationQuantity?: Maybe<MaterialItemLocationQuantityDocument>;
  materialItemSiteLocationQuantities?: Maybe<MaterialItemSiteLocationQuantitiesConnection>;
  materialItemSiteLocationQuantity?: Maybe<MaterialItemSiteLocationQuantityDocument>;
  materialItemTotalQuantity: Scalars['Decimal']['output'];
  materialItems?: Maybe<MaterialItemsConnection>;
  /**
   * All open material orders for the calling tenant — the surface the PWA reads to list outstanding
   * POs and inbound transfer orders. Tenant-scoped; paged, filterable, sortable so the PWA can scope
   * by order type, station, vendor, or expected-receipt date.
   */
  materialOrders?: Maybe<MaterialOrdersConnection>;
  /**
   * Open material orders whose receiving station resolves to a single location node — the parity
   * replacement for legacy orderLinesForNode (and the Finish receive flow's
   * orderLinesForFinishNode, which is the same shape scoped to a node). Tenant-scoped and
   * filtered to locationId; paged, filterable, sortable.
   */
  materialOrdersForLocation?: Maybe<MaterialOrdersForLocationConnection>;
  /**
   * The material-receipt audit history for the calling tenant — the immutable record of every
   * receipt recorded by field users (the parity replacement for the legacy
   * InventoryMaterial.OrderLineChange rows). Tenant-scoped; paged, filterable, sortable for
   * triage.
   */
  materialReceipts?: Maybe<MaterialReceiptsConnection>;
  /**
   * Returns material transactions (counts and moves) for the authenticated tenant,
   * with paging, filtering, and sorting support.
   */
  materialTransactions?: Maybe<MaterialTransactionsConnection>;
  /**
   * The calling user's own directory entry, resolved from their FusionAuth identity
   * (subject claim) with a case-insensitive email fallback. Null when the caller has
   * no directory entry yet — clients should treat that as "no business roles".
   */
  me?: Maybe<UserDocument>;
  mergeDevAccounts?: Maybe<MergeDevAccountsConnection>;
  /**
   * Returns the per-integration Merge.dev connection metadata (the friendly QuickBooks company name)
   * for the given integration, or null when the synchronizer has not yet captured a connection
   * document for the caller's tenant. Tenant-scoped: filtered by both the caller's tenant and the
   * supplied integration id.
   */
  mergeDevConnection?: Maybe<MergeDevConnectionDocument>;
  /**
   * Reads the tenant's outbound export attempts to Merge.dev (WS Orders → QB Invoices) from
   * the MergeDevExports read model. Paginated, filterable, and sortable so clients can
   * narrow to failures (e.g. where: { exportStatus: { eq: FAILED_PERMANENT } }) for
   * the PWA Errors tab.
   */
  mergeDevExports?: Maybe<MergeDevExportsConnection>;
  /** Returns the persisted genuine per-record Merge.dev import failures (entity type, source record id, human label, reason, and timestamp) for the given integration, newest-first, optionally capped to the most recent N. Backs the Integrations "Errors" tab so operators see why each record was dropped, not just a count. */
  mergeDevImportFailures: Array<MergeDevImportFailureDocument>;
  mergeDevPayments?: Maybe<MergeDevPaymentsConnection>;
  /** Returns the cached Merge.dev field schema for the given integration and model, or null if not yet discovered. */
  mergeDevSchema?: Maybe<MergeDevSchemaDocument>;
  /** Returns the most recent Merge.dev sync cycle metrics for the given integration, ordered by completion time descending. */
  mergeDevSyncMetrics: Array<MergeDevSyncMetricsDocument>;
  /** Returns the authoritative per-entity Merge.dev sync state (last successful sync time and consecutive-failure count) for the given integration, ordered by entity type. */
  mergeDevSyncState: Array<MergeDevSyncStateDocument>;
  mergeDevTaxRates?: Maybe<MergeDevTaxRatesConnection>;
  /**
   * Returns a single pending transfer-order document by its underlying MovementOrder
   * aggregate id for the caller's tenant, or null when no matching row exists.
   * Used by the mobile receive UI to render the review step for one specific transfer.
   *
   *
   * **Returns:**
   *
   * The matching PendingTransferOrderDocument when found within the
   * caller's tenant; null when no row matches (unknown id, or id belongs to
   * another tenant).
   */
  movementOrder?: Maybe<PendingTransferOrderDocument>;
  /**
   * Returns the caller's tenant's MovementOrder history rows for the given
   * SiteLocation, in both directions:
   *
   * Outbound — the location is the source and the order has shipped
   * (FromSiteLocationId == locationId and ShippedAt is set).
   * Inbound — the location is the destination and the order has been received
   * (ToSiteLocationId == locationId and ReceivedAt is set).
   *
   * A transfer shipped to the location but not yet received is a pending inbound, not
   * history, and is never returned — the ReceivedAt clause is what excludes it.
   *
   *
   * **Returns:**
   *
   * Pageable IExecutable`1 of MovementOrder history rows for the caller's
   * tenant where locationId is the shipped source or the received
   * destination.
   */
  movementOrderTransactionsByLocation?: Maybe<MovementOrderTransactionsConnection>;
  /**
   * Worker-scoped task list — returns the tasks assigned to the calling user on
   * the caller's tenant, optionally filtered by lifecycle status. Backed by the
   * MyCountTaskDocument read model (per-task row keyed by
   * (tenant, assignment, task)). The worker id is resolved from the
   * authenticated principal, never accepted as an argument — supervisor-scoped
   * "view another worker's tasks" is a separate authorized query.
   */
  myAssignedCountTasks?: Maybe<MyAssignedCountTasksConnection>;
  /**
   * The authenticated caller's own BPF starting-node grants — the parity replacement for the legacy
   * treeForUser query. Resolves by composite _id (tenant + caller user id) so the PWA
   * can scope its Finish/Material location pickers to the current user's entry points. The caller's
   * JWT sub arrives dashed or dashless depending on identity provider, but grants are always
   * keyed strict-dashless (matching the setBpfUserStartingNodes write path's ValidIdStrict),
   * so the sub is normalized via ValidIdStrict.CreateFromExternalId before the lookup —
   * otherwise a dashed sub never resolves a real grant. Returns null when the user has no assignment,
   * or when the sub fails id validation.
   */
  myBpfStartingNodes?: Maybe<BpfUserStartingNodeDocument>;
  /**
   * Returns task assignments assigned to the current user.
   * Excludes cancelled assignments by default.
   */
  myTaskAssignments?: Maybe<MyTaskAssignmentsConnection>;
  onHandProcessQueue?: Maybe<OnHandProcessQueueConnection>;
  order?: Maybe<OrderStateData>;
  orderAddressEditPermissions: OrderAddressEditPermissions;
  /** @deprecated OrderAllocations collection removed. Allocation data is now on InventoryItem streams. Use inventoryItems query with AllocatedQuantity/AvailableQuantity fields instead. */
  orderAllocations?: Maybe<OrderAllocationsConnection>;
  /**
   * Generates the Bonnie-branded order invoice PDF. Restricted to the BPF tenant —
   * returns null for any other tenant. Non-BPF tenants must use the reporting module
   * via generateReportPdf with the report ID configured in
   * TenantState.OrderInvoiceReportId.
   * @deprecated BPF-only legacy generator. Non-BPF tenants must use generateReportPdf with the tenant's OrderInvoiceReportId.
   */
  orderDetailsPdf?: Maybe<OrderDetailsPdfData>;
  /**
   * OrderEase connection status for the current tenant, for the pwa connect card. Reads the
   * tenant's aggregate state (same source of truth as the connect/disconnect payloads, so status is
   * strongly consistent with a just-completed mutation) and surfaces only non-secret status — the
   * connected flag, the connect timestamp, and a MASKED client key. The client secret and refresh
   * token never leave wsapi; the read-model credential columns exist solely for the workers.
   */
  orderEaseIntegration: OrderEaseConnectionStatus;
  /**
   * Returns the calling tenant's order-email recipient-routing overrides (the sparse doc-type
   * -> ContactType map), or null when the tenant has never set any. Mirrors
   * tenantRouteConfig. A doc-type absent from Entries uses
   * OrderEmailRecipientResolver's built-in default.
   */
  orderEmailRecipientRouting?: Maybe<OrderEmailRecipientRoutingDocument>;
  /** Gets the order-email settings records for the current tenant. */
  orderEmailSettings?: Maybe<OrderEmailSettingsConnection>;
  /**
   * Resolves the compose-dialog defaults for the given order: the invoice recipients — every email of
   * every AccountsPayable-typed contact on the order's customer, falling back to the order's own
   * contact email when the customer has none (empty only when neither exists) — the effective verified
   * sender, the authored confirmation subject/body (raw
   * Handlebars, or raw defaults when not authored), and the tenant's effective invoice report id
   * (null when unbound). Returns null when the order is not found in the caller's tenant.
   */
  orderInvoiceEmailDraft?: Maybe<OrderInvoiceEmailDraftData>;
  orderLineItems?: Maybe<OrderLineItemsConnection>;
  /**
   * Returns a single order-production-lot allocation by its allocation id, scoped to the
   * caller's tenant. Filters on the composite _id ({TenantId}-{AllocationId})
   * so the lookup uses the free primary index rather than a secondary index (Atlas discipline
   * acada0ab).
   */
  orderProductionLotAllocationById?: Maybe<OrderProductionLotAllocationDocument>;
  /**
   * Returns all order-production-lot allocations for the caller's tenant, with paging,
   * filtering, and sorting. Filter by orderId, orderLineId, or
   * productionLotId to scope to a specific order line or lot.
   */
  orderProductionLotAllocations?: Maybe<OrderProductionLotAllocationsConnection>;
  orderVerificationComparison: OrderVerificationComparison;
  /**
   * Returns the calling tenant's Orderful integration config. Never null: when nothing has been
   * persisted the per-tenant defaults are applied (inactive, no mapping, no secret reference). The
   * tenant is resolved from the caller's context (no tenant-id parameter) so a tenant can never
   * read another tenant's config.
   */
  orderfulIntegrationConfig: OrderfulIntegrationConfigDocument;
  /**
   * Cross-tenant admin overview: every tenant that has an Orderful integration config, one row each,
   * enriched with the tenant display name from our own registry (Orderful exposes no list-orgs
   * endpoint). SuperAdmin-only. Key status is surfaced as a presence flag only — the
   * @keyvault(...) reference is never returned.
   */
  orderfulIntegrationConfigs: Array<OrderfulIntegrationConfigAdminRow>;
  /**
   * Lists the calling tenant's Orderful EDI transactions by proxying GET /v3/transactions
   * at resolve time — no projection is read or written. The tenant is resolved from the caller's
   * context (never an input), so a tenant can only ever see its own organization's transactions.
   * Gated twice, both as payload errors: the caller must hold an EDI role granting
   * View, and the tenant's integration must be Active
   * (enforced fail-closed inside IOrderfulClient.SendAsync, which also resolves the
   * per-tenant API key and applies the resilient client). Pages are Orderful-fixed at 100 max;
   * navigate with the returned cursors.
   */
  orderfulTransactions: OrderfulTransactionsPayload;
  orders?: Maybe<OrdersConnection>;
  ordersGrid?: Maybe<GridResponse>;
  /**
   * Distinct OrderStatus values present in the tenant's non-deleted combined orders
   * (orders + master orders) after applying the resolver's where filter. Powers the Fulfill
   * Orders grid's Status set-filter: the grid sends the same where it uses for
   * combinedOrders with the Status column's own predicate removed, so the option list shows
   * only statuses that will actually return rows. Never returns Deleted.
   */
  ordersStatuses: Array<OrderStatus>;
  /**
   * Distinct OrderType values present in the tenant's non-deleted combined orders
   * (orders + master orders) after applying the resolver's where filter. Powers the Fulfill
   * Orders grid's Type set-filter; see the ordersStatuses query for the set-filter contract.
   */
  ordersTypes: Array<OrderType>;
  /**
   * Distinct payment-status values present in the tenant's non-deleted combined orders (orders + master
   * orders) after applying the resolver's where filter. Powers the Fulfill Orders grid's Payment
   * Status set-filter; see the ordersStatuses query for the set-filter contract. Master orders carry
   * no payment ledger, so they always contribute the Unpaid value.
   */
  paymentStatuses: Array<PaymentStatus>;
  /**
   * Returns the calling tenant's Pending write-back records for a single workflow, oldest-first —
   * a read-only survey of outstanding work (depth, age) without taking a lease. Use the
   * claimPendingErpWriteBacks mutation to actually claim records for processing.
   */
  pendingErpWriteBacks?: Maybe<PendingErpWriteBacksConnection>;
  /**
   * Returns pending transfer orders for the caller's tenant whose
   * PendingTransferOrderDocument.ToSiteLocationId matches the given
   * destination. Used by the mobile receive UI to populate the worker's "to-do" list at
   * their current location.
   *
   *
   * **Returns:**
   *
   * Pageable IExecutable`1 of pending transfer orders matching the
   * caller's tenant, the destination, and IsReceived == false.
   */
  pendingTransferOrdersByDestination?: Maybe<PendingTransferOrdersByDestinationConnection>;
  /**
   * Returns the calling tenant's portal settings, reading the current state directly
   * from the KurrentDB stream (no projection lag). When the tenant has never saved
   * settings the documented defaults are returned (portal enabled, no minimum order,
   * self-registration on, grid catalog). Staff-only: a customer-type portal JWT gets
   * null, consistent with the portal authz pattern. Tenant-scoped — the stream is
   * keyed by the caller's own tenant id, so one tenant cannot read another's settings.
   */
  portalSettings?: Maybe<PortalSettingsStateData>;
  priceGroup?: Maybe<PriceGroupStateData>;
  priceGroups?: Maybe<PriceGroupsConnection>;
  /**
   * Relay-cursor read of price levels. priceGroupId, when supplied, is pushed into the FIRST
   * $match — ahead of the three target-name lookups — so the compound {TenantId, PriceGroupId} index
   * engages and the lookups only fan out over that group's rows. Previously the resolver matched on
   * TenantId alone and left group filtering to [UseFiltering]'s where clause, which
   * HotChocolate appends AFTER the lookups — every
   * tenant-wide level ran through all three joins before anything narrowed, which is what produced
   * the reported 10k-level totalCount TaskCanceledException. Any other where/
   * order the caller supplies via [UseFiltering]/[UseSorting] still applies
   * afterward as before; those dimensions aren't index-backed pre-lookup filters.
   * See the priceLevelsBlock field for the AG Grid SSRM offset-paging contract, which also
   * counts and pages in the same aggregation pass and appends an Id sort tiebreaker.
   */
  priceLevels?: Maybe<PriceLevelsConnection>;
  /**
   * AG Grid SSRM offset-block read of price levels: one request returns exactly the requested
   * offset/limit window (nodes) plus totalCount, both computed in a
   * SINGLE aggregation via $facet. priceGroupId, type, targetId, and
   * levelType are pushed into the pre-lookup $match the same way priceGroupId is on
   * the priceLevels field — levelType lives directly on the document, so it costs
   * nothing extra pre-lookup. sort always gets a trailing ascending-Id tiebreaker so
   * low-cardinality columns don't thrash page boundaries across blocks.
   */
  priceLevelsBlock: PriceLevelsBlockPayload;
  /** Returns the current pricing page for the caller's tenant, or null if none is set. */
  pricingPage?: Maybe<TenantPricingPageDocument>;
  /**
   * Retrieves a single production catalog by ID and tenant.
   * Returns null if the catalog is deleted.
   */
  productionCatalog?: Maybe<ProductionCatalogData>;
  /** Retrieves a list of production catalogs with filtering, sorting, and pagination support. */
  productionCatalogs?: Maybe<ProductionCatalogsConnection>;
  productionCategories?: Maybe<ProductionCategoriesConnection>;
  productionCategory?: Maybe<ProductionCategoryStateData>;
  productionItems?: Maybe<ProductionItemsConnection>;
  /**
   * Returns the distinct native production items (id and number with Genus / Series / Color / Category)
   * available to the calling tenant, for the mapping-setup picker. Replaces the legacy cross-DB
   * DB_ID('Produce') pull that silently returned nothing when the Produce database was absent: a
   * tenant with no production items gets an explicit empty list — never null, never a swallowed error.
   * A disabled FORECAST flag also returns an empty list (the module is dark, nothing is exposed).
   */
  productionItemsCatalog: Array<ProductionItemCatalogEntry>;
  /**
   * Returns the computed consumption manifest (material × computed quantity × suggested bin + on-hand)
   * for each requested production job at its produced quantity.
   */
  productionJobConsumptionManifest: ProductionJobConsumptionManifest;
  productionJobs?: Maybe<ProductionJobsConnection>;
  productionLot?: Maybe<ProductionLotStateData>;
  /**
   * Returns the per-lot allocation rollups for the caller's tenant — one document per spec
   * production lot, exposing lotQty, totalAllocatedQty, and the derived
   * netAvailableQty (max(0, lotQty − totalAllocatedQty)). Filter by
   * productionLotId (e.g. { in: [...] }) so the client can read live net
   * availability for the lots it is about to allocate against.
   */
  productionLotAllocationRollups?: Maybe<ProductionLotAllocationRollupsConnection>;
  productionLotAsyncImportJobRows?: Maybe<ProductionLotAsyncImportJobRowsConnection>;
  /**
   * The tenant's production lots. When salesItemId is supplied the candidate
   * set is scoped server-side to the lots whose FinishJob (catalog, category) matches the
   * production item linked to that sales item — the order-line-aware guardrail for Produce
   * Allocation, so an under-scoped client cannot widen the candidate set beyond the line's linked
   * lots. Omitting salesItemId returns the unscoped tenant lot list.
   */
  productionLots?: Maybe<ProductionLotsConnection>;
  productionMaterialEvent?: Maybe<ProductionMaterialEventStateData>;
  /**
   * Returns paginated details for production material events. Supports two calling modes:
   *
   * Single-event mode: pass productionMaterialEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionMaterialEventId: null and supply a
   * where: { productionMaterialEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant.
   */
  productionMaterialEventDetails?: Maybe<ProductionMaterialEventDetailsConnection>;
  productionMaterialEvents?: Maybe<ProductionMaterialEventsConnection>;
  productionPlan?: Maybe<ProductionPlanStateData>;
  productionPlans?: Maybe<ProductionPlansConnection>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
  /**
   * Returns the computed Bill-of-Materials for a specific production recipe variation.
   * Returns null when the variation cannot be found for the current tenant.
   */
  productionRecipeBom?: Maybe<ProductionRecipeBom>;
  /**
   * Server-computed group headers (with per-group counts) for the Recipes sidebar, so the client
   * renders grouping over the full catalog without loading every recipe and grouping in memory.
   * groupBy selects the bucket key (category code, or "{genus} {series}"
   * catalog identity). search is the same case-insensitive OR-contains over
   * the catalog/category fields the sidebar applies, so counts reflect the active search. The
   * group's children are then lazy-loaded via productionRecipes filtered to the bucket key.
   */
  productionRecipeGroups: Array<ProductionRecipeGroupBucket>;
  /**
   * Returns the audit history of a production recipe, newest first. Each record
   * represents a single event written to the recipe's event stream (creation,
   * variation add/update/remove, activation, inactivation, deletion, and labor-source
   * changes). The recipe event stream is bounded (per-recipe) and small in practice,
   * so the full history is returned in one call rather than wrapped in HotChocolate's
   * cursor-paging connection — the only existing wsapi paging provider is the MongoDB
   * one, which cannot paginate an in-memory event-store projection. The PWA History
   * tab currently renders a flat list, so client-side paging is sufficient.
   *
   *
   * **Returns:**
   * History records ordered newest-first, or an empty sequence when the recipe has no events.
   */
  productionRecipeHistory: Array<ProductionRecipeHistoryRecord>;
  productionRecipeVariations?: Maybe<ProductionRecipeVariationsConnection>;
  productionRecipes?: Maybe<ProductionRecipesConnection>;
  productionSpaceCategories?: Maybe<ProductionSpaceCategoriesConnection>;
  productionSpaceCategory?: Maybe<ProductionSpaceCategoryStateData>;
  productionSpaceEvent?: Maybe<ProductionSpaceEventStateData>;
  /**
   * Returns paginated details for production space events. Supports two calling modes:
   *
   * Single-event mode: pass productionSpaceEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionSpaceEventId: null and supply a
   * where: { productionSpaceEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant.
   */
  productionSpaceEventDetails?: Maybe<ProductionSpaceEventDetailsConnection>;
  productionSpaceEvents?: Maybe<ProductionSpaceEventsConnection>;
  productionSpaceType?: Maybe<ProductionSpaceTypeStateData>;
  productionSpaceTypes?: Maybe<ProductionSpaceTypesConnection>;
  productionTaskEvent?: Maybe<ProductionTaskEventStateData>;
  /**
   * Returns paginated details for production task events. Supports two calling modes:
   *
   * Single-event mode: pass productionTaskEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionTaskEventId: null and supply a
   * where: { productionTaskEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant.
   */
  productionTaskEventDetails?: Maybe<ProductionTaskEventDetailsConnection>;
  productionTaskEvents?: Maybe<ProductionTaskEventsConnection>;
  productionTriggers?: Maybe<ProductionTriggersConnection>;
  programs?: Maybe<ProgramsConnection>;
  projectionStatus?: Maybe<ProjectionStatusDocument>;
  projectionStatuses: Array<ProjectionStatusDocument>;
  promotionRule?: Maybe<PromotionRuleStateData>;
  /**
   * UNAUTHENTICATED code lookup for the public registration page. Returns only validity
   * (plus the recipient email to prefill when valid) — unknown and deleted codes are both
   * NotFound, and no other invite data crosses this surface.
   */
  publicUserInviteByCode: PublicUserInvitePayload;
  purchaseOrderAllocationById?: Maybe<PurchaseOrderAllocationDocument>;
  purchaseOrderAllocations?: Maybe<PurchaseOrderAllocationsConnection>;
  /**
   * Full detail for one run, with media paths composed into absolute URLs. Returns null when the
   * id is unknown so a stale dashboard deep-link renders "run not found" rather than erroring.
   */
  qaTestRun?: Maybe<QaTestRunResult>;
  /**
   * Paged index of test runs, newest first by default. Flows are projected away (see
   * QaTestRunSummaryResult); the dashboard fetches a single run's detail separately
   * once the user selects it.
   */
  qaTestRuns?: Maybe<QaTestRunsConnection>;
  reapplyRecipesPreview: Array<ReapplyRecipesPreviewResult>;
  /**
   * Server-computed group headers (with per-group counts) for the Restock Rules sidebar, so the
   * client renders grouping over the full rule set without loading every rule and grouping in
   * memory. groupBy selects the bucket key (rule Status or rule
   * RuleType). search is the same case-insensitive OR-contains over the
   * rule name/description the sidebar applies, so counts reflect the active search. The group's
   * children are then lazy-loaded via replenishmentRules filtered to the bucket key, which
   * is the canonical GraphQL enum value the list where filter expects.
   */
  replenishmentRuleGroups: Array<ReplenishmentRuleGroupBucket>;
  replenishmentRules?: Maybe<ReplenishmentRulesConnection>;
  replenishmentSettings?: Maybe<ReplenishmentSettingsStateData>;
  /** Returns per-customer order history data for report generation. */
  reportCustomerOrderHistoryData: ReportCustomerOrderHistoryDataPayload;
  /**
   * Returns customer data for report generation. Filters the CustomersSummary collection
   * by tenant and optional status/name filters.
   */
  reportCustomersData: ReportCustomersDataPayload;
  /**
   * Returns one report row per cycle count item for the current tenant. The userId
   * filter and output field map to CycleCountLogDocument.RecordedBy,
   * which stores the email of the person who submitted the count.
   */
  reportCycleCountHistoryData: ReportCycleCountHistoryDataPayload;
  /**
   * Returns all report data sources. These are system-level seed data shared across all tenants
   * (not tenant-scoped), so no TenantId filter is applied.
   * Paging is omitted intentionally — the data source count is small and fixed.
   */
  reportDataSources: Array<ReportDataSourceDocument>;
  /**
   * Returns one report row per item, with booked demand, on-hand inventory,
   * available inventory, scheduled production, net supply, and shortage.
   */
  reportDemandVsSupplyData: ReportDemandVsSupplyDataPayload;
  /**
   * Gets report execution records for the current tenant, optionally filtered
   * by report identifier, schedule identifier, or order identifier.
   */
  reportExecutions?: Maybe<ReportExecutionsConnection>;
  reportFolders?: Maybe<ReportFoldersConnection>;
  /**
   * Returns inventory data for report generation. Filters the InventoryItems collection
   * by tenant and optional sku/itemName/locationId, returning one row per
   * (location × item × grade) combination.
   */
  reportInventoryData: ReportInventoryDataPayload;
  /**
   * Returns inventory transaction data for report generation. Filters the InventoryTransactions
   * collection by tenant and optional transaction type, item, location, sku, and timestamp range.
   */
  reportInventoryTransactionsData: ReportInventoryTransactionsDataPayload;
  /**
   * Returns material-item catalog data for report generation. Filters
   * MaterialItemDocument by tenant and optional name/erpId/status/category,
   * returning one row per material item. Status is projected as its enum string name so
   * CSV/PDF/Excel exports render the human-readable value.
   */
  reportMaterialItemsData: ReportMaterialItemsDataPayload;
  /** Returns one row per open order with line-level readiness summarized to the order. */
  reportOrderFulfillmentReadinessData: ReportOrderFulfillmentReadinessDataPayload;
  /** Returns one report row per order line item, enriched with parent-order fields. */
  reportOrderLineItemsData: ReportOrderLineItemsDataPayload;
  /**
   * Returns order data for report generation. Uses MongoDB aggregation pipeline with
   * $lookup joins to OrderLineItems and CustomersSummary, then maps to a denormalized
   * report shape. Filter semantics (tenant scoping, Deleted exclusion, enum-validation
   * short-circuit, inclusive-day-bound on dateTo) are shared with the PDF path
   * through ReportOrdersDataMaterializer.BuildBaseFilters. statuses
   * is the multi-status selector (e.g. "Shipped OR Closed"): when supplied it drives a Mongo
   * $in and wins over the single status eq, so a Customer
   * Statement / Invoice can target several real order statuses in one report.
   * route filters on the same resolved EffectiveRoute value the
   * route column shows.
   */
  reportOrdersData: ReportOrdersDataPayload;
  /**
   * Returns production cost rollup data for report generation. Filters the
   * CollectionNames.ProductionCosts collection by tenant and the optional
   * recipe, location, and date range parameters. Default sort is total cost descending so
   * the most expensive lots surface first for margin review.
   */
  reportProductionCostsData: ReportProductionCostsDataPayload;
  /**
   * Returns production job data for report generation. Filters the Job collection
   * by tenant and optional status, location, item, and delivery date range.
   */
  reportProductionJobsData: ReportProductionJobsDataPayload;
  /**
   * Returns production lot data for report generation. Filters the ProductionLots collection
   * by tenant and optional status, production plan, customer, and created-at date range.
   */
  reportProductionLotsData: ReportProductionLotsDataPayload;
  /**
   * Returns production schedule data for report generation. Filters Job by tenant and optional
   * delivery date, location, and status, then joins tenant-scoped WorkOrder and SiteLocation data.
   */
  reportProductionScheduleData: ReportProductionScheduleDataPayload;
  /**
   * Returns product data for report generation. Filters the ItemSummary collection
   * by tenant and optional status, genus, and product group.
   */
  reportProductsData: ReportProductsDataPayload;
  /**
   * Returns the picking-ticket rows for a single order. One row per
   * (order line item × allocated location). Order-header fields are denormalized
   * onto every row so the slip can be rendered tabularly without per-row joins
   * on the client. ReportPullSlipDataRow.AlternateLocations excludes
   * the allocated location itself and only includes locations with positive
   * available quantity.
   */
  reportPullSlipData: ReportPullSlipDataPayload;
  /** Returns one profitability row per recipe with joined production lots and linked sales item data. */
  reportRecipeProfitabilityData: ReportRecipeProfitabilityDataPayload;
  /**
   * Returns aggregated royalty totals grouped by payee for orders shipped within
   * the supplied date window. Lines with RoyaltyExempt = true or no royalty config
   * are excluded. Orders in Cancelled, Deleted, or Initialized (Draft) status are
   * excluded. shippedTo is normalized to an inclusive end-of-day bound so a
   * UTC-midnight upper bound (the natural date-picker value) includes the entire
   * selected day. The rollup is shared with the reporting-engine export pipeline.
   */
  reportRoyaltyPayoutData: ReportRoyaltyPayoutDataPayload;
  /**
   * Returns the sales-by-category rollup. groupBy selects the rollup
   * dimension; dateFrom / dateTo bound the order
   * initialization date inclusively (no default — callers supply explicit bounds, or
   * omit them to scan the full corpus). customerId narrows to a single
   * customer. Rows are sorted by total revenue descending.
   */
  reportSalesByCategoryData: ReportSalesByCategoryDataPayload;
  /**
   * Returns the period-vs-period sales comparison rollup. metric
   * selects whether totals are Dollars or Units; groupBy selects
   * the grouping dimension. The same scope filters are applied to both periods.
   */
  reportSalesComparisonData: ReportSalesComparisonDataPayload;
  /**
   * Returns one aggregated row per sales person. Orders without a sales person, and orders
   * in Deleted or Cancelled status, are excluded before grouping.
   */
  reportSalesPersonPerformanceData: ReportSalesPersonPerformanceDataPayload;
  /**
   * Returns sales velocity data from BaseRatesOfSale for report generation.
   * Filters by tenant and optional item, customer, location, program, and minimum weekly rate of sale.
   */
  reportSalesVelocityData: ReportSalesVelocityDataPayload;
  /** Gets report schedules for the current tenant. */
  reportSchedules?: Maybe<ReportSchedulesConnection>;
  /**
   * Returns one row per customer ship-to location for report generation, segmentable by state,
   * route ("run"), salesperson and customer name.
   */
  reportShipToAddressesData: ReportShipToAddressesDataPayload;
  /** Gets a single report template by ID for the current tenant or system templates. */
  reportTemplate?: Maybe<ReportTemplateDocument>;
  /** Gets report templates for the current tenant and system templates. */
  reportTemplates?: Maybe<ReportTemplatesConnection>;
  /**
   * Returns vendor purchase order data for report generation. Filters the
   * VendorPurchaseOrder collection by tenant and optional status, vendor id,
   * and order-date range. Default sort is OrderPlacedDate descending so the
   * most recently placed POs appear first.
   */
  reportVendorPurchaseOrdersData: ReportVendorPurchaseOrdersDataPayload;
  /**
   * Returns one aggregated row per vendor. Filters the underlying
   * VendorPurchaseOrderDocument collection by tenant, optional vendorId
   * (vendor ERP id), and optional dateFrom/dateTo on
   * OrderPlacedDate. Default sort is VendorName ascending until the projection
   * enrichment task lands TotalSpend; the enrichment PR will move the primary sort
   * key to TotalSpend descending in lockstep with the sort doc + integration test.
   */
  reportVendorSpendData: ReportVendorSpendDataPayload;
  /**
   * Returns the version history of a report, newest first. Each record is one full-snapshot event
   * (creation or update) written to the report's event stream, carrying the author, timestamp, and
   * the complete snapshot for preview. The report event stream is bounded (per-report) and small,
   * so the full history is returned in one call rather than wrapped in HotChocolate's cursor-paging
   * connection — the only existing wsapi paging provider is the MongoDB one, which cannot paginate
   * an in-memory event-store read. Tenant isolation is enforced by the stream name (built from the
   * caller's tenant) and [Authorize].
   *
   *
   * **Returns:**
   * Version records ordered newest-first, or an empty sequence when the report has no events.
   */
  reportVersions: Array<ReportVersionRecord>;
  /**
   * Returns work order data for report generation. Filters the WorkOrder collection
   * by tenant and optional job, status, and start date range.
   */
  reportWorkOrdersData: ReportWorkOrdersDataPayload;
  reports?: Maybe<ReportsConnection>;
  reserveRule?: Maybe<ReserveRuleStateData>;
  resolveAvailabilityImportItems: AvailabilityImportItemResolutionPayload;
  /**
   * Resolves the single active SKU/UPC mapping for a given (tenant, customer, customerLocationId?, itemId)
   * tuple at a moment in time. Falls back from location-specific to customer-level when no location
   * match exists. Returns null when no active mapping exists.
   */
  resolveSkuUpcMapping?: Maybe<SkuUpcMapping>;
  /**
   * Resolves the effective space capacity for a sub-location and space type at an ISO (year, week):
   * a year-specific window wins over a recurring window, which wins over the sub-location's flat
   * capacity, else null. Carries the winning source for UI provenance. Shares the resolution ladder
   * with the domain path so the two read paths cannot drift.
   */
  resolvedSpaceCapacity?: Maybe<ResolvedSpaceCapacity>;
  restockCustomerLocations?: Maybe<RestockCustomerLocationsConnection>;
  /**
   * Returns the caller-tenant's pre-calculated Restock demand rows for the
   * asOf day. weeksOfSupply is optional —
   * when omitted, the tenant aggregate's DefaultWeeksOfSupply is read and
   * applied. Tenant scope is derived from UserResolverContext.TenantId
   * and never accepted as input. Paging via the GraphQL Connection spec
   * (first/after/last/before).
   */
  restockDailyDemand?: Maybe<RestockDailyDemandConnection>;
  /**
   * Returns aggregate KPIs for the caller-tenant's pre-calculated Restock demand rows on
   * the asOf day. weeksOfSupply falls back to the
   * tenant's DefaultWeeksOfSupply when omitted — same resolution rule as
   * restockDailyDemand. Tenant scope is derived from
   * UserResolverContext.TenantId and never accepted as input.
   *
   * The optional station argument narrows the two demand-side tiles to one dashboard
   * station, on DIFFERENT axes: TOTAL DEMAND filters the calc slice by the station's resolved
   * store ErpIds (RestockWorkQueueResultDocument.LocationCode $in), while TOTAL
   * AVAILABLE filters ErpAvailabilityDocument.StationCode == station directly. A station
   * that resolves to zero stores yields zero demand (never a silent tenant-wide fall-through).
   * latestCalcDate stays tenant-wide and is NOT narrowed by the station. Omitting
   * station leaves every tile unchanged.
   */
  restockDailyDemandSummary: RestockDailyDemandSummaryData;
  /**
   * Aggregates RestockWorkQueueResultDocument rows for the caller's tenant
   * into per-store rows. Optional itemCodes / locationCodes
   * narrow the scope: null or empty for either parameter means "no filter on this axis."
   * Returns an empty list (not null) when scope yields no rows. Malformed entity codes
   * throw a top-level GraphQL error rather than silently scanning the collection.
   */
  restockDashboardStoreRows: Array<RestockDashboardStoreRowData>;
  /**
   * Server-paged, server-filtered, server-sorted variant of
   * GetRestockDashboardStoreRows. Mirrors the Orders pattern
   * restockSessionOrderItemsBlock: offset-based paging with a parallel
   * RestockDashboardStoreRowsBlockData.TotalCount so the PWA AG Grid
   * serverSide row model can render large tenants (~20k stores for BPF) without shipping
   * every row to the client. Tenant scope is identical to the legacy resolver — derived
   * from the JWT, never an input. The legacy resolver is intentionally untouched; the
   * PWA cutover is the sibling task.
   */
  restockDashboardStoreRowsBlock: RestockDashboardStoreRowsBlockData;
  /**
   * Unified restock metrics entry point. Returns the seven-concept
   * RestockMetricsData shape at either session or item scope based
   * on whether itemId is supplied. Branches on
   * session.StationCode — non-null routes to the ERP-tenant path
   * (NAV/SQL availability + ERP pricing); null routes to the inventory-tenant path
   * (RestockAvailabilityDocument with Source=Inventory for Available,
   * InventoryItemDocument.AllocatedQuantity for Allocated, MongoPricingService
   * for prices, InTransit held at zero until an inventory-side analogue is
   * modelled). Returns null only when the session does not exist or is soft-deleted.
   */
  restockMetrics?: Maybe<RestockMetrics>;
  /**
   * Returns the BYOA explanation payload for a single Restock row, scoped to the caller's
   * tenant. Returns null when no explanation has been persisted for the
   * (sessionId, storeSkuKey) pair.
   */
  restockRowExplanation?: Maybe<RestockExplanationPayload>;
  restockSession?: Maybe<RestockSessionStateData>;
  /**
   * Drill-down for a session create that completed with exclusions: the full capped
   * (≤200) excluded item-code list plus tuple/item totals, scoped to the caller's tenant.
   * Backed by the same RestockSessionCreationProgressDocument TTL audit row as the
   * progress surfaces — the subscription payload carries only a bounded sample, so the PWA
   * fetches this on demand when the user expands the amber created-with-exclusions notice.
   * Returns null when the session recorded no exclusions (or the audit row aged out).
   */
  restockSessionCreationExclusions?: Maybe<RestockSessionCreationExclusionsPayload>;
  /**
   * ERP-agnostic export feed of a session's orderable rows (OrderQuantity > 0), joined to
   * store/item/session reference data and resolved container codes. Mirrors the DBR
   * dbrSessionNavOrders shape but is deliberately not Nav-specific — downstream
   * integrations consume the generic store/station/carrier/container attributes.
   */
  restockSessionExportOrders?: Maybe<RestockSessionExportOrdersConnection>;
  /**
   * Paged read of the per-(tenant, session, item) allocated-quantity totals from the
   * CollectionNames.RestockSessionItemAllocations collection. Filtered to the
   * caller's tenant. Powers the allocation wizard's "available" widget.
   */
  restockSessionItemAllocations?: Maybe<RestockSessionItemAllocationsConnection>;
  /**
   * Returns per-item availability for every distinct item in a Restock session. Mirrors
   * dbrSessionItemsAvailability with the same ERP/inventory branching, reading from
   * CollectionNames.RestockSessions + CollectionNames.RestockSessionOrderItems.
   * Returns an empty list when the session is missing, soft-deleted, or has no order items.
   */
  restockSessionItemsAvailability: Array<RestockSessionItemAvailabilityData>;
  /**
   * Paged read of the persisted Restock session order-items grid, joined to the same shared
   * reference data as the DBR 1.0 surface (ItemSummary, CustomerLocations, CustomersSummary,
   * ErpItemPricing, CycleCountLog). Mirrors dbrSessionOrderItems.
   */
  restockSessionOrderItems?: Maybe<RestockSessionOrderItemsConnection>;
  /**
   * Windowed/grouped fetch of the Restock session order-items grid. Mirrors
   * dbrSessionOrderItemsBlock; the only difference is the source collection.
   */
  restockSessionOrderItemsBlock: RestockSessionOrderItemsBlockPayload;
  /**
   * Returns the append-only override history for a specific
   * (tenant, session, item, customerLocation) tuple from the
   * CollectionNames.RestockSessionOrderQuantityOverrideHistory collection,
   * ordered by newest change first (OccurredAt descending, with Sequence as a
   * stable tie-breaker). Tenant isolation is enforced by the first filter condition.
   * Mirrors dbrSessionOrderQuantityOverrideHistory.
   */
  restockSessionOrderQuantityOverrideHistory?: Maybe<RestockSessionOrderQuantityOverrideHistoryConnection>;
  /**
   * Returns the latest BYOA-v1 session-create progress phase for a single session, scoped to
   * the caller's tenant. Backed by the RestockSessionCreationProgressDocument
   * TTL audit row written by RestockSessionProgressEmitter. Lets the PWA seed
   * its progress modal from the last-known phase when the user opens the dashboard after the
   * onRestockSessionBatchProgress subscription would have already missed earlier
   * phases. Returns null when no progress doc exists for the session.
   * LEGACY: the subscription now replays the same state on (re)subscribe via the shared
   * RestockSessionProgressReader; this query is deleted once the PWA cutover
   * ships (helm task 62b07d66cf75406bbd807b2cac77bdee).
   */
  restockSessionProgress?: Maybe<RestockSessionBatchProgressPayload>;
  /**
   * Returns the persisted Restock calculation steps for a single
   * (sessionId, itemId, locationId) row, scoped to the caller's tenant. Steps live in
   * the RestockSessionCalcStepsDocument side collection (off the session's event
   * stream) and share the row with the BYOA explanation payload. Returns an empty array when
   * the row does not exist or its TTL window has expired. Mirrors
   * calcStepsForDbrSessionRow; the only signature difference is the composite
   * storeSkuKey assembled from (locationId, itemId).
   */
  restockSessionRowCalcSteps: Array<RestockCalcStepDocument>;
  /**
   * Returns session-level totals for the v2 Submit Orders confirmation card: store count
   * (from the session document), selected item row count, and sums of Carts and
   * UnitValue × OrderQuantity across all RestockSessionOrderItemDocument
   * rows for the session. Mirrors dbrSessionSubmitSummary. Returns null when
   * the session does not exist, is soft-deleted, or the sessionId fails strict validation.
   */
  restockSessionSubmitSummary?: Maybe<RestockSessionSubmitSummaryData>;
  restockSessions?: Maybe<RestockSessionsConnection>;
  /**
   * The BP organic lots currently available for the calling tenant — the parity replacement for
   * inventory-api's retailAvailableBpLots. Read from the worker-owned RetailBpLots read
   * model (see RetailAvailableBpLotDocument) with every recorded retail count netted off
   * the mirrored Nav quantity, so a lot that has been fully dropped off disappears instead of staying
   * assignable forever. One row per Nav transfer-shipment line: when a lot arrived on several lines the
   * recorded counts are apportioned across them, so summing the rows of a lot yields its true remaining
   * availability. Paged, filterable, sortable — over the NETTED quantity — so the PWA can scope by
   * product or station. Tenant-scoped.
   */
  retailAvailableBpLots?: Maybe<RetailAvailableBpLotsConnection>;
  /**
   * The retail store-count audit history for the calling tenant — the immutable record of every
   * count recorded by field users. Tenant-scoped; paged, filterable, sortable so the PWA can scope
   * by product, location, or count type for triage and read-back.
   */
  retailProductCounts?: Maybe<RetailProductCountsConnection>;
  /** Gets paginated, filtered, and sortable RFID scan records for the current tenant */
  rfidScans?: Maybe<RfidScansConnection>;
  scavengeLog?: Maybe<ScavengeLogConnection>;
  /**
   * Gets the current tenant's selectable senders merged across EVERY registered channel source
   * (SendGrid single + domain, SMTP), each node carrying its channel. Each source enforces
   * its own send-eligibility contract server-side (SendGrid exposes only verified senders), never a
   * client-supplied filter. The merged set is small and bounded, so it is returned as a plain list
   * rather than a paged connection.
   *
   * CALLER-AWARE (Decision D): an unrestricted staff (admin) caller sees every selectable sender;
   * a non-admin staff caller never sees a sender flagged adminOnly. This is a UX filter on
   * the dropdown — the real security boundary is the use-time TenantEmailSenderGate
   * enforced on the FK-validated write paths.
   */
  selectableEmailSenders: Array<TenantEmailSenderData>;
  /**
   * Returns the hard goods (MaterialItems) the tenant offers for sale in the FULFILL context —
   * i.e. those flagged Sellable and currently
   * Active. This is the available-to-sell surface a FULFILL
   * order picker uses to add a hard good to an order line. Non-sellable hard goods are excluded
   * here, but remain freely usable as item upgrades (any hard good can be an upgrade).
   */
  sellableHardgoods?: Maybe<SellableHardgoodsConnection>;
  /** Resolves the DNS/SendGrid domain-policy signal for the given domain. */
  senderDomainPolicy: SenderDomainPolicyData;
  /**
   * Returns the session-level restock metrics for the v2 Restock Orders sidebar.
   * Seven concepts (Available / Allocated / In Transit / Available for Orders /
   * On Order / Remaining Availability / Utilization %), each with a quantity and a
   * wholesale dollar value. Available, Allocated, and In Transit are deduped per
   * ItemId (wsapi mirrors each item onto every customer-location row, so
   * the per-item figure must be counted once). Allocated vs. In Transit routing
   * is decided by a per-tenant mapping keyed off user.TenantId. When the
   * session has no StationCode (inventory-tenant path), ERP-sourced
   * concepts (Available / In Transit / their values) are returned as zero; the
   * live OnOrder/RemainingAvailability/Utilization still
   * reflect the session's OrderQuantity state. RemainingAvailability
   * is unclamped — negatives signal legitimate over-allocation. Utilization
   * returns a large sentinel (9999.0) when AvailableForOrders <= 0
   * and OnOrder > 0, and 0 when both are zero. Returns null
   * when the session does not exist, is soft-deleted, or sessionId
   * fails ValidIdStrict.
   */
  sessionRestockMetrics?: Maybe<SessionRestockMetricsData>;
  sftpSystemSettings: SftpSystemSettingsStateData;
  sftpTenantConfig?: Maybe<SftpTenantConfigStateData>;
  sftpTenantConfigs?: Maybe<SftpTenantConfigsConnection>;
  sftpTenants: Array<Scalars['String']['output']>;
  /**
   * Distinct ship-from site names present in the tenant's non-deleted combined orders (orders + master
   * orders) after applying the resolver's where filter. Powers the Fulfill Orders grid's Ship-From
   * Site set-filter; see the ordersStatuses query for the set-filter contract. Blank names — the
   * master-order rows and legacy / pre-V3 orders that carry no structured ship-from site — are excluded,
   * so the list is exactly the distinct set of sites actually in use.
   */
  shipFromSiteNames: Array<Scalars['String']['output']>;
  /**
   * Generates the Bonnie-branded shipping acknowledgement PDF. Restricted to the BPF tenant —
   * returns null for any other tenant. Non-BPF tenants must use the reporting module
   * via generateReportPdf with the report ID configured in
   * TenantState.OrderAcknowledgementReportId.
   * @deprecated BPF-only legacy generator. Non-BPF tenants must use generateReportPdf with the tenant's OrderAcknowledgementReportId.
   */
  shippingAcknowledgmentPdf?: Maybe<OrderDetailsPdfData>;
  siteLocation?: Maybe<SiteLocationDocument>;
  siteLocationAsyncImportJobRows?: Maybe<SiteLocationAsyncImportJobRowsConnection>;
  siteLocationTypeRelationships: SiteLocationTypeRelationships;
  siteLocations?: Maybe<SiteLocationsConnection>;
  /**
   * Computes export-precondition site-map coverage for a forecast (spec P10/P12): over the grid of the
   * forecast customer's locations by the forecast's programs, the location-and-program pairs that lack a
   * site map. The FORECAST feature gate is checked FIRST — a tenant without the flag gets null, never a
   * computed coverage. The forecast id is validated and the forecast is loaded tenant-scoped (its
   * composite id embeds the tenant); a missing forecast returns null. Locations and existing mappings
   * are read tenant-and-customer scoped (guarded by a cross-tenant leak test). A well-formed forecast
   * with no locations or no programs returns an empty, complete coverage (not null) — an empty gap list
   * is a valid complete result.
   */
  siteMapCoverage?: Maybe<SiteMapCoverage>;
  /**
   * Lists the calling tenant's active site maps for a customer, optionally narrowed to a single
   * customer location. Tenant-scoped via the load-bearing TenantId filter, guarded by a cross-tenant
   * leak integration test. Returns no rows when the Forecast flag is disabled for the tenant.
   */
  siteMaps?: Maybe<SiteMapsConnection>;
  sizeUom?: Maybe<SizeUomStateData>;
  sizeUoms?: Maybe<SizeUomsConnection>;
  /**
   * Returns customer SKU/UPC/retail-price mappings (renamed from "customerItems") for the
   * given itemId within the caller's tenant. Same shape as the
   * deprecated customerItems query — both back the same Mongo collection.
   */
  skuUpcMappings?: Maybe<SkuUpcMappingsConnection>;
  /**
   * Paginated, filterable, sortable space-capacity windows for the tenant. Clients scope to a site,
   * sub-location or space type via the filter input (e.g. where: { siteLocationId: { eq } }).
   */
  spaceCapacityWindows?: Maybe<SpaceCapacityWindowsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Space Events sidebar, so the
   * client renders grouping over the full event list without loading every event and grouping in
   * memory. groupBy selects the bucket key dimension (event Status or
   * event Name). search is the same case-insensitive OR-contains over the
   * event name the sidebar applies, so counts reflect the active search. The group's children are
   * then lazy-loaded via productionSpaceEvents filtered to the bucket key — each bucket's
   * Key equals that list's where eq-value for the
   * dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  spaceEventGroups: Array<SpaceEventGroupBucket>;
  spaceUtilization: Array<SpaceCapacityRow>;
  /**
   * Stateless, read-only what-if overlay for the capacity board. Loads the same space-usage
   * documents as the spaceUtilization board for the given filters, applies the staged moves in
   * memory, and returns before/after usage per row plus violations and per-move validity/staleness.
   * Performs no writes and never touches ProductionJob.SpaceDimensions.
   */
  spaceUtilizationPreview: SpaceUtilizationPreview;
  /**
   * Staged equivalent of the production categories query — cursor-paged,
   * with where/order against the same CategoryDocument type the
   * pwa Category grid already binds to. Reads from Category.Staged.Summary
   * populated by validateCategoryDocuments.
   */
  stagedCategories?: Maybe<StagedCategoriesConnection>;
  /**
   * Staged equivalent of the production single-category lookup — returns the
   * staged CategoryDocument for the given code, or null.
   */
  stagedCategory?: Maybe<CategoryDocument>;
  /**
   * Staged equivalent of the production customer(customerId) query —
   * returns a CustomerStateData stitched from the staged summary
   * + the staged ship-to locations so the pwa fragment Customer on
   * CustomerStateData works unchanged. Returns null when no staged
   * row exists for the customerId.
   */
  stagedCustomer?: Maybe<CustomerStateData>;
  /**
   * Staged equivalent of the production customerLocations query —
   * cursor-paged, with where/order against the same
   * CustomerLocationDocument type the pwa already binds to.
   * Reads from Customers.Staged.Locations populated by
   * validateCustomerDocuments.
   */
  stagedCustomerLocations?: Maybe<StagedCustomerLocationsConnection>;
  /**
   * Staged equivalent of the production customers query — cursor-paged,
   * with where/order against the same CustomersSummaryDocument
   * type the pwa Customer grid already binds to. Reads from
   * Customers.Staged.Summary populated by validateCustomerDocuments.
   */
  stagedCustomers?: Maybe<StagedCustomersConnection>;
  /**
   * Staged single-order lookup — returns the staged
   * HistoricalOrderStagedSummaryDocument for the given order id, or null when
   * no staged row exists for the (tenantId, orderId) pair.
   */
  stagedHistoricalOrder?: Maybe<HistoricalOrderStagedSummaryDocument>;
  /**
   * Staged line items for one order — returns the
   * HistoricalOrderStagedLineItemDocument echoes written by
   * validateHistoricalOrderDocuments into HistoricalOrders.Staged.Lines, in
   * line-number order, so the pwa staged-review grid can show an order's lines on row click.
   * Returns an empty list when no staged lines exist for the (tenantId, orderId) pair.
   */
  stagedHistoricalOrderLineItems: Array<HistoricalOrderStagedLineItemDocument>;
  /**
   * Staged historical orders for the tenant — cursor-paged, with where/order against the
   * HistoricalOrderStagedSummaryDocument the pwa staged-review grid binds to. Reads
   * from HistoricalOrders.Staged.Summary populated by validateHistoricalOrderDocuments.
   */
  stagedHistoricalOrders?: Maybe<StagedHistoricalOrdersConnection>;
  /**
   * Staged equivalent of the production getInventoryItems query — cursor-paged,
   * with where/order against the same InventoryItemDocument type the pwa
   * inventory grid already binds to. Reads from Inventory.Staged.Summary
   * populated by validateInventoryItemDocuments, resolving the linked item name +
   * sku and location name at query time via the staged name-lookup $lookup (the
   * staging projection writes those fields empty by design).
   */
  stagedInventoryItems?: Maybe<StagedInventoryItemsConnection>;
  /**
   * Staged equivalent of the production item(itemId) query — returns
   * an ItemStateData stitched from the staged summary so the
   * pwa fragment Item on ItemStateData works unchanged. Returns
   * null when no staged row exists for the itemId.
   */
  stagedItem?: Maybe<ItemStateData>;
  /**
   * Staged equivalent of the production items query — cursor-paged,
   * with where/order against the same ItemSummaryDocument type
   * the pwa Item grid already binds to. Reads from Items.Staged.Summary
   * populated by validateItemsDocuments.
   */
  stagedItems?: Maybe<StagedItemsConnection>;
  /**
   * Staged equivalent of the production priceGroups query — cursor-paged,
   * with where/order against the same PriceGroupDocument type the pwa
   * price-group grid already binds to. Reads from PriceGroups.Staged.Summary
   * populated by validatePriceGroupDocuments.
   */
  stagedPriceGroups?: Maybe<StagedPriceGroupsConnection>;
  /**
   * Staged equivalent of the production priceLevels query — cursor-paged,
   * with where/order against the same PriceLevelDocument type the pwa
   * already binds to (filter on priceGroupId for one group's levels).
   * Reads from PriceGroups.Staged.Levels populated by
   * validatePriceGroupDocuments; no item/category $lookup is needed because
   * the staged documents carry TargetName from the posted payload.
   */
  stagedPriceLevels?: Maybe<StagedPriceLevelsConnection>;
  /**
   * Staged equivalent of the production siteLocation(siteLocationId) query.
   * Returns null when no staged row exists for the siteLocationId.
   */
  stagedSiteLocation?: Maybe<SiteLocationDocument>;
  /**
   * Staged equivalent of the production siteLocations query — cursor-paged, with
   * where/order against the same SiteLocationDocument type the pwa already binds
   * to. Reads from SiteLocations.Staged.Summary populated by
   * validateSiteLocationsDocuments.
   */
  stagedSiteLocations?: Maybe<StagedSiteLocationsConnection>;
  /**
   * Staged equivalent of the production subLocations query — cursor-paged, with
   * where/order against the same SubLocationDocument type the pwa already binds
   * to. Reads from SiteLocations.Staged.Locations populated by
   * validateSiteLocationsDocuments.
   */
  stagedSubLocations?: Maybe<StagedSubLocationsConnection>;
  /**
   * Staged equivalent of the production taxAuthorities query — cursor-paged, with
   * where/order against the same TaxAuthorityDocument type the pwa tax-authority grid
   * already binds to. Reads from TaxAuthority.Staged.Summary populated by
   * validateTaxAuthorityDocuments, tenant-scoped. Unlike the production query this carries
   * no TaxCalculationEnabled kill switch — the staged-review surface is SuperAdmin import
   * tooling that must show staged data regardless of the tenant's runtime flag.
   */
  stagedTaxAuthorities?: Maybe<StagedTaxAuthoritiesConnection>;
  /**
   * Staged equivalent of the production taxAuthority(taxAuthorityId) query — returns the
   * staged TaxAuthorityDocument so the pwa tax-authority detail fragments work unchanged.
   * Returns null when no staged row exists for the taxAuthorityId.
   */
  stagedTaxAuthority?: Maybe<TaxAuthorityDocument>;
  /**
   * Staged equivalent of the production termsById(termsId) query — returns a
   * TermsStateData stitched from the staged summary so the pwa Terms detail
   * fragments work unchanged. Returns null when no staged row exists for the termsId.
   */
  stagedTerm?: Maybe<TermsStateData>;
  /**
   * Staged equivalent of the production terms query — cursor-paged, with
   * where/order against the same TermsDocument type the pwa Terms grid already
   * binds to. Reads from Terms.Staged.Summary populated by
   * validateTermsDocuments. Uses the production
   * TermsDocumentFilterInputType so the staged filter input matches production
   * (percent-unit accrueInterestPercentage operands).
   */
  stagedTerms?: Maybe<StagedTermsConnection>;
  /**
   * The BP organic lots available at a single station for the calling tenant — the parity replacement
   * for inventory-api's stationBpLotInventory, scoped to the supplied station
   * (stationLocationId, the PWA's treeLocationAndChildren station node).
   * Like inventory-api's station arm, the Nav transfer-shipment lines of one lot are summed into a
   * single row and the recorded retail counts are netted off that total ONCE — so this surface reports
   * a lot's true station-wide availability. Paged, filterable, sortable — over the NETTED quantity;
   * tenant-scoped.
   */
  stationBpLotInventory?: Maybe<StationBpLotInventoryConnection>;
  storeClasses?: Maybe<StoreClassStateData>;
  streamCounts?: Maybe<StreamCountsConnection>;
  subLocation?: Maybe<SubLocationDocument>;
  subLocations?: Maybe<SubLocationsConnection>;
  synchronizationIterations?: Maybe<SynchronizationIterationsConnection>;
  synchronizationOnHandProcessIterations?: Maybe<SynchronizationOnHandProcessIterationsConnection>;
  synchronizationOnHandQueueingIterations?: Maybe<SynchronizationOnHandQueueingIterationsConnection>;
  /** Get a single task assignment by ID from the event store. */
  taskAssignment?: Maybe<TaskAssignmentStateData>;
  /** Get all task assignments for the tenant from MongoDB with paging, filtering, and sorting. */
  taskAssignments?: Maybe<TaskAssignmentsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Task Events sidebar, so the client
   * renders grouping over the full event list without loading every event and grouping in memory.
   * groupBy selects the bucket key dimension (event Status or event
   * Name). search is the same case-insensitive OR-contains over the event
   * name the sidebar applies, so counts reflect the active search. The base set mirrors
   * productionTaskEvents — tenant-scoped and excluding Deleted — so a Status group-by's bucket
   * counts sum to the list total. The group's children are then lazy-loaded via
   * productionTaskEvents filtered to the bucket key, which equals that list's where
   * eq-value for the dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  taskEventGroups: Array<TaskEventGroupBucket>;
  taskEventType?: Maybe<TaskEventTypeStateData>;
  taskEventTypes?: Maybe<TaskEventTypesConnection>;
  /**
   * Returns the tax authorities for the calling tenant. When the
   * TaxCalculationEnabled feature flag resolves to disabled, returns an
   * empty result so consumers cannot leak tax-authority data via the read model
   * while the kill switch is engaged. The MatchNothingTenantId
   * sentinel is needed because the HotChocolate [UsePaging] middleware
   * requires an IExecutable{T} back — it cannot be replaced with
   * an empty list, so we deterministically filter the collection to no rows.
   */
  taxAuthorities?: Maybe<TaxAuthoritiesConnection>;
  /**
   * Returns a single tax authority by id, or null when the input id fails to
   * parse, when the tenant has tax calculation disabled, or when the document does
   * not exist. Both the flag check (via TaxCalculationGate.RequireEnabled)
   * and the parse step (ValidIdStrict.Create) flow through one railway
   * so disabled-flag and malformed-id branches both fall through LeftAsync
   * without hitting Mongo. Mirrors the parse-early discipline already enforced by
   * the mutation surface in TaxAuthorityCommands.
   */
  taxAuthority?: Maybe<TaxAuthorityDocument>;
  tenant?: Maybe<TenantStateData>;
  /**
   * Returns the authenticated tenant's production import jobs for the user-facing list
   * (the PWA ScheduleImportListPage). Unlike GetAsyncImportJobs — which is intentionally
   * cross-tenant for the shared AsyncImportWorker — this query is tenant-scoped server-side:
   * the auth-context tenant from TenantResolver.RequireTenantId is AND-ed into the Mongo filter
   * before [UseFiltering] applies any client where-clause, so a client that supplies a mismatched
   * tenantId filter gets an impossible (tenantId == auth AND tenantId == client) predicate and
   * sees only the auth tenant's rows. The PWA-needed filters (createdBy, jobType) and createdAt
   * ordering remain available via the standard filtering/sorting surface; only tenantId is forced
   * server-side.
   */
  tenantAsyncImportJobs?: Maybe<TenantAsyncImportJobsConnection>;
  /**
   * UNAUTHENTICATED slug → tenant lookup for the portal vanity subdomain. The worksuite-pwa calls
   * this pre-login to resolve which tenant a {companySlug}.portal.silverfern.* host belongs
   * to, then bootstraps its tenant context exactly as it does from the /portal/:tenantSlug
   * path. Returns null for an unknown/unclaimed slug. Rate-limited per client (the only key
   * on this anonymous surface), gated like the other public portal reads
   * (publicUserInviteByCode, trialRequestStatus).
   */
  tenantByCompanySlug?: Maybe<TenantByCompanySlugView>;
  /**
   * UNAUTHENTICATED host → tenant lookup covering BOTH portal vanity layers: a registered
   * {companySlug}.portal.silverfern.* subdomain, and a tenant's own VERIFIED custom domain.
   * The worksuite-pwa calls this once pre-login on whatever host it was loaded from, then bootstraps
   * its tenant context exactly as it does from the /portal/:tenantSlug path. Returns
   * null for an unknown host, a non-portal host, and — deliberately — a custom domain whose
   * ownership is still unproven.
   */
  tenantByPortalHost?: Maybe<PortalHostTenantView>;
  /**
   * Returns the calling tenant's carrier configuration record (the tenant-default carrier), or
   * null when the tenant has not yet set a default. Mirrors tenantRouteConfig.
   */
  tenantCarrierConfig?: Maybe<TenantCarrierConfigDocument>;
  tenantCustomerPermissions?: Maybe<TenantCustomerPermissionsConnection>;
  /**
   * This tenant's bound email-authentication domain, or null when no domain is bound. Select
   * dnsRecords to fetch the live DNS records to publish at the domain's DNS provider before
   * calling validateTenantEmailDomain.
   */
  tenantEmailDomain?: Maybe<TenantEmailDomainData>;
  /** Gets all email sender identities for the current tenant. */
  tenantEmailSenders?: Maybe<TenantEmailSendersConnection>;
  tenantId: Scalars['String']['output'];
  /** Gets a single tenant integration token by integration ID from the event store. */
  tenantIntegrationToken?: Maybe<TenantIntegrationTokensStateData>;
  /** Gets all tenant integration tokens from MongoDB for the current tenant. */
  tenantIntegrationTokens: Array<TenantIntegrationTokenDocument>;
  /**
   * Returns the calling tenant's route configuration record (the tenant-default route), or
   * null when the tenant has not yet set a default. Mirrors tenantTaxConfig.
   */
  tenantRouteConfig?: Maybe<TenantRouteConfigDocument>;
  /**
   * Gets the current tenant's custom SMTP connection (host / port / username / mode / addresses /
   * status / last-verified), or null when none is configured. The password is never exposed.
   */
  tenantSmtpConnection?: Maybe<TenantSmtpConnectionData>;
  /**
   * Returns the calling tenant's tax configuration record. Returns null when
   * the tenant has not yet set defaults OR when the TaxCalculationEnabled
   * feature flag resolves to disabled. The flag check flows through
   * TaxCalculationGate.RequireEnabled so the disabled branch falls
   * through the railway.
   */
  tenantTaxConfig?: Maybe<TenantTaxConfigDocument>;
  terms?: Maybe<TermsConnection>;
  termsById?: Maybe<TermsStateData>;
  termsIdsByErpId: Array<TermsErpIdPair>;
  /**
   * Returns every configured trial policy. The collection holds one document per
   * TrialKind, so this is a small unpaged list by design.
   */
  trialPolicies: Array<TrialPolicyDocument>;
  /**
   * Returns the policy for one trial kind, or null when that kind has no policy row. Null is not
   * "unrestricted" — request-path callers read the policy through
   * ITrialPolicyProvider, which substitutes the built-in Standard defaults instead.
   */
  trialPolicy?: Maybe<TrialPolicyDocument>;
  /**
   * ANONYMOUS coarse status lookup by request id. Returns ONLY the request id and a collapsed
   * public status ({Pending, Approved, Rejected}); it exposes no contact PII, no match
   * candidates, and nothing about tenant existence. Keyed by the caller's own unguessable request
   * id and rate-limited per IP. Returns null for an unknown id.
   */
  trialRequestStatus?: Maybe<TrialRequestStatusView>;
  /**
   * SUPERADMIN approval queue: every trial request with full detail INCLUDING match candidates
   * and contact info, filterable/sortable/paged. This is the only surface that ever exposes the
   * match annotations. Oldest-first is the intended default ordering for the approval queue.
   */
  trialRequests?: Maybe<TrialRequestsConnection>;
  /**
   * Per-trial-tenant usage for the admin Trial Tenants grid and its detail drawer.
   *
   * tenantIds narrows the result to those tenants; omitted or empty returns every trial
   * tenant. Non-trial and deleted tenants are never returned, even when named explicitly — this
   * surface is defined over trial tenants, and a tenant with no cap context would be meaningless
   * here.
   */
  trialTenantUsage: Array<TrialTenantUsage>;
  /**
   * A single user from the tenant's user directory, or null when no user with the
   * given id exists in the caller's tenant.
   */
  user?: Maybe<UserDocument>;
  userAppSettings?: Maybe<UserAppSettingsConnection>;
  /**
   * Tenant-scoped pending-invites list for the worksuite app's Administration > Users page.
   * Unlike the SuperAdmin-only cross-tenant adminUserInvites console surface, the
   * tenant comes from the caller's JWT and there is no cross-tenant escape hatch, so a tenant can
   * only ever see its OWN invites. Callable by a platform superadmin JWT OR any tenant user whose
   * WorkSuiteUser directory entry is Active and holds the Admin role (the same in-code gate as
   * createUserInvite); the outer RestockWriter policy only excludes portal principals.
   * A superadmin gets the tenant's real pending list even with no directory entry, so it can
   * bootstrap an empty tenant; every other non-Admin caller still gets an empty list. By default
   * ("Pending" — includeExpired false) this means Unused and not yet past
   * ExpiresAt — accepted, used, failed, AND expired invites are excluded, exactly as
   * before this field was added. Passing includeExpired true additionally
   * surfaces the tenant's Unused invites now past ExpiresAt — still never accepted, used,
   * or failed invites — so a tenant admin can find one and re-invite it via
   * resendUserInvite (which resets ExpiresAt in place; see
   * TenantInviteAccess.EnsureNoExpiredInviteAwaitingResend for why
   * createUserInvite is not the path for this case). Returns the same
   * UserInviteDocument fields the admin grid renders, including status and
   * expiresAt so the caller can derive an "Expired" display state
   * (status == Unused && expiresAt < now).
   */
  userInvites: Array<UserInviteDocument>;
  /** Get current user's time entries with filtering support */
  userTimeEntries?: Maybe<UserTimeEntriesConnection>;
  /**
   * The tenant's user directory: internal staff with their business roles
   * (Sales, Sales Manager, Admin, Maintenance, Ops) and optional FusionAuth login link.
   */
  users?: Maybe<UsersConnection>;
  vendor?: Maybe<VendorStateData>;
  vendorMaterialCosts?: Maybe<VendorMaterialCostsConnection>;
  vendorPurchaseOrderById?: Maybe<VendorPurchaseOrderDocument>;
  vendorPurchaseOrders?: Maybe<VendorPurchaseOrdersConnection>;
  vendors?: Maybe<VendorsConnection>;
  verifyContainers?: Maybe<VerifyContainersConnection>;
  version: Scalars['String']['output'];
  workOrder: WorkOrderDocument;
  workOrders?: Maybe<WorkOrdersConnection>;
  /**
   * Returns the resolved worker config values for a given service and tenant.
   * This is what wsapi-services calls at runtime to get tenant-specific config values.
   */
  workerConfigs: Array<WorkerConfigResult>;
  wsapiImport?: Maybe<WsapiImportStateData>;
  /**
   * Returns the distinct tenant IDs that have at least one enabled WsapiImport.
   * Cross-tenant query used by the Synchronization service to discover which tenants
   * to fan out import iterations across — replaces a direct Mongo distinct lookup.
   */
  wsapiImportTenants: Array<Scalars['String']['output']>;
  wsapiImports?: Maybe<WsapiImportsConnection>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryActiveImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryActivePortalUsersByEmailArgs = {
  email: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminBackgroundServiceConfigArgs = {
  serviceName: BackgroundServiceName;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminBackgroundServiceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminBackgroundServiceConfigResultSortInput>>;
  where?: InputMaybe<AdminBackgroundServiceConfigResultFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminBackgroundServicePodsArgs = {
  order?: InputMaybe<Array<AdminBackgroundServicePodResultSortInput>>;
  where?: InputMaybe<AdminBackgroundServicePodResultFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcLatestResultDateArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcResultArgs = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcResultsByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcResultsByItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcResultsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCode: Scalars['String']['input'];
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcResultsByTenantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcTenantQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcTenantQueueDocumentSortInput>>;
  where?: InputMaybe<DbrCalcTenantQueueDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcWorkSummaryArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminDbrCalcWorkerFleetStatusArgs = {
  recentMinutes?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminFeatureFlagArgs = {
  name: FeatureFlagName;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminFeatureFlagResultSortInput>>;
  where?: InputMaybe<AdminFeatureFlagResultFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminIntegrationsArgs = {
  order?: InputMaybe<Array<TenantIntegrationDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcLatestResultDateArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcResultArgs = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcResultsByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcResultsByItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcResultsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCode: Scalars['String']['input'];
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcResultsByTenantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcTenantQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentSortInput>>;
  where?: InputMaybe<AdminRestockCalcTenantQueueDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcWorkSummaryArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockCalcWorkerFleetStatusArgs = {
  recentMinutes?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockDataValidityArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockSeedingCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockSeedingItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminRestockSeedingPipelineStatusArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminTenantArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminTenantPricingPageArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminTenantDocumentSortInput>>;
  where?: InputMaybe<AdminTenantDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminUserInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserInviteDocumentSortInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserInviteDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fusionAuthUserId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserDocumentSortInput>>;
  where?: InputMaybe<UserDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminWorkerConfigArgs = {
  configName: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAdminWorkerConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminWorkerConfigResultSortInput>>;
  where?: InputMaybe<AdminWorkerConfigResultFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAgGridRowsArgs = {
  gridId: Scalars['String']['input'];
  request: GridRequestInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAgGridSetValuesArgs = {
  colId: Scalars['String']['input'];
  gridId: Scalars['String']['input'];
  request: GridRequestInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllBaseRatesOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BaseRateOfSaleDocumentSortInput>>;
  where?: InputMaybe<BaseRateOfSaleDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllContainerConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContainerConfigDocumentSortInput>>;
  where?: InputMaybe<ContainerConfigDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllDailySalesProportionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DailySalesProportionDocumentSortInput>>;
  where?: InputMaybe<DailySalesProportionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllDeliverySchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeliveryScheduleDocumentSortInput>>;
  where?: InputMaybe<DeliveryScheduleDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllForecastSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ForecastSettingsDocumentSortInput>>;
  where?: InputMaybe<ForecastSettingsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllProgramReplenishmentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentSortInput>>;
  where?: InputMaybe<ProgramReplenishmentSettingsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllReplenishmentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReplenishmentSettingsDocumentSortInput>>;
  where?: InputMaybe<ReplenishmentSettingsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllWeeklySlopeFactorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WeeklySlopeFactorDocumentSortInput>>;
  where?: InputMaybe<WeeklySlopeFactorDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllocationTemplateArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllocationTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AllocationTemplateDocumentSortInput>>;
  where?: InputMaybe<AllocationTemplateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAllottedTimeBaselineArgs = {
  productionCategoryId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAssignmentHistoryByItemArgs = {
  limit?: Scalars['Int']['input'];
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAssignmentsByLocationArgs = {
  siteLocationId: Scalars['String']['input'];
  status?: InputMaybe<CycleCountAssignmentStatus>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAsyncImportJobArgs = {
  asyncImportJobId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAsyncImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAvailabilitySessionArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAvailabilitySessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AvailabilitySessionDocumentSortInput>>;
  where?: InputMaybe<AvailabilitySessionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryAvailableInventoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBackgroundServiceManifestArgs = {
  runsOn: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBlockingRuleArgs = {
  blockingRuleId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBlockingRuleItemLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BlockingRuleItemLocationDocumentSortInput>>;
  where?: InputMaybe<BlockingRuleItemLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfCycleCountMissionTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missionKey: Scalars['String']['input'];
  order?: InputMaybe<Array<BpfMissionTaskDocumentSortInput>>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BpfMissionTaskDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfCycleCountMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfMissionDocumentSortInput>>;
  where?: InputMaybe<BpfMissionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfLotChangeReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotChangeReasonDocumentSortInput>>;
  where?: InputMaybe<BpfLotChangeReasonDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfLotChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotChangeDocumentSortInput>>;
  where?: InputMaybe<BpfLotChangeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfLotCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotCountDocumentSortInput>>;
  where?: InputMaybe<BpfLotCountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfLotCountsByStageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotCountDocumentSortInput>>;
  stage: BpfLotStage;
  where?: InputMaybe<BpfLotCountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryBpfUserStartingNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfUserStartingNodeDocumentSortInput>>;
  where?: InputMaybe<BpfUserStartingNodeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCalculateProductionJobCostsArgs = {
  productionJobIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCalculateRecipeCostArgs = {
  productionRecipeId: Scalars['String']['input'];
  productionRecipeVariationId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CategoryDocumentSortInput>>;
  where?: InputMaybe<CategoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCheckpointArgs = {
  checkpointType: CheckpointType;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCombinedOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CombinedOrderDocumentSortInput>>;
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCommandBarOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommandBarDocumentSortInput>>;
  where?: InputMaybe<CommandBarDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCommissionConfigArgs = {
  userId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCommissionConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommissionConfigDocumentSortInput>>;
  where?: InputMaybe<CommissionConfigDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryConfigCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConfigCategoryDocumentSortInput>>;
  where?: InputMaybe<ConfigCategoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryConfigCategoryArgs = {
  configCategoryId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryConsolidationPreviewArgs = {
  input: ConsolidationPreviewInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryContainerConfigArgs = {
  containerConfigId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryContainerConfigByCategoryContainerSiteArgs = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCountProductionLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLineDocumentSortInput>>;
  where?: InputMaybe<ProductionLineDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCountRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountRegistrationDocumentSortInput>>;
  where?: InputMaybe<CountRegistrationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCountSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountSessionDocumentSortInput>>;
  where?: InputMaybe<CountSessionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCrmExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CrmExportDocumentSortInput>>;
  where?: InputMaybe<CrmExportDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerActivityFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerInvoiceRecipientsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerItemArgs = {
  customerItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerLocationGroupsArgs = {
  groupBy: CustomerLocationGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerLocationPoRequiredInheritedArgs = {
  locationId: Scalars['UUID']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerLocationTermsIdInheritedArgs = {
  locationId: Scalars['UUID']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerLocationsWithBaseRateOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerOrderStatsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalAccountArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalFavoritesListArgs = {
  favoritesListId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalFavoritesListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FavoritesListDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<FavoritesListDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalInventoryAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalItemAvailabilityArgs = {
  order?: InputMaybe<Array<ItemAvailabilityDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<ItemAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalPortalUserByStreamArgs = {
  portalUserId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalSellableHardgoodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalSettingsArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalShoppingCartArgs = {
  cartId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerPortalUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortalUserDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<PortalUserDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TimeEntryDocumentSortInput>>;
  where?: InputMaybe<TimeEntryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerTopSkusArgs = {
  customerId: Scalars['String']['input'];
  top?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerTypeDocumentSortInput>>;
  where?: InputMaybe<CustomerTypeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomersSummaryDocumentSortInput>>;
  where?: InputMaybe<CustomersSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCustomersGridArgs = {
  request: GridRequestInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCycleCountAssignmentArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryCycleCountHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<CycleCountLogDocumentSortInput>>;
  recordedBy?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<CycleCountLogDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryDeletedStreamTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeletedStreamTransactionDocumentSortInput>>;
  where?: InputMaybe<DeletedStreamTransactionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryDeletedStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeletedStreamDocumentSortInput>>;
  where?: InputMaybe<DeletedStreamDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryDeliveryScheduleArgs = {
  deliveryScheduleId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEffectiveCustomerTaxAuthoritiesArgs = {
  customerId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEmailSendsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailSendDocumentSortInput>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  sentAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  sentAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<EmailSendDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEntityCheckpointsArgs = {
  order?: InputMaybe<Array<EntityCheckpointDocumentSortInput>>;
  where?: InputMaybe<EntityCheckpointDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEntityEventsArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ErpAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpFinishAvailabilityArgs = {
  stationCode: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpItemPricesArgs = {
  order?: InputMaybe<Array<ErpItemPricingDocumentSortInput>>;
  where?: InputMaybe<ErpItemPricingDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpItemPricingArgs = {
  erpPriceGroupId: Scalars['String']['input'];
  startYear: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListQuantitiesDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListQuantitiesDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListRouteDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListRouteDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListSessionArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListSessionDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListSessionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListUserArgs = {
  erpLoadListUserId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpLoadListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListUserDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListUserDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpStationRoutesArgs = {
  station: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryErpWriteBackQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpWriteBackDocumentSortInput>>;
  where?: InputMaybe<ErpWriteBackDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEventCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventCountDocumentSortInput>>;
  where?: InputMaybe<EventCountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryEventStreamAggregatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventStreamAggregateDocumentSortInput>>;
  where?: InputMaybe<EventStreamAggregateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryFeatureFlagArgs = {
  name: FeatureFlagName;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryFloatingTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDiscarded?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FloatingTimeEntryDocumentSortInput>>;
  where?: InputMaybe<FloatingTimeEntryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryFloatingTimeEntryArgs = {
  floatingTimeEntryId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryForecastArgs = {
  forecastId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryForecastHolidayArgs = {
  holidayId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryForecastSummaryArgs = {
  forecastId: Scalars['String']['input'];
  scope?: InputMaybe<ForecastSummaryScopeInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryForecastWeeklyDeltaInputsArgs = {
  forecastId: Scalars['String']['input'];
  scope?: InputMaybe<ForecastWeeklyDeltaScopeInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryForecastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ForecastDocumentSortInput>>;
  where?: InputMaybe<ForecastDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryGenerateReportCsvArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryGenerateReportExcelArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryGenerateReportPdfArgs = {
  footerHtml?: InputMaybe<Scalars['String']['input']>;
  headerHtml?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryHardgoodsInventoryGridArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HardgoodsInventoryGridDocumentSortInput>>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<HardgoodsInventoryGridDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryHardgoodsRequiredByReadyWeekArgs = {
  readyWeek?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryIntegrationHealthArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryIntegrationsArgs = {
  order?: InputMaybe<Array<TenantIntegrationDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryInventoryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryTransactionDocumentSortInput>>;
  where?: InputMaybe<InventoryTransactionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemAvailabilityArgs = {
  order?: InputMaybe<Array<ItemAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ItemAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemIdsByErpIdArgs = {
  erpIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemListGroupsArgs = {
  groupBy: ItemGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemLocationAvailabilityArgs = {
  order?: InputMaybe<Array<ItemLocationAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ItemLocationAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemPriceArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemPriceExplanationArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemPriceLevelsArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemPricesArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemProductionMappingsArgs = {
  salesItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemProgramDocumentSortInput>>;
  where?: InputMaybe<ItemProgramDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemRestockMetricsArgs = {
  itemId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemsGridArgs = {
  request: GridRequestInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemsWithBaseRateOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryItemsWithRestockAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ItemWithRestockAvailabilityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobCostBreakdownArgs = {
  costCategory: CostCategory;
  jobId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobCostRecordsArgs = {
  costCategory?: InputMaybe<CostCategory>;
  jobId: Scalars['String']['input'];
  sourceType?: InputMaybe<CostSourceType>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobCostSummaryArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobCostTimelineArgs = {
  jobId: Scalars['String']['input'];
  weeks?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<JobDocumentSortInput>>;
  where?: InputMaybe<JobDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryKitArgs = {
  kitId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryKitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KitDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  where?: InputMaybe<KitDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLaborActiveRatesArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLaborDemandArgs = {
  endDate: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLaborRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeactivated?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LaborRateDocumentSortInput>>;
  where?: InputMaybe<LaborRateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLatestQaTestRunArgs = {
  suite: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLineItemActualQuantitiesArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLineItemActualQuantitiesByLocationGradeArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationArgs = {
  locationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationActiveOverheadRateArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationOverheadRateArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationOverheadRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeactivated?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationOverheadRateDocumentSortInput>>;
  where?: InputMaybe<LocationOverheadRateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationDocumentSortInput>>;
  where?: InputMaybe<LocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLocationsSalesPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationsSalesPersonDocumentSortInput>>;
  where?: InputMaybe<LocationsSalesPersonDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLotCostBreakdownArgs = {
  costCategory: CostCategory;
  lotId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLotCostRecordsArgs = {
  costCategory?: InputMaybe<CostCategory>;
  lotId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLotCostSummaryArgs = {
  lotId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryLotCostTimelineArgs = {
  lotId: Scalars['String']['input'];
  weeks?: Scalars['Int']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryM365MailboxAuthorizeUrlArgs = {
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMakeToOrderPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MakeToOrderPlanDocumentSortInput>>;
  where?: InputMaybe<MakeToOrderPlanDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMasterOrderArgs = {
  masterOrderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMasterOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MasterOrdersDocumentSortInput>>;
  where?: InputMaybe<MasterOrdersDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialAllocationByIdArgs = {
  materialAllocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialAllocationDocumentSortInput>>;
  where?: InputMaybe<MaterialAllocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialDemandArgs = {
  endDate: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialEventGroupsArgs = {
  groupBy: MaterialEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemArgs = {
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemLocationQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemLocationQuantityDocumentSortInput>>;
  where?: InputMaybe<MaterialItemLocationQuantityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemLocationQuantityArgs = {
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemSiteLocationQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentSortInput>>;
  where?: InputMaybe<MaterialItemSiteLocationQuantityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemSiteLocationQuantityArgs = {
  materialItemId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemTotalQuantityArgs = {
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpOrderDocumentSortInput>>;
  where?: InputMaybe<ErpOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialOrdersForLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  order?: InputMaybe<Array<ErpOrderDocumentSortInput>>;
  where?: InputMaybe<ErpOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialReceiptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialReceiptDocumentSortInput>>;
  where?: InputMaybe<MaterialReceiptDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMaterialTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialTransactionDocumentSortInput>>;
  where?: InputMaybe<MaterialTransactionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevAccountDocumentSortInput>>;
  where?: InputMaybe<MergeDevAccountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevConnectionArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevExportDocumentSortInput>>;
  where?: InputMaybe<MergeDevExportDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevImportFailuresArgs = {
  integrationId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevPaymentDocumentSortInput>>;
  where?: InputMaybe<MergeDevPaymentDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevSchemaArgs = {
  integrationId: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevSyncMetricsArgs = {
  integrationId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevSyncStateArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMergeDevTaxRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevTaxRateDocumentSortInput>>;
  where?: InputMaybe<MergeDevTaxRateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMovementOrderArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMovementOrderTransactionsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  order?: InputMaybe<Array<MovementOrderHistoryDocumentSortInput>>;
  where?: InputMaybe<MovementOrderHistoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMyAssignedCountTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MyCountTaskDocumentSortInput>>;
  status?: InputMaybe<CycleCountTaskStatus>;
  where?: InputMaybe<MyCountTaskDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryMyTaskAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskAssignmentDocumentSortInput>>;
  where?: InputMaybe<TaskAssignmentDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOnHandProcessQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandAdjustmentDocumentSortInput>>;
  where?: InputMaybe<OnHandAdjustmentDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderAddressEditPermissionsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AllocationItemDocumentSortInput>>;
  where?: InputMaybe<AllocationItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderDetailsPdfArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderEmailSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderEmailSettingsDocumentSortInput>>;
  where?: InputMaybe<OrderEmailSettingsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderInvoiceEmailDraftArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderLineItemDocumentSortInput>>;
  where?: InputMaybe<OrderLineItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderProductionLotAllocationByIdArgs = {
  allocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderProductionLotAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderProductionLotAllocationDocumentSortInput>>;
  where?: InputMaybe<OrderProductionLotAllocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderVerificationComparisonArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrderfulTransactionsArgs = {
  filter?: InputMaybe<OrderfulTransactionsFilterInput>;
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  prevCursor?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrdersDocumentSortInput>>;
  where?: InputMaybe<OrdersDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrdersGridArgs = {
  request: GridRequestInput;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrdersStatusesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryOrdersTypesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPaymentStatusesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPendingErpWriteBacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpWriteBackDocumentSortInput>>;
  where?: InputMaybe<ErpWriteBackDocumentFilterInput>;
  workflow: ErpWriteBackWorkflow;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPendingTransferOrdersByDestinationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  destinationLocationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PendingTransferOrderDocumentSortInput>>;
  where?: InputMaybe<PendingTransferOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPriceGroupArgs = {
  groupId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPriceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceGroupDocumentSortInput>>;
  where?: InputMaybe<PriceGroupDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPriceLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceLevelDocumentSortInput>>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PriceLevelDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPriceLevelsBlockArgs = {
  levelType?: InputMaybe<PriceLevelType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PriceLevelSortInput>>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TargetType>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionCatalogArgs = {
  productionCatalogId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionCatalogDocumentSortInput>>;
  where?: InputMaybe<ProductionCatalogDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionCategoryDocumentSortInput>>;
  where?: InputMaybe<ProductionCategoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionCategoryArgs = {
  productionCategoryId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionItemDocumentSortInput>>;
  where?: InputMaybe<ProductionItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionJobConsumptionManifestArgs = {
  jobs: Array<ProductionJobConsumptionRequestInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionJobDocumentSortInput>>;
  where?: InputMaybe<ProductionJobDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionLotArgs = {
  productionLotId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionLotAllocationRollupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotAllocationRollupDocumentSortInput>>;
  where?: InputMaybe<ProductionLotAllocationRollupDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionLotAsyncImportJobRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asyncImportJobId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotAsyncImportJobRowSortInput>>;
  where?: InputMaybe<ProductionLotAsyncImportJobRowFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionLotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotDocumentSortInput>>;
  salesItemId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionLotDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionMaterialEventArgs = {
  productionMaterialEventId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionMaterialEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionMaterialEventDetailDocumentSortInput>>;
  productionMaterialEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionMaterialEventDetailDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionMaterialEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionMaterialEventDocumentSortInput>>;
  where?: InputMaybe<ProductionMaterialEventDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionPlanArgs = {
  productionPlanId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionPlanDocumentSortInput>>;
  where?: InputMaybe<ProductionPlanDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipeArgs = {
  productionRecipeId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipeBomArgs = {
  productionRecipeVariationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipeGroupsArgs = {
  groupBy: ProductionRecipeGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipeHistoryArgs = {
  productionRecipeId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipeVariationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionRecipeVariationDocumentSortInput>>;
  where?: InputMaybe<ProductionRecipeVariationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionRecipesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionRecipeDocumentSortInput>>;
  where?: InputMaybe<ProductionRecipeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceCategoryDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceCategoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceCategoryArgs = {
  productionSpaceCategoryId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceEventArgs = {
  productionSpaceEventId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceEventDetailDocumentSortInput>>;
  productionSpaceEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionSpaceEventDetailDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceEventDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceEventDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceTypeArgs = {
  productionSpaceTypeId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionSpaceTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceTypeDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceTypeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionTaskEventArgs = {
  productionTaskEventId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionTaskEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTaskEventDetailDocumentSortInput>>;
  productionTaskEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionTaskEventDetailDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionTaskEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTaskEventDocumentSortInput>>;
  where?: InputMaybe<ProductionTaskEventDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProductionTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTriggerDocumentSortInput>>;
  where?: InputMaybe<ProductionTriggerDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProgramDocumentSortInput>>;
  where?: InputMaybe<ProgramDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProjectionStatusArgs = {
  projectionName: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryProjectionStatusesArgs = {
  order?: InputMaybe<Array<ProjectionStatusDocumentSortInput>>;
  where?: InputMaybe<ProjectionStatusDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPromotionRuleArgs = {
  promotionRuleId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPublicUserInviteByCodeArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPurchaseOrderAllocationByIdArgs = {
  purchaseOrderAllocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryPurchaseOrderAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PurchaseOrderAllocationDocumentSortInput>>;
  where?: InputMaybe<PurchaseOrderAllocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryQaTestRunArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryQaTestRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<QaTestRunSummaryResultSortInput>>;
  where?: InputMaybe<QaTestRunSummaryResultFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReapplyRecipesPreviewArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReplenishmentRuleGroupsArgs = {
  groupBy: ReplenishmentRuleGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReplenishmentRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentSortInput>>;
  where?: InputMaybe<ReplenishmentRuleSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportCustomerOrderHistoryDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minOrderCount?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportCustomersDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportCycleCountHistoryDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportDataSourcesArgs = {
  order?: InputMaybe<Array<ReportDataSourceDocumentSortInput>>;
  where?: InputMaybe<ReportDataSourceDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportDemandVsSupplyDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportExecutionDocumentSortInput>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ReportExecutionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportFoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportFolderDocumentSortInput>>;
  where?: InputMaybe<ReportFolderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportInventoryDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportInventoryTransactionsDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportMaterialItemsDataArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportOrderFulfillmentReadinessDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dueDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  readinessStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportOrderLineItemsDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportOrdersDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportProductionCostsDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportProductionJobsDataArgs = {
  deliveryDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportProductionLotsDataArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportProductionScheduleDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportProductsDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportPullSlipDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderNumber: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportRecipeProfitabilityDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minMarginPercent?: InputMaybe<Scalars['Decimal']['input']>;
  productionCategoryId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportRoyaltyPayoutDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  itemCategory?: InputMaybe<Scalars['String']['input']>;
  payeeName?: InputMaybe<Scalars['String']['input']>;
  shippedFrom: Scalars['DateTime']['input'];
  shippedTo: Scalars['DateTime']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportSalesByCategoryDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: SalesByCategoryGroupBy;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportSalesComparisonDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: SalesComparisonGroupBy;
  metric: SalesComparisonMetric;
  minPeriodATotal?: InputMaybe<Scalars['Decimal']['input']>;
  periodAFrom: Scalars['DateTime']['input'];
  periodATo: Scalars['DateTime']['input'];
  periodBFrom: Scalars['DateTime']['input'];
  periodBTo: Scalars['DateTime']['input'];
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SalesComparisonSort>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportSalesPersonPerformanceDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportSalesVelocityDataArgs = {
  customerCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  minWeeklyRateOfSale?: InputMaybe<Scalars['Decimal']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportScheduleDocumentSortInput>>;
  where?: InputMaybe<ReportScheduleDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportShipToAddressesDataArgs = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportTemplateArgs = {
  templateId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportTemplateDocumentSortInput>>;
  where?: InputMaybe<ReportTemplateDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportVendorPurchaseOrdersDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportVendorSpendDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportVersionsArgs = {
  reportId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportWorkOrdersDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportDocumentSortInput>>;
  where?: InputMaybe<ReportDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryReserveRuleArgs = {
  reserveRuleId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryResolveAvailabilityImportItemsArgs = {
  items: Array<AvailabilityImportItemInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryResolveSkuUpcMappingArgs = {
  atMoment?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryResolvedSpaceCapacityArgs = {
  isoWeek: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  subLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockCustomerLocationDocumentSortInput>>;
  where?: InputMaybe<RestockCustomerLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockDailyDemandArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asOf: Scalars['DateTime']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  weeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockDailyDemandSummaryArgs = {
  asOf: Scalars['DateTime']['input'];
  station?: InputMaybe<Scalars['String']['input']>;
  weeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockDashboardStoreRowsArgs = {
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  scoreDate?: InputMaybe<Scalars['DateTime']['input']>;
  station?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockDashboardStoreRowsBlockArgs = {
  filter?: InputMaybe<RestockDashboardStoreRowFilterInput>;
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  offset: Scalars['Int']['input'];
  scoreDate?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<Array<RestockDashboardStoreRowSortInput>>;
  station?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockMetricsArgs = {
  filter?: InputMaybe<RestockMetricsFilterInput>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockRowExplanationArgs = {
  sessionId: Scalars['String']['input'];
  storeSkuKey: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionCreationExclusionsArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionExportOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionExportOrderDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionExportOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionItemAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionItemAllocationDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionItemAllocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionItemsAvailabilityArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionOrderItemDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionOrderItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionOrderItemsBlockArgs = {
  filter?: InputMaybe<RestockOrderItemFilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  sort?: InputMaybe<Array<RestockOrderItemSortInput>>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionOrderQuantityOverrideHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerLocationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentSortInput>>;
  restockSessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionProgressArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionRowCalcStepsArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionSubmitSummaryArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRestockSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionDocumentSortInput>>;
  where?: InputMaybe<RestockSessionDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRetailAvailableBpLotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailAvailableBpLotDocumentSortInput>>;
  where?: InputMaybe<RetailAvailableBpLotDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRetailProductCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailProductCountDocumentSortInput>>;
  where?: InputMaybe<RetailProductCountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryRfidScansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RfidScanDocumentSortInput>>;
  where?: InputMaybe<RfidScanDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryScavengeLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScavengeLogDocumentSortInput>>;
  where?: InputMaybe<ScavengeLogDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySellableHardgoodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySenderDomainPolicyArgs = {
  domain: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySessionRestockMetricsArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySftpTenantConfigArgs = {
  configId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySftpTenantConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SftpTenantConfigDocumentSortInput>>;
  where?: InputMaybe<SftpTenantConfigDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryShipFromSiteNamesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryShippingAcknowledgmentPdfArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySiteLocationArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySiteLocationAsyncImportJobRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asyncImportJobId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationAsyncImportJobRowSortInput>>;
  where?: InputMaybe<SiteLocationAsyncImportJobRowFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySiteLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationDocumentSortInput>>;
  where?: InputMaybe<SiteLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySiteMapCoverageArgs = {
  forecastId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySiteMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteMapDocumentSortInput>>;
  where?: InputMaybe<SiteMapDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySizeUomArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySizeUomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SizeUomDocumentSortInput>>;
  where?: InputMaybe<SizeUomDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySkuUpcMappingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySpaceCapacityWindowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SpaceCapacityWindowDocumentSortInput>>;
  where?: InputMaybe<SpaceCapacityWindowDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySpaceEventGroupsArgs = {
  groupBy: SpaceEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySpaceUtilizationArgs = {
  isoWeekEnd?: InputMaybe<Scalars['Int']['input']>;
  isoWeekStart?: InputMaybe<Scalars['Int']['input']>;
  isoYear?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySpaceUtilizationPreviewArgs = {
  isoWeekEnd?: InputMaybe<Scalars['Int']['input']>;
  isoWeekStart?: InputMaybe<Scalars['Int']['input']>;
  isoYear?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  moves?: InputMaybe<Array<SpaceMoveInput>>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CategoryDocumentSortInput>>;
  where?: InputMaybe<CategoryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedCategoryArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedCustomerArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomersSummaryDocumentSortInput>>;
  where?: InputMaybe<CustomersSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedHistoricalOrderArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedHistoricalOrderLineItemsArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedHistoricalOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentSortInput>>;
  where?: InputMaybe<HistoricalOrderStagedSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedItemArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedPriceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceGroupDocumentSortInput>>;
  where?: InputMaybe<PriceGroupDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedPriceLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceLevelDocumentSortInput>>;
  where?: InputMaybe<PriceLevelDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedSiteLocationArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedSiteLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationDocumentSortInput>>;
  where?: InputMaybe<SiteLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedSubLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubLocationDocumentSortInput>>;
  where?: InputMaybe<SubLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedTaxAuthoritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaxAuthorityDocumentSortInput>>;
  where?: InputMaybe<TaxAuthorityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedTaxAuthorityArgs = {
  taxAuthorityId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedTermArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStagedTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermsDocumentSortInput>>;
  where?: InputMaybe<TermsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStationBpLotInventoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailAvailableBpLotDocumentSortInput>>;
  stationLocationId: Scalars['String']['input'];
  where?: InputMaybe<RetailAvailableBpLotDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryStreamCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StreamCountDocumentSortInput>>;
  where?: InputMaybe<StreamCountDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySubLocationArgs = {
  locationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySubLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubLocationDocumentSortInput>>;
  where?: InputMaybe<SubLocationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySynchronizationIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IterationDocumentSortInput>>;
  where?: InputMaybe<IterationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySynchronizationOnHandProcessIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandProcessIterationDocumentSortInput>>;
  where?: InputMaybe<OnHandProcessIterationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QuerySynchronizationOnHandQueueingIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandQueueIterationDocumentSortInput>>;
  where?: InputMaybe<OnHandQueueIterationDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaskAssignmentArgs = {
  taskAssignmentId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaskAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskAssignmentDocumentSortInput>>;
  where?: InputMaybe<TaskAssignmentDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaskEventGroupsArgs = {
  groupBy: TaskEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaskEventTypeArgs = {
  taskEventTypeId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaskEventTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskEventTypeDocumentSortInput>>;
  where?: InputMaybe<TaskEventTypeDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaxAuthoritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaxAuthorityDocumentSortInput>>;
  where?: InputMaybe<TaxAuthorityDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTaxAuthorityArgs = {
  taxAuthorityId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantAsyncImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantByCompanySlugArgs = {
  slug: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantByPortalHostArgs = {
  host: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantCustomerPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TenantCustomerPermissionsDocumentSortInput>>;
  where?: InputMaybe<TenantCustomerPermissionsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantEmailSendersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TenantEmailSenderDocumentSortInput>>;
  where?: InputMaybe<TenantEmailSenderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantIntegrationTokenArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTenantIntegrationTokensArgs = {
  order?: InputMaybe<Array<TenantIntegrationTokenDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationTokenDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermsDocumentSortInput>>;
  where?: InputMaybe<TermsDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTermsByIdArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTermsIdsByErpIdArgs = {
  erpIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTrialPolicyArgs = {
  kind: TrialKind;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTrialRequestStatusArgs = {
  requestId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTrialRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TrialRequestDocumentSortInput>>;
  where?: InputMaybe<TrialRequestDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryTrialTenantUsageArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryUserAppSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserAppSettingDocumentSortInput>>;
  where?: InputMaybe<UserAppSettingDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryUserInvitesArgs = {
  includeExpired?: Scalars['Boolean']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryUserTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TimeEntryDocumentSortInput>>;
  where?: InputMaybe<TimeEntryDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserDocumentSortInput>>;
  where?: InputMaybe<UserDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVendorArgs = {
  vendorId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVendorMaterialCostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<VendorMaterialCostDocumentSortInput>>;
  where?: InputMaybe<VendorMaterialCostDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVendorPurchaseOrderByIdArgs = {
  vendorPurchaseOrderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVendorPurchaseOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VendorPurchaseOrderDocumentSortInput>>;
  where?: InputMaybe<VendorPurchaseOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VendorDocumentSortInput>>;
  where?: InputMaybe<VendorDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryVerifyContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VerifyContainerDocumentSortInput>>;
  where?: InputMaybe<VerifyContainerDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryWorkOrderArgs = {
  workOrderId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WorkOrderDocumentSortInput>>;
  where?: InputMaybe<WorkOrderDocumentFilterInput>;
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryWorkerConfigsArgs = {
  serviceName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryWsapiImportArgs = {
  wsapiImportId: Scalars['String']['input'];
};


/**
 * Read side of the QA dashboard: the run index and per-run detail rendered by the wsapi-admin-pwa
 * QA Dashboard page. Cross-tenant operational telemetry about our own test suites — not tenant
 * data — so both operations are SuperAdmin-gated, matching the rest of the admin surface.
 */
export type QueryWsapiImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WsapiImportDocumentSortInput>>;
  where?: InputMaybe<WsapiImportDocumentFilterInput>;
};

export type QueueOnHandAdjustmentInput = {
  externalCustomerId: Scalars['String']['input'];
  externalItemId: Scalars['String']['input'];
  gtin: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  retailerId: Scalars['String']['input'];
  storeNumber: Scalars['String']['input'];
  type: OnHandAdjustmentType;
};

export type ReactivateUserInput = {
  userId: Scalars['String']['input'];
};

export type ReapplyError = {
  __typename?: 'ReapplyError';
  code: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  variationId?: Maybe<Scalars['String']['output']>;
};

export type ReapplyRecipesEventIdChangeInput = {
  eventId: Scalars['String']['input'];
  eventListName: Scalars['String']['input'];
  expectedEventFingerprint?: InputMaybe<Scalars['String']['input']>;
  kind: EventChangeKind;
};

export type ReapplyRecipesInput = {
  jobSelections: Array<ReapplyRecipesJobSelectionInput>;
};

export type ReapplyRecipesJobResult = {
  __typename?: 'ReapplyRecipesJobResult';
  applied: Array<RecipeChangeApplied>;
  currentRecipeVersion: Scalars['Int']['output'];
  failed: Array<RecipeChangeFailed>;
  fullyReconciled: Scalars['Boolean']['output'];
  previewedAtRecipeVersion: Scalars['Int']['output'];
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  skipped: Array<RecipeChangeSkipped>;
};

export type ReapplyRecipesJobSelectionInput = {
  cascadeParentProductionJobId?: InputMaybe<Scalars['String']['input']>;
  fullyReconciled: Scalars['Boolean']['input'];
  previewedAtRecipeVersion: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  removedVariationIds: Array<Scalars['String']['input']>;
  variationSelections: Array<ReapplyRecipesVariationSelectionInput>;
};

export type ReapplyRecipesPayload = {
  __typename?: 'ReapplyRecipesPayload';
  errors: Array<ReapplyError>;
  results: Array<ReapplyRecipesJobResult>;
};

export type ReapplyRecipesPreviewResult = {
  __typename?: 'ReapplyRecipesPreviewResult';
  affectedChildJobs: Array<AffectedChildJob>;
  currentRecipeVersion: Scalars['Int']['output'];
  diff: JobDiffProjection;
  productionJobId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  recipeDeleted: Scalars['Boolean']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
};

export type ReapplyRecipesVariationSelectionInput = {
  assignmentOverrideEventIds: Array<Scalars['String']['input']>;
  eventIdChanges: Array<ReapplyRecipesEventIdChangeInput>;
  regenerateTaskEvents: Scalars['Boolean']['input'];
  scalarFieldNames: Array<Scalars['String']['input']>;
  variationId: Scalars['String']['input'];
};

export type ReassignTaskInput = {
  newAssignedTo?: InputMaybe<Scalars['String']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

export type ReassignWsapiImportIntegrationInput = {
  newIntegrationId: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type RecalculateRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

/**
 * Input record for receiveMovementOrder. ReceivedLines must replay the
 * full Shipped snapshot 1:1; quantities may differ to record real loss/gain.
 */
export type ReceiveMovementOrderInput = {
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  receivedLines: Array<MovementOrderLineInput>;
};

export type ReceiveVendorPurchaseOrderItemInput = {
  id: Scalars['String']['input'];
  isOrganicAtReceive?: InputMaybe<Scalars['Boolean']['input']>;
  organicLotCode?: InputMaybe<Scalars['String']['input']>;
  qualityNotes?: InputMaybe<Scalars['String']['input']>;
  quantityReceived: Scalars['Decimal']['input'];
  receiveToLocationId: Scalars['String']['input'];
  shortageNotes?: InputMaybe<Scalars['String']['input']>;
  varianceReason?: InputMaybe<VendorReceiveVarianceReason>;
  vendorLotNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiveVendorPurchaseOrderItemsInput = {
  items: Array<ReceiveVendorPurchaseOrderItemInput>;
  receivedByUserEmail: Scalars['String']['input'];
  shipmentReceivedDate: Scalars['DateTime']['input'];
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type RecipeChangeApplied = {
  __typename?: 'RecipeChangeApplied';
  changeType: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  expectedEventFingerprint?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  variationId: Scalars['String']['output'];
};

export type RecipeChangeFailed = {
  __typename?: 'RecipeChangeFailed';
  changeType: Scalars['String']['output'];
  code: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  variationId: Scalars['String']['output'];
};

export type RecipeChangeSkipped = {
  __typename?: 'RecipeChangeSkipped';
  changeType: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  variationId: Scalars['String']['output'];
};

/** Computed cost breakdown for a production recipe variation at a specific site location. */
export type RecipeCostSummaryResult = {
  __typename?: 'RecipeCostSummaryResult';
  /** Total additional cost (per pot) from flat-rate cost events (packaging, shipping, etc.). */
  additionalCost: Scalars['Decimal']['output'];
  /** Step-by-step audit trail showing how each cost was calculated. */
  calcSteps: Array<CostCalcStep>;
  /** Reasons why individual cost components could not be resolved. */
  incompleteCostReasons: Array<Scalars['String']['output']>;
  /** True when all cost components could be fully resolved. */
  isComplete: Scalars['Boolean']['output'];
  /** Total labor cost (per pot) resolved via the recipe's labor source mode. */
  laborCost: Scalars['Decimal']['output'];
  /** The labor source mode used for this calculation. */
  laborCostSource: RecipeLaborSource;
  /** Total material cost (per pot) from default vendor pricing across all BOM items. */
  materialsCost: Scalars['Decimal']['output'];
  /** Overall calculation status derived from step severities. */
  overallStatus: CostCalcStepSeverity;
  /** Overhead cost per sq ft for the grow duration. Not included in TotalCost (different unit basis). */
  overheadCost: Scalars['Decimal']['output'];
  /** Sum of materials, labor, and additional costs (per pot). Excludes overhead (per sq ft). */
  totalCost: Scalars['Decimal']['output'];
};

export enum RecipeLaborSource {
  DefaultPerUnit = 'DEFAULT_PER_UNIT',
  Events = 'EVENTS'
}

export type RecipeLaborSourceOperationFilterInput = {
  eq?: InputMaybe<RecipeLaborSource>;
  in?: InputMaybe<Array<RecipeLaborSource>>;
  neq?: InputMaybe<RecipeLaborSource>;
  nin?: InputMaybe<Array<RecipeLaborSource>>;
};

/**
 * Input record for reconcileMovementOrder. Variance resolutions must cover
 * exactly the set of lines whose shipped quantity differs from received.
 */
export type ReconcileMovementOrderInput = {
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  varianceResolutions: Array<VarianceResolutionInput>;
};

/**
 * Input for reconnectMergeLink. The reconnect re-prompts with the same setup step so the user
 * re-confirms explicit choices (NOT a silent auto-preserve). Setup is optional: when omitted
 * the backstop preserves the tenant's current config.
 */
export type ReconnectMergeLinkInput = {
  setup?: InputMaybe<MergeConnectSetupInput>;
};

export type RecordAdjustmentInput = {
  comment: Scalars['String']['input'];
  direction: AvailabilityAdjustmentDirection;
  itemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  reason: AvailabilityAdjustmentReason;
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type RecordCountInput = {
  counts: Array<CountDataInput>;
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type RecordEmailDeliveryInput = {
  bounceClassification?: InputMaybe<Scalars['String']['input']>;
  eventType: EmailDeliveryEventType;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recipient: Scalars['String']['input'];
  sendGridMessageId: Scalars['String']['input'];
  sgEventId?: InputMaybe<Scalars['String']['input']>;
  statusCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RecordEmailSendInput = {
  channel?: InputMaybe<EmailSenderChannel>;
  docType?: InputMaybe<Scalars['String']['input']>;
  emailSendId?: InputMaybe<Scalars['String']['input']>;
  fromEmail: Scalars['String']['input'];
  fromName?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  pdfSizeBytes?: InputMaybe<Scalars['Long']['input']>;
  recipients: Array<RecordEmailSendRecipientDataInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  sendGridMessageId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  source: EmailSendSource;
  subject: Scalars['String']['input'];
};

export type RecordEmailSendRecipientDataInput = {
  email: Scalars['String']['input'];
  kind: EmailRecipientKind;
  sendErrorMessage?: InputMaybe<Scalars['String']['input']>;
  sendStatus?: EmailRecipientSendStatus;
};

/**
 * GraphQL input for recordMaterialReceipt. Primitive/non-Option fields only (HotChocolate
 * input type). Tenant and user are taken from the authenticated principal, never this input.
 */
export type RecordMaterialReceiptInput = {
  binCode: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  lineNo: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  orderType: ErpOrderType;
  quantityReceived: Scalars['Decimal']['input'];
  unit: Scalars['String']['input'];
  vendorLotNumber: Scalars['String']['input'];
};

export type RecordOrderDepositInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type RecordOrderPaymentInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type RecordReportExecutionInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  executionId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  pdfSizeBytes: Scalars['Long']['input'];
  recipientCount: Scalars['Int']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  reportId: Scalars['String']['input'];
  reportName?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
};

export type RecordShrinkEventDataInput = {
  input: RecordShrinkEventInput;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type RecordShrinkEventInput = {
  date: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shrinkEventId: Scalars['String']['input'];
  shrinkType: ShrinkType;
};

/**
 * Boundary input for recordUserLastLogins: a batch of FusionAuth last-login instants for the
 * caller's tenant. Batched (not per-user) because the worker syncs a whole tenant per iteration and a
 * per-user mutation would mean N round-trips. Single-use Data type per the read-model/command
 * type-isolation convention already noted in UsersMutation.cs.
 */
export type RecordUserLastLoginsDataInput = {
  entries: Array<UserLastLoginEntryDataInput>;
};

/**
 * Result of recordUserLastLogins: the number of directory rows whose lastLoginAt was
 * actually moved forward. An entry whose fusionAuthUserId matches no directory row in the
 * caller's tenant, and an entry whose instant does not advance the stored value (the monotonic guard),
 * are both silently excluded from the count — neither is an error. A malformed
 * fusionAuthUserId IS an error and surfaces in errors.
 */
export type RecordUserLastLoginsPayload = {
  __typename?: 'RecordUserLastLoginsPayload';
  errors?: Maybe<Array<ValidationError>>;
  updatedCount: Scalars['Int']['output'];
};

export type RefreshTenantEmailSenderStatusInput = {
  senderId: Scalars['String']['input'];
};

export type RefreshTenantIntegrationTokensInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiration: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiration: Scalars['DateTime']['input'];
};

export type RegisterCountInput = {
  countSessionId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

export type ReleaseAllocationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type RemoveBillingAddressInput = {
  addressId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type RemoveBlockingRuleLinkedItemsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
};

export type RemoveBlockingRuleLinkedLocationsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedLocationIds: Array<Scalars['String']['input']>;
};

export type RemoveCategoryInput = {
  code: Scalars['String']['input'];
};

export type RemoveContactInput = {
  contactId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
};

export type RemoveContainerConfigFromConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
};

export type RemoveImportRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rowIndexes: Array<Scalars['Int']['input']>;
};

export type RemoveItemMinShipQtyInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveItemRoyaltyInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveItemSubstitutionInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveLineItemAllocationsInput = {
  lineItemIds: Array<Scalars['UUID']['input']>;
  orderId: Scalars['String']['input'];
};

export type RemoveLineItemInput = {
  id: Scalars['UUID']['input'];
  lineNumber: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};

export type RemoveLocationInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
};

export type RemoveMasterLineItemInput = {
  id: Scalars['UUID']['input'];
  lineNumber: Scalars['Int']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type RemoveOrderLineUpgradeInput = {
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type RemovePortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

export type RemoveProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type RemoveProductionMaterialEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type RemoveProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variationId: Scalars['String']['input'];
};

export type RemoveProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type RemoveProductionSpaceEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventFromItemInput = {
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemovePromotionRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type RemovePromotionRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type RemovePurchaseOrderLineItemInput = {
  lineItemId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type RemoveReserveRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type RemoveReserveRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type RemoveSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type RemoveSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type RemoveShrinkEventDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  shrinkEventId: Scalars['String']['input'];
};

export type RemoveSizeUomFromConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type RemoveSpaceCapacityWindowInput = {
  endWeek: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  subLocationId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveTenantEmailSenderInput = {
  senderId: Scalars['String']['input'];
};

export type RemoveTimeEntryInput = {
  taskAssignmentId: Scalars['String']['input'];
  timeEntryId: Scalars['String']['input'];
};

export type RemoveVerifyContainerInput = {
  containerId: Scalars['String']['input'];
  removedBy: Scalars['String']['input'];
};

export type RemoveWsapiImportEntityMappingInput = {
  entityMappingId: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type RemovedVariationProjection = {
  __typename?: 'RemovedVariationProjection';
  completedEventCount: Scalars['Int']['output'];
  plannedEventCount: Scalars['Int']['output'];
  variationId: Scalars['String']['output'];
  variationName: Scalars['String']['output'];
};

export type RenameReportFolderInput = {
  folderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum RenderDocType {
  Acknowledgement = 'ACKNOWLEDGEMENT',
  Credit = 'CREDIT',
  Invoice = 'INVOICE'
}

export enum RenderMode {
  Legacy = 'LEGACY',
  Parallel = 'PARALLEL',
  ReportEngine = 'REPORT_ENGINE'
}

export type ReopenProductionJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ReplaceCustomerSalesPeopleInput = {
  customerId: Scalars['String']['input'];
  salesPeopleEmails: Array<Scalars['String']['input']>;
};

export type ReplaceErpLoadListRoutesInput = {
  routeCodes: Array<Scalars['String']['input']>;
};

export type ReplaceSalesPeopleInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  salesPeopleEmails: Array<Scalars['String']['input']>;
};

/**
 * One group header for the Restock Rules sidebar: the group's Key (the canonical
 * GraphQL enum name, also used verbatim as the where eq value when lazy-loading the
 * group's children via replenishmentRules), a display Label, and the
 * server-computed Count of rules in the group under the active search.
 */
export type ReplenishmentRuleGroupBucket = {
  __typename?: 'ReplenishmentRuleGroupBucket';
  /** Number of rules in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /**
   * Canonical (SCREAMING_SNAKE_CASE) group key — the GraphQL enum value the
   * replenishmentRules list where filter expects as its eq argument.
   */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for replenishmentRuleGroups. Mirrors the Restock Rules sidebar's
 * group-by options so the client can render server-computed group headers instead of grouping the
 * full rule set in memory: Status buckets on the rule's lifecycle status, RuleType
 * buckets on the rule's strategy (Blocking / Promotion / Reserve). Both are flat scalar fields on
 * the ReplenishmentRuleSummaryDocument read model that map directly to the
 * replenishmentRules list where filter.
 */
export enum ReplenishmentRuleGroupField {
  /** One bucket per distinct rule strategy (BLOCKING, PROMOTION, RESERVE). */
  RuleType = 'RULE_TYPE',
  /** One bucket per distinct rule lifecycle status (e.g. ACTIVE, INACTIVE). */
  Status = 'STATUS'
}

export type ReplenishmentRuleSummaryDocument = {
  __typename?: 'ReplenishmentRuleSummaryDocument';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  locationCount: Scalars['Int']['output'];
  mode: ReserveRuleMode;
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  quantityFloor: Scalars['Int']['output'];
  ruleId: Scalars['String']['output'];
  ruleType: ReplenishmentRuleSummaryType;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: ReplenishmentRuleSummaryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ReplenishmentRuleSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemCount?: InputMaybe<IntOperationFilterInput>;
  level?: InputMaybe<ReserveRuleLevelOperationFilterInput>;
  linkedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  linkedLocationIds?: InputMaybe<ListStringOperationFilterInput>;
  locationCount?: InputMaybe<IntOperationFilterInput>;
  mode?: InputMaybe<ReserveRuleModeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentFilterInput>>;
  percentage?: InputMaybe<DecimalOperationFilterInput>;
  quantityFloor?: InputMaybe<IntOperationFilterInput>;
  ruleId?: InputMaybe<StringOperationFilterInput>;
  ruleType?: InputMaybe<ReplenishmentRuleSummaryTypeOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ReplenishmentRuleSummaryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ReplenishmentRuleSummaryDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCount?: InputMaybe<SortEnumType>;
  level?: InputMaybe<SortEnumType>;
  locationCount?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  percentage?: InputMaybe<SortEnumType>;
  quantityFloor?: InputMaybe<SortEnumType>;
  ruleId?: InputMaybe<SortEnumType>;
  ruleType?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum ReplenishmentRuleSummaryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ReplenishmentRuleSummaryStatusOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentRuleSummaryStatus>;
  in?: InputMaybe<Array<ReplenishmentRuleSummaryStatus>>;
  neq?: InputMaybe<ReplenishmentRuleSummaryStatus>;
  nin?: InputMaybe<Array<ReplenishmentRuleSummaryStatus>>;
};

export enum ReplenishmentRuleSummaryType {
  Blocking = 'BLOCKING',
  Promotion = 'PROMOTION',
  Reserve = 'RESERVE',
  Unknown = 'UNKNOWN'
}

export type ReplenishmentRuleSummaryTypeOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentRuleSummaryType>;
  in?: InputMaybe<Array<ReplenishmentRuleSummaryType>>;
  neq?: InputMaybe<ReplenishmentRuleSummaryType>;
  nin?: InputMaybe<Array<ReplenishmentRuleSummaryType>>;
};

/** A connection to a list of items. */
export type ReplenishmentRulesConnection = {
  __typename?: 'ReplenishmentRulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReplenishmentRulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReplenishmentRuleSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReplenishmentRulesEdge = {
  __typename?: 'ReplenishmentRulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReplenishmentRuleSummaryDocument;
};

export type ReplenishmentSettingsDocument = {
  __typename?: 'ReplenishmentSettingsDocument';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReplenishmentSettingsDocumentFilterInput = {
  allocationPriorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  allocationReservationPercentage?: InputMaybe<DecimalOperationFilterInput>;
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<ReplenishmentSettingsDocumentFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReplenishmentSettingsDocumentFilterInput>>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReplenishmentSettingsDocumentSortInput = {
  allocationReservationPercentage?: InputMaybe<SortEnumType>;
  allocationType?: InputMaybe<SortEnumType>;
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ReplenishmentSettingsPayload = {
  __typename?: 'ReplenishmentSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ReplenishmentSettingsStateData>;
};

export type ReplenishmentSettingsStateData = {
  __typename?: 'ReplenishmentSettingsStateData';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  programWindowConfigs: Array<ProgramWindowConfigStateData>;
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ReplenishmentUnit {
  Eaches = 'EACHES',
  Trays = 'TRAYS'
}

export type ReplenishmentUnitOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentUnit>;
  in?: InputMaybe<Array<ReplenishmentUnit>>;
  neq?: InputMaybe<ReplenishmentUnit>;
  nin?: InputMaybe<Array<ReplenishmentUnit>>;
};

/** Address data for billing or shipping on report output. */
export type ReportAddressData = {
  __typename?: 'ReportAddressData';
  attention?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  /**
   * Second address line (AddressData.AddressLine2); empty when unused. The legacy address
   * block renders this beneath street.
   */
  street2: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/**
 * Result of a generateReportCsv query. On success, CsvBase64
 * carries the UTF-8 CSV payload base64-encoded; on failure, ErrorMessage
 * carries a diagnostic string.
 */
export type ReportCsvPayload = {
  __typename?: 'ReportCsvPayload';
  /** The base64-encoded UTF-8 CSV content, or null on failure. */
  csvBase64?: Maybe<Scalars['String']['output']>;
  /** An error description if generation failed, or null on success. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether CSV generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Customer summary data for report output. */
export type ReportCustomerData = {
  __typename?: 'ReportCustomerData';
  accountNumber: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** Flattened customer record for report generation. One row per CustomersSummary document. */
export type ReportCustomerDataRow = {
  __typename?: 'ReportCustomerDataRow';
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfContacts: Scalars['Int']['output'];
  numberOfLocations: Scalars['Int']['output'];
  priceGroupName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  synchronizeOrders: Scalars['Boolean']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
};

/** Per-customer order history rollup for report generation. */
export type ReportCustomerOrderHistoryData = {
  __typename?: 'ReportCustomerOrderHistoryData';
  /** Gets the customer account number. */
  accountNumber: Scalars['String']['output'];
  /** Gets the average order value for the customer. */
  avgOrderValue: Scalars['Decimal']['output'];
  /** Gets the customer identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the customer name. */
  customerName: Scalars['String']['output'];
  /** Gets the number of days since the customer's last order. */
  daysSinceLastOrder: Scalars['Int']['output'];
  /** Gets the earliest order date for the customer. */
  firstOrderDate: Scalars['DateTime']['output'];
  /** Gets the latest order date for the customer. */
  lastOrderDate: Scalars['DateTime']['output'];
  /** Gets the number of orders for the customer. */
  orderCount: Scalars['Int']['output'];
  /** Gets the customer price group name. */
  priceGroupName: Scalars['String']['output'];
  /** Gets the total order revenue for the customer. */
  totalRevenue: Scalars['Decimal']['output'];
  /** Gets the total units ordered by the customer. */
  totalUnits: Scalars['Decimal']['output'];
};

/** Payload wrapper for the reportCustomerOrderHistoryData query. */
export type ReportCustomerOrderHistoryDataPayload = {
  __typename?: 'ReportCustomerOrderHistoryDataPayload';
  /** The customer order history rows returned for the current page. */
  data: Array<ReportCustomerOrderHistoryData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of customer rows matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportCustomersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportCustomersDataPayload = {
  __typename?: 'ReportCustomersDataPayload';
  data: Array<ReportCustomerDataRow>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Payload wrapper for the reportCycleCountHistoryData query. */
export type ReportCycleCountHistoryDataPayload = {
  __typename?: 'ReportCycleCountHistoryDataPayload';
  /** The returned cycle count item rows. */
  data: Array<ReportCycleCountHistoryItemData>;
  /** The number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
};

/** Flattened cycle count history record for report generation. */
export type ReportCycleCountHistoryItemData = {
  __typename?: 'ReportCycleCountHistoryItemData';
  /** Gets the UTC timestamp when the count was posted. */
  countedAt: Scalars['DateTime']['output'];
  /** Gets the hard-count quantity recorded for this item. */
  countedQuantity: Scalars['Decimal']['output'];
  /** Gets the cycle count submission identifier. */
  cycleCountId: Scalars['String']['output'];
  /** Gets the counted item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the counted item display name. */
  itemName: Scalars['String']['output'];
  /** Gets the counted location identifier. */
  locationId: Scalars['String']['output'];
  /** Gets the counted location display name. */
  locationName: Scalars['String']['output'];
  /** Gets the counted item SKU. */
  sku: Scalars['String']['output'];
  /** Gets the user id, mapped from the cycle count RecordedBy email. */
  userId: Scalars['String']['output'];
};

export type ReportData = {
  __typename?: 'ReportData';
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  filters: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  handlebarsTemplate: Scalars['String']['output'];
  isStarred: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageSettings: Scalars['String']['output'];
  parameterConfig: Scalars['String']['output'];
  parameterValues: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  status: ReportStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocument = {
  __typename?: 'ReportDataSourceDocument';
  /** Category for grouping data sources */
  category: Scalars['String']['output'];
  /** Description of the data source */
  description: Scalars['String']['output'];
  /** Available fields that can be selected from this data source */
  fields: Array<ReportDataSourceField>;
  /** Unique data source identifier (e.g., "orders") */
  id: Scalars['String']['output'];
  /** Display name of the data source */
  name: Scalars['String']['output'];
  /** Parameters that can be used to filter this data source */
  parameters: Array<ReportDataSourceParameter>;
  /** GraphQL query name to fetch data from this source */
  queryName: Scalars['String']['output'];
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocumentFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceDocumentFilterInput>>;
  /** Category for grouping data sources */
  category?: InputMaybe<StringOperationFilterInput>;
  /** Description of the data source */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Available fields that can be selected from this data source */
  fields?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /** Unique data source identifier (e.g., "orders") */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the data source */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceDocumentFilterInput>>;
  /** Parameters that can be used to filter this data source */
  parameters?: InputMaybe<ListFilterInputTypeOfReportDataSourceParameterFilterInput>;
  /** GraphQL query name to fetch data from this source */
  queryName?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocumentSortInput = {
  /** Category for grouping data sources */
  category?: InputMaybe<SortEnumType>;
  /** Description of the data source */
  description?: InputMaybe<SortEnumType>;
  /** Unique data source identifier (e.g., "orders") */
  id?: InputMaybe<SortEnumType>;
  /** Display name of the data source */
  name?: InputMaybe<SortEnumType>;
  /** GraphQL query name to fetch data from this source */
  queryName?: InputMaybe<SortEnumType>;
};

/** Field definition within a report data source, supporting nested hierarchies. */
export type ReportDataSourceField = {
  __typename?: 'ReportDataSourceField';
  /** Item fields for array types */
  arrayItemFields?: Maybe<Array<ReportDataSourceField>>;
  /** Child fields for object types */
  children?: Maybe<Array<ReportDataSourceField>>;
  /** Optional description of the field */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique field identifier */
  id: Scalars['String']['output'];
  /** Display label for the field */
  label: Scalars['String']['output'];
  /** Dot-notation path to the field in the data */
  path: Scalars['String']['output'];
  /** Data type (string, number, date, enum, object, array) */
  type: Scalars['String']['output'];
};

/** Field definition within a report data source, supporting nested hierarchies. */
export type ReportDataSourceFieldFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceFieldFilterInput>>;
  /** Item fields for array types */
  arrayItemFields?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /** Child fields for object types */
  children?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /** Optional description of the field */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique field identifier */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Display label for the field */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceFieldFilterInput>>;
  /** Dot-notation path to the field in the data */
  path?: InputMaybe<StringOperationFilterInput>;
  /** Data type (string, number, date, enum, object, array) */
  type?: InputMaybe<StringOperationFilterInput>;
};

/** Configuration for LOOKUP-type parameters that render as entity search autocompletes. */
export type ReportDataSourceLookupConfig = {
  __typename?: 'ReportDataSourceLookupConfig';
  /** Fields to display in the dropdown */
  displayFields: Array<Scalars['String']['output']>;
  /** Entity to search (e.g., "customer", "item", "order") */
  entity: Scalars['String']['output'];
  /** Field to use as the selected value */
  valueField: Scalars['String']['output'];
};

/** Configuration for LOOKUP-type parameters that render as entity search autocompletes. */
export type ReportDataSourceLookupConfigFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceLookupConfigFilterInput>>;
  /** Fields to display in the dropdown */
  displayFields?: InputMaybe<ListStringOperationFilterInput>;
  /** Entity to search (e.g., "customer", "item", "order") */
  entity?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceLookupConfigFilterInput>>;
  /** Field to use as the selected value */
  valueField?: InputMaybe<StringOperationFilterInput>;
};

/** Parameter definition for filtering a report data source. */
export type ReportDataSourceParameter = {
  __typename?: 'ReportDataSourceParameter';
  /** Default value if not specified */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Optional description of the parameter */
  description?: Maybe<Scalars['String']['output']>;
  /** Allowed values for enum-type parameters */
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether this parameter is required */
  isRequired: Scalars['Boolean']['output'];
  /** Display label for the parameter */
  label: Scalars['String']['output'];
  /**
   * Element type for LIST-type parameters (e.g. "STRING"); the builder/preview and the
   * bulk-render ribbon read this to render a multi-value input. Null for scalar parameters.
   */
  listType?: Maybe<Scalars['String']['output']>;
  /** Lookup configuration for LOOKUP-type parameters */
  lookupConfig?: Maybe<ReportDataSourceLookupConfig>;
  /** Parameter name used in queries */
  name: Scalars['String']['output'];
  /** Data type (string, number, date, enum, list) */
  type: Scalars['String']['output'];
};

/** Parameter definition for filtering a report data source. */
export type ReportDataSourceParameterFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceParameterFilterInput>>;
  /** Default value if not specified */
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  /** Optional description of the parameter */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Allowed values for enum-type parameters */
  enumValues?: InputMaybe<ListStringOperationFilterInput>;
  /** Whether this parameter is required */
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  /** Display label for the parameter */
  label?: InputMaybe<StringOperationFilterInput>;
  /**
   * Element type for LIST-type parameters (e.g. "STRING"); the builder/preview and the
   * bulk-render ribbon read this to render a multi-value input. Null for scalar parameters.
   */
  listType?: InputMaybe<StringOperationFilterInput>;
  /** Lookup configuration for LOOKUP-type parameters */
  lookupConfig?: InputMaybe<ReportDataSourceLookupConfigFilterInput>;
  /** Parameter name used in queries */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceParameterFilterInput>>;
  /** Data type (string, number, date, enum, list) */
  type?: InputMaybe<StringOperationFilterInput>;
};

/** Flattened demand vs supply record for report generation. One row per item. */
export type ReportDemandVsSupplyData = {
  __typename?: 'ReportDemandVsSupplyData';
  /** The total available inventory quantity for the item. */
  availableQuantity: Scalars['Decimal']['output'];
  /** The total open booked order quantity (Submitted / Acknowledged / Picked, net of shipped quantities) for the item in the selected window. */
  bookedQuantity: Scalars['Decimal']['output'];
  /** The item genus code. */
  genusCode: Scalars['String']['output'];
  /** The item identifier. */
  itemId: Scalars['String']['output'];
  /** The item display name. */
  itemName: Scalars['String']['output'];
  /** The total net supply, calculated from on-hand inventory plus scheduled production. */
  netSupply: Scalars['Decimal']['output'];
  /** The total on-hand inventory quantity for the item. */
  onHandQuantity: Scalars['Decimal']['output'];
  /** The total scheduled production quantity for the item in the selected window. */
  scheduledProductionQuantity: Scalars['Decimal']['output'];
  /** The shortage quantity, calculated as booked demand beyond net supply. */
  shortage: Scalars['Decimal']['output'];
  /** The item SKU. */
  sku: Scalars['String']['output'];
  /** The inclusive lower date-window bound applied to demand and scheduled production. */
  windowFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The inclusive upper date-window bound applied to demand and scheduled production. */
  windowTo?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Payload wrapper for the reportDemandVsSupplyData query. TotalCount is the number of records returned
 * after applying the row limit. TotalMatching is the total number of records matching the filters before limiting.
 */
export type ReportDemandVsSupplyDataPayload = {
  __typename?: 'ReportDemandVsSupplyDataPayload';
  /** The returned demand vs supply rows. */
  data: Array<ReportDemandVsSupplyData>;
  /** The number of rows returned after applying the row limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the row limit. */
  totalMatching: Scalars['Int']['output'];
};

export type ReportDocument = {
  __typename?: 'ReportDocument';
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  filters: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  handlebarsTemplate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isStarred: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageSettings: Scalars['String']['output'];
  parameterConfig: Scalars['String']['output'];
  parameterValues: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  status: ReportStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportDocumentFilterInput = {
  and?: InputMaybe<Array<ReportDocumentFilterInput>>;
  craftJsTemplate?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  dataSourceId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  filters?: InputMaybe<StringOperationFilterInput>;
  folderId?: InputMaybe<StringOperationFilterInput>;
  handlebarsTemplate?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isStarred?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDocumentFilterInput>>;
  pageSettings?: InputMaybe<StringOperationFilterInput>;
  parameterConfig?: InputMaybe<StringOperationFilterInput>;
  parameterValues?: InputMaybe<StringOperationFilterInput>;
  reportId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ReportStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReportDocumentSortInput = {
  craftJsTemplate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  dataSourceId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  filters?: InputMaybe<SortEnumType>;
  folderId?: InputMaybe<SortEnumType>;
  handlebarsTemplate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isStarred?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pageSettings?: InputMaybe<SortEnumType>;
  parameterConfig?: InputMaybe<SortEnumType>;
  parameterValues?: InputMaybe<SortEnumType>;
  reportId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/**
 * Result of a generateReportExcel query. On success, ExcelBase64
 * carries the XLSX workbook bytes base64-encoded; on failure, ErrorMessage
 * carries a diagnostic string.
 */
export type ReportExcelPayload = {
  __typename?: 'ReportExcelPayload';
  /** An error description if generation failed, or null on success. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The base64-encoded XLSX workbook bytes, or null on failure. */
  excelBase64?: Maybe<Scalars['String']['output']>;
  /** Whether Excel generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** GraphQL data transfer object for a report execution record. */
export type ReportExecutionData = {
  __typename?: 'ReportExecutionData';
  errorMessage?: Maybe<Scalars['String']['output']>;
  executedAt: Scalars['DateTime']['output'];
  executedBy: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['String']['output']>;
  pdfSizeBytes: Scalars['Long']['output'];
  recipientCount: Scalars['Int']['output'];
  recipients: Array<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  reportName?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  status: ReportExecutionStatus;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  triggerType: Scalars['String']['output'];
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocument = {
  __typename?: 'ReportExecutionDocument';
  /** Gets the error message if execution failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp when the execution occurred. */
  executedAt: Scalars['DateTime']['output'];
  /** Gets the email of the executor. */
  executedBy: Scalars['String']['output'];
  /** Gets the unique execution identifier. */
  executionId: Scalars['String']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: Maybe<Scalars['String']['output']>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes: Scalars['Long']['output'];
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount: Scalars['Int']['output'];
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier that was executed. */
  reportId: Scalars['String']['output'];
  /** Gets the report name snapshot at execution time. */
  reportName?: Maybe<Scalars['String']['output']>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets the status of the execution record. */
  status: ReportExecutionStatus;
  /** Gets a value indicating whether the execution succeeded. */
  success: Scalars['Boolean']['output'];
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType: Scalars['String']['output'];
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocumentFilterInput = {
  and?: InputMaybe<Array<ReportExecutionDocumentFilterInput>>;
  /** Gets the error message if execution failed. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the execution occurred. */
  executedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the executor. */
  executedBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the unique execution identifier. */
  executionId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportExecutionDocumentFilterInput>>;
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: InputMaybe<StringOperationFilterInput>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes?: InputMaybe<LongOperationFilterInput>;
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets the list of recipient email addresses. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the report identifier that was executed. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the report name snapshot at execution time. */
  reportName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the status of the execution record. */
  status?: InputMaybe<ReportExecutionStatusOperationFilterInput>;
  /** Gets a value indicating whether the execution succeeded. */
  success?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocumentSortInput = {
  /** Gets the error message if execution failed. */
  errorMessage?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the execution occurred. */
  executedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the executor. */
  executedBy?: InputMaybe<SortEnumType>;
  /** Gets the unique execution identifier. */
  executionId?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: InputMaybe<SortEnumType>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes?: InputMaybe<SortEnumType>;
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount?: InputMaybe<SortEnumType>;
  /** Gets the report identifier that was executed. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the report name snapshot at execution time. */
  reportName?: InputMaybe<SortEnumType>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the status of the execution record. */
  status?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the execution succeeded. */
  success?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType?: InputMaybe<SortEnumType>;
};

/** Payload returned from report execution mutations. */
export type ReportExecutionPayload = {
  __typename?: 'ReportExecutionPayload';
  errors?: Maybe<Array<ValidationError>>;
  reportExecution?: Maybe<ReportExecutionData>;
};

export enum ReportExecutionStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type ReportExecutionStatusOperationFilterInput = {
  eq?: InputMaybe<ReportExecutionStatus>;
  in?: InputMaybe<Array<ReportExecutionStatus>>;
  neq?: InputMaybe<ReportExecutionStatus>;
  nin?: InputMaybe<Array<ReportExecutionStatus>>;
};

/** A connection to a list of items. */
export type ReportExecutionsConnection = {
  __typename?: 'ReportExecutionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportExecutionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportExecutionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportExecutionsEdge = {
  __typename?: 'ReportExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportExecutionDocument;
};

export type ReportFolderData = {
  __typename?: 'ReportFolderData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  folderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportFolderDocument = {
  __typename?: 'ReportFolderDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  folderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportFolderDocumentFilterInput = {
  and?: InputMaybe<Array<ReportFolderDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  folderId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFolderDocumentFilterInput>>;
  parentId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReportFolderDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  folderId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ReportFolderPayload = {
  __typename?: 'ReportFolderPayload';
  errors?: Maybe<Array<ValidationError>>;
  folder?: Maybe<ReportFolderData>;
};

/** A connection to a list of items. */
export type ReportFoldersConnection = {
  __typename?: 'ReportFoldersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportFoldersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportFolderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFoldersEdge = {
  __typename?: 'ReportFoldersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportFolderDocument;
};

/**
 * Payload wrapper for the reportInventoryData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportInventoryDataPayload = {
  __typename?: 'ReportInventoryDataPayload';
  data: Array<ReportInventoryItemData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Flattened inventory record for report generation. One row per
 * (location × item × grade) combination — the same key used by
 * InventoryItemDocument.
 */
export type ReportInventoryItemData = {
  __typename?: 'ReportInventoryItemData';
  allocatedQuantity: Scalars['Decimal']['output'];
  availableQuantity: Scalars['Decimal']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  lastTransactionDate: Scalars['DateTime']['output'];
  lastTransactionType: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  onOrderQuantity: Scalars['Decimal']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** Flattened inventory transaction record for report generation. One row per transaction document. */
export type ReportInventoryTransactionData = {
  __typename?: 'ReportInventoryTransactionData';
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  sku: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionType: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportInventoryTransactionsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportInventoryTransactionsDataPayload = {
  __typename?: 'ReportInventoryTransactionsDataPayload';
  data: Array<ReportInventoryTransactionData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Flattened material-item record for report generation. One row per MaterialItemDocument.
 * Status is projected as a string so the same shape renders correctly across GraphQL output and
 * CSV/PDF/Excel exports.
 */
export type ReportMaterialItemData = {
  __typename?: 'ReportMaterialItemData';
  accountingId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  defaultVendorId: Scalars['String']['output'];
  defaultVendorName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Payload wrapper for the reportMaterialItemsData query. TotalCount is the number of records returned
 * (capped at ReportDataSourceConstants.MaxReportRows).
 * TotalMatching is the total number of records matching the filters — when TotalMatching > TotalCount,
 * the client should prompt the user to narrow their filters.
 */
export type ReportMaterialItemsDataPayload = {
  __typename?: 'ReportMaterialItemsDataPayload';
  data: Array<ReportMaterialItemData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Flattened order record for report generation, combining order header, customer,
 * addresses, and line items into a single denormalized shape.
 */
export type ReportOrderData = {
  __typename?: 'ReportOrderData';
  billTo: ReportAddressData;
  customer: ReportCustomerData;
  /**
   * The resolved dollar value actually subtracted from subtotal — sourced ONLY from the
   * kernel-computed OrdersDocument.EffectiveDiscountAmount (flat-beats-percent: a positive
   * flat discount always wins over a percent discount). Reports 0 — never a recompute — for
   * an order whose EffectiveDiscountAmount has not yet been kernel-computed / backfilled,
   * rather than deriving money at read time from fields that may themselves be stale. A projection
   * rebuild or the orders-effective-discount-royalty-backfill-v1.js migration is the repair
   * path for a null value, not a recompute here. (OrdersDocument.DiscountPercent is now a
   * single FRACTION convention for live and imported orders alike — Helm e1860e5d — so the
   * up-to-100x hazard this note used to cite no longer exists.) Never the flat OrdersDocument.DiscountAmount alone — that
   * field ignores a percent discount entirely. Supersedes the deprecated discountAmount
   * alias; both fields stay in sync until the seeded Invoice / Acknowledgement / Packing Slip
   * templates migrate.
   */
  discount: Scalars['Decimal']['output'];
  /**
   * Deprecated alias for discount — carries the same resolved effective-discount
   * value (NOT the flat OrdersDocument.DiscountAmount alone). Kept in sync until seeded
   * Invoice / Acknowledgement / Packing Slip templates migrate their bindings to discount.
   * @deprecated Use `discount` instead. Will be removed once seeded Invoice / Acknowledgement / Packing Slip templates migrate.
   */
  discountAmount: Scalars['Decimal']['output'];
  discountPercent: Scalars['Decimal']['output'];
  dueDate: Scalars['DateTime']['output'];
  /**
   * The order's expected delivery date (OrdersDocument.ExpectedDeliveryDate). This is the
   * date the legacy invoice ("Invoice & Delivery Date"), credit memo ("Pick Up Date"), and
   * acknowledgement ("Ship Date") all print — distinct from orderDate (initialized),
   * shipDate (actual ship), and dueDate (terms-derived).
   */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /**
   * Whether this credit order is a final credit (OrdersDocument.FinalCredit) — the per-order
   * value shown as "Final Credit: Yes/No". Surfaced so a credit-memo template can render that line,
   * but only when finalCreditEnabled (the tenant-level gate below) is on.
   */
  finalCredit: Scalars['Boolean']['output'];
  /**
   * Whether the tenant's final-credit feature is enabled (TenantState.FinalCreditEnabled),
   * resolved once per page from the tenant aggregate. This is the GATE the legacy credit generator
   * used (via IsFinalCreditEnabled) to decide whether to render the per-order
   * finalCredit "Final Credit: Yes/No" row at all; a credit-memo template reproduces the
   * legacy behavior by showing that row only when this is true. Defaults to false
   * when the tenant flag cannot be resolved. Tenant-level, so identical for every row on a page.
   */
  finalCreditEnabled: Scalars['Boolean']['output'];
  /**
   * Freight charge captured on the order header (OrdersDocument.FreightChargeAmount).
   * Defaults to 0m when the order has no freight charge set.
   */
  freight: Scalars['Decimal']['output'];
  /**
   * The order's effective General note, resolved live by the same inheritance chain. Routed
   * onto the general order documents (invoice, acknowledgement). null when no tier
   * supplies one.
   */
  generalNotes?: Maybe<Scalars['String']['output']>;
  itemCount: Scalars['Int']['output'];
  items: Array<ReportOrderItemData>;
  /**
   * Free-form running order history joined into a single string from
   * OrdersDocument.History. This is the legacy generic notes field that predates
   * the typed Ship/Pull/General notes below; it is kept (not dropped) so existing report
   * templates that bind {{notes}} keep rendering. New templates should prefer the
   * routed ShipNotes / PullNotes / GeneralNotes fields.
   */
  notes?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  /**
   * The order type as its enum name (e.g. Credit, Sales), sourced from
   * OrdersDocument.OrderType. Lets an invoice template pick the invoice-vs-credit variant
   * the legacy QuestPDF generator selected via order.Type == OrderType.Credit — a credit
   * memo renders negated quantities/totals and the "Credit Memo" heading instead of "Invoice".
   */
  orderType: Scalars['String']['output'];
  /**
   * The online-payment-portal URL the legacy invoice encodes as its scannable QR code (and also
   * surfaces as the "Pay online" hyperlink). Single-sourced from
   * ConfirmationEmailPdfText.BonnieInfo.PayOnlineLinkUrl — the only in-code definition of the
   * link the QuestPDF invoice used — so an invoice template can render the same payment QR.
   */
  paymentQrPayload: Scalars['String']['output'];
  paymentTerms?: Maybe<Scalars['String']['output']>;
  poNumber: Scalars['String']['output'];
  /**
   * The order's effective Pull note, resolved live by the same inheritance chain. Routed
   * onto the pull sheet / picking ticket. null when no tier supplies one.
   */
  pullNotes?: Maybe<Scalars['String']['output']>;
  /**
   * The order's resolved route (OrdersDocument.EffectiveRoute), resolved by the same
   * 3-tier precedence (direct order override → ship-to location → customer → tenant default)
   * as the live order.effectiveRoute field. null when nothing resolves.
   */
  route?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level royalty rollup computed as the sum of per-line
   * OrderLineItemDocument.Royalty.Amount snapshots. OrdersDocument has no
   * order-level royalty field; rollup is computed in ReportOrdersDataQuery after
   * the line-item join. Defaults to 0m when no lines carry a royalty snapshot.
   */
  royalty: Scalars['Decimal']['output'];
  salesPerson?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The order's effective Ship note, resolved live by the order-note inheritance chain
   * (order override → ship-to customer location → customer) via
   * WorkSuite.GraphQl.Features.Orders.EffectiveOrderNotes. Routed onto shipping
   * documents (packing slip, order acknowledgement). null when no tier supplies one.
   */
  shipNotes?: Maybe<Scalars['String']['output']>;
  shipTo: ReportAddressData;
  /**
   * Alias for freight — the freight charge captured on the order header
   * (OrdersDocument.FreightChargeAmount) — so a template built against the "shipping"
   * terminology binds the same dollar value as one built against "freight".
   */
  shippingAmount: Scalars['Decimal']['output'];
  /**
   * Captured authorized-signature block (base64 image + signer name) when the order carries one,
   * else null. Mirrors the signature the legacy invoice / credit / acknowledgement PDFs
   * render above the footer from OrderStateData.SignatureImage.
   */
  signature?: Maybe<ReportOrderSignatureData>;
  status: Scalars['String']['output'];
  /**
   * The true line-item subtotal — the sum of every line's amount BEFORE freight and discount are
   * applied (OrdersDocument.Subtotal) — distinct from totalAmount, the grand
   * total. Falls back to summing items' lineTotal for an order whose
   * Subtotal has not yet been kernel-computed (see discount).
   */
  subtotal: Scalars['Decimal']['output'];
  /** Total tax dollars captured on the order (OrdersDocument.TotalTax). */
  taxAmount: Scalars['Decimal']['output'];
  /**
   * The blended effective tax rate actually applied, as a PERCENT in 0..100 (6.5 means 6.5%, NOT
   * 0.065) — wsapi's tax-rate convention throughout (see TaxRateEntry.Rate;
   * OrderTaxCalculation divides by 100 to fold a rate into a dollar amount). Computed as
   * OrdersDocument.TotalTax divided by OrdersDocument.TaxableSubtotal, ×100 (0 when
   * no tax base was captured, e.g. tax calculation was never run or the kill switch was off). An
   * order taxed under a single authority resolves to that authority's rate; a multi-authority order
   * resolves to the blended rate across all of them.
   */
  taxRate: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  totalUnits: Scalars['Int']['output'];
};

/** Flattened order fulfillment readiness record for report generation. */
export type ReportOrderFulfillmentReadinessData = {
  __typename?: 'ReportOrderFulfillmentReadinessData';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  earliestUnblockDate?: Maybe<Scalars['DateTime']['output']>;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  linesBlockedInventory: Scalars['Int']['output'];
  linesBlockedProduction: Scalars['Int']['output'];
  linesLate: Scalars['Int']['output'];
  linesReady: Scalars['Int']['output'];
  linesTotal: Scalars['Int']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  readinessPercent: Scalars['Decimal']['output'];
  readinessStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportOrderFulfillmentReadinessData query. TotalCount is the number of
 * records returned (capped at 5000). TotalMatching is the total number of records matching the
 * filters before the page limit is applied. TotalMatchingExact is false when the input
 * materialization hit the cap (TotalMatching is then a lower bound, and the caller should
 * narrow the filter for an exact total).
 */
export type ReportOrderFulfillmentReadinessDataPayload = {
  __typename?: 'ReportOrderFulfillmentReadinessDataPayload';
  data: Array<ReportOrderFulfillmentReadinessData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  totalMatchingExact: Scalars['Boolean']['output'];
};

/** Line item data for a single order line on report output. */
export type ReportOrderItemData = {
  __typename?: 'ReportOrderItemData';
  /**
   * The line's assigned container code (OrderLineItemDocument.ContainerCode), shown in the
   * legacy acknowledgement line table's "Container Code" column. null when unassigned.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  /**
   * The line's eaches (individual-unit) quantity (OrderLineItemDocument.EachesQuantity) —
   * carried separately from quantity (which now prefers this same value) so a
   * template can still distinguish "how many eaches" from a handling-UOM/pick-quantity display if
   * it needs to. 0 when the line carries no eaches count.
   */
  eachesQuantity: Scalars['Int']['output'];
  genus?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  /**
   * The line item's item-group label (OrderLineItemDocument.ItemGroup), shown in the legacy
   * invoice / credit line table's "Item Group" column. null when ungrouped.
   */
  itemGroup?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  lineTotal: Scalars['Decimal']['output'];
  /**
   * The line item's note text (OrderLineItemDocument.Note.NoteText), shown in the legacy
   * acknowledgement line table's "Note" column. null when the line has no note.
   */
  note?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  /**
   * The quantity shown in the "Qty" column, on the same basis lineTotal is priced from:
   * eaches-first, then the handling-UOM/tray-case quantity, then the historical-import ordered
   * quantity — the physical pick quantity (eachesQuantity) when that differs is carried
   * separately. Because unitPrice is the upgrade-inclusive effective price (see its own
   * doc), quantity x unitPrice reconstructs lineTotal on every row, with or
   * without an upgrade.
   */
  quantity: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  /**
   * The effective per-each price, INCLUDING any upgrade ("Value Add") adjustment folded into
   * lineTotal — derived as lineTotal / quantity, NOT the raw catalog
   * OverridePrice ?? Price. An upgrade contributes a dollar term
   * (OrderState.CalculateUpgradeAdjustment) the raw catalog price cannot express, so this
   * derivation is what keeps quantity x unitPrice == lineTotal true on every
   * row rather than only on upgrade-free lines. Carries full (unrounded) decimal precision, like
   * every other money field on this type — no display-rounding is applied, so the footing identity
   * holds exactly rather than drifting by a cent the way a 2dp-rounded value re-multiplied by
   * quantity could. Falls back to the raw catalog price on a zero-quantity line.
   */
  unitPrice: Scalars['Decimal']['output'];
  /**
   * The line item's UPC (OrderLineItemDocument.Upc), shown in the legacy line table's UPC
   * column. Empty when the item has no UPC.
   */
  upc: Scalars['String']['output'];
};

/** Flattened order line item record for report generation. */
export type ReportOrderLineItemData = {
  __typename?: 'ReportOrderLineItemData';
  /** Gets the currency code. */
  currency: Scalars['String']['output'];
  /** Gets the customer identifier from the joined order. */
  customerId: Scalars['String']['output'];
  /** Gets the line number. */
  lineNumber: Scalars['Int']['output'];
  /** Gets the item display name. */
  name: Scalars['String']['output'];
  /** Gets the order identifier from the line item. */
  orderId: Scalars['String']['output'];
  /** Gets the order number from the joined order. */
  orderNumber: Scalars['String']['output'];
  /** Gets the ordered quantity. */
  orderedQuantity: Scalars['Int']['output'];
  /** Gets the override price, when one exists. */
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the base price. */
  price: Scalars['Decimal']['output'];
  /** Gets the effective quantity, falling back to ordered quantity. */
  quantity: Scalars['Int']['output'];
  /** Gets the item SKU. */
  sku: Scalars['String']['output'];
  /** Gets the order status from the joined order. */
  status: Scalars['String']['output'];
};

/** Payload wrapper for the reportOrderLineItemsData query. */
export type ReportOrderLineItemsDataPayload = {
  __typename?: 'ReportOrderLineItemsDataPayload';
  /** The returned order line item rows. */
  data: Array<ReportOrderLineItemData>;
  /** The number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
};

/**
 * Authorized-signature block for report output. Mirrors the base64 image + signer name the legacy
 * QuestPDF invoice / credit / acknowledgement PDFs render above the footer.
 */
export type ReportOrderSignatureData = {
  __typename?: 'ReportOrderSignatureData';
  /** Signer first name printed beneath the signature. */
  firstName: Scalars['String']['output'];
  /** Base64-encoded signature image bytes (no data-URI prefix). */
  imageBase64: Scalars['String']['output'];
  /** Signer last name printed beneath the signature. */
  lastName: Scalars['String']['output'];
  /** MIME type of the signature image (e.g. image/png), for building a data URI. */
  mime: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportOrdersDataPayload = {
  __typename?: 'ReportOrdersDataPayload';
  data: Array<ReportOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

export type ReportPayload = {
  __typename?: 'ReportPayload';
  errors?: Maybe<Array<ValidationError>>;
  report?: Maybe<ReportData>;
};

/** Payload returned from the generateReportPdf query. */
export type ReportPdfPayload = {
  __typename?: 'ReportPdfPayload';
  /** An error description if generation failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The base64-encoded PDF content, or null on failure. */
  pdfBase64?: Maybe<Scalars['String']['output']>;
  /** Whether PDF generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Flattened product record for report generation. One row per ItemSummary document. */
export type ReportProductData = {
  __typename?: 'ReportProductData';
  availableQuantity: Scalars['Int']['output'];
  categories: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  group: Scalars['String']['output'];
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/**
 * Per-recipe / per-lot cost rollup row. Material + labor + overhead = total; cost-per-unit is
 * total divided by actual quantity. One row per ProductionCosts document.
 */
export type ReportProductionCostData = {
  __typename?: 'ReportProductionCostData';
  actualQuantity: Scalars['Int']['output'];
  costPerUnit: Scalars['Decimal']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  laborCost: Scalars['Decimal']['output'];
  locationId: Scalars['String']['output'];
  materialCost: Scalars['Decimal']['output'];
  overheadCost: Scalars['Decimal']['output'];
  plannedQuantity: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  recipeId: Scalars['String']['output'];
  recipeName: Scalars['String']['output'];
  totalCost: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportProductionCostsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionCostsDataPayload = {
  __typename?: 'ReportProductionCostsDataPayload';
  data: Array<ReportProductionCostData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Flattened production job record for report generation. One row per Job document. */
export type ReportProductionJobData = {
  __typename?: 'ReportProductionJobData';
  containerQuantity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  item: ReportProductionJobItemData;
  jobId: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workOrderCount: Scalars['Int']['output'];
};

/** Item data on a production job for report output. */
export type ReportProductionJobItemData = {
  __typename?: 'ReportProductionJobItemData';
  genusCode: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportProductionJobsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionJobsDataPayload = {
  __typename?: 'ReportProductionJobsDataPayload';
  data: Array<ReportProductionJobData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Flattened production lot record for report generation. One row per ProductionLots document. */
export type ReportProductionLotData = {
  __typename?: 'ReportProductionLotData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportProductionLotsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionLotsDataPayload = {
  __typename?: 'ReportProductionLotsDataPayload';
  data: Array<ReportProductionLotData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Flattened production schedule row for report generation. One row per Job document. */
export type ReportProductionScheduleData = {
  __typename?: 'ReportProductionScheduleData';
  containerQuantity: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  weekNumber: Scalars['Int']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  workOrders: Array<ReportProductionScheduleWorkOrderData>;
};

/** Payload wrapper for the reportProductionScheduleData query. */
export type ReportProductionScheduleDataPayload = {
  __typename?: 'ReportProductionScheduleDataPayload';
  data: Array<ReportProductionScheduleData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Work order summary nested under a production schedule row. */
export type ReportProductionScheduleWorkOrderData = {
  __typename?: 'ReportProductionScheduleWorkOrderData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskCount: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportProductsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductsDataPayload = {
  __typename?: 'ReportProductsDataPayload';
  data: Array<ReportProductData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * One alternate location holding the same item as the row's allocation, with current
 * on-hand and available so the picker can pull from a backup bin if the primary is empty.
 * Sub-type name suffix is "Data" per the wsapi GraphQL convention to prevent cross-type
 * reuse breakage (per WorkSuite.GraphQl.Features.Orders.AddLineItemData).
 */
export type ReportPullSlipAlternateLocationData = {
  __typename?: 'ReportPullSlipAlternateLocationData';
  /** Available quantity at the alternate location. Always > 0 (zero-available locations are filtered out). */
  available: Scalars['Decimal']['output'];
  /** Grade present at the alternate location. */
  grade: Scalars['Int']['output'];
  /** Identifier of the alternate location. */
  locationId: Scalars['String']['output'];
  /** Alternate location display name. */
  locationName: Scalars['String']['output'];
  /** On-hand quantity at the alternate location. */
  onHand: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportPullSlipData query. TotalCount is the number of
 * rows returned (capped at ReportDataSourceConstants.MaxReportRows). TotalMatching
 * is the total number of rows matching the orderNumber lookup before any client-side limit; for the
 * single-order resolver these are usually equal unless the caller passes a smaller first.
 */
export type ReportPullSlipDataPayload = {
  __typename?: 'ReportPullSlipDataPayload';
  data: Array<ReportPullSlipDataRow>;
  /** Order-level header for the slip — the order number, PO, dates, status, ship-to address, effective Pull note, and order-number barcode value — carried independently of the line-item rows so the slip header and barcode still render for an order with no allocations (empty Data). Null only when the order itself does not resolve. */
  order?: Maybe<ReportPullSlipOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * One row of the picking ticket — exactly one (order line item × allocated location) pair. A line
 * item that is allocated across N physical locations contributes N rows; an order with 5 line items
 * where line 3 spans 2 locations produces 6 rows total. Order-header fields are denormalized onto
 * every row so the slip can be rendered tabularly without per-row joins on the client.
 */
export type ReportPullSlipDataRow = {
  __typename?: 'ReportPullSlipDataRow';
  /** Grade allocated at this location. */
  allocatedGrade: Scalars['Int']['output'];
  /** Identifier of the location the picker is being directed to for this row. */
  allocatedLocationId: Scalars['String']['output'];
  /** Allocated location display name. */
  allocatedLocationName: Scalars['String']['output'];
  /** Quantity to pull from the allocated location for this line item. */
  allocatedQuantity: Scalars['Int']['output'];
  /** Other locations holding this item with positive available quantity at slip-generation time. Sorted by available quantity descending. The allocated location itself is never present in this list. */
  alternateLocations: Array<ReportPullSlipAlternateLocationData>;
  /** Available (on-hand minus allocated) at the allocated location at the time of slip generation. */
  availableAtAllocated: Scalars['Decimal']['output'];
  /** Customer ERP account number / external identifier. */
  customerAccountNumber: Scalars['String']['output'];
  /** Customer identifier for joining customer-specific reference data. */
  customerId: Scalars['String']['output'];
  /** Customer display name. */
  customerName: Scalars['String']['output'];
  /** Expected delivery date. */
  dueDate: Scalars['DateTime']['output'];
  /** True when the allocated bin is empty at slip-generation time. Lets the UI surface the alternates pane. */
  isAllocatedLocationEmpty: Scalars['Boolean']['output'];
  /** Item identifier used to join inventory for the alternate-location backup pane. */
  itemId: Scalars['String']['output'];
  /** Item display name. */
  itemName: Scalars['String']['output'];
  /** Position of this line on the order (1-based). */
  lineNumber: Scalars['Int']['output'];
  /** The line item's note text (LineItemData.Note.NoteText), shown in the Pull Slip's "Note" column so the picker sees any special handling instructions captured on the line. Null when the line has no note. */
  note?: Maybe<Scalars['String']['output']>;
  /** On-hand quantity at the allocated location at the time of slip generation. Zero when the bin is empty. */
  onHandAtAllocated: Scalars['Decimal']['output'];
  /** Order initialization date. */
  orderDate: Scalars['DateTime']['output'];
  /** Stable identifier of the order this slip row belongs to. */
  orderId: Scalars['String']['output'];
  /** Human-readable order number used by the picker to acknowledge the slip. */
  orderNumber: Scalars['String']['output'];
  /** Quantity ordered on this line item (across all allocated locations combined). */
  orderedQuantity: Scalars['Int']['output'];
  /** Customer purchase order number (optional). */
  poNumber: Scalars['String']['output'];
  /** Effective Pull note for the order, resolved by the same inheritance chain the live order.effectiveNotes field and the ds-orders report path use (order override → ship-to location → customer). Denormalized onto every row so the pull sheet can render it once from any row. Empty when no tier supplies a Pull note. */
  pullNotes: Scalars['String']['output'];
  /** Date the order was shipped, or null if not yet shipped. */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ship-to city. */
  shipToCity: Scalars['String']['output'];
  /** Ship-to recipient name. */
  shipToName: Scalars['String']['output'];
  /** Ship-to state/province. */
  shipToState: Scalars['String']['output'];
  /** Ship-to street address line. */
  shipToStreet: Scalars['String']['output'];
  /** Ship-to postal code. */
  shipToZip: Scalars['String']['output'];
  /** Stock keeping unit. */
  sku: Scalars['String']['output'];
  /** Order status at the time the slip was generated (string-projected enum). */
  status: Scalars['String']['output'];
  /** Universal product code (optional). */
  upc: Scalars['String']['output'];
};

/**
 * Order-level header for the picking ticket, carried once per order rather than denormalized onto
 * each row. The seeded Pull Slip template binds these fields at the record root ({{orderNumber}},
 * {{shipToName}}, {{pullNotes}}, {{barcodeValue}}) so the header and order-number
 * barcode print even when the order has no allocations and the row table is empty. Sub-type name suffix
 * is "Data" per the wsapi GraphQL convention (see ReportPullSlipAlternateLocationData).
 */
export type ReportPullSlipOrderData = {
  __typename?: 'ReportPullSlipOrderData';
  /** Scannable value for the order-number barcode printed on the slip. Currently the order number itself, so the picking crew can scan the ticket back to the order. */
  barcodeValue: Scalars['String']['output'];
  /** Customer ERP account number / external identifier. */
  customerAccountNumber: Scalars['String']['output'];
  /** Customer identifier for joining customer-specific reference data. */
  customerId: Scalars['String']['output'];
  /** Customer display name. */
  customerName: Scalars['String']['output'];
  /** Expected delivery date. */
  dueDate: Scalars['DateTime']['output'];
  /** Order initialization date. */
  orderDate: Scalars['DateTime']['output'];
  /** Stable identifier of the order. */
  orderId: Scalars['String']['output'];
  /** Human-readable order number used by the picker to acknowledge the slip. */
  orderNumber: Scalars['String']['output'];
  /** Customer purchase order number (optional). */
  poNumber: Scalars['String']['output'];
  /** Effective Pull note for the order (order override → ship-to location → customer). Empty when no tier supplies a Pull note. */
  pullNotes: Scalars['String']['output'];
  /** Date the order was shipped, or null if not yet shipped. */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ship-to city. */
  shipToCity: Scalars['String']['output'];
  /** Ship-to recipient name. */
  shipToName: Scalars['String']['output'];
  /** Ship-to state/province. */
  shipToState: Scalars['String']['output'];
  /** Ship-to street address line. */
  shipToStreet: Scalars['String']['output'];
  /** Ship-to postal code. */
  shipToZip: Scalars['String']['output'];
  /** Order status at the time the slip was generated (string-projected enum). */
  status: Scalars['String']['output'];
};

/**
 * Flattened recipe profitability record for report generation. Units sold are sourced
 * from joined production lots, average sell price is sourced from ItemSummary.SellPrice
 * with RetailPrice fallback, and average unit cost is sourced from ProductionItem.LaborCostPerUnit.
 */
export type ReportRecipeProfitabilityData = {
  __typename?: 'ReportRecipeProfitabilityData';
  /** Gets the sell price from ItemSummary.SellPrice, falling back to RetailPrice. */
  avgSellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the unit cost from the linked ProductionItem.LaborCostPerUnit. */
  avgUnitCost?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the linked sales item identifier, when one is available. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** Gets the linked sales item name, when one is available. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** Gets the margin percentage: (avgSellPrice - avgUnitCost) / avgSellPrice * 100. */
  marginPercent: Scalars['Decimal']['output'];
  /** Gets the production catalog identifier. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the production category identifier. */
  productionCategoryId: Scalars['String']['output'];
  /** Gets the production recipe identifier. */
  productionRecipeId: Scalars['String']['output'];
  /** Gets a display name built from the recipe catalog/category fields. */
  recipeName: Scalars['String']['output'];
  /** Gets the linked sales item SKU, when one is available. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Gets the sum of joined production lot quantities for the recipe. */
  unitsSold: Scalars['Int']['output'];
};

/** Payload wrapper for the reportRecipeProfitabilityData query. */
export type ReportRecipeProfitabilityDataPayload = {
  __typename?: 'ReportRecipeProfitabilityDataPayload';
  /** The returned recipe profitability rows. */
  data: Array<ReportRecipeProfitabilityData>;
  /** The number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
};

/** Per-item-category breakdown of royalty totals within a payee. */
export type ReportRoyaltyPayoutDataCategoryBreakdown = {
  __typename?: 'ReportRoyaltyPayoutDataCategoryBreakdown';
  category: Scalars['String']['output'];
  lineCount: Scalars['Int']['output'];
  totalRoyalty: Scalars['Decimal']['output'];
};

/** Per-customer breakdown of royalty totals within a payee. */
export type ReportRoyaltyPayoutDataCustomerBreakdown = {
  __typename?: 'ReportRoyaltyPayoutDataCustomerBreakdown';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  lineCount: Scalars['Int']['output'];
  totalRoyalty: Scalars['Decimal']['output'];
};

/**
 * Aggregated royalty totals for a single payee, with sub-breakdowns by customer
 * and item category.
 */
export type ReportRoyaltyPayoutDataPayee = {
  __typename?: 'ReportRoyaltyPayoutDataPayee';
  /** Per-customer breakdown within this payee, sorted by customer name ascending. */
  byCustomer: Array<ReportRoyaltyPayoutDataCustomerBreakdown>;
  /** Per-category breakdown within this payee, sorted by category ascending. Lines whose item has no SortCategory are grouped under an empty-string key. */
  byItemCategory: Array<ReportRoyaltyPayoutDataCategoryBreakdown>;
  /** Number of lines tied to this payee. */
  lineCount: Scalars['Int']['output'];
  /** The royalty payee, taken from the frozen line snapshot. */
  payeeName: Scalars['String']['output'];
  /** Sum of pre-discount line subtotals tied to this payee. */
  totalLineSubtotal: Scalars['Decimal']['output'];
  /** Sum of royalty amounts owed to this payee. */
  totalRoyalty: Scalars['Decimal']['output'];
};

/**
 * Top-level payload for the reportRoyaltyPayoutData query. Aggregates frozen
 * per-line royalty snapshots over a shippedAt date range, grouped by payee,
 * with optional sub-breakdowns by customer and item category.
 */
export type ReportRoyaltyPayoutDataPayload = {
  __typename?: 'ReportRoyaltyPayoutDataPayload';
  /** One aggregated row per payee, sorted by payee name ascending. */
  byPayee: Array<ReportRoyaltyPayoutDataPayee>;
  /** Number of distinct payees in the result. */
  distinctPayeeCount: Scalars['Int']['output'];
  /** Number of matched royalty-bearing lines in the report. */
  lineCount: Scalars['Int']['output'];
  /** Sum of EachesQuantity * (HandlingUom ?? 1) * (OverridePrice ?? Price) across every matched line — the pre-discount line revenue the royalty was earned against, matching the Phase 1 royalty basis. */
  totalLineSubtotal: Scalars['Decimal']['output'];
  /** Total number of matched source lines before the runaway-query cap was applied. */
  totalMatching: Scalars['Int']['output'];
  /** Sum of LineItemRoyalty.Amount across every matched line. */
  totalRoyalty: Scalars['Decimal']['output'];
  /** True when the runaway-query cap excluded rows. When true, finance must narrow the date range to get an accurate total. */
  truncatedByLimit: Scalars['Boolean']['output'];
};

/**
 * Per-group sales-by-category rollup row. Director-level KPI shape: revenue + units rolled up
 * by Category / Customer / Region across a date range.
 */
export type ReportSalesByCategoryData = {
  __typename?: 'ReportSalesByCategoryData';
  /** TotalRevenue / OrderCount. Zero when OrderCount is zero. */
  avgOrderValue: Scalars['Decimal']['output'];
  /** Echoed groupBy parameter (e.g. 'Category', 'Customer', 'Region') so the row is self-describing. */
  groupBy: Scalars['String']['output'];
  /** Raw key of the group (e.g. category code, customer id, or region code). */
  groupKey: Scalars['String']['output'];
  /** Display label for the group (e.g. category name, customer name, or region label). */
  groupLabel: Scalars['String']['output'];
  /** Distinct order count contributing to the group. */
  orderCount: Scalars['Int']['output'];
  /** Sum of (quantity * unit-price) for all line items in the group. */
  totalRevenue: Scalars['Decimal']['output'];
  /** Sum of line-item quantity across the group. */
  totalUnits: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportSalesByCategoryData query.
 * TotalCount is the number of rows returned (capped at 5000).
 * TotalMatching is the total number of groups matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow filters.
 */
export type ReportSalesByCategoryDataPayload = {
  __typename?: 'ReportSalesByCategoryDataPayload';
  data: Array<ReportSalesByCategoryData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Per-group period-vs-period sales comparison row. PercentChange is null when
 * PeriodATotal is zero (avoids divide-by-zero; null is more informative than
 * Infinity / NaN / a sentinel).
 */
export type ReportSalesComparisonData = {
  __typename?: 'ReportSalesComparisonData';
  /** PeriodBTotal minus PeriodATotal (negative = decline, positive = growth). */
  delta: Scalars['Decimal']['output'];
  /** Echoed groupBy parameter (e.g. 'Customer', 'Item'). */
  groupBy: Scalars['String']['output'];
  /** Raw key of the group (e.g. customer id, item id, customer-type code). */
  groupKey: Scalars['String']['output'];
  /** Display label for the group (e.g. customer name, item name). */
  groupLabel: Scalars['String']['output'];
  /** Echoed metric parameter ('Dollars' or 'Units') so the row is self-describing. */
  metric: Scalars['String']['output'];
  /** Distinct order count contributing to Period A. */
  orderCountA: Scalars['Int']['output'];
  /** Distinct order count contributing to Period B. */
  orderCountB: Scalars['Int']['output'];
  /** (Delta / PeriodATotal) * 100. Null when PeriodATotal is 0. */
  percentChange?: Maybe<Scalars['Decimal']['output']>;
  /** Echoed Period A start (inclusive). */
  periodAFrom: Scalars['DateTime']['output'];
  /** Echoed Period A end (inclusive). */
  periodATo: Scalars['DateTime']['output'];
  /** Aggregate metric value over Period A. */
  periodATotal: Scalars['Decimal']['output'];
  /** Echoed Period B start (inclusive). */
  periodBFrom: Scalars['DateTime']['output'];
  /** Echoed Period B end (inclusive). */
  periodBTo: Scalars['DateTime']['output'];
  /** Aggregate metric value over Period B. */
  periodBTotal: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportSalesComparisonData query.
 * TotalCount is the number of records returned (capped at 5000).
 * TotalMatching is the total number of groups matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow filters.
 */
export type ReportSalesComparisonDataPayload = {
  __typename?: 'ReportSalesComparisonDataPayload';
  data: Array<ReportSalesComparisonData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Aggregated sales performance record for report generation. One row per sales person. */
export type ReportSalesPersonPerformanceData = {
  __typename?: 'ReportSalesPersonPerformanceData';
  avgOrderValue: Scalars['Decimal']['output'];
  firstOrderDate: Scalars['DateTime']['output'];
  lastOrderDate: Scalars['DateTime']['output'];
  orderCount: Scalars['Int']['output'];
  salesPerson: Scalars['String']['output'];
  totalRevenue: Scalars['Decimal']['output'];
  totalUnits: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportSalesPersonPerformanceData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportSalesPersonPerformanceDataPayload = {
  __typename?: 'ReportSalesPersonPerformanceDataPayload';
  data: Array<ReportSalesPersonPerformanceData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Flattened sales velocity record for report generation. One row per BaseRateOfSale document. */
export type ReportSalesVelocityData = {
  __typename?: 'ReportSalesVelocityData';
  /** Timestamp when the base rate of sale was calculated. */
  calculatedAt: Scalars['DateTime']['output'];
  /** Customer code associated with the base rate of sale. */
  customerCode: Scalars['String']['output'];
  /** Item code associated with the base rate of sale. */
  itemCode: Scalars['String']['output'];
  /** Location code associated with the base rate of sale. */
  locationCode: Scalars['String']['output'];
  /** Program associated with the base rate of sale. */
  program: Scalars['String']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window. */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  /** Units sold across trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  /** Rolling weekly rate of sale used by DBR replenishment. */
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportSalesVelocityData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters.
 */
export type ReportSalesVelocityDataPayload = {
  __typename?: 'ReportSalesVelocityDataPayload';
  data: Array<ReportSalesVelocityData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** GraphQL data transfer record for a report schedule. */
export type ReportScheduleData = {
  __typename?: 'ReportScheduleData';
  /** Gets the timestamp when the schedule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who created the schedule. */
  createdBy: Scalars['String']['output'];
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression: Scalars['String']['output'];
  /** Gets the optional order-email doc-type carried opaquely for the executor to stamp on the email audit. */
  docType?: Maybe<OrderEmailDocType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the authorable Handlebars email subject (tokens + inline {{#if}}), or null when
   * not authored. Rendered at send time; supports invoice-vs-credit branching on
   * orderType for order-context reuse.
   */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule expires. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets a value indicating whether this schedule is active. */
  isActive: Scalars['Boolean']['output'];
  /** Gets the last completed run time. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the schedule name. */
  name: Scalars['String']['output'];
  /** Gets the next scheduled run time. */
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the optional order id carried opaquely for the executor to stamp on the email audit. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the optional order number carried opaquely for the executor to stamp on the email audit. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat: Scalars['String']['output'];
  /** Gets the JSON blob of report parameters. */
  parameters?: Maybe<Scalars['String']['output']>;
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier this schedule is linked to. */
  reportId: Scalars['String']['output'];
  /** Gets the optional report template identifier. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this is a one-shot (runOnce) schedule. When true the schedule
   * fires once at NextRunAt and is deactivated by the executor; the cron expression
   * is optional.
   */
  runOnce: Scalars['Boolean']['output'];
  /** Gets the unique schedule identifier. */
  scheduleId: Scalars['String']['output'];
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the current status of the schedule. */
  status: ReportScheduleStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId: Scalars['String']['output'];
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last updated the schedule. */
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocument = {
  __typename?: 'ReportScheduleDocument';
  /** Gets the timestamp when the schedule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who created the schedule. */
  createdBy: Scalars['String']['output'];
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression: Scalars['String']['output'];
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: Maybe<OrderEmailDocType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule expires. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets a value indicating whether this schedule is active. */
  isActive: Scalars['Boolean']['output'];
  /** Gets the last completed run time. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the schedule name. */
  name: Scalars['String']['output'];
  /** Gets the next scheduled run time. */
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat: Scalars['String']['output'];
  /** Gets the JSON blob of report parameters. */
  parameters?: Maybe<Scalars['String']['output']>;
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier this schedule is linked to. */
  reportId: Scalars['String']['output'];
  /** Gets the optional report template identifier. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce: Scalars['Boolean']['output'];
  /** Gets the unique schedule identifier. */
  scheduleId: Scalars['String']['output'];
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the current status of the schedule. */
  status: ReportScheduleStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId: Scalars['String']['output'];
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last updated the schedule. */
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocumentFilterInput = {
  and?: InputMaybe<Array<ReportScheduleDocumentFilterInput>>;
  /** Gets the timestamp when the schedule was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who created the schedule. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: InputMaybe<NullableOfOrderEmailDocTypeOperationFilterInput>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<StringOperationFilterInput>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date when the schedule expires. */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this schedule is active. */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the last completed run time. */
  lastRunAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the schedule name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Gets the next scheduled run time. */
  nextRunAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ReportScheduleDocumentFilterInput>>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat?: InputMaybe<StringOperationFilterInput>;
  /** Gets the JSON blob of report parameters. */
  parameters?: InputMaybe<StringOperationFilterInput>;
  /** Gets the list of recipient email addresses. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the report identifier this schedule is linked to. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional report template identifier. */
  reportTemplateId?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the unique schedule identifier. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the current status of the schedule. */
  status?: InputMaybe<ReportScheduleStatusOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who last updated the schedule. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocumentSortInput = {
  /** Gets the timestamp when the schedule was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who created the schedule. */
  createdBy?: InputMaybe<SortEnumType>;
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression?: InputMaybe<SortEnumType>;
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<SortEnumType>;
  /** Gets the date when the schedule expires. */
  endDate?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this schedule is active. */
  isActive?: InputMaybe<SortEnumType>;
  /** Gets the last completed run time. */
  lastRunAt?: InputMaybe<SortEnumType>;
  /** Gets the schedule name. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the next scheduled run time. */
  nextRunAt?: InputMaybe<SortEnumType>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat?: InputMaybe<SortEnumType>;
  /** Gets the JSON blob of report parameters. */
  parameters?: InputMaybe<SortEnumType>;
  /** Gets the report identifier this schedule is linked to. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the optional report template identifier. */
  reportTemplateId?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce?: InputMaybe<SortEnumType>;
  /** Gets the unique schedule identifier. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: InputMaybe<SortEnumType>;
  /** Gets the current status of the schedule. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who last updated the schedule. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Payload returned from report schedule mutations. */
export type ReportSchedulePayload = {
  __typename?: 'ReportSchedulePayload';
  errors?: Maybe<Array<ValidationError>>;
  reportSchedule?: Maybe<ReportScheduleData>;
};

export enum ReportScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportScheduleStatusOperationFilterInput = {
  eq?: InputMaybe<ReportScheduleStatus>;
  in?: InputMaybe<Array<ReportScheduleStatus>>;
  neq?: InputMaybe<ReportScheduleStatus>;
  nin?: InputMaybe<Array<ReportScheduleStatus>>;
};

/** A connection to a list of items. */
export type ReportSchedulesConnection = {
  __typename?: 'ReportSchedulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportSchedulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportScheduleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportSchedulesEdge = {
  __typename?: 'ReportSchedulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportScheduleDocument;
};

/**
 * One mailable ship-to location for report generation. The grain is the customer LOCATION, not
 * the customer: a customer with four locations contributes four rows, because a mailing list is
 * a list of addresses. The customer domain has no primary/default location, so there is no
 * non-arbitrary way to collapse these to one row per customer.
 */
export type ReportShipToAddressData = {
  __typename?: 'ReportShipToAddressData';
  /** Gets the customer account number. */
  accountNumber: Scalars['String']['output'];
  /** Gets the first address line. */
  addressLine1: Scalars['String']['output'];
  /** Gets the second address line. */
  addressLine2: Scalars['String']['output'];
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the ship-to location code. */
  code: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the customer identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the customer name. */
  customerName: Scalars['String']['output'];
  /** Gets the ship-to location identifier. */
  locationId: Scalars['String']['output'];
  /** Gets the ship-to location name. */
  locationName: Scalars['String']['output'];
  /** Gets the market recorded on the ship-to location. */
  market: Scalars['String']['output'];
  /** Gets the region recorded on the ship-to location. */
  region: Scalars['String']['output'];
  /**
   * Gets the effective route ("run") for this ship-to: the location's own route, falling back to
   * the customer-level route and then the tenant default. Mirrors
   * MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Gets the effective salesperson email addresses for this ship-to's customer: the per-location
   * projection's list, falling back to the customer-level list. Empty when the tenant has not
   * assigned salespeople (assignment requires an active user holding a Sales role).
   */
  salesPersonEmails: Array<Scalars['String']['output']>;
  /** Gets the state or province. */
  state: Scalars['String']['output'];
  /** Gets the store number recorded on the ship-to location. */
  storeNumber: Scalars['String']['output'];
  /** Gets the addressee recorded on the ship-to address. */
  toName: Scalars['String']['output'];
  /** Gets the postal code. */
  zipcode: Scalars['String']['output'];
};

/** Payload wrapper for the reportShipToAddressesData query. */
export type ReportShipToAddressesDataPayload = {
  __typename?: 'ReportShipToAddressesDataPayload';
  /** The ship-to address rows returned for the current page. */
  data: Array<ReportShipToAddressData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of ship-to locations matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
};

export enum ReportStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportStatusOperationFilterInput = {
  eq?: InputMaybe<ReportStatus>;
  in?: InputMaybe<Array<ReportStatus>>;
  neq?: InputMaybe<ReportStatus>;
  nin?: InputMaybe<Array<ReportStatus>>;
};

/** GraphQL data transfer record for a report template. */
export type ReportTemplateData = {
  __typename?: 'ReportTemplateData';
  category: Scalars['String']['output'];
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  handlebarsTemplate: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters: Scalars['String']['output'];
  status: ReportTemplateStatus;
  tags: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocument = {
  __typename?: 'ReportTemplateDocument';
  category: Scalars['String']['output'];
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  handlebarsTemplate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters: Scalars['String']['output'];
  status: ReportTemplateStatus;
  tags: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocumentFilterInput = {
  and?: InputMaybe<Array<ReportTemplateDocumentFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  craftJsTemplate?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  dataSourceId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  handlebarsTemplate?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportTemplateDocumentFilterInput>>;
  parameters?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ReportTemplateStatusOperationFilterInput>;
  tags?: InputMaybe<StringOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocumentSortInput = {
  category?: InputMaybe<SortEnumType>;
  craftJsTemplate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  dataSourceId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  handlebarsTemplate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parameters?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tags?: InputMaybe<SortEnumType>;
  templateId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Payload returned from report template mutations. */
export type ReportTemplatePayload = {
  __typename?: 'ReportTemplatePayload';
  errors?: Maybe<Array<ValidationError>>;
  reportTemplate?: Maybe<ReportTemplateData>;
};

export enum ReportTemplateStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportTemplateStatusOperationFilterInput = {
  eq?: InputMaybe<ReportTemplateStatus>;
  in?: InputMaybe<Array<ReportTemplateStatus>>;
  neq?: InputMaybe<ReportTemplateStatus>;
  nin?: InputMaybe<Array<ReportTemplateStatus>>;
};

/** A connection to a list of items. */
export type ReportTemplatesConnection = {
  __typename?: 'ReportTemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportTemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportTemplateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTemplatesEdge = {
  __typename?: 'ReportTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportTemplateDocument;
};

/**
 * Flattened vendor purchase order record for report generation. One row per
 * VendorPurchaseOrderDocument. Status is rendered as the enum
 * name (e.g. "Confirmed") so PDF/CSV/XLSX exports show human-readable values.
 */
export type ReportVendorPurchaseOrderData = {
  __typename?: 'ReportVendorPurchaseOrderData';
  isUrgent: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  orderDate: Scalars['DateTime']['output'];
  poId: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalLineItems: Scalars['Int']['output'];
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportVendorPurchaseOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportVendorPurchaseOrdersDataPayload = {
  __typename?: 'ReportVendorPurchaseOrdersDataPayload';
  data: Array<ReportVendorPurchaseOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Per-vendor spend rollup for strategic sourcing reports. One row per distinct vendor
 * (keyed by VendorPurchaseOrderDocument.ErpId).
 *
 * Field coverage caveat: The current VendorPurchaseOrderDocument projection does
 * not carry per-line-item unit cost, expected delivery date, or per-PO receipt-completed date.
 * Until the projection is enriched (tracked as a follow-up task), the financial and SLA fields
 * — totalSpend, avgPoSize, onTimeReceiptCount, lateReceiptCount,
 * onTimePercent, and avgLeadTimeDays — are returned as null so the PWA
 * Report Builder can distinguish "data not yet available" from a legitimate zero. The schema
 * surface is stable; downstream rollouts will turn the nulls into live values once the
 * projection lands the source fields.
 */
export type ReportVendorSpendData = {
  __typename?: 'ReportVendorSpendData';
  /**
   * Average lead time in days between order placed and receipt completed. null
   * until the projection carries PO-level received-completed date.
   */
  avgLeadTimeDays?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Average PO value (= TotalSpend / PoCount). null until
   * TotalSpend is populated by the projection enrichment task.
   */
  avgPoSize?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Number of POs received after their expected delivery date. null until the
   * projection carries expected delivery date and PO-level receipt-completed date.
   */
  lateReceiptCount?: Maybe<Scalars['Int']['output']>;
  /**
   * On-time receipt percentage in the 0–100 range. null until
   * OnTimeReceiptCount and LateReceiptCount are populated.
   */
  onTimePercent?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Number of POs received on or before their expected delivery date. null until the
   * projection carries expected delivery date and PO-level receipt-completed date.
   */
  onTimeReceiptCount?: Maybe<Scalars['Int']['output']>;
  /** Number of purchase orders for the vendor in the filtered window. */
  poCount: Scalars['Int']['output'];
  /** Total line items across all rolled-up POs for the vendor. */
  totalLineItems: Scalars['Int']['output'];
  /**
   * Sum of vendor-side spend across the rolled-up POs. null until the projection
   * enrichment task lands per-line-item unit cost; a real zero (e.g., all POs cancelled
   * before invoicing) and "not yet available" must be distinguishable for the PWA Report
   * Builder.
   */
  totalSpend?: Maybe<Scalars['Decimal']['output']>;
  /** Vendor ERP identifier (matches VendorPurchaseOrderDocument.ErpId). */
  vendorId: Scalars['String']['output'];
  /** Vendor display name as denormalised on the most recent PO for the vendor. */
  vendorName: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportVendorSpendData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of vendor rollup rows matching the filters —
 * when TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportVendorSpendDataPayload = {
  __typename?: 'ReportVendorSpendDataPayload';
  data: Array<ReportVendorSpendData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * A single version of a report, derived on-demand from the report's KurrentDB event stream. Each
 * record corresponds to one full-snapshot event (creation or update) stored for the report, and
 * carries the complete snapshot so the UI can preview or diff a version without a second call.
 */
export type ReportVersionRecord = {
  __typename?: 'ReportVersionRecord';
  /** The Craft.js layout template at this version. */
  craftJsTemplate: Scalars['String']['output'];
  /** The data source bound to the report at this version. */
  dataSourceId: Scalars['String']['output'];
  /** The report description at this version. */
  description: Scalars['String']['output'];
  /** The unique event identifier from the event store. */
  eventId: Scalars['String']['output'];
  /** The domain event type name (e.g. "V1.ReportUpdated"). */
  eventType: Scalars['String']['output'];
  /** The saved filters (JSON) at this version. */
  filters: Scalars['String']['output'];
  /** The folder the report lived in at this version, if any. */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The compiled Handlebars template at this version. */
  handlebarsTemplate: Scalars['String']['output'];
  /** Whether the report was starred at this version. */
  isStarred: Scalars['Boolean']['output'];
  /** The report name at this version. */
  name: Scalars['String']['output'];
  /** The page settings (JSON) at this version. */
  pageSettings: Scalars['String']['output'];
  /** The parameter configuration (JSON) at this version. */
  parameterConfig: Scalars['String']['output'];
  /** The saved parameter values (JSON) at this version. */
  parameterValues: Scalars['String']['output'];
  /** When this version was recorded. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user (email) that authored this version. */
  updatedBy: Scalars['String']['output'];
  /** The event-stream revision that identifies this version; pass it to revertReport. */
  version: Scalars['Long']['output'];
};

/** Flattened work order record for report generation. One row per WorkOrder document. */
export type ReportWorkOrderData = {
  __typename?: 'ReportWorkOrderData';
  activityCode: Scalars['String']['output'];
  containerQuantity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity: Scalars['Int']['output'];
  productionPhaseCode: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workOrderId: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportWorkOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportWorkOrdersDataPayload = {
  __typename?: 'ReportWorkOrdersDataPayload';
  data: Array<ReportWorkOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportDocument;
};

export type RequestAllocationInput = {
  allocationId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  requiredQty: Scalars['Decimal']['input'];
  targetLocationId: Scalars['String']['input'];
};

export type RequestRestockCalculationInput = {
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  /** @deprecated Never consumed; ignored by the server. Will be removed with the DEL2 client cutover. */
  merge?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
};

/**
 * Optional scope for the dashboard refresh. Both lists null/empty triggers a tenant-wide
 * recalc. When both are populated the filter is the intersection (item AND location must
 * match) — matching what a dashboard user would expect after filtering by both axes.
 */
export type RequestRestockDashboardRecalcInput = {
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RequestTenantEmailSenderVerificationInput = {
  senderId: Scalars['String']['input'];
};

/** Anonymous input to request an email-verification code. */
export type RequestTrialSignupVerificationInput = {
  email: Scalars['String']['input'];
};

/**
 * Uniform response to requestTrialSignupVerification. sent is true
 * whenever a code was issued; it never reveals whether the address is already associated with a
 * tenant.
 */
export type RequestTrialSignupVerificationPayload = {
  __typename?: 'RequestTrialSignupVerificationPayload';
  errors?: Maybe<Array<ValidationError>>;
  sent: Scalars['Boolean']['output'];
};

export type ResendUserInviteInput = {
  inviteId: Scalars['String']['input'];
};

export enum ReserveRuleLevel {
  Category = 'CATEGORY',
  Item = 'ITEM',
  ProductGroup = 'PRODUCT_GROUP',
  Program = 'PROGRAM',
  SubCategory = 'SUB_CATEGORY',
  Unknown = 'UNKNOWN'
}

export type ReserveRuleLevelOperationFilterInput = {
  eq?: InputMaybe<ReserveRuleLevel>;
  in?: InputMaybe<Array<ReserveRuleLevel>>;
  neq?: InputMaybe<ReserveRuleLevel>;
  nin?: InputMaybe<Array<ReserveRuleLevel>>;
};

export enum ReserveRuleMode {
  Allocate = 'ALLOCATE',
  Reserve = 'RESERVE',
  Unknown = 'UNKNOWN'
}

export type ReserveRuleModeOperationFilterInput = {
  eq?: InputMaybe<ReserveRuleMode>;
  in?: InputMaybe<Array<ReserveRuleMode>>;
  neq?: InputMaybe<ReserveRuleMode>;
  nin?: InputMaybe<Array<ReserveRuleMode>>;
};

export type ReserveRulePayload = {
  __typename?: 'ReserveRulePayload';
  errors?: Maybe<Array<ValidationError>>;
  reserveRule?: Maybe<ReserveRuleStateData>;
};

export type ReserveRuleStateData = {
  __typename?: 'ReserveRuleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  reserveRuleId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: ReserveRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ReserveRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ResetAcknowledgmentEmailInput = {
  endInitializationDate?: InputMaybe<Scalars['DateTime']['input']>;
  startInitializationDate: Scalars['DateTime']['input'];
};

export type ResetConfirmationEmailInput = {
  endInitializationDate?: InputMaybe<Scalars['DateTime']['input']>;
  startInitializationDate: Scalars['DateTime']['input'];
};

export type ResetSyncStatusInput = {
  orderIds: Array<Scalars['String']['input']>;
};

/**
 * Boundary input for resetUserLogin: the directory user whose FusionAuth login is being
 * reset, plus the replacement invite's expiry and FusionAuth application registrations — the SAME
 * two knobs createUserInvite carries, so the recovery invite is shaped exactly like an
 * ordinary tenant invite. There is deliberately NO recipient email: it is read from the target
 * directory row, so a reset can never redirect a user's login to a different address, and no
 * linkedUserId beyond the target, so a reset can never fork the row. Single-use boundary
 * input per the command/read-model type-isolation convention; named without a Data suffix
 * so HotChocolate emits ResetUserLoginInput, matching the sibling CreateUserInviteInput
 * the PWA already codegens against.
 */
export type ResetUserLoginInput = {
  expiresInDays: Scalars['Int']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
  userId: Scalars['String']['input'];
};

export type ResetWorkOrderQuantityProducedInput = {
  jobId: Scalars['String']['input'];
  workOrderId: Scalars['String']['input'];
};

export type ResetWorkerConfigRunNowInput = {
  configName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type ResetWsapiImportRunNowInput = {
  wsapiImportId: Scalars['String']['input'];
};

/** Superadmin input to resolve a pending trial request. */
export type ResolveTrialRequestInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  resolution: TrialRequestResolution;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ResolvedEventData = {
  __typename?: 'ResolvedEventData';
  event: EventRecordData;
  isResolved: Scalars['Boolean']['output'];
  link?: Maybe<EventRecordData>;
  originalEventNumber: Scalars['Long']['output'];
  originalPosition?: Maybe<PositionData>;
  originalStreamId: Scalars['String']['output'];
};

/** The resolved price group and which tier of the Location → Customer → Default hierarchy supplied it. */
export type ResolvedPriceGroup = {
  __typename?: 'ResolvedPriceGroup';
  name: Scalars['String']['output'];
  priceGroupId: Scalars['String']['output'];
  source: PriceGroupSource;
};

export type ResolvedSpaceCapacity = {
  __typename?: 'ResolvedSpaceCapacity';
  amount: Scalars['Decimal']['output'];
  reliefFraction: Scalars['Decimal']['output'];
  source: SpaceCapacitySource;
};

/**
 * Component breakdown of RestockDashboardStoreRowData.AllocationReason.
 * Surfaced alongside the resolved reason so the PWA breakdown dialog can show *why* a
 * store landed where it did (which tier, which threshold, how stale the last delivery,
 * what the decayed sales signal looked like) without recomputing on the client.
 * Sibling of RestockIndexBreakdownData for the legacy S27 score —
 * intentionally separate so the two grids can show both during the parity cutover.
 */
export type RestockAllocationBreakdownData = {
  __typename?: 'RestockAllocationBreakdownData';
  /**
   * Trailing decayed sales sum — Layer 1 of the spec. Same value carried on the row's
   * RestockDashboardStoreRowData.DecayedScore; included here so the
   * dialog displays a self-contained snapshot. Null when no underlying
   * DailyTransactionSummaries rows exist for the store, matching
   * RestockDashboardStoreRowData.DecayedScore semantics.
   */
  decayedScore?: Maybe<Scalars['Decimal']['output']>;
  /** Half-life used for the decay calculation (currently fixed by configuration; surfaced for audit). */
  halfLifeDays: Scalars['Int']['output'];
  /** Most recent delivery date observed in the lookup window. Null when none. */
  lastDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Lookback window applied to DecayedScore (currently fixed by configuration; surfaced for audit). */
  lookbackDays: Scalars['Int']['output'];
  /** The resolved classification — duplicated from the row for dialog self-containment. */
  reason: RestockAllocationReason;
  /**
   * Tier-derived weeks-since-ship cutoff. A store at or above this for its tier is
   * forced into RestockAllocationReason.Mandatory.
   */
  thresholdWeeks: Scalars['Int']['output'];
  /**
   * Resolved store tier (StoreClass) used for the threshold lookup. Always a
   * non-empty string — a null/blank StoreClass on the underlying row is
   * normalized to "Unranked" before the breakdown is built.
   */
  tier: Scalars['String']['output'];
  /**
   * Floor-division weeks since this store's most recent delivery in the lookup window.
   * Null when no delivery is on record in the window (treated as
   * RestockAllocationReason.Excluded regardless of tier).
   */
  weeksSinceShip?: Maybe<Scalars['Int']['output']>;
};

/**
 * Classification produced by Layer 2 of the new Restock dashboard allocation formula.
 * Drives whether a store ships this replenishment cycle, competes for remaining capacity,
 * or is bumped to area-manager review.
 */
export enum RestockAllocationReason {
  /**
   * Store competes for remaining ship slots based on its decayedScore.
   * weeksSinceShip < tier threshold. Default classification for active stores.
   */
  Eligible = 'ELIGIBLE',
  /**
   * Store has not received a delivery within inactivityWeeks (default 16 weeks),
   * or has no delivery in the lookup window at all. Bumped to the inactive-review list
   * instead of auto-shipping.
   */
  Excluded = 'EXCLUDED',
  /**
   * Store ships this cycle regardless of score because it has gone too long without a
   * delivery for its tier. tier threshold ≤ weeksSinceShip < inactivityWeeks.
   */
  Mandatory = 'MANDATORY'
}

export type RestockAvailabilityByItemIdSummary = {
  __typename?: 'RestockAvailabilityByItemIdSummary';
  itemId: Scalars['String']['output'];
  mustGoQty: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
};

export type RestockAvailabilityByItemIdSummaryFilterInput = {
  and?: InputMaybe<Array<RestockAvailabilityByItemIdSummaryFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  mustGoQty?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<RestockAvailabilityByItemIdSummaryFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type RestockAvailabilityByItemIdSummarySortInput = {
  itemId?: InputMaybe<SortEnumType>;
  mustGoQty?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * Client-facing batch lifecycle phase emitted on the onRestockSessionBatchProgress
 * subscription. Carries phase signals for two server flows behind a single contract:
 *
 *
 *     The chunked session-creation worker (StartRestockSessionCreation +
 *     RestockSessionCreationWorkflowWorker) — emits Populating,
 *     Calculating, Persisting.
 *
 *
 *     The BYOA-v1 default-WOS session creation + on-demand-miss flow — emits
 *     EnqueuingMisses, WaitingOnRCDQ, WaitingOnRCAQ,
 *     HydratingGrid. The phase emit wiring lands in C2; C1 only locks the contract.
 *
 *
 * Idle is the terminal state for both flows so the PWA can reset its progress UI.
 * New values are appended only — additive per Atlas standard bde8323d82064d928e44bebcff552a2e.
 */
export enum RestockBatchPhase {
  /**
   * A Restock calculation is running, either as the second phase of chunked session creation
   * or as a standalone client-triggered calculation.
   */
  Calculating = 'CALCULATING',
  /**
   * BYOA-v1 flow: wsapi is enqueuing missing
   * (tenant, customer, item, location, wos) tuples into RestockCalcOnDemandWork
   * for the wsapi-services calc fleet to drain. First in-flight phase of session
   * creation when default-WOS hits do not cover every selected row.
   */
  EnqueuingMisses = 'ENQUEUING_MISSES',
  /**
   * BYOA-v1 flow: wsapi is reading RestockCalcResults and writing session
   * order-item rows. Terminal in-flight phase before Idle for the BYOA-v1
   * session-creation path.
   */
  HydratingGrid = 'HYDRATING_GRID',
  /**
   * Terminal state; emitted on workflow completion or failure so the PWA can reset any
   * in-flight progress UI. On failure the payload's Error field carries the
   * failure message.
   */
  Idle = 'IDLE',
  /**
   * Chunked-creation worker: writing calculated rows back to MongoDB — the terminal in-flight
   * phase of the StartRestockSessionCreation workflow.
   */
  Persisting = 'PERSISTING',
  /**
   * Chunked-creation worker: hydrating order-item rows from master data — the first phase
   * of the StartRestockSessionCreation workflow.
   */
  Populating = 'POPULATING',
  /**
   * BYOA-v1 flow: waiting for the wsapi-services RestockCalcAchievableQuantity
   * worker to react to the demand writes and write achievable columns to
   * RestockCalcResults.
   */
  WaitingOnRcaq = 'WAITING_ON_RCAQ',
  /**
   * BYOA-v1 flow: waiting for the wsapi-services RestockCalcDemandQuantity
   * worker to drain enqueued tuples and write demand columns to RestockCalcResults.
   */
  WaitingOnRcdq = 'WAITING_ON_RCDQ'
}

export type RestockBatchSummary = {
  __typename?: 'RestockBatchSummary';
  blockedCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type RestockCalcStep = {
  __typename?: 'RestockCalcStep';
  code: Scalars['String']['output'];
  context: Array<RestockCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: RestockCalcStepSeverity;
};

/** Mongo-side representation of a single context entry on RestockCalcStepDocument. */
export type RestockCalcStepContextDocument = {
  __typename?: 'RestockCalcStepContextDocument';
  /** Context key (e.g. "reservePercent"). */
  key: Scalars['String']['output'];
  /** Stringified context value. */
  value: Scalars['String']['output'];
};

export type RestockCalcStepContextEntry = {
  __typename?: 'RestockCalcStepContextEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RestockCalcStepContextEntryFilterInput = {
  and?: InputMaybe<Array<RestockCalcStepContextEntryFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCalcStepContextEntryFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Mongo-side representation of a single Restock calculation step. Owned by the Document layer
 * so the read model can evolve independently of domain commands and event records.
 */
export type RestockCalcStepDocument = {
  __typename?: 'RestockCalcStepDocument';
  /** Stable machine-readable identifier for the step (e.g. "RESERVE_APPLIED"). */
  code: Scalars['String']['output'];
  /** Key/value pairs carrying inputs and outputs that contributed to this step. */
  context: Array<RestockCalcStepContextDocument>;
  /** Human-readable description of what the step computed or why it was applied. */
  message: Scalars['String']['output'];
  /** Severity tier; see RestockCalcStepSeverity for canonical values. */
  severity: Scalars['String']['output'];
};

export type RestockCalcStepFilterInput = {
  and?: InputMaybe<Array<RestockCalcStepFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  context?: InputMaybe<ListFilterInputTypeOfRestockCalcStepContextEntryFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCalcStepFilterInput>>;
  severity?: InputMaybe<RestockCalcStepSeverityOperationFilterInput>;
};

export enum RestockCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type RestockCalcStepSeverityOperationFilterInput = {
  eq?: InputMaybe<RestockCalcStepSeverity>;
  in?: InputMaybe<Array<RestockCalcStepSeverity>>;
  neq?: InputMaybe<RestockCalcStepSeverity>;
  nin?: InputMaybe<Array<RestockCalcStepSeverity>>;
};

export type RestockCalculationData = {
  __typename?: 'RestockCalculationData';
  batchSummary?: Maybe<RestockBatchSummary>;
  results?: Maybe<Array<RestockCalculationResult>>;
  totalCount: Scalars['Int']['output'];
};

export type RestockCalculationInput = {
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type RestockCalculationPayload = {
  __typename?: 'RestockCalculationPayload';
  errors?: Maybe<Array<ValidationError>>;
  restockCalculation?: Maybe<RestockCalculationData>;
};

export type RestockCalculationResult = {
  __typename?: 'RestockCalculationResult';
  /**
   * Per-store allocation from the MIP solver driven by tenant-level allocation defaults
   * (reservation %, allocation type, ordered priorities). 0 when no ERP availability exists
   * for the item at the session's station, when no session is provided (ad-hoc calcs), or
   * when the solver cannot produce a feasible solution for the item.
   */
  achievableQuantity: Scalars['Int']['output'];
  /** Final order quantity after greenhouse supply constraints and pro-rata distribution. */
  adjustedOrderQuantity: Scalars['Int']['output'];
  /** Percentage of post-reserve inventory pre-committed by the matched allocate rule (0 if no rule). */
  allocatePercent: Scalars['Decimal']['output'];
  /** Greenhouse units available to ship after reserve and allocate deductions. */
  availableToShip: Scalars['Int']['output'];
  /** Ordered breakdown of each calculation step for this row, used for debugging and UI traces. */
  calcSteps: Array<RestockCalcStep>;
  /** Timestamp when the calculation was produced. */
  calculatedAt: Scalars['DateTime']['output'];
  /** The delivery date used for the calculation (lead time applied to the request date). */
  deliveryDate: Scalars['DateTime']['output'];
  /** Total greenhouse inventory for this item; null when no availability data exists. */
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  /** Identifier of the item this row belongs to. */
  itemId: Scalars['String']['output'];
  /** Identifier of the customer location this row belongs to. */
  locationId: Scalars['String']['output'];
  /** Order quantity prior to greenhouse supply constraints (post-rounding). */
  orderQuantity: Scalars['Int']['output'];
  /** Overall status of the calculation for this row (e.g. success or an error state). */
  overallStatus: CalculationStatus;
  /** Projected on-hand units at the delivery date after current-horizon sell-down. */
  predictedOnHand: Scalars['Int']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  /** Units needed to bring PredictedOnHand up to TargetOnHand. */
  replenishmentTarget: Scalars['Int']['output'];
  /** Percentage of greenhouse inventory withheld by the matched reserve rule (0 if no rule). */
  reservePercent: Scalars['Decimal']['output'];
  /** Units withheld from greenhouse inventory by the reserve rule. */
  reserveQuantity: Scalars['Int']['output'];
  /** Expected units sold between now and the delivery date (demand during lead time). */
  sellDownUnits: Scalars['Decimal']['output'];
  /** Target inventory position (WeeklyRateOfSale × tenant target weeks of supply). */
  targetOnHand: Scalars['Int']['output'];
  /** Dollar value of trailing sales: unit price × RawTrailingUnitsSold. Price is resolved from ERP or Mongo pricing based on the tenant's UseErpPricing flag, as of CalculatedAt, at quantity 1. */
  trailingSales: Scalars['Decimal']['output'];
  /** Current on-hand inventory units at the location for this item at the time of calculation. */
  unitsOnHand: Scalars['Int']['output'];
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  /** Seven-day average sales rate for this (item, location) used to project demand. */
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

export enum RestockCalculationStatus {
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS'
}

export type RestockCalculationStatusOperationFilterInput = {
  eq?: InputMaybe<RestockCalculationStatus>;
  in?: InputMaybe<Array<RestockCalculationStatus>>;
  neq?: InputMaybe<RestockCalculationStatus>;
  nin?: InputMaybe<Array<RestockCalculationStatus>>;
};

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocument = {
  __typename?: 'RestockCustomerLocationDocument';
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  region: Scalars['String']['output'];
  settings?: Maybe<RestockCustomerLocationSettingsDocument>;
  stateProvince: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocumentFilterInput = {
  and?: InputMaybe<Array<RestockCustomerLocationDocumentFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCustomerLocationDocumentFilterInput>>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<RestockCustomerLocationSettingsDocumentFilterInput>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocumentSortInput = {
  city?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<RestockCustomerLocationSettingsDocumentSortInput>;
  stateProvince?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocument = {
  __typename?: 'RestockCustomerLocationSettingsDocument';
  deliveryScheduleId: Scalars['String']['output'];
  deliveryScheduleName: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
  retailerName: Scalars['String']['output'];
  route: Scalars['String']['output'];
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<RestockCustomerLocationSettingsDocumentFilterInput>>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via
   * RestockCustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<StringOperationFilterInput>;
  noteCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RestockCustomerLocationSettingsDocumentFilterInput>>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  zone?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocumentSortInput = {
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via
   * RestockCustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<SortEnumType>;
  noteCount?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  zone?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockCustomerLocationsConnection = {
  __typename?: 'RestockCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockCustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockCustomerLocationsEdge = {
  __typename?: 'RestockCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockCustomerLocationDocument;
};

/** A connection to a list of items. */
export type RestockDailyDemandConnection = {
  __typename?: 'RestockDailyDemandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockDailyDemandEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockDailyDemandEdge = {
  __typename?: 'RestockDailyDemandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/**
 * Aggregate KPIs over the tenant's RestockWorkQueueResultDocument rows for a
 * given asOf / weeksOfSupply slice. Backs the Restock Demand Dashboard's
 * top-of-page KPI tiles (Total Demand, Total Achievable) — the row grid uses SSRM cursor
 * paging, so the tiles cannot be summed client-side without a full-table scan.
 */
export type RestockDailyDemandSummaryData = {
  __typename?: 'RestockDailyDemandSummaryData';
  /**
   * Most recent RestockWorkQueueResultDocument.CalcDate across the tenant —
   * independent of asOf so the dashboard can self-correct when the user's
   * asOf=now falls before today's calc has run. null when the tenant has no
   * calc results at all.
   */
  latestCalcDate?: Maybe<Scalars['DateTime']['output']>;
  rowCount: Scalars['Int']['output'];
  /**
   * Sum of RestockWorkQueueResultDocument.AchievableQuantity across the slice,
   * substituting 0 for any row whose allocation result is still null. Matches the
   * per-row orderQuantity fallback contract in RestockDailyDemandRowResolvers.
   */
  totalAchievable: Scalars['Int']['output'];
  /**
   * Sum of ErpAvailability.Quantity — the pre-allocation supply number from the ERP
   * master. Computed server-side because ItemSummaryDocument.AvailableQuantity is empty
   * for ERP-driven tenants, so the dashboard cannot reduce client-side. Tenant-wide by default;
   * when a station is supplied it narrows to ErpAvailability.StationCode == station
   * (the availability axis — distinct from the demand tile's ErpId scoping). The slice's
   * asOf / weeksOfSupply do not narrow this tile.
   */
  totalAvailable: Scalars['Decimal']['output'];
  totalDemand: Scalars['Decimal']['output'];
};

/** Result of requestRestockDashboardRecalc. */
export type RestockDashboardRecalcPayload = {
  __typename?: 'RestockDashboardRecalcPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

/**
 * Set-membership filter on RestockAllocationReason. The row matches when its
 * allocation reason equals any element of In. Empty or null means no filter on
 * this field. Mirrors the AG Grid set-filter shape so the PWA SSRM-v2 grid can pass through
 * multi-select choices without an extra mapping layer.
 */
export type RestockDashboardStoreRowAllocationReasonFilterInput = {
  in?: InputMaybe<Array<RestockAllocationReason>>;
};

/**
 * One row in the Restock Demand Dashboard's per-store aggregate. Each row collapses
 * every item-level RestockWorkQueueResultDocument for a single
 * (CustomerCode, LocationCode) into the metrics the
 * dashboard needs: TotalDemand summed across items, ItemCount
 * counted across rows, and LastCalculatedAt set to the most recent calc
 * timestamp in scope. RestockIndex ranks the store 0–100 using Nathan's
 * S27 formula (demand × 0.6 cap 50 + 25 − WoS × 4 cap 25 + velocity × 0.25 cap 15 +
 * storeClass A:10/B:5/C:0, total cap 100); RestockIndexBreakdown exposes
 * each component for the UI breakdown dialog.
 */
export type RestockDashboardStoreRowData = {
  __typename?: 'RestockDashboardStoreRowData';
  /**
   * Per-component breakdown of AllocationReason. Surfaces tier, threshold,
   * weeks-since-ship, last-delivery date, decayed score, and the resolved reason for the PWA
   * breakdown dialog. Null when no underlying DailyTransactionSummaries rows exist
   * for the store (matching DecayedScore being null).
   */
  allocationBreakdown?: Maybe<RestockAllocationBreakdownData>;
  /**
   * Layer 2 of the new allocation formula — whether the store is forced to ship this cycle
   * (MANDATORY), competes on score (ELIGIBLE), or is bumped to inactive
   * review (EXCLUDED). Defaults to RestockAllocationReason.Eligible
   * when the row has no underlying transactions yet.
   */
  allocationReason: RestockAllocationReason;
  /** Customer code shared by every result row in this aggregate bucket. */
  customerCode: Scalars['String']['output'];
  /**
   * Resolved CustomersSummaryDocument.CustomerId for the
   * (CustomerCode, LocationCode) pair. Null when no matching
   * customer is projected yet (orphan aggregate) — caller should treat the row as display-only.
   */
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved RestockCustomerLocationDocument.LocationId for this store. Null when the
   * customer is found but its restock-location read model has not yet been projected. The
   * dashboard treats null here as "Start Session unavailable for this row."
   */
  customerLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Layer 1 of the new allocation formula — recency-weighted sum of UnitsSold over the
   * configured lookback window (default 56 days). Each day's units contribute
   * units × exp(-ln(2) × daysAgo / halfLife). Null only when no
   * DailyTransactionSummaries rows exist for the store in the window (treated as zero
   * signal upstream by the allocation rules).
   */
  decayedScore?: Maybe<Scalars['Decimal']['output']>;
  /** Count of RestockWorkQueueResultDocument rows folded into this aggregate. */
  itemCount: Scalars['Int']['output'];
  /**
   * Maximum RestockWorkQueueResultDocument.CalcDate across the grouped rows;
   * null when every in-scope row is a stub.
   */
  lastCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent delivery (UnitsShipped > 0) date observed in the lookup window. Null when none. */
  lastDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Location code shared by every result row in this aggregate bucket. */
  locationCode: Scalars['String']['output'];
  /**
   * Per-store priority score, 0–100, computed at aggregate-query time. Nullable for the
   * edge case where the underlying InputsSnapshot rows pre-date the writer-side
   * keys (WeeklyRos, UnitsOnHand) — once every store has at least one
   * post-S27 calc row, this is non-null in steady state.
   */
  restockIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * Per-component breakdown of RestockIndex. Null when RestockIndex
   * is null. Surfaced so the PWA breakdown dialog can show which component is driving the
   * score without recomputing on the client.
   */
  restockIndexBreakdown?: Maybe<RestockIndexBreakdownData>;
  /**
   * Sum of UnitsSold over the trailing
   * RestockDashboardAllocationOptions.SalesVelocityWindowDays (default 28 days).
   * Null when no sales rows exist for the store in the window.
   */
  sales4Wk?: Maybe<Scalars['Int']['output']>;
  /**
   * Store class from RestockCustomerLocationDocument.Settings.StoreClass. Null when the
   * restock-location read model (or its settings sub-document) is not yet projected.
   */
  storeClass?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved chain-store name from CustomersSummaryDocument.Name
   * (e.g. "TRACTOR SUPPLY CO. #2205"). Null when no matching customer is projected.
   */
  storeName?: Maybe<Scalars['String']['output']>;
  /**
   * Chain-store-suffix store number from RestockCustomerLocationDocument.StoreNumber
   * (e.g. "2205"). Null when the restock-location read model is not yet projected.
   */
  storeNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Tier-derived weeks-since-ship cutoff resolved from
   * RestockDashboardAllocationOptions.TierThresholdWeeks for this row's
   * effective tier (a null/blank StoreClass normalizes to "Unranked").
   */
  thresholdWeeks?: Maybe<Scalars['Int']['output']>;
  /** Sum of RestockWorkQueueResultDocument.DemandQuantity across the grouped rows. */
  totalDemand: Scalars['Decimal']['output'];
  /**
   * Sales4Wk divided by distinct sale-days in the same window. Null when no
   * sales rows exist for the store in the window.
   */
  velocity4Wk?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Floor-division weeks between scoreDate and the most recent UnitsShipped > 0
   * row for the store. Null when no delivery is on record in the lookup window, which the
   * allocation rules treat as RestockAllocationReason.Excluded.
   */
  weeksSinceShip?: Maybe<Scalars['Int']['output']>;
};

/** Decimal column filter. All populated properties combine with AND semantics. */
export type RestockDashboardStoreRowDecimalFilterInput = {
  equalTo?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Decimal']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * Column-level filters applied to a Restock dashboard store-rows block request. Every property
 * is optional; non-null properties combine with AND semantics. Three classes of filterable field:
 *
 *
 * Mongo-resolvable fields (customerCode, locationCode, itemCount,
 * totalDemand, restockIndex) — applied in a post-$group $match
 * stage so the materialized set is reduced before C# merge.
 * Enrichment fields (storeName, storeNumber, storeClass) — applied
 * in C# after the post-pipeline batch fetch resolves them from CustomersSummary and
 * RestockCustomerLocations. They are not joined into the Mongo pipeline (see the class
 * docs on RestockDashboardStoreRowsBlockQueryService for why an in-pipeline
 * $lookup against the full ~28k-row collections is unsafe).
 * Allocation fields (decayedScore, weeksSinceShip, thresholdWeeks,
 * sales4Wk, velocity4Wk, allocationReason) — applied in C# after the
 * parallel DailyTransactionSummaries aggregate is merged in, because those values do
 * not exist on the source RestockCalcResults row and cannot be expressed as a pipeline
 * $match.
 *
 *
 * Numeric range predicates on nullable allocation fields treat null rows as non-matching:
 * supplying any of equalTo / gte / lte excludes rows whose underlying
 * value is null (matches AG Grid's clientSide default and avoids ambiguity about
 * whether a missing value satisfies a numeric bound). String predicates on the enrichment
 * fields apply the same nulls-non-matching rule: a row whose storeName / storeNumber
 * / storeClass is unresolved (no matching customer or location read model) is excluded
 * when any predicate component is supplied.
 */
export type RestockDashboardStoreRowFilterInput = {
  allocationReason?: InputMaybe<RestockDashboardStoreRowAllocationReasonFilterInput>;
  customerCode?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  decayedScore?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  itemCount?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  locationCode?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  restockIndex?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  sales4Wk?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  storeClass?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  storeName?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  storeNumber?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  thresholdWeeks?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  totalDemand?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  velocity4Wk?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  weeksSinceShip?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
};

/** Integer column filter. All populated properties combine with AND semantics. */
export type RestockDashboardStoreRowIntFilterInput = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Single sort directive for a Restock dashboard store-rows block request. Multiple directives
 * combine into a composite sort in the order supplied. Field must be a GraphQL
 * camelCase field name resolvable by the server's allow-list; unknown fields produce a
 * top-level GraphQL error.
 */
export type RestockDashboardStoreRowSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

/**
 * String column filter. EqualTo produces an exact match and wins over
 * Contains; Contains performs a case-insensitive substring match
 * via a regex-escaped pattern.
 */
export type RestockDashboardStoreRowStringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equalTo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Windowed result for a single block request against the Restock dashboard store-rows grid.
 * Nodes holds the current page; TotalCount reports the number of
 * rows matching the active itemCodes/locationCodes + filter scope across all
 * pages. No group-totals branch yet — the dashboard UI doesn't ship grouping; can be added
 * later without breaking changes.
 */
export type RestockDashboardStoreRowsBlockData = {
  __typename?: 'RestockDashboardStoreRowsBlockData';
  /** Leaf rows for the current page. */
  nodes: Array<RestockDashboardStoreRowData>;
  /**
   * Total matching rows for the current scope. Computed in the same aggregation round trip as
   * Nodes so the count cannot drift relative to the returned page.
   */
  totalCount: Scalars['Int']['output'];
};

/**
 * Per-tenant data-validity summary: the evaluated checks plus the worst-of rollup. The flat
 * Checks list maps 1:1 to the PWA RAG cards; a category grouping can be added
 * later without breaking this shape.
 */
export type RestockDataValiditySummary = {
  __typename?: 'RestockDataValiditySummary';
  checks: Array<RestockValidityCheck>;
  evaluatedAt: Scalars['DateTime']['output'];
  overallStatus: RestockValidityStatus;
  tenantId: Scalars['String']['output'];
};

/**
 * BYOA explanation payload for a single Restock calc row. The Payload string is
 * capped at 4096 bytes by the writer; oversized inputs are truncated with
 * Overflowed = true so the audit row is always persisted.
 */
export type RestockExplanationPayload = {
  __typename?: 'RestockExplanationPayload';
  /** Version of the provider model that produced the payload. */
  modelVersion: Scalars['String']['output'];
  /** True when the payload was truncated to fit the size cap. */
  overflowed: Scalars['Boolean']['output'];
  /** JSON-serialized provider payload, capped to 4096 bytes UTF-8. */
  payload: Scalars['String']['output'];
  /** Identifier of the provider that emitted this explanation (e.g. "internal-statistical"). */
  providerKey: Scalars['String']['output'];
  /** UTC timestamp at which the explanation was persisted. */
  writtenAt: Scalars['DateTime']['output'];
};

/**
 * Component breakdown of RestockDashboardStoreRowData.RestockIndex. Exposed
 * alongside the aggregate score so the PWA breakdown dialog can attribute a store's rank
 * to its strongest driver (demand, urgency, velocity, or class) without recomputing the
 * formula client-side. Sum of components equals the pre-cap index; the dashboard's
 * RestockIndex applies the 100-cap to the sum.
 */
export type RestockIndexBreakdownData = {
  __typename?: 'RestockIndexBreakdownData';
  /** Demand contribution — min(50, totalDemand × 0.6). */
  demandScore: Scalars['Int']['output'];
  /** Store-class bonus — A:10, B:5, C:0, anything else:0. */
  rankBonus: Scalars['Int']['output'];
  /** Velocity contribution — min(15, salesVelocity × 0.25). */
  velocityScore: Scalars['Int']['output'];
  /** Urgency contribution — max(0, 25 − weeksOfSupply × 4); lower WoS scores higher. */
  wosScore: Scalars['Int']['output'];
};

/**
 * Unified restock metrics shape served by restockMetrics(sessionId, itemId).
 * Scope is session-level when itemId is omitted and item-level when itemId
 * is supplied; in either case the shape is the same seven concepts — six physical
 * metrics (each with a quantity and wholesale dollar value) plus a non-additive
 * UtilizationPercent. Supersedes SessionRestockMetricsData and
 * ItemRestockMetricsData; those remain callable during the rollout and
 * are removed in a follow-up cleanup task.
 * RemainingAvailability is unclamped so negatives signal over-allocation.
 * UtilizationPercent returns the 9999.0 sentinel when
 * AvailableForOrders <= 0 and OnOrder > 0, and 0 when both
 * are zero.
 */
export type RestockMetrics = {
  __typename?: 'RestockMetrics';
  allocated: MetricValue;
  available: MetricValue;
  availableForOrders: MetricValue;
  inTransit: MetricValue;
  onOrder: MetricValue;
  remainingAvailability: MetricValue;
  utilizationPercent: Scalars['Decimal']['output'];
};

/** Optional item and hierarchy filters applied to restock metrics aggregation. */
export type RestockMetricsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by exact match on ItemSummaryDocument.Group (the item group / singular).
   * Provide one or more candidate values; an item matches if its Group equals any.
   */
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by exact match on ItemSummaryDocument.Subcategory (a singular field).
   * Provide one or more candidate values; an item matches if its Subcategory equals any.
   */
  subcategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Decimal column filter. All populated properties combine with AND semantics. */
export type RestockOrderItemDecimalFilterInput = {
  equalTo?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThan?: InputMaybe<Scalars['Decimal']['input']>;
  lessThan?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RestockOrderItemDelta = {
  __typename?: 'RestockOrderItemDelta';
  achievableQuantity: Scalars['Int']['output'];
  customerLocationId: Scalars['String']['output'];
  demandQuantity: Scalars['Int']['output'];
  hasOverrides: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
};

/**
 * Column-level filters applied to a Restock session order items block request. Every property is
 * optional; non-null properties combine with AND semantics. Only doc-native fields are
 * filterable — ERP-derived fields are intentionally excluded because they are resolved per-row
 * after the windowing match stage.
 */
export type RestockOrderItemFilterInput = {
  achievableQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  city?: InputMaybe<RestockOrderItemStringFilterInput>;
  demandQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  description?: InputMaybe<RestockOrderItemStringFilterInput>;
  inTransit?: InputMaybe<RestockOrderItemIntFilterInput>;
  itemGroup?: InputMaybe<RestockOrderItemStringFilterInput>;
  itemName?: InputMaybe<RestockOrderItemStringFilterInput>;
  itemNumber?: InputMaybe<RestockOrderItemStringFilterInput>;
  orderQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  overallStatus?: InputMaybe<RestockOrderItemStringFilterInput>;
  predictedOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  productGroup?: InputMaybe<RestockOrderItemStringFilterInput>;
  route?: InputMaybe<RestockOrderItemStringFilterInput>;
  sellDownUnits?: InputMaybe<RestockOrderItemIntFilterInput>;
  stateProvince?: InputMaybe<RestockOrderItemStringFilterInput>;
  storeClass?: InputMaybe<RestockOrderItemStringFilterInput>;
  storeName?: InputMaybe<RestockOrderItemStringFilterInput>;
  subcategory?: InputMaybe<RestockOrderItemStringFilterInput>;
  targetOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  unitsOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  weeklyRateOfSale?: InputMaybe<RestockOrderItemDecimalFilterInput>;
  weeksOfSupply?: InputMaybe<RestockOrderItemDecimalFilterInput>;
};

/**
 * Aggregate row representing one group under the current group-by path.
 * GroupKeyValues is ordered to match the group-by sequence up to and including
 * this group's level.
 */
export type RestockOrderItemGroupTotal = {
  __typename?: 'RestockOrderItemGroupTotal';
  /** Sum of leaf AchievableQuantity values in this group. */
  achievableQuantity: Scalars['Int']['output'];
  /**
   * Sum of resolved leaf Available values in this group. Resolution matches the detail
   * path: RestockAvailability (with Source=Erp) when a matching doc exists for
   * the row's ItemNumber + session station, otherwise the stored doc value.
   */
  available: Scalars['Int']['output'];
  /** Sum of leaf DemandQuantity values in this group. */
  demandQuantity: Scalars['Int']['output'];
  /** Group-by key values identifying this group, in group-by order. */
  groupKeyValues: Array<Scalars['String']['output']>;
  /** Sum of leaf OrderQuantity values in this group. */
  orderQuantity: Scalars['Int']['output'];
  /** Number of leaf rows contributing to this group. */
  rowCount: Scalars['Int']['output'];
  /** Sum of leaf UnitsOnHand values in this group. */
  unitsOnHand: Scalars['Int']['output'];
};

/** Integer column filter. All populated properties combine with AND semantics. */
export type RestockOrderItemIntFilterInput = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Single sort directive for a Restock session order items block request. Multiple directives
 * combine into a composite sort in the order supplied. Field must be a GraphQL
 * camelCase field name resolvable by the server's allow-list; unknown fields produce a GraphQL
 * error.
 */
export type RestockOrderItemSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

/**
 * String column filter. EqualTo produces an exact match and wins over
 * Contains; Contains performs a case-insensitive substring match
 * via a regex-escaped pattern.
 */
export type RestockOrderItemStringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equalTo?: InputMaybe<Scalars['String']['input']>;
};

export type RestockOrderQuantityOverrideItemDataInput = {
  customerLocationId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};

export enum RestockOverrideType {
  Add = 'ADD',
  Replace = 'REPLACE',
  Subtract = 'SUBTRACT',
  ToAchievable = 'TO_ACHIEVABLE',
  ToDemand = 'TO_DEMAND',
  ToTargetWeeksOfSupply = 'TO_TARGET_WEEKS_OF_SUPPLY'
}

export type RestockProviderSettingsData = {
  __typename?: 'RestockProviderSettingsData';
  rosProviderConfig?: Maybe<Scalars['String']['output']>;
  rosProviderKey: Scalars['String']['output'];
};

export type RestockProviderSettingsDataFilterInput = {
  and?: InputMaybe<Array<RestockProviderSettingsDataFilterInput>>;
  or?: InputMaybe<Array<RestockProviderSettingsDataFilterInput>>;
  rosProviderConfig?: InputMaybe<StringOperationFilterInput>;
  rosProviderKey?: InputMaybe<StringOperationFilterInput>;
};

export type RestockProviderSettingsDataSortInput = {
  rosProviderConfig?: InputMaybe<SortEnumType>;
  rosProviderKey?: InputMaybe<SortEnumType>;
};

export type RestockReserveRuleDataInput = {
  id: Scalars['String']['input'];
  level: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  value: Scalars['String']['input'];
};

/**
 * Payload for the onRestockSessionBatchProgress subscription. Each event
 * represents the in-flight state of one of:
 *
 *   the chunked server-driven session creation workflow (
 *     StartRestockSessionCreation),
 *   the BYOA-v1 default-WOS session creation + on-demand-miss flow (
 *     CreateRestockSession — phase emit lands in C2),
 *   a client-triggered Restock calculation.
 *
 * This type is transient and never persisted — it exists only to carry progress signals
 * from the server to connected subscribers. Subscribers must subscribe BEFORE issuing the
 * triggering mutation; SessionId is client-generated, so the PWA can subscribe up-front
 * without a race against the producer.
 */
export type RestockSessionBatchProgressPayload = {
  __typename?: 'RestockSessionBatchProgressPayload';
  /**
   * Zero-based index of the batch currently in flight. Always 0 when
   * Phase is RestockBatchPhase.Idle, when the producing
   * event has not yet reached a progressed batch, or when the active phase does not
   * carry batch semantics (BYOA-v1 phases — see RestockBatchPhase).
   */
  currentBatch: Scalars['Int']['output'];
  /**
   * Populated with the worker error message when Phase is
   * RestockBatchPhase.Idle and the workflow terminated abnormally;
   * null on successful terminal events or in-flight progress.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Bounded comma-joined sample of the excluded item codes (first five, with a trailing
   * ellipsis when more were excluded); null when nothing was excluded. The full capped list
   * is served by the restockSessionCreationExclusions drill-down query.
   */
  excludedItemCodesSample?: Maybe<Scalars['String']['output']>;
  /**
   * Full distinct count of items excluded from the session because their tuples were
   * un-computable data gaps (missing rate-of-sale/inventory data). Non-zero only on the
   * terminal Idle payload of a create that completed with exclusions — the amber
   * partial-success state; Error stays null on that payload.
   */
  excludedItemCount: Scalars['Int']['output'];
  /**
   * Comma-joined distinct missing-input reason codes
   * (NO_BASE_ROS / NO_INVENTORY / NO_GREENHOUSE_INVENTORY); null when
   * nothing was skipped.
   */
  missingInputReasonsSample?: Maybe<Scalars['String']['output']>;
  /**
   * Count of tuples skipped because the drain resolved them as missing-input data gaps (the row
   * exists but carries no demand). Distinct from ExcludedItemCount (the
   * un-computable, never-produced-a-row population). Non-zero only on a terminal Idle
   * whose session completed with such rows; Error stays null.
   */
  missingInputSkipCount: Scalars['Int']['output'];
  /** Full distinct count of items spanned by the missing-input skip rows. */
  missingInputSkipItemCount: Scalars['Int']['output'];
  /**
   * UTC instant the producing emit was stamped. Live publishes carry the emitter's clock at
   * publish time; events replayed from the RestockSessionCreationProgressDocument audit
   * row on (re)subscribe carry the row's LastUpdate. Lets clients order events and
   * distinguish a fresh transition from a replayed last-known state.
   */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * The current lifecycle phase. RestockBatchPhase.Idle is emitted
   * on terminal success or failure so clients can reset local UI.
   */
  phase: RestockBatchPhase;
  /** The ID of the session this progress notification is scoped to. */
  sessionId: Scalars['String']['output'];
  /**
   * Total number of batches expected for the current workflow. Always
   * 0 when Phase is RestockBatchPhase.Idle or when
   * the active phase does not carry batch semantics (BYOA-v1 phases).
   */
  totalBatches: Scalars['Int']['output'];
};

/**
 * Drill-down payload for the restockSessionCreationExclusions query: the structured
 * exclusions recorded when a session create completed with un-computable data-gap tuples
 * excluded (missing rate-of-sale/inventory data). Backed by the
 * RestockSessionCreationProgressDocument TTL audit row, so exclusions are queryable
 * for the retention window after the create — the live
 * onRestockSessionBatchProgress payload carries only a bounded item-code sample.
 */
export type RestockSessionCreationExclusionsPayload = {
  __typename?: 'RestockSessionCreationExclusionsPayload';
  /**
   * Distinct, ordered excluded item codes, capped at 200 entries. Compare with
   * ExcludedItemCount to detect truncation.
   */
  excludedItemCodes: Array<Scalars['String']['output']>;
  /**
   * Full distinct count of items spanned by the excluded tuples — always the total, even
   * when ExcludedItemCodes is capped.
   */
  excludedItemCount: Scalars['Int']['output'];
  /** Count of un-computable tuples excluded from the session. */
  excludedTupleCount: Scalars['Int']['output'];
  /** UTC instant the terminal progress emit recorded the exclusions. */
  occurredAt: Scalars['DateTime']['output'];
  /** The session whose create completed with exclusions. */
  sessionId: Scalars['String']['output'];
};

export type RestockSessionCreationStatusData = {
  __typename?: 'RestockSessionCreationStatusData';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  phase: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
};

export type RestockSessionCreationStatusDocument = {
  __typename?: 'RestockSessionCreationStatusDocument';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  phase: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
};

export type RestockSessionCreationStatusDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionCreationStatusDocumentFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  currentChunk?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  lastProgressAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionCreationStatusDocumentFilterInput>>;
  phase?: InputMaybe<StringOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  totalChunks?: InputMaybe<IntOperationFilterInput>;
};

export type RestockSessionCreationStatusDocumentSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  currentChunk?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  lastProgressAt?: InputMaybe<SortEnumType>;
  phase?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  totalChunks?: InputMaybe<SortEnumType>;
};

export type RestockSessionDocument = {
  __typename?: 'RestockSessionDocument';
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: Maybe<Scalars['Int']['output']>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus: RestockCalculationStatus;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: Maybe<RestockSessionCreationStatusDocument>;
  id: Scalars['String']['output'];
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError: Scalars['String']['output'];
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: Maybe<LockedRestockConfig>;
  reserveRules: Array<RestockSessionReserveRuleDocument>;
  selectedItemIds: Array<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode?: Maybe<Scalars['String']['output']>;
  status: RestockSessionStatus;
  storeCount: Scalars['Int']['output'];
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RestockSessionDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionDocumentFilterInput>>;
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: InputMaybe<IntOperationFilterInput>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus?: InputMaybe<RestockCalculationStatusOperationFilterInput>;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: InputMaybe<RestockSessionCreationStatusDocumentFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: InputMaybe<LockedRestockConfigFilterInput>;
  or?: InputMaybe<Array<RestockSessionDocumentFilterInput>>;
  reserveRules?: InputMaybe<ListFilterInputTypeOfRestockSessionReserveRuleDocumentFilterInput>;
  selectedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  sessionName?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RestockSessionStatusOperationFilterInput>;
  storeCount?: InputMaybe<IntOperationFilterInput>;
  targetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalQuantity?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type RestockSessionDocumentSortInput = {
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: InputMaybe<SortEnumType>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus?: InputMaybe<SortEnumType>;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: InputMaybe<RestockSessionCreationStatusDocumentSortInput>;
  id?: InputMaybe<SortEnumType>;
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: InputMaybe<LockedRestockConfigSortInput>;
  sessionId?: InputMaybe<SortEnumType>;
  sessionName?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storeCount?: InputMaybe<SortEnumType>;
  targetWeeksOfSupply?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalQuantity?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocument = {
  __typename?: 'RestockSessionExportOrderDocument';
  carts: Scalars['Decimal']['output'];
  containerCode?: Maybe<Scalars['String']['output']>;
  customerLocationId: Scalars['String']['output'];
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode: Scalars['String']['output'];
  status: RestockSessionStatus;
  storeName: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionExportOrderDocumentFilterInput>>;
  carts?: InputMaybe<DecimalOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionExportOrderDocumentFilterInput>>;
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RestockSessionStatusOperationFilterInput>;
  storeName?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocumentSortInput = {
  carts?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemNumber?: InputMaybe<SortEnumType>;
  orderQuantity?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storeName?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockSessionExportOrdersConnection = {
  __typename?: 'RestockSessionExportOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionExportOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionExportOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionExportOrdersEdge = {
  __typename?: 'RestockSessionExportOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionExportOrderDocument;
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocument = {
  __typename?: 'RestockSessionItemAllocationDocument';
  allocatedQuantity: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  perStore: Array<KeyValuePairOfStringAndInt32>;
  sessionId: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<RestockSessionItemAllocationDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionItemAllocationDocumentFilterInput>>;
  perStore?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndInt32FilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockSessionItemAllocationsConnection = {
  __typename?: 'RestockSessionItemAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionItemAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionItemAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionItemAllocationsEdge = {
  __typename?: 'RestockSessionItemAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionItemAllocationDocument;
};

export type RestockSessionItemAvailabilityData = {
  __typename?: 'RestockSessionItemAvailabilityData';
  available: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
};

export type RestockSessionOrderItemData = {
  __typename?: 'RestockSessionOrderItemData';
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  allocatePercent: Scalars['Decimal']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableToShip: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  blockingRuleIds: Array<Scalars['String']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  calculatedOrderQuantity: Scalars['Int']['output'];
  carts: Scalars['Decimal']['output'];
  customerLocationId: Scalars['String']['output'];
  daysSinceLastDelivery: Scalars['Int']['output'];
  daysSinceLastSale: Scalars['Int']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  demandQuantity: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  inTransit: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  overallStatus: Scalars['String']['output'];
  predictedOnHand: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  promotionRuleIds: Array<Scalars['String']['output']>;
  rawTrailingUnitsSold: Scalars['Int']['output'];
  replenishmentTarget: Scalars['Int']['output'];
  reservePercent: Scalars['Decimal']['output'];
  reserveQuantity: Scalars['Int']['output'];
  sellDownUnits: Scalars['Decimal']['output'];
  storeName: Scalars['String']['output'];
  targetOnHand: Scalars['Int']['output'];
  trailingSales: Scalars['Decimal']['output'];
  unitValue: Scalars['Decimal']['output'];
  unitsOnHand: Scalars['Int']['output'];
  unitsOnHandValue: Scalars['Decimal']['output'];
  unitsReplenished: Scalars['Int']['output'];
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type RestockSessionOrderItemDocument = {
  __typename?: 'RestockSessionOrderItemDocument';
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  allocatePercent: Scalars['Decimal']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableToShip: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  blockingRuleIds: Array<Scalars['String']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  calculatedOrderQuantity: Scalars['Int']['output'];
  carts: Scalars['Decimal']['output'];
  categories?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  customerLocationId: Scalars['String']['output'];
  daysSinceLastDelivery: Scalars['Int']['output'];
  daysSinceLastSale: Scalars['Int']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  demandQuantity: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inTransit: Scalars['Int']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence: Scalars['Long']['output'];
  location?: Maybe<CustomerLocationDocument>;
  onHandConfidencePercent: Scalars['Decimal']['output'];
  orderQuantity: Scalars['Int']['output'];
  overallStatus: Scalars['String']['output'];
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount: Scalars['Int']['output'];
  predictedOnHand: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  programs?: Maybe<Array<Scalars['String']['output']>>;
  promotionRuleIds: Array<Scalars['String']['output']>;
  rawTrailingUnitsSold: Scalars['Int']['output'];
  remainingValue: Scalars['Decimal']['output'];
  replenishmentTarget: Scalars['Int']['output'];
  reservePercent: Scalars['Decimal']['output'];
  reserveQuantity: Scalars['Int']['output'];
  roundToFullCart: Scalars['Boolean']['output'];
  route?: Maybe<Scalars['String']['output']>;
  sellDownUnits: Scalars['Decimal']['output'];
  sessionId: Scalars['String']['output'];
  shipmentIncrement: Scalars['Int']['output'];
  sizes?: Maybe<Array<ItemDocumentSize>>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  storeClass?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
  subcategory?: Maybe<Scalars['String']['output']>;
  targetOnHand: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingSales: Scalars['Decimal']['output'];
  unitValue: Scalars['Decimal']['output'];
  unitsOnHand: Scalars['Int']['output'];
  unitsOnHandValue: Scalars['Decimal']['output'];
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: Maybe<Scalars['Int']['output']>;
  unitsReplenished: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type RestockSessionOrderItemDocumentFilterInput = {
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  allocatePercent?: InputMaybe<DecimalOperationFilterInput>;
  allocatedValue?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<RestockSessionOrderItemDocumentFilterInput>>;
  available?: InputMaybe<IntOperationFilterInput>;
  availableToShip?: InputMaybe<IntOperationFilterInput>;
  availableValue?: InputMaybe<DecimalOperationFilterInput>;
  blockingRuleIds?: InputMaybe<ListStringOperationFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  calculatedOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  carts?: InputMaybe<DecimalOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  daysSinceLastDelivery?: InputMaybe<IntOperationFilterInput>;
  daysSinceLastSale?: InputMaybe<IntOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  demandQuantity?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  greenhouseInventory?: InputMaybe<IntOperationFilterInput>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inTransit?: InputMaybe<IntOperationFilterInput>;
  itemGroup?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence?: InputMaybe<LongOperationFilterInput>;
  location?: InputMaybe<CustomerLocationDocumentFilterInput>;
  or?: InputMaybe<Array<RestockSessionOrderItemDocumentFilterInput>>;
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  overallStatus?: InputMaybe<StringOperationFilterInput>;
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount?: InputMaybe<IntOperationFilterInput>;
  predictedOnHand?: InputMaybe<IntOperationFilterInput>;
  previousOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  promotionRuleIds?: InputMaybe<ListStringOperationFilterInput>;
  rawTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  replenishmentTarget?: InputMaybe<IntOperationFilterInput>;
  reservePercent?: InputMaybe<DecimalOperationFilterInput>;
  reserveQuantity?: InputMaybe<IntOperationFilterInput>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  sellDownUnits?: InputMaybe<DecimalOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  storeName?: InputMaybe<StringOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  targetOnHand?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingSales?: InputMaybe<DecimalOperationFilterInput>;
  unitValue?: InputMaybe<DecimalOperationFilterInput>;
  unitsOnHand?: InputMaybe<IntOperationFilterInput>;
  unitsOnHandValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: InputMaybe<IntOperationFilterInput>;
  unitsReplenished?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  usableTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  weeklyRateOfSale?: InputMaybe<DecimalOperationFilterInput>;
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

export type RestockSessionOrderItemDocumentSortInput = {
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: InputMaybe<SortEnumType>;
  allocatePercent?: InputMaybe<SortEnumType>;
  allocatedValue?: InputMaybe<SortEnumType>;
  available?: InputMaybe<SortEnumType>;
  availableToShip?: InputMaybe<SortEnumType>;
  availableValue?: InputMaybe<SortEnumType>;
  calculatedAt?: InputMaybe<SortEnumType>;
  calculatedOrderQuantity?: InputMaybe<SortEnumType>;
  carts?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  daysSinceLastDelivery?: InputMaybe<SortEnumType>;
  daysSinceLastSale?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  demandQuantity?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  greenhouseInventory?: InputMaybe<SortEnumType>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inTransit?: InputMaybe<SortEnumType>;
  itemGroup?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemNumber?: InputMaybe<SortEnumType>;
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: InputMaybe<SortEnumType>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence?: InputMaybe<SortEnumType>;
  location?: InputMaybe<CustomerLocationDocumentSortInput>;
  orderQuantity?: InputMaybe<SortEnumType>;
  overallStatus?: InputMaybe<SortEnumType>;
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount?: InputMaybe<SortEnumType>;
  predictedOnHand?: InputMaybe<SortEnumType>;
  previousOrderQuantity?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  rawTrailingUnitsSold?: InputMaybe<SortEnumType>;
  replenishmentTarget?: InputMaybe<SortEnumType>;
  reservePercent?: InputMaybe<SortEnumType>;
  reserveQuantity?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  sellDownUnits?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  storeName?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  targetOnHand?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingSales?: InputMaybe<SortEnumType>;
  unitValue?: InputMaybe<SortEnumType>;
  unitsOnHand?: InputMaybe<SortEnumType>;
  unitsOnHandValue?: InputMaybe<SortEnumType>;
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: InputMaybe<SortEnumType>;
  unitsReplenished?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  usableTrailingUnitsSold?: InputMaybe<SortEnumType>;
  weeklyRateOfSale?: InputMaybe<SortEnumType>;
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

/**
 * Windowed result for a single block request against a Restock session's order items grid.
 * Nodes holds leaf rows for the current page; GroupTotals holds
 * summary rows when the client is browsing a group level. The two arrays are mutually
 * exclusive — a summary request returns empty Nodes and vice versa.
 */
export type RestockSessionOrderItemsBlockPayload = {
  __typename?: 'RestockSessionOrderItemsBlockPayload';
  /** Aggregated totals per group, populated only when the request is a group summary. */
  groupTotals: Array<RestockOrderItemGroupTotal>;
  /** Leaf rows for the current page. Empty when the request resolves to a group summary. */
  nodes: Array<RestockSessionOrderItemDocument>;
  /**
   * Total matching rows for the current filter/group scope. For leaf requests this is the row
   * count across all pages; for group summaries it is the number of groups returned.
   */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type RestockSessionOrderItemsConnection = {
  __typename?: 'RestockSessionOrderItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionOrderItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionOrderItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionOrderItemsEdge = {
  __typename?: 'RestockSessionOrderItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionOrderItemDocument;
};

/** A connection to a list of items. */
export type RestockSessionOrderQuantityOverrideHistoryConnection = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionOrderQuantityOverrideHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionOrderQuantityOverrideHistoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocument = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryDocument';
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: Maybe<Scalars['Int']['output']>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId: Scalars['String']['output'];
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id: Scalars['String']['output'];
  /** Item the override targets. */
  itemId: Scalars['String']['output'];
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt: Scalars['DateTime']['output'];
  /** Order quantity recorded on the event's line item. */
  orderQuantity: Scalars['Int']['output'];
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind: OverrideKind;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  /** RestockSession the override targets. */
  restockSessionId: Scalars['String']['output'];
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence: Scalars['Long']['output'];
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId: Scalars['String']['output'];
  /** User that produced the override. */
  updatedBy: Scalars['String']['output'];
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>>;
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: InputMaybe<IntOperationFilterInput>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Item the override targets. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>>;
  /** Order quantity recorded on the event's line item. */
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind?: InputMaybe<OverrideKindOperationFilterInput>;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  /** RestockSession the override targets. */
  restockSessionId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence?: InputMaybe<LongOperationFilterInput>;
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** User that produced the override. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocumentSortInput = {
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: InputMaybe<SortEnumType>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId?: InputMaybe<SortEnumType>;
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id?: InputMaybe<SortEnumType>;
  /** Item the override targets. */
  itemId?: InputMaybe<SortEnumType>;
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt?: InputMaybe<SortEnumType>;
  /** Order quantity recorded on the event's line item. */
  orderQuantity?: InputMaybe<SortEnumType>;
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind?: InputMaybe<SortEnumType>;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: InputMaybe<SortEnumType>;
  /** RestockSession the override targets. */
  restockSessionId?: InputMaybe<SortEnumType>;
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence?: InputMaybe<SortEnumType>;
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** User that produced the override. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type RestockSessionOrderQuantityOverrideHistoryEdge = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionOrderQuantityOverrideHistoryDocument;
};

export type RestockSessionPayload = {
  __typename?: 'RestockSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<Scalars['String']['output']>;
  updatedRows?: Maybe<Array<RestockOrderItemDelta>>;
};

export type RestockSessionReserveRuleData = {
  __typename?: 'RestockSessionReserveRuleData';
  id: Scalars['String']['output'];
  level: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  value: Scalars['String']['output'];
};

export type RestockSessionReserveRuleDocument = {
  __typename?: 'RestockSessionReserveRuleDocument';
  id: Scalars['String']['output'];
  level: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  value: Scalars['String']['output'];
};

export type RestockSessionReserveRuleDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionReserveRuleDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  level?: InputMaybe<StringOperationFilterInput>;
  mode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionReserveRuleDocumentFilterInput>>;
  percentage?: InputMaybe<DecimalOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Adds unallocatedAvailability(itemId, stationCode) to the
 * RestockSessionStateData GraphQL type (the type returned by the
 * restockSession(sessionId) root query). Returns
 * liveErp − allocatedQuantity for the given item, capping at zero. If the projection
 * has not yet built a row (session newly created or replay lagging), we treat
 * allocatedQuantity as zero and return the live ERP value. Mirrors
 * DbrSessionUnallocatedAvailabilityResolver.
 */
export type RestockSessionStateData = {
  __typename?: 'RestockSessionStateData';
  calculationStatus: RestockCalculationStatus;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creationStatus?: Maybe<RestockSessionCreationStatusData>;
  lastCalculationError: Scalars['String']['output'];
  lockedConfig?: Maybe<LockedRestockConfig>;
  orderItems: Array<RestockSessionOrderItemData>;
  reserveRules: Array<RestockSessionReserveRuleData>;
  selectedItemIds: Array<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode?: Maybe<Scalars['String']['output']>;
  status: RestockSessionStatus;
  stores: Array<RestockSessionStoreData>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  unallocatedAvailability: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


/**
 * Adds unallocatedAvailability(itemId, stationCode) to the
 * RestockSessionStateData GraphQL type (the type returned by the
 * restockSession(sessionId) root query). Returns
 * liveErp − allocatedQuantity for the given item, capping at zero. If the projection
 * has not yet built a row (session newly created or replay lagging), we treat
 * allocatedQuantity as zero and return the live ERP value. Mirrors
 * DbrSessionUnallocatedAvailabilityResolver.
 */
export type RestockSessionStateDataUnallocatedAvailabilityArgs = {
  itemId: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
};

export enum RestockSessionStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Synchronized = 'SYNCHRONIZED'
}

export type RestockSessionStatusOperationFilterInput = {
  eq?: InputMaybe<RestockSessionStatus>;
  in?: InputMaybe<Array<RestockSessionStatus>>;
  neq?: InputMaybe<RestockSessionStatus>;
  nin?: InputMaybe<Array<RestockSessionStatus>>;
};

export type RestockSessionStoreData = {
  __typename?: 'RestockSessionStoreData';
  customerLocationId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export type RestockSessionSubmitSummaryData = {
  __typename?: 'RestockSessionSubmitSummaryData';
  selectedItemCount: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  storeCount: Scalars['Int']['output'];
  totalCarts: Scalars['Decimal']['output'];
  totalValue: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type RestockSessionsConnection = {
  __typename?: 'RestockSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionsEdge = {
  __typename?: 'RestockSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionDocument;
};

/**
 * One evaluated data-validity check. Value is the rendered metric behind the
 * status (e.g. "310991/497125 demand>0 (63%)"); Detail and
 * Remediation are human hints. RelatedTaskId links a known Helm bug
 * when one backs the check.
 */
export type RestockValidityCheck = {
  __typename?: 'RestockValidityCheck';
  detail?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  relatedTaskId?: Maybe<Scalars['String']['output']>;
  remediation?: Maybe<Scalars['String']['output']>;
  status: RestockValidityStatus;
  value: Scalars['String']['output'];
};

/**
 * RAG status for a single Restock data-validity check (and the rolled-up overall status).
 * Unknown is first so a default-constructed value reads as "not yet evaluated".
 * Re-homed from wsapi-admin-api (PR #8762) — behaviour preserved, names prefixed to avoid
 * collisions in the larger wsapi schema.
 */
export enum RestockValidityStatus {
  Amber = 'AMBER',
  Green = 'GREEN',
  Red = 'RED',
  Unknown = 'UNKNOWN'
}

/**
 * Payload broadcast on restockWorkQueueResultBatchCompleted once per
 * RestockWorkQueueResultDocument batch the worker (S19) flushes via
 * BulkWriteAsync. Batched-only from inception — there is no per-row channel
 * for the Restock work-queue result stream, ever.
 */
export type RestockWorkQueueResultBatchPayload = {
  __typename?: 'RestockWorkQueueResultBatchPayload';
  calcDate: Scalars['DateTime']['output'];
  rows: Array<RestockWorkQueueResultBatchRowData>;
  tenantId: Scalars['String']['output'];
};

/**
 * Mutation result for publishRestockWorkQueueResultBatch. RowCount
 * echoes the batch size accepted for publish; a non-empty Errors array
 * signals the caller's input was rejected before any topic event was sent.
 */
export type RestockWorkQueueResultBatchPublishedPayload = {
  __typename?: 'RestockWorkQueueResultBatchPublishedPayload';
  errors?: Maybe<Array<ValidationError>>;
  rowCount: Scalars['Int']['output'];
};

/**
 * Single calc result inside a batch. Shape is shared between the publish input and the
 * broadcast payload so PWA clients and the worker speak the same row schema. The
 * Data suffix locks the type to this contract — keep it out of other surfaces
 * to preserve forward compatibility.
 */
export type RestockWorkQueueResultBatchRowData = {
  __typename?: 'RestockWorkQueueResultBatchRowData';
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  demandQuantity: Scalars['Decimal']['output'];
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  strategyKey: Scalars['String']['output'];
};

/**
 * Single calc result inside a batch. Shape is shared between the publish input and the
 * broadcast payload so PWA clients and the worker speak the same row schema. The
 * Data suffix locks the type to this contract — keep it out of other surfaces
 * to preserve forward compatibility.
 */
export type RestockWorkQueueResultBatchRowDataInput = {
  calcDate: Scalars['DateTime']['input'];
  customerCode: Scalars['String']['input'];
  demandQuantity: Scalars['Decimal']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  strategyKey: Scalars['String']['input'];
};

export type ResumeCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocument = {
  __typename?: 'RetailAvailableBpLotDocument';
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity: Scalars['Decimal']['output'];
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode: Scalars['String']['output'];
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo: Scalars['String']['output'];
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId: Scalars['String']['output'];
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId: Scalars['String']['output'];
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocumentFilterInput = {
  and?: InputMaybe<Array<RetailAvailableBpLotDocumentFilterInput>>;
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo?: InputMaybe<StringOperationFilterInput>;
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RetailAvailableBpLotDocumentFilterInput>>;
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocumentSortInput = {
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity?: InputMaybe<SortEnumType>;
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RetailAvailableBpLotsConnection = {
  __typename?: 'RetailAvailableBpLotsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RetailAvailableBpLotsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailAvailableBpLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RetailAvailableBpLotsEdge = {
  __typename?: 'RetailAvailableBpLotsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailAvailableBpLotDocument;
};

/**
 * Per-count result for the batch mutation: the audit record on success, or the validation error on
 * failure. The IdempotencyKey echoes the input key so the PWA can correlate each result
 * to the offline-queued count it submitted.
 */
export type RetailCountResult = {
  __typename?: 'RetailCountResult';
  count?: Maybe<RetailProductCountDocument>;
  error?: Maybe<ValidationError>;
  idempotencyKey: Scalars['String']['output'];
};

export enum RetailCountType {
  Credit = 'CREDIT',
  CycleCount = 'CYCLE_COUNT',
  DropOff = 'DROP_OFF',
  MustGo = 'MUST_GO',
  Unknown = 'UNKNOWN'
}

export type RetailCountTypeOperationFilterInput = {
  eq?: InputMaybe<RetailCountType>;
  in?: InputMaybe<Array<RetailCountType>>;
  neq?: InputMaybe<RetailCountType>;
  nin?: InputMaybe<Array<RetailCountType>>;
};

/**
 * Batch payload for the multi-count mutation. Results holds one row per input count (in
 * input order), each carrying either the audit record or the per-count error — so a partial
 * offline-replay flush surfaces exactly which counts landed and which were rejected.
 * Errors carries a BATCH-level failure only (e.g. the BPF-only tenant rejection or an
 * empty/over-cap batch), in which case Results is empty.
 */
export type RetailProductCountBatchPayload = {
  __typename?: 'RetailProductCountBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<RetailCountResult>;
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocument = {
  __typename?: 'RetailProductCountDocument';
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode: Scalars['String']['output'];
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType: RetailCountType;
  /** When the count was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference: Scalars['String']['output'];
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference: Scalars['String']['output'];
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude: Scalars['Float']['output'];
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId: Scalars['String']['output'];
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude: Scalars['Float']['output'];
  /** Free-form field-user note; empty when none. */
  note: Scalars['String']['output'];
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId: Scalars['String']['output'];
  /** The product-count quantity delta the field user recorded. */
  quantityChange: Scalars['Decimal']['output'];
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit: Scalars['String']['output'];
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange: Scalars['Decimal']['output'];
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocumentFilterInput = {
  and?: InputMaybe<Array<RetailProductCountDocumentFilterInput>>;
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode?: InputMaybe<StringOperationFilterInput>;
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType?: InputMaybe<RetailCountTypeOperationFilterInput>;
  /** When the count was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference?: InputMaybe<StringOperationFilterInput>;
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  /** Free-form field-user note; empty when none. */
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RetailProductCountDocumentFilterInput>>;
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** The product-count quantity delta the field user recorded. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocumentSortInput = {
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode?: InputMaybe<SortEnumType>;
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType?: InputMaybe<SortEnumType>;
  /** When the count was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference?: InputMaybe<SortEnumType>;
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude?: InputMaybe<SortEnumType>;
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId?: InputMaybe<SortEnumType>;
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude?: InputMaybe<SortEnumType>;
  /** Free-form field-user note; empty when none. */
  note?: InputMaybe<SortEnumType>;
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId?: InputMaybe<SortEnumType>;
  /** The product-count quantity delta the field user recorded. */
  quantityChange?: InputMaybe<SortEnumType>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<SortEnumType>;
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
};

/**
 * Single-record payload for the retail product-count mutation. Carries the audit record on success,
 * or the validation error(s) on failure (including the BPF-only tenant rejection).
 */
export type RetailProductCountPayload = {
  __typename?: 'RetailProductCountPayload';
  count?: Maybe<RetailProductCountDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type RetailProductCountsConnection = {
  __typename?: 'RetailProductCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RetailProductCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailProductCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RetailProductCountsEdge = {
  __typename?: 'RetailProductCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailProductCountDocument;
};

export type RevalidateImportInput = {
  asyncImportJobId: Scalars['String']['input'];
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocument = {
  __typename?: 'RfidScanDocument';
  /** When this record was first created */
  createdAt: Scalars['DateTime']['output'];
  /** WorkSuite customer ID */
  customerId: Scalars['String']['output'];
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id: Scalars['String']['output'];
  /** WorkSuite item ID */
  itemId: Scalars['String']['output'];
  /** Location where scan occurred */
  locationId: Scalars['String']['output'];
  /** Quantity scanned (typically 1) */
  quantity: Scalars['Int']['output'];
  /** Type of RFID record */
  recordType: Scalars['Int']['output'];
  /** Client timestamp when scan was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId: Scalars['String']['output'];
  /** Date component for natural key */
  scanDate: Scalars['LocalDate']['output'];
  /** EPC - unique RFID tag identifier */
  serialId: Scalars['String']['output'];
  /** When this record was synced to external system (null = not synced) */
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocumentFilterInput = {
  and?: InputMaybe<Array<RfidScanDocumentFilterInput>>;
  /** When this record was first created */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** WorkSuite customer ID */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id?: InputMaybe<StringOperationFilterInput>;
  /** WorkSuite item ID */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Location where scan occurred */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RfidScanDocumentFilterInput>>;
  /** Quantity scanned (typically 1) */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** Type of RFID record */
  recordType?: InputMaybe<IntOperationFilterInput>;
  /** Client timestamp when scan was recorded */
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId?: InputMaybe<StringOperationFilterInput>;
  /** Date component for natural key */
  scanDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** EPC - unique RFID tag identifier */
  serialId?: InputMaybe<StringOperationFilterInput>;
  /** When this record was synced to external system (null = not synced) */
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocumentSortInput = {
  /** When this record was first created */
  createdAt?: InputMaybe<SortEnumType>;
  /** WorkSuite customer ID */
  customerId?: InputMaybe<SortEnumType>;
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id?: InputMaybe<SortEnumType>;
  /** WorkSuite item ID */
  itemId?: InputMaybe<SortEnumType>;
  /** Location where scan occurred */
  locationId?: InputMaybe<SortEnumType>;
  /** Quantity scanned (typically 1) */
  quantity?: InputMaybe<SortEnumType>;
  /** Type of RFID record */
  recordType?: InputMaybe<SortEnumType>;
  /** Client timestamp when scan was recorded */
  recordedAt?: InputMaybe<SortEnumType>;
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId?: InputMaybe<SortEnumType>;
  /** Date component for natural key */
  scanDate?: InputMaybe<SortEnumType>;
  /** EPC - unique RFID tag identifier */
  serialId?: InputMaybe<SortEnumType>;
  /** When this record was synced to external system (null = not synced) */
  syncDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** When this record was last updated */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** RFID scan input data */
export type RfidScanInputDataInput = {
  customerId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordType: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  salespersonPurchaserId: Scalars['String']['input'];
  serialId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type RfidScansConnection = {
  __typename?: 'RfidScansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RfidScansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RfidScanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RfidScansEdge = {
  __typename?: 'RfidScansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RfidScanDocument;
};

export type RoundRestockSessionOrderQuantityToFullCartInput = {
  customerLocationIds: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

export type RowImportResultInput = {
  createdEntityId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  status: AsyncImportRowStatus;
};

export type RowValidationResultInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  status: AsyncImportRowStatus;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type RoyaltyConfig = {
  __typename?: 'RoyaltyConfig';
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocument = {
  __typename?: 'RoyaltyConfigDocument';
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
  /** Document → Domain projection — the inverse of FromEvent. */
  toDomain: RoyaltyConfig;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocumentFilterInput = {
  and?: InputMaybe<Array<RoyaltyConfigDocumentFilterInput>>;
  or?: InputMaybe<Array<RoyaltyConfigDocumentFilterInput>>;
  payeeName?: InputMaybe<StringOperationFilterInput>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
  rateType?: InputMaybe<RoyaltyRateTypeOperationFilterInput>;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocumentSortInput = {
  payeeName?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  rateType?: InputMaybe<SortEnumType>;
};

export type RoyaltyConfigInput = {
  payeeName: Scalars['String']['input'];
  rate: Scalars['Decimal']['input'];
  rateType: RoyaltyRateType;
};

export enum RoyaltyRateType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type RoyaltyRateTypeOperationFilterInput = {
  eq?: InputMaybe<RoyaltyRateType>;
  in?: InputMaybe<Array<RoyaltyRateType>>;
  neq?: InputMaybe<RoyaltyRateType>;
  nin?: InputMaybe<Array<RoyaltyRateType>>;
};

/**
 * Grouping dimension for the sales-by-category data source. One row is emitted per distinct
 * value of the chosen dimension.
 */
export enum SalesByCategoryGroupBy {
  /** Group by item category (first Categories entry on the joined item). */
  Category = 'CATEGORY',
  /** Group by customer (one row per customer). */
  Customer = 'CUSTOMER',
  /** Group by billing-address region (state/province). */
  Region = 'REGION'
}

/**
 * Grouping dimension for the period-vs-period sales comparison data source.
 * One row is emitted per distinct value of the chosen dimension.
 */
export enum SalesComparisonGroupBy {
  /** Group by customer (one row per customer). */
  Customer = 'CUSTOMER',
  /** Group by item (one row per item / SKU). */
  Item = 'ITEM',
  /** Group by sales person. */
  SalesPerson = 'SALES_PERSON'
}

/** Metric selector for the period-vs-period sales comparison data source. */
export enum SalesComparisonMetric {
  /** Aggregate revenue (line-item dollar totals) per period. */
  Dollars = 'DOLLARS',
  /** Aggregate quantity (line-item unit count) per period. */
  Units = 'UNITS'
}

/**
 * Sort order for the sales comparison rows. Default is PercentChangeDesc
 * so the biggest growers/decliners surface first.
 */
export enum SalesComparisonSort {
  /** Largest negative dollar/unit delta first. */
  DeltaAsc = 'DELTA_ASC',
  /** Largest positive dollar/unit delta first. */
  DeltaDesc = 'DELTA_DESC',
  /** Group label ascending (alphabetical). */
  GroupLabelAsc = 'GROUP_LABEL_ASC',
  /** Largest negative percent change first; null percent changes last. */
  PercentChangeAsc = 'PERCENT_CHANGE_ASC',
  /** Largest positive percent change first; null percent changes last. */
  PercentChangeDesc = 'PERCENT_CHANGE_DESC',
  /** Largest Period A total first. */
  PeriodATotalDesc = 'PERIOD_A_TOTAL_DESC',
  /** Largest Period B total first. */
  PeriodBTotalDesc = 'PERIOD_B_TOTAL_DESC'
}

export type SalesPersonData = {
  __typename?: 'SalesPersonData';
  emailAddress: EmailAddressData;
};

export type SalesPersonDataFilterInput = {
  and?: InputMaybe<Array<SalesPersonDataFilterInput>>;
  emailAddress?: InputMaybe<EmailAddressDataFilterInput>;
  or?: InputMaybe<Array<SalesPersonDataFilterInput>>;
};

export type SalesPersonDataInput = {
  emailAddress: EmailAddressDataInput;
};

export type SalesPersonMapDataInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type ScalarFieldChangeProjection = {
  __typename?: 'ScalarFieldChangeProjection';
  fieldName: Scalars['String']['output'];
  hasExistingOverride: Scalars['Boolean']['output'];
  jobValue?: Maybe<Scalars['JSON']['output']>;
  recipeValue?: Maybe<Scalars['JSON']['output']>;
};

export type ScanDataInput = {
  barcode: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  scannedAt: Scalars['DateTime']['input'];
  scannedBy: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ScavengeLogConnection = {
  __typename?: 'ScavengeLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScavengeLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScavengeLogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ScavengeLogDocument = {
  __typename?: 'ScavengeLogDocument';
  checkTime: Scalars['DateTime']['output'];
  duration: Scalars['TimeSpan']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  scavengeId: Scalars['String']['output'];
  scavengeStatus?: Maybe<ScavengeStatus>;
  startTime: Scalars['DateTime']['output'];
  status: ScavengeLogStatus;
  stopRequested?: Maybe<Scalars['DateTime']['output']>;
  stopRequestedBy?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['DateTime']['output']>;
  threadCount: Scalars['Int']['output'];
};

export type ScavengeLogDocumentFilterInput = {
  and?: InputMaybe<Array<ScavengeLogDocumentFilterInput>>;
  checkTime?: InputMaybe<DateTimeOperationFilterInput>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ScavengeLogDocumentFilterInput>>;
  scavengeId?: InputMaybe<StringOperationFilterInput>;
  scavengeStatus?: InputMaybe<ScavengeStatusFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ScavengeLogStatusOperationFilterInput>;
  stopRequested?: InputMaybe<DateTimeOperationFilterInput>;
  stopRequestedBy?: InputMaybe<StringOperationFilterInput>;
  stopped?: InputMaybe<DateTimeOperationFilterInput>;
  threadCount?: InputMaybe<IntOperationFilterInput>;
};

export type ScavengeLogDocumentSortInput = {
  checkTime?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  scavengeId?: InputMaybe<SortEnumType>;
  scavengeStatus?: InputMaybe<ScavengeStatusSortInput>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  stopRequested?: InputMaybe<SortEnumType>;
  stopRequestedBy?: InputMaybe<SortEnumType>;
  stopped?: InputMaybe<SortEnumType>;
  threadCount?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ScavengeLogEdge = {
  __typename?: 'ScavengeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScavengeLogDocument;
};

export enum ScavengeLogStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type ScavengeLogStatusOperationFilterInput = {
  eq?: InputMaybe<ScavengeLogStatus>;
  in?: InputMaybe<Array<ScavengeLogStatus>>;
  neq?: InputMaybe<ScavengeLogStatus>;
  nin?: InputMaybe<Array<ScavengeLogStatus>>;
};

export type ScavengeStatus = {
  __typename?: 'ScavengeStatus';
  chunksScavenged: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  eventsDeleted: Scalars['Long']['output'];
  scavengeCompletedPercent: Scalars['Int']['output'];
  scavengeId: Scalars['String']['output'];
  scavengeResult: Scalars['String']['output'];
  spaceReclaimed: Scalars['Long']['output'];
  totalEventsScanned: Scalars['Long']['output'];
};

export type ScavengeStatusFilterInput = {
  and?: InputMaybe<Array<ScavengeStatusFilterInput>>;
  chunksScavenged?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  eventsDeleted?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ScavengeStatusFilterInput>>;
  scavengeCompletedPercent?: InputMaybe<IntOperationFilterInput>;
  scavengeId?: InputMaybe<StringOperationFilterInput>;
  scavengeResult?: InputMaybe<StringOperationFilterInput>;
  spaceReclaimed?: InputMaybe<LongOperationFilterInput>;
  totalEventsScanned?: InputMaybe<LongOperationFilterInput>;
};

export type ScavengeStatusSortInput = {
  chunksScavenged?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  eventsDeleted?: InputMaybe<SortEnumType>;
  scavengeCompletedPercent?: InputMaybe<SortEnumType>;
  scavengeId?: InputMaybe<SortEnumType>;
  scavengeResult?: InputMaybe<SortEnumType>;
  spaceReclaimed?: InputMaybe<SortEnumType>;
  totalEventsScanned?: InputMaybe<SortEnumType>;
};

export type ScheduledOrderData = {
  __typename?: 'ScheduledOrderData';
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
};

export type ScheduledOrderDataFilterInput = {
  and?: InputMaybe<Array<ScheduledOrderDataFilterInput>>;
  or?: InputMaybe<Array<ScheduledOrderDataFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
};

export type ScrapInventoryItemCommandInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

/**
 * Input for the idempotent legacy-holiday seed. The through-year caps the range (defaults to
 *             2035); the start is always the 2018 legacy floor so the historical window is never left short.
 */
export type SeedForecastHolidaysInput = {
  throughYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Outcome of a seed run: how many holidays the range produced, how many new rows were written,
 *             how many were already present (skipped), and the effective upper year.
 */
export type SeedForecastHolidaysPayload = {
  __typename?: 'SeedForecastHolidaysPayload';
  defined: Scalars['Int']['output'];
  errors?: Maybe<Array<ValidationError>>;
  requested: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  throughYear: Scalars['Int']['output'];
};

/**
 * Input for the anonymous customer-portal self-registration mutation. A self-registering buyer
 * supplies their own details plus the customer they belong to (the worksuite-pwa self-register
 * form resolves the customer for the buyer); the tenant is an explicit argument because the caller
 * is unauthenticated. The FusionAuth application + roles are NOT accepted from the caller — an
 * unauthenticated surface must not choose its own registration — they are server-determined from
 * CustomerPortalProvisioningOptions. Single-use Data type per the
 * read-model/command type-isolation convention.
 */
export type SelfRegisterPortalUserDataInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiresInDays: Scalars['Int']['input'];
  fullName: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type SellableHardgoodsConnection = {
  __typename?: 'SellableHardgoodsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SellableHardgoodsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SellableHardgoodsEdge = {
  __typename?: 'SellableHardgoodsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/**
 * Input for sendInvoiceEmail: the order id plus the compose dialog's (possibly user-edited)
 * recipients and RAW (unrendered) Handlebars subject/body — the same editable fields
 * getOrderInvoiceEmailDraft prefills. The tenant and user come from the caller's JWT (the email
 * is sent from the caller's own mailbox for the caller's own tenant), never from input.
 *
 * The three compose fields are NULLABLE on purpose. This mutation shipped as a one-field
 * { orderId } input, so making them required would break any caller still sending that shape;
 * each instead falls back server-side — recipients to every email of every AccountsPayable-typed
 * contact on the order's customer, falling back in turn to the order's own contact email when the
 * customer has none; subject/body to the seeded Invoice {{orderNumber}} defaults.
 */
export type SendInvoiceEmailInput = {
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Result of sendInvoiceEmail: whether the invoice email was sent from the caller's own
 * mailbox and the draft's Outlook draftWebLink. On success the link points at the sent message; on
 * DRAFT_CREATED_SEND_FAILED it points at the created-but-unsent draft so the user can finish it in
 * Outlook; on every other failure it is null. Errors carry the coded validation error(s) that stopped it.
 */
export type SendInvoiceEmailPayload = {
  __typename?: 'SendInvoiceEmailPayload';
  draftWebLink?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  sent: Scalars['Boolean']['output'];
};

/**
 * The senderDomainPolicy query result: the server-computed DNS/SendGrid signal the PWA uses to
 * warn before a user adds a single sender on a domain whose DNS configuration would guarantee
 * spam/quarantine treatment for an unaligned SendGrid send. Every field is null when the domain
 * could not be resolved — either it failed basic domain-format validation, or a DNS/SendGrid lookup
 * failed — so the client shows no warning rather than a false one. This fail-open behavior is
 * server-side only; it is never cached, so a transient lookup hiccup recovers on the next call.
 */
export type SenderDomainPolicyData = {
  __typename?: 'SenderDomainPolicyData';
  /**
   * The domain's DMARC enforcement policy, or null when the domain publishes no _dmarc TXT
   * record (or one without a recognized p= tag).
   */
  dmarcPolicy?: Maybe<EmailDmarcPolicy>;
  /**
   * True when the domain matches an authenticated domain on our SendGrid account (the same
   * account-wide domain-authentication lookup addTenantEmailDomain uses to grandfather an
   * already-authenticated domain). Null only on lookup failure.
   */
  isDomainAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the domain's SPF record already authorizes SendGrid to send on its behalf (an
   * include:sendgrid.net-style mechanism). Null only on lookup failure.
   */
  spfIncludesSendgrid?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the domain's SPF record ends in a hard-fail (-all) qualifier — the
   * configuration that, combined with a quarantine/reject DMARC policy, guarantees an unaligned
   * SendGrid send is rejected or quarantined. Null only on lookup failure.
   */
  spfStrict?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Session-level restock metrics aggregated server-side for the v2 Restock Orders
 * sidebar. Seven concepts (Available / Allocated / In Transit / Available for Orders
 * / On Order / Remaining Availability / Utilization %), each with a quantity and a
 * wholesale dollar value. Per-item dedup is applied to Available, Allocated, and
 * In Transit so the same item mirrored across multiple customer-location rows is
 * counted once. Per-tenant field mapping decides which ERP source backs Allocated
 * vs. In Transit. Unclamped: RemainingAvailability may be negative to
 * signal over-allocation; UtilizationPercent returns a large sentinel
 * (9999.0) when AvailableForOrders <= 0 and OnOrder > 0.
 */
export type SessionRestockMetricsData = {
  __typename?: 'SessionRestockMetricsData';
  allocated: Scalars['Int']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableForOrders: Scalars['Int']['output'];
  availableForOrdersValue: Scalars['Decimal']['output'];
  availableValue: Scalars['Decimal']['output'];
  inTransit: Scalars['Int']['output'];
  inTransitValue: Scalars['Decimal']['output'];
  onOrder: Scalars['Int']['output'];
  onOrderValue: Scalars['Decimal']['output'];
  remainingAvailability: Scalars['Int']['output'];
  remainingAvailabilityValue: Scalars['Decimal']['output'];
  sessionId: Scalars['String']['output'];
  utilizationPercent: Scalars['Decimal']['output'];
  utilizationPercentValue: Scalars['Decimal']['output'];
};

export type SetAccountingIntegrationConfigInput = {
  defaultIncomeAccountName?: InputMaybe<Scalars['String']['input']>;
  defaultIncomeAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  mergeDevAccountId?: InputMaybe<Scalars['String']['input']>;
  outboundDetail: OutboundDetailLevel;
  provider: AccountingProvider;
};

export type SetActiveCountSessionInput = {
  activeCountSessionId: Scalars['String']['input'];
  productionLineId: Scalars['String']['input'];
};

export type SetBackgroundServiceEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  serviceName: BackgroundServiceName;
};

export type SetBpfUserStartingNodesInput = {
  startingNodes: Array<BpfStartingNodeDataInput>;
  userId: Scalars['String']['input'];
};

export type SetCategoryLaborCostInput = {
  effectiveDate: Scalars['DateTime']['input'];
  laborCostPerUnit: Scalars['Decimal']['input'];
  productionCategoryId: Scalars['String']['input'];
};

export type SetCheckpointInput = {
  checkpointType: CheckpointType;
  externalId: Scalars['String']['input'];
};

export type SetCommissionDefaultRateInput = {
  newRatePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

export type SetConsolidationRuleSetInput = {
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['input'];
  lookForwardWeeks: Scalars['Int']['input'];
  minimumLotQuantity: Scalars['Int']['input'];
  roundingUnit?: InputMaybe<Scalars['Int']['input']>;
};

export type SetContactCrmLinkInput = {
  contactId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  importId: Scalars['String']['input'];
};

export type SetCountSessionTargetInput = {
  countSessionId: Scalars['String']['input'];
  newTargetQuantity: Scalars['Decimal']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerCommissionOverrideInput = {
  customerId: Scalars['String']['input'];
  ratePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

export type SetCustomerCrmLinkInput = {
  crmImportId: Scalars['String']['input'];
  crmRecordUrl?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerDepositRequirementInput = {
  customerId: Scalars['String']['input'];
  depositRequirementType?: InputMaybe<DepositRequirementType>;
  depositRequirementValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerItemEffectiveDatesInput = {
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetCustomerItemRetailPriceInput = {
  customerItemId: Scalars['String']['input'];
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerLocationNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerLocationServicingSiteInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  servicingSiteLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerTypeInput = {
  customerId: Scalars['String']['input'];
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerTypeRevenueGlAccountInput = {
  id: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type SetDefaultGroupInput = {
  id: Scalars['String']['input'];
};

export type SetDefaultVendorInput = {
  id: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type SetEmailSenderAdminOnlyInput = {
  adminOnly: Scalars['Boolean']['input'];
  senderId: Scalars['String']['input'];
};

export type SetGlobalValueInput = {
  config: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: FeatureFlagName;
};

export type SetInventoryItemInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  itemType: ItemType;
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

export type SetInventoryItemReadyDateCommandInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  readyDate: Scalars['LocalDate']['input'];
  why: Scalars['String']['input'];
};

export type SetItemContainerConfigOverrideInput = {
  containerCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  maxLayersPerContainer?: InputMaybe<Scalars['Int']['input']>;
  maxTraysPerLayer?: InputMaybe<Scalars['Int']['input']>;
  shipFactor?: InputMaybe<Scalars['Int']['input']>;
  shipMinimum?: InputMaybe<Scalars['Int']['input']>;
  shippingConfigCategoryCode: Scalars['String']['input'];
  siteCode: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type SetItemLaborCostInput = {
  effectiveDate: Scalars['DateTime']['input'];
  laborCostPerUnit: Scalars['Decimal']['input'];
  productionItemId: Scalars['String']['input'];
};

export type SetItemNoteInput = {
  context: NoteContext;
  itemId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetItemProductionMappingsInput = {
  lines: Array<ProductionMappingLineDataInput>;
  salesItemId: Scalars['String']['input'];
};

export type SetJobGrowWeeksOverrideDataInput = {
  growWeeks: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetJobLinksOverrideDataInput = {
  linkId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetJobPlannedHoursOverrideDataInput = {
  plannedHours: Scalars['Decimal']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type SetJobPlantsPerPotOverrideDataInput = {
  plantsPerPot: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetLaborTypesInput = {
  laborTypes: Array<LaborTypeDataInput>;
  siteLocationId: Scalars['String']['input'];
};

export type SetLineItemOverridePriceInput = {
  lineItemId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetLocationOverheadRateInput = {
  costPerSqFtPerWeek: Scalars['Decimal']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Boundary input for setMyLanguagePreference: the caller's own new language preference (EN or
 * ES) for the Work Suite UI. There is deliberately NO userId — the target is always the authenticated
 * caller's own directory entry (mirrors SetMyProfileImageData — no admin-sets-others in v1).
 * An out-of-schema enum literal is rejected by GraphQL at request-validation time before this
 * resolver even runs; the domain-level ValidLanguagePreference type is the backstop for any
 * other caller of the command.
 */
export type SetMyLanguagePreferenceDataInput = {
  languagePreference: LanguagePreference;
};

/**
 * Boundary input for setMyProfileImage: the caller's own avatar bytes (Base64) plus MIME type.
 * Both fields are nullable so the input stays additive; presence, format (jpeg/png/webp) and size
 * (<= 5 MB) are enforced during validation (ValidImageUpload). There is deliberately
 * NO userId — the target is always the authenticated caller's own directory entry (no admin-sets-others
 * in v1). Single-use Data type per the command/read-model type-isolation convention.
 */
export type SetMyProfileImageDataInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
};

/** Sets one doc-type's routed contact type. Uses the real generated enums on the wire. */
export type SetOrderEmailRecipientRoutingInput = {
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

export type SetOrderEmailSettingsInput = {
  docType: OrderEmailDocType;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  includeSalesPersonCc?: Scalars['Boolean']['input'];
  includeServicingSiteManagerCc?: Scalars['Boolean']['input'];
  recipients: Array<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderNoteInput = {
  context: NoteContext;
  orderId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderShipFromSiteInput = {
  orderId: Scalars['String']['input'];
  shipFromSiteLocationId: Scalars['String']['input'];
};

export type SetOrderfulApiKeySecretNameInput = {
  orderfulApiKeySecretName?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderfulIntegrationMappingInput = {
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderfulIntegrationStatusInput = {
  status: OrderfulIntegrationStatus;
};

export type SetOrderfulOrganizationIsaIdsInput = {
  organizationIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SetPodAssignmentReplicasInput = {
  podName: Scalars['String']['input'];
  replicaCount: Scalars['Int']['input'];
  serviceName: BackgroundServiceName;
};

export type SetPriceGroupDerivationInput = {
  derivedFromPriceGroupId?: InputMaybe<Scalars['String']['input']>;
  derivedPercentOff?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
};

export type SetPriceGroupOrderVolumeDiscountInput = {
  id: Scalars['String']['input'];
  thresholdType?: InputMaybe<OrderVolumeThresholdType>;
  thresholdValue?: InputMaybe<Scalars['Decimal']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  valueType?: InputMaybe<OrderVolumeDiscountValueType>;
};

export type SetProductionJobPropagationYieldDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  propagationYield: Scalars['Decimal']['input'];
};

/**
 * Input for worker to set resolved entity IDs after successful lookups.
 * Merges IDs into existing row data without modifying user-provided values.
 */
export type SetProductionLotAsyncImportJobRowIdsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowIdsInput>;
};

export type SetPurchaseOrderUrgentInput = {
  isUrgent: Scalars['Boolean']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type SetRecipeLaborSourceInput = {
  laborSource: RecipeLaborSource;
  productionRecipeId: Scalars['String']['input'];
};

export type SetRecipeTaskEventIdsInput = {
  productionRecipeId: Scalars['String']['input'];
  taskEventIds: Array<Scalars['String']['input']>;
};

export type SetReportScheduleEmailSettingsInput = {
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['String']['input'];
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type SetRestockSessionOrderQuantitiesInput = {
  items: Array<SetRestockSessionOrderQuantityItemDataInput>;
  sessionId: Scalars['String']['input'];
};

export type SetRestockSessionOrderQuantityItemDataInput = {
  customerLocationId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
};

export type SetSiteContactsInput = {
  contacts: Array<SiteContactDataInput>;
  siteLocationId: Scalars['String']['input'];
};

export type SetSiteLaborRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  laborTypeId: Scalars['String']['input'];
  ratePerHour: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

/**
 * Input for worker to set resolved entity IDs after successful lookups.
 * Merges IDs into existing row data without modifying user-provided values.
 */
export type SetSiteLocationAsyncImportJobRowIdsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowIdsInput>;
};

export type SetSiteTimeZoneInput = {
  siteLocationId: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type SetSpaceCapacityWindowInput = {
  amount: Scalars['Decimal']['input'];
  endWeek: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reliefFraction: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  subLocationId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SetSpaceCategorySiteOverrideInput = {
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type SetSpaceDimensionOverrideInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type SetStoreClassesInput = {
  storeClasses: Array<StoreClassEntryInput>;
};

export type SetTaskEventDirectCostInput = {
  costPerEvent: Scalars['Decimal']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  productionTaskEventId: Scalars['String']['input'];
};

export type SetTaskEventLaborTypeTagInput = {
  laborTypeTagId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type SetTaskEventThroughputInput = {
  productionTaskEventId: Scalars['String']['input'];
  unitsPerHour: Scalars['Decimal']['input'];
};

export type SetTenantBillingRateCardInput = {
  annualAmount?: InputMaybe<Scalars['Long']['input']>;
  currency?: Scalars['String']['input'];
  monthlyAmount?: InputMaybe<Scalars['Long']['input']>;
  quarterlyAmount?: InputMaybe<Scalars['Long']['input']>;
};

export type SetTenantDefaultCarrierInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantDefaultEmailSenderInput = {
  senderId: Scalars['String']['input'];
};

export type SetTenantDefaultRouteInput = {
  route?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantOverridesInput = {
  name: FeatureFlagName;
  tenantOverrides: Array<TenantOverrideDataInput>;
};

/**
 * Input for setTenantSmtpConnection. The plaintext password is encrypted server-side before
 * any event is written and is never stored or echoed back. The tenant is taken from the caller's JWT.
 */
export type SetTenantSmtpConnectionInput = {
  /** Gets the configured from-address list. */
  addresses: Array<SmtpSenderAddressInput>;
  /** Gets the from-mode governing which addresses are usable. */
  fromMode: SmtpFromMode;
  /** Gets the SMTP server host. */
  host: Scalars['String']['input'];
  /** Gets the plaintext SMTP AUTH password (encrypted at rest server-side; never returned). */
  password: Scalars['String']['input'];
  /** Gets the SMTP server port (587 STARTTLS by convention). */
  port: Scalars['Int']['input'];
  /** Gets the SMTP AUTH username. */
  username: Scalars['String']['input'];
};

export type SetTenantTaxDefaultAuthoritiesInput = {
  defaultAuthorityIds: Array<Scalars['String']['input']>;
};

export type SetVendorMaterialCostInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  materialItemId: Scalars['String']['input'];
  unitCost: Scalars['Decimal']['input'];
  vendorId: Scalars['String']['input'];
};

export type SetWorkOrderLineNumberInput = {
  jobId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
};

export type SetWorkerConfigRunNowInput = {
  configName: Scalars['String']['input'];
  runNow: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
};

export type SetWsapiImportRunNowInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type SftpSystemSettingsPayload = {
  __typename?: 'SftpSystemSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<SftpSystemSettingsStateData>;
};

export type SftpSystemSettingsStateData = {
  __typename?: 'SftpSystemSettingsStateData';
  enabled: Scalars['Boolean']['output'];
  timerPeriodString: Scalars['String']['output'];
};

export type SftpTenantConfigDocument = {
  __typename?: 'SftpTenantConfigDocument';
  batchSize: Scalars['Int']['output'];
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  destinations: Array<DestinationConfigData>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mongoDestinations: Array<MongoDestinationDocumentData>;
  podId: Scalars['String']['output'];
  source: SourceConfigData;
  status: SftpTenantConfigStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type SftpTenantConfigDocumentFilterInput = {
  and?: InputMaybe<Array<SftpTenantConfigDocumentFilterInput>>;
  batchSize?: InputMaybe<IntOperationFilterInput>;
  configId?: InputMaybe<StringOperationFilterInput>;
  configName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  destinations?: InputMaybe<ListFilterInputTypeOfDestinationConfigDataFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  mongoDestinations?: InputMaybe<ListFilterInputTypeOfMongoDestinationDocumentDataFilterInput>;
  or?: InputMaybe<Array<SftpTenantConfigDocumentFilterInput>>;
  podId?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<SourceConfigDataFilterInput>;
  status?: InputMaybe<SftpTenantConfigStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SftpTenantConfigDocumentSortInput = {
  batchSize?: InputMaybe<SortEnumType>;
  configId?: InputMaybe<SortEnumType>;
  configName?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  podId?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SourceConfigDataSortInput>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type SftpTenantConfigPayload = {
  __typename?: 'SftpTenantConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  sftpTenantConfig?: Maybe<SftpTenantConfigDocument>;
};

export type SftpTenantConfigStateData = {
  __typename?: 'SftpTenantConfigStateData';
  batchSize: Scalars['Int']['output'];
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  destinations: Array<DestinationConfigData>;
  enabled: Scalars['Boolean']['output'];
  mongoDestinations: Array<MongoDestinationConfigData>;
  podId: Scalars['String']['output'];
  source: SourceConfigData;
  status: SftpTenantConfigStatus;
  tenantId: Scalars['String']['output'];
};

export enum SftpTenantConfigStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type SftpTenantConfigStatusOperationFilterInput = {
  eq?: InputMaybe<SftpTenantConfigStatus>;
  in?: InputMaybe<Array<SftpTenantConfigStatus>>;
  neq?: InputMaybe<SftpTenantConfigStatus>;
  nin?: InputMaybe<Array<SftpTenantConfigStatus>>;
};

/** A connection to a list of items. */
export type SftpTenantConfigsConnection = {
  __typename?: 'SftpTenantConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SftpTenantConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SftpTenantConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SftpTenantConfigsEdge = {
  __typename?: 'SftpTenantConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SftpTenantConfigDocument;
};

export type ShipFromLocationData = {
  __typename?: 'ShipFromLocationData';
  name: Scalars['String']['output'];
};

export type ShipFromLocationDataInput = {
  name: Scalars['String']['input'];
};

/**
 * Input record for shipMovementOrder. ShippedLines must replay the
 * full Created snapshot (same LineItemId set, same MaterialItemId per line);
 * quantities may differ.
 */
export type ShipMovementOrderInput = {
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  shippedLines: Array<MovementOrderLineInput>;
};

export type ShipPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type ShopperData = {
  __typename?: 'ShopperData';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ShoppingCartCustomerData = {
  __typename?: 'ShoppingCartCustomerData';
  billToAddress: CartAddressData;
  customerId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shipToAddress: CartAddressData;
  shopper: ShopperData;
};

export type ShoppingCartItemData = {
  __typename?: 'ShoppingCartItemData';
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ShoppingCartPayload = {
  __typename?: 'ShoppingCartPayload';
  errors?: Maybe<Array<ValidationError>>;
  shoppingCart?: Maybe<ShoppingCartStateData>;
};

export type ShoppingCartStateData = {
  __typename?: 'ShoppingCartStateData';
  cartId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: ShoppingCartCustomerData;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  items: Array<ShoppingCartItemData>;
  shopperId: Scalars['String']['output'];
  status: ShoppingCartStatus;
  tenantId: Scalars['String']['output'];
};

export enum ShoppingCartStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Empty = 'EMPTY',
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

export type ShrinkEvent = {
  __typename?: 'ShrinkEvent';
  date: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  shrinkEventId: Scalars['String']['output'];
  shrinkType: ShrinkType;
};

export enum ShrinkType {
  Disease = 'DISEASE',
  EnvironmentalLoss = 'ENVIRONMENTAL_LOSS',
  Other = 'OTHER',
  Overproduction = 'OVERPRODUCTION',
  QualityIssue = 'QUALITY_ISSUE'
}

export type ShrinkTypeOperationFilterInput = {
  eq?: InputMaybe<ShrinkType>;
  in?: InputMaybe<Array<ShrinkType>>;
  neq?: InputMaybe<ShrinkType>;
  nin?: InputMaybe<Array<ShrinkType>>;
};

export type SignatureImageData = {
  __typename?: 'SignatureImageData';
  dateCaptured: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  image: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mime: Scalars['String']['output'];
};

export type SignatureImageDataFilterInput = {
  and?: InputMaybe<Array<SignatureImageDataFilterInput>>;
  dateCaptured?: InputMaybe<DateTimeOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  mime?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SignatureImageDataFilterInput>>;
};

export type SignatureImageDataSortInput = {
  dateCaptured?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  image?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  mime?: InputMaybe<SortEnumType>;
};

export type SiteContactDataInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: SiteContactRole;
};

/** A named contact stored within a site location document. */
export type SiteContactDocumentData = {
  __typename?: 'SiteContactDocumentData';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  role: SiteContactRole;
};

/** A named contact stored within a site location document. */
export type SiteContactDocumentDataFilterInput = {
  and?: InputMaybe<Array<SiteContactDocumentDataFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteContactDocumentDataFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<SiteContactRoleOperationFilterInput>;
};

export enum SiteContactRole {
  Dispatch = 'DISPATCH',
  Manager = 'MANAGER',
  Unknown = 'UNKNOWN'
}

export type SiteContactRoleOperationFilterInput = {
  eq?: InputMaybe<SiteContactRole>;
  in?: InputMaybe<Array<SiteContactRole>>;
  neq?: InputMaybe<SiteContactRole>;
  nin?: InputMaybe<Array<SiteContactRole>>;
};

export type SiteContactStateData = {
  __typename?: 'SiteContactStateData';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  role: SiteContactRole;
};

/** Labor rate data for a specific labor type at a site location. */
export type SiteLaborRateDocumentData = {
  __typename?: 'SiteLaborRateDocumentData';
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
};

/** Labor rate data for a specific labor type at a site location. */
export type SiteLaborRateDocumentDataFilterInput = {
  and?: InputMaybe<Array<SiteLaborRateDocumentDataFilterInput>>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  laborTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLaborRateDocumentDataFilterInput>>;
  ratePerHour?: InputMaybe<DecimalOperationFilterInput>;
};

export type SiteLaborRateStateData = {
  __typename?: 'SiteLaborRateStateData';
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
};

export type SiteLocationAsyncImportJobRow = {
  __typename?: 'SiteLocationAsyncImportJobRow';
  capacity?: Maybe<Scalars['Decimal']['output']>;
  createdEntityId?: Maybe<Scalars['String']['output']>;
  erpId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationStatus: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentLocationId?: Maybe<Scalars['String']['output']>;
  parentRef: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  status: AsyncImportRowStatus;
  warning?: Maybe<Scalars['String']['output']>;
};

export type SiteLocationAsyncImportJobRowFilterInput = {
  and?: InputMaybe<Array<SiteLocationAsyncImportJobRowFilterInput>>;
  capacity?: InputMaybe<DecimalOperationFilterInput>;
  createdEntityId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationStatus?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLocationAsyncImportJobRowFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  parentRef?: InputMaybe<StringOperationFilterInput>;
  rowIndex?: InputMaybe<IntOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AsyncImportRowStatusOperationFilterInput>;
  warning?: InputMaybe<StringOperationFilterInput>;
};

export type SiteLocationAsyncImportJobRowSortInput = {
  capacity?: InputMaybe<SortEnumType>;
  createdEntityId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationStatus?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  parentRef?: InputMaybe<SortEnumType>;
  rowIndex?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  warning?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SiteLocationAsyncImportJobRowsConnection = {
  __typename?: 'SiteLocationAsyncImportJobRowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteLocationAsyncImportJobRowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationAsyncImportJobRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteLocationAsyncImportJobRowsEdge = {
  __typename?: 'SiteLocationAsyncImportJobRowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationAsyncImportJobRow;
};

export type SiteLocationBulkActionPayload = {
  __typename?: 'SiteLocationBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteLocations?: Maybe<Array<SiteLocationPayload>>;
};

export type SiteLocationDocument = {
  __typename?: 'SiteLocationDocument';
  address?: Maybe<AddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * Labor rates configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — same as LaborTypes above).
   */
  laborRates: Array<SiteLaborRateDocumentData>;
  /**
   * Labor types configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — MongoDB deserializes missing arrays as null,
   * and the default initializer handles it).
   */
  laborTypes: Array<LaborTypeDocumentData>;
  name: Scalars['String']['output'];
  /**
   * Named contacts at this site. Empty for every site that has never had contacts set.
   * Ordering is not significant — a resubmission differing only in order is absorbed as a no-op.
   */
  siteContacts: Array<SiteContactDocumentData>;
  siteLocationId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: Maybe<Scalars['String']['output']>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance: TimeZoneProvenance;
  updated: Scalars['DateTime']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type SiteLocationDocumentFilterInput = {
  address?: InputMaybe<AddressDataFilterInput>;
  and?: InputMaybe<Array<SiteLocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Labor rates configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — same as LaborTypes above).
   */
  laborRates?: InputMaybe<ListFilterInputTypeOfSiteLaborRateDocumentDataFilterInput>;
  /**
   * Labor types configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — MongoDB deserializes missing arrays as null,
   * and the default initializer handles it).
   */
  laborTypes?: InputMaybe<ListFilterInputTypeOfLaborTypeDocumentDataFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLocationDocumentFilterInput>>;
  /**
   * Named contacts at this site. Empty for every site that has never had contacts set.
   * Ordering is not significant — a resubmission differing only in order is absorbed as a no-op.
   */
  siteContacts?: InputMaybe<ListFilterInputTypeOfSiteContactDocumentDataFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: InputMaybe<StringOperationFilterInput>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance?: InputMaybe<TimeZoneProvenanceOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SiteLocationDocumentSortInput = {
  address?: InputMaybe<AddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: InputMaybe<SortEnumType>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * Resolved entity IDs set by the worker after successful lookups.
 * For Site rows, only SiteLocationId is set (the new or matched site id).
 * For SubLocation rows, all three IDs are set: the owning site, the resolved parent (if
 * the parent is itself a sub-location), and the sub-location's own id.
 */
export type SiteLocationImportRowIdsInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * User-provided field values during upload or correction.
 * Does not include resolved IDs - those are set separately by the worker.
 * Converted to SiteLocationImportRowData via named init-only assignment so
 * adjacent string columns cannot be silently swapped at the boundary.
 */
export type SiteLocationImportRowValuesInput = {
  capacity?: InputMaybe<Scalars['Decimal']['input']>;
  erpId: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  locationStatus: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentRef: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
};

export type SiteLocationPayload = {
  __typename?: 'SiteLocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteLocation?: Maybe<SiteLocationStateData>;
};

/**
 * Per-row failure surfaced by validateSiteLocationsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type SiteLocationStagedRowError = {
  __typename?: 'SiteLocationStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type SiteLocationStateData = {
  __typename?: 'SiteLocationStateData';
  address?: Maybe<AddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborRates: Array<SiteLaborRateStateData>;
  laborRatesHistory: Array<SiteLaborRateStateData>;
  laborTypes: Array<LaborTypeStateData>;
  locations: Array<LocationStateData>;
  name: Scalars['String']['output'];
  overheadRate?: Maybe<OverheadRateStateData>;
  overheadRates: Array<OverheadRateHistoryStateData>;
  siteContacts: Array<SiteContactStateData>;
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneProvenance: TimeZoneProvenance;
  updated: Scalars['DateTime']['output'];
};

export enum SiteLocationType {
  Aisle = 'AISLE',
  Bay = 'BAY',
  Bin = 'BIN',
  Field = 'FIELD',
  House = 'HOUSE',
  Row = 'ROW',
  Section = 'SECTION',
  ShipTo = 'SHIP_TO',
  Unknown = 'UNKNOWN',
  Warehouse = 'WAREHOUSE'
}

export type SiteLocationTypeOperationFilterInput = {
  eq?: InputMaybe<SiteLocationType>;
  in?: InputMaybe<Array<SiteLocationType>>;
  neq?: InputMaybe<SiteLocationType>;
  nin?: InputMaybe<Array<SiteLocationType>>;
};

export type SiteLocationTypeRelationships = {
  __typename?: 'SiteLocationTypeRelationships';
  childToParents: Array<ChildParentRelationship>;
  parentToChildren: Array<ParentChildRelationship>;
  rootTypes: Array<SiteLocationType>;
};

/** A connection to a list of items. */
export type SiteLocationsConnection = {
  __typename?: 'SiteLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteLocationsEdge = {
  __typename?: 'SiteLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationDocument;
};

/**
 * Export-precondition coverage for a forecast: over the grid of the forecast customer's locations by the
 * forecast's programs, which location-and-program pairs still lack a site map. A missing mapping hard-
 * blocks the weekly site fan-out, so the plan-grid export badge (spec P10/P12) reads the isComplete flag
 * and lists the gaps so an operator can resolve them. An excluded mapping (excludeFromDistribution) is a
 * resolved decision, not a gap, so it counts as covered. A well-formed forecast whose scope is fully
 * mapped — or whose customer has no locations or the forecast has no programs — returns an empty gap list
 * with isComplete true (an empty list is a valid, complete result, never an error).
 */
export type SiteMapCoverage = {
  __typename?: 'SiteMapCoverage';
  /** The forecast this coverage was computed for. */
  forecastId: Scalars['String']['output'];
  /** Number of pairs in scope with no site map — the export-blocking gaps. */
  gapCount: Scalars['Int']['output'];
  /** The unmapped location-and-program pairs, each carrying its location display fields. */
  gaps: Array<SiteMapCoverageGap>;
  /** True when every pair in scope is mapped (no export-blocking gaps remain). */
  isComplete: Scalars['Boolean']['output'];
  /** Number of pairs in scope that have an active site map (mapped, including excluded mappings). */
  mappedPairs: Scalars['Int']['output'];
  /** Number of location-and-program pairs in the forecast scope (locations × programs). */
  totalPairs: Scalars['Int']['output'];
};

/**
 * A single unmapped location-and-program pair for a forecast — one row of the coverage badge/panel. The
 * location display fields are denormalized from the customer location so the UI can render the gap
 * without a second lookup.
 */
export type SiteMapCoverageGap = {
  __typename?: 'SiteMapCoverageGap';
  /** The customer location id (matches CustomerLocation.LocationId) that lacks a mapping. */
  customerLocationId: Scalars['String']['output'];
  /** Display name of the customer location. */
  locationName: Scalars['String']['output'];
  /** The forecast program id the location is unmapped for. */
  programId: Scalars['String']['output'];
  /** Region of the customer location. */
  region: Scalars['String']['output'];
  /** Store number of the customer location. */
  storeNumber: Scalars['String']['output'];
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocument = {
  __typename?: 'SiteMapDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLocationId: Scalars['String']['output'];
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  programId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  siteMapId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocumentFilterInput = {
  and?: InputMaybe<Array<SiteMapDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SiteMapDocumentFilterInput>>;
  programId?: InputMaybe<StringOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  siteMapId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  programId?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  siteMapId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type SiteMapPayload = {
  __typename?: 'SiteMapPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteMap?: Maybe<SiteMapStateData>;
};

/**
 * GraphQL output shape returned by the site map mutations (create/update/delete). Mirrors the
 * aggregate state after the command applied.
 */
export type SiteMapStateData = {
  __typename?: 'SiteMapStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLocationId: Scalars['String']['output'];
  excludeFromDistribution: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  programId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  siteMapId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SiteMapsConnection = {
  __typename?: 'SiteMapsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteMapsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteMapDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteMapsEdge = {
  __typename?: 'SiteMapsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteMapDocument;
};

export type SizeUomDocument = {
  __typename?: 'SizeUomDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eachesPerUnit: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  status: SizeUomStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type SizeUomDocumentFilterInput = {
  and?: InputMaybe<Array<SizeUomDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  eachesPerUnit?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SizeUomDocumentFilterInput>>;
  status?: InputMaybe<SizeUomStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type SizeUomDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  eachesPerUnit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type SizeUomPayload = {
  __typename?: 'SizeUomPayload';
  errors?: Maybe<Array<ValidationError>>;
  sizeUom?: Maybe<SizeUomStateData>;
};

export type SizeUomStateData = {
  __typename?: 'SizeUomStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eachesPerUnit: Scalars['Int']['output'];
  sizeUomId: Scalars['String']['output'];
  status: SizeUomStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum SizeUomStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type SizeUomStatusOperationFilterInput = {
  eq?: InputMaybe<SizeUomStatus>;
  in?: InputMaybe<Array<SizeUomStatus>>;
  neq?: InputMaybe<SizeUomStatus>;
  nin?: InputMaybe<Array<SizeUomStatus>>;
};

/** A connection to a list of items. */
export type SizeUomsConnection = {
  __typename?: 'SizeUomsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SizeUomsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SizeUomDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SizeUomsEdge = {
  __typename?: 'SizeUomsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SizeUomDocument;
};

/** Input for skipAssignmentTask. */
export type SkipAssignmentTaskInput = {
  assignmentId: Scalars['String']['input'];
  binLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMapping = {
  __typename?: 'SkuUpcMapping';
  additionalSkus: Array<Scalars['String']['output']>;
  additionalUpcs: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerItemId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationName: Scalars['String']['output'];
  /** @deprecated Use retailShelfPrice. Will be removed in next release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPriceCurrency?: Maybe<Scalars['String']['output']>;
  sizeUomCode?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: CustomerItemStatus;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMappingFilterInput = {
  additionalSkus?: InputMaybe<ListStringOperationFilterInput>;
  additionalUpcs?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<SkuUpcMappingFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerItemId?: InputMaybe<StringOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveUntil?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SkuUpcMappingFilterInput>>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  retailShelfPriceCurrency?: InputMaybe<StringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CustomerItemStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMappingSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerItemId?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveUntil?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  retailPrice?: InputMaybe<SortEnumType>;
  retailShelfPriceCurrency?: InputMaybe<SortEnumType>;
  sizeUomCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SkuUpcMappingsConnection = {
  __typename?: 'SkuUpcMappingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SkuUpcMappingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SkuUpcMappingsEdge = {
  __typename?: 'SkuUpcMappingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

export enum SmtpConnectionStatus {
  Failed = 'FAILED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export enum SmtpFromMode {
  AnyWithList = 'ANY_WITH_LIST',
  DefinedList = 'DEFINED_LIST',
  SingleAccount = 'SINGLE_ACCOUNT'
}

/** GraphQL view of one configured SMTP from-address. */
export type SmtpSenderAddressData = {
  __typename?: 'SmtpSenderAddressData';
  /**
   * Gets whether this address is restricted to admin callers (Decision D). Defaults to false
   * (anyone-can-send).
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
};

/** Input for one configured SMTP from-address. Display name is optional (defaults to the email). */
export type SmtpSenderAddressInput = {
  /**
   * Gets whether this address is restricted to admin callers (Decision D). Nullable so existing
   * callers that predate this field can omit it; null and false are both treated as
   * anyone-can-send.
   */
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gets the optional friendly from-name. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Gets the from-address. */
  email: Scalars['String']['input'];
};

export type SortColumnInput = {
  colId: Scalars['String']['input'];
  sort: Scalars['String']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceConfigData = {
  __typename?: 'SourceConfigData';
  directory: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  filePattern: Scalars['String']['output'];
  password: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SourceConfigDataFilterInput = {
  and?: InputMaybe<Array<SourceConfigDataFilterInput>>;
  directory?: InputMaybe<StringOperationFilterInput>;
  endpoint?: InputMaybe<StringOperationFilterInput>;
  filePattern?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SourceConfigDataFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  port?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type SourceConfigDataSortInput = {
  directory?: InputMaybe<SortEnumType>;
  endpoint?: InputMaybe<SortEnumType>;
  filePattern?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  port?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

/**
 * A capacity row with the same fields as a `SpaceCapacityRow` row (so names and capacity-derived
 * fields resolve through the same GraphQL type resolvers), annotated with the what-if before/after
 * math. The row's `totalUsed` carries the after-move value.
 */
export type SpaceCapacityPreviewRow = {
  __typename?: 'SpaceCapacityPreviewRow';
  remainingAfter: Scalars['Decimal']['output'];
  row: SpaceCapacityRow;
  usedAfter: Scalars['Decimal']['output'];
  usedBefore: Scalars['Decimal']['output'];
};

export type SpaceCapacityRow = {
  __typename?: 'SpaceCapacityRow';
  byProductionPlan: Array<SpacePlanLoad>;
  bySpaceType: Array<SpaceTypeUtilization>;
  /**
   * Whether a capacity window (year-specific or recurring) or a positive flat fallback resolved for
   * this row's (sub-location, space type, ISO year/week). False = uncovered: `totalAvailable` 0 and
   * `capacityPct` null, but the demand row is retained and flagged.
   */
  capacityCovered: Scalars['Boolean']['output'];
  /**
   * Utilization as a percentage of resolved capacity, or null when no capacity is configured for this
   * (sub-location, space type, ISO year/week) — i.e. `capacityCovered` is false. Demand still renders;
   * the UI flags the null as uncovered rather than dropping the row (legacy silently dropped uncovered
   * demand).
   */
  capacityPct?: Maybe<Scalars['Decimal']['output']>;
  isoWeek: Scalars['Int']['output'];
  isoYear: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  remaining: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  siteLocationName: Scalars['String']['output'];
  spaceTypeCode: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAvailable: Scalars['Decimal']['output'];
  totalUsed: Scalars['Decimal']['output'];
  trendBuckets: Array<SpaceTrendBucket>;
};

export enum SpaceCapacitySource {
  FlatFallback = 'FLAT_FALLBACK',
  None = 'NONE',
  RecurringWindow = 'RECURRING_WINDOW',
  YearWindow = 'YEAR_WINDOW'
}

/** A row whose after-move usage exceeds its sub-location capacity. */
export type SpaceCapacityViolation = {
  __typename?: 'SpaceCapacityViolation';
  capacity: Scalars['Decimal']['output'];
  isoWeek: Scalars['Int']['output'];
  isoYear: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  overBy: Scalars['Decimal']['output'];
  productionPlanId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  usedAfter: Scalars['Decimal']['output'];
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocument = {
  __typename?: 'SpaceCapacityWindowDocument';
  amount: Scalars['Decimal']['output'];
  endWeek: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reliefFraction: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  startWeek: Scalars['Int']['output'];
  subLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: Maybe<Scalars['Int']['output']>;
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<SpaceCapacityWindowDocumentFilterInput>>;
  endWeek?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SpaceCapacityWindowDocumentFilterInput>>;
  reliefFraction?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  spaceTypeId?: InputMaybe<StringOperationFilterInput>;
  startWeek?: InputMaybe<IntOperationFilterInput>;
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: InputMaybe<IntOperationFilterInput>;
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocumentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  endWeek?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  reliefFraction?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  spaceTypeId?: InputMaybe<SortEnumType>;
  startWeek?: InputMaybe<SortEnumType>;
  subLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SpaceCapacityWindowsConnection = {
  __typename?: 'SpaceCapacityWindowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SpaceCapacityWindowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SpaceCapacityWindowDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SpaceCapacityWindowsEdge = {
  __typename?: 'SpaceCapacityWindowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpaceCapacityWindowDocument;
};

export type SpaceCategoryDimensionsData = {
  __typename?: 'SpaceCategoryDimensionsData';
  length: Scalars['Decimal']['output'];
  stagger: Scalars['Boolean']['output'];
  width: Scalars['Decimal']['output'];
};

/**
 * One group header for the Space Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionSpaceEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type SpaceEventGroupBucket = {
  __typename?: 'SpaceEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for spaceEventGroups. Mirrors the Space Events sidebar's group-by options
 * so the client can render server-computed group headers instead of grouping the full event list in
 * memory: Status buckets on the event lifecycle status, Name buckets on the event name.
 * Both are flat scalar fields on ProductionSpaceEventDocument.
 */
export enum SpaceEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Deleted / Unknown). */
  Status = 'STATUS'
}

/**
 * One staged what-if move for the spaceUtilizationPreview query: relocate a production job to a new
 * sub-location and/or shift its week start. Both targets are optional — a null toLocationId keeps the
 * job's current location and a null toWeekStartIso keeps its current week start. toWeekStartIso is an
 * ISO-8601 date (any day within the target ISO week; normalized to its ISO week/year). The optional
 * staged-against baseline (stagedLocationId / stagedWeekStartIso) is what the client captured when
 * the move was staged; the preview compares it to the job's current location/week to flag
 * changedSinceStaged. No write ever touches ProductionJob.SpaceDimensions.
 */
export type SpaceMoveInput = {
  lotId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  stagedLocationId?: InputMaybe<Scalars['String']['input']>;
  stagedWeekStartIso?: InputMaybe<Scalars['String']['input']>;
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toWeekStartIso?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Validity and staleness for a single staged move. `isValid` is the AND of
 * job-exists, not-archived, target-location-valid, and target-week-valid;
 * `changedSinceStaged` is an advisory staleness flag (last-writer-wins at commit)
 * and does not gate validity.
 */
export type SpaceMovePreview = {
  __typename?: 'SpaceMovePreview';
  changedSinceStaged: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  jobArchived: Scalars['Boolean']['output'];
  jobExists: Scalars['Boolean']['output'];
  lotId: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  targetLocationValid: Scalars['Boolean']['output'];
  targetWeekValid: Scalars['Boolean']['output'];
  toLocationId?: Maybe<Scalars['String']['output']>;
  toWeekStartIso?: Maybe<Scalars['String']['output']>;
};

export type SpacePlanLoad = {
  __typename?: 'SpacePlanLoad';
  endDate: Scalars['LocalDate']['output'];
  planName: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  qty: Scalars['Decimal']['output'];
  startDate: Scalars['LocalDate']['output'];
};

export type SpaceTrendBucket = {
  __typename?: 'SpaceTrendBucket';
  utilizationPct: Scalars['Decimal']['output'];
  weekLabel: Scalars['String']['output'];
  weekStart: Scalars['LocalDate']['output'];
};

export type SpaceTypeUtilization = {
  __typename?: 'SpaceTypeUtilization';
  spaceTypeId: Scalars['String']['output'];
  spaceTypeName: Scalars['String']['output'];
  utilizationPct: Scalars['Decimal']['output'];
};

/**
 * Read-only, stateless what-if result for the spaceUtilizationPreview query: the capacity board
 * recomputed in memory with the staged moves applied. Nothing is persisted.
 */
export type SpaceUtilizationPreview = {
  __typename?: 'SpaceUtilizationPreview';
  /** Per-move validity and staleness, in the order supplied. */
  moves: Array<SpaceMovePreview>;
  /**
   * Every (location, space type, plan, week) row touched by the base board or the staged moves,
   * annotated with before/after usage and post-move remaining capacity.
   */
  rows: Array<SpaceCapacityPreviewRow>;
  /** Rows whose after-move usage exceeds the sub-location capacity. */
  violations: Array<SpaceCapacityViolation>;
};

export type SplitProductionLotDataInput = {
  newLots: Array<SplitProductionLotTargetDataInput>;
  productionLotId: Scalars['String']['input'];
  retainedQuantity: Scalars['Int']['input'];
};

export type SplitProductionLotPayload = {
  __typename?: 'SplitProductionLotPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type SplitProductionLotTargetDataInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  weekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SqlColumnMapData = {
  __typename?: 'SqlColumnMapData';
  columnName: Scalars['String']['output'];
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: SqlDataType;
};

export type SqlColumnMapDataFilterInput = {
  and?: InputMaybe<Array<SqlColumnMapDataFilterInput>>;
  columnName?: InputMaybe<StringOperationFilterInput>;
  csvHeader?: InputMaybe<StringOperationFilterInput>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataFilterInput>;
  or?: InputMaybe<Array<SqlColumnMapDataFilterInput>>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataFilterInput>;
  transform?: InputMaybe<DynamicTransformUnitDataFilterInput>;
  type?: InputMaybe<SqlDataTypeOperationFilterInput>;
};

export type SqlColumnMapDataInput = {
  columnName: Scalars['String']['input'];
  csvHeader?: InputMaybe<Scalars['String']['input']>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataInput>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataInput>;
  transform?: InputMaybe<DynamicTransformUnitDataInput>;
  type: SqlDataType;
};

export enum SqlDataType {
  Boolean = 'BOOLEAN',
  Byte = 'BYTE',
  DateTime = 'DATE_TIME',
  Decimal = 'DECIMAL',
  Double = 'DOUBLE',
  Float = 'FLOAT',
  Guid = 'GUID',
  Int = 'INT',
  Long = 'LONG',
  NotSet = 'NOT_SET',
  Short = 'SHORT',
  String = 'STRING'
}

export type SqlDataTypeOperationFilterInput = {
  eq?: InputMaybe<SqlDataType>;
  in?: InputMaybe<Array<SqlDataType>>;
  neq?: InputMaybe<SqlDataType>;
  nin?: InputMaybe<Array<SqlDataType>>;
};

/** A connection to a list of items. */
export type StagedCategoriesConnection = {
  __typename?: 'StagedCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCategoriesEdge = {
  __typename?: 'StagedCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryDocument;
};

/**
 * Deleted-document count for a single staged collection that backs a
 * GrowPointStagedEntity. CollectionName is the
 * GrowPointCollectionNames constant; the count
 * comes from MongoDB's DeleteResult.DeletedCount.
 */
export type StagedCollectionDeletionData = {
  __typename?: 'StagedCollectionDeletionData';
  collectionName: Scalars['String']['output'];
  deletedCount: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type StagedCustomerLocationsConnection = {
  __typename?: 'StagedCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCustomerLocationsEdge = {
  __typename?: 'StagedCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/** A connection to a list of items. */
export type StagedCustomersConnection = {
  __typename?: 'StagedCustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomersSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCustomersEdge = {
  __typename?: 'StagedCustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomersSummaryDocument;
};

/** A connection to a list of items. */
export type StagedHistoricalOrdersConnection = {
  __typename?: 'StagedHistoricalOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedHistoricalOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HistoricalOrderStagedSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedHistoricalOrdersEdge = {
  __typename?: 'StagedHistoricalOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HistoricalOrderStagedSummaryDocument;
};

/** A connection to a list of items. */
export type StagedInventoryItemsConnection = {
  __typename?: 'StagedInventoryItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedInventoryItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedInventoryItemsEdge = {
  __typename?: 'StagedInventoryItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/** A connection to a list of items. */
export type StagedItemsConnection = {
  __typename?: 'StagedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedItemsEdge = {
  __typename?: 'StagedItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type StagedPriceGroupsConnection = {
  __typename?: 'StagedPriceGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedPriceGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceGroupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedPriceGroupsEdge = {
  __typename?: 'StagedPriceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceGroupDocument;
};

/** A connection to a list of items. */
export type StagedPriceLevelsConnection = {
  __typename?: 'StagedPriceLevelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedPriceLevelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceLevelDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedPriceLevelsEdge = {
  __typename?: 'StagedPriceLevelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceLevelDocument;
};

/** A connection to a list of items. */
export type StagedSiteLocationsConnection = {
  __typename?: 'StagedSiteLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedSiteLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedSiteLocationsEdge = {
  __typename?: 'StagedSiteLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationDocument;
};

/** A connection to a list of items. */
export type StagedSubLocationsConnection = {
  __typename?: 'StagedSubLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedSubLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SubLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedSubLocationsEdge = {
  __typename?: 'StagedSubLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubLocationDocument;
};

/** A connection to a list of items. */
export type StagedTaxAuthoritiesConnection = {
  __typename?: 'StagedTaxAuthoritiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedTaxAuthoritiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaxAuthorityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedTaxAuthoritiesEdge = {
  __typename?: 'StagedTaxAuthoritiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaxAuthorityDocument;
};

/** A connection to a list of items. */
export type StagedTermsConnection = {
  __typename?: 'StagedTermsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedTermsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TermsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedTermsEdge = {
  __typename?: 'StagedTermsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TermsDocument;
};

export type StampPortalCustomDomainLoginRedirectSyncInput = {
  domain: Scalars['String']['input'];
  failureKind?: InputMaybe<PortalLoginRedirectSyncFailureKind>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  operation: PortalLoginRedirectSyncOperation;
  succeeded: Scalars['Boolean']['input'];
  verificationToken: Scalars['String']['input'];
};

/** Input for startAssignmentTask; addresses the task by its item × bin business key. */
export type StartAssignmentTaskInput = {
  assignmentId: Scalars['String']['input'];
  binLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
};

export type StartAvailabilitySessionInput = {
  comment: Scalars['String']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type StartCountSessionInput = {
  countSessionId: Scalars['String']['input'];
  crewSize: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLineId: Scalars['String']['input'];
  targetQty: Scalars['Decimal']['input'];
};

export type StartFloatingTimerInput = {
  floatingTimeEntryId: Scalars['String']['input'];
  workerId: Scalars['String']['input'];
};

export type StartRestockSessionCreationInput = {
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type StartTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type StartTimerInput = {
  headcount?: InputMaybe<Scalars['Int']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

/**
 * Anonymous input to submit a trial signup. The VerificationToken is the code delivered by
 * requestTrialSignupVerification. CAPTCHA is deferred (Kennedy 07-02): an optional
 * captchaToken can be added here additively later without breaking existing clients.
 * AcceptedTermsVersion is the Trial Terms of Service version the prospect accepted
 * (nullable-additive the same way, so pre-terms clients keep working); it is recorded on the
 * signup, never validated, and never changes the uniform response.
 */
export type StartTrialInput = {
  acceptedTermsVersion?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requestedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  verificationToken: Scalars['String']['input'];
};

/**
 * Uniform response to startTrial. Every accepted signup — matched or not, auto-approved or
 * pending — receives the identical message and only its own request id, so the
 * anonymous surface reveals nothing about matches, tenant existence, or the approval outcome.
 */
export type StartTrialPayload = {
  __typename?: 'StartTrialPayload';
  errors?: Maybe<Array<ValidationError>>;
  message: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
};

export enum StaticDefaultType {
  Constant = 'CONSTANT',
  DateTime = 'DATE_TIME',
  FileDate = 'FILE_DATE',
  FileName = 'FILE_NAME',
  Guid = 'GUID',
  NotSet = 'NOT_SET'
}

export type StaticDefaultTypeOperationFilterInput = {
  eq?: InputMaybe<StaticDefaultType>;
  in?: InputMaybe<Array<StaticDefaultType>>;
  neq?: InputMaybe<StaticDefaultType>;
  nin?: InputMaybe<Array<StaticDefaultType>>;
};

export type StaticDefaultUnitData = {
  __typename?: 'StaticDefaultUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: StaticDefaultType;
};

export type StaticDefaultUnitDataFilterInput = {
  and?: InputMaybe<Array<StaticDefaultUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StaticDefaultUnitDataFilterInput>>;
  type?: InputMaybe<StaticDefaultTypeOperationFilterInput>;
};

export type StaticDefaultUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: StaticDefaultType;
};

/** A connection to a list of items. */
export type StationBpLotInventoryConnection = {
  __typename?: 'StationBpLotInventoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StationBpLotInventoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailAvailableBpLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StationBpLotInventoryEdge = {
  __typename?: 'StationBpLotInventoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailAvailableBpLotDocument;
};

export type StopFloatingTimerInput = {
  floatingTimeEntryId: Scalars['String']['input'];
};

export type StopTimerInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

export type StoreAllocationData = {
  __typename?: 'StoreAllocationData';
  achievableQuantity: Scalars['Int']['output'];
  demandMetPercentage: Scalars['Decimal']['output'];
  minConstraintMet: Scalars['Boolean']['output'];
  shortfall: Scalars['Int']['output'];
  storeId: Scalars['String']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type StoreClassEntryInput = {
  class: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
};

export type StoreClassEntryStateData = {
  __typename?: 'StoreClassEntryStateData';
  class: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type StoreClassPayload = {
  __typename?: 'StoreClassPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<StoreClassStateData>;
};

export type StoreClassStateData = {
  __typename?: 'StoreClassStateData';
  storeClasses: Array<StoreClassEntryStateData>;
  tenantId: Scalars['String']['output'];
};

export type StreamCountDocument = {
  __typename?: 'StreamCountDocument';
  count: Scalars['Long']['output'];
  streamName: Scalars['String']['output'];
};

export type StreamCountDocumentFilterInput = {
  and?: InputMaybe<Array<StreamCountDocumentFilterInput>>;
  count?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<StreamCountDocumentFilterInput>>;
  streamName?: InputMaybe<StringOperationFilterInput>;
};

export type StreamCountDocumentSortInput = {
  count?: InputMaybe<SortEnumType>;
  streamName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StreamCountsConnection = {
  __typename?: 'StreamCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StreamCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<StreamCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StreamCountsEdge = {
  __typename?: 'StreamCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StreamCountDocument;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Mutation payload for createBillingPortalSession. On success portalUrl is the
 * hosted Stripe Customer Portal URL; on rejection portalUrl is null and
 * errors carries the reason.
 */
export type StripeBillingPortalSessionPayload = {
  __typename?: 'StripeBillingPortalSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Mutation payload for createSubscriptionCheckoutSession. On success sessionUrl is
 * the hosted Stripe Checkout URL the admin hands the tenant; on rejection (e.g. the $25k offline gate,
 * an unlinked tenant, or a cadence the rate card does not offer) sessionUrl is null and
 * errors carries the reason.
 */
export type StripeCheckoutSessionPayload = {
  __typename?: 'StripeCheckoutSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  sessionUrl?: Maybe<Scalars['String']['output']>;
};

export type SubLocationDataInput = {
  capacity: Scalars['Decimal']['input'];
  erpId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  locationType: SiteLocationType;
  name: Scalars['String']['input'];
  parentLocationId: Scalars['String']['input'];
  status: LocationStatus;
};

export type SubLocationDocument = {
  __typename?: 'SubLocationDocument';
  capacity?: Maybe<Scalars['Decimal']['output']>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationType: SiteLocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type SubLocationDocumentFilterInput = {
  and?: InputMaybe<Array<SubLocationDocumentFilterInput>>;
  capacity?: InputMaybe<DecimalOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<SiteLocationTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubLocationDocumentFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SubLocationDocumentSortInput = {
  capacity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SubLocationsConnection = {
  __typename?: 'SubLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SubLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubLocationsEdge = {
  __typename?: 'SubLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubLocationDocument;
};

export type SubmitErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type SubmitFullOrderInput = {
  customer: OrderCustomerDataInput;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit: Scalars['Boolean']['input'];
  fromLocation: ShipFromLocationDataInput;
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<AddLineItemDataInput>;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<CaptureSignatureDataInput>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type SubmitOrderVerificationInput = {
  adjustments: Array<SubmitVerifyAdjustmentDataInput>;
  lines: Array<SubmitVerifyLineDataInput>;
  orderId: Scalars['String']['input'];
  substitutions: Array<SubmitVerifySubstitutionDataInput>;
  verifyContainerIds: Array<Scalars['String']['input']>;
};

export type SubmitRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type SubmitVerifyAdjustmentDataInput = {
  itemId: Scalars['String']['input'];
  newQuantity: Scalars['Int']['input'];
  orderLineNumber: Scalars['Int']['input'];
  originalQuantity: Scalars['Int']['input'];
};

export type SubmitVerifyContainerInput = {
  containerId?: InputMaybe<Scalars['String']['input']>;
  drop: Scalars['String']['input'];
  label: Scalars['String']['input'];
  orderAssociations: Array<OrderAssociationDataInput>;
  scans: Array<ScanDataInput>;
  submitted: Scalars['Boolean']['input'];
  submittedBy: Scalars['String']['input'];
};

export type SubmitVerifyLineDataInput = {
  itemId: Scalars['String']['input'];
  orderLineNumber: Scalars['Int']['input'];
  shippedQuantity: Scalars['Int']['input'];
};

export type SubmitVerifySubstitutionDataInput = {
  newItemId: Scalars['String']['input'];
  orderLineNumber: Scalars['Int']['input'];
  originalItemId: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribes to live updates for a single count session. Emits the latest
   * CountSessionDocument after each coalesced batch of projection updates,
   * and the current document immediately on connect. The sessionId is
   * client-supplied, so a client may open the subscription before the session exists.
   */
  countSessionTicked: CountSessionDocument;
  /**
   * Subscribes to manifest changes for the pod identified by runsOn.
   * Publishers (admin background-service-config and worker-config mutations)
   * emit one event per affected pod after a successful write.
   */
  manifestChanged: ManifestChangedEvent;
  /**
   * Subscribes to feature flag changes for the authenticated tenant. The PWA
   * receives one event per change and re-runs featureFlag(name: ...) or
   * allFeatureFlags to pull the new value.
   */
  onFeatureFlagChanged: FeatureFlagChangedEvent;
  /**
   * Subscribes to InventoryItem changes for the authenticated user's tenant.
   * Publishes an InventoryItemDocument each time the projection
   * service processes an inventory event.
   */
  onInventoryItemChanged: InventoryItemDocument;
  /**
   * Subscribes to progress for a single Restock session. Emits a phase (plus a
   * batch counter when the active phase carries batch semantics) after each
   * workflow checkpoint. Terminal events emit RestockBatchPhase.Idle
   * so clients can reset local progress UI; Error is populated on failure.
   * On every (re)subscribe the last-known state from the
   * RestockSessionCreationProgressDocument audit row is replayed first (when one
   * exists), so clients recover the current phase after a reconnect without polling.
   * Subscribe BEFORE invoking the triggering mutation — SessionId is client-generated,
   * so the subscription can be opened up-front without a producer race.
   */
  onRestockSessionBatchProgress: RestockSessionBatchProgressPayload;
  /**
   * Subscribes the authenticated staff caller to their tenant's user-directory changes. The admin
   * users grid/detail panel refreshes the affected row from the pushed UserDocument.
   */
  onUserChanged: UserDocument;
  restockWorkQueueResultBatchCompleted: RestockWorkQueueResultBatchPayload;
  /**
   * Subscribes the authenticated supervisor to their tenant's container status changes. The PWA
   * refetches the comparison on Submitted and drops the row on Verified.
   */
  verifyContainerStatusChanged: VerifyContainerStatusChangedEvent;
};


export type SubscriptionCountSessionTickedArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionManifestChangedArgs = {
  runsOn: Scalars['String']['input'];
};


export type SubscriptionOnRestockSessionBatchProgressArgs = {
  sessionId: Scalars['String']['input'];
};

export type Substitution = {
  __typename?: 'Substitution';
  substitutionType: SubstitutionType;
  value: Scalars['String']['output'];
};

export type SubstitutionDocument = {
  __typename?: 'SubstitutionDocument';
  substitutionType: SubstitutionType;
  value: Scalars['String']['output'];
};

export type SubstitutionDocumentFilterInput = {
  and?: InputMaybe<Array<SubstitutionDocumentFilterInput>>;
  or?: InputMaybe<Array<SubstitutionDocumentFilterInput>>;
  substitutionType?: InputMaybe<SubstitutionTypeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type SubstitutionDocumentSortInput = {
  substitutionType?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type SubstitutionInput = {
  substitutionType: SubstitutionType;
  value: Scalars['String']['input'];
};

export enum SubstitutionType {
  Category = 'CATEGORY',
  ItemGroup = 'ITEM_GROUP',
  Subcategory = 'SUBCATEGORY'
}

export type SubstitutionTypeOperationFilterInput = {
  eq?: InputMaybe<SubstitutionType>;
  in?: InputMaybe<Array<SubstitutionType>>;
  neq?: InputMaybe<SubstitutionType>;
  nin?: InputMaybe<Array<SubstitutionType>>;
};

export type SyncAttemptData = {
  __typename?: 'SyncAttemptData';
  dateAttempted: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type SynchronizationIterationsConnection = {
  __typename?: 'SynchronizationIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<IterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationIterationsEdge = {
  __typename?: 'SynchronizationIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: IterationDocument;
};

/** A connection to a list of items. */
export type SynchronizationOnHandProcessIterationsConnection = {
  __typename?: 'SynchronizationOnHandProcessIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationOnHandProcessIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandProcessIterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationOnHandProcessIterationsEdge = {
  __typename?: 'SynchronizationOnHandProcessIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandProcessIterationDocument;
};

/** A connection to a list of items. */
export type SynchronizationOnHandQueueingIterationsConnection = {
  __typename?: 'SynchronizationOnHandQueueingIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationOnHandQueueingIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandQueueIterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationOnHandQueueingIterationsEdge = {
  __typename?: 'SynchronizationOnHandQueueingIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandQueueIterationDocument;
};

export type SynchronizeErpItemPricingInput = {
  erpPriceGroupId: Scalars['String']['input'];
  itemPrices: Array<ItemPriceInput>;
};

export type SynchronizeRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type SynchronizeSalesPeopleInput = {
  salesPeople: Array<SalesPersonMapDataInput>;
};

export enum TargetType {
  Category = 'CATEGORY',
  Item = 'ITEM',
  Material = 'MATERIAL'
}

export type TargetTypeOperationFilterInput = {
  eq?: InputMaybe<TargetType>;
  in?: InputMaybe<Array<TargetType>>;
  neq?: InputMaybe<TargetType>;
  nin?: InputMaybe<Array<TargetType>>;
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocument = {
  __typename?: 'TaskAssignmentDocument';
  activeTimerCreatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: Maybe<Scalars['Int']['output']>;
  activeTimerStartTime?: Maybe<Scalars['DateTime']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Resolved trigger/due date for assignments materialized from a triggered production event,
   * written from TaskAssignmentDueDateAssigned.DueDate via a pure absolute $set. Null for
   * ad-hoc/pre-existing assignments with no resolvable trigger. Nullable so the GraphQL field is
   * additive (DateTime, not DateTime! — AI Atlas bde8323d); no migration for existing documents.
   */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  productionJobId?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  sourceLevel: TaskAssignmentSourceLevel;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  status: TaskAssignmentStatus;
  taskAssignmentId: Scalars['String']['output'];
  taskEventName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds: Scalars['Long']['output'];
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocumentFilterInput = {
  activeTimerCreatedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: InputMaybe<IntOperationFilterInput>;
  activeTimerStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TaskAssignmentDocumentFilterInput>>;
  assignedTo?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedBy?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Resolved trigger/due date for assignments materialized from a triggered production event,
   * written from TaskAssignmentDueDateAssigned.DueDate via a pure absolute $set. Null for
   * ad-hoc/pre-existing assignments with no resolvable trigger. Nullable so the GraphQL field is
   * additive (DateTime, not DateTime! — AI Atlas bde8323d); no migration for existing documents.
   */
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskAssignmentDocumentFilterInput>>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: InputMaybe<OptionOfInt32FilterInput>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  sourceLevel?: InputMaybe<TaskAssignmentSourceLevelOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startedBy?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TaskAssignmentStatusOperationFilterInput>;
  taskAssignmentId?: InputMaybe<StringOperationFilterInput>;
  taskEventName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds?: InputMaybe<LongOperationFilterInput>;
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocumentSortInput = {
  activeTimerCreatedBy?: InputMaybe<SortEnumType>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: InputMaybe<SortEnumType>;
  activeTimerStartTime?: InputMaybe<SortEnumType>;
  assignedTo?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  completedBy?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Resolved trigger/due date for assignments materialized from a triggered production event,
   * written from TaskAssignmentDueDateAssigned.DueDate via a pure absolute $set. Null for
   * ad-hoc/pre-existing assignments with no resolvable trigger. Nullable so the GraphQL field is
   * additive (DateTime, not DateTime! — AI Atlas bde8323d); no migration for existing documents.
   */
  dueDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productionJobId?: InputMaybe<SortEnumType>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: InputMaybe<SortEnumType>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: InputMaybe<SortEnumType>;
  sourceLevel?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskAssignmentId?: InputMaybe<SortEnumType>;
  taskEventName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds?: InputMaybe<SortEnumType>;
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL data type for task assignment notes. */
export type TaskAssignmentNoteData = {
  __typename?: 'TaskAssignmentNoteData';
  addedAt: Scalars['DateTime']['output'];
  addedBy: Scalars['String']['output'];
  content: Scalars['String']['output'];
};

/** GraphQL payload for TaskAssignment mutations. */
export type TaskAssignmentPayload = {
  __typename?: 'TaskAssignmentPayload';
  errors?: Maybe<Array<ValidationError>>;
  taskAssignment?: Maybe<TaskAssignmentStateData>;
};

export enum TaskAssignmentSourceLevel {
  AdHoc = 'AD_HOC',
  Category = 'CATEGORY',
  Item = 'ITEM',
  Recipe = 'RECIPE',
  Unknown = 'UNKNOWN'
}

export type TaskAssignmentSourceLevelOperationFilterInput = {
  eq?: InputMaybe<TaskAssignmentSourceLevel>;
  in?: InputMaybe<Array<TaskAssignmentSourceLevel>>;
  neq?: InputMaybe<TaskAssignmentSourceLevel>;
  nin?: InputMaybe<Array<TaskAssignmentSourceLevel>>;
};

/** GraphQL data type for TaskAssignment state. */
export type TaskAssignmentStateData = {
  __typename?: 'TaskAssignmentStateData';
  assignedTo?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  notes: Array<TaskAssignmentNoteData>;
  productionJobId?: Maybe<Scalars['String']['output']>;
  productionJobNumber?: Maybe<Scalars['Int']['output']>;
  siteLocationId?: Maybe<Scalars['String']['output']>;
  sourceLevel: TaskAssignmentSourceLevel;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  status: TaskAssignmentStatus;
  taskAssignmentId: Scalars['String']['output'];
  taskEventName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timeEntries: Array<TimeEntryData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum TaskAssignmentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type TaskAssignmentStatusOperationFilterInput = {
  eq?: InputMaybe<TaskAssignmentStatus>;
  in?: InputMaybe<Array<TaskAssignmentStatus>>;
  neq?: InputMaybe<TaskAssignmentStatus>;
  nin?: InputMaybe<Array<TaskAssignmentStatus>>;
};

/** A connection to a list of items. */
export type TaskAssignmentsConnection = {
  __typename?: 'TaskAssignmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaskAssignmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskAssignmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskAssignmentsEdge = {
  __typename?: 'TaskAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskAssignmentDocument;
};

/**
 * One group header for the Task Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionTaskEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type TaskEventGroupBucket = {
  __typename?: 'TaskEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for taskEventGroups. Mirrors the Task Events sidebar's group-by options so
 * the client can render server-computed group headers instead of grouping the full event list in
 * memory: Status buckets on the event lifecycle status, Name buckets on the event name.
 * Both are flat scalar fields on ProductionTaskEventDocument.
 */
export enum TaskEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Unknown). Deleted is excluded. */
  Status = 'STATUS'
}

export type TaskEventRegenerationCandidateProjection = {
  __typename?: 'TaskEventRegenerationCandidateProjection';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocument = {
  __typename?: 'TaskEventTypeDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: TaskEventTypeStatus;
  taskEventTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocumentFilterInput = {
  and?: InputMaybe<Array<TaskEventTypeDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskEventTypeDocumentFilterInput>>;
  status?: InputMaybe<TaskEventTypeStatusOperationFilterInput>;
  taskEventTypeId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventTypeId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for TaskEventType mutations. */
export type TaskEventTypePayload = {
  __typename?: 'TaskEventTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  taskEventType?: Maybe<TaskEventTypeStateData>;
};

export type TaskEventTypeStateData = {
  __typename?: 'TaskEventTypeStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: TaskEventTypeStatus;
  taskEventTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum TaskEventTypeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type TaskEventTypeStatusOperationFilterInput = {
  eq?: InputMaybe<TaskEventTypeStatus>;
  in?: InputMaybe<Array<TaskEventTypeStatus>>;
  neq?: InputMaybe<TaskEventTypeStatus>;
  nin?: InputMaybe<Array<TaskEventTypeStatus>>;
};

/** A connection to a list of items. */
export type TaskEventTypesConnection = {
  __typename?: 'TaskEventTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaskEventTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskEventTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskEventTypesEdge = {
  __typename?: 'TaskEventTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskEventTypeDocument;
};

/** A connection to a list of items. */
export type TaxAuthoritiesConnection = {
  __typename?: 'TaxAuthoritiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaxAuthoritiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaxAuthorityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxAuthoritiesEdge = {
  __typename?: 'TaxAuthoritiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaxAuthorityDocument;
};

/**
 * MongoDB read-model document for a tax authority. Composite Id
 * is {TenantId}-{TaxAuthorityId}; TaxAuthorityId is the plain
 * authority id (preferred for new frontend code).
 */
export type TaxAuthorityDocument = {
  __typename?: 'TaxAuthorityDocument';
  code: Scalars['String']['output'];
  /**
   * External ERP natural key (GrowPoint artax.CODE). Backs the (TenantId, ErpId)
   * dedupe the GrowPoint import worker performs to route a row to a new vs existing aggregate
   * stream. Empty for authorities not imported from an external ERP. Written by
   * TaxAuthorityProjectionService from the TaxAuthorityCreated event (and a
   * non-empty TaxAuthorityUpdated).
   */
  erpId: Scalars['String']['output'];
  glAccount: Scalars['String']['output'];
  /**
   * Optional FK into MergeDevAccount (deterministic dashless GUID). Empty when the
   * authority has not been reconciled to a Chart-of-Accounts row. The
   * TaxAuthorityResolvers.GetGlAccountReference resolver hydrates the linked
   * MergeDevAccountDocument on this id at query time.
   */
  glAccountId: Scalars['String']['output'];
  /** Linked Chart-of-Accounts row resolved from GlAccountId. Null when the authority has not yet been reconciled to a structured account, or when the linked account no longer exists for the tenant. */
  glAccountReference?: Maybe<MergeDevAccountDocument>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Optional FK into MergeDevTaxRate (deterministic dashless GUID) recording which
   * imported QuickBooks tax rate this authority reconciles to. Empty when the authority
   * has not been mapped. Written by TaxAuthorityProjectionService from the
   * MergeDevTaxRateMapped/MergeDevTaxRateUnmapped events.
   */
  mergeDevTaxRateId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rateHistory: Array<TaxRateEntryDocument>;
  taxAuthorityId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tax authority. Composite Id
 * is {TenantId}-{TaxAuthorityId}; TaxAuthorityId is the plain
 * authority id (preferred for new frontend code).
 */
export type TaxAuthorityDocumentFilterInput = {
  and?: InputMaybe<Array<TaxAuthorityDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  /**
   * External ERP natural key (GrowPoint artax.CODE). Backs the (TenantId, ErpId)
   * dedupe the GrowPoint import worker performs to route a row to a new vs existing aggregate
   * stream. Empty for authorities not imported from an external ERP. Written by
   * TaxAuthorityProjectionService from the TaxAuthorityCreated event (and a
   * non-empty TaxAuthorityUpdated).
   */
  erpId?: InputMaybe<StringOperationFilterInput>;
  glAccount?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional FK into MergeDevAccount (deterministic dashless GUID). Empty when the
   * authority has not been reconciled to a Chart-of-Accounts row. The
   * TaxAuthorityResolvers.GetGlAccountReference resolver hydrates the linked
   * MergeDevAccountDocument on this id at query time.
   */
  glAccountId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Optional FK into MergeDevTaxRate (deterministic dashless GUID) recording which
   * imported QuickBooks tax rate this authority reconciles to. Empty when the authority
   * has not been mapped. Written by TaxAuthorityProjectionService from the
   * MergeDevTaxRateMapped/MergeDevTaxRateUnmapped events.
   */
  mergeDevTaxRateId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaxAuthorityDocumentFilterInput>>;
  rateHistory?: InputMaybe<ListFilterInputTypeOfTaxRateEntryDocumentFilterInput>;
  taxAuthorityId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a tax authority. Composite Id
 * is {TenantId}-{TaxAuthorityId}; TaxAuthorityId is the plain
 * authority id (preferred for new frontend code).
 */
export type TaxAuthorityDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  /**
   * External ERP natural key (GrowPoint artax.CODE). Backs the (TenantId, ErpId)
   * dedupe the GrowPoint import worker performs to route a row to a new vs existing aggregate
   * stream. Empty for authorities not imported from an external ERP. Written by
   * TaxAuthorityProjectionService from the TaxAuthorityCreated event (and a
   * non-empty TaxAuthorityUpdated).
   */
  erpId?: InputMaybe<SortEnumType>;
  glAccount?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into MergeDevAccount (deterministic dashless GUID). Empty when the
   * authority has not been reconciled to a Chart-of-Accounts row. The
   * TaxAuthorityResolvers.GetGlAccountReference resolver hydrates the linked
   * MergeDevAccountDocument on this id at query time.
   */
  glAccountId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into MergeDevTaxRate (deterministic dashless GUID) recording which
   * imported QuickBooks tax rate this authority reconciles to. Empty when the authority
   * has not been mapped. Written by TaxAuthorityProjectionService from the
   * MergeDevTaxRateMapped/MergeDevTaxRateUnmapped events.
   */
  mergeDevTaxRateId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  taxAuthorityId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for the TaxAuthority aggregate. Either
 * TaxAuthority contains the post-event state, or
 * Errors describes why the mutation failed.
 */
export type TaxAuthorityPayload = {
  __typename?: 'TaxAuthorityPayload';
  errors?: Maybe<Array<ValidationError>>;
  taxAuthority?: Maybe<TaxAuthorityStateData>;
};

/**
 * Per-row failure surfaced by validateTaxAuthorityDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError implements IFieldValidationError, otherwise null.
 */
export type TaxAuthorityStagedRowError = {
  __typename?: 'TaxAuthorityStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type TaxAuthorityStateData = {
  __typename?: 'TaxAuthorityStateData';
  code: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  glAccount: Scalars['String']['output'];
  glAccountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mergeDevTaxRateId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rateHistory: Array<TaxRateEntryData>;
  taxAuthorityId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TaxRateEntryData = {
  __typename?: 'TaxRateEntryData';
  effectiveDate: Scalars['DateTime']['output'];
  rate: Scalars['Decimal']['output'];
};

export type TaxRateEntryDocument = {
  __typename?: 'TaxRateEntryDocument';
  effectiveDate: Scalars['DateTime']['output'];
  rate: Scalars['Decimal']['output'];
};

export type TaxRateEntryDocumentFilterInput = {
  and?: InputMaybe<Array<TaxRateEntryDocumentFilterInput>>;
  effectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TaxRateEntryDocumentFilterInput>>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
};

/** A connection to a list of items. */
export type TenantAsyncImportJobsConnection = {
  __typename?: 'TenantAsyncImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantAsyncImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantAsyncImportJobsEdge = {
  __typename?: 'TenantAsyncImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingData = {
  __typename?: 'TenantBillingData';
  /**
   * The active charge in minor units for the current Frequency — the rate-card amount
   * for that cadence. Null when no cadence is active or that cadence is not offered. Derived; not stored.
   */
  activeChargeAmount?: Maybe<Scalars['Long']['output']>;
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: Maybe<Scalars['Long']['output']>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency: Scalars['String']['output'];
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency: BillingFrequency;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: Maybe<Scalars['Long']['output']>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: Maybe<Scalars['Long']['output']>;
  /**
   * True when the active charge is at or above the online-payment ceiling ($25,000): such charges
   * collect offline and are not offered Stripe online payment. Derived from the rate card and active
   * cadence; not stored.
   */
  onlinePaymentDisabled: Scalars['Boolean']['output'];
  /** The configured online-payment ceiling in minor units — a chosen cadence charge at or above this is collected offline, matching the checkout gate the picker mirrors. */
  onlinePaymentMaxAmount: Scalars['Long']['output'];
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: Maybe<Scalars['Long']['output']>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status: BillingStatus;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /**
   * The subscription's line items (Stripe subscription item + price references). Multi-item-capable
   * so a future per-module subscription is the same shape; empty until the tenant is linked.
   */
  subscriptionItems: Array<TenantSubscriptionItemData>;
};

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingDataFilterInput = {
  and?: InputMaybe<Array<TenantBillingDataFilterInput>>;
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: InputMaybe<LongOperationFilterInput>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency?: InputMaybe<StringOperationFilterInput>;
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: InputMaybe<DateTimeOperationFilterInput>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency?: InputMaybe<BillingFrequencyOperationFilterInput>;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: InputMaybe<LongOperationFilterInput>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<TenantBillingDataFilterInput>>;
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: InputMaybe<LongOperationFilterInput>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status?: InputMaybe<BillingStatusOperationFilterInput>;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: InputMaybe<StringOperationFilterInput>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The subscription's line items (Stripe subscription item + price references). Multi-item-capable
   * so a future per-module subscription is the same shape; empty until the tenant is linked.
   */
  subscriptionItems?: InputMaybe<ListFilterInputTypeOfTenantSubscriptionItemDataFilterInput>;
};

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingDataSortInput = {
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: InputMaybe<SortEnumType>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency?: InputMaybe<SortEnumType>;
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: InputMaybe<SortEnumType>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency?: InputMaybe<SortEnumType>;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: InputMaybe<SortEnumType>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: InputMaybe<SortEnumType>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: InputMaybe<SortEnumType>;
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: InputMaybe<SortEnumType>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status?: InputMaybe<SortEnumType>;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: InputMaybe<SortEnumType>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: InputMaybe<SortEnumType>;
};

/**
 * Public view returned by tenantByCompanySlug: the tenant id the portal vanity subdomain
 * resolves to, plus the normalized slug that resolved it. Deliberately minimal — the pwa needs only
 * the tenant id to bootstrap settings.tenantId from the subdomain before login, mirroring how
 * it reads the tenant from the /portal/:tenantSlug path today.
 */
export type TenantByCompanySlugView = {
  __typename?: 'TenantByCompanySlugView';
  companySlug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's carrier configuration — the tier-0 default of the
 * hierarchical carrier setting. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes so that invariant can
 * evolve without breaking call sites. Mirrors TenantRouteConfigDocument.
 */
export type TenantCarrierConfigDocument = {
  __typename?: 'TenantCarrierConfigDocument';
  carrier: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

export type TenantCarrierConfigPayload = {
  __typename?: 'TenantCarrierConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenantCarrierConfig?: Maybe<TenantCarrierConfigStateData>;
};

export type TenantCarrierConfigStateData = {
  __typename?: 'TenantCarrierConfigStateData';
  carrier: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TenantCustomerPermissionsConnection = {
  __typename?: 'TenantCustomerPermissionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantCustomerPermissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantCustomerPermissionsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type TenantCustomerPermissionsDocument = {
  __typename?: 'TenantCustomerPermissionsDocument';
  billingAddressEditable: Scalars['Boolean']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationAddressEditable: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantCustomerPermissionsDocumentFilterInput = {
  and?: InputMaybe<Array<TenantCustomerPermissionsDocumentFilterInput>>;
  billingAddressEditable?: InputMaybe<BooleanOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationAddressEditable?: InputMaybe<BooleanOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantCustomerPermissionsDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type TenantCustomerPermissionsDocumentSortInput = {
  billingAddressEditable?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationAddressEditable?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type TenantCustomerPermissionsEdge = {
  __typename?: 'TenantCustomerPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TenantCustomerPermissionsDocument;
};

/**
 * Adds dnsRecords to TenantEmailDomainData as a field-level resolver rather than a
 * plain property, so clients that don't select it never pay for or fail on the live SendGrid round-trip
 * — unlike every other tenantEmail* read, which is Mongo-only.
 */
export type TenantEmailDomainData = {
  __typename?: 'TenantEmailDomainData';
  boundAt: Scalars['DateTime']['output'];
  /**
   * When the pending grandfather claim stops blocking a rival tenant's bind for the same domain, or
   * null when there is no pending grandfather challenge.
   */
  challengeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The per-tenant ownership-challenge token a grandfather bind must prove before it verifies, or
   * null on the created path (SendGrid CNAME proves ownership there) and once verified. Published as
   * the value of the challengeTxtRecord TXT record at challengeTxtHost.
   */
  challengeToken?: Maybe<Scalars['String']['output']>;
  /**
   * The DNS host to publish the ownership-challenge TXT record at (_worksuite.{domain}), or
   * null when there is no pending grandfather challenge.
   */
  challengeTxtHost?: Maybe<Scalars['String']['output']>;
  /**
   * The exact TXT record value to publish to prove ownership (worksuite-domain-verify={token}),
   * or null when there is no pending grandfather challenge.
   */
  challengeTxtRecord?: Maybe<Scalars['String']['output']>;
  /**
   * Live DNS records for this bound domain, fetched from SendGrid only when selected. Null signals
   * the lookup failed (SendGrid outage/timeout/contract error) — distinct from an empty list, which
   * means the domain genuinely has no DNS records reported. Failures are logged and degrade the field
   * to null rather than erroring the whole query.
   */
  dnsRecords?: Maybe<Array<TenantEmailDomainDnsRecord>>;
  domain: Scalars['String']['output'];
  origin: EmailDomainOrigin;
  sendGridDomainId: Scalars['String']['output'];
  status: EmailSenderVerificationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TenantEmailDomainDnsRecord = {
  __typename?: 'TenantEmailDomainDnsRecord';
  data: Scalars['String']['output'];
  host: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type TenantEmailDomainPayload = {
  __typename?: 'TenantEmailDomainPayload';
  domain?: Maybe<TenantEmailDomainData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** GraphQL data transfer record for a single tenant sender identity. */
export type TenantEmailSenderData = {
  __typename?: 'TenantEmailSenderData';
  /** Gets the timestamp when the sender was added (default when platform-default). */
  addedAt: Scalars['DateTime']['output'];
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1: Scalars['String']['output'];
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send). Filters getSelectableEmailSenders for non-admin
   * callers and is enforced again (defense in depth) at the FK-validated write paths
   * (setOrderEmailSettings / setReportScheduleEmailSettings). Never filters
   * getEffectiveEmailSender — the tenant default may be admin-only because background sends
   * are system acts, not user acts.
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the connection channel this sender is served through (single/domain/SMTP/M365). */
  channel: EmailSenderChannel;
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault: Scalars['Boolean']['output'];
  /** Gets a value indicating whether this sender is the synthesized platform-default fallback. */
  isPlatformDefault: Scalars['Boolean']['output'];
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: Maybe<Scalars['String']['output']>;
  /** Gets the sender identifier. */
  senderId: Scalars['String']['output'];
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the sender (default when platform-default). */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Gets the SendGrid verification method for a SendGrid-channel sender, or None for a sender served
   * through a non-SendGrid channel (e.g. custom SMTP). The channel — not this method —
   * discriminates the source; this stays SendGrid-specific and is absent off the SendGrid channels.
   */
  verificationMethod?: Maybe<EmailSenderVerificationMethod>;
  /** Gets the verification lifecycle status. */
  verificationStatus: EmailSenderVerificationStatus;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocument = {
  __typename?: 'TenantEmailSenderDocument';
  /** Gets the timestamp when the sender was added. */
  addedAt: Scalars['DateTime']['output'];
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1: Scalars['String']['output'];
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id: Scalars['String']['output'];
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault: Scalars['Boolean']['output'];
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: Maybe<Scalars['String']['output']>;
  /** Gets the sender identifier. */
  senderId: Scalars['String']['output'];
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the sender. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod: EmailSenderVerificationMethod;
  /** Gets the verification lifecycle status. */
  verificationStatus: EmailSenderVerificationStatus;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocumentFilterInput = {
  /** Gets the timestamp when the sender was added. */
  addedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TenantEmailSenderDocumentFilterInput>>;
  /** Gets the city. */
  city?: InputMaybe<StringOperationFilterInput>;
  /** Gets the country. */
  country?: InputMaybe<StringOperationFilterInput>;
  /** Gets the friendly from-name. */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the from-address. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TenantEmailSenderDocumentFilterInput>>;
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets the sender identifier. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp of the last change to the sender. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod?: InputMaybe<EmailSenderVerificationMethodOperationFilterInput>;
  /** Gets the verification lifecycle status. */
  verificationStatus?: InputMaybe<EmailSenderVerificationStatusOperationFilterInput>;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocumentSortInput = {
  /** Gets the timestamp when the sender was added. */
  addedAt?: InputMaybe<SortEnumType>;
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1?: InputMaybe<SortEnumType>;
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly?: InputMaybe<SortEnumType>;
  /** Gets the city. */
  city?: InputMaybe<SortEnumType>;
  /** Gets the country. */
  country?: InputMaybe<SortEnumType>;
  /** Gets the friendly from-name. */
  displayName?: InputMaybe<SortEnumType>;
  /** Gets the from-address. */
  email?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault?: InputMaybe<SortEnumType>;
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: InputMaybe<SortEnumType>;
  /** Gets the sender identifier. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp of the last change to the sender. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod?: InputMaybe<SortEnumType>;
  /** Gets the verification lifecycle status. */
  verificationStatus?: InputMaybe<SortEnumType>;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: InputMaybe<SortEnumType>;
};

/** Payload returned from tenant email-sender mutations. */
export type TenantEmailSenderPayload = {
  __typename?: 'TenantEmailSenderPayload';
  errors?: Maybe<Array<ValidationError>>;
  sender?: Maybe<TenantEmailSenderData>;
};

/** A connection to a list of items. */
export type TenantEmailSendersConnection = {
  __typename?: 'TenantEmailSendersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantEmailSendersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantEmailSenderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantEmailSendersEdge = {
  __typename?: 'TenantEmailSendersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TenantEmailSenderDocument;
};

/** GraphQL-output projection of a single tenant grade → custom label pairing. */
export type TenantGradeLabelData = {
  __typename?: 'TenantGradeLabelData';
  grade: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type TenantIntegrationData = {
  __typename?: 'TenantIntegrationData';
  accessToken: Scalars['String']['output'];
  accessTokenExpiration: Scalars['DateTime']['output'];
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category: IntegrationCategory;
  created: Scalars['DateTime']['output'];
  integrationId: Scalars['String']['output'];
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null for non-Merge.dev integrations, and for Merge.dev links completed before platform
   * identity was captured — all such legacy links are QuickBooks Online, the only connector
   * enabled until then; consumers may fall back to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: Maybe<Scalars['String']['output']>;
  realmId: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
  source: IntegrationSource;
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocument = {
  __typename?: 'TenantIntegrationDocument';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt: Scalars['DateTime']['output'];
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category: IntegrationCategory;
  integrationId: Scalars['String']['output'];
  mergeDevAccountToken?: Maybe<Scalars['String']['output']>;
  mergeDevApiKey?: Maybe<Scalars['String']['output']>;
  mergeDevBaseUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: Maybe<Scalars['String']['output']>;
  mergeDevOrderExportTriggerStatus?: Maybe<Scalars['Int']['output']>;
  mySqlDatabase?: Maybe<Scalars['String']['output']>;
  mySqlEndpoint?: Maybe<Scalars['String']['output']>;
  mySqlPassword?: Maybe<Scalars['String']['output']>;
  mySqlUsername?: Maybe<Scalars['String']['output']>;
  orderEaseBaseUrl?: Maybe<Scalars['String']['output']>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether the connected Merge.dev platform supports outbound invoice creation (POST Invoices)
   * through Merge. Inbound-only platforms (QuickBooks Desktop, Sage Business Cloud Accounting,
   * Wave, Dynamics 365 Finance & Operations) are false; every other slug and null (legacy
   * QuickBooks Online) is true.
   */
  outboundInvoiceExportSupported: Scalars['Boolean']['output'];
  realmId?: Maybe<Scalars['String']['output']>;
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  source: IntegrationSource;
  tenantId: Scalars['String']['output'];
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocumentFilterInput = {
  accessToken?: InputMaybe<StringOperationFilterInput>;
  accessTokenExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TenantIntegrationDocumentFilterInput>>;
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category?: InputMaybe<IntegrationCategoryOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  mergeDevAccountToken?: InputMaybe<StringOperationFilterInput>;
  mergeDevApiKey?: InputMaybe<StringOperationFilterInput>;
  mergeDevBaseUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: InputMaybe<StringOperationFilterInput>;
  mergeDevOrderExportTriggerStatus?: InputMaybe<IntOperationFilterInput>;
  mySqlDatabase?: InputMaybe<StringOperationFilterInput>;
  mySqlEndpoint?: InputMaybe<StringOperationFilterInput>;
  mySqlPassword?: InputMaybe<StringOperationFilterInput>;
  mySqlUsername?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantIntegrationDocumentFilterInput>>;
  orderEaseBaseUrl?: InputMaybe<StringOperationFilterInput>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: InputMaybe<DateTimeOperationFilterInput>;
  realmId?: InputMaybe<StringOperationFilterInput>;
  refreshToken?: InputMaybe<StringOperationFilterInput>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  source?: InputMaybe<IntegrationSourceOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocumentSortInput = {
  accessToken?: InputMaybe<SortEnumType>;
  accessTokenExpiresAt?: InputMaybe<SortEnumType>;
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  mergeDevAccountToken?: InputMaybe<SortEnumType>;
  mergeDevApiKey?: InputMaybe<SortEnumType>;
  mergeDevBaseUrl?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: InputMaybe<SortEnumType>;
  mergeDevOrderExportTriggerStatus?: InputMaybe<SortEnumType>;
  mySqlDatabase?: InputMaybe<SortEnumType>;
  mySqlEndpoint?: InputMaybe<SortEnumType>;
  mySqlPassword?: InputMaybe<SortEnumType>;
  mySqlUsername?: InputMaybe<SortEnumType>;
  orderEaseBaseUrl?: InputMaybe<SortEnumType>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: InputMaybe<SortEnumType>;
  realmId?: InputMaybe<SortEnumType>;
  refreshToken?: InputMaybe<SortEnumType>;
  refreshTokenExpiresAt?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type TenantIntegrationTokenDocument = {
  __typename?: 'TenantIntegrationTokenDocument';
  accessToken: Scalars['String']['output'];
  accessTokenExpiration: Scalars['DateTime']['output'];
  /** Composite ID: {tenantId}-{integrationId} */
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantIntegrationTokenDocumentFilterInput = {
  accessToken?: InputMaybe<StringOperationFilterInput>;
  accessTokenExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TenantIntegrationTokenDocumentFilterInput>>;
  /** Composite ID: {tenantId}-{integrationId} */
  id?: InputMaybe<StringOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TenantIntegrationTokenDocumentFilterInput>>;
  refreshToken?: InputMaybe<StringOperationFilterInput>;
  refreshTokenExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type TenantIntegrationTokenDocumentSortInput = {
  accessToken?: InputMaybe<SortEnumType>;
  accessTokenExpiration?: InputMaybe<SortEnumType>;
  /** Composite ID: {tenantId}-{integrationId} */
  id?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  refreshToken?: InputMaybe<SortEnumType>;
  refreshTokenExpiration?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type TenantIntegrationTokensPayload = {
  __typename?: 'TenantIntegrationTokensPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<TenantIntegrationTokensStateData>;
};

export type TenantIntegrationTokensStateData = {
  __typename?: 'TenantIntegrationTokensStateData';
  accessToken: Scalars['String']['output'];
  accessTokenExpiration: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
};

export type TenantOverrideDataInput = {
  config: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
};

/** MongoDB sub-document representing a tenant-specific feature flag override. */
export type TenantOverrideDocument = {
  __typename?: 'TenantOverrideDocument';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantPayload = {
  __typename?: 'TenantPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenant?: Maybe<TenantStateData>;
};

/** GraphQL-facing snapshot of a tenant's pricing page state after a successful mutation. */
export type TenantPricingPageData = {
  __typename?: 'TenantPricingPageData';
  content: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model for a tenant's personalized pricing page.
 * One document per tenant. Projected from the TenantPricingPage-{TenantId} stream.
 */
export type TenantPricingPageDocument = {
  __typename?: 'TenantPricingPageDocument';
  /** Full HTML/text content shown to growers on the pricing page. */
  content: Scalars['String']['output'];
  /** Mongo id; also the tenant id (one document per tenant). */
  id: Scalars['String']['output'];
  /** The tenant this pricing page belongs to. Equal to Id. */
  tenantId: Scalars['String']['output'];
  /** Timestamp of the last upsert. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Mutation payload for TenantPricingPage upsert/delete. */
export type TenantPricingPagePayload = {
  __typename?: 'TenantPricingPagePayload';
  data?: Maybe<TenantPricingPageData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * MongoDB read-model document for a tenant's route configuration — the tier-0 default of the
 * hierarchical route setting. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes so that invariant can
 * evolve without breaking call sites. Mirrors TenantTaxConfigDocument.
 */
export type TenantRouteConfigDocument = {
  __typename?: 'TenantRouteConfigDocument';
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  route: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantRouteConfigPayload = {
  __typename?: 'TenantRouteConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenantRouteConfig?: Maybe<TenantRouteConfigStateData>;
};

export type TenantRouteConfigStateData = {
  __typename?: 'TenantRouteConfigStateData';
  route: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * GraphQL view of a tenant's custom SMTP connection. Carries the configuration and verification status
 * but NEVER the password (encrypted or otherwise) — the password lives only in the aggregate and the
 * non-exposed read model, read solely by the SMTP sender worker.
 */
export type TenantSmtpConnectionData = {
  __typename?: 'TenantSmtpConnectionData';
  /** Gets the configured from-address list. */
  addresses: Array<SmtpSenderAddressData>;
  /** Gets the from-mode governing which addresses are usable. */
  fromMode: SmtpFromMode;
  /** Gets the SMTP server host. */
  host: Scalars['String']['output'];
  /** Gets a sanitized (non-secret) description of the last verification failure, or None. */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp of the last successful verification, or None if never verified. */
  lastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the SMTP server port. */
  port: Scalars['Int']['output'];
  /** Gets the verification status. */
  status: SmtpConnectionStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the connection. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the SMTP AUTH username. */
  username: Scalars['String']['output'];
};

/** Payload returned from tenant SMTP connection mutations (never carries the password). */
export type TenantSmtpConnectionPayload = {
  __typename?: 'TenantSmtpConnectionPayload';
  connection?: Maybe<TenantSmtpConnectionData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type TenantStateData = {
  __typename?: 'TenantStateData';
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Per-tenant platform-billing state (Stripe linkage, per-tenant rate card, active cadence,
   * subscription status, and most-recent payment). Always present; defaults to an empty
   * (unconfigured) billing state for tenants with no billing events in their stream. This is the
   * surface the worksuite-pwa Billing page reads.
   */
  billing: TenantBillingData;
  created: Scalars['DateTime']['output'];
  /** The tenant-level default freight charge type. */
  defaultFreightChargeType?: Maybe<FreightChargeType>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Per-tenant default weeks-of-supply applied by the Restock dashboard's
   * restockDailyDemand query when no explicit override is supplied.
   * Default: TenantState.DefaultWeeksOfSupplyDefault.
   */
  defaultWeeksOfSupply: Scalars['Decimal']['output'];
  /**
   * Per-document-type render mode overrides the tenant has explicitly set (invoice/confirmation,
   * acknowledgement, credit). Only configured doc types appear; a doc type absent here resolves to
   * the RenderMode.Legacy default. Read effectiveDocumentRenderModes for the resolved
   * value across every doc type.
   */
  documentRenderModes: Array<DocumentRenderModeData>;
  /** Effective render mode for every order document type (invoice/confirmation, acknowledgement, credit): the tenant's configured value, or Legacy when unset. Read by the render-time email workers to choose the legacy QuestPDF generator vs the report engine (Parallel renders both). */
  effectiveDocumentRenderModes: Array<DocumentRenderModeData>;
  /** Order acknowledgement report id the PWA should render: the tenant's configured value, or the seeded Order Acknowledgement template when unconfigured. */
  effectiveOrderAcknowledgementReportId: Scalars['String']['output'];
  /** Whether order/confirmation/acknowledgement emails are enabled for the tenant: the tenant's configured value, or false (opt-in) when unconfigured. */
  effectiveOrderEmailsEnabled: Scalars['Boolean']['output'];
  /** Order invoice report id the PWA should render: the tenant's configured value, or the seeded Professional Invoice template when unconfigured. */
  effectiveOrderInvoiceReportId: Scalars['String']['output'];
  finalCreditEnabled: Scalars['Boolean']['output'];
  /**
   * Per-tenant custom display labels for inventory grades 1–5 (display layer only — grade values
   * stay int 1–5). Only grades the tenant has labelled appear here; an empty list means no custom
   * labels are configured and consumers fall back to the numeric grade client-side.
   */
  gradeLabels: Array<TenantGradeLabelData>;
  integrations: Array<TenantIntegrationData>;
  /** True when the tenant is on a self-serve trial — i.e. a trialExpirationDate is present. False for real (non-trial) tenants. */
  isTrial: Scalars['Boolean']['output'];
  maxDiscountPercentage: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF. Empty string means
   * no report is configured. Ignored for BPF, which retains the hardcoded Bonnie PDF.
   */
  orderAcknowledgementReportId: Scalars['String']['output'];
  /**
   * Tenant-level opt-in master switch for order/confirmation/acknowledgement emails. Null
   * means the tenant has never configured this setting — the Settings page shows "not
   * configured" for that state. Read effectiveOrderEmailsEnabled for the resolved
   * value the wsapi-services email workers act on.
   */
  orderEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Timestamp of the most recent transition of orderEmailsEnabled into true —
   * the enablement cutoff the wsapi-services email worker filters orders on so enabling a
   * tenant never blasts its historical backlog. Null means the tenant has never been enabled.
   */
  orderEmailsEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF. Empty string means
   * no report is configured. Ignored for BPF, which retains the hardcoded Bonnie PDF.
   */
  orderInvoiceReportId: Scalars['String']['output'];
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * OrganicReceiveMode.Warn surfaces a warning and allows submit;
   * OrganicReceiveMode.Block denies submit with a ValidationError.
   * Defaults to OrganicReceiveMode.Warn for back-compat with existing
   * tenants. New tenants are flipped to OrganicReceiveMode.Block when
   * AddTenant chains the corresponding event.
   */
  organicReceiveMode: OrganicReceiveMode;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers. Defaults to
   * 64 — current/unchanged behavior for every tenant that has not configured this.
   */
  poNumberMaxLength: Scalars['Int']['output'];
  /** None when no branding has been configured; OptionTypeInterceptor rewrites to nullable at the GraphQL schema boundary. */
  portalBranding?: Maybe<PortalBrandingData>;
  produceEnabled: Scalars['Boolean']['output'];
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled: Scalars['Boolean']['output'];
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours: Scalars['Int']['output'];
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours: Scalars['Int']['output'];
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey: Scalars['String']['output'];
  status: TenantStatus;
  /**
   * When true, the order tax engine folds each line's royalty into the taxable base.
   * Default OFF — most tenants do NOT tax royalty.
   */
  taxRoyaltyEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Which trial policy the tenant runs under. Null means no kind was ever stamped — consumers
   * MUST read that as Standard, the restrictive default, so trials provisioned before this
   * field existed stay bounded without a backfill. Only meaningful alongside
   * TrialExpirationDate, which is what marks a tenant as a trial in the first place.
   */
  trialKind?: Maybe<TrialKind>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means no overrides at all; a null
   * category inside the object means that one category uses the TrialPolicy default. Null is
   * never "unlimited".
   */
  trialLimits?: Maybe<TrialLimitsData>;
  /** Per-tenant unit configuration for the restock / replenishment pipeline. */
  unitConfig: TenantUnitConfigData;
  useErpPricing: Scalars['Boolean']['output'];
  /**
   * Tenant-level Verify routing preference read by worksuite-pwa to decide worker Finished
   * behavior. VerifyMode.Staged (default) routes submits to the supervisor review queue;
   * VerifyMode.Direct is owner-operator mode. Defaults to VerifyMode.Staged for
   * tenants with no TenantVerifyModeUpdated event in their stream.
   */
  verifyMode: VerifyMode;
};

export enum TenantStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type TenantStatusOperationFilterInput = {
  eq?: InputMaybe<TenantStatus>;
  in?: InputMaybe<Array<TenantStatus>>;
  neq?: InputMaybe<TenantStatus>;
  nin?: InputMaybe<Array<TenantStatus>>;
};

/** GraphQL + read-model projection of a single subscription line item (TenantSubscriptionItem). */
export type TenantSubscriptionItemData = {
  __typename?: 'TenantSubscriptionItemData';
  priceId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subscriptionItemId: Scalars['String']['output'];
};

/** GraphQL + read-model projection of a single subscription line item (TenantSubscriptionItem). */
export type TenantSubscriptionItemDataFilterInput = {
  and?: InputMaybe<Array<TenantSubscriptionItemDataFilterInput>>;
  or?: InputMaybe<Array<TenantSubscriptionItemDataFilterInput>>;
  priceId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  subscriptionItemId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a tenant's tax configuration. There is exactly
 * one document per tenant; Id equals TenantId today,
 * but use GetDocumentId for all reads/writes so that invariant can
 * evolve without breaking call sites.
 */
export type TenantTaxConfigDocument = {
  __typename?: 'TenantTaxConfigDocument';
  defaultAuthorityIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

export type TenantTaxConfigPayload = {
  __typename?: 'TenantTaxConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenantTaxConfig?: Maybe<TenantTaxConfigStateData>;
};

export type TenantTaxConfigStateData = {
  __typename?: 'TenantTaxConfigStateData';
  defaultAuthorityIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type TenantUnitConfigData = {
  __typename?: 'TenantUnitConfigData';
  dailyInventoryStateIngestUnit: ReplenishmentUnit;
  dailyTransactionSummaryIngestUnit: ReplenishmentUnit;
  erpAvailabilityIngestUnit: ReplenishmentUnit;
  erpInTransitIngestUnit: ReplenishmentUnit;
  inventoryItemIngestUnit: ReplenishmentUnit;
  restockViewDisplayUnit: ReplenishmentUnit;
};

export type TenantUnitConfigDataFilterInput = {
  and?: InputMaybe<Array<TenantUnitConfigDataFilterInput>>;
  dailyInventoryStateIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  dailyTransactionSummaryIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  erpAvailabilityIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  erpInTransitIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  inventoryItemIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  or?: InputMaybe<Array<TenantUnitConfigDataFilterInput>>;
  restockViewDisplayUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
};

export type TenantUnitConfigDataInput = {
  dailyInventoryStateIngestUnit: ReplenishmentUnit;
  dailyTransactionSummaryIngestUnit: ReplenishmentUnit;
  erpAvailabilityIngestUnit: ReplenishmentUnit;
  erpInTransitIngestUnit: ReplenishmentUnit;
  inventoryItemIngestUnit: ReplenishmentUnit;
  restockViewDisplayUnit: ReplenishmentUnit;
};

export type TenantUnitConfigDataSortInput = {
  dailyInventoryStateIngestUnit?: InputMaybe<SortEnumType>;
  dailyTransactionSummaryIngestUnit?: InputMaybe<SortEnumType>;
  erpAvailabilityIngestUnit?: InputMaybe<SortEnumType>;
  erpInTransitIngestUnit?: InputMaybe<SortEnumType>;
  inventoryItemIngestUnit?: InputMaybe<SortEnumType>;
  restockViewDisplayUnit?: InputMaybe<SortEnumType>;
};

export type TenantValueData = {
  __typename?: 'TenantValueData';
  tenantId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TenantValueDataInput = {
  tenantId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TenantValueStateData = {
  __typename?: 'TenantValueStateData';
  tenantId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TermsConnection = {
  __typename?: 'TermsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TermsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TermsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type TermsDocument = {
  __typename?: 'TermsDocument';
  accrueInterestPercentage: Scalars['Decimal']['output'];
  discountDays: Scalars['Int']['output'];
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: TermsStatus;
  tenantId: Scalars['String']['output'];
  termLimitDays: Scalars['Int']['output'];
  termsId: Scalars['String']['output'];
};

export type TermsDocumentFilterInput = {
  accrueInterestPercentage?: InputMaybe<PercentValueOperationFilterInput>;
  and?: InputMaybe<Array<TermsDocumentFilterInput>>;
  discountDays?: InputMaybe<IntOperationFilterInput>;
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TermsDocumentFilterInput>>;
  status?: InputMaybe<TermsStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termLimitDays?: InputMaybe<IntOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
};

export type TermsDocumentSortInput = {
  accrueInterestPercentage?: InputMaybe<SortEnumType>;
  discountDays?: InputMaybe<SortEnumType>;
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termLimitDays?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type TermsEdge = {
  __typename?: 'TermsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TermsDocument;
};

/**
 * A single erpId-to-termsId resolution returned by the termsIdsByErpId query.
 * Single-purpose by design (per the wsapi single-use type convention) — do not reuse for other surfaces.
 */
export type TermsErpIdPair = {
  __typename?: 'TermsErpIdPair';
  erpId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
};

export type TermsPayload = {
  __typename?: 'TermsPayload';
  errors?: Maybe<Array<ValidationError>>;
  terms?: Maybe<TermsStateData>;
};

/**
 * Per-row failure surfaced by validateTermsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError implements IFieldValidationError, otherwise null.
 */
export type TermsStagedRowError = {
  __typename?: 'TermsStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type TermsStateData = {
  __typename?: 'TermsStateData';
  /**
   * Annual interest rate as a percent value (5 means 5%), not a fraction. Internally
   * the domain stores the fraction form (0.05); this field is boundary-converted at the
   * API edge so callers send and receive percent values.
   */
  accrueInterestPercentage: Scalars['Decimal']['output'];
  discountDays: Scalars['Int']['output'];
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa.
   */
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: TermsStatus;
  tenantId: Scalars['String']['output'];
  termLimitDays: Scalars['Int']['output'];
};

export enum TermsStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type TermsStatusOperationFilterInput = {
  eq?: InputMaybe<TermsStatus>;
  in?: InputMaybe<Array<TermsStatus>>;
  neq?: InputMaybe<TermsStatus>;
  nin?: InputMaybe<Array<TermsStatus>>;
};

/** GraphQL data type for task assignment time entries. */
export type TimeEntryData = {
  __typename?: 'TimeEntryData';
  createdBy: Scalars['String']['output'];
  duration: Scalars['TimeSpan']['output'];
  endTime: Scalars['DateTime']['output'];
  headcount: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  timeEntryId: Scalars['String']['output'];
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocument = {
  __typename?: 'TimeEntryDocument';
  /** Task ID from ClickUp */
  clickUpTaskId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Customer ID from ClickUp */
  customerId: Scalars['String']['output'];
  /** Date of work performed */
  entryDate: Scalars['DateTime']['output'];
  /** Total hours worked (not incremental) */
  hoursWorked: Scalars['Decimal']['output'];
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id: Scalars['String']['output'];
  /** Developer notes about work */
  notes: Scalars['String']['output'];
  /** Project ID from ClickUp */
  projectId: Scalars['String']['output'];
  /** Task title for display */
  taskTitle: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Last modified timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** User email address */
  userId: Scalars['String']['output'];
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocumentFilterInput = {
  and?: InputMaybe<Array<TimeEntryDocumentFilterInput>>;
  /** Task ID from ClickUp */
  clickUpTaskId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Customer ID from ClickUp */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** Date of work performed */
  entryDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Total hours worked (not incremental) */
  hoursWorked?: InputMaybe<DecimalOperationFilterInput>;
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Developer notes about work */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TimeEntryDocumentFilterInput>>;
  /** Project ID from ClickUp */
  projectId?: InputMaybe<StringOperationFilterInput>;
  /** Task title for display */
  taskTitle?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Last modified timestamp */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User email address */
  userId?: InputMaybe<StringOperationFilterInput>;
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocumentSortInput = {
  /** Task ID from ClickUp */
  clickUpTaskId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  /** Customer ID from ClickUp */
  customerId?: InputMaybe<SortEnumType>;
  /** Date of work performed */
  entryDate?: InputMaybe<SortEnumType>;
  /** Total hours worked (not incremental) */
  hoursWorked?: InputMaybe<SortEnumType>;
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id?: InputMaybe<SortEnumType>;
  /** Developer notes about work */
  notes?: InputMaybe<SortEnumType>;
  /** Project ID from ClickUp */
  projectId?: InputMaybe<SortEnumType>;
  /** Task title for display */
  taskTitle?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Last modified timestamp */
  updatedAt?: InputMaybe<SortEnumType>;
  /** User email address */
  userId?: InputMaybe<SortEnumType>;
};

/** Upsert operation result */
export type TimeEntryPayload = {
  __typename?: 'TimeEntryPayload';
  errors?: Maybe<Array<ValidationError>>;
  timeEntries?: Maybe<Array<TimeEntryDocument>>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']['input']>;
  gt?: InputMaybe<Scalars['TimeSpan']['input']>;
  gte?: InputMaybe<Scalars['TimeSpan']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']['input']>;
  lte?: InputMaybe<Scalars['TimeSpan']['input']>;
  neq?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngt?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngte?: InputMaybe<Scalars['TimeSpan']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']['input']>;
  nlte?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export enum TimeZoneProvenance {
  Derived = 'DERIVED',
  Explicit = 'EXPLICIT',
  Unset = 'UNSET'
}

export type TimeZoneProvenanceOperationFilterInput = {
  eq?: InputMaybe<TimeZoneProvenance>;
  in?: InputMaybe<Array<TimeZoneProvenance>>;
  neq?: InputMaybe<TimeZoneProvenance>;
  nin?: InputMaybe<Array<TimeZoneProvenance>>;
};

export type ToggleItemUpgradeDefaultInput = {
  isDefault: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  upgradeId: Scalars['String']['input'];
};

export type ToggleSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  enable: Scalars['Boolean']['input'];
};

export type ToggleSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  enable: Scalars['Boolean']['input'];
};

export enum TransformType {
  NotSet = 'NOT_SET',
  Regex = 'REGEX'
}

export type TransformTypeOperationFilterInput = {
  eq?: InputMaybe<TransformType>;
  in?: InputMaybe<Array<TransformType>>;
  neq?: InputMaybe<TransformType>;
  nin?: InputMaybe<Array<TransformType>>;
};

/** Where a tenant sits against one capped category. */
export type TrialCategoryUsage = {
  __typename?: 'TrialCategoryUsage';
  /** The capped category. */
  category: TrialLimitCategory;
  /**
   * The tenant's current usage, absent when the count could not be read. Absent means UNKNOWN and is
   * never a synonym for zero — a transient datastore failure yields no count, and reporting that as
   * 0 would tell an operator a trial is empty when it may be full.
   */
  current?: Maybe<Scalars['Long']['output']>;
  /**
   * The cap in force — the tenant's own override when it has one, else the trial policy default for
   * its kind. Absent means NO CAP APPLIES: either the tenant is exempt (a Migrator trial, flagged by
   * capsExempt) or its kind has no policy configured. A cap of 0 is legal and distinct from absent:
   * it means "may not create any".
   */
  effectiveCap?: Maybe<Scalars['Int']['output']>;
};

export enum TrialKind {
  Migrator = 'MIGRATOR',
  Standard = 'STANDARD'
}

/** What one run of the trial-kind backfill did. */
export type TrialKindBackfillPayload = {
  __typename?: 'TrialKindBackfillPayload';
  /**
   * One entry per tenant whose stamp failed. A failure does not abort the run: the remaining tenants
   * are still stamped, and re-running picks up whatever was left behind.
   */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * In-scope trial tenants that already carried a kind and were left exactly as they were. Non-trial
   * and deleted tenants are not in scope at all and are counted in neither number.
   */
  skipped: Scalars['Int']['output'];
  /** Trial tenants this run stamped Standard. Zero on a re-run — everything already carries a kind. */
  stamped: Scalars['Int']['output'];
  /**
   * The tenants this run stamped, so an operator knows exactly which ones to review. Nothing
   * distinguishes a migrating customer's trial from an ordinary one retroactively, so every kind-less
   * trial is stamped Standard — the restrictive kind — and known migrators are re-flagged afterwards
   * from the Trial Tenants grid. That re-flag is a deliberate manual follow-up, not automation.
   */
  stampedTenantIds: Array<Scalars['String']['output']>;
};

/**
 * The thirteen capped resource categories a Standard trial tenant runs under. Each member pairs
 * one-for-one with a property on BOTH the trial policy limits (the per-trial-kind policy default)
 * and the per-tenant trial limit overrides. Cap resolution is the single place that pairing is
 * expressed.
 */
export enum TrialLimitCategory {
  /** Customers (CustomersSummary read model). */
  Customers = 'CUSTOMERS',
  /** Inventory items (InventoryItems read model). */
  InventoryItems = 'INVENTORY_ITEMS',
  /** Catalog items (ItemSummary read model). */
  Items = 'ITEMS',
  /** Material items (MaterialItem read model). */
  MaterialItems = 'MATERIAL_ITEMS',
  /** Orders (Orders read model). */
  Orders = 'ORDERS',
  /** Price groups (PriceGroups read model). */
  PriceGroups = 'PRICE_GROUPS',
  /** Price levels (PriceLevels read model), tenant-wide across all price groups. */
  PriceLevels = 'PRICE_LEVELS',
  /** Production lots (ProductionLots read model). */
  ProductionLots = 'PRODUCTION_LOTS',
  /** Production recipes (ProductionRecipes read model). */
  ProductionRecipes = 'PRODUCTION_RECIPES',
  /** Seats — directory users PLUS still-pending user invites (two collections). */
  Seats = 'SEATS',
  /** Site locations (SiteLocations read model). */
  SiteLocations = 'SITE_LOCATIONS',
  /**
   * Child locations under a SINGLE site (SubLocations read model). Unlike every other
   * category this cap is per-site, not tenant-wide.
   */
  SiteLocationChildrenPerSite = 'SITE_LOCATION_CHILDREN_PER_SITE',
  /** Vendors (Vendor read model). */
  Vendors = 'VENDORS'
}

export type TrialLimitsData = {
  __typename?: 'TrialLimitsData';
  customers?: Maybe<Scalars['Int']['output']>;
  inventoryItems?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  materialItems?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  priceGroups?: Maybe<Scalars['Int']['output']>;
  priceLevels?: Maybe<Scalars['Int']['output']>;
  productionLots?: Maybe<Scalars['Int']['output']>;
  productionRecipes?: Maybe<Scalars['Int']['output']>;
  seats?: Maybe<Scalars['Int']['output']>;
  siteLocationChildrenPerSite?: Maybe<Scalars['Int']['output']>;
  siteLocations?: Maybe<Scalars['Int']['output']>;
  vendors?: Maybe<Scalars['Int']['output']>;
};

export type TrialLimitsDataFilterInput = {
  and?: InputMaybe<Array<TrialLimitsDataFilterInput>>;
  customers?: InputMaybe<IntOperationFilterInput>;
  inventoryItems?: InputMaybe<IntOperationFilterInput>;
  items?: InputMaybe<IntOperationFilterInput>;
  materialItems?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TrialLimitsDataFilterInput>>;
  orders?: InputMaybe<IntOperationFilterInput>;
  priceGroups?: InputMaybe<IntOperationFilterInput>;
  priceLevels?: InputMaybe<IntOperationFilterInput>;
  productionLots?: InputMaybe<IntOperationFilterInput>;
  productionRecipes?: InputMaybe<IntOperationFilterInput>;
  seats?: InputMaybe<IntOperationFilterInput>;
  siteLocationChildrenPerSite?: InputMaybe<IntOperationFilterInput>;
  siteLocations?: InputMaybe<IntOperationFilterInput>;
  vendors?: InputMaybe<IntOperationFilterInput>;
};

export type TrialLimitsDataInput = {
  customers?: InputMaybe<Scalars['Int']['input']>;
  inventoryItems?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Scalars['Int']['input']>;
  materialItems?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Scalars['Int']['input']>;
  priceGroups?: InputMaybe<Scalars['Int']['input']>;
  priceLevels?: InputMaybe<Scalars['Int']['input']>;
  productionLots?: InputMaybe<Scalars['Int']['input']>;
  productionRecipes?: InputMaybe<Scalars['Int']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  siteLocationChildrenPerSite?: InputMaybe<Scalars['Int']['input']>;
  siteLocations?: InputMaybe<Scalars['Int']['input']>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
};

export type TrialLimitsDataSortInput = {
  customers?: InputMaybe<SortEnumType>;
  inventoryItems?: InputMaybe<SortEnumType>;
  items?: InputMaybe<SortEnumType>;
  materialItems?: InputMaybe<SortEnumType>;
  orders?: InputMaybe<SortEnumType>;
  priceGroups?: InputMaybe<SortEnumType>;
  priceLevels?: InputMaybe<SortEnumType>;
  productionLots?: InputMaybe<SortEnumType>;
  productionRecipes?: InputMaybe<SortEnumType>;
  seats?: InputMaybe<SortEnumType>;
  siteLocationChildrenPerSite?: InputMaybe<SortEnumType>;
  siteLocations?: InputMaybe<SortEnumType>;
  vendors?: InputMaybe<SortEnumType>;
};

/**
 * MongoDB read model document for one trial kind's policy — the feature flags a trial of that kind
 * may turn on, and the default creation caps it runs under. One document per
 * TrialKind, keyed by the kind name.
 */
export type TrialPolicyDocument = {
  __typename?: 'TrialPolicyDocument';
  /**
   * The flags a trial of this kind may turn on. DEFAULT-DENY — a flag absent from this list is off
   * for the trial regardless of the tenant's own feature-flag overrides.
   */
  allowedFeatureFlags: Array<FeatureFlagName>;
  /**
   * The default creation caps for this kind. A tenant's own trialLimits override wins per
   * category; categories it leaves unset fall through to these values.
   */
  defaultLimits: TrialPolicyLimitsData;
  id: Scalars['String']['output'];
  kind: TrialKind;
};

export type TrialPolicyLimitsData = {
  __typename?: 'TrialPolicyLimitsData';
  customers: Scalars['Int']['output'];
  inventoryItems: Scalars['Int']['output'];
  items: Scalars['Int']['output'];
  materialItems: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  priceGroups: Scalars['Int']['output'];
  priceLevels: Scalars['Int']['output'];
  productionLots: Scalars['Int']['output'];
  productionRecipes: Scalars['Int']['output'];
  seats: Scalars['Int']['output'];
  siteLocationChildrenPerSite: Scalars['Int']['output'];
  siteLocations: Scalars['Int']['output'];
  vendors: Scalars['Int']['output'];
};

export type TrialPolicyLimitsDataInput = {
  customers: Scalars['Int']['input'];
  inventoryItems: Scalars['Int']['input'];
  items: Scalars['Int']['input'];
  materialItems: Scalars['Int']['input'];
  orders: Scalars['Int']['input'];
  priceGroups: Scalars['Int']['input'];
  priceLevels: Scalars['Int']['input'];
  productionLots: Scalars['Int']['input'];
  productionRecipes: Scalars['Int']['input'];
  seats: Scalars['Int']['input'];
  siteLocationChildrenPerSite: Scalars['Int']['input'];
  siteLocations: Scalars['Int']['input'];
  vendors: Scalars['Int']['input'];
};

/** Data projection of trial policy state returned in mutation payloads. */
export type TrialPolicyStateData = {
  __typename?: 'TrialPolicyStateData';
  allowedFeatureFlags: Array<FeatureFlagName>;
  defaultLimits: TrialPolicyLimitsData;
  kind: TrialKind;
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocument = {
  __typename?: 'TrialRequestDocument';
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contactFirstName: Scalars['String']['output'];
  contactLastName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId: Scalars['String']['output'];
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedTenantId: Scalars['String']['output'];
  matchCandidates: Array<MatchCandidateDocument>;
  normalizedCompany: Scalars['String']['output'];
  normalizedEmail: Scalars['String']['output'];
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: Maybe<Scalars['String']['output']>;
  provisionedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId: Scalars['String']['output'];
  provisioningFailedAt?: Maybe<Scalars['DateTime']['output']>;
  provisioningStartedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason: Scalars['String']['output'];
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId: Scalars['String']['output'];
  requestedModules: Array<Scalars['String']['output']>;
  resolvedBy: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status: Scalars['Int']['output'];
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode: Scalars['String']['output'];
  trialDays: Scalars['Int']['output'];
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocumentFilterInput = {
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TrialRequestDocumentFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  contactFirstName?: InputMaybe<StringOperationFilterInput>;
  contactLastName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId?: InputMaybe<StringOperationFilterInput>;
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  linkedTenantId?: InputMaybe<StringOperationFilterInput>;
  matchCandidates?: InputMaybe<ListFilterInputTypeOfMatchCandidateDocumentFilterInput>;
  normalizedCompany?: InputMaybe<StringOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrialRequestDocumentFilterInput>>;
  provisionedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId?: InputMaybe<StringOperationFilterInput>;
  provisioningFailedAt?: InputMaybe<DateTimeOperationFilterInput>;
  provisioningStartedAt?: InputMaybe<DateTimeOperationFilterInput>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId?: InputMaybe<StringOperationFilterInput>;
  requestedModules?: InputMaybe<ListStringOperationFilterInput>;
  resolvedBy?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<StringOperationFilterInput>;
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status?: InputMaybe<IntOperationFilterInput>;
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode?: InputMaybe<StringOperationFilterInput>;
  trialDays?: InputMaybe<IntOperationFilterInput>;
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocumentSortInput = {
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  contactFirstName?: InputMaybe<SortEnumType>;
  contactLastName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId?: InputMaybe<SortEnumType>;
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  linkedTenantId?: InputMaybe<SortEnumType>;
  normalizedCompany?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: InputMaybe<SortEnumType>;
  provisionedAt?: InputMaybe<SortEnumType>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId?: InputMaybe<SortEnumType>;
  provisioningFailedAt?: InputMaybe<SortEnumType>;
  provisioningStartedAt?: InputMaybe<SortEnumType>;
  rejectionReason?: InputMaybe<SortEnumType>;
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId?: InputMaybe<SortEnumType>;
  resolvedBy?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status?: InputMaybe<SortEnumType>;
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode?: InputMaybe<SortEnumType>;
  trialDays?: InputMaybe<SortEnumType>;
};

/** Superadmin resolve payload (full request document). */
export type TrialRequestPayload = {
  __typename?: 'TrialRequestPayload';
  errors?: Maybe<Array<ValidationError>>;
  trialRequest?: Maybe<TrialRequestDocument>;
};

/** How a superadmin is resolving a pending trial request. */
export enum TrialRequestResolution {
  Approve = 'APPROVE',
  LinkToExisting = 'LINK_TO_EXISTING',
  Reject = 'REJECT'
}

/** Anonymous status view — coarse status keyed by the caller's own request id ONLY. */
export type TrialRequestStatusView = {
  __typename?: 'TrialRequestStatusView';
  requestId: Scalars['String']['output'];
  status: TrialSignupPublicStatus;
};

/** A connection to a list of items. */
export type TrialRequestsConnection = {
  __typename?: 'TrialRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TrialRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TrialRequestDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrialRequestsEdge = {
  __typename?: 'TrialRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TrialRequestDocument;
};

/** Coarse lifecycle status exposed to the anonymous status probe (no PII, no candidates). */
export enum TrialSignupPublicStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/**
 * How many child locations one of the tenant's sites holds. The child-location cap is measured per
 * site, so the drawer needs this breakdown rather than a single tenant-wide number.
 */
export type TrialSiteChildUsage = {
  __typename?: 'TrialSiteChildUsage';
  /** Child locations currently under that site. */
  children: Scalars['Int']['output'];
  /** The parent site. */
  siteLocationId: Scalars['String']['output'];
};

/**
 * One trial tenant's stewardship snapshot: where it sits against every capped category, how many
 * seats it consumes, and how recently it was used. Read-only and assembled per request — it is not
 * a stored read model.
 */
export type TrialTenantUsage = {
  __typename?: 'TrialTenantUsage';
  /**
   * True when the creation caps do not apply to this tenant, which today means a Migrator trial.
   * Every effective cap is then absent; this flag says WHY, so the grid can render "exempt" instead
   * of a blank cap it has to explain.
   */
  capsExempt: Scalars['Boolean']['output'];
  /**
   * One entry per capped category — always all of them, in a stable order, so the grid can bind a
   * fixed column set.
   */
  categories: Array<TrialCategoryUsage>;
  /**
   * A cheap freshness signal, NOT an activity system: the most recent order initialization timestamp
   * for the tenant, absent when it has never created an order. Orders were chosen because they are
   * the one high-signal tenant artifact already indexed so that "newest first" costs nothing.
   */
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  /** The tenant's display name, so the grid needs no second lookup. */
  name: Scalars['String']['output'];
  /**
   * Seats consumed: provisioned users PLUS still-pending invites. Deliberately the same number as
   * the seats entry in the categories list (it is read from it, not counted again) — surfaced as its
   * own field because seats are a headline grid column and should not require the client to search
   * the category list.
   */
  seats?: Maybe<Scalars['Long']['output']>;
  /**
   * Per-site child-location counts, for the drawer. One entry per site that has at least one child;
   * a site with no children is omitted rather than reported as zero. The per-site child category
   * reports the MAXIMUM across these, because that cap is per-site and the worst site is the one
   * that will hit it first.
   */
  siteChildCounts: Array<TrialSiteChildUsage>;
  /** The tenant this snapshot describes. */
  tenantId: Scalars['String']['output'];
  /**
   * When an administrator recorded the expired trial's data as deleted; absent when no deletion has
   * been stamped. Separates "expired, data still present" from "expired and cleaned up".
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the trial expires. Always present here — its presence is what selected the tenant into this
   * query at all.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The kind the trial actually runs under. Resolved, never absent: a tenant with no stamped kind
   * reports Standard, the restrictive default every enforcement path already applies to it.
   * Consumers must not re-derive this.
   */
  trialKind: TrialKind;
};

export type UnassignMaterialItemToVendorInput = {
  id: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type UndoRestockSessionOrderQuantityOverrideInput = {
  items: Array<RestockOrderQuantityOverrideItemDataInput>;
  sessionId: Scalars['String']['input'];
};

export type UnlinkFusionAuthUserInput = {
  userId: Scalars['String']['input'];
};

/** Input for unlinking one or more production items from their sales items. */
export type UnlinkProductionItemsFromSalesItemInput = {
  productionItemIds: Array<Scalars['String']['input']>;
};

export type UnmapMergeDevTaxRateInput = {
  id: Scalars['String']['input'];
};

export type UnsetDefaultGroupInput = {
  id: Scalars['String']['input'];
};

export type UnsetDefaultVendorInput = {
  id: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type UpdateAcknowledgedQuantityDataInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateAcknowledgedQuantityItemsInput = {
  items: Array<UpdateAcknowledgedQuantityDataInput>;
  orderId: Scalars['String']['input'];
};

export type UpdateAcknowledgedQuantityMasterItemsInput = {
  masterItems: Array<UpdateMasterAcknowledgedQuantityDataInput>;
  masterOrderId: Scalars['String']['input'];
};

export type UpdateAcknowledgmentEmailInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateAllocationTemplateInput = {
  allocationType: AllocationType;
  equalizeWeeksOfSupply: Scalars['Boolean']['input'];
  favorHigherWeight: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  mode: AllocationMode;
  name: Scalars['String']['input'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateAsyncImportJobStatusInput = {
  asyncImportJobId: Scalars['String']['input'];
  status: AsyncImportJobStatus;
};

export type UpdateBillingAddressInput = {
  customerId: Scalars['String']['input'];
  newAddress: CreateAddressInput;
};

export type UpdateBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCartInput = {
  billToAddressCity: Scalars['String']['input'];
  billToAddressCountry: Scalars['String']['input'];
  billToAddressId: Scalars['String']['input'];
  billToAddressLine1: Scalars['String']['input'];
  billToAddressLine2: Scalars['String']['input'];
  billToAddressStateProvince: Scalars['String']['input'];
  billToAddressToName: Scalars['String']['input'];
  billToAddressZipcode: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expectedDeliveryDate: Scalars['DateTime']['input'];
  shipToAddressCity: Scalars['String']['input'];
  shipToAddressCountry: Scalars['String']['input'];
  shipToAddressId: Scalars['String']['input'];
  shipToAddressLine1: Scalars['String']['input'];
  shipToAddressLine2: Scalars['String']['input'];
  shipToAddressStateProvince: Scalars['String']['input'];
  shipToAddressToName: Scalars['String']['input'];
  shipToAddressZipcode: Scalars['String']['input'];
  shopperEmail: Scalars['String']['input'];
  shopperFirstName: Scalars['String']['input'];
  shopperId: Scalars['String']['input'];
  shopperLastName: Scalars['String']['input'];
  shopperPhone: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type UpdateCategoryInput = {
  category: CategoryDataInput;
};

export type UpdateConfigCategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configCategoryId: Scalars['String']['input'];
  defaultSizeUomCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateConfirmationEmailInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateContactInput = {
  contact: ContactDataInput;
  customerId: Scalars['String']['input'];
};

export type UpdateContainerConfigDetailsInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type UpdateCountInput = {
  comment: Scalars['String']['input'];
  countRowId: Scalars['String']['input'];
  grade: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type UpdateCustomerItemAdditionalSkusInput = {
  additionalSkus: Array<Scalars['String']['input']>;
  customerItemId: Scalars['String']['input'];
};

export type UpdateCustomerItemAdditionalUpcsInput = {
  additionalUpcs: Array<Scalars['String']['input']>;
  customerItemId: Scalars['String']['input'];
};

export type UpdateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  isDefault: Scalars['Boolean']['input'];
  retailShelfPrice?: InputMaybe<Scalars['Decimal']['input']>;
  retailShelfPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  sizeUomCode?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerLocationOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type UpdateCustomerLocationSendOrderEmailsInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomerOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
  customerId: Scalars['String']['input'];
};

export type UpdateCustomerSendOrderEmailsInput = {
  customerId: Scalars['String']['input'];
  sendOrderEmails: Scalars['Boolean']['input'];
};

export type UpdateCustomerTypeInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating the tenant-level default freight charge. */
export type UpdateDefaultFreightChargeInput = {
  defaultFreightChargeType?: InputMaybe<FreightChargeType>;
  defaultFreightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateDefaultOrderSubmitterInput = {
  customerId: Scalars['String']['input'];
  orderSubmitter: OrderSubmitterDataInput;
};

export type UpdateDefaultWeeksOfSupplyInput = {
  defaultWeeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateDeliveryScheduleLocationsInput = {
  deliveryScheduleId: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
};

export type UpdateDocumentRenderModeInput = {
  docType: RenderDocType;
  renderMode: RenderMode;
};

export type UpdateErpAvailabilityItemInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpItemId: Scalars['String']['input'];
  inTransitQty: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  mustGoQuantity: Scalars['Int']['input'];
  productGroup: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  stationCode: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type UpdateErpIdInput = {
  erpId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateErpLoadListQuantitiesInput = {
  quantities: Array<UpdateErpLoadListQuantityInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListQuantityInput = {
  containerCode: Scalars['String']['input'];
  containerUtilization: Scalars['Decimal']['input'];
  erpItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  routeCode: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionItemAvailabilityInput = {
  items: Array<UpdateErpAvailabilityItemInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionNameInput = {
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionRoutesInput = {
  routes: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionShipDateInput = {
  sessionId: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
};

export type UpdateErpManagerEmailsInput = {
  emails: Array<ErpManagerEmailDataInput>;
};

export type UpdateFavoritesListInput = {
  description: Scalars['String']['input'];
  favoritesListId: Scalars['String']['input'];
  items: Array<FavoritesListItemDataInput>;
  name: Scalars['String']['input'];
};

export type UpdateFinalCreditEnabledInput = {
  finalCreditEnabled: Scalars['Boolean']['input'];
};

export type UpdateForecastInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  forecastId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  programIds: Array<Scalars['String']['input']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['input'];
  weeklyMetric: ForecastWeeklyMetric;
};

export type UpdateImageUrlInput = {
  imageUrl: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};

export type UpdateImportRowImportResultsInput = {
  asyncImportJobId: Scalars['String']['input'];
  results: Array<RowImportResultInput>;
};

export type UpdateImportRowValidationResultsInput = {
  asyncImportJobId: Scalars['String']['input'];
  results: Array<RowValidationResultInput>;
};

export type UpdateItemAttributesInput = {
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  defaultShippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingConfigCategoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: Scalars['Boolean']['input'];
  usedForRetail: Scalars['Boolean']['input'];
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateItemInput = {
  categories: Array<CategoryDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgrade: ItemUpgradeDataInput;
};

export type UpdateKitInput = {
  containerCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  kitId: Scalars['String']['input'];
  lines: Array<KitLineDataInput>;
  name: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateLineItemContainerCodeDataInput = {
  containerCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateLineItemInput = {
  lineItem: LineItemUpdateDataInput;
  lineNumber: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateLineItemNoteInput = {
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type UpdateLineItemsContainerCodeInput = {
  items: Array<UpdateLineItemContainerCodeDataInput>;
  orderId: Scalars['String']['input'];
};

export type UpdateLocationAddressInput = {
  address: CreateAddressInput;
  locationId: Scalars['String']['input'];
};

export type UpdateLocationInput = {
  customerId: Scalars['String']['input'];
  location: CreateCustomerLocationInput;
};

export type UpdateLocationNameInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMasterAcknowledgedQuantityDataInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateMasterConfirmationEmailInput = {
  emailAddress: Scalars['String']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterLineItemInput = {
  lineItem: MasterLineItemUpdateDataInput;
  lineNumber: Scalars['Int']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderContactInput = {
  contact: MasterOrderContactDataInput;
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderSalesPersonInput = {
  emailAddress: Scalars['String']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderStatusInput = {
  masterOrderId: Scalars['String']['input'];
  status: MasterOrderStatus;
};

export type UpdateMaterialItemDetailsInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMaxDiscountPercentageInput = {
  maxDiscountPercentage: Scalars['Decimal']['input'];
};

export type UpdateMissingItemGroupsInput = {
  orderId: Scalars['String']['input'];
};

export type UpdateMissingMasterItemGroupsInput = {
  masterOrderId: Scalars['String']['input'];
};

export type UpdateOrderAcknowledgementReportInput = {
  orderAcknowledgementReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
};

export type UpdateOrderBillingAddressInput = {
  billingAddress: AddressDataInput;
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateOrderContactInput = {
  contact: OrderContactDataInput;
  orderId: Scalars['String']['input'];
};

export type UpdateOrderEmailsEnabledInput = {
  enabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderInvoiceReportInput = {
  orderInvoiceReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderLocationAddressInput = {
  customerId: Scalars['String']['input'];
  locationAddress: AddressDataInput;
  locationId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateOrderSendOrderEmailsInput = {
  orderId: Scalars['String']['input'];
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderStatusInput = {
  dateUpdatedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['String']['input'];
  status: OrderStatus;
};

export type UpdateOrganicReceiveModeInput = {
  organicReceiveMode: OrganicReceiveMode;
};

/** Input for updating the tenant-configured PO-number max length. */
export type UpdatePoNumberMaxLengthInput = {
  poNumberMaxLength: Scalars['Int']['input'];
};

export type UpdatePortalSettingsInput = {
  availabilityLocationId?: InputMaybe<Scalars['String']['input']>;
  availabilityMinGrade?: InputMaybe<Scalars['Int']['input']>;
  catalogDisplayMode: CatalogDisplayMode;
  companySlug?: InputMaybe<Scalars['String']['input']>;
  includeSellableHardGoods?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount: Scalars['Decimal']['input'];
  portalEnabled: Scalars['Boolean']['input'];
  preferAvailabilityImage?: InputMaybe<Scalars['Boolean']['input']>;
  selfRegistrationEnabled: Scalars['Boolean']['input'];
};

export type UpdatePortalUserInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userType: UserType;
};

export type UpdatePriceGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdatePriceLevelsInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevels: Array<PriceLevelInputDataInput>;
  replaceAllLevels?: Scalars['Boolean']['input'];
};

export type UpdateProduceEnabledInput = {
  produceEnabled: Scalars['Boolean']['input'];
};

export type UpdateProductionCatalogInput = {
  color: Scalars['String']['input'];
  genus: Scalars['String']['input'];
  productionCatalogId: Scalars['String']['input'];
  series: Scalars['String']['input'];
};

export type UpdateProductionCategoryDetailsInput = {
  code: Scalars['String']['input'];
  eaches: Scalars['Int']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type UpdateProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type UpdateProductionJobLocationDataInput = {
  locationId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type UpdateProductionJobLocationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionJobLocationDataInput>;
};

export type UpdateProductionJobLocationPayload = {
  __typename?: 'UpdateProductionJobLocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionLineInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
  productionLineId: Scalars['String']['input'];
};

/**
 * Input for user corrections to row values. Used when user fixes validation errors.
 * Clears any previously resolved IDs since lookups must be re-performed.
 */
export type UpdateProductionLotAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowValuesInput>;
};

export type UpdateProductionLotCustomerDataInput = {
  customerId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type UpdateProductionLotCustomerInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionLotCustomerDataInput>;
};

export type UpdateProductionLotCustomerPayload = {
  __typename?: 'UpdateProductionLotCustomerPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionLotPlanDataInput = {
  productionLotId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type UpdateProductionLotPlanInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionLotPlanDataInput>;
};

export type UpdateProductionLotPlanPayload = {
  __typename?: 'UpdateProductionLotPlanPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionMaterialEventDetailInput = {
  detail: AddProductionMaterialEventDetailsDataInput;
  productionMaterialEventId: Scalars['String']['input'];
};

export type UpdateProductionMaterialEventInput = {
  name: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type UpdateProductionPlanDetailsInput = {
  name: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type UpdateProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variation: ProductionRecipeVariationDataInput;
};

export type UpdateProductionSpaceCategoryDetailsInput = {
  code: Scalars['String']['input'];
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type UpdateProductionSpaceEventDetailInput = {
  detail: AddProductionSpaceEventDetailsDataInput;
  productionSpaceEventId: Scalars['String']['input'];
};

export type UpdateProductionSpaceEventInput = {
  name: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type UpdateProductionSpaceTypeDetailsInput = {
  code: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventAssigneeInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventDetailDataInput = {
  description: Scalars['String']['input'];
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  multiple: Scalars['Decimal']['input'];
  productionTaskEventDetailId: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  taskEventTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventDetailInput = {
  detail: UpdateProductionTaskEventDetailDataInput;
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventInput = {
  name: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTriggerInput = {
  expireBy: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  productionTriggerId: Scalars['String']['input'];
  source: ProductionTriggerSource;
  unit: ProductionTriggerUnit;
};

export type UpdatePromotionRuleInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  promotionRuleId: Scalars['String']['input'];
  quantityFloor: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UpdatePublicScoreResult = {
  __typename?: 'UpdatePublicScoreResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newScore: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateReportInput = {
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  filters: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  handlebarsTemplate: Scalars['String']['input'];
  isStarred: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pageSettings: Scalars['String']['input'];
  parameterConfig: Scalars['String']['input'];
  parameterValues: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};

export type UpdateReportScheduleInput = {
  cronExpression: Scalars['String']['input'];
  docType?: InputMaybe<OrderEmailDocType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  nextRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  outputFormat: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
  reportTemplateId?: InputMaybe<Scalars['String']['input']>;
  runOnce: Scalars['Boolean']['input'];
  scheduleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZoneId: Scalars['String']['input'];
};

export type UpdateReportTemplateInput = {
  category: Scalars['String']['input'];
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  handlebarsTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  tags: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type UpdateReserveRuleInput = {
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  reserveRuleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateRestockSessionInput = {
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateRestockSessionOrderItemInput = {
  achievableQuantity: Scalars['Int']['input'];
  allocatedValue: Scalars['Decimal']['input'];
  available: Scalars['Int']['input'];
  availableValue: Scalars['Decimal']['input'];
  blockingRuleIds: Array<Scalars['String']['input']>;
  carts: Scalars['Decimal']['input'];
  customerLocationId: Scalars['String']['input'];
  daysSinceLastDelivery: Scalars['Int']['input'];
  daysSinceLastSale: Scalars['Int']['input'];
  demandQuantity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  inTransit: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemNumber: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
  promotionRuleIds: Array<Scalars['String']['input']>;
  storeName: Scalars['String']['input'];
  trailingSales: Scalars['Decimal']['input'];
  unitValue: Scalars['Decimal']['input'];
  unitsOnHand: Scalars['Int']['input'];
  unitsOnHandValue: Scalars['Decimal']['input'];
  unitsReplenished: Scalars['Int']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateRestockSessionOrderQuantitiesInput = {
  items: Array<UpdateRestockSessionOrderItemInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateRestockSessionReserveRulesInput = {
  rules: Array<RestockReserveRuleDataInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateRetailPriceInput = {
  itemId: Scalars['String']['input'];
  retailPrice: Scalars['Decimal']['input'];
};

export type UpdateRouteInput = {
  orderId: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSalesPersonInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateSftpAggregationConfigInput = {
  aggregation?: InputMaybe<MongoAggregationConfigDataInput>;
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destination: DestinationConfigDataInput;
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpMongoColumnMapInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  mongoColumns: Array<MongoColumnMapDataInput>;
};

export type UpdateSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destination: MongoDestinationConfigDataInput;
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpSqlColumnMapInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  sqlColumns: Array<SqlColumnMapDataInput>;
};

export type UpdateSftpSystemSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  timerPeriodString: Scalars['String']['input'];
};

export type UpdateSftpTenantConfigInput = {
  batchSize: Scalars['Int']['input'];
  configId: Scalars['String']['input'];
  configName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podId: Scalars['String']['input'];
  sourceDirectory: Scalars['String']['input'];
  sourceEndpoint: Scalars['String']['input'];
  sourceFilePattern: Scalars['String']['input'];
  sourcePassword: Scalars['String']['input'];
  sourcePort: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
  sourceUsername: Scalars['String']['input'];
};

export type UpdateShippedQuantityDataInput = {
  id: Scalars['UUID']['input'];
  shippedQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateShippedQuantityItemsInput = {
  dateShippedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<UpdateShippedQuantityDataInput>;
  orderId: Scalars['String']['input'];
};

/**
 * Input for user corrections to row values. Used when user fixes validation errors.
 * Clears any previously resolved IDs since lookups must be re-performed.
 */
export type UpdateSiteLocationAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowValuesInput>;
};

export type UpdateSiteMapInput = {
  excludeFromDistribution: Scalars['Boolean']['input'];
  siteLocationId: Scalars['String']['input'];
  siteMapId: Scalars['String']['input'];
};

export type UpdateSizeUomInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  eachesPerUnit: Scalars['Int']['input'];
};

export type UpdateSyncAttemptInput = {
  attemptDate: Scalars['DateTime']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type UpdateTaskEventTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskEventTypeId: Scalars['String']['input'];
};

export type UpdateTaxAuthorityInput = {
  code: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  glAccount: Scalars['String']['input'];
  glAccountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Input for updating the tenant-level tax-on-royalty setting. */
export type UpdateTaxRoyaltyInput = {
  taxRoyaltyEnabled: Scalars['Boolean']['input'];
};

export type UpdateTenantBrandingInput = {
  displayName: Scalars['String']['input'];
  logoImage?: InputMaybe<LogoImageDataInput>;
  logoUrl: Scalars['String']['input'];
  palette?: InputMaybe<PortalPaletteDataInput>;
  primaryColorHex: Scalars['String']['input'];
  styleTokens?: InputMaybe<PortalStyleTokensDataInput>;
  tagline: Scalars['String']['input'];
};

export type UpdateTenantGradeLabelsInput = {
  labels: Array<GradeLabelDataInput>;
};

export type UpdateTenantRestockProviderSettingsInput = {
  rosProviderConfig?: InputMaybe<Scalars['String']['input']>;
  rosProviderKey: Scalars['String']['input'];
};

/** Input for updating the per-tenant unit configuration. */
export type UpdateTenantUnitConfigInput = {
  unitConfig: TenantUnitConfigDataInput;
};

export type UpdateTermsIdInput = {
  orderId: Scalars['String']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
};

export type UpdateUseErpPricingInput = {
  useErpPricing: Scalars['Boolean']['input'];
};

export type UpdateUserAppSettingInput = {
  base64Settings: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserFullNameInput = {
  fullName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserRolesInput = {
  roles: Array<UserRole>;
  userId: Scalars['String']['input'];
};

export type UpdateVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateVendorPurchaseOrderSiteLocationInput = {
  siteLocationId: Scalars['String']['input'];
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type UpdateVerifyModeInput = {
  verifyMode: VerifyMode;
};

export type UpdateWsapiImportEntityMappingInput = {
  enabled: Scalars['Boolean']['input'];
  entityMappingId: Scalars['String']['input'];
  entityType: WsapiImportEntityType;
  keySourceField: Scalars['String']['input'];
  keyTargetField: Scalars['String']['input'];
  sourceTable: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type UpdateWsapiImportScheduleInput = {
  scheduleDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  scheduleTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  wsapiImportId: Scalars['String']['input'];
};

export type UploadItemImageInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMergeCrmTenantIntegrationInput = {
  accountToken: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  integrationName?: InputMaybe<Scalars['String']['input']>;
  integrationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMergeTenantIntegrationInput = {
  accountToken: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  integrationName?: InputMaybe<Scalars['String']['input']>;
  integrationSlug?: InputMaybe<Scalars['String']['input']>;
  orderExportTriggerStatus?: OrderExportTriggerStatus;
};

export type UpsertMySqlTenantIntegrationInput = {
  database: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Upsert operation result */
export type UpsertRfidScansPayload = {
  __typename?: 'UpsertRfidScansPayload';
  errors?: Maybe<Array<ValidationError>>;
  rfidScans?: Maybe<Array<RfidScanDocument>>;
};

export type UpsertTenantIntegrationInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiration: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  realmId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiration: Scalars['DateTime']['input'];
  source: IntegrationSource;
};

export type UpsertTenantPricingPageInput = {
  content: Scalars['String']['input'];
};

/** Time entry input data */
export type UpsertTimeEntryInput = {
  clickUpTaskId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  entryDate: Scalars['DateTime']['input'];
  hoursWorked: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  taskTitle: Scalars['String']['input'];
};

export type UpsertTrialPolicyInput = {
  allowedFeatureFlags: Array<FeatureFlagName>;
  defaultLimits: TrialPolicyLimitsDataInput;
  kind: TrialKind;
};

export type UserAppSettingData = {
  __typename?: 'UserAppSettingData';
  appSettingsId: Scalars['String']['output'];
  base64Settings: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type UserAppSettingDocument = {
  __typename?: 'UserAppSettingDocument';
  appSettingsId: Scalars['String']['output'];
  base64Settings: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type UserAppSettingDocumentFilterInput = {
  and?: InputMaybe<Array<UserAppSettingDocumentFilterInput>>;
  appSettingsId?: InputMaybe<StringOperationFilterInput>;
  base64Settings?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserAppSettingDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type UserAppSettingDocumentSortInput = {
  appSettingsId?: InputMaybe<SortEnumType>;
  base64Settings?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type UserAppSettingPayload = {
  __typename?: 'UserAppSettingPayload';
  errors?: Maybe<Array<ValidationError>>;
  setting?: Maybe<UserAppSettingData>;
};

/** A connection to a list of items. */
export type UserAppSettingsConnection = {
  __typename?: 'UserAppSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserAppSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserAppSettingDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserAppSettingsEdge = {
  __typename?: 'UserAppSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserAppSettingDocument;
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocument = {
  __typename?: 'UserDocument';
  /**
   * The PRECOMPUTED resolved customer access scope for this user — the ready-to-inject filter value
   * the query layer reads directly (B2/C2/C3) instead of recomputing per request. A non-empty set
   * limits the user to those customers; an EMPTY list means "no limit — sees all". Written from the
   * UserCustomersAssigned event and mirrors a portal user's legacy single customerId,
   * so exactly one field carries the resolved scope. (C1 adds sibling site/location scope fields for
   * the expanded access model; this field remains the customer-id scope.)
   */
  assignedCustomerIds: Array<Scalars['String']['output']>;
  /**
   * The PRECOMPUTED resolved route access scope for this user (D2) — the ready-to-inject filter
   * value the query layer reads directly (D3) instead of recomputing per request. A non-empty set
   * limits the user to those routes; an EMPTY list means "no limit — sees all". Written from the
   * UserRoutesAssigned event. There is no legacy predecessor for this axis, so existing
   * users correctly default to an empty (unrestricted) list — no backfill required.
   */
  assignedRoutes: Array<Scalars['String']['output']>;
  /**
   * The site/location NODE ids this user is scoped to (each a site or a location node). Empty
   * means "no site limit" — the user sees all sites. Access is parent-and-below: assigning a node
   * grants that node and every descendant. Defaults to empty for existing users that predate this
   * field — which correctly means "no limit" for this brand-new axis (no migration required).
   */
  assignedSiteIds: Array<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference: LanguagePreference;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastModified: Scalars['DateTime']['output'];
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  roles: Array<UserRole>;
  status: UserStatus;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocumentFilterInput = {
  and?: InputMaybe<Array<UserDocumentFilterInput>>;
  /**
   * The PRECOMPUTED resolved customer access scope for this user — the ready-to-inject filter value
   * the query layer reads directly (B2/C2/C3) instead of recomputing per request. A non-empty set
   * limits the user to those customers; an EMPTY list means "no limit — sees all". Written from the
   * UserCustomersAssigned event and mirrors a portal user's legacy single customerId,
   * so exactly one field carries the resolved scope. (C1 adds sibling site/location scope fields for
   * the expanded access model; this field remains the customer-id scope.)
   */
  assignedCustomerIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The PRECOMPUTED resolved route access scope for this user (D2) — the ready-to-inject filter
   * value the query layer reads directly (D3) instead of recomputing per request. A non-empty set
   * limits the user to those routes; an EMPTY list means "no limit — sees all". Written from the
   * UserRoutesAssigned event. There is no legacy predecessor for this axis, so existing
   * users correctly default to an empty (unrestricted) list — no backfill required.
   */
  assignedRoutes?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The site/location NODE ids this user is scoped to (each a site or a location node). Empty
   * means "no site limit" — the user sees all sites. Access is parent-and-below: assigning a node
   * grants that node and every descendant. Defaults to empty for existing users that predate this
   * field — which correctly means "no limit" for this brand-new axis (no migration required).
   */
  assignedSiteIds?: InputMaybe<ListStringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference?: InputMaybe<LanguagePreferenceOperationFilterInput>;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: InputMaybe<DateTimeOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<UserDocumentFilterInput>>;
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: InputMaybe<StringOperationFilterInput>;
  roles?: InputMaybe<ListUserRoleOperationFilterInput>;
  status?: InputMaybe<UserStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference?: InputMaybe<SortEnumType>;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: InputMaybe<SortEnumType>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserInviteDocument = {
  __typename?: 'UserInviteDocument';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  changePasswordId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId: Scalars['String']['output'];
  emailError: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  emailStatus: Scalars['Int']['output'];
  error: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  expiresInDays: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  fusionAuthUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  recipientEmail: Scalars['String']['output'];
  registrations: Array<UserInviteRegistrationDocumentData>;
  resentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType: UserType;
};

export type UserInviteDocumentFilterInput = {
  acceptedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserInviteDocumentFilterInput>>;
  changePasswordId?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  emailError?: InputMaybe<StringOperationFilterInput>;
  emailSentAt?: InputMaybe<DateTimeOperationFilterInput>;
  emailStatus?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  expiresInDays?: InputMaybe<IntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fusionAuthUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inviteId?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserInviteDocumentFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  recipientEmail?: InputMaybe<StringOperationFilterInput>;
  registrations?: InputMaybe<ListFilterInputTypeOfUserInviteRegistrationDocumentDataFilterInput>;
  resentAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  usedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType?: InputMaybe<UserTypeOperationFilterInput>;
};

export type UserInviteDocumentSortInput = {
  acceptedAt?: InputMaybe<SortEnumType>;
  changePasswordId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId?: InputMaybe<SortEnumType>;
  emailError?: InputMaybe<SortEnumType>;
  emailSentAt?: InputMaybe<SortEnumType>;
  emailStatus?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  expiresInDays?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fusionAuthUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inviteId?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  recipientEmail?: InputMaybe<SortEnumType>;
  resentAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  usedAt?: InputMaybe<SortEnumType>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType?: InputMaybe<SortEnumType>;
};

export type UserInvitePayload = {
  __typename?: 'UserInvitePayload';
  errors?: Maybe<Array<ValidationError>>;
  userInvite?: Maybe<UserInviteDocument>;
};

export type UserInviteRegistrationDataInput = {
  applicationId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

/**
 * Document-local registration shape — deliberately separate from the command's
 * UserInviteRegistrationData and the event's InviteRegistrationData per the
 * single-use Data-type convention, so the read model can evolve without breaking either.
 */
export type UserInviteRegistrationDocumentData = {
  __typename?: 'UserInviteRegistrationDocumentData';
  applicationId: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

/**
 * Document-local registration shape — deliberately separate from the command's
 * UserInviteRegistrationData and the event's InviteRegistrationData per the
 * single-use Data-type convention, so the read model can evolve without breaking either.
 */
export type UserInviteRegistrationDocumentDataFilterInput = {
  and?: InputMaybe<Array<UserInviteRegistrationDocumentDataFilterInput>>;
  applicationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserInviteRegistrationDocumentDataFilterInput>>;
  roles?: InputMaybe<ListStringOperationFilterInput>;
};

export enum UserInviteValidity {
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Used = 'USED',
  Valid = 'VALID'
}

/**
 * One FusionAuth user's last-login instant, as read by the wsapi-services
 * UserLastLoginSyncWorker off FusionAuth's lastLoginInstant. fusionAuthUserId is
 * the join key the worker actually has from FusionAuth (not the directory's own userId).
 */
export type UserLastLoginEntryDataInput = {
  fusionAuthUserId: Scalars['String']['input'];
  lastLoginAt: Scalars['DateTime']['input'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  errors?: Maybe<Array<ValidationError>>;
  user?: Maybe<UserDocument>;
};

export enum UserRole {
  Admin = 'ADMIN',
  EdiManager = 'EDI_MANAGER',
  EdiViewer = 'EDI_VIEWER',
  Finance = 'FINANCE',
  Maintenance = 'MAINTENANCE',
  /** @deprecated Decision 5: grants no visibility bypass. Read scope is decided by OrderVisibilityScope. Kept as a stable event-replay ordinal + transitional write-side bypass input. */
  NoOrderRestrictions = 'NO_ORDER_RESTRICTIONS',
  Ops = 'OPS',
  Portal = 'PORTAL',
  RestockOrderer = 'RESTOCK_ORDERER',
  Sales = 'SALES',
  SalesManager = 'SALES_MANAGER',
  VerifyDispatcher = 'VERIFY_DISPATCHER',
  VerifyManager = 'VERIFY_MANAGER',
  VerifyScanner = 'VERIFY_SCANNER'
}

export type UserRoleOperationFilterInput = {
  eq?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  neq?: InputMaybe<UserRole>;
  nin?: InputMaybe<Array<UserRole>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type UserStatusOperationFilterInput = {
  eq?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  neq?: InputMaybe<UserStatus>;
  nin?: InputMaybe<Array<UserStatus>>;
};

/** A connection to a list of items. */
export type UserTimeEntriesConnection = {
  __typename?: 'UserTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserTimeEntriesEdge = {
  __typename?: 'UserTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeEntryDocument;
};

export enum UserType {
  Customer = 'CUSTOMER',
  Tenant = 'TENANT'
}

export type UserTypeOperationFilterInput = {
  eq?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  neq?: InputMaybe<UserType>;
  nin?: InputMaybe<Array<UserType>>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserDocument;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Result of validateCategoryDocuments: how many staged-summary documents were
 * inserted / updated in Category.Staged.Summary plus per-row validation failures.
 */
export type ValidateCategoryDocumentsResult = {
  __typename?: 'ValidateCategoryDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<CategoryStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateCustomerDocuments: how many parent summaries were
 * inserted / updated in Customers.Staged.Summary plus per-row validation
 * failures. The location-collection fan-out is implicit (one delete-and-insert
 * per parent) and not separately reported.
 */
export type ValidateCustomerDocumentsResult = {
  __typename?: 'ValidateCustomerDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<CustomerStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateHistoricalOrderDocuments: how many summary documents were inserted /
 * updated in HistoricalOrders.Staged.Summary plus per-row validation failures. The
 * line-item-collection fan-out is implicit (one delete-and-insert per order) and not separately
 * reported.
 */
export type ValidateHistoricalOrderDocumentsResult = {
  __typename?: 'ValidateHistoricalOrderDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<HistoricalOrderStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidateHistoricalOrdersResult = {
  __typename?: 'ValidateHistoricalOrdersResult';
  rowErrors: Array<HistoricalOrderImportRowError>;
  valid: Scalars['Int']['output'];
};

/**
 * Result of validateInventoryItemDocuments: how many inventory summaries were
 * inserted / updated in Inventory.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is a 1:1 sibling and not
 * separately reported. Errors is non-null only when the whole batch was
 * rejected (e.g. the staged collections are locked while the tenant's import
 * worker is running) — nothing was written.
 */
export type ValidateInventoryItemDocumentsResult = {
  __typename?: 'ValidateInventoryItemDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<InventoryItemStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateItemsDocuments: how many summary documents were
 * inserted / updated in Items.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is implicit (one upsert
 * per row) and not separately reported. Errors is non-null only when
 * the whole batch was rejected (e.g. the staged collections are locked while
 * the tenant's import worker is running) — nothing was written.
 */
export type ValidateItemsDocumentsResult = {
  __typename?: 'ValidateItemsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<ItemStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validatePriceGroupDocuments: how many group summaries were
 * inserted / updated in PriceGroups.Staged.Summary plus per-row validation
 * failures. The levels- and import-command-collection fan-outs are implicit (one
 * replace / one upsert per group) and not separately reported.
 */
export type ValidatePriceGroupDocumentsResult = {
  __typename?: 'ValidatePriceGroupDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<PriceGroupStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidateProductionLotPayload = {
  __typename?: 'ValidateProductionLotPayload';
  errors?: Maybe<Array<ValidationError>>;
  isValid: Scalars['Boolean']['output'];
};

/**
 * Result of validateSiteLocationsDocuments: how many site summaries were
 * inserted / updated in SiteLocations.Staged.Summary plus per-row validation
 * failures. The sub-location and import-command fan-outs are implicit (per parent)
 * and not separately reported.
 */
export type ValidateSiteLocationsDocumentsResult = {
  __typename?: 'ValidateSiteLocationsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<SiteLocationStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateTaxAuthorityDocuments: how many summary documents were
 * inserted / updated in TaxAuthority.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is implicit (one upsert per row)
 * and not separately reported. Errors is non-null only when the whole batch
 * was rejected (e.g. the staged collections are locked while the tenant's import
 * worker is running) — nothing was written.
 */
export type ValidateTaxAuthorityDocumentsResult = {
  __typename?: 'ValidateTaxAuthorityDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<TaxAuthorityStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateTermsDocuments: how many summary documents were
 * inserted / updated in Terms.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is implicit (one upsert per row)
 * and not separately reported. Errors is non-null only when the whole batch
 * was rejected (e.g. the staged collections are locked while the tenant's import
 * worker is running) — nothing was written.
 */
export type ValidateTermsDocumentsResult = {
  __typename?: 'ValidateTermsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<TermsStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ValueColumnInput = {
  aggFunc: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

/** Per-line variance-resolution input for reconcileMovementOrder. */
export type VarianceResolutionInput = {
  countReasonCode: Scalars['Int']['input'];
  lineItemId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  receivedQuantity: Scalars['Decimal']['input'];
  shippedQuantity: Scalars['Decimal']['input'];
};

/** GraphQL projection of a single variance resolution recorded by reconcile. */
export type VarianceResolutionStateData = {
  __typename?: 'VarianceResolutionStateData';
  countReasonCode: Scalars['Int']['output'];
  lineItemId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  receivedQuantity: Scalars['Decimal']['output'];
  shippedQuantity: Scalars['Decimal']['output'];
};

export type VariationDiffProjection = {
  __typename?: 'VariationDiffProjection';
  assignmentOverrideChanges: Array<AssignmentOverrideChangeProjection>;
  candidateTaskEventsToRegenerate: Array<TaskEventRegenerationCandidateProjection>;
  eventIdChanges: Array<EventIdChangeProjection>;
  scalarFieldChanges: Array<ScalarFieldChangeProjection>;
  variationId: Scalars['String']['output'];
  variationName: Scalars['String']['output'];
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  billingAddress?: Maybe<AddressData>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: VendorStatus;
  tenantId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

export type VendorDocumentFilterInput = {
  and?: InputMaybe<Array<VendorDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorDocumentFilterInput>>;
  status?: InputMaybe<VendorStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
};

export type VendorDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  description?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocument = {
  __typename?: 'VendorMaterialCostDocument';
  /**
   * The specific date this cost takes effect, independent of the week/year rollup fields.
   * Null when no explicit effective date was provided at ingestion time.
   */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveWeek?: Maybe<Scalars['Int']['output']>;
  effectiveYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isDefaultVendor: Scalars['Boolean']['output'];
  materialItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  unitCost: Scalars['Decimal']['output'];
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocumentFilterInput = {
  and?: InputMaybe<Array<VendorMaterialCostDocumentFilterInput>>;
  /**
   * The specific date this cost takes effect, independent of the week/year rollup fields.
   * Null when no explicit effective date was provided at ingestion time.
   */
  effectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveWeek?: InputMaybe<IntOperationFilterInput>;
  effectiveYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefaultVendor?: InputMaybe<BooleanOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorMaterialCostDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocumentSortInput = {
  /**
   * The specific date this cost takes effect, independent of the week/year rollup fields.
   * Null when no explicit effective date was provided at ingestion time.
   */
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveWeek?: InputMaybe<SortEnumType>;
  effectiveYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefaultVendor?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitCost?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VendorMaterialCostsConnection = {
  __typename?: 'VendorMaterialCostsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorMaterialCostsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorMaterialCostDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorMaterialCostsEdge = {
  __typename?: 'VendorMaterialCostsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorMaterialCostDocument;
};

export type VendorPayload = {
  __typename?: 'VendorPayload';
  errors?: Maybe<Array<ValidationError>>;
  vendor?: Maybe<VendorStateData>;
};

export type VendorPurchaseOrderDocument = {
  __typename?: 'VendorPurchaseOrderDocument';
  billingAddress?: Maybe<AddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isUrgent: Scalars['Boolean']['output'];
  items: Array<VendorPurchaseOrderItemData>;
  orderPlacedDate: Scalars['DateTime']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  receipts: Array<VendorPurchaseOrderReceiptData>;
  shippingAddress?: Maybe<AddressData>;
  siteLocationId: Scalars['String']['output'];
  status: VendorPurchaseOrderStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type VendorPurchaseOrderDocumentFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isUrgent?: InputMaybe<BooleanOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderItemDataFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderDocumentFilterInput>>;
  orderPlacedDate?: InputMaybe<DateTimeOperationFilterInput>;
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  receipts?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderReceiptDataFilterInput>;
  shippingAddress?: InputMaybe<AddressDataFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<VendorPurchaseOrderStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
};

export type VendorPurchaseOrderDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isUrgent?: InputMaybe<SortEnumType>;
  orderPlacedDate?: InputMaybe<SortEnumType>;
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  shippingAddress?: InputMaybe<AddressDataSortInput>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
  vendorName?: InputMaybe<SortEnumType>;
};

export type VendorPurchaseOrderItemData = {
  __typename?: 'VendorPurchaseOrderItemData';
  erpJobId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOrganicAtReceive: Scalars['Boolean']['output'];
  itemName: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  materialItemErpId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  organicLotCode?: Maybe<Scalars['String']['output']>;
  qualityNotes?: Maybe<Scalars['String']['output']>;
  quantityOrdered: Scalars['Decimal']['output'];
  quantityReceived: Scalars['Decimal']['output'];
  shortageNotes?: Maybe<Scalars['String']['output']>;
  varianceReason: VendorReceiveVarianceReason;
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorPurchaseOrderItemDataFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderItemDataFilterInput>>;
  erpJobId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  materialItemErpId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderItemDataFilterInput>>;
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  qualityNotes?: InputMaybe<StringOperationFilterInput>;
  quantityOrdered?: InputMaybe<DecimalOperationFilterInput>;
  quantityReceived?: InputMaybe<DecimalOperationFilterInput>;
  shortageNotes?: InputMaybe<StringOperationFilterInput>;
  varianceReason?: InputMaybe<VendorReceiveVarianceReasonOperationFilterInput>;
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

export type VendorPurchaseOrderPayload = {
  __typename?: 'VendorPurchaseOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  vendorPurchaseOrder?: Maybe<VendorPurchaseOrderDocument>;
  warnings?: Maybe<Array<OrganicReceiveWarning>>;
};

/**
 * Per-receipt history entry appended by the VendorPurchaseOrderItemsReceived projection so the
 * correction handler can resolve the receive location for a specific line item — needed when the
 * receive happens at a location other than the PO-level SiteLocationId (cross-location receipt).
 *
 * Deduplicated on event replay by ReceiptEntryId, which is derived deterministically
 * from the event payload (VPO id + line item id + received-at location + received date).
 */
export type VendorPurchaseOrderReceiptData = {
  __typename?: 'VendorPurchaseOrderReceiptData';
  itemId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  receiptEntryId: Scalars['String']['output'];
  receiveLocationId: Scalars['String']['output'];
  receivedDate: Scalars['DateTime']['output'];
};

/**
 * Per-receipt history entry appended by the VendorPurchaseOrderItemsReceived projection so the
 * correction handler can resolve the receive location for a specific line item — needed when the
 * receive happens at a location other than the PO-level SiteLocationId (cross-location receipt).
 *
 * Deduplicated on event replay by ReceiptEntryId, which is derived deterministically
 * from the event payload (VPO id + line item id + received-at location + received date).
 */
export type VendorPurchaseOrderReceiptDataFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderReceiptDataFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderReceiptDataFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  receiptEntryId?: InputMaybe<StringOperationFilterInput>;
  receiveLocationId?: InputMaybe<StringOperationFilterInput>;
  receivedDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum VendorPurchaseOrderStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED',
  Unconfirmed = 'UNCONFIRMED'
}

export type VendorPurchaseOrderStatusOperationFilterInput = {
  eq?: InputMaybe<VendorPurchaseOrderStatus>;
  in?: InputMaybe<Array<VendorPurchaseOrderStatus>>;
  neq?: InputMaybe<VendorPurchaseOrderStatus>;
  nin?: InputMaybe<Array<VendorPurchaseOrderStatus>>;
};

/** A connection to a list of items. */
export type VendorPurchaseOrdersConnection = {
  __typename?: 'VendorPurchaseOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorPurchaseOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorPurchaseOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorPurchaseOrdersEdge = {
  __typename?: 'VendorPurchaseOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorPurchaseOrderDocument;
};

export enum VendorReceiveVarianceReason {
  Damaged = 'DAMAGED',
  None = 'NONE',
  Other = 'OTHER',
  Overship = 'OVERSHIP',
  QualityReject = 'QUALITY_REJECT',
  Short = 'SHORT',
  SubstituteAccepted = 'SUBSTITUTE_ACCEPTED',
  WrongItem = 'WRONG_ITEM'
}

export type VendorReceiveVarianceReasonOperationFilterInput = {
  eq?: InputMaybe<VendorReceiveVarianceReason>;
  in?: InputMaybe<Array<VendorReceiveVarianceReason>>;
  neq?: InputMaybe<VendorReceiveVarianceReason>;
  nin?: InputMaybe<Array<VendorReceiveVarianceReason>>;
};

export type VendorStateData = {
  __typename?: 'VendorStateData';
  billingAddress?: Maybe<CreateAddress>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: VendorStatus;
  tenantId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

export enum VendorStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type VendorStatusOperationFilterInput = {
  eq?: InputMaybe<VendorStatus>;
  in?: InputMaybe<Array<VendorStatus>>;
  neq?: InputMaybe<VendorStatus>;
  nin?: InputMaybe<Array<VendorStatus>>;
};

/** A connection to a list of items. */
export type VendorsConnection = {
  __typename?: 'VendorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorsEdge = {
  __typename?: 'VendorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorDocument;
};

/**
 * A container that contributed scans to the comparison, surfaced for the dashboard's drill-in.
 * ScanCount is the number of scan rows on the container (not the summed quantity).
 */
export type VerifyComparisonContainer = {
  __typename?: 'VerifyComparisonContainer';
  containerId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  scanCount: Scalars['Int']['output'];
  status: VerifyContainerStatus;
};

/**
 * A scanned quantity that has no matching order line. Two cases:
 *
 *  is None — a raw barcode that never resolved to an item (blind-count
 * unknown). The Barcodes that summed into ScannedQuantity are listed.
 *  is Some — a resolved item that is not on the current order (e.g. a stray
 * item scanned into the container). Barcodes lists the contributing barcodes.
 *
 * Optional fields use Option<T>: this is a pure query OUTPUT object (no
 * [UseFiltering]/[UseSorting] on the computed resolver), so the OptionTypeInterceptor
 * rewrites it to a nullable GraphQL field cleanly.
 */
export type VerifyComparisonUnknownItem = {
  __typename?: 'VerifyComparisonUnknownItem';
  barcodes: Array<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  scannedQuantity: Scalars['Int']['output'];
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocument = {
  __typename?: 'VerifyContainerDocument';
  /** The container id (the aggregate's entity id), distinct from the composite Id. */
  containerId: Scalars['String']['output'];
  /** The drop, read from the label. */
  drop: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Raw scanned QR/text from the physical container; the container's unique identity. */
  label: Scalars['String']['output'];
  /** The orders this container holds. N-ready for future racking; v1 resolves to exactly one. */
  orderAssociations: Array<VerifyContainerOrderAssociationDocument>;
  removedAt: Scalars['DateTime']['output'];
  removedBy: Scalars['String']['output'];
  /** The raw item scans, including unknown barcodes (unresolved ItemId). */
  scans: Array<VerifyContainerScanDocument>;
  status: VerifyContainerStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerDocumentFilterInput>>;
  /** The container id (the aggregate's entity id), distinct from the composite Id. */
  containerId?: InputMaybe<StringOperationFilterInput>;
  /** The drop, read from the label. */
  drop?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Raw scanned QR/text from the physical container; the container's unique identity. */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VerifyContainerDocumentFilterInput>>;
  /** The orders this container holds. N-ready for future racking; v1 resolves to exactly one. */
  orderAssociations?: InputMaybe<ListFilterInputTypeOfVerifyContainerOrderAssociationDocumentFilterInput>;
  removedAt?: InputMaybe<DateTimeOperationFilterInput>;
  removedBy?: InputMaybe<StringOperationFilterInput>;
  /** The raw item scans, including unknown barcodes (unresolved ItemId). */
  scans?: InputMaybe<ListFilterInputTypeOfVerifyContainerScanDocumentFilterInput>;
  status?: InputMaybe<VerifyContainerStatusOperationFilterInput>;
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  verifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocumentSortInput = {
  /** The container id (the aggregate's entity id), distinct from the composite Id. */
  containerId?: InputMaybe<SortEnumType>;
  /** The drop, read from the label. */
  drop?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Raw scanned QR/text from the physical container; the container's unique identity. */
  label?: InputMaybe<SortEnumType>;
  removedAt?: InputMaybe<SortEnumType>;
  removedBy?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  submittedAt?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  verifiedAt?: InputMaybe<SortEnumType>;
};

/** One order the container holds. */
export type VerifyContainerOrderAssociationData = {
  __typename?: 'VerifyContainerOrderAssociationData';
  orderId: Scalars['String']['output'];
};

/**
 * One order the container holds. Document-only sub-record (no boundary Data suffix —
 *             the parent VerifyContainerDocument is itself the read-model boundary type).
 */
export type VerifyContainerOrderAssociationDocument = {
  __typename?: 'VerifyContainerOrderAssociationDocument';
  orderId: Scalars['String']['output'];
};

/**
 * One order the container holds. Document-only sub-record (no boundary Data suffix —
 *             the parent VerifyContainerDocument is itself the read-model boundary type).
 */
export type VerifyContainerOrderAssociationDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerOrderAssociationDocumentFilterInput>>;
  or?: InputMaybe<Array<VerifyContainerOrderAssociationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
};

export type VerifyContainerPayload = {
  __typename?: 'VerifyContainerPayload';
  errors?: Maybe<Array<ValidationError>>;
  verifyContainer?: Maybe<VerifyContainerStateData>;
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured
 * raw, never blocking the scan — blind count).
 */
export type VerifyContainerScanData = {
  __typename?: 'VerifyContainerScanData';
  barcode: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  scannedAt: Scalars['DateTime']['output'];
  scannedBy: Scalars['String']['output'];
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured raw,
 * never blocking the scan — blind count). T? (not Option<T>) because the parent
 * document is a [UseFiltering] source.
 */
export type VerifyContainerScanDocument = {
  __typename?: 'VerifyContainerScanDocument';
  barcode: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  scannedAt: Scalars['DateTime']['output'];
  scannedBy: Scalars['String']['output'];
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured raw,
 * never blocking the scan — blind count). T? (not Option<T>) because the parent
 * document is a [UseFiltering] source.
 */
export type VerifyContainerScanDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerScanDocumentFilterInput>>;
  barcode?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VerifyContainerScanDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  scannedAt?: InputMaybe<DateTimeOperationFilterInput>;
  scannedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * GraphQL-facing snapshot of a VerifyContainerState returned by the
 * submitVerifyContainer / removeVerifyContainer mutations. A flat DTO that mirrors
 * the replayed domain state; optional fields surface as nullable primitives (no Option<T>
 * on the wire). The Mongo read model and its queries are a separate task — this type is only the
 * mutation's response shape.
 */
export type VerifyContainerStateData = {
  __typename?: 'VerifyContainerStateData';
  drop: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  orderAssociations: Array<VerifyContainerOrderAssociationData>;
  removedAt: Scalars['DateTime']['output'];
  removedBy: Scalars['String']['output'];
  scans: Array<VerifyContainerScanData>;
  status: VerifyContainerStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

export enum VerifyContainerStatus {
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Open = 'OPEN',
  Scanned = 'SCANNED',
  Submitted = 'SUBMITTED',
  Verified = 'VERIFIED'
}

/**
 * Payload delivered to verifyContainerStatusChanged subscribers: a single container's
 * lifecycle transition. The supervisor dashboard reacts by VerifyContainerStatus:
 * on Submitted it refetches the comparison for that container;
 * on Verified it drops the row (also clearing a second
 * supervisor's screen). OrderIds lets the client target the affected order(s) without
 * a round-trip. The payload intentionally carries only identity + status; richer container detail is
 * pulled via the verifyContainers query.
 */
export type VerifyContainerStatusChangedEvent = {
  __typename?: 'VerifyContainerStatusChangedEvent';
  containerId: Scalars['String']['output'];
  orderIds: Array<Scalars['String']['output']>;
  status: VerifyContainerStatus;
};

export type VerifyContainerStatusOperationFilterInput = {
  eq?: InputMaybe<VerifyContainerStatus>;
  in?: InputMaybe<Array<VerifyContainerStatus>>;
  neq?: InputMaybe<VerifyContainerStatus>;
  nin?: InputMaybe<Array<VerifyContainerStatus>>;
};

/** A connection to a list of items. */
export type VerifyContainersConnection = {
  __typename?: 'VerifyContainersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VerifyContainersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VerifyContainerDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VerifyContainersEdge = {
  __typename?: 'VerifyContainersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VerifyContainerDocument;
};

/**
 * How a comparison line's summed scan quantity stacks up against its order line's ordered quantity.
 * Ordinals are NOT persisted — this enum exists only on the derived, never-stored
 * OrderVerificationComparison read shape (computed fresh on every
 * orderVerificationComparison query) — so it carries no Enum-Ordinal-Stability obligation.
 */
export enum VerifyLineVariance {
  /** Scanned sum equals the ordered quantity. */
  Matched = 'MATCHED',
  /** Scanned sum is greater than the ordered quantity. */
  Over = 'OVER',
  /** Scanned sum is less than the ordered quantity. */
  Short = 'SHORT'
}

export enum VerifyMode {
  Direct = 'DIRECT',
  Staged = 'STAGED'
}

export type VerifyPortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

/**
 * Input for verifyTenantSmtpConnection. The server sends a live test message to
 * testRecipient using the stored connection; success marks it verified, failure marks it failed
 * with a sanitized reason.
 */
export type VerifyTenantSmtpConnectionInput = {
  /** Gets the address the verification test message is sent to. */
  testRecipient: Scalars['String']['input'];
};

export type WeeklyCellEditInput = {
  isoWeek: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  metric: ForecastWeeklyMetric;
  region: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export type WeeklySlopeFactorDocument = {
  __typename?: 'WeeklySlopeFactorDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  region: Scalars['String']['output'];
  slopeFactor: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  weekOfYear: Scalars['Int']['output'];
};

export type WeeklySlopeFactorDocumentFilterInput = {
  and?: InputMaybe<Array<WeeklySlopeFactorDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WeeklySlopeFactorDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  slopeFactor?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weekOfYear?: InputMaybe<IntOperationFilterInput>;
};

export type WeeklySlopeFactorDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  slopeFactor?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weekOfYear?: InputMaybe<SortEnumType>;
};

export type WorkOrderBuildItemData = {
  __typename?: 'WorkOrderBuildItemData';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type WorkOrderBuildItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderBuildItemDataFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderBuildItemDataFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type WorkOrderData = {
  __typename?: 'WorkOrderData';
  activityCode: Scalars['String']['output'];
  buildItems: Array<WorkOrderBuildItemData>;
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity: Scalars['Int']['output'];
  productionPhaseCode: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderStatus: WorkOrderStatus;
};

export type WorkOrderDocument = {
  __typename?: 'WorkOrderDocument';
  activityCode?: Maybe<Scalars['String']['output']>;
  buildItems?: Maybe<Array<WorkOrderBuildItemData>>;
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity?: Maybe<Scalars['Int']['output']>;
  productionPhaseCode?: Maybe<Scalars['String']['output']>;
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderStatus: WorkOrderStatus;
};

export type WorkOrderDocumentFilterInput = {
  activityCode?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderDocumentFilterInput>>;
  buildItems?: InputMaybe<ListFilterInputTypeOfWorkOrderBuildItemDataFilterInput>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderDocumentFilterInput>>;
  plannedQuantity?: InputMaybe<IntOperationFilterInput>;
  productionPhaseCode?: InputMaybe<StringOperationFilterInput>;
  productionQuantity?: InputMaybe<IntOperationFilterInput>;
  quantityProduced?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  workOrderStatus?: InputMaybe<WorkOrderStatusOperationFilterInput>;
};

export type WorkOrderDocumentSortInput = {
  activityCode?: InputMaybe<SortEnumType>;
  containerQuantity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  lineNumber?: InputMaybe<SortEnumType>;
  plannedQuantity?: InputMaybe<SortEnumType>;
  productionPhaseCode?: InputMaybe<SortEnumType>;
  productionQuantity?: InputMaybe<SortEnumType>;
  quantityProduced?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  workOrderStatus?: InputMaybe<SortEnumType>;
};

export type WorkOrderInput = {
  activityCode: Scalars['String']['input'];
  buildItems: Array<BuildItemInput>;
  containerQuantity: Scalars['Int']['input'];
  erpId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  plannedQuantity: Scalars['Int']['input'];
  productionPhaseCode: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  quantityProduced: Scalars['Int']['input'];
  status: WorkOrderStatus;
  workOrderId: Scalars['String']['input'];
};

export enum WorkOrderStatus {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Unknown = 'UNKNOWN'
}

export type WorkOrderStatusOperationFilterInput = {
  eq?: InputMaybe<WorkOrderStatus>;
  in?: InputMaybe<Array<WorkOrderStatus>>;
  neq?: InputMaybe<WorkOrderStatus>;
  nin?: InputMaybe<Array<WorkOrderStatus>>;
};

/** A connection to a list of items. */
export type WorkOrdersConnection = {
  __typename?: 'WorkOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WorkOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WorkOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkOrdersEdge = {
  __typename?: 'WorkOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WorkOrderDocument;
};

/**
 * Result containing a resolved worker config value for a specific service and tenant.
 * This is what wsapi-services receives at runtime.
 */
export type WorkerConfigResult = {
  __typename?: 'WorkerConfigResult';
  configName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WorkerConfigStateData = {
  __typename?: 'WorkerConfigStateData';
  configName: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValues: Array<TenantValueStateData>;
};

export type WsapiImportDocument = {
  __typename?: 'WsapiImportDocument';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityMappings: Array<EntityMappingData>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  runNow: Scalars['Boolean']['output'];
  scheduleDayOfWeek?: Maybe<Scalars['Int']['output']>;
  scheduleTimeOfDay?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wsapiImportId: Scalars['String']['output'];
};

export type WsapiImportDocumentFilterInput = {
  and?: InputMaybe<Array<WsapiImportDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  entityMappings?: InputMaybe<ListFilterInputTypeOfEntityMappingDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WsapiImportDocumentFilterInput>>;
  runNow?: InputMaybe<BooleanOperationFilterInput>;
  scheduleDayOfWeek?: InputMaybe<IntOperationFilterInput>;
  scheduleTimeOfDay?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  wsapiImportId?: InputMaybe<StringOperationFilterInput>;
};

export type WsapiImportDocumentSortInput = {
  created?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  runNow?: InputMaybe<SortEnumType>;
  scheduleDayOfWeek?: InputMaybe<SortEnumType>;
  scheduleTimeOfDay?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  wsapiImportId?: InputMaybe<SortEnumType>;
};

export enum WsapiImportEntityType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  CrmAccount = 'CRM_ACCOUNT',
  CrmContact = 'CRM_CONTACT',
  CrmCustomerExport = 'CRM_CUSTOMER_EXPORT',
  Customer = 'CUSTOMER',
  InvoiceImport = 'INVOICE_IMPORT',
  Item = 'ITEM',
  JournalEntry = 'JOURNAL_ENTRY',
  Location = 'LOCATION',
  Order = 'ORDER',
  OrderExport = 'ORDER_EXPORT',
  Payment = 'PAYMENT',
  PricingImport = 'PRICING_IMPORT',
  TaxRate = 'TAX_RATE',
  Vendor = 'VENDOR'
}

export type WsapiImportEntityTypeOperationFilterInput = {
  eq?: InputMaybe<WsapiImportEntityType>;
  in?: InputMaybe<Array<WsapiImportEntityType>>;
  neq?: InputMaybe<WsapiImportEntityType>;
  nin?: InputMaybe<Array<WsapiImportEntityType>>;
};

export type WsapiImportPayload = {
  __typename?: 'WsapiImportPayload';
  errors?: Maybe<Array<ValidationError>>;
  wsapiImport?: Maybe<WsapiImportStateData>;
};

export type WsapiImportStateData = {
  __typename?: 'WsapiImportStateData';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityMappings: Array<EntityMappingData>;
  integrationId: Scalars['String']['output'];
  runNow: Scalars['Boolean']['output'];
  scheduleDayOfWeek?: Maybe<Scalars['Int']['output']>;
  scheduleTimeOfDay?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wsapiImportId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type WsapiImportsConnection = {
  __typename?: 'WsapiImportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WsapiImportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WsapiImportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WsapiImportsEdge = {
  __typename?: 'WsapiImportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WsapiImportDocument;
};

export type GetBpfCycleCountMissionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BpfMissionDocumentFilterInput>;
  order?: InputMaybe<Array<BpfMissionDocumentSortInput> | BpfMissionDocumentSortInput>;
}>;


export type GetBpfCycleCountMissionsQuery = { __typename?: 'Query', bpfCycleCountMissions?: { __typename?: 'BpfCycleCountMissionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'BpfMissionDocument', id: string, missionKey: string, startDate: TDateISO, endDate: TDateISO, description: string, status: BpfMissionStatus }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type BpfCycleCountMissionFragment = { __typename?: 'BpfMissionDocument', id: string, missionKey: string, startDate: TDateISO, endDate: TDateISO, description: string, status: BpfMissionStatus };

export type GetBpfCycleCountMissionTasksQueryVariables = Exact<{
  missionKey: Scalars['String']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BpfMissionTaskDocumentFilterInput>;
  order?: InputMaybe<Array<BpfMissionTaskDocumentSortInput> | BpfMissionTaskDocumentSortInput>;
}>;


export type GetBpfCycleCountMissionTasksQuery = { __typename?: 'Query', bpfCycleCountMissionTasks?: { __typename?: 'BpfCycleCountMissionTasksConnection', totalCount: number, nodes?: Array<{ __typename?: 'BpfMissionTaskDocument', id: string, missionKey: string, entryId: string, lotCountId: string, siteLocationId: string, subLocationId: string, locationCode: string, isComplete: boolean, processed: boolean, oldQuantity?: number | null, newQuantity?: number | null, lotChangeId?: string | null, completedAt?: TDateISO | null, completedByEmail?: string | null, itemReference: string, lotReference: string, variantReference: string, active: boolean, itemDescription: string, categoryDescription: string, binDescription: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type BpfCycleCountMissionTaskFragment = { __typename?: 'BpfMissionTaskDocument', id: string, missionKey: string, entryId: string, lotCountId: string, siteLocationId: string, subLocationId: string, locationCode: string, isComplete: boolean, processed: boolean, oldQuantity?: number | null, newQuantity?: number | null, lotChangeId?: string | null, completedAt?: TDateISO | null, completedByEmail?: string | null, itemReference: string, lotReference: string, variantReference: string, active: boolean, itemDescription: string, categoryDescription: string, binDescription: string };

export type GetBpfLotChangeReasonsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBpfLotChangeReasonsQuery = { __typename?: 'Query', bpfLotChangeReasons?: { __typename?: 'BpfLotChangeReasonsConnection', nodes?: Array<{ __typename?: 'BpfLotChangeReasonDocument', id: string, code: string, description: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetMyBpfStartingNodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyBpfStartingNodesQuery = { __typename?: 'Query', myBpfStartingNodes?: { __typename?: 'BpfUserStartingNodeDocument', id: string, userId: string, startingNodes: Array<{ __typename?: 'BpfStartingNodeDocument', treeType: BpfTreeType, siteLocationId: string, subLocationId?: string | null }> } | null };

export type GetSiteLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SiteLocationDocumentFilterInput>;
  order?: InputMaybe<Array<SiteLocationDocumentSortInput> | SiteLocationDocumentSortInput>;
}>;


export type GetSiteLocationsQuery = { __typename?: 'Query', siteLocations?: { __typename?: 'SiteLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SiteLocationDocument', id: string, siteLocationId: string, erpId: string, name: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCountReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountReasonsQuery = { __typename?: 'Query', countReasons: Array<{ __typename?: 'CountReasonData', code: number, reason: string }> };

export type AddBpfLotChangeMutationVariables = Exact<{
  input: AddBpfLotChangeInput;
}>;


export type AddBpfLotChangeMutation = { __typename?: 'Mutation', addBpfLotChange: { __typename?: 'BpfLotChangePayload', lotChange?: { __typename?: 'BpfLotChangeDocument', id: string, lotChangeId: string, changeType: BpfLotChangeType, stage: BpfLotStage, lotCountId: string, itemReference: string, lotReference: string, variantReference: string, fromSiteLocationId: string, fromSubLocationId: string, toSiteLocationId: string, toSubLocationId: string, quantityChange: number, unit: string, changeReasonCode: string, jobReference: string, notes: string, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type BpfLotChangeFragment = { __typename?: 'BpfLotChangeDocument', id: string, lotChangeId: string, changeType: BpfLotChangeType, stage: BpfLotStage, lotCountId: string, itemReference: string, lotReference: string, variantReference: string, fromSiteLocationId: string, fromSubLocationId: string, toSiteLocationId: string, toSubLocationId: string, quantityChange: number, unit: string, changeReasonCode: string, jobReference: string, notes: string, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO };

export type GetBpfLotCountsByStageQueryVariables = Exact<{
  stage: BpfLotStage;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BpfLotCountDocumentFilterInput>;
  order?: InputMaybe<Array<BpfLotCountDocumentSortInput> | BpfLotCountDocumentSortInput>;
}>;


export type GetBpfLotCountsByStageQuery = { __typename?: 'Query', bpfLotCountsByStage?: { __typename?: 'BpfLotCountsByStageConnection', totalCount: number, nodes?: Array<{ __typename?: 'BpfLotCountDocument', id: string, lotCountId: string, stage: BpfLotStage, itemReference: string, lotReference: string, variantReference: string, siteLocationId: string, subLocationId: string, quantity: number, unit: string, jobReference: string, updated: TDateISO, source: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type BpfLotCountFragment = { __typename?: 'BpfLotCountDocument', id: string, lotCountId: string, stage: BpfLotStage, itemReference: string, lotReference: string, variantReference: string, siteLocationId: string, subLocationId: string, quantity: number, unit: string, jobReference: string, updated: TDateISO, source: string };

export type GetMaterialOrdersForLocationQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ErpOrderDocumentFilterInput>;
  order?: InputMaybe<Array<ErpOrderDocumentSortInput> | ErpOrderDocumentSortInput>;
}>;


export type GetMaterialOrdersForLocationQuery = { __typename?: 'Query', materialOrdersForLocation?: { __typename?: 'MaterialOrdersForLocationConnection', totalCount: number, nodes?: Array<{ __typename?: 'ErpOrderDocument', id: string, orderType: ErpOrderType, orderNumber: string, locationId: string, stationCode: string, vendorNo?: string | null, fromLocationCode?: string | null, description: string, orderDate?: TDateISO | null, expectedReceiptDate?: TDateISO | null, lines: Array<{ __typename?: 'ErpOrderLine', lineNo: number, itemId: string, erpItemNo: string, variantCode?: string | null, description: string, outstandingQuantity: number, unitOfMeasureCode?: string | null, binCode?: string | null, vendorLotNumber?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type MaterialOrderFragment = { __typename?: 'ErpOrderDocument', id: string, orderType: ErpOrderType, orderNumber: string, locationId: string, stationCode: string, vendorNo?: string | null, fromLocationCode?: string | null, description: string, orderDate?: TDateISO | null, expectedReceiptDate?: TDateISO | null, lines: Array<{ __typename?: 'ErpOrderLine', lineNo: number, itemId: string, erpItemNo: string, variantCode?: string | null, description: string, outstandingQuantity: number, unitOfMeasureCode?: string | null, binCode?: string | null, vendorLotNumber?: string | null }> };

export type MaterialOrderLineFragment = { __typename?: 'ErpOrderLine', lineNo: number, itemId: string, erpItemNo: string, variantCode?: string | null, description: string, outstandingQuantity: number, unitOfMeasureCode?: string | null, binCode?: string | null, vendorLotNumber?: string | null };

export type RecordMaterialReceiptMutationVariables = Exact<{
  input: RecordMaterialReceiptInput;
}>;


export type RecordMaterialReceiptMutation = { __typename?: 'Mutation', recordMaterialReceipt: { __typename?: 'MaterialReceiptPayload', receipt?: { __typename?: 'MaterialReceiptDocument', id: string, receiptId: string, orderType: ErpOrderType, orderNumber: string, lineNo: number, itemId: string, erpItemNo: string, locationId: string, binCode: string, vendorLotNumber: string, quantityReceived: number, outstandingBefore: number, unit: string, notes: string, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type MaterialReceiptFragment = { __typename?: 'MaterialReceiptDocument', id: string, receiptId: string, orderType: ErpOrderType, orderNumber: string, lineNo: number, itemId: string, erpItemNo: string, locationId: string, binCode: string, vendorLotNumber: string, quantityReceived: number, outstandingBefore: number, unit: string, notes: string, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO };

export type GetRetailAvailableBpLotsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RetailAvailableBpLotDocumentFilterInput>;
  order?: InputMaybe<Array<RetailAvailableBpLotDocumentSortInput> | RetailAvailableBpLotDocumentSortInput>;
}>;


export type GetRetailAvailableBpLotsQuery = { __typename?: 'Query', retailAvailableBpLots?: { __typename?: 'RetailAvailableBpLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'RetailAvailableBpLotDocument', bpLotCode: string, itemNo: string, locationId: string, availableQuantity: number }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type RetailBpLotFragment = { __typename?: 'RetailAvailableBpLotDocument', bpLotCode: string, itemNo: string, locationId: string, availableQuantity: number };

export type GetRetailCustomerLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput> | CustomerLocationDocumentSortInput>;
}>;


export type GetRetailCustomerLocationsQuery = { __typename?: 'Query', customerLocations?: { __typename?: 'CustomerLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerLocationDocument', id: string, customerId: string, customerName: string, locationId: string, name: string, code: string, storeNumber: string, region: string, market: string }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type RetailCustomerLocationFragment = { __typename?: 'CustomerLocationDocument', id: string, customerId: string, customerName: string, locationId: string, name: string, code: string, storeNumber: string, region: string, market: string };

export type AddRetailProductCountMutationVariables = Exact<{
  input: AddRetailProductCountInput;
}>;


export type AddRetailProductCountMutation = { __typename?: 'Mutation', addRetailProductCount: { __typename?: 'RetailProductCountPayload', count?: { __typename?: 'RetailProductCountDocument', id: string, retailCountId: string, countType: RetailCountType, productId: string, itemReference: string, locationId: string, customerReference: string, quantityChange: number, unitQuantityChange: number, unit: string, bpLotCode: string, note: string, latitude: number, longitude: number, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddMultipleRetailProductCountMutationVariables = Exact<{
  input: Array<AddRetailProductCountInput> | AddRetailProductCountInput;
}>;


export type AddMultipleRetailProductCountMutation = { __typename?: 'Mutation', addMultipleRetailProductCount: { __typename?: 'RetailProductCountBatchPayload', results: Array<{ __typename?: 'RetailCountResult', idempotencyKey: string, count?: { __typename?: 'RetailProductCountDocument', id: string, retailCountId: string, countType: RetailCountType, productId: string, itemReference: string, locationId: string, customerReference: string, quantityChange: number, unitQuantityChange: number, unit: string, bpLotCode: string, note: string, latitude: number, longitude: number, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO } | null, error?: { __typename?: 'ValidationError', code?: string | null, message: string } | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RetailProductCountFragment = { __typename?: 'RetailProductCountDocument', id: string, retailCountId: string, countType: RetailCountType, productId: string, itemReference: string, locationId: string, customerReference: string, quantityChange: number, unitQuantityChange: number, unit: string, bpLotCode: string, note: string, latitude: number, longitude: number, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO };

export type RetailValidationErrorFragment = { __typename?: 'ValidationError', code?: string | null, message: string };

export type GetRetailProductCountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RetailProductCountDocumentFilterInput>;
  order?: InputMaybe<Array<RetailProductCountDocumentSortInput> | RetailProductCountDocumentSortInput>;
}>;


export type GetRetailProductCountsQuery = { __typename?: 'Query', retailProductCounts?: { __typename?: 'RetailProductCountsConnection', totalCount: number, nodes?: Array<{ __typename?: 'RetailProductCountDocument', id: string, retailCountId: string, countType: RetailCountType, productId: string, itemReference: string, locationId: string, customerReference: string, quantityChange: number, unitQuantityChange: number, unit: string, bpLotCode: string, note: string, latitude: number, longitude: number, user: string, idempotencyKey: string, erpWriteBackId: string, createdAt: TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetRetailProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput> | ItemSummaryDocumentSortInput>;
}>;


export type GetRetailProductsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', id: string, itemId: string, name: string, description: string, sku: string, upc: string, productGroup: string, categories?: Array<string> | null, isOrganic: boolean, usedForRetail: boolean, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string }> | null }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type RetailProductFragment = { __typename?: 'ItemSummaryDocument', id: string, itemId: string, name: string, description: string, sku: string, upc: string, productGroup: string, categories?: Array<string> | null, isOrganic: boolean, usedForRetail: boolean, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string }> | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const BpfCycleCountMissionFragmentDoc = new TypedDocumentString(`
    fragment BpfCycleCountMission on BpfMissionDocument {
  id
  missionKey
  startDate
  endDate
  description
  status
}
    `, {"fragmentName":"BpfCycleCountMission"});
export const BpfCycleCountMissionTaskFragmentDoc = new TypedDocumentString(`
    fragment BpfCycleCountMissionTask on BpfMissionTaskDocument {
  id
  missionKey
  entryId
  lotCountId
  siteLocationId
  subLocationId
  locationCode
  isComplete
  processed
  oldQuantity
  newQuantity
  lotChangeId
  completedAt
  completedByEmail
  itemReference
  lotReference
  variantReference
  active
  itemDescription
  categoryDescription
  binDescription
}
    `, {"fragmentName":"BpfCycleCountMissionTask"});
export const BpfLotChangeFragmentDoc = new TypedDocumentString(`
    fragment BpfLotChange on BpfLotChangeDocument {
  id
  lotChangeId
  changeType
  stage
  lotCountId
  itemReference
  lotReference
  variantReference
  fromSiteLocationId
  fromSubLocationId
  toSiteLocationId
  toSubLocationId
  quantityChange
  unit
  changeReasonCode
  jobReference
  notes
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}
    `, {"fragmentName":"BpfLotChange"});
export const BpfLotCountFragmentDoc = new TypedDocumentString(`
    fragment BpfLotCount on BpfLotCountDocument {
  id
  lotCountId
  stage
  itemReference
  lotReference
  variantReference
  siteLocationId
  subLocationId
  quantity
  unit
  jobReference
  updated
  source
}
    `, {"fragmentName":"BpfLotCount"});
export const MaterialOrderLineFragmentDoc = new TypedDocumentString(`
    fragment MaterialOrderLine on ErpOrderLine {
  lineNo
  itemId
  erpItemNo
  variantCode
  description
  outstandingQuantity
  unitOfMeasureCode
  binCode
  vendorLotNumber
}
    `, {"fragmentName":"MaterialOrderLine"});
export const MaterialOrderFragmentDoc = new TypedDocumentString(`
    fragment MaterialOrder on ErpOrderDocument {
  id
  orderType
  orderNumber
  locationId
  stationCode
  vendorNo
  fromLocationCode
  description
  orderDate
  expectedReceiptDate
  lines {
    ...MaterialOrderLine
  }
}
    fragment MaterialOrderLine on ErpOrderLine {
  lineNo
  itemId
  erpItemNo
  variantCode
  description
  outstandingQuantity
  unitOfMeasureCode
  binCode
  vendorLotNumber
}`, {"fragmentName":"MaterialOrder"});
export const MaterialReceiptFragmentDoc = new TypedDocumentString(`
    fragment MaterialReceipt on MaterialReceiptDocument {
  id
  receiptId
  orderType
  orderNumber
  lineNo
  itemId
  erpItemNo
  locationId
  binCode
  vendorLotNumber
  quantityReceived
  outstandingBefore
  unit
  notes
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}
    `, {"fragmentName":"MaterialReceipt"});
export const RetailBpLotFragmentDoc = new TypedDocumentString(`
    fragment RetailBpLot on RetailAvailableBpLotDocument {
  bpLotCode
  itemNo
  locationId
  availableQuantity
}
    `, {"fragmentName":"RetailBpLot"});
export const RetailCustomerLocationFragmentDoc = new TypedDocumentString(`
    fragment RetailCustomerLocation on CustomerLocationDocument {
  id
  customerId
  customerName
  locationId
  name
  code
  storeNumber
  region
  market
}
    `, {"fragmentName":"RetailCustomerLocation"});
export const RetailProductCountFragmentDoc = new TypedDocumentString(`
    fragment RetailProductCount on RetailProductCountDocument {
  id
  retailCountId
  countType
  productId
  itemReference
  locationId
  customerReference
  quantityChange
  unitQuantityChange
  unit
  bpLotCode
  note
  latitude
  longitude
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}
    `, {"fragmentName":"RetailProductCount"});
export const RetailValidationErrorFragmentDoc = new TypedDocumentString(`
    fragment RetailValidationError on ValidationError {
  code
  message
}
    `, {"fragmentName":"RetailValidationError"});
export const RetailProductFragmentDoc = new TypedDocumentString(`
    fragment RetailProduct on ItemSummaryDocument {
  id
  itemId
  name
  description
  sku
  upc
  productGroup
  categories
  isOrganic
  usedForRetail
  sizes {
    code
  }
}
    `, {"fragmentName":"RetailProduct"});
export const GetBpfCycleCountMissionsDocument = new TypedDocumentString(`
    query GetBpfCycleCountMissions($first: Int, $after: String, $where: BpfMissionDocumentFilterInput, $order: [BpfMissionDocumentSortInput!]) {
  bpfCycleCountMissions(
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...BpfCycleCountMission
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment BpfCycleCountMission on BpfMissionDocument {
  id
  missionKey
  startDate
  endDate
  description
  status
}`);
export const GetBpfCycleCountMissionTasksDocument = new TypedDocumentString(`
    query GetBpfCycleCountMissionTasks($missionKey: String!, $siteLocationId: String, $first: Int, $after: String, $where: BpfMissionTaskDocumentFilterInput, $order: [BpfMissionTaskDocumentSortInput!]) {
  bpfCycleCountMissionTasks(
    missionKey: $missionKey
    siteLocationId: $siteLocationId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...BpfCycleCountMissionTask
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment BpfCycleCountMissionTask on BpfMissionTaskDocument {
  id
  missionKey
  entryId
  lotCountId
  siteLocationId
  subLocationId
  locationCode
  isComplete
  processed
  oldQuantity
  newQuantity
  lotChangeId
  completedAt
  completedByEmail
  itemReference
  lotReference
  variantReference
  active
  itemDescription
  categoryDescription
  binDescription
}`);
export const GetBpfLotChangeReasonsDocument = new TypedDocumentString(`
    query GetBpfLotChangeReasons($first: Int, $after: String) {
  bpfLotChangeReasons(first: $first, after: $after) {
    nodes {
      id
      code
      description
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `);
export const GetMyBpfStartingNodesDocument = new TypedDocumentString(`
    query GetMyBpfStartingNodes {
  myBpfStartingNodes {
    id
    userId
    startingNodes {
      treeType
      siteLocationId
      subLocationId
    }
  }
}
    `);
export const GetSiteLocationsDocument = new TypedDocumentString(`
    query GetSiteLocations($first: Int, $after: String, $where: SiteLocationDocumentFilterInput, $order: [SiteLocationDocumentSortInput!]) {
  siteLocations(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      siteLocationId
      erpId
      name
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    `);
export const GetCountReasonsDocument = new TypedDocumentString(`
    query GetCountReasons {
  countReasons {
    code
    reason
  }
}
    `);
export const AddBpfLotChangeDocument = new TypedDocumentString(`
    mutation AddBpfLotChange($input: AddBpfLotChangeInput!) {
  addBpfLotChange(input: $input) {
    lotChange {
      ...BpfLotChange
    }
    errors {
      message
    }
  }
}
    fragment BpfLotChange on BpfLotChangeDocument {
  id
  lotChangeId
  changeType
  stage
  lotCountId
  itemReference
  lotReference
  variantReference
  fromSiteLocationId
  fromSubLocationId
  toSiteLocationId
  toSubLocationId
  quantityChange
  unit
  changeReasonCode
  jobReference
  notes
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}`);
export const GetBpfLotCountsByStageDocument = new TypedDocumentString(`
    query GetBpfLotCountsByStage($stage: BpfLotStage!, $first: Int, $after: String, $where: BpfLotCountDocumentFilterInput, $order: [BpfLotCountDocumentSortInput!]) {
  bpfLotCountsByStage(
    stage: $stage
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...BpfLotCount
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment BpfLotCount on BpfLotCountDocument {
  id
  lotCountId
  stage
  itemReference
  lotReference
  variantReference
  siteLocationId
  subLocationId
  quantity
  unit
  jobReference
  updated
  source
}`);
export const GetMaterialOrdersForLocationDocument = new TypedDocumentString(`
    query GetMaterialOrdersForLocation($locationId: String!, $first: Int, $after: String, $where: ErpOrderDocumentFilterInput, $order: [ErpOrderDocumentSortInput!]) {
  materialOrdersForLocation(
    locationId: $locationId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...MaterialOrder
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment MaterialOrder on ErpOrderDocument {
  id
  orderType
  orderNumber
  locationId
  stationCode
  vendorNo
  fromLocationCode
  description
  orderDate
  expectedReceiptDate
  lines {
    ...MaterialOrderLine
  }
}
fragment MaterialOrderLine on ErpOrderLine {
  lineNo
  itemId
  erpItemNo
  variantCode
  description
  outstandingQuantity
  unitOfMeasureCode
  binCode
  vendorLotNumber
}`);
export const RecordMaterialReceiptDocument = new TypedDocumentString(`
    mutation RecordMaterialReceipt($input: RecordMaterialReceiptInput!) {
  recordMaterialReceipt(input: $input) {
    receipt {
      ...MaterialReceipt
    }
    errors {
      message
    }
  }
}
    fragment MaterialReceipt on MaterialReceiptDocument {
  id
  receiptId
  orderType
  orderNumber
  lineNo
  itemId
  erpItemNo
  locationId
  binCode
  vendorLotNumber
  quantityReceived
  outstandingBefore
  unit
  notes
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}`);
export const GetRetailAvailableBpLotsDocument = new TypedDocumentString(`
    query GetRetailAvailableBpLots($first: Int, $after: String, $where: RetailAvailableBpLotDocumentFilterInput, $order: [RetailAvailableBpLotDocumentSortInput!]) {
  retailAvailableBpLots(
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...RetailBpLot
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment RetailBpLot on RetailAvailableBpLotDocument {
  bpLotCode
  itemNo
  locationId
  availableQuantity
}`);
export const GetRetailCustomerLocationsDocument = new TypedDocumentString(`
    query GetRetailCustomerLocations($first: Int, $after: String, $where: CustomerLocationDocumentFilterInput, $order: [CustomerLocationDocumentSortInput!]) {
  customerLocations(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...RetailCustomerLocation
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment RetailCustomerLocation on CustomerLocationDocument {
  id
  customerId
  customerName
  locationId
  name
  code
  storeNumber
  region
  market
}`);
export const AddRetailProductCountDocument = new TypedDocumentString(`
    mutation AddRetailProductCount($input: AddRetailProductCountInput!) {
  addRetailProductCount(input: $input) {
    count {
      ...RetailProductCount
    }
    errors {
      ...RetailValidationError
    }
  }
}
    fragment RetailProductCount on RetailProductCountDocument {
  id
  retailCountId
  countType
  productId
  itemReference
  locationId
  customerReference
  quantityChange
  unitQuantityChange
  unit
  bpLotCode
  note
  latitude
  longitude
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}
fragment RetailValidationError on ValidationError {
  code
  message
}`);
export const AddMultipleRetailProductCountDocument = new TypedDocumentString(`
    mutation AddMultipleRetailProductCount($input: [AddRetailProductCountInput!]!) {
  addMultipleRetailProductCount(input: $input) {
    results {
      idempotencyKey
      count {
        ...RetailProductCount
      }
      error {
        ...RetailValidationError
      }
    }
    errors {
      ...RetailValidationError
    }
  }
}
    fragment RetailProductCount on RetailProductCountDocument {
  id
  retailCountId
  countType
  productId
  itemReference
  locationId
  customerReference
  quantityChange
  unitQuantityChange
  unit
  bpLotCode
  note
  latitude
  longitude
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}
fragment RetailValidationError on ValidationError {
  code
  message
}`);
export const GetRetailProductCountsDocument = new TypedDocumentString(`
    query GetRetailProductCounts($first: Int, $after: String, $where: RetailProductCountDocumentFilterInput, $order: [RetailProductCountDocumentSortInput!]) {
  retailProductCounts(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...RetailProductCount
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment RetailProductCount on RetailProductCountDocument {
  id
  retailCountId
  countType
  productId
  itemReference
  locationId
  customerReference
  quantityChange
  unitQuantityChange
  unit
  bpLotCode
  note
  latitude
  longitude
  user
  idempotencyKey
  erpWriteBackId
  createdAt
}`);
export const GetRetailProductsDocument = new TypedDocumentString(`
    query GetRetailProducts($first: Int, $after: String, $where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!]) {
  items(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...RetailProduct
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment RetailProduct on ItemSummaryDocument {
  id
  itemId
  name
  description
  sku
  upc
  productGroup
  categories
  isOrganic
  usedForRetail
  sizes {
    code
  }
}`);

const injectedRtkApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    GetBpfCycleCountMissions: build.query<GetBpfCycleCountMissionsQuery, GetBpfCycleCountMissionsQueryVariables | void>({
      query: (variables) => ({ document: GetBpfCycleCountMissionsDocument as unknown as string, variables })
    }),
    GetBpfCycleCountMissionTasks: build.query<GetBpfCycleCountMissionTasksQuery, GetBpfCycleCountMissionTasksQueryVariables>({
      query: (variables) => ({ document: GetBpfCycleCountMissionTasksDocument as unknown as string, variables })
    }),
    GetBpfLotChangeReasons: build.query<GetBpfLotChangeReasonsQuery, GetBpfLotChangeReasonsQueryVariables | void>({
      query: (variables) => ({ document: GetBpfLotChangeReasonsDocument as unknown as string, variables })
    }),
    GetMyBpfStartingNodes: build.query<GetMyBpfStartingNodesQuery, GetMyBpfStartingNodesQueryVariables | void>({
      query: (variables) => ({ document: GetMyBpfStartingNodesDocument as unknown as string, variables })
    }),
    GetSiteLocations: build.query<GetSiteLocationsQuery, GetSiteLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetSiteLocationsDocument as unknown as string, variables })
    }),
    GetCountReasons: build.query<GetCountReasonsQuery, GetCountReasonsQueryVariables | void>({
      query: (variables) => ({ document: GetCountReasonsDocument as unknown as string, variables })
    }),
    AddBpfLotChange: build.mutation<AddBpfLotChangeMutation, AddBpfLotChangeMutationVariables>({
      query: (variables) => ({ document: AddBpfLotChangeDocument as unknown as string, variables })
    }),
    GetBpfLotCountsByStage: build.query<GetBpfLotCountsByStageQuery, GetBpfLotCountsByStageQueryVariables>({
      query: (variables) => ({ document: GetBpfLotCountsByStageDocument as unknown as string, variables })
    }),
    GetMaterialOrdersForLocation: build.query<GetMaterialOrdersForLocationQuery, GetMaterialOrdersForLocationQueryVariables>({
      query: (variables) => ({ document: GetMaterialOrdersForLocationDocument as unknown as string, variables })
    }),
    RecordMaterialReceipt: build.mutation<RecordMaterialReceiptMutation, RecordMaterialReceiptMutationVariables>({
      query: (variables) => ({ document: RecordMaterialReceiptDocument as unknown as string, variables })
    }),
    GetRetailAvailableBpLots: build.query<GetRetailAvailableBpLotsQuery, GetRetailAvailableBpLotsQueryVariables | void>({
      query: (variables) => ({ document: GetRetailAvailableBpLotsDocument as unknown as string, variables })
    }),
    GetRetailCustomerLocations: build.query<GetRetailCustomerLocationsQuery, GetRetailCustomerLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetRetailCustomerLocationsDocument as unknown as string, variables })
    }),
    AddRetailProductCount: build.mutation<AddRetailProductCountMutation, AddRetailProductCountMutationVariables>({
      query: (variables) => ({ document: AddRetailProductCountDocument as unknown as string, variables })
    }),
    AddMultipleRetailProductCount: build.mutation<AddMultipleRetailProductCountMutation, AddMultipleRetailProductCountMutationVariables>({
      query: (variables) => ({ document: AddMultipleRetailProductCountDocument as unknown as string, variables })
    }),
    GetRetailProductCounts: build.query<GetRetailProductCountsQuery, GetRetailProductCountsQueryVariables | void>({
      query: (variables) => ({ document: GetRetailProductCountsDocument as unknown as string, variables })
    }),
    GetRetailProducts: build.query<GetRetailProductsQuery, GetRetailProductsQueryVariables | void>({
      query: (variables) => ({ document: GetRetailProductsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetBpfCycleCountMissionsQuery, useLazyGetBpfCycleCountMissionsQuery, useGetBpfCycleCountMissionTasksQuery, useLazyGetBpfCycleCountMissionTasksQuery, useGetBpfLotChangeReasonsQuery, useLazyGetBpfLotChangeReasonsQuery, useGetMyBpfStartingNodesQuery, useLazyGetMyBpfStartingNodesQuery, useGetSiteLocationsQuery, useLazyGetSiteLocationsQuery, useGetCountReasonsQuery, useLazyGetCountReasonsQuery, useAddBpfLotChangeMutation, useGetBpfLotCountsByStageQuery, useLazyGetBpfLotCountsByStageQuery, useGetMaterialOrdersForLocationQuery, useLazyGetMaterialOrdersForLocationQuery, useRecordMaterialReceiptMutation, useGetRetailAvailableBpLotsQuery, useLazyGetRetailAvailableBpLotsQuery, useGetRetailCustomerLocationsQuery, useLazyGetRetailCustomerLocationsQuery, useAddRetailProductCountMutation, useAddMultipleRetailProductCountMutation, useGetRetailProductCountsQuery, useLazyGetRetailProductCountsQuery, useGetRetailProductsQuery, useLazyGetRetailProductsQuery } = injectedRtkApi;

